(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './core-core-api.js', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-serialization-kotlinx-serialization-json.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./core-core-api.js'), require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'));
  else {
    if (typeof this['core-core-api'] === 'undefined') {
      throw new Error("Error loading module 'core-core-stl'. Its dependency 'core-core-api' was not found. Please, check whether 'core-core-api' is loaded prior to 'core-core-stl'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'core-core-stl'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'core-core-stl'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'core-core-stl'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'core-core-stl'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'core-core-stl'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'core-core-stl'.");
    }
    root['core-core-stl'] = factory(typeof this['core-core-stl'] === 'undefined' ? {} : this['core-core-stl'], this['core-core-api'], this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlinx-serialization-kotlinx-serialization-json']);
  }
}(this, function (_, kotlin_core_core_api, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var sign = Math.sign;
  var Companion_getInstance = kotlin_core_core_api.$_$.ta;
  var Unit_instance = kotlin_kotlin.$_$.x3;
  var get_children = kotlin_core_core_api.$_$.p3;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
  var copyToArray = kotlin_kotlin.$_$.l5;
  var distinct = kotlin_kotlin.$_$.n5;
  var get_parent = kotlin_core_core_api.$_$.f4;
  var equals = kotlin_kotlin.$_$.t8;
  var ConnectionUtils_instance = kotlin_core_core_api.$_$.aa;
  var protoOf = kotlin_kotlin.$_$.u9;
  var objectMeta = kotlin_kotlin.$_$.t9;
  var setMetadataFor = kotlin_kotlin.$_$.v9;
  var SystemBase2 = kotlin_core_core_api.$_$.a3;
  var ComponentIds_instance = kotlin_core_core_api.$_$.w9;
  var Companion_getInstance_0 = kotlin_core_core_api.$_$.xa;
  var Companion_instance = kotlin_core_core_api.$_$.uc;
  var Companion_getInstance_1 = kotlin_core_core_api.$_$.ba;
  var classMeta = kotlin_kotlin.$_$.q8;
  var defineProp = kotlin_kotlin.$_$.s8;
  var VOID = kotlin_kotlin.$_$.e;
  var joinToString = kotlin_kotlin.$_$.f6;
  var getKClassFromExpression = kotlin_kotlin.$_$.c;
  var THROW_CCE = kotlin_kotlin.$_$.ad;
  var contentEquals = kotlin_kotlin.$_$.z4;
  var contentHashCode = kotlin_kotlin.$_$.a5;
  var get_serializable = kotlin_core_core_api.$_$.w2;
  var get_doStoreInSnapshot = kotlin_core_core_api.$_$.v2;
  var Component = kotlin_core_core_api.$_$.x2;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.h3;
  var getNumberHashCode = kotlin_kotlin.$_$.x8;
  var LoggerState_getInstance = kotlin_core_core_api.$_$.fb;
  var get_descendants = kotlin_core_core_api.$_$.q3;
  var listOf = kotlin_kotlin.$_$.o6;
  var get_snapRoot = kotlin_core_core_api.$_$.i1;
  var get_highestPriorityConnection = kotlin_core_core_api.$_$.s1;
  var SnapActionCandidateSortAndSelectStrategies_getInstance = kotlin_core_core_api.$_$.sc;
  var SnapUtils_instance = kotlin_core_core_api.$_$.vc;
  var toList = kotlin_kotlin.$_$.v7;
  var sortedWith = kotlin_kotlin.$_$.m7;
  var Comparator = kotlin_kotlin.$_$.pc;
  var compareValues = kotlin_kotlin.$_$.d8;
  var SystemBase = kotlin_core_core_api.$_$.e3;
  var ConnectorTagConstants_instance = kotlin_core_core_api.$_$.ea;
  var Companion_instance_0 = kotlin_core_core_api.$_$.fd;
  var ValidationImpl = kotlin_core_core_api.$_$.t7;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.q;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.g;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.z;
  var Map = kotlin_kotlin.$_$.g4;
  var isInterface = kotlin_kotlin.$_$.j9;
  var Companion_getInstance_2 = kotlin_core_core_api.$_$.ha;
  var ConnectorsComponent = kotlin_core_core_api.$_$.u1;
  var get_connectorsComponent = kotlin_core_core_api.$_$.h2;
  var contains = kotlin_kotlin.$_$.x4;
  var SurfaceConnector = kotlin_core_core_api.$_$.g2;
  var emptyList = kotlin_kotlin.$_$.o5;
  var any = kotlin_kotlin.$_$.o4;
  var getHierarchyWithComponent = kotlin_core_core_api.$_$.v3;
  var get_guestConnections = kotlin_core_core_api.$_$.q1;
  var HierarchyUtils_instance = kotlin_core_core_api.$_$.za;
  var Companion_instance_1 = kotlin_core_core_api.$_$.z9;
  var addAll = kotlin_kotlin.$_$.l4;
  var get_worldTransform = kotlin_core_core_api.$_$.n7;
  var SystemBase4 = kotlin_core_core_api.$_$.c3;
  var SceneReloadingComponent_instance = kotlin_core_core_api.$_$.nc;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.s;
  var findInHierarchy = kotlin_core_core_api.$_$.s3;
  var Exception = kotlin_kotlin.$_$.uc;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.v4;
  var addAll_0 = kotlin_kotlin.$_$.m4;
  var Vector = kotlin_core_core_api.$_$.c5;
  var ConnectorType_instance = kotlin_core_core_api.$_$.fa;
  var Transform = kotlin_core_core_api.$_$.b5;
  var PointConnector = kotlin_core_core_api.$_$.z1;
  var Pair = kotlin_kotlin.$_$.yc;
  var asSequence = kotlin_kotlin.$_$.s4;
  var map = kotlin_kotlin.$_$.za;
  var compareTo = kotlin_kotlin.$_$.r8;
  var EdgeConnector = kotlin_core_core_api.$_$.y1;
  var Companion_getInstance_3 = kotlin_core_core_api.$_$.pc;
  var objectCreate = kotlin_kotlin.$_$.s9;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.d1;
  var listOf_0 = kotlin_kotlin.$_$.p6;
  var any_0 = kotlin_kotlin.$_$.p4;
  var toString = kotlin_kotlin.$_$.z9;
  var get_productRefOrEmptyString = kotlin_core_core_api.$_$.x;
  var roundToInt = kotlin_kotlin.$_$.ba;
  var ValidationResult = kotlin_core_core_api.$_$.w7;
  var ValidationResultType_FAIL_getInstance = kotlin_core_core_api.$_$.n8;
  var interfaceMeta = kotlin_kotlin.$_$.b9;
  var get_hierarchy = kotlin_core_core_api.$_$.x3;
  var get_isPropping = kotlin_core_core_api.$_$.j5;
  var PointSeriesSubConnector = kotlin_core_core_api.$_$.b2;
  var toList_0 = kotlin_kotlin.$_$.u7;
  var get_connectionRootEntity = kotlin_core_core_api.$_$.g5;
  var asSequence_0 = kotlin_kotlin.$_$.t4;
  var filter = kotlin_kotlin.$_$.ua;
  var onEach = kotlin_kotlin.$_$.bb;
  var mapNotNull = kotlin_kotlin.$_$.ya;
  var firstOrNull = kotlin_kotlin.$_$.va;
  var ModelUtils_getInstance = kotlin_core_core_api.$_$.ec;
  var setParent = kotlin_core_core_api.$_$.i4;
  var ValidSnapActionCandidateOrErrors = kotlin_core_core_api.$_$.s7;
  var SnapSettings = kotlin_core_core_api.$_$.a7;
  var Companion_instance_2 = kotlin_core_core_api.$_$.rc;
  var get_snappingEntitiesSequence = kotlin_core_core_api.$_$.j2;
  var Collection = kotlin_kotlin.$_$.z3;
  var any_1 = kotlin_kotlin.$_$.qa;
  var NoValidConnectorAvailableValidationResult = kotlin_core_core_api.$_$.q7;
  var UnknownErrorValidationResult = kotlin_core_core_api.$_$.r7;
  var TransformUtils_instance = kotlin_core_core_api.$_$.cd;
  var get_productRef = kotlin_core_core_api.$_$.w;
  var ensureNotNull = kotlin_kotlin.$_$.qd;
  var none = kotlin_kotlin.$_$.v6;
  var get_parentComponent = kotlin_core_core_api.$_$.g4;
  var firstOrNull_0 = kotlin_kotlin.$_$.u5;
  var hashCode = kotlin_kotlin.$_$.a9;
  var get_worldPosition = kotlin_core_core_api.$_$.l7;
  var firstOrNull_1 = kotlin_kotlin.$_$.t5;
  var sortedWith_0 = kotlin_kotlin.$_$.n7;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var get_partKey = kotlin_core_core_api.$_$.m;
  var first = kotlin_kotlin.$_$.w5;
  var get_immediateConnectionRootDescendants = kotlin_core_core_api.$_$.i5;
  var getStringHashCode = kotlin_kotlin.$_$.z8;
  var SnapActionCandidateSortAndSelectStrategy = kotlin_core_core_api.$_$.x6;
  var get_displayName = kotlin_core_core_api.$_$.h5;
  var Companion_instance_3 = kotlin_core_core_api.$_$.ca;
  var filterNotNull = kotlin_kotlin.$_$.s5;
  var Companion_instance_4 = kotlin_core_core_api.$_$.oa;
  var distinct_0 = kotlin_kotlin.$_$.m5;
  var resumeViewerUpdatesOnDraggedEntity = kotlin_core_core_api.$_$.z5;
  var SomethingIsDraggedComponent = kotlin_core_core_api.$_$.r2;
  var pauseViewerUpdatesOnDraggedEntity = kotlin_core_core_api.$_$.y5;
  var Companion_instance_5 = kotlin_core_core_api.$_$.bc;
  var plus = kotlin_kotlin.$_$.cb;
  var setParentMaintainWorldTransform = kotlin_core_core_api.$_$.h4;
  var ViewerLineIdsComponent = kotlin_core_core_api.$_$.t5;
  var LogLevel_DEBUG_getInstance = kotlin_core_core_api.$_$.a8;
  var Companion_instance_6 = kotlin_core_core_api.$_$.la;
  var Companion_instance_7 = kotlin_core_core_api.$_$.xc;
  var Companion_instance_8 = kotlin_core_core_api.$_$.hc;
  var repeat = kotlin_kotlin.$_$.rb;
  var joinToString_0 = kotlin_kotlin.$_$.e6;
  var println = kotlin_kotlin.$_$.h8;
  var EntityManagerWatcher = kotlin_core_core_api.$_$.z2;
  var Measurer = kotlin_core_core_api.$_$.o7;
  var DebugLinesComponent = kotlin_core_core_api.$_$.k2;
  var PolyhedronGroup = kotlin_core_core_api.$_$.u6;
  var Companion_getInstance_4 = kotlin_core_core_api.$_$.tb;
  var DebugLine = kotlin_core_core_api.$_$.l2;
  var ConvexPolyhedron = kotlin_core_core_api.$_$.s6;
  var last = kotlin_kotlin.$_$.m6;
  var Companion_instance_9 = kotlin_core_core_api.$_$.qa;
  var InSceneComponent_instance = kotlin_core_core_api.$_$.ab;
  var Companion_instance_10 = kotlin_core_core_api.$_$.ma;
  var get_isInScene = kotlin_core_core_api.$_$.e4;
  var PolyhedronUtils_getInstance = kotlin_core_core_api.$_$.qc;
  var DebugSurfacesComponent = kotlin_core_core_api.$_$.m2;
  var get_colliderShapeComponent = kotlin_core_core_api.$_$.e1;
  var DragSurface = kotlin_core_core_api.$_$.o2;
  var DragSurfacesComponent = kotlin_core_core_api.$_$.n2;
  var Companion_instance_11 = kotlin_core_core_api.$_$.s9;
  var triggerMovedToValidSnapPositionComponent = kotlin_core_core_api.$_$.c7;
  var Companion_instance_12 = kotlin_core_core_api.$_$.ra;
  var filterInHierarchy = kotlin_core_core_api.$_$.r3;
  var Companion_instance_13 = kotlin_core_core_api.$_$.cc;
  var Companion_instance_14 = kotlin_core_core_api.$_$.dc;
  var Companion_getInstance_5 = kotlin_core_core_api.$_$.rb;
  var Companion_instance_15 = kotlin_core_core_api.$_$.ed;
  var CollisionUtils_instance = kotlin_core_core_api.$_$.u9;
  var hierarchyExceptSubTreeArray = kotlin_core_core_api.$_$.z3;
  var Companion_getInstance_6 = kotlin_core_core_api.$_$.kb;
  var forEachInHierarchy = kotlin_core_core_api.$_$.u3;
  var RaycastUtils_instance = kotlin_core_core_api.$_$.ac;
  var findWithComponentInUpwardsHierarchy = kotlin_core_core_api.$_$.t3;
  var get_draggableRootEntity = kotlin_core_core_api.$_$.g1;
  var Companion_instance_16 = kotlin_core_core_api.$_$.zb;
  var WorldSpaceDragEventComponent = kotlin_core_core_api.$_$.u2;
  var almostEquals = kotlin_core_core_api.$_$.d5;
  var Companion_instance_17 = kotlin_core_core_api.$_$.pa;
  var centerOfConnections = kotlin_core_core_api.$_$.p1;
  var hierarchyExceptSubTreesWithComponentSequence = kotlin_core_core_api.$_$.b4;
  var Companion_getInstance_7 = kotlin_core_core_api.$_$.sa;
  var UnserializableEntityComponent = kotlin_core_core_api.$_$.q6;
  var DisplayNameComponent = kotlin_core_core_api.$_$.e5;
  var plus_0 = kotlin_kotlin.$_$.x6;
  var isDescendantOf = kotlin_core_core_api.$_$.d4;
  var RaycastResult = kotlin_core_core_api.$_$.l5;
  var RaycastHit = kotlin_core_core_api.$_$.k5;
  var Plane = kotlin_core_core_api.$_$.v4;
  var get_hierarchySequence = kotlin_core_core_api.$_$.c4;
  var get_objectOrientedBoundingBoxForHierarchy = kotlin_core_core_api.$_$.f1;
  var Companion_instance_18 = kotlin_core_core_api.$_$.bd;
  var get_collider = kotlin_core_core_api.$_$.d1;
  var lazy = kotlin_kotlin.$_$.wd;
  var KProperty0 = kotlin_kotlin.$_$.ma;
  var THROW_ISE = kotlin_kotlin.$_$.cd;
  var getLocalDelegateReference = kotlin_kotlin.$_$.w8;
  var hierarchyContains = kotlin_core_core_api.$_$.y3;
  var ValidationResultType_WARNING_getInstance = kotlin_core_core_api.$_$.o8;
  var fillArrayVal = kotlin_kotlin.$_$.u8;
  var isArray = kotlin_kotlin.$_$.c9;
  var mutableListOf = kotlin_kotlin.$_$.u6;
  var mapCapacity = kotlin_kotlin.$_$.q6;
  var coerceAtLeast = kotlin_kotlin.$_$.fa;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.p;
  var to = kotlin_kotlin.$_$.be;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.n;
  var LogLevel_ERROR_getInstance = kotlin_core_core_api.$_$.b8;
  var values = kotlin_core_core_api.$_$.m4;
  var echoStandardConsole = kotlin_core_core_api.$_$.r4;
  var toString_0 = kotlin_kotlin.$_$.ae;
  var LogLevel_WARN_getInstance = kotlin_core_core_api.$_$.d8;
  var LogLevel_INFO_getInstance = kotlin_core_core_api.$_$.c8;
  var set_logLevel = kotlin_core_core_api.$_$.o4;
  var get_logLevel = kotlin_core_core_api.$_$.n4;
  var Logger = kotlin_core_core_api.$_$.q4;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.y;
  var captureStack = kotlin_kotlin.$_$.k8;
  var get_viewerObject = kotlin_core_core_api.$_$.a6;
  var get_isSelected = kotlin_core_core_api.$_$.g6;
  var SelectedComponent_instance = kotlin_core_core_api.$_$.mc;
  var hasComponentInUpwardsHierarchy = kotlin_core_core_api.$_$.w3;
  var Companion_instance_19 = kotlin_core_core_api.$_$.ya;
  var Companion_instance_20 = kotlin_core_core_api.$_$.cb;
  var get_worldRotation = kotlin_core_core_api.$_$.m7;
  var SnapCandidateComponent = kotlin_core_core_api.$_$.y6;
  var Companion_instance_21 = kotlin_core_core_api.$_$.tc;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.k1;
  var addAll_1 = kotlin_kotlin.$_$.n4;
  var ValidationResultFail = kotlin_core_core_api.$_$.u7;
  var ValidationResultWarning = kotlin_core_core_api.$_$.v7;
  var get_axisAlignedBoundingBoxForHierarchy = kotlin_core_core_api.$_$.c1;
  var minus = kotlin_kotlin.$_$.ab;
  var RestrictAllowedRequiredHostsComponent = kotlin_core_core_api.$_$.w6;
  var ChildComponent = kotlin_core_core_api.$_$.j3;
  var LocalTransformComponentFromPosAndRot = kotlin_core_core_api.$_$.h9;
  var AxisAlignedBox = kotlin_core_core_api.$_$.r6;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.i1;
  var CollisionValidationResult = kotlin_core_core_api.$_$.z;
  var plus_1 = kotlin_kotlin.$_$.b7;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.j3;
  var CollisionValidation = kotlin_core_core_api.$_$.a1;
  var numberRangeToNumber = kotlin_kotlin.$_$.o9;
  var numberToInt = kotlin_kotlin.$_$.q9;
  var RenderedComponent_instance = kotlin_core_core_api.$_$.fc;
  var toMutableList = kotlin_kotlin.$_$.x7;
  var Companion_instance_22 = kotlin_core_core_api.$_$.r9;
  var flatten = kotlin_kotlin.$_$.y5;
  var get_snapRootSubTree = kotlin_core_core_api.$_$.b7;
  var get_guestConnectors = kotlin_core_core_api.$_$.i2;
  var get_isHanging = kotlin_core_core_api.$_$.j7;
  var get_localTransform = kotlin_core_core_api.$_$.k7;
  var Radians = kotlin_core_core_api.$_$.x4;
  var Connection = kotlin_core_core_api.$_$.l1;
  var GuestConnectionsComponent = kotlin_core_core_api.$_$.m1;
  var Companion_instance_23 = kotlin_core_core_api.$_$.na;
  var toSet = kotlin_kotlin.$_$.a8;
  var sorted = kotlin_kotlin.$_$.o7;
  var ColliderShapeComponent = kotlin_core_core_api.$_$.y;
  var AlwaysHangDownComponent_instance = kotlin_core_core_api.$_$.zc;
  var Default_getInstance = kotlin_kotlin.$_$.m3;
  var NoSuchElementException_init_$Create$_0 = kotlin_kotlin.$_$.h1;
  var Companion_instance_24 = kotlin_core_core_api.$_$.l9;
  var AddPartAction = kotlin_core_core_api.$_$.e;
  var ReplacePartAction = kotlin_core_core_api.$_$.d6;
  var RemovePartAction = kotlin_core_core_api.$_$.l;
  var RelativeConnectorRepositioner_instance = kotlin_core_core_api.$_$.ja;
  var getBooleanHashCode = kotlin_kotlin.$_$.v8;
  var get_guests = kotlin_core_core_api.$_$.r1;
  var ReplaceAction = kotlin_core_core_api.$_$.c6;
  var FastReplaceAction = kotlin_core_core_api.$_$.b6;
  var get_isAutomaticGroup = kotlin_core_core_api.$_$.i3;
  var ComponentDeserializer = kotlin_core_core_api.$_$.i6;
  var getKClass = kotlin_kotlin.$_$.d;
  var ReferenceArraySerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var $serializer_getInstance = kotlin_core_core_api.$_$.sb;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.n3;
  var $serializer_getInstance_0 = kotlin_core_core_api.$_$.qb;
  var DisabledConnectorsComponent = kotlin_core_core_api.$_$.x1;
  var Companion_instance_25 = kotlin_core_core_api.$_$.ia;
  var plus_2 = kotlin_kotlin.$_$.c7;
  var minus_0 = kotlin_kotlin.$_$.t6;
  var Connector = kotlin_core_core_api.$_$.v1;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.h;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var JsonSerializable = kotlin_core_core_api.$_$.j6;
  var get_serializable_0 = kotlin_core_core_api.$_$.o6;
  var SerializableComponent = kotlin_core_core_api.$_$.p6;
  var __VectorIntConstructorKotlin = kotlin_core_core_api.$_$.e9;
  var createCustomAssembly = kotlin_core_core_api.$_$.o;
  var createCustomAssemblySpecification = kotlin_core_core_api.$_$.n;
  var beforeDeserialize = kotlin_core_core_api.$_$.m6;
  var beforeParsingComponents = kotlin_core_core_api.$_$.n6;
  var afterDeserializeComplete = kotlin_core_core_api.$_$.l6;
  var ProductCatalog = kotlin_core_core_api.$_$.p;
  var StaticComponent_getInstance = kotlin_core_core_api.$_$.wa;
  var ConnectionRootComponent = kotlin_core_core_api.$_$.k1;
  var SnapRootComponent = kotlin_core_core_api.$_$.z6;
  var CuboidFromSize = kotlin_core_core_api.$_$.f9;
  var LocalTransformComponent = kotlin_core_core_api.$_$.g7;
  var WorldTransformComponent = kotlin_core_core_api.$_$.i7;
  var toMap = kotlin_kotlin.$_$.w7;
  var Degrees = kotlin_core_core_api.$_$.s4;
  var get_indices = kotlin_kotlin.$_$.d6;
  var mapOf = kotlin_kotlin.$_$.s6;
  var plus_3 = kotlin_kotlin.$_$.z6;
  var QuaternionFromDouble = kotlin_core_core_api.$_$.c9;
  var MultiSelectionEnabledComponent_instance = kotlin_core_core_api.$_$.kc;
  var get_selectableRoot = kotlin_core_core_api.$_$.h1;
  var Companion_instance_26 = kotlin_core_core_api.$_$.lc;
  var Companion_instance_27 = kotlin_core_core_api.$_$.jc;
  var Ray = kotlin_core_core_api.$_$.m5;
  var ViewerDragEventComponent = kotlin_core_core_api.$_$.s2;
  var ConnectorUtils_instance = kotlin_core_core_api.$_$.ga;
  var hierarchyExceptSubTreesWithComponentArray = kotlin_core_core_api.$_$.a4;
  var Companion_instance_28 = kotlin_core_core_api.$_$.y9;
  var CuboidFromSizeAndCenter = kotlin_core_core_api.$_$.g9;
  var Companion_instance_29 = kotlin_core_core_api.$_$.ic;
  var ViewerObjectComponent = kotlin_core_core_api.$_$.u5;
  var SystemBase3 = kotlin_core_core_api.$_$.b3;
  var Companion_instance_30 = kotlin_core_core_api.$_$.gc;
  var Companion_instance_31 = kotlin_core_core_api.$_$.wc;
  var emptyMap = kotlin_kotlin.$_$.p5;
  var Error_init_$Create$ = kotlin_kotlin.$_$.x;
  var mapOf_0 = kotlin_kotlin.$_$.r6;
  var SystemBase5 = kotlin_core_core_api.$_$.d3;
  var SceneComponent_instance = kotlin_core_core_api.$_$.bb;
  var toMutableMap = kotlin_kotlin.$_$.z7;
  var PointSeriesConnector = kotlin_core_core_api.$_$.a2;
  var Random = kotlin_kotlin.$_$.da;
  var toList_1 = kotlin_kotlin.$_$.fb;
  var flatten_0 = kotlin_kotlin.$_$.x5;
  var emptySequence = kotlin_kotlin.$_$.ta;
  var endsWith = kotlin_kotlin.$_$.jb;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(AlignmentConnectionCreationSystem, 'AlignmentConnectionCreationSystem', classMeta, SystemBase2);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(AlignmentConnectionsComponent, 'AlignmentConnectionsComponent', classMeta, VOID, [Component], AlignmentConnectionsComponent);
  setMetadataFor(AlignmentPlane, 'AlignmentPlane', classMeta);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(HandleUnderAlignmentComponent, 'HandleUnderAlignmentComponent', objectMeta, VOID, [Component]);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(HandleRotationSystem, 'HandleRotationSystem', classMeta, SystemBase);
  setMetadataFor(HostConnectorRotationValidation, 'HostConnectorRotationValidation', classMeta, ValidationImpl, VOID, HostConnectorRotationValidation);
  setMetadataFor(AlignmentLinesReferenceCounter, 'AlignmentLinesReferenceCounter', classMeta, VOID, VOID, AlignmentLinesReferenceCounter);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(AlignmentLinesSystem, 'AlignmentLinesSystem', classMeta, SystemBase4);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(AlignmentLinesUtils, 'AlignmentLinesUtils', classMeta, VOID, VOID, AlignmentLinesUtils);
  setMetadataFor(IntersectionPointConnectors, 'IntersectionPointConnectors', classMeta);
  setMetadataFor(IntersectionPointsTracker, 'IntersectionPointsTracker', classMeta, VOID, VOID, IntersectionPointsTracker);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor(RoomAlignmentEdgesComponent, 'RoomAlignmentEdgesComponent', classMeta, VOID, [Component]);
  setMetadataFor(SurfaceAlignmentLines, 'SurfaceAlignmentLines', classMeta);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(AllowedDoorPairsComponent, 'AllowedDoorPairsComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(AllowedDoorPairsValidation, 'AllowedDoorPairsValidation', classMeta, ValidationImpl, VOID, AllowedDoorPairsValidation);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(InvalidDoorPairsResult, 'InvalidDoorPairsResult', classMeta, ValidationResult);
  setMetadataFor(AssemblyInstructionsService, 'AssemblyInstructionsService', interfaceMeta);
  setMetadataFor(AssemblyInstructionsServiceImpl, 'AssemblyInstructionsServiceImpl', classMeta, VOID, [AssemblyInstructionsService], AssemblyInstructionsServiceImpl);
  setMetadataFor(PointSeriesAssemblyInstruction, 'PointSeriesAssemblyInstruction', interfaceMeta);
  setMetadataFor(PointSeriesAssemblyInstructionImpl, 'PointSeriesAssemblyInstructionImpl', classMeta, VOID, [PointSeriesAssemblyInstruction]);
  setMetadataFor(AutoAdaptFeature, 'AutoAdaptFeature', objectMeta);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptProductSpecificationsSystem, 'AutoAdaptProductSpecificationsSystem', classMeta, SystemBase);
  setMetadataFor(AutoAdaptService, 'AutoAdaptService', classMeta);
  setMetadataFor(EntityWithSensorZone, 'EntityWithSensorZone', classMeta);
  setMetadataFor(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(AutoAdaptUtils, 'AutoAdaptUtils', objectMeta);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptChildFailedEventComponent, 'AutoAdaptChildFailedEventComponent', classMeta, VOID, [Component], AutoAdaptChildFailedEventComponent);
  setMetadataFor(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(ChildInfo, 'ChildInfo', classMeta);
  setMetadataFor(PreferSameConnectorsStrategy, 'PreferSameConnectorsStrategy', classMeta, VOID, [SnapActionCandidateSortAndSelectStrategy]);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptChildrenSystem, 'AutoAdaptChildrenSystem', classMeta, SystemBase);
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptDisposeFailedChildrenSystem, 'AutoAdaptDisposeFailedChildrenSystem', classMeta, SystemBase, VOID, AutoAdaptDisposeFailedChildrenSystem);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptCacheSystem, 'AutoAdaptCacheSystem', classMeta, SystemBase);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptCachedVariantsComponent, 'AutoAdaptCachedVariantsComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptSessionComponent, 'AutoAdaptSessionComponent', classMeta, VOID, [Component], AutoAdaptSessionComponent);
  setMetadataFor(Companion_15, 'Companion', objectMeta);
  setMetadataFor(CleanCacheOnFinishedAutoAdaptSystem, 'CleanCacheOnFinishedAutoAdaptSystem', classMeta, SystemBase2, VOID, CleanCacheOnFinishedAutoAdaptSystem);
  setMetadataFor(Companion_16, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptGuestComponent, 'AutoAdaptGuestComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_17, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptHostComponent, 'AutoAdaptHostComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_18, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptProductSpecificationsComponent, 'AutoAdaptProductSpecificationsComponent', classMeta, VOID, [Component]);
  setMetadataFor(SpecificationPair, 'SpecificationPair', classMeta);
  setMetadataFor(Companion_19, 'Companion', objectMeta);
  setMetadataFor(AutoAdaptVariantComponent, 'AutoAdaptVariantComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_20, 'Companion', objectMeta);
  setMetadataFor(ForceAutoAdaptWhenParentIsDraggedComponent, 'ForceAutoAdaptWhenParentIsDraggedComponent', classMeta, VOID, [Component], ForceAutoAdaptWhenParentIsDraggedComponent);
  setMetadataFor(Companion_21, 'Companion', objectMeta);
  setMetadataFor(ReplacedWithAutoAdaptEventComponent, 'ReplacedWithAutoAdaptEventComponent', classMeta, VOID, [Component]);
  function dragStart(draggedRootEntity) {
  }
  function dragStop(draggedRootEntity) {
  }
  setMetadataFor(DragStrategy, 'DragStrategy', interfaceMeta);
  setMetadataFor(AbstractDragStrategy, 'AbstractDragStrategy', classMeta, VOID, [DragStrategy]);
  setMetadataFor(AutoAdaptDragStrategy, 'AutoAdaptDragStrategy', classMeta, AbstractDragStrategy);
  setMetadataFor(Companion_22, 'Companion', objectMeta);
  setMetadataFor(DragSurfaceSelector, 'DragSurfaceSelector', interfaceMeta);
  setMetadataFor(DragSurfaceCanHostSelector, 'DragSurfaceCanHostSelector', classMeta, VOID, [DragSurfaceSelector], DragSurfaceCanHostSelector);
  setMetadataFor(DragSurfaceCanHostWithAutoAdaptSelector, 'DragSurfaceCanHostWithAutoAdaptSelector', classMeta, DragSurfaceCanHostSelector);
  setMetadataFor(ValidDragStrategyResult, 'ValidDragStrategyResult', classMeta);
  setMetadataFor(ValidAutoAdaptDragStrategyResult, 'ValidAutoAdaptDragStrategyResult', classMeta, ValidDragStrategyResult);
  setMetadataFor(Companion_23, 'Companion', objectMeta);
  setMetadataFor(DebugLineDrawingSystem, 'DebugLineDrawingSystem', classMeta, SystemBase2);
  setMetadataFor(LoggingEntityManagerWatcher, 'LoggingEntityManagerWatcher', classMeta, VOID, [EntityManagerWatcher]);
  setMetadataFor(DoneEntry, 'DoneEntry', objectMeta);
  setMetadataFor(AddEntry, 'AddEntry', classMeta);
  setMetadataFor(RemoveEntry, 'RemoveEntry', classMeta);
  setMetadataFor(CallEntry, 'CallEntry', classMeta);
  setMetadataFor(MeasuringEntityManagerWatcher, 'MeasuringEntityManagerWatcher', classMeta, VOID, [EntityManagerWatcher]);
  setMetadataFor(Companion_24, 'Companion', objectMeta);
  setMetadataFor(DragState, 'DragState', classMeta);
  setMetadataFor(Companion_25, 'Companion', objectMeta);
  setMetadataFor(DragStateComponent, 'DragStateComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_26, 'Companion', objectMeta);
  setMetadataFor(DragSurfaceNormalVisualizationSystem, 'DragSurfaceNormalVisualizationSystem', classMeta, SystemBase2);
  setMetadataFor(Companion_27, 'Companion', objectMeta);
  setMetadataFor(DragSurfaceVisualizationSystem, 'DragSurfaceVisualizationSystem', classMeta, SystemBase2);
  setMetadataFor(DragSurfacesUpdateSystem, 'DragSurfacesUpdateSystem', classMeta, SystemBase2);
  setMetadataFor(Companion_28, 'Companion', objectMeta);
  setMetadataFor(DragSystem, 'DragSystem', classMeta, SystemBase);
  setMetadataFor(Companion_29, 'Companion', objectMeta);
  setMetadataFor(DrawDragGhostSystem, 'DrawDragGhostSystem', classMeta, SystemBase);
  setMetadataFor(PostProcessDragStrategy, 'PostProcessDragStrategy', interfaceMeta);
  setMetadataFor(HigherPriorityAlignmentPostProcess, 'HigherPriorityAlignmentPostProcess', classMeta, VOID, [PostProcessDragStrategy]);
  setMetadataFor(IsDraggedComponent, 'IsDraggedComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_30, 'Companion', objectMeta);
  setMetadataFor(TakeSnapshotBeforeDragSystem, 'TakeSnapshotBeforeDragSystem', classMeta, SystemBase);
  setMetadataFor(FreeMoveComponent, 'FreeMoveComponent', objectMeta, VOID, [Component]);
  setMetadataFor(FreeMoveDragStrategy, 'FreeMoveDragStrategy', classMeta, AbstractDragStrategy);
  setMetadataFor(ResolveCollisionsDragStrategy, 'ResolveCollisionsDragStrategy', classMeta, AbstractDragStrategy);
  setMetadataFor(SnapCardinalDirectionsDragStrategy, 'SnapCardinalDirectionsDragStrategy', classMeta, AbstractDragStrategy);
  setMetadataFor(SnapClosestDragStrategy, 'SnapClosestDragStrategy', classMeta, AbstractDragStrategy);
  setMetadataFor(SnapClosestWithSubConnectorsDragStrategy, 'SnapClosestWithSubConnectorsDragStrategy', classMeta, AbstractDragStrategy);
  setMetadataFor(Companion_31, 'Companion', objectMeta);
  setMetadataFor(Companion_32, 'Companion', objectMeta);
  setMetadataFor(CanvasTo3DDragConverterSystem, 'CanvasTo3DDragConverterSystem', classMeta, SystemBase);
  setMetadataFor(DragSurfaceEntityPair, 'DragSurfaceEntityPair', classMeta);
  setMetadataFor(Companion_33, 'Companion', objectMeta);
  setMetadataFor(DragSurfaceOnlyRoomSelector, 'DragSurfaceOnlyRoomSelector', classMeta, VOID, [DragSurfaceSelector], DragSurfaceOnlyRoomSelector);
  setMetadataFor(Companion_34, 'Companion', objectMeta);
  setMetadataFor(LegacyCanvasTo3DDragConverterSystem, 'LegacyCanvasTo3DDragConverterSystem', classMeta, SystemBase);
  setMetadataFor(NoDragConverterDetector, 'NoDragConverterDetector', classMeta, SystemBase2);
  setMetadataFor(Companion_35, 'Companion', objectMeta);
  setMetadataFor(DragProjectionPointComponent, 'DragProjectionPointComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_36, 'Companion', objectMeta);
  setMetadataFor(GrabOffsetComponent, 'GrabOffsetComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_37, 'Companion', objectMeta);
  setMetadataFor(DragSurfacesChangedListener, 'DragSurfacesChangedListener', interfaceMeta);
  setMetadataFor(DragSurfaceProjector, 'DragSurfaceProjector', interfaceMeta, VOID, [DragSurfacesChangedListener]);
  setMetadataFor(AnyDragSurfaceProjector, 'AnyDragSurfaceProjector', classMeta, VOID, [DragSurfaceProjector]);
  setMetadataFor(Companion_38, 'Companion', objectMeta);
  setMetadataFor(DragSurfaceEntityPairsCacheComponent, 'DragSurfaceEntityPairsCacheComponent', classMeta, VOID, [Component], DragSurfaceEntityPairsCacheComponent);
  setMetadataFor(Companion_39, 'Companion', objectMeta);
  setMetadataFor(DragSurfaceUpdatesListenerSystem, 'DragSurfaceUpdatesListenerSystem', classMeta, SystemBase2);
  setMetadataFor(XYPlaneProjector, 'XYPlaneProjector', classMeta, VOID, [DragSurfaceProjector], XYPlaneProjector);
  setMetadataFor(Companion_40, 'Companion', objectMeta);
  setMetadataFor(FunctionalMarginComponent, 'FunctionalMarginComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_41, 'Companion', objectMeta);
  setMetadataFor(FunctionalMarginShapeComponent, 'FunctionalMarginShapeComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_42, 'Companion', objectMeta);
  setMetadataFor(FunctionalMarginSystem, 'FunctionalMarginSystem', classMeta, SystemBase2, VOID, FunctionalMarginSystem);
  setMetadataFor(Companion_43, 'Companion', objectMeta);
  setMetadataFor(FunctionalMarginValidation, 'FunctionalMarginValidation', classMeta, ValidationImpl);
  setMetadataFor(Companion_44, 'Companion', objectMeta);
  setMetadataFor(FunctionalMarginWarning, 'FunctionalMarginWarning', classMeta, ValidationResult);
  setMetadataFor(FunctionalZone, 'FunctionalZone', classMeta);
  setMetadataFor(Companion_45, 'Companion', objectMeta);
  setMetadataFor(FunctionalZonesLocalComponent, 'FunctionalZonesLocalComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_46, 'Companion', objectMeta);
  setMetadataFor(FunctionalZonesLocalToWorldSystem, 'FunctionalZonesLocalToWorldSystem', classMeta, SystemBase2);
  setMetadataFor(Companion_47, 'Companion', objectMeta);
  setMetadataFor(FunctionalZonesWorldComponent, 'FunctionalZonesWorldComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_48, 'Companion', objectMeta);
  setMetadataFor(ICFDataService, 'ICFDataService', classMeta);
  setMetadataFor(ICFProductData, 'ICFProductData', classMeta);
  setMetadataFor(Companion_49, 'Companion', objectMeta);
  setMetadataFor(LabelComponent, 'LabelComponent', classMeta, VOID, [Component]);
  setMetadataFor(DebugLogger, 'DebugLogger', classMeta, VOID, [Logger], DebugLogger);
  setMetadataFor(LoggerException, 'LoggerException', classMeta, Exception, VOID, LoggerException);
  setMetadataFor(Companion_50, 'Companion', objectMeta);
  setMetadataFor(ColoredOutlineComponent, 'ColoredOutlineComponent', classMeta, VOID, [Component], ColoredOutlineComponent);
  setMetadataFor(ColoredOutlineSystem, 'ColoredOutlineSystem', classMeta, SystemBase, VOID, ColoredOutlineSystem);
  setMetadataFor(Companion_51, 'Companion', objectMeta);
  setMetadataFor(OutlineBlockingComponent, 'OutlineBlockingComponent', classMeta, VOID, [Component], OutlineBlockingComponent);
  setMetadataFor(Companion_52, 'Companion', objectMeta);
  setMetadataFor(OutlineEntityGroupDeselectSystem, 'OutlineEntityGroupDeselectSystem', classMeta, SystemBase);
  setMetadataFor(Companion_53, 'Companion', objectMeta);
  setMetadataFor(OutlineSelectedSystem, 'OutlineSelectedSystem', classMeta, SystemBase, VOID, OutlineSelectedSystem);
  setMetadataFor(OutlineSystem, 'OutlineSystem', classMeta, SystemBase4, VOID, OutlineSystem);
  setMetadataFor(Companion_54, 'Companion', objectMeta);
  setMetadataFor(OutlinedComponent, 'OutlinedComponent', classMeta, VOID, [Component], OutlinedComponent);
  setMetadataFor(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(AutoAdaptPlacementActor, 'AutoAdaptPlacementActor', classMeta);
  setMetadataFor(PlacementHelper, 'PlacementHelper', objectMeta);
  setMetadataFor(Companion_55, 'Companion', objectMeta);
  setMetadataFor(PlacementResult, 'PlacementResult', classMeta);
  setMetadataFor(PlacementService, 'PlacementService', classMeta);
  setMetadataFor(Companion_56, 'Companion', objectMeta);
  setMetadataFor(PlacementZoneByHeightComponent, 'PlacementZoneByHeightComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_57, 'Companion', objectMeta);
  setMetadataFor(RecommendedInitialPositionFromFloorComponent, 'RecommendedInitialPositionFromFloorComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_58, 'Companion', objectMeta);
  setMetadataFor(RecommendedInitialPositionFromParentComponent, 'RecommendedInitialPositionFromParentComponent', classMeta, VOID, [Component]);
  setMetadataFor(SearchDirectionsUtils, 'SearchDirectionsUtils', objectMeta);
  setMetadataFor(CandidateResult, 'CandidateResult', classMeta);
  setMetadataFor(Companion_59, 'Companion', objectMeta);
  setMetadataFor(SnapPlacementActor, 'SnapPlacementActor', classMeta);
  setMetadataFor(SortCriterion, 'SortCriterion', interfaceMeta);
  setMetadataFor(SortCriterionBase, 'SortCriterionBase', classMeta, VOID, [SortCriterion]);
  setMetadataFor(DistanceCriterion, 'DistanceCriterion', classMeta, SortCriterionBase, [SortCriterionBase, SortCriterion], DistanceCriterion);
  setMetadataFor(FilterCriterion, 'FilterCriterion', interfaceMeta);
  setMetadataFor(InActivationDistanceFilter, 'InActivationDistanceFilter', classMeta, VOID, [FilterCriterion], InActivationDistanceFilter);
  setMetadataFor(OriginalVariantCriterion, 'OriginalVariantCriterion', classMeta, SortCriterionBase, [SortCriterionBase, SortCriterion], OriginalVariantCriterion);
  setMetadataFor(PriorityCriterionSettings, 'PriorityCriterionSettings', interfaceMeta);
  setMetadataFor(PriorityCriterionSettings$Companion$all$1, VOID, classMeta, VOID, [PriorityCriterionSettings]);
  setMetadataFor(PriorityCriterionSettings$Companion$onlyInActivationDistance$1, VOID, classMeta, VOID, [PriorityCriterionSettings]);
  setMetadataFor(Companion_60, 'Companion', objectMeta);
  setMetadataFor(PriorityCriterion, 'PriorityCriterion', classMeta, SortCriterionBase, [SortCriterionBase, SortCriterion]);
  setMetadataFor(RecommendedDistanceFromFloorCriterion, 'RecommendedDistanceFromFloorCriterion', classMeta, SortCriterionBase, [SortCriterionBase, SortCriterion], RecommendedDistanceFromFloorCriterion);
  setMetadataFor(sam$kotlin_Comparator$0_5, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(sam$kotlin_Comparator$0_6, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(SnapSorter, 'SnapSorter', classMeta);
  setMetadataFor(SnapSorterBuilder, 'SnapSorterBuilder', classMeta, VOID, VOID, SnapSorterBuilder);
  setMetadataFor(WarningsCriterion, 'WarningsCriterion', classMeta, VOID, [SortCriterion], WarningsCriterion);
  setMetadataFor(sam$kotlin_Comparator$0_7, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(sam$kotlin_Comparator$0_8, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(SpaceFinderUtils, 'SpaceFinderUtils', objectMeta);
  setMetadataFor(ProppingData, 'ProppingData', classMeta);
  setMetadataFor(Companion_61, 'Companion', objectMeta);
  setMetadataFor(ProppingHostConnectorsComponent, 'ProppingHostConnectorsComponent', classMeta, VOID, [Component]);
  setMetadataFor(ProppingHostConnectorData, 'ProppingHostConnectorData', classMeta);
  setMetadataFor(Companion_62, 'Companion', objectMeta);
  setMetadataFor(ProppingInfoComponent, 'ProppingInfoComponent', classMeta, VOID, [Component]);
  setMetadataFor(PropHolderInfo, 'PropHolderInfo', classMeta);
  setMetadataFor(ProppingSubSystem, 'ProppingSubSystem', classMeta, SystemBase2);
  setMetadataFor(Companion_63, 'Companion', objectMeta);
  setMetadataFor(ProppingSystem, 'ProppingSystem', classMeta, SystemBase2);
  setMetadataFor(ProppingUtils, 'ProppingUtils', objectMeta);
  setMetadataFor(ProppingsAvailableForDemand, 'ProppingsAvailableForDemand', classMeta);
  setMetadataFor(Companion_64, 'Companion', objectMeta);
  setMetadataFor(SetPropHolderInfoSystem, 'SetPropHolderInfoSystem', classMeta, SystemBase, VOID, SetPropHolderInfoSystem);
  setMetadataFor(Companion_65, 'Companion', objectMeta);
  setMetadataFor(SetProppingHostConnectorDataSystem, 'SetProppingHostConnectorDataSystem', classMeta, SystemBase);
  setMetadataFor(Companion_66, 'Companion', objectMeta);
  setMetadataFor(CommunicationSizeComponent, 'CommunicationSizeComponent', classMeta, VOID, [Component]);
  setMetadataFor(DoorComponent, 'DoorComponent', objectMeta, VOID, [Component]);
  setMetadataFor(DoorFrontComponent, 'DoorFrontComponent', objectMeta, VOID, [Component]);
  setMetadataFor(DrawerComponent, 'DrawerComponent', objectMeta, VOID, [Component]);
  setMetadataFor(FrameComponent, 'FrameComponent', objectMeta, VOID, [Component]);
  setMetadataFor(HandleComponent, 'HandleComponent', objectMeta, VOID, [Component]);
  setMetadataFor(IncludedHandleComponent, 'IncludedHandleComponent', objectMeta, VOID, [Component]);
  setMetadataFor(LegComponent, 'LegComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_67, 'Companion', objectMeta);
  setMetadataFor(LightComponent, 'LightComponent', classMeta, VOID, [Component]);
  setMetadataFor(ReplaceAssemblyPartUtils, 'ReplaceAssemblyPartUtils', objectMeta);
  setMetadataFor(Companion_68, 'Companion', objectMeta);
  setMetadataFor(ReplacePartResult, 'ReplacePartResult', classMeta);
  setMetadataFor(ReplacePlacementResult, 'ReplacePlacementResult', classMeta);
  setMetadataFor(ReplaceUtils, 'ReplaceUtils', objectMeta);
  setMetadataFor(RoomComponentDeserializer, 'RoomComponentDeserializer', classMeta, VOID, [ComponentDeserializer], RoomComponentDeserializer);
  setMetadataFor(RoomConnectorConstants, 'RoomConnectorConstants', objectMeta);
  setMetadataFor(Companion_69, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CoreRoomGeometryData, 'CoreRoomGeometryData', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(CoreRoomGeometry, 'CoreRoomGeometry', interfaceMeta);
  setMetadataFor(Companion_70, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CoreRoomSurface, 'CoreRoomSurface', classMeta, VOID, [CoreRoomGeometry], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(Companion_71, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomSurfaceGeometryImpl, 'RoomSurfaceGeometryImpl', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_72, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CoreRoomEdge, 'CoreRoomEdge', classMeta, VOID, [CoreRoomGeometry], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(Companion_73, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CoreRoomVertex, 'CoreRoomVertex', classMeta, VOID, [CoreRoomGeometry], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_74, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CoreRoomObstacle, 'CoreRoomObstacle', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(Companion_75, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(CoreRoomBoundingBox, 'CoreRoomBoundingBox', classMeta, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(RoomGeometryData, 'RoomGeometryData', interfaceMeta);
  setMetadataFor(RoomSurface, 'RoomSurface', interfaceMeta);
  setMetadataFor(RoomEdge, 'RoomEdge', interfaceMeta);
  setMetadataFor(RoomCorner, 'RoomCorner', interfaceMeta);
  setMetadataFor(RoomObstacle, 'RoomObstacle', interfaceMeta);
  setMetadataFor(RoomPoint3D, 'RoomPoint3D', interfaceMeta);
  setMetadataFor(RoomRotation, 'RoomRotation', interfaceMeta);
  setMetadataFor(RoomBoundingBox, 'RoomBoundingBox', interfaceMeta);
  setMetadataFor(RoomTransform, 'RoomTransform', interfaceMeta);
  setMetadataFor(RoomService, 'RoomService', classMeta);
  setMetadataFor(Companion_76, 'Companion', objectMeta);
  setMetadataFor(DisabledRoomConnectorsConfigComponent, 'DisabledRoomConnectorsConfigComponent', classMeta, VOID, [Component]);
  setMetadataFor(RoomComponent, 'RoomComponent', objectMeta, VOID, [Component]);
  setMetadataFor(Companion_77, 'Companion', objectMeta);
  setMetadataFor(RoomConnectorRelationsComponent, 'RoomConnectorRelationsComponent', classMeta, VOID, [Component]);
  setMetadataFor(RoomConnectorKeysForSurface, 'RoomConnectorKeysForSurface', classMeta);
  setMetadataFor(RoomConnectorKeysForEdge, 'RoomConnectorKeysForEdge', classMeta);
  setMetadataFor(RoomConnectorKeysForCorner, 'RoomConnectorKeysForCorner', classMeta);
  setMetadataFor(RoomConnectorsForSurface, 'RoomConnectorsForSurface', classMeta);
  setMetadataFor(RoomConnectorsForEdge, 'RoomConnectorsForEdge', classMeta);
  setMetadataFor(RoomConnectorsForCorner, 'RoomConnectorsForCorner', classMeta);
  setMetadataFor(Companion_78, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomDimensionsComponent, 'RoomDimensionsComponent', classMeta, VOID, [JsonSerializable, Component], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(Companion_79, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RoomGeometryComponent, 'RoomGeometryComponent', classMeta, VOID, [SerializableComponent], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(Companion_80, 'Companion', objectMeta);
  setMetadataFor(RoomPartComponent, 'RoomPartComponent', classMeta, VOID, [Component]);
  setMetadataFor(RoomRefToRoomComponentInterceptor, 'RoomRefToRoomComponentInterceptor', classMeta, VOID, [ProductCatalog], RoomRefToRoomComponentInterceptor);
  setMetadataFor(Companion_81, 'Companion', objectMeta);
  setMetadataFor(RoomDimensionToGeometrySystem, 'RoomDimensionToGeometrySystem', classMeta, SystemBase);
  setMetadataFor(RoomServiceDragSystem, 'RoomServiceDragSystem', classMeta, SystemBase);
  setMetadataFor(Companion_82, 'Companion', objectMeta);
  setMetadataFor(RoomSystem, 'RoomSystem', classMeta, SystemBase);
  setMetadataFor(Companion_83, 'Companion', objectMeta);
  setMetadataFor(RoomColliderUtilities, 'RoomColliderUtilities', classMeta, VOID, VOID, RoomColliderUtilities);
  setMetadataFor(RoomConnectorPair, 'RoomConnectorPair', classMeta);
  setMetadataFor(Companion_84, 'Companion', objectMeta);
  setMetadataFor(RoomConnectorRelationsMapper, 'RoomConnectorRelationsMapper', classMeta, VOID, VOID, RoomConnectorRelationsMapper);
  setMetadataFor(Wall, 'Wall', classMeta);
  setMetadataFor(Companion_85, 'Companion', objectMeta);
  setMetadataFor(RoomConnectorUtilities, 'RoomConnectorUtilities', classMeta, VOID, VOID, RoomConnectorUtilities);
  setMetadataFor(Companion_86, 'Companion', objectMeta);
  setMetadataFor(RoomGeometryUtilities, 'RoomGeometryUtilities', classMeta, VOID, VOID, RoomGeometryUtilities);
  setMetadataFor(StandardSelectionService, 'StandardSelectionService', classMeta);
  setMetadataFor(Companion_87, 'Companion', objectMeta);
  setMetadataFor(StandardSelectionSystem, 'StandardSelectionSystem', classMeta, SystemBase4);
  setMetadataFor(StlSystemIds, 'StlSystemIds', objectMeta);
  setMetadataFor(Companion_88, 'Companion', objectMeta);
  setMetadataFor(DragExtensions, 'DragExtensions', classMeta, VOID, VOID, DragExtensions);
  setMetadataFor(ViewerDragState, 'ViewerDragState', objectMeta);
  setMetadataFor(Companion_89, 'Companion', objectMeta);
  setMetadataFor(AllowedNumberOfChildrenOfTypeValidation, 'AllowedNumberOfChildrenOfTypeValidation', classMeta, ValidationImpl);
  setMetadataFor(Companion_90, 'Companion', objectMeta);
  setMetadataFor(DisallowSeparateRequiredHostsValidation, 'DisallowSeparateRequiredHostsValidation', classMeta, ValidationImpl);
  setMetadataFor(Companion_91, 'Companion', objectMeta);
  setMetadataFor(InvalidNumberOfChildren, 'InvalidNumberOfChildren', classMeta, ValidationResult);
  setMetadataFor(Companion_92, 'Companion', objectMeta);
  setMetadataFor(PlacementZoneValidation, 'PlacementZoneValidation', classMeta, ValidationImpl, VOID, PlacementZoneValidation);
  setMetadataFor(PlacementZoneWarning, 'PlacementZoneWarning', classMeta, ValidationResult);
  setMetadataFor(Companion_93, 'Companion', objectMeta);
  setMetadataFor(RequiredConnectorsSatisfiedValidation, 'RequiredConnectorsSatisfiedValidation', classMeta, ValidationImpl, VOID, RequiredConnectorsSatisfiedValidation);
  setMetadataFor(Companion_94, 'Companion', objectMeta);
  setMetadataFor(RequiredConnectorsValidationResult, 'RequiredConnectorsValidationResult', classMeta, ValidationResult);
  setMetadataFor(ValidationResultIds, 'ValidationResultIds', objectMeta);
  setMetadataFor(ValidationRuleIds, 'ValidationRuleIds', objectMeta);
  setMetadataFor(CoreVisualization, 'CoreVisualization', classMeta);
  setMetadataFor(VisualizationState, 'VisualizationState', classMeta, VOID, VOID, VisualizationState);
  setMetadataFor(Companion_95, 'Companion', objectMeta);
  setMetadataFor(ColliderVisualizationConfigComponent, 'ColliderVisualizationConfigComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_96, 'Companion', objectMeta);
  setMetadataFor(ColliderVisualizationNodeComponent, 'ColliderVisualizationNodeComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_97, 'Companion', objectMeta);
  setMetadataFor(ColliderVisualizerViewerObjectsComponent, 'ColliderVisualizerViewerObjectsComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_98, 'Companion', objectMeta);
  setMetadataFor(ConnectorVisualizationConfigComponent, 'ConnectorVisualizationConfigComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_99, 'Companion', objectMeta);
  setMetadataFor(ConnectorVisualizationNodeComponent, 'ConnectorVisualizationNodeComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_100, 'Companion', objectMeta);
  setMetadataFor(ConnectorVisualizerViewerObjectsComponent, 'ConnectorVisualizerViewerObjectsComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_101, 'Companion', objectMeta);
  setMetadataFor(DecoratorComponent, 'DecoratorComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_102, 'Companion', objectMeta);
  setMetadataFor(EntityColliderVisualizationComponent, 'EntityColliderVisualizationComponent', classMeta, VOID, [Component], EntityColliderVisualizationComponent);
  setMetadataFor(Companion_103, 'Companion', objectMeta);
  setMetadataFor(EntityConnectorVisualizationComponent, 'EntityConnectorVisualizationComponent', classMeta, VOID, [Component], EntityConnectorVisualizationComponent);
  setMetadataFor(ConnectorVisualizationData, 'ConnectorVisualizationData', interfaceMeta);
  setMetadataFor(Companion_104, 'Companion', objectMeta);
  setMetadataFor(PolyhedronVisualizationNodeComponent, 'PolyhedronVisualizationNodeComponent', classMeta, VOID, [Component], PolyhedronVisualizationNodeComponent);
  setMetadataFor(Companion_105, 'Companion', objectMeta);
  setMetadataFor(PolyhedronVisualizationSystem, 'PolyhedronVisualizationSystem', classMeta, SystemBase3);
  setMetadataFor(AutoAdaptHostZoneVisualizationSystem, 'AutoAdaptHostZoneVisualizationSystem', classMeta, PolyhedronVisualizationSystem);
  setMetadataFor(Companion_106, 'Companion', objectMeta);
  setMetadataFor(DragProjectionPointVisualizationSystem, 'DragProjectionPointVisualizationSystem', classMeta, PolyhedronVisualizationSystem);
  setMetadataFor(Companion_107, 'Companion', objectMeta);
  setMetadataFor(FunctionalMarginVisualizationSystem, 'FunctionalMarginVisualizationSystem', classMeta, PolyhedronVisualizationSystem);
  setMetadataFor(Companion_108, 'Companion', objectMeta);
  setMetadataFor(FunctionalZoneVisualizationSystem, 'FunctionalZoneVisualizationSystem', classMeta, PolyhedronVisualizationSystem);
  setMetadataFor(Companion_109, 'Companion', objectMeta);
  setMetadataFor(PolyhedronVisualizationHolderComponent, 'PolyhedronVisualizationHolderComponent', classMeta, VOID, [Component]);
  setMetadataFor(Companion_110, 'Companion', objectMeta);
  setMetadataFor(ForcedComponentBaseSystem, 'ForcedComponentBaseSystem', classMeta, SystemBase4);
  setMetadataFor(ColliderVisualizationSystem, 'ColliderVisualizationSystem', classMeta, ForcedComponentBaseSystem);
  setMetadataFor(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1, VOID, classMeta, VOID, [ConnectorVisualizationData]);
  setMetadataFor(Companion_111, 'Companion', objectMeta);
  setMetadataFor(ConnectorVisualizationSystem, 'ConnectorVisualizationSystem', classMeta, ForcedComponentBaseSystem);
  setMetadataFor(Companion_112, 'Companion', objectMeta);
  setMetadataFor(EntityColliderVisualizationSystem, 'EntityColliderVisualizationSystem', classMeta, SystemBase5);
  setMetadataFor(Companion_113, 'Companion', objectMeta);
  setMetadataFor(CollisionVisualizationSceneDataComponent, 'CollisionVisualizationSceneDataComponent', classMeta, VOID, [Component]);
  setMetadataFor(CollisionVisualizationSceneData, 'CollisionVisualizationSceneData', classMeta, VOID, VOID, CollisionVisualizationSceneData);
  setMetadataFor(Companion_114, 'Companion', objectMeta);
  setMetadataFor(EntityCollisionVisualizationSystem, 'EntityCollisionVisualizationSystem', classMeta, SystemBase3);
  setMetadataFor(Companion_115, 'Companion', objectMeta);
  setMetadataFor(EntityConnectorVisualizationSystem, 'EntityConnectorVisualizationSystem', classMeta, SystemBase5);
  function createColliderVisualization(entity, polyhedron, color, collides, collisionData, $super) {
    color = color === VOID ? null : color;
    collides = collides === VOID ? false : collides;
    collisionData = collisionData === VOID ? null : collisionData;
    return this.b3w(entity, polyhedron, color, collides, collisionData);
  }
  setMetadataFor(ColliderVisualizer, 'ColliderVisualizer', interfaceMeta);
  setMetadataFor(CollisionVisualizationData, 'CollisionVisualizationData', classMeta);
  setMetadataFor(Color, 'Color', classMeta);
  setMetadataFor(ConnectorVisualizer, 'ConnectorVisualizer', interfaceMeta);
  setMetadataFor(Companion_116, 'Companion', objectMeta);
  setMetadataFor(Visualizer, 'Visualizer', interfaceMeta);
  setMetadataFor(DefaultVisualizer, 'DefaultVisualizer', classMeta, VOID, [Visualizer, ConnectorVisualizer, ColliderVisualizer]);
  setMetadataFor(Companion_117, 'Companion', objectMeta);
  setMetadataFor(VisualizerUtils, 'VisualizerUtils', classMeta, VOID, VOID, VisualizerUtils);
  //endregion
  function childConnectionAdded($this, entity, component) {
    handlePositionChange($this, entity);
  }
  function childConnectionRemoved($this, entity, component) {
    handlePositionChange($this, entity);
  }
  function childConnectionUpdated($this, entity, oldComponent, component) {
    handlePositionChange($this, entity);
  }
  function handlePositionChange($this, entity) {
    Companion_getInstance();
    if (entity.hasComponent(38)) {
      updateGroupAlignment($this, entity);
    } else {
      updateAlignment($this, entity);
    }
  }
  function updateGroupAlignment($this, entity) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.updateGroupAlignment.<anonymous>' call
      updateAlignment($this, element);
    }
  }
  function updateAlignment($this, entity) {
    var oldAlignments = getOldAlignmentConnections($this, entity);
    var newAlignments = matchingAlignmentConnections($this, entity);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_children(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.updateAlignment.<anonymous>' call
      handlePositionChange($this, element);
    }
    set_alignmentConnections(entity, newAlignments);
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = oldAlignments.concat(newAlignments);
    updateRelativeAlignments($this, tmp$ret$1);
  }
  function getOldAlignmentConnections($this, entity) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(51);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connections;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.getOldAlignmentConnections.<anonymous>' call
        if (!element.offeringEntity.isDisposed ? !element.demandingEntity.isDisposed : false) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    return tmp_1;
  }
  function updateRelativeAlignments($this, connections) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = connections.length;
    while (inductionVariable < last) {
      var element = connections[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.updateRelativeAlignments.<anonymous>' call
      var tmp;
      if (belongsToSameEntityGroup($this, element)) {
        tmp = null;
      } else {
        tmp = element.offeringEntity;
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver);
      }
    }
    var tmp0_iterator = distinct(destination).t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.updateRelativeAlignments.<anonymous>' call
      set_alignmentConnections(element_0, matchingAlignmentConnections($this, element_0));
    }
  }
  function belongsToSameEntityGroup($this, it) {
    var tmp;
    var tmp0_safe_receiver = get_parent(it.offeringEntity);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      Companion_getInstance();
      tmp_0 = tmp0_safe_receiver.hasComponent(38);
    }
    if (tmp_0 === true) {
      tmp = equals(get_parent(it.offeringEntity), get_parent(it.demandingEntity));
    } else {
      tmp = false;
    }
    return tmp;
  }
  function matchingAlignmentConnections($this, entity) {
    return ConnectionUtils_instance.matchingAlignmentConnections(entity, $this.u2v_1.sceneManager.entities);
  }
  function Companion() {
    this.ID = 'AlignmentConnectionCreationSystem';
  }
  protoOf(Companion).u1n = function () {
    return this.ID;
  };
  var Companion_instance_32;
  function Companion_getInstance_8() {
    return Companion_instance_32;
  }
  function AlignmentConnectionCreationSystem(coreServices) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [51];
    // Inline function 'kotlin.arrayOf' call
    Companion_getInstance_0();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = ['ConnectionParentingSystem'];
    SystemBase2.call(this, 'AlignmentConnectionCreationSystem', 104, 73, tmp, tmp$ret$5, null);
    this.u2v_1 = coreServices;
    this.v2v_1 = false;
  }
  protoOf(AlignmentConnectionCreationSystem).enable = function () {
    protoOf(SystemBase2).enable.call(this);
    this.v2v_1 = false;
  };
  protoOf(AlignmentConnectionCreationSystem).refreshAlignments = function (entities) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = entities.length;
    while (inductionVariable < last) {
      var element = entities[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.refreshAlignments.<anonymous>' call
      if (element.hasComponent(47)) {
        destination.q(element);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.refreshAlignments.<anonymous>' call
      Companion_getInstance_1();
      var tmp0_safe_receiver = element_0.__getComponentForKotlin(104);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.alignment.AlignmentConnectionCreationSystem.refreshAlignments.<anonymous>.<anonymous>' call
        childConnectionAdded(this, element_0, tmp0_safe_receiver);
      }
    }
  };
  protoOf(AlignmentConnectionCreationSystem).onAddComponent2 = function (entity, newComponent) {
    this.v2v_1 = true;
  };
  protoOf(AlignmentConnectionCreationSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(AlignmentConnectionCreationSystem).onRemoveComponent2 = function (entity, oldComponent) {
    this.v2v_1 = false;
    this.refreshAlignments(this.u2v_1.sceneManager.entities);
  };
  protoOf(AlignmentConnectionCreationSystem).onAddComponent = function (entity, newComponent) {
    if (!this.v2v_1) {
      childConnectionAdded(this, entity, newComponent);
    }
  };
  protoOf(AlignmentConnectionCreationSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (!this.v2v_1) {
      childConnectionUpdated(this, entity, oldComponent, newComponent);
    }
  };
  protoOf(AlignmentConnectionCreationSystem).onRemoveComponent = function (entity, oldComponent) {
    if (!this.v2v_1) {
      childConnectionRemoved(this, entity, oldComponent);
    }
  };
  function Companion_0() {
    this.id = 51;
  }
  protoOf(Companion_0).s1k = function () {
    return this.id;
  };
  var Companion_instance_33;
  function Companion_getInstance_9() {
    return Companion_instance_33;
  }
  function AlignmentConnectionsComponent$toString$lambda(it) {
    return it.toString();
  }
  function AlignmentConnectionsComponent(connections) {
    var tmp;
    if (connections === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = connections;
    }
    connections = tmp;
    this.connections = connections;
  }
  protoOf(AlignmentConnectionsComponent).d1w = function () {
    return this.connections;
  };
  protoOf(AlignmentConnectionsComponent).x1k = function () {
    return 51;
  };
  protoOf(AlignmentConnectionsComponent).toString = function () {
    return 'AlignmentConnectionsComponent[' + joinToString(this.connections, ';', VOID, VOID, VOID, VOID, AlignmentConnectionsComponent$toString$lambda) + ']';
  };
  protoOf(AlignmentConnectionsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof AlignmentConnectionsComponent))
      THROW_CCE();
    if (!contentEquals(this.connections, other.connections))
      return false;
    return true;
  };
  protoOf(AlignmentConnectionsComponent).hashCode = function () {
    return contentHashCode(this.connections);
  };
  protoOf(AlignmentConnectionsComponent).eq = function (other) {
    var otherAlignmentConnectionsComponent = other instanceof AlignmentConnectionsComponent ? other : THROW_CCE();
    return contentEquals(this.connections, otherAlignmentConnectionsComponent.connections);
  };
  function set_alignmentConnections(_this__u8e3s4, value) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (value.length === 0) {
      _this__u8e3s4.removeComponent(51);
    } else {
      _this__u8e3s4.addComponent(new AlignmentConnectionsComponent(value));
    }
  }
  function AlignmentPlane(planeNormal, planePoint, activationDistance) {
    var tmp;
    if (activationDistance === VOID) {
      tmp = 1.7976931348623157E308;
    } else {
      tmp = activationDistance;
    }
    activationDistance = tmp;
    this.planeNormal = planeNormal;
    this.planePoint = planePoint;
    this.activationDistance = activationDistance;
  }
  protoOf(AlignmentPlane).y23 = function () {
    return this.planeNormal;
  };
  protoOf(AlignmentPlane).x23 = function () {
    return this.planePoint;
  };
  protoOf(AlignmentPlane).l1x = function () {
    return this.activationDistance;
  };
  protoOf(AlignmentPlane).projectPointOnPlane = function (point) {
    return point.projectOnPlane(this.planeNormal, this.planePoint);
  };
  protoOf(AlignmentPlane).af = function () {
    return this.planeNormal;
  };
  protoOf(AlignmentPlane).bf = function () {
    return this.planePoint;
  };
  protoOf(AlignmentPlane).g1k = function () {
    return this.activationDistance;
  };
  protoOf(AlignmentPlane).w2v = function (planeNormal, planePoint, activationDistance) {
    return new AlignmentPlane(planeNormal, planePoint, activationDistance);
  };
  protoOf(AlignmentPlane).copy = function (planeNormal, planePoint, activationDistance, $super) {
    planeNormal = planeNormal === VOID ? this.planeNormal : planeNormal;
    planePoint = planePoint === VOID ? this.planePoint : planePoint;
    activationDistance = activationDistance === VOID ? this.activationDistance : activationDistance;
    return this.w2v(planeNormal, planePoint, activationDistance);
  };
  protoOf(AlignmentPlane).toString = function () {
    return 'AlignmentPlane(planeNormal=' + this.planeNormal + ', planePoint=' + this.planePoint + ', activationDistance=' + this.activationDistance + ')';
  };
  protoOf(AlignmentPlane).hashCode = function () {
    var result = this.planeNormal.hashCode();
    result = imul(result, 31) + this.planePoint.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.activationDistance) | 0;
    return result;
  };
  protoOf(AlignmentPlane).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AlignmentPlane))
      return false;
    var tmp0_other_with_cast = other instanceof AlignmentPlane ? other : THROW_CCE();
    if (!this.planeNormal.equals(tmp0_other_with_cast.planeNormal))
      return false;
    if (!this.planePoint.equals(tmp0_other_with_cast.planePoint))
      return false;
    if (!equals(this.activationDistance, tmp0_other_with_cast.activationDistance))
      return false;
    return true;
  };
  function Companion_1() {
    Companion_instance_34 = this;
    this.ID = 'HandleRotationSystem';
    this.x2v_1 = LoggerState_getInstance().m1m('HandleRotationSystem');
  }
  protoOf(Companion_1).u1n = function () {
    return this.ID;
  };
  var Companion_instance_34;
  function Companion_getInstance_10() {
    if (Companion_instance_34 == null)
      new Companion_1();
    return Companion_instance_34;
  }
  function onMoveToValidSnapPosition($this, entity, new_0) {
    checkAndCorrectRotation($this, entity);
  }
  function checkAndCorrectRotation($this, entity) {
    var isDoorOrHandle = (entity.hasComponent(HandleComponent_getInstance().id) ? true : entity.hasComponent(DoorComponent_getInstance().id)) ? true : entity.hasComponent(DoorFrontComponent_getInstance().id);
    if (!isDoorOrHandle) {
      return Unit_instance;
    }
    var tmp;
    if (entity.hasComponent(HandleComponent_getInstance().id)) {
      tmp = listOf(entity);
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = get_descendants(entity);
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignment.HandleRotationSystem.checkAndCorrectRotation.<anonymous>' call
        if (element.hasComponent(HandleComponent_getInstance().id)) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var handles = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = handles.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.alignment.HandleRotationSystem.checkAndCorrectRotation.<anonymous>' call
      if (!isUnderAlignment($this, element_0)) {
        findAndApplyPossibleAlignment($this, element_0);
      }
    }
  }
  function findAndApplyPossibleAlignment($this, entity) {
    markAsUnderAlignment($this, entity);
    validateAndReSnap($this, entity);
    unmarkAsUnderAlignment($this, entity);
  }
  function validateAndReSnap($this, entity) {
    var tmp0_elvis_lhs = get_snapRoot(entity);
    var tmp1_elvis_lhs = get_parent(tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var parent = tmp;
    var tmp2_safe_receiver = get_highestPriorityConnection(entity);
    var currentConnector = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hostConnector;
    var possibleSnap = findValidSnapCandidate($this, entity, parent);
    if (!(possibleSnap == null) ? !equals(currentConnector, possibleSnap.hostConnector) : false) {
      possibleSnap.createAction().perform();
    } else if (possibleSnap == null) {
      var tmp_0 = Companion_getInstance_10().x2v_1;
      tmp_0.debug(HandleRotationSystem$validateAndReSnap$lambda(entity));
    }
  }
  function findValidSnapCandidate($this, entity, parent) {
    var tmp0_elvis_lhs = get_snapRoot(entity);
    var snappingGuestEntity = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = toList(SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_DISTANCE.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(snappingGuestEntity, parent)));
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = HandleRotationSystem$findValidSnapCandidate$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    var matchingSnaps = sortedWith(this_0, tmp$ret$0);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$2 = copyToArray(matchingSnaps);
    var validationResults = $this.g2w_1.getFirstValidSnapAction(tmp$ret$2);
    return validationResults.snapActionCandidate;
  }
  function isUnderAlignment($this, entity) {
    return entity.hasComponent(HandleUnderAlignmentComponent_getInstance().j2w_1);
  }
  function markAsUnderAlignment($this, entity) {
    entity.addComponentInternal(HandleUnderAlignmentComponent_getInstance());
  }
  function unmarkAsUnderAlignment($this, entity) {
    entity.removeComponentInternal(HandleUnderAlignmentComponent_getInstance().j2w_1);
  }
  function HandleUnderAlignmentComponent() {
    HandleUnderAlignmentComponent_instance = this;
    this.j2w_1 = this.id;
  }
  protoOf(HandleUnderAlignmentComponent).x1k = function () {
    return this.j2w_1;
  };
  protoOf(HandleUnderAlignmentComponent).s1k = function () {
    return 52;
  };
  protoOf(HandleUnderAlignmentComponent).eq = function (other) {
    return true;
  };
  var HandleUnderAlignmentComponent_instance;
  function HandleUnderAlignmentComponent_getInstance() {
    if (HandleUnderAlignmentComponent_instance == null)
      new HandleUnderAlignmentComponent();
    return HandleUnderAlignmentComponent_instance;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.k2w_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).u1j = function (a, b) {
    return this.k2w_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function HandleRotationSystem$validateAndReSnap$lambda($entity) {
    return function () {
      return 'No valid snap found when trying to ensure correct rotation of entity ' + $entity.id + ' ' + $entity;
    };
  }
  function HandleRotationSystem$findValidSnapCandidate$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.alignment.HandleRotationSystem.findValidSnapCandidate.<anonymous>' call
    var tmp = b.priority;
    // Inline function 'com.ikea.core.stl.alignment.HandleRotationSystem.findValidSnapCandidate.<anonymous>' call
    var tmp$ret$1 = a.priority;
    return compareValues(tmp, tmp$ret$1);
  }
  function HandleRotationSystem(validationService, sceneManager) {
    Companion_getInstance_10();
    SystemBase.call(this, 'HandleRotationSystem', 45);
    this.g2w_1 = validationService;
    this.h2w_1 = sceneManager;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i2w_1 = [52];
  }
  protoOf(HandleRotationSystem).onAddComponent = function (entity, newComponent) {
    onMoveToValidSnapPosition(this, entity, newComponent);
  };
  protoOf(HandleRotationSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(HandleRotationSystem).onRemoveComponent = function (entity, oldComponent) {
  };
  protoOf(HandleRotationSystem).w1o = function () {
    return this.i2w_1;
  };
  function validateWithParent($this, guestConnector, hostEntity, hostConnector) {
    var tmp;
    if (guestConnector.hasTag('requireUpwardParent')) {
      var tmp_0;
      if (hostConnector.isRotatedUpward(hostEntity)) {
        tmp_0 = null;
      } else {
        tmp_0 = Companion_instance_0.fail('Guest connector requires a host connector that is rotated upwards.');
      }
      tmp = tmp_0;
    } else {
      if (guestConnector.hasTag('requireDownwardParent')) {
        var tmp_1;
        if (!hostConnector.isRotatedUpward(hostEntity)) {
          tmp_1 = null;
        } else {
          tmp_1 = Companion_instance_0.fail('Guest connector requires a host connector that is not rotated upwards.');
        }
        tmp = tmp_1;
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function HostConnectorRotationValidation() {
    ValidationImpl.call(this);
    this.m2w_1 = 'HostConnectorRotationValidation';
  }
  protoOf(HostConnectorRotationValidation).s1k = function () {
    return this.m2w_1;
  };
  protoOf(HostConnectorRotationValidation).validateCurrentState = function (entity) {
    return null;
  };
  protoOf(HostConnectorRotationValidation).validateSnap = function (snapActionCandidate) {
    return validateWithParent(this, snapActionCandidate.guestConnector, snapActionCandidate.host, snapActionCandidate.hostConnector);
  };
  function getCloseKey($this, key) {
    return getCloseKeyFromSet(key, $this.o2w_1.o2(), $this.n2w_1);
  }
  function getCloseConnectorKey($this, key) {
    return getCloseKeyFromSet(key, $this.p2w_1.o2(), $this.n2w_1);
  }
  function AlignmentLinesReferenceCounter(epsilon) {
    epsilon = epsilon === VOID ? 1.0 : epsilon;
    this.n2w_1 = epsilon;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.o2w_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.p2w_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(AlignmentLinesReferenceCounter).q2w = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.p2w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.q2().t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesReferenceCounter.<get-generatedAlignmentConnectorKeys>.<anonymous>' call
      var tmp$ret$1 = item.u2().key;
      destination.q(tmp$ret$1);
    }
    return destination;
  };
  protoOf(AlignmentLinesReferenceCounter).addReferenceCount = function (key) {
    var usedKey = getCloseKey(this, key);
    var current = this.o2w_1.b3(usedKey);
    if (current == null ? true : current === 0) {
      // Inline function 'kotlin.collections.set' call
      this.o2w_1.r2(usedKey, 1);
      return true;
    }
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.o2w_1;
    var value = current + 1 | 0;
    this_0.r2(usedKey, value);
    return false;
  };
  protoOf(AlignmentLinesReferenceCounter).subtractReferenceCount = function (key) {
    var usedKey = getCloseKey(this, key);
    var tmp0_elvis_lhs = this.o2w_1.b3(usedKey);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw Exception_init_$Create$('Tried to remove reference count at ' + key + ' where none existed  Sender: ' + this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var current = tmp;
    current = current - 1 | 0;
    if (current === 0) {
      this.o2w_1.v2(usedKey);
    } else {
      // Inline function 'kotlin.collections.set' call
      var this_0 = this.o2w_1;
      var value = current;
      this_0.r2(usedKey, value);
    }
    if (current === 0)
      return true;
    return false;
  };
  protoOf(AlignmentLinesReferenceCounter).registerConnector = function (connector, key) {
    var usedKey = getCloseKey(this, key);
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.p2w_1;
    if ((isInterface(this_0, Map) ? this_0 : THROW_CCE()).y2(usedKey))
      throw Exception_init_$Create$('Cannot add several connectors to the same position, already has one at ' + key + ' Sender: ' + this);
    // Inline function 'kotlin.collections.set' call
    this.p2w_1.r2(usedKey, connector);
  };
  protoOf(AlignmentLinesReferenceCounter).unregisterConnector = function (key) {
    var usedKey = getCloseConnectorKey(this, key);
    this.p2w_1.v2(usedKey);
  };
  protoOf(AlignmentLinesReferenceCounter).getConnector = function (key) {
    var usedKey = getCloseConnectorKey(this, key);
    var tmp0_elvis_lhs = this.p2w_1.b3(usedKey);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw Exception_init_$Create$('No connector exists at ' + key + ' Sender: ' + this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AlignmentLinesReferenceCounter).hasConnector = function (key) {
    var usedKey = getCloseKey(this, key);
    return this.p2w_1.y2(usedKey);
  };
  protoOf(AlignmentLinesReferenceCounter).toString = function () {
    var str = '';
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.o2w_1.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesReferenceCounter.toString.<anonymous>' call
      str = str + ('At: ' + element.t2() + ' has ' + element.u2() + ' entries\n');
    }
    return str;
  };
  function Companion_2() {
    this.ID = 'AlignmentLinesSystem';
  }
  protoOf(Companion_2).u1n = function () {
    return this.ID;
  };
  var Companion_instance_35;
  function Companion_getInstance_11() {
    return Companion_instance_35;
  }
  function clearAlignmentEdgesFeature($this) {
    var tmp0_safe_receiver = $this.j2x_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p2x();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.clearAlignmentEdgesFeature.<anonymous>' call
      var tmp0_safe_receiver_0 = $this.g2x_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        Companion_getInstance_2();
        tmp = tmp0_safe_receiver_0.__getComponentForKotlin(11);
      }
      var tmp1_safe_receiver_0 = tmp;
      var tmp_0;
      if (tmp1_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.clearAlignmentEdgesFeature.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = tmp1_safe_receiver_0.connectors;
        var destination = ArrayList_init_$Create$();
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var element = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.clearAlignmentEdgesFeature.<anonymous>.<anonymous>.<anonymous>' call
          if (!tmp1_safe_receiver.p(element.key)) {
            destination.q(element);
          }
        }
        var connectorsToKeep = destination;
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$3 = copyToArray(connectorsToKeep);
        var newConnectorsComponent = new ConnectorsComponent(tmp$ret$3);
        var tmp0_safe_receiver_1 = $this.g2x_1;
        tmp_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.addComponent(newConnectorsComponent);
      }
    }
  }
  function initializeAlignmentEdgesFeature($this) {
    $this.j2x_1 = null;
    var tmp0_safe_receiver = $this.g2x_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_connectorsComponent(tmp0_safe_receiver);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.connectors;
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>' call
        var tmp_0;
        // Inline function 'kotlin.collections.isEmpty' call
        if ($this.h2x_1.length === 0) {
          tmp_0 = true;
        } else {
          tmp_0 = contains($this.h2x_1, element.key);
        }
        if (tmp_0) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var tmp3_safe_receiver = tmp;
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator = tmp3_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        if (element_0 instanceof SurfaceConnector) {
          destination_0.q(element_0);
        }
      }
      tmp_1 = destination_0;
    }
    var tmp4_elvis_lhs = tmp_1;
    var roomSurfaceConnectors = tmp4_elvis_lhs == null ? emptyList() : tmp4_elvis_lhs;
    if (!any(roomSurfaceConnectors))
      return Unit_instance;
    var tmp5_safe_receiver = $this.g2x_1;
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var newAlignments = new RoomAlignmentEdgesComponent($this.b2x_1, $this.c2x_1, $this.f2x_1, $this.d2x_1, $this.e2x_1, roomSurfaceConnectors, tmp5_safe_receiver);
      tmp5_safe_receiver.addComponent(newAlignments);
      $this.j2x_1 = newAlignments;
      var indexedObject = getHierarchyWithComponent(tmp5_safe_receiver, $this.a2x_1);
      var inductionVariable_0 = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable_0 < last_0) {
        var element_1 = indexedObject[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject_0 = get_guestConnections(element_1);
        var inductionVariable_1 = 0;
        var last_1 = indexedObject_0.length;
        while (inductionVariable_1 < last_1) {
          var element_2 = indexedObject_0[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.initializeAlignmentEdgesFeature.<anonymous>.<anonymous>.<anonymous>' call
          var surfaceConnector = getSurfaceConnector($this, element_2);
          if (surfaceConnector == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            addRoomAlignmentsForAlignmentEntity($this, element_1, surfaceConnector);
          }
        }
      }
    }
  }
  function onAddConnection($this, entity, newConnection) {
    var tmp0_safe_receiver = getSurfaceConnector($this, newConnection);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      addRoomAlignmentsForAlignmentEntity($this, entity, tmp0_safe_receiver);
    }
  }
  function isPartOfDraggedHierarchy($this, entity) {
    return $this.m2x_1.p(entity);
  }
  function onRemoveConnection($this, entity, oldConnection) {
    var tmp0_safe_receiver = getSurfaceConnector($this, oldConnection);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      removeRoomAlignmentsForAlignmentEntity($this, entity, tmp0_safe_receiver, oldConnection);
    }
  }
  function onStartedDragging($this, entity) {
    var tmp0_elvis_lhs = get_snapRoot(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var draggedEntity = tmp;
    var tmp_0 = HierarchyUtils_instance;
    tmp_0.forEachInHierarchy(draggedEntity, AlignmentLinesSystem$onStartedDragging$lambda($this));
    $this.l2x_1 = draggedEntity;
    addAll($this.m2x_1, getHierarchyWithComponent(draggedEntity, 28));
    $this.n2x_1 = get_worldTransform(draggedEntity);
  }
  function onStoppedDragging($this, entity) {
    var tmp0_elvis_lhs = $this.l2x_1;
    var draggedEntity = tmp0_elvis_lhs == null ? get_snapRoot(entity) : tmp0_elvis_lhs;
    var tmp;
    if (draggedEntity == null) {
      tmp = true;
    } else {
      var tmp1_safe_receiver = $this.n2x_1;
      tmp = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.equals(get_worldTransform(draggedEntity))) === true;
    }
    if (tmp) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = $this.m2x_1.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.onStoppedDragging.<anonymous>' call
        Companion_getInstance_1();
        var tmp0_safe_receiver = element.__getComponentForKotlin(104);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          $this.onAddComponent(element, tmp0_safe_receiver);
        }
      }
    }
    clearDragged($this);
  }
  function clearDragged($this) {
    $this.n2x_1 = null;
    $this.l2x_1 = null;
    $this.m2x_1.z();
  }
  function isApplicableGuestEntity($this, entity) {
    var tmp1_elvis_lhs = entity == null ? null : entity.hasComponent($this.a2x_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function getSurfaceConnector($this, connection) {
    if (get_isRoom(connection.hostConnectorEntity)) {
      var tmp;
      if (connection.hostConnector instanceof SurfaceConnector) {
        var sc = connection.hostConnector;
        tmp = sc instanceof SurfaceConnector ? sc : THROW_CCE();
      } else {
        tmp = null;
      }
      return tmp;
    }
    return null;
  }
  function addRoomAlignmentsForAlignmentEntity($this, entity, wallConnector) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var addedConnectors = ArrayList_init_$Create$();
    var tmp0_safe_receiver = $this.g2x_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>' call
      var tmp0_safe_receiver_0 = $this.j2x_1;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.verticalAlignmentKeys;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
          Companion_getInstance_12().addVertical(tmp0_safe_receiver, wallConnector, entity, element, addedConnectors);
        }
      }
      var tmp2_safe_receiver = $this.j2x_1;
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.horizontalAlignmentKeys;
      var tmp;
      if (tmp3_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp3_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp3_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
          Companion_getInstance_12().addHorizontal(tmp0_safe_receiver, wallConnector, entity, element_0, addedConnectors);
        }
        tmp = Unit_instance;
      }
    }
    if (addedConnectors.b1())
      return Unit_instance;
    var tmp1_safe_receiver_0 = $this.g2x_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver_0 == null ? null : get_connectorsComponent(tmp1_safe_receiver_0);
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$3 = [];
      tmp_0 = new ConnectorsComponent(tmp$ret$3);
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var connectorsComponent = tmp_0;
    var tmp3_safe_receiver_0 = $this.g2x_1;
    if (tmp3_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.addRoomAlignmentsForAlignmentEntity.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$4 = copyToArray(addedConnectors);
      $this.k2x_1.addComponent(tmp3_safe_receiver_0, connectorsComponent.plusConnectors(tmp$ret$4));
    }
  }
  function removeRoomAlignmentsForAlignmentEntity($this, entity, wallConnector, oldConnection) {
    var tmp;
    if (oldConnection.guestConnectorEntity.equals(entity)) {
      tmp = get_worldTransform(oldConnection.hostConnectorEntity).concatenate(oldConnection.hostGuestDeltaTransform);
    } else {
      tmp = get_worldTransform(oldConnection.hostConnectorEntity).concatenate(oldConnection.hostGuestDeltaTransform).concatenate(get_worldTransform(entity).delta(get_worldTransform(oldConnection.guestConnectorEntity)));
    }
    var oldTransform = tmp;
    // Inline function 'kotlin.collections.mutableListOf' call
    var removedConnectors = ArrayList_init_$Create$();
    var tmp1_safe_receiver = $this.g2x_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : get_connectorsComponent(tmp1_safe_receiver);
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var connectorsComponent = tmp_0;
    var tmp3_safe_receiver = $this.g2x_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>' call
      var tmp0_safe_receiver = $this.j2x_1;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.verticalAlignmentKeys;
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp1_safe_receiver_0.length;
        while (inductionVariable < last) {
          var element = tmp1_safe_receiver_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
          Companion_getInstance_12().removeVertical(tmp3_safe_receiver, wallConnector, entity, element, removedConnectors, oldTransform);
        }
      }
      var tmp2_safe_receiver = $this.j2x_1;
      var tmp3_safe_receiver_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.horizontalAlignmentKeys;
      var tmp_1;
      if (tmp3_safe_receiver_0 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp3_safe_receiver_0.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp3_safe_receiver_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>.<anonymous>' call
          Companion_getInstance_12().removeHorizontal(tmp3_safe_receiver, wallConnector, entity, element_0, removedConnectors, oldTransform);
        }
        tmp_1 = Unit_instance;
      }
    }
    if (!any(removedConnectors))
      return Unit_instance;
    var tmp_2 = connectorsComponent;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3 = copyToArray(removedConnectors);
    connectorsComponent = tmp_2.minusConnectors(tmp$ret$3);
    var tmp4_safe_receiver = $this.g2x_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.removeRoomAlignmentsForAlignmentEntity.<anonymous>' call
      $this.k2x_1.addComponent(tmp4_safe_receiver, connectorsComponent);
    }
  }
  function onRoomRebuild($this, room) {
    $this.g2x_1 = room;
    if ($this.i2x_1)
      return Unit_instance;
    initializeAlignmentEdgesFeature($this);
  }
  function AlignmentLinesSystem$enable$lambda(it) {
    Companion_getInstance_88();
    return it.hasComponent(70);
  }
  function AlignmentLinesSystem$onStartedDragging$lambda(this$0) {
    return function (hierarchyMember) {
      Companion_getInstance_1();
      var tmp0_safe_receiver = hierarchyMember.__getComponentForKotlin(104);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this$0.onRemoveComponent(hierarchyMember, tmp0_safe_receiver);
      }
      return Unit_instance;
    };
  }
  function AlignmentLinesSystem(coreServices, tagComponentId, activationDistance, priority, horizontalAlignmentKeys, verticalAlignmentKeys, offeredTags) {
    activationDistance = activationDistance === VOID ? 100.0 : activationDistance;
    priority = priority === VOID ? 5 : priority;
    var tmp;
    if (horizontalAlignmentKeys === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = ['line-align-bottom-left', 'line-align-top-right'];
    } else {
      tmp = horizontalAlignmentKeys;
    }
    horizontalAlignmentKeys = tmp;
    var tmp_0;
    if (verticalAlignmentKeys === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = ['line-align-bottom-left', 'line-align-top-right'];
    } else {
      tmp_0 = verticalAlignmentKeys;
    }
    verticalAlignmentKeys = tmp_0;
    var tmp_1;
    if (offeredTags === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = ['frame'];
    } else {
      tmp_1 = offeredTags;
    }
    offeredTags = tmp_1;
    Companion_getInstance_1();
    Companion_getInstance_88();
    var tmp_2 = IsDraggedComponent_instance.id;
    var tmp_3 = SceneReloadingComponent_instance.id;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_4 = [11];
    // Inline function 'kotlin.arrayOf' call
    Companion_getInstance_0();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$14 = ['ConnectionParentingSystem', 'RoomSystem'];
    SystemBase4.call(this, 'AlignmentLinesSystem', 104, 70, tmp_2, tmp_3, tmp_4, tmp$ret$14, null);
    this.z2w_1 = coreServices;
    this.a2x_1 = tagComponentId;
    this.b2x_1 = activationDistance;
    this.c2x_1 = priority;
    this.d2x_1 = horizontalAlignmentKeys;
    this.e2x_1 = verticalAlignmentKeys;
    this.f2x_1 = offeredTags;
    this.g2x_1 = null;
    var tmp_5 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_5.h2x_1 = [];
    this.i2x_1 = false;
    this.j2x_1 = null;
    this.k2x_1 = this.z2w_1.entityManager;
    this.l2x_1 = null;
    var tmp_6 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_6.m2x_1 = LinkedHashSet_init_$Create$();
    this.n2x_1 = null;
    this.enable();
  }
  protoOf(AlignmentLinesSystem).enable = function () {
    protoOf(SystemBase4).enable.call(this);
    this.i2x_1 = false;
    var tmp = this;
    var tmp_0 = this.z2w_1.sceneManager.scene;
    tmp.g2x_1 = findInHierarchy(tmp_0, AlignmentLinesSystem$enable$lambda);
    initializeAlignmentEdgesFeature(this);
  };
  protoOf(AlignmentLinesSystem).disable = function () {
    protoOf(SystemBase4).disable.call(this);
    clearAlignmentEdgesFeature(this);
  };
  protoOf(AlignmentLinesSystem).setRoomSurfaceKeys = function (keys) {
    this.h2x_1 = keys;
    clearAlignmentEdgesFeature(this);
    initializeAlignmentEdgesFeature(this);
  };
  protoOf(AlignmentLinesSystem).onAddComponent = function (entity, newComponent) {
    if (this.i2x_1)
      return Unit_instance;
    if (!isApplicableGuestEntity(this, entity))
      return Unit_instance;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = newComponent.connections;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.onAddComponent.<anonymous>' call
      onAddConnection(this, entity, element);
    }
  };
  protoOf(AlignmentLinesSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (this.i2x_1)
      return Unit_instance;
    this.onAddComponent(entity, newComponent);
    this.onRemoveComponent(entity, oldComponent);
  };
  protoOf(AlignmentLinesSystem).onRemoveComponent = function (entity, oldComponent) {
    if (this.i2x_1)
      return Unit_instance;
    if (!isApplicableGuestEntity(this, entity))
      return Unit_instance;
    if (isPartOfDraggedHierarchy(this, entity)) {
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = oldComponent.connections;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignmentlines.AlignmentLinesSystem.onRemoveComponent.<anonymous>' call
      onRemoveConnection(this, entity, element);
    }
  };
  protoOf(AlignmentLinesSystem).onAddComponent2 = function (entity, newComponent) {
    onRoomRebuild(this, entity);
  };
  protoOf(AlignmentLinesSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    onRoomRebuild(this, entity);
  };
  protoOf(AlignmentLinesSystem).onRemoveComponent2 = function (entity, oldComponent) {
  };
  protoOf(AlignmentLinesSystem).onAddComponent3 = function (entity, newComponent) {
    onStartedDragging(this, entity);
  };
  protoOf(AlignmentLinesSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
  };
  protoOf(AlignmentLinesSystem).onRemoveComponent3 = function (entity, oldComponent) {
    onStoppedDragging(this, entity);
  };
  protoOf(AlignmentLinesSystem).onAddComponent4 = function (entity, newComponent) {
    this.i2x_1 = true;
  };
  protoOf(AlignmentLinesSystem).onUpdateComponent4 = function (entity, oldComponent, newComponent) {
  };
  protoOf(AlignmentLinesSystem).onRemoveComponent4 = function (entity, oldComponent) {
    this.i2x_1 = false;
    initializeAlignmentEdgesFeature(this);
  };
  function getConnectorOldPosition($this, oldTransform, connector) {
    return connector.getWorldPositionFromOwnerTransform(oldTransform);
  }
  function AlignmentLinesUtils$Companion$addVertical$lambda($alignmentEntity, $atAlignmentEntityConnector, $ex) {
    return function () {
      return 'Add vertical failed Entity id: ' + $alignmentEntity.id + ' connector: ' + $atAlignmentEntityConnector + ' ' + $ex;
    };
  }
  function AlignmentLinesUtils$Companion$addHorizontal$lambda($alignmentEntity, $atAlignmentEntityConnector, $ex) {
    return function () {
      return 'Add horizontal failed Entity id: ' + $alignmentEntity.id + ' connector: ' + $atAlignmentEntityConnector + ' ' + $ex;
    };
  }
  function AlignmentLinesUtils$Companion$removeHorizontal$lambda($alignmentEntity, $atConnector, $ex) {
    return function () {
      return 'Remove horizontal failed Entity id: ' + $alignmentEntity.id + ' connector: ' + $atConnector + ' ' + $ex;
    };
  }
  function AlignmentLinesUtils$Companion$removeVertical$lambda($alignmentEntity, $atConnector, $ex) {
    return function () {
      return 'Remove vertical failed Entity id: ' + $alignmentEntity.id + ' connector: ' + $atConnector + ' ' + $ex;
    };
  }
  function Companion_3() {
    Companion_instance_36 = this;
    this.q2x_1 = LoggerState_getInstance().m1m('AlignmentLinesUtils');
  }
  protoOf(Companion_3).addVertical = function (room, wallConnector, alignmentEntity, atAlignmentEntityConnector, addedConnectors) {
    try {
      var tmp0_elvis_lhs = room.__getComponentForKotlin(64);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var roomAlignments = tmp;
      var tmp1_elvis_lhs = roomAlignments.getAlignmentLinesForSurface(wallConnector);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var alignmentLines = tmp_0;
      var tmp2_safe_receiver = get_connectorsComponent(alignmentEntity);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.alignmentConnectors;
      var tmp_1;
      if (tmp3_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = tmp3_safe_receiver.t();
          while (tmp0_iterator.u()) {
            var element = tmp0_iterator.w();
            // Inline function 'com.ikea.core.stl.alignmentlines.Companion.addVertical.<anonymous>' call
            if (element.key === atAlignmentEntityConnector) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp_1 = tmp$ret$1;
      }
      var tmp4_safe_receiver = tmp_1;
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var posWorld = tmp4_safe_receiver.getWorldPositionFromOwnerEntity(alignmentEntity);
        alignmentLines.addVerticalLine(posWorld, addedConnectors);
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var ex = $p;
        this.q2x_1.error(AlignmentLinesUtils$Companion$addVertical$lambda(alignmentEntity, atAlignmentEntityConnector, ex));
      } else {
        throw $p;
      }
    }
  };
  protoOf(Companion_3).addHorizontal = function (room, wallConnector, alignmentEntity, atAlignmentEntityConnector, addedConnectors) {
    try {
      var tmp0_elvis_lhs = room.__getComponentForKotlin(64);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var roomAlignments = tmp;
      var tmp1_elvis_lhs = roomAlignments.getAlignmentLinesForSurface(wallConnector);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var alignmentLines = tmp_0;
      var tmp2_safe_receiver = get_connectorsComponent(alignmentEntity);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.alignmentConnectors;
      var tmp_1;
      if (tmp3_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = tmp3_safe_receiver.t();
          while (tmp0_iterator.u()) {
            var element = tmp0_iterator.w();
            // Inline function 'com.ikea.core.stl.alignmentlines.Companion.addHorizontal.<anonymous>' call
            if (element.key === atAlignmentEntityConnector) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp_1 = tmp$ret$1;
      }
      var tmp4_safe_receiver = tmp_1;
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var posWorld = tmp4_safe_receiver.getWorldPositionFromOwnerEntity(alignmentEntity);
        alignmentLines.addHorizontal(posWorld, addedConnectors);
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var ex = $p;
        this.q2x_1.error(AlignmentLinesUtils$Companion$addHorizontal$lambda(alignmentEntity, atAlignmentEntityConnector, ex));
      } else {
        throw $p;
      }
    }
  };
  protoOf(Companion_3).removeHorizontal = function (room, wallConnector, alignmentEntity, atConnector, removedConnectors, oldTransform) {
    try {
      var tmp0_elvis_lhs = room.__getComponentForKotlin(64);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        throw Exception_init_$Create$('Cannot remove alignment connectors unless there is a room with a ' + Companion_instance_37);
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var roomAlignments = tmp;
      var tmp1_elvis_lhs = roomAlignments.getAlignmentLinesForSurface(wallConnector);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var alignmentLines = tmp_0;
      var tmp2_safe_receiver = get_connectorsComponent(alignmentEntity);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.alignmentConnectors;
      var tmp_1;
      if (tmp3_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = tmp3_safe_receiver.t();
          while (tmp0_iterator.u()) {
            var element = tmp0_iterator.w();
            // Inline function 'com.ikea.core.stl.alignmentlines.Companion.removeHorizontal.<anonymous>' call
            if (element.key === atConnector) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp_1 = tmp$ret$1;
      }
      var tmp4_safe_receiver = tmp_1;
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var oldConnectorPosWorld = getConnectorOldPosition(Companion_getInstance_12(), oldTransform, tmp4_safe_receiver);
        alignmentLines.removeHorizontalLine(oldConnectorPosWorld, removedConnectors);
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var ex = $p;
        this.q2x_1.error(AlignmentLinesUtils$Companion$removeHorizontal$lambda(alignmentEntity, atConnector, ex));
      } else {
        throw $p;
      }
    }
  };
  protoOf(Companion_3).removeVertical = function (room, wallConnector, alignmentEntity, atConnector, removedConnectors, oldTransform) {
    try {
      var tmp0_elvis_lhs = room.__getComponentForKotlin(64);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        throw Exception_init_$Create$('Cannot remove alignment connectors unless there is a room with a ' + Companion_instance_37);
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var roomAlignments = tmp;
      var tmp1_elvis_lhs = roomAlignments.getAlignmentLinesForSurface(wallConnector);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var alignmentLines = tmp_0;
      var tmp2_safe_receiver = get_connectorsComponent(alignmentEntity);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.alignmentConnectors;
      var tmp_1;
      if (tmp3_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = tmp3_safe_receiver.t();
          while (tmp0_iterator.u()) {
            var element = tmp0_iterator.w();
            // Inline function 'com.ikea.core.stl.alignmentlines.Companion.removeVertical.<anonymous>' call
            if (element.key === atConnector) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp_1 = tmp$ret$1;
      }
      var tmp4_safe_receiver = tmp_1;
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var oldConnectorPosWorld = getConnectorOldPosition(Companion_getInstance_12(), oldTransform, tmp4_safe_receiver);
        alignmentLines.removeVerticalLine(oldConnectorPosWorld, removedConnectors);
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var ex = $p;
        this.q2x_1.error(AlignmentLinesUtils$Companion$removeVertical$lambda(alignmentEntity, atConnector, ex));
      } else {
        throw $p;
      }
    }
  };
  var Companion_instance_36;
  function Companion_getInstance_12() {
    if (Companion_instance_36 == null)
      new Companion_3();
    return Companion_instance_36;
  }
  function AlignmentLinesUtils() {
    Companion_getInstance_12();
  }
  function IntersectionPointConnectors(priority, tags, offers, localToParentTransform, activationDistance) {
    this.r2x_1 = priority;
    this.s2x_1 = tags;
    this.t2x_1 = offers;
    this.u2x_1 = localToParentTransform;
    this.v2x_1 = activationDistance;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.w2x_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(IntersectionPointConnectors).q2w = function () {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = this.w2x_1;
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.alignmentlines.IntersectionPointConnectors.<get-generatedAlignmentConnectorKeys>.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = element.u2().p2();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.t();
      while (tmp0_iterator_0.u()) {
        var item = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.alignmentlines.IntersectionPointConnectors.<get-generatedAlignmentConnectorKeys>.<anonymous>.<anonymous>' call
        var tmp$ret$1 = item.key;
        destination_0.q(tmp$ret$1);
      }
      var list = destination_0;
      addAll_0(destination, list);
    }
    return destination;
  };
  protoOf(IntersectionPointConnectors).addConnector = function (x, y) {
    var pos = new Vector(x, 0.0, y);
    var posWS = this.u2x_1.transformPosition(pos);
    var tmp0_key = 'Intersection alignment at ' + pos;
    var tmp2_transform = new Transform(posWS, this.u2x_1.rotation);
    var tmp3_priority = this.r2x_1;
    var tmp4_tagArray = this.s2x_1;
    // Inline function 'kotlin.collections.plus' call
    var this_0 = this.t2x_1;
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = ['intersection'];
    var tmp5_offersArray = this_0.concat(tmp$ret$3);
    var tmp6_activationDistance = this.v2x_1;
    var connector = new PointConnector(tmp0_key, 2, tmp2_transform, tmp3_priority, tmp6_activationDistance, VOID, tmp4_tagArray, tmp5_offersArray);
    if (!this.w2x_1.y2(x)) {
      // Inline function 'kotlin.collections.set' call
      var this_1 = this.w2x_1;
      // Inline function 'kotlin.collections.mutableMapOf' call
      var value = LinkedHashMap_init_$Create$();
      this_1.r2(x, value);
    }
    var tmp7_safe_receiver = this.w2x_1.b3(x);
    if ((tmp7_safe_receiver == null ? null : tmp7_safe_receiver.y2(y)) === true)
      throw Exception_init_$Create$('Already has connector at (' + x + ',' + y + ')');
    var tmp8_safe_receiver = this.w2x_1.b3(x);
    if (tmp8_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.set' call
      tmp8_safe_receiver.r2(y, connector);
    }
    return connector;
  };
  protoOf(IntersectionPointConnectors).removeConnector = function (x, y) {
    var tmp0_safe_receiver = this.w2x_1.b3(x);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v2(y);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw Exception_init_$Create$('No connector exist at (' + x + ', ' + y + ')');
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  function IntersectionPointsTracker$addHorizontalLine$lambda($closeY) {
    return function (x) {
      return new Pair(x, $closeY);
    };
  }
  function IntersectionPointsTracker$addVerticalLine$lambda($closeX) {
    return function (y) {
      return new Pair($closeX, y);
    };
  }
  function IntersectionPointsTracker$removeHorizontalLine$lambda($closeY) {
    return function (x) {
      return new Pair(x, $closeY);
    };
  }
  function IntersectionPointsTracker$removeVerticalLine$lambda($closeX) {
    return function (y) {
      return new Pair($closeX, y);
    };
  }
  function IntersectionPointsTracker(epsilon) {
    epsilon = epsilon === VOID ? 1.0 : epsilon;
    this.x2x_1 = epsilon;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.y2x_1 = LinkedHashSet_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_0.z2x_1 = LinkedHashSet_init_$Create$();
  }
  protoOf(IntersectionPointsTracker).addHorizontalLine = function (y) {
    var closeY = getCloseKeyFromSet(y, this.z2x_1, this.x2x_1);
    if (this.z2x_1.p(closeY))
      throw Exception_init_$Create$('Already contains a horizontal line at y:' + y);
    this.z2x_1.q(closeY);
    var tmp = asSequence(this.y2x_1);
    return map(tmp, IntersectionPointsTracker$addHorizontalLine$lambda(closeY));
  };
  protoOf(IntersectionPointsTracker).addVerticalLine = function (x) {
    var closeX = getCloseKeyFromSet(x, this.y2x_1, this.x2x_1);
    if (this.y2x_1.p(closeX))
      throw Exception_init_$Create$('Already contains a vertical line at x:' + closeX);
    this.y2x_1.q(closeX);
    var tmp = asSequence(this.z2x_1);
    return map(tmp, IntersectionPointsTracker$addVerticalLine$lambda(closeX));
  };
  protoOf(IntersectionPointsTracker).removeHorizontalLine = function (y) {
    var closeY = getCloseKeyFromSet(y, this.z2x_1, this.x2x_1);
    if (!this.z2x_1.p(closeY))
      throw Exception_init_$Create$('Does not contain a horizontal line at y:' + closeY);
    this.z2x_1.r(closeY);
    var tmp = asSequence(this.y2x_1);
    return map(tmp, IntersectionPointsTracker$removeHorizontalLine$lambda(closeY));
  };
  protoOf(IntersectionPointsTracker).removeVerticalLine = function (x) {
    var closeX = getCloseKeyFromSet(x, this.y2x_1, this.x2x_1);
    if (!this.y2x_1.p(closeX))
      throw Exception_init_$Create$('Does not contain a vertical line at x:' + closeX);
    this.y2x_1.r(closeX);
    var tmp = asSequence(this.z2x_1);
    return map(tmp, IntersectionPointsTracker$removeVerticalLine$lambda(closeX));
  };
  function Companion_4() {
    this.id = 64;
  }
  protoOf(Companion_4).s1k = function () {
    return this.id;
  };
  var Companion_instance_37;
  function Companion_getInstance_13() {
    return Companion_instance_37;
  }
  function RoomAlignmentEdgesComponent(activationDistance, priority, offeredTags, horizontalAlignmentKeys, verticalAlignmentKeys, surfaceConnectors, surfaceConnectorsOwnerEntity) {
    this.activationDistance = activationDistance;
    this.priority = priority;
    this.horizontalAlignmentKeys = horizontalAlignmentKeys;
    this.verticalAlignmentKeys = verticalAlignmentKeys;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(surfaceConnectors, 10));
    var tmp0_iterator = surfaceConnectors.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.alignmentlines.RoomAlignmentEdgesComponent.surfacesAlignmentLines.<anonymous>' call
      var tmp$ret$0 = new SurfaceAlignmentLines(item, surfaceConnectorsOwnerEntity, this.priority, this.activationDistance, offeredTags);
      destination.q(tmp$ret$0);
    }
    tmp.o2x_1 = destination;
  }
  protoOf(RoomAlignmentEdgesComponent).l1x = function () {
    return this.activationDistance;
  };
  protoOf(RoomAlignmentEdgesComponent).v1v = function () {
    return this.priority;
  };
  protoOf(RoomAlignmentEdgesComponent).a2y = function () {
    return this.horizontalAlignmentKeys;
  };
  protoOf(RoomAlignmentEdgesComponent).b2y = function () {
    return this.verticalAlignmentKeys;
  };
  protoOf(RoomAlignmentEdgesComponent).getAlignmentLinesForSurface = function (surfaceConnector) {
    return this.getAlignmentLinesForSurfaceKey(surfaceConnector.p22_1);
  };
  protoOf(RoomAlignmentEdgesComponent).getAlignmentLinesForSurfaceKey = function (surfaceConnectorKey) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.o2x_1.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.alignmentlines.RoomAlignmentEdgesComponent.getAlignmentLinesForSurfaceKey.<anonymous>' call
        if (element.surfaceConnector.p22_1 === surfaceConnectorKey) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(RoomAlignmentEdgesComponent).x1k = function () {
    return 64;
  };
  protoOf(RoomAlignmentEdgesComponent).eq = function (other) {
    return false;
  };
  protoOf(RoomAlignmentEdgesComponent).p2x = function () {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var connectorKeys = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.o2x_1.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.alignmentlines.RoomAlignmentEdgesComponent.getAllGeneratedAlignmentConnectors.<anonymous>' call
      connectorKeys.x(element.q2w());
    }
    return connectorKeys;
  };
  function getCloseKeyFromSet(key, set, epsilon) {
    if (!set.p(key)) {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.minByOrNull' call
        var iterator = set.t();
        if (!iterator.u()) {
          tmp$ret$0 = null;
          break $l$block_0;
        }
        var minElem = iterator.w();
        if (!iterator.u()) {
          tmp$ret$0 = minElem;
          break $l$block_0;
        }
        // Inline function 'com.ikea.core.stl.alignmentlines.getCloseKeyFromSet.<anonymous>' call
        // Inline function 'kotlin.math.abs' call
        var x = minElem - key;
        var minValue = Math.abs(x);
        do {
          var e = iterator.w();
          // Inline function 'com.ikea.core.stl.alignmentlines.getCloseKeyFromSet.<anonymous>' call
          // Inline function 'kotlin.math.abs' call
          var x_0 = e - key;
          var v = Math.abs(x_0);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (iterator.u());
        tmp$ret$0 = minElem;
      }
      var closestAlternative = tmp$ret$0;
      var tmp;
      var tmp_0;
      if (closestAlternative == null) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.math.abs' call
        var x_1 = closestAlternative - key;
        tmp_0 = Math.abs(x_1) >= epsilon;
      }
      if (tmp_0) {
        tmp = key;
      } else {
        tmp = closestAlternative;
      }
      return tmp;
    }
    return key;
  }
  function createHorizontalAlignmentConnector($this, height) {
    var halfWidth = $this.width / 2.0;
    var p1 = new Vector(halfWidth, VOID, height);
    var p2 = new Vector(-halfWidth, VOID, height);
    var p1EntitySpace = $this.surfaceConnector.y22_1.transformPosition(p1);
    var p2EntitySpace = $this.surfaceConnector.y22_1.transformPosition(p2);
    var tmp0_key = 'horizontal alignment height ' + height;
    var tmp2_rotation = $this.surfaceConnector.y22_1.rotation;
    var tmp3_priority = $this.d2y_1;
    // Inline function 'kotlin.emptyArray' call
    var tmp4_tagArray = [];
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = $this.f2y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = ['line'];
    var tmp5_offersArray = tmp$ret$1.concat(tmp$ret$4);
    var tmp6_activationDistance = $this.e2y_1;
    var connector = new EdgeConnector(tmp0_key, 2, p1EntitySpace, p2EntitySpace, tmp2_rotation, tmp3_priority, tmp6_activationDistance, VOID, tmp4_tagArray, tmp5_offersArray);
    $this.g2y_1.registerConnector(connector, height);
    return connector;
  }
  function createVerticalAlignmentConnector($this, x) {
    var halfHeight = $this.height * 0.5;
    var p1 = new Vector(x, 0.0, -halfHeight);
    var p2 = new Vector(x, 0.0, halfHeight);
    var p1EntitySpace = $this.surfaceConnector.y22_1.transformPosition(p1);
    var p2EntitySpace = $this.surfaceConnector.y22_1.transformPosition(p2);
    var tmp0_key = 'vertical alignment connector at x: ' + x;
    var tmp2_rotation = $this.surfaceConnector.y22_1.rotation;
    var tmp3_priority = $this.d2y_1;
    // Inline function 'kotlin.emptyArray' call
    var tmp4_tagArray = [];
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = $this.f2y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = ['line'];
    var tmp5_offersArray = tmp$ret$1.concat(tmp$ret$4);
    var tmp6_activationDistance = $this.e2y_1;
    var connector = new EdgeConnector(tmp0_key, 2, p1EntitySpace, p2EntitySpace, tmp2_rotation, tmp3_priority, tmp6_activationDistance, VOID, tmp4_tagArray, tmp5_offersArray);
    $this.h2y_1.registerConnector(connector, x);
    return connector;
  }
  function SurfaceAlignmentLines(surfaceConnector, ownerEntity, priority, activationDistance, offers, epsilon) {
    epsilon = epsilon === VOID ? 1.0 : epsilon;
    this.surfaceConnector = surfaceConnector;
    this.c2y_1 = ownerEntity;
    this.d2y_1 = priority;
    this.e2y_1 = activationDistance;
    this.f2y_1 = offers;
    this.g2y_1 = new AlignmentLinesReferenceCounter(epsilon);
    this.h2y_1 = new AlignmentLinesReferenceCounter(epsilon);
    this.i2y_1 = new IntersectionPointsTracker(epsilon);
    this.normal = this.surfaceConnector.plane.normal;
    this.center = this.surfaceConnector.y22_1.position;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.surfaceConnector.vertices;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.<anonymous>' call
      var tmp$ret$0 = this.surfaceConnector.y22_1.inverseTransformPosition(item);
      destination.q(tmp$ret$0);
    }
    var localSurfaceVertices = destination;
    var tmp = Companion_getInstance_3();
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3 = copyToArray(localSurfaceVertices);
    var aabb = tmp.fromVertices(tmp$ret$3);
    var size = aabb.size;
    this.width = size.X;
    this.height = size.Z;
    var tmp_0 = this;
    var tmp0_localToParentTransform = this.surfaceConnector.y22_1;
    var tmp1_priority = this.d2y_1 + 1 | 0;
    // Inline function 'kotlin.emptyArray' call
    var tmp2_tags = [];
    var tmp3_offers = this.f2y_1;
    var tmp4_activationDistance = this.e2y_1;
    tmp_0.j2y_1 = new IntersectionPointConnectors(tmp1_priority, tmp2_tags, tmp3_offers, tmp0_localToParentTransform, tmp4_activationDistance);
  }
  protoOf(SurfaceAlignmentLines).k2y = function () {
    return this.surfaceConnector;
  };
  protoOf(SurfaceAlignmentLines).d23 = function () {
    return this.normal;
  };
  protoOf(SurfaceAlignmentLines).g2p = function () {
    return this.center;
  };
  protoOf(SurfaceAlignmentLines).u2b = function () {
    return this.width;
  };
  protoOf(SurfaceAlignmentLines).v2b = function () {
    return this.height;
  };
  protoOf(SurfaceAlignmentLines).q2w = function () {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var keys = LinkedHashSet_init_$Create$();
    keys.x(this.j2y_1.q2w());
    keys.x(this.g2y_1.q2w());
    keys.x(this.h2y_1.q2w());
    return keys;
  };
  protoOf(SurfaceAlignmentLines).transformWorldSpaceToConnectorSpace = function (pointWorldSpace) {
    var ownerTransform = get_worldTransform(this.c2y_1);
    var posOwnerSpace = ownerTransform.inverseTransformPosition(pointWorldSpace);
    return this.surfaceConnector.y22_1.inverseTransformPosition(posOwnerSpace);
  };
  protoOf(SurfaceAlignmentLines).transformConnectorSpaceToWorldSpace = function (pointInConnectorSpace) {
    var ownerTransform = get_worldTransform(this.c2y_1);
    var posOwnerSpace = this.surfaceConnector.y22_1.transformPosition(pointInConnectorSpace);
    return ownerTransform.transformPosition(posOwnerSpace);
  };
  protoOf(SurfaceAlignmentLines).addVerticalLine = function (worldSpacePoint, addedConnectors) {
    var x = this.transformWorldSpaceToConnectorSpace(worldSpacePoint).X;
    if (this.h2y_1.addReferenceCount(x)) {
      var newEdgeConnector = createVerticalAlignmentConnector(this, x);
      addedConnectors.q(newEdgeConnector);
      // Inline function 'kotlin.sequences.forEach' call
      var tmp0_iterator = this.i2y_1.addVerticalLine(x).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.addVerticalLine.<anonymous>' call
        var x_0 = element.af();
        var y = element.bf();
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var newPointConnector = this.j2y_1.addConnector(x_0, y);
        addedConnectors.q(newPointConnector);
      }
    }
  };
  protoOf(SurfaceAlignmentLines).addHorizontal = function (worldSpacePoint, addedConnectors) {
    var y = this.transformWorldSpaceToConnectorSpace(worldSpacePoint).Z;
    if (this.g2y_1.addReferenceCount(y)) {
      var horizontalConnector = createHorizontalAlignmentConnector(this, y);
      addedConnectors.q(horizontalConnector);
      // Inline function 'kotlin.sequences.forEach' call
      var tmp0_iterator = this.i2y_1.addHorizontalLine(y).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.addHorizontal.<anonymous>' call
        var x = element.af();
        var y_0 = element.bf();
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var newPointConnector = this.j2y_1.addConnector(x, y_0);
        addedConnectors.q(newPointConnector);
      }
    }
  };
  protoOf(SurfaceAlignmentLines).removeHorizontalLine = function (worldSpacePoint, removedConnectors) {
    var y = this.transformWorldSpaceToConnectorSpace(worldSpacePoint).Z;
    if (this.g2y_1.subtractReferenceCount(y)) {
      var edgeToRemove = this.g2y_1.getConnector(y);
      this.g2y_1.unregisterConnector(y);
      removedConnectors.q(edgeToRemove);
      // Inline function 'kotlin.sequences.forEach' call
      var tmp0_iterator = this.i2y_1.removeHorizontalLine(y).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.removeHorizontalLine.<anonymous>' call
        var x = element.af();
        var y_0 = element.bf();
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var removedPointConnector = this.j2y_1.removeConnector(x, y_0);
        removedConnectors.q(removedPointConnector);
      }
    }
  };
  protoOf(SurfaceAlignmentLines).removeVerticalLine = function (worldSpacePoint, removedConnectors) {
    var x = this.transformWorldSpaceToConnectorSpace(worldSpacePoint).X;
    if (this.h2y_1.subtractReferenceCount(x)) {
      var edgeToRemove = this.h2y_1.getConnector(x);
      this.h2y_1.unregisterConnector(x);
      removedConnectors.q(edgeToRemove);
      // Inline function 'kotlin.sequences.forEach' call
      var tmp0_iterator = this.i2y_1.removeVerticalLine(x).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.alignmentlines.SurfaceAlignmentLines.removeVerticalLine.<anonymous>' call
        var x_0 = element.af();
        var y = element.bf();
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var removedPointConnector = this.j2y_1.removeConnector(x_0, y);
        removedConnectors.q(removedPointConnector);
      }
    }
  };
  function AllowedDoorPairsComponent_init_$Init$(width1, width2, $this) {
    width2 = width2 === VOID ? null : width2;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [new Pair(width1, width2)];
    AllowedDoorPairsComponent.call($this, tmp$ret$2);
    return $this;
  }
  function AllowedDoorPairsComponentFromInts(width1, width2) {
    return AllowedDoorPairsComponent_init_$Init$(width1, width2, objectCreate(protoOf(AllowedDoorPairsComponent)));
  }
  function AllowedDoorPairsComponent_init_$Init$_0(pairs, $this) {
    AllowedDoorPairsComponent.call($this, Companion_instance_38.toPairs(pairs));
    return $this;
  }
  function AllowedDoorPairsComponentFromArrays(pairs) {
    return AllowedDoorPairsComponent_init_$Init$_0(pairs, objectCreate(protoOf(AllowedDoorPairsComponent)));
  }
  function Companion_5() {
    this.id = 29;
  }
  protoOf(Companion_5).s1k = function () {
    return this.id;
  };
  protoOf(Companion_5).toPairs = function (values) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(values.length);
    var inductionVariable = 0;
    var last = values.length;
    while (inductionVariable < last) {
      var item = values[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alloweddoorpairs.Companion.toPairs.<anonymous>' call
      var tmp;
      switch (item.length) {
        case 1:
          tmp = new Pair(item[0], null);
          break;
        case 2:
          tmp = new Pair(item[0], item[1]);
          break;
        default:
          throw IllegalArgumentException_init_$Create$('Door pair must have one or two widths');
      }
      var tmp$ret$0 = tmp;
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  var Companion_instance_38;
  function Companion_getInstance_14() {
    return Companion_instance_38;
  }
  function AllowedDoorPairsComponent(pairs) {
    this.pairs = pairs;
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = this.pairs;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsComponent.allWidths.<anonymous>' call
      var width1 = element.af();
      var width2 = element.bf();
      var tmp_0;
      if (width2 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsComponent.allWidths.<anonymous>.<anonymous>' call
        tmp_0 = listOf_0([width1, width2]);
      }
      var tmp1_elvis_lhs = tmp_0;
      var list = tmp1_elvis_lhs == null ? listOf(width1) : tmp1_elvis_lhs;
      addAll_0(destination, list);
    }
    tmp.l2y_1 = copyToArray(destination);
  }
  protoOf(AllowedDoorPairsComponent).m2y = function () {
    return this.pairs;
  };
  protoOf(AllowedDoorPairsComponent).x1k = function () {
    return 29;
  };
  protoOf(AllowedDoorPairsComponent).equals = function (other) {
    return other === other;
  };
  protoOf(AllowedDoorPairsComponent).hashCode = function () {
    var tmp;
    if (any_0(this.pairs)) {
      var tmp_0 = this.pairs[0].ye_1;
      var tmp0_elvis_lhs = this.pairs[0].ze_1;
      tmp = tmp_0 + (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) | 0;
    } else {
      tmp = 0;
    }
    return tmp;
  };
  protoOf(AllowedDoorPairsComponent).allows = function (oneDoorWidth, secondDoorWidth) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = this.pairs;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsComponent.allows.<anonymous>' call
        var width1 = element.af();
        var width2 = element.bf();
        if ((width1 === oneDoorWidth ? width2 === secondDoorWidth : false) ? true : width2 === oneDoorWidth ? width1 === secondDoorWidth : false) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(AllowedDoorPairsComponent).isWidthAllowed = function (comSizeWidth) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = this.l2y_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsComponent.isWidthAllowed.<anonymous>' call
        if (element === comSizeWidth) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(AllowedDoorPairsComponent).eq = function (other) {
    return false;
  };
  protoOf(AllowedDoorPairsComponent).af = function () {
    return this.pairs;
  };
  protoOf(AllowedDoorPairsComponent).n2y = function (pairs) {
    return new AllowedDoorPairsComponent(pairs);
  };
  protoOf(AllowedDoorPairsComponent).copy = function (pairs, $super) {
    pairs = pairs === VOID ? this.pairs : pairs;
    return this.n2y(pairs);
  };
  protoOf(AllowedDoorPairsComponent).toString = function () {
    return 'AllowedDoorPairsComponent(pairs=' + toString(this.pairs) + ')';
  };
  function validate($this, entity, snapActionCandidate) {
    var tmp1_elvis_lhs = snapActionCandidate == null ? null : snapActionCandidate.host;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var parent = tmp;
    var allowedDoorPairs = parent.__getComponentForKotlin(29);
    var entityIsDoor = entity.hasComponent(DoorComponent_getInstance().o2y_1);
    if (!(allowedDoorPairs == null) ? entityIsDoor : false) {
      return allowedToPlaceFrontOnFrame($this, allowedDoorPairs, entity, parent);
    }
    return null;
  }
  function allowedToPlaceFrontOnFrame($this, allowedDoorPairsComponent, newDoor, frame) {
    var existingDoors = findExistingDoorsOnFrame($this, frame, newDoor);
    if (existingDoors.n() >= 2) {
      return new InvalidDoorPairsResult('Not allowed to have more than 2 doors', get_productRefOrEmptyString(newDoor), $this);
    }
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!existingDoors.b1()) {
      tmp = allowedToPlaceSecondDoor($this, allowedDoorPairsComponent, existingDoors.f1(0), newDoor);
    } else {
      tmp = allowedToPlaceFirstDoor($this, allowedDoorPairsComponent, newDoor);
    }
    return tmp;
  }
  function allowedToPlaceSecondDoor($this, allowedDoorPairsComponent, firstDoor, secondDoor) {
    var tmp0_safe_receiver = firstDoor.__getComponentForKotlin(33);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.s2e_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
    var tmp;
    if (tmp3_elvis_lhs == null) {
      return new InvalidDoorPairsResult('Door ' + firstDoor.id + ' has no size component hence no width', get_productRefOrEmptyString(secondDoor), $this);
    } else {
      tmp = tmp3_elvis_lhs;
    }
    var firstDoorWidth = tmp;
    var tmp4_safe_receiver = secondDoor.__getComponentForKotlin(33);
    var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.size;
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.s2e_1;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
    var tmp_0;
    if (tmp7_elvis_lhs == null) {
      return new InvalidDoorPairsResult('Door ' + secondDoor.id + ' has no size component hence no width', get_productRefOrEmptyString(secondDoor), $this);
    } else {
      tmp_0 = tmp7_elvis_lhs;
    }
    var secondDoorWidth = tmp_0;
    if (!allowedDoorPairsComponent.isWidthAllowed(firstDoorWidth))
      return new InvalidDoorPairsResult('Door (' + firstDoor.id + ') of width ' + firstDoorWidth + ' not allowed on frame. Allowed widths: ' + allowedDoorPairsComponent.pairs, get_productRefOrEmptyString(secondDoor), $this);
    if (!allowedDoorPairsComponent.isWidthAllowed(secondDoorWidth))
      return new InvalidDoorPairsResult('Door (' + secondDoor.id + ') of width ' + secondDoorWidth + ' not allowed on frame. Allowed widths: ' + allowedDoorPairsComponent.pairs, get_productRefOrEmptyString(secondDoor), $this);
    var tmp_1;
    if (allowedDoorPairsComponent.allows(firstDoorWidth, secondDoorWidth)) {
      tmp_1 = null;
    } else {
      tmp_1 = new InvalidDoorPairsResult('Not allowed to pair a door of width ' + secondDoorWidth + ' with and existing door of width ' + firstDoorWidth + '. Allowed widths: ' + allowedDoorPairsComponent.pairs, get_productRefOrEmptyString(secondDoor), $this);
    }
    return tmp_1;
  }
  function allowedToPlaceFirstDoor($this, allowedDoorPairsComponent, firstDoor) {
    var tmp0_safe_receiver = firstDoor.__getComponentForKotlin(33);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.s2e_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
    var tmp;
    if (tmp3_elvis_lhs == null) {
      return new InvalidDoorPairsResult('Door ' + firstDoor.id + ' has no size component hence no width', get_productRefOrEmptyString(firstDoor), $this);
    } else {
      tmp = tmp3_elvis_lhs;
    }
    var doorPhysicalWidth = tmp;
    var tmp_0;
    if (allowedDoorPairsComponent.isWidthAllowed(doorPhysicalWidth)) {
      tmp_0 = null;
    } else {
      tmp_0 = new InvalidDoorPairsResult('Door (' + firstDoor.id + ') of width ' + doorPhysicalWidth + ' not allowed on frame. Allowed widths: ' + allowedDoorPairsComponent.pairs, get_productRefOrEmptyString(firstDoor), $this);
    }
    return tmp_0;
  }
  function findExistingDoorsOnFrame($this, frame, newDoor) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_children(frame);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsValidation.findExistingDoorsOnFrame.<anonymous>' call
      if (element.hasComponent(DoorComponent_getInstance().o2y_1)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.alloweddoorpairs.AllowedDoorPairsValidation.findExistingDoorsOnFrame.<anonymous>' call
      if (!element_0.equals(newDoor)) {
        destination_0.q(element_0);
      }
    }
    return destination_0;
  }
  function Companion_6() {
    this.ID = 'AllowedDoorPairs';
  }
  protoOf(Companion_6).u1n = function () {
    return this.ID;
  };
  var Companion_instance_39;
  function Companion_getInstance_15() {
    return Companion_instance_39;
  }
  function AllowedDoorPairsValidation() {
    ValidationImpl.call(this);
    this.q2y_1 = 'AllowedDoorPairs';
  }
  protoOf(AllowedDoorPairsValidation).s1k = function () {
    return this.q2y_1;
  };
  protoOf(AllowedDoorPairsValidation).validateCurrentState = function (entity) {
    return validate(this, entity, null);
  };
  protoOf(AllowedDoorPairsValidation).validateSnap = function (snapActionCandidate) {
    return validate(this, snapActionCandidate.guestRoot, snapActionCandidate);
  };
  function Companion_7() {
    this.ID = 'InvalidDoorPairsResult';
  }
  protoOf(Companion_7).u1n = function () {
    return this.ID;
  };
  var Companion_instance_40;
  function Companion_getInstance_16() {
    return Companion_instance_40;
  }
  function InvalidDoorPairsResult(message, productRef, rule) {
    ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef, rule);
    this.r2y_1 = message;
  }
  protoOf(InvalidDoorPairsResult).s1k = function () {
    return 'InvalidDoorPairsResult';
  };
  protoOf(InvalidDoorPairsResult).toString = function () {
    return this.id + ': ' + this.r2y_1;
  };
  function AssemblyInstructionsService() {
  }
  function AssemblyInstructionsServiceImpl() {
  }
  protoOf(AssemblyInstructionsServiceImpl).getAssemblyInstructionsForPointSeries = function (root) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_hierarchy(root);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsServiceImpl.getAssemblyInstructionsForPointSeries.<anonymous>' call
      if (!get_isPropping(element)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsServiceImpl.getAssemblyInstructionsForPointSeries.<anonymous>' call
      Companion_getInstance_1();
      if (element_0.hasComponent(104)) {
        destination_0.q(element_0);
      }
    }
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = destination_0.t();
    while (tmp0_iterator_0.u()) {
      var element_1 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsServiceImpl.getAssemblyInstructionsForPointSeries.<anonymous>' call
      var list = toList(get_guestConnections(element_1));
      addAll_0(destination_1, list);
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = destination_1.t();
    while (tmp0_iterator_1.u()) {
      var element_2 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsServiceImpl.getAssemblyInstructionsForPointSeries.<anonymous>' call
      var tmp = element_2.hostConnector;
      if (tmp instanceof PointSeriesSubConnector) {
        destination_2.q(element_2);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_2, 10));
    var tmp0_iterator_2 = destination_2.t();
    while (tmp0_iterator_2.u()) {
      var item = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.stl.assemblyinstructions.AssemblyInstructionsServiceImpl.getAssemblyInstructionsForPointSeries.<anonymous>' call
      var tmp$ret$12 = new PointSeriesAssemblyInstructionImpl(item);
      destination_3.q(tmp$ret$12);
    }
    var this_1 = toList_0(destination_3);
    return copyToArray(this_1);
  };
  function PointSeriesAssemblyInstruction() {
  }
  function _get_hostSubConnector__a6nvli($this) {
    var tmp = $this.v2y_1.hostConnector;
    return tmp instanceof PointSeriesSubConnector ? tmp : THROW_CCE();
  }
  function PointSeriesAssemblyInstructionImpl(connection) {
    this.v2y_1 = connection;
    this.w2y_1 = _get_hostSubConnector__a6nvli(this).positionInSeries;
    this.x2y_1 = get_worldTransform(this.v2y_1.hostConnectorEntity).transformPosition(_get_hostSubConnector__a6nvli(this).positionInSeries);
  }
  protoOf(PointSeriesAssemblyInstructionImpl).i2q = function () {
    return this.v2y_1.hostConnectorEntity;
  };
  protoOf(PointSeriesAssemblyInstructionImpl).j2q = function () {
    return this.v2y_1.guestConnectorEntity;
  };
  protoOf(PointSeriesAssemblyInstructionImpl).t1v = function () {
    var tmp0_elvis_lhs = get_connectionRootEntity(this.guest);
    return tmp0_elvis_lhs == null ? this.guest : tmp0_elvis_lhs;
  };
  protoOf(PointSeriesAssemblyInstructionImpl).s2y = function () {
    return _get_hostSubConnector__a6nvli(this).hole;
  };
  protoOf(PointSeriesAssemblyInstructionImpl).t2y = function () {
    return this.w2y_1;
  };
  protoOf(PointSeriesAssemblyInstructionImpl).u2y = function () {
    return this.x2y_1;
  };
  protoOf(PointSeriesAssemblyInstructionImpl).y2y = function (connection) {
    return new PointSeriesAssemblyInstructionImpl(connection);
  };
  protoOf(PointSeriesAssemblyInstructionImpl).copy = function (connection, $super) {
    connection = connection === VOID ? this.v2y_1 : connection;
    return this.y2y(connection);
  };
  protoOf(PointSeriesAssemblyInstructionImpl).toString = function () {
    return 'PointSeriesAssemblyInstructionImpl(connection=' + this.v2y_1 + ')';
  };
  protoOf(PointSeriesAssemblyInstructionImpl).hashCode = function () {
    return this.v2y_1.hashCode();
  };
  protoOf(PointSeriesAssemblyInstructionImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PointSeriesAssemblyInstructionImpl))
      return false;
    var tmp0_other_with_cast = other instanceof PointSeriesAssemblyInstructionImpl ? other : THROW_CCE();
    if (!this.v2y_1.equals(tmp0_other_with_cast.v2y_1))
      return false;
    return true;
  };
  function AutoAdaptFeature() {
  }
  protoOf(AutoAdaptFeature).start = function (coreServices) {
    var entityManager = coreServices.entityManager;
    // Inline function 'kotlin.collections.find' call
    var this_0 = entityManager.getSystemsRegistered();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptFeature.start.<anonymous>' call
        var tmp = element.id;
        if (tmp === 'AutoAdaptCacheSystem') {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp_0 = tmp$ret$1;
    var preExistingCache = tmp_0 instanceof AutoAdaptCacheSystem ? tmp_0 : null;
    var autoAdaptCacheSystem = preExistingCache == null ? new AutoAdaptCacheSystem(coreServices.productManager) : preExistingCache;
    if (preExistingCache == null) {
      entityManager.registerSystem(autoAdaptCacheSystem);
    }
    // Inline function 'kotlin.collections.find' call
    var this_1 = entityManager.getSystemsRegistered();
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptFeature.start.<anonymous>' call
        var tmp_1 = element_0.id;
        Companion_getInstance_19();
        if (tmp_1 === 'AutoAdaptChildrenSystem') {
          tmp$ret$4 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$4 = null;
    }
    var tmp_2 = tmp$ret$4;
    var preExistingChildrenSystem = tmp_2 instanceof AutoAdaptChildrenSystem ? tmp_2 : null;
    var autoAdaptChildrenSystem = preExistingChildrenSystem == null ? new AutoAdaptChildrenSystem(coreServices) : preExistingChildrenSystem;
    if (preExistingChildrenSystem == null) {
      entityManager.registerSystem(autoAdaptChildrenSystem);
    }
    // Inline function 'kotlin.collections.find' call
    var this_2 = entityManager.getSystemsRegistered();
    var tmp$ret$7;
    $l$block_1: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_1 = 0;
      var last_1 = this_2.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = this_2[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptFeature.start.<anonymous>' call
        var tmp_3 = element_1.id;
        if (tmp_3 === 'CleanCacheOnFinishedAutoAdaptSystem') {
          tmp$ret$7 = element_1;
          break $l$block_1;
        }
      }
      tmp$ret$7 = null;
    }
    var tmp_4 = tmp$ret$7;
    var preExistingCleanCacheOnFinishedAutoAdaptSystem = tmp_4 instanceof CleanCacheOnFinishedAutoAdaptSystem ? tmp_4 : null;
    var cleanCacheOnFinishedAutoAdaptSystem = preExistingCleanCacheOnFinishedAutoAdaptSystem == null ? new CleanCacheOnFinishedAutoAdaptSystem() : preExistingCleanCacheOnFinishedAutoAdaptSystem;
    if (preExistingCleanCacheOnFinishedAutoAdaptSystem == null) {
      entityManager.registerSystem(cleanCacheOnFinishedAutoAdaptSystem);
    }
    // Inline function 'kotlin.collections.find' call
    var this_3 = entityManager.getSystemsRegistered();
    var tmp$ret$10;
    $l$block_2: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_2 = 0;
      var last_2 = this_3.length;
      while (inductionVariable_2 < last_2) {
        var element_2 = this_3[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptFeature.start.<anonymous>' call
        var tmp_5 = element_2.id;
        Companion_getInstance_20();
        if (tmp_5 === 'AutoAdaptDisposeFailedChildrenSystem') {
          tmp$ret$10 = element_2;
          break $l$block_2;
        }
      }
      tmp$ret$10 = null;
    }
    var tmp_6 = tmp$ret$10;
    var preExistingDisposeFailedChildrenSystem = tmp_6 instanceof AutoAdaptDisposeFailedChildrenSystem ? tmp_6 : null;
    var disposeFailedChildrenSystem = preExistingDisposeFailedChildrenSystem == null ? new AutoAdaptDisposeFailedChildrenSystem() : preExistingDisposeFailedChildrenSystem;
    if (preExistingDisposeFailedChildrenSystem == null) {
      entityManager.registerSystem(disposeFailedChildrenSystem);
    }
  };
  var AutoAdaptFeature_instance;
  function AutoAdaptFeature_getInstance() {
    return AutoAdaptFeature_instance;
  }
  function update($this, entity, component) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = component.variants;
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptProductSpecificationsSystem.update.<anonymous>' call
      var spec = $this.productManager.productSpecification(element);
      var tmp;
      if (spec == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptProductSpecificationsSystem.update.<anonymous>.<anonymous>' call
        tmp = new SpecificationPair(element, spec);
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver);
      }
    }
    var pairs = copyToArray(destination);
    entity.addComponent(new AutoAdaptProductSpecificationsComponent(pairs));
  }
  function Companion_8() {
    this.ID = 'AutoAdaptProductSpecificationSystem';
  }
  protoOf(Companion_8).u1n = function () {
    return this.ID;
  };
  var Companion_instance_41;
  function Companion_getInstance_17() {
    return Companion_instance_41;
  }
  function AutoAdaptProductSpecificationsSystem(productManager) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [133];
    SystemBase.call(this, 'AutoAdaptProductSpecificationSystem', 126, tmp$ret$2);
    this.productManager = productManager;
  }
  protoOf(AutoAdaptProductSpecificationsSystem).u1i = function () {
    return this.productManager;
  };
  protoOf(AutoAdaptProductSpecificationsSystem).onAddComponent = function (entity, newComponent) {
    update(this, entity, newComponent);
  };
  protoOf(AutoAdaptProductSpecificationsSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    update(this, entity, newComponent);
  };
  protoOf(AutoAdaptProductSpecificationsSystem).onRemoveComponent = function (entity, oldComponent) {
    entity.removeComponent(133);
  };
  function snapToValidAutoAdaptedSnap($this, guest, host, snapSettings, sortAndSelectStrategy) {
    var snapValidationResult = findWithAutoAdapt($this, host, guest, snapSettings, sortAndSelectStrategy);
    return snapValidationResult;
  }
  function triggerReplaceEvent(_this__u8e3s4, $this, oldEntity) {
    var event = new ReplacedWithAutoAdaptEventComponent(oldEntity);
    _this__u8e3s4.entityManager.addComponent(_this__u8e3s4, event);
    _this__u8e3s4.entityManager.removeComponent(_this__u8e3s4, event.h2z_1);
  }
  function findWithAutoAdapt($this, host, guest, snapSettings, sortAndSelectStrategy) {
    guest.addComponent(new AutoAdaptSessionComponent());
    var invalidSnapResult = {_v: null};
    var tmp0_safe_receiver = get_snapRoot(guest);
    var originalParent = tmp0_safe_receiver == null ? null : get_parent(tmp0_safe_receiver);
    var tmp = asSequence_0(get_variantEntities(guest));
    var tmp_0 = filter(tmp, AutoAdaptService$findWithAutoAdapt$lambda(guest));
    var tmp_1 = filter(tmp_0, AutoAdaptService$findWithAutoAdapt$lambda_0($this, host));
    var tmp_2 = onEach(tmp_1, AutoAdaptService$findWithAutoAdapt$lambda_1($this, guest));
    var tmp_3 = onEach(tmp_2, AutoAdaptService$findWithAutoAdapt$lambda_2($this, guest));
    var tmp_4 = map(tmp_3, AutoAdaptService$findWithAutoAdapt$lambda_3(guest, $this, host, snapSettings, invalidSnapResult, sortAndSelectStrategy));
    var tmp_5 = onEach(tmp_4, AutoAdaptService$findWithAutoAdapt$lambda_4(invalidSnapResult));
    var validSnapResult = firstOrNull(mapNotNull(tmp_5, AutoAdaptService$findWithAutoAdapt$lambda_5($this)));
    var tmp2_safe_receiver = validSnapResult == null ? null : validSnapResult.snapActionCandidate;
    var autoAdaptedEntity = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.guestRoot;
    if (autoAdaptedEntity == null) {
      var tmp3_safe_receiver = get_snapRoot(guest);
      if (tmp3_safe_receiver == null)
        null;
      else {
        setParent(tmp3_safe_receiver, originalParent);
      }
    } else {
      ModelUtils_getInstance().hide(guest, true);
      ModelUtils_getInstance().show(autoAdaptedEntity, true);
      var tmp4_safe_receiver = get_snapRoot(guest);
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        triggerReplaceEvent(autoAdaptedEntity, $this, tmp4_safe_receiver);
      }
    }
    var tmp6_elvis_lhs = validSnapResult == null ? invalidSnapResult._v : validSnapResult;
    var tmp_6;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp_7 = [];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = [Companion_instance_0.fail('No snap candidates', get_productRefOrEmptyString(guest), null)];
      tmp_6 = new ValidSnapActionCandidateOrErrors(null, tmp_7, tmp$ret$4);
    } else {
      tmp_6 = tmp6_elvis_lhs;
    }
    return tmp_6;
  }
  function findWithAutoAdapt$default($this, host, guest, snapSettings, sortAndSelectStrategy, $super) {
    snapSettings = snapSettings === VOID ? new SnapSettings(false, VOID, VOID, false) : snapSettings;
    return findWithAutoAdapt($this, host, guest, snapSettings, sortAndSelectStrategy);
  }
  function restrictAllowedRequiredHostsOnVariant($this, originalGuest, variant) {
    $l$block: {
      // Inline function 'com.ikea.core.utils.orElse' call
      var tmp0_safe_receiver = originalGuest.__getComponentForKotlin(Companion_instance_2.id);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptService.restrictAllowedRequiredHostsOnVariant.<anonymous>' call
        tmp = variant.addComponent(tmp0_safe_receiver);
      }
      if (tmp == null) {
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptService.restrictAllowedRequiredHostsOnVariant.<anonymous>' call
        variant.removeComponent(Companion_instance_2.id);
        break $l$block;
      }
    }
  }
  function canSnap($this, guest, host) {
    var tmp$ret$3;
    $l$block_1: {
      // Inline function 'kotlin.sequences.any' call
      var tmp0_iterator = get_snappingEntitiesSequence(guest).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptService.canSnap.<anonymous>' call
        var tmp0_safe_receiver = get_connectorsComponent(element);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.enabledConnectors;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_0;
            if (isInterface(tmp1_safe_receiver, Collection)) {
              tmp_0 = tmp1_safe_receiver.b1();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var tmp0_iterator_0 = tmp1_safe_receiver.t();
            while (tmp0_iterator_0.u()) {
              var element_0 = tmp0_iterator_0.w();
              // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptService.canSnap.<anonymous>.<anonymous>' call
              if (any_1(element_0.findHostConnectorsWithMatchingTags(get_connectorsComponent(host)))) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          tmp = tmp$ret$0;
        }
        var tmp2_elvis_lhs = tmp;
        if (tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs) {
          tmp$ret$3 = true;
          break $l$block_1;
        }
      }
      tmp$ret$3 = false;
    }
    return tmp$ret$3;
  }
  function onlyValidSnap($this, snapResult) {
    var tmp;
    if (snapResult.valid) {
      tmp = snapResult;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function snapToValidSnap($this, guest, host, includeSubConnectors, sortByWarnings, includeAlignmentConnectorsOutsideActivationDistance, sortAndSelectStrategy) {
    var anyResult = {_v: null};
    var snapSettings = new SnapSettings(includeSubConnectors, VOID, VOID, includeAlignmentConnectorsOutsideActivationDistance);
    var snapsSorted = sortAndSelectStrategy.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(guest, host, snapSettings));
    // Inline function 'kotlin.collections.isEmpty' call
    if (snapsSorted.length === 0) {
      // Inline function 'kotlin.emptyArray' call
      var tmp = [];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = [new NoValidConnectorAvailableValidationResult(get_productRefOrEmptyString(guest))];
      return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$4);
    }
    var bestWarning = {_v: null};
    var tmp_0 = asSequence_0(snapsSorted);
    var tmp_1 = map(tmp_0, AutoAdaptService$snapToValidSnap$lambda($this, anyResult, bestWarning));
    var valid = firstOrNull(filter(tmp_1, AutoAdaptService$snapToValidSnap$lambda_0(sortByWarnings)));
    var tmp1_elvis_lhs = valid == null ? bestWarning._v : valid;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? anyResult._v : tmp1_elvis_lhs;
    var tmp_2;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp_3 = [];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = [new UnknownErrorValidationResult(get_productRefOrEmptyString(guest))];
      tmp_2 = new ValidSnapActionCandidateOrErrors(null, tmp_3, tmp$ret$8);
    } else {
      tmp_2 = tmp2_elvis_lhs;
    }
    return tmp_2;
  }
  function snapToValidSnap$default($this, guest, host, includeSubConnectors, sortByWarnings, includeAlignmentConnectorsOutsideActivationDistance, sortAndSelectStrategy, $super) {
    includeSubConnectors = includeSubConnectors === VOID ? false : includeSubConnectors;
    includeAlignmentConnectorsOutsideActivationDistance = includeAlignmentConnectorsOutsideActivationDistance === VOID ? false : includeAlignmentConnectorsOutsideActivationDistance;
    return snapToValidSnap($this, guest, host, includeSubConnectors, sortByWarnings, includeAlignmentConnectorsOutsideActivationDistance, sortAndSelectStrategy);
  }
  function snapAndValidateVariant($this, possibleVariant, host, snapSettings, earlyOut, sortAndSelectStrategy) {
    var firstInvalidResult = null;
    var snapsSorted = sortAndSelectStrategy.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(possibleVariant, host, snapSettings));
    // Inline function 'kotlin.collections.isEmpty' call
    if (snapsSorted.length === 0) {
      // Inline function 'kotlin.emptyArray' call
      var tmp = [];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = [new NoValidConnectorAvailableValidationResult(get_productRefOrEmptyString(possibleVariant))];
      return new ValidSnapActionCandidateOrErrors(null, tmp, tmp$ret$4);
    }
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = snapsSorted.length;
    while (inductionVariable < last) {
      var element = snapsSorted[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptService.snapAndValidateVariant.<anonymous>' call
      var result = $this.j2z_1.evaluateSnapCandidate(element, earlyOut ? true : !(firstInvalidResult == null));
      if (result.valid) {
        return result;
      }
      if (firstInvalidResult == null) {
        firstInvalidResult = result;
      }
    }
    var tmp0_elvis_lhs = firstInvalidResult;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      var tmp_1 = [];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$8 = [new UnknownErrorValidationResult(get_productRefOrEmptyString(possibleVariant))];
      tmp_0 = new ValidSnapActionCandidateOrErrors(null, tmp_1, tmp$ret$8);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  function snapAndValidateVariant$default($this, possibleVariant, host, snapSettings, earlyOut, sortAndSelectStrategy, $super) {
    snapSettings = snapSettings === VOID ? new SnapSettings(false, VOID, VOID, false) : snapSettings;
    return snapAndValidateVariant($this, possibleVariant, host, snapSettings, earlyOut, sortAndSelectStrategy);
  }
  function prepareVariantForSnapping($this, originalEntity, variant) {
    var tmp0_elvis_lhs = get_snapRoot(originalEntity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var originalRootEntity = tmp;
    setParent(variant, null);
    setParent(originalRootEntity, null);
    TransformUtils_instance.setWorldTransform(variant, get_worldTransform(originalRootEntity));
  }
  function findWithAutoAdapt$combineInvalidResult(invalidSnapResult, newFail) {
    if (newFail.valid)
      return Unit_instance;
    var tmp;
    if (invalidSnapResult._v == null) {
      tmp = newFail;
    } else {
      var tmp0_safe_receiver = invalidSnapResult._v;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.combineFailures(newFail);
    }
    invalidSnapResult._v = tmp;
  }
  function AutoAdaptService$findWithAutoAdapt$lambda($guest) {
    return function (it) {
      return !(get_productRef(it) == get_productRef($guest));
    };
  }
  function AutoAdaptService$findWithAutoAdapt$lambda_0(this$0, $host) {
    return function (it) {
      var tmp0_elvis_lhs = get_snapRoot(it);
      return canSnap(this$0, tmp0_elvis_lhs == null ? it : tmp0_elvis_lhs, $host);
    };
  }
  function AutoAdaptService$findWithAutoAdapt$lambda_1(this$0, $guest) {
    return function (it) {
      restrictAllowedRequiredHostsOnVariant(this$0, $guest, it);
      return Unit_instance;
    };
  }
  function AutoAdaptService$findWithAutoAdapt$lambda_2(this$0, $guest) {
    return function (it) {
      prepareVariantForSnapping(this$0, $guest, it);
      return Unit_instance;
    };
  }
  function AutoAdaptService$findWithAutoAdapt$lambda_3($guest, this$0, $host, $snapSettings, $invalidSnapResult, $sortAndSelectStrategy) {
    return function (it) {
      it.addComponent(new AutoAdaptVariantComponent($guest));
      var result = snapAndValidateVariant(this$0, it, $host, $snapSettings, !($invalidSnapResult._v == null), $sortAndSelectStrategy);
      return result;
    };
  }
  function AutoAdaptService$findWithAutoAdapt$lambda_4($invalidSnapResult) {
    return function (it) {
      var tmp;
      if (!it.valid) {
        findWithAutoAdapt$combineInvalidResult($invalidSnapResult, it);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function AutoAdaptService$findWithAutoAdapt$lambda_5(this$0) {
    return function (it) {
      return onlyValidSnap(this$0, it);
    };
  }
  function AutoAdaptService$snapToValidSnap$lambda(this$0, $anyResult, $bestWarning) {
    return function (it) {
      var res = this$0.j2z_1.evaluateSnapCandidate(it, !($anyResult._v == null));
      var tmp;
      if ($anyResult._v == null) {
        $anyResult._v = res;
        tmp = Unit_instance;
      }
      var tmp_0;
      if (res.valid ? any_0(res.warnings) : false) {
        var tmp_1;
        var tmp_2;
        if ($bestWarning._v == null) {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.collections.count' call
          var tmp_3 = ensureNotNull($bestWarning._v).warnings.length;
          // Inline function 'kotlin.collections.count' call
          tmp_2 = tmp_3 > res.warnings.length;
        }
        if (tmp_2) {
          $bestWarning._v = res;
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      }
      var tmp_4;
      if ((!ensureNotNull($anyResult._v).valid ? !res.valid : false) ? !equals($anyResult._v, res) : false) {
        $anyResult._v = ensureNotNull($anyResult._v).combineFailures(res);
        tmp_4 = Unit_instance;
      }
      return res;
    };
  }
  function AutoAdaptService$snapToValidSnap$lambda_0($sortByWarnings) {
    return function (it) {
      return $sortByWarnings ? it.valid ? none(it.warnings) : false : it.valid;
    };
  }
  function AutoAdaptService(coreServices) {
    this.coreServices = coreServices;
    this.i2z_1 = this.coreServices.sceneManager;
    this.j2z_1 = this.coreServices.validations;
  }
  protoOf(AutoAdaptService).k2z = function () {
    return this.coreServices;
  };
  protoOf(AutoAdaptService).l2z = function (guest, host, snapSettings, sortByWarnings, sortAndSelectStrategy) {
    var snapWithoutAutoAdaptResult = snapToValidSnap(this, guest, host, snapSettings.includeAllSubConnectors, sortByWarnings, snapSettings.includeAlignmentConnectorsOutsideActivationDistance, sortAndSelectStrategy);
    var tmp;
    if (snapWithoutAutoAdaptResult.valid) {
      tmp = snapWithoutAutoAdaptResult;
    } else {
      var result = snapToValidAutoAdaptedSnap(this, guest, host, snapSettings, sortAndSelectStrategy);
      tmp = result.valid ? result : snapWithoutAutoAdaptResult.combineFailures(result);
    }
    return tmp;
  };
  protoOf(AutoAdaptService).findValidSnapActionWithAutoAdapt = function (guest, host, snapSettings, sortByWarnings, sortAndSelectStrategy, $super) {
    snapSettings = snapSettings === VOID ? new SnapSettings(VOID, VOID, VOID, true) : snapSettings;
    sortByWarnings = sortByWarnings === VOID ? true : sortByWarnings;
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE : sortAndSelectStrategy;
    return this.l2z(guest, host, snapSettings, sortByWarnings, sortAndSelectStrategy);
  };
  protoOf(AutoAdaptService).findClosestAutoAdaptHost = function (entity, point) {
    return AutoAdaptUtils_getInstance().findClosestAutoAdaptHost(this.i2z_1.scene, entity, point);
  };
  protoOf(AutoAdaptService).findAutoAdaptHostsContainingPoint = function (entity, point) {
    var tmp0_elvis_lhs = get_parentComponent(this.i2z_1.scene);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      return [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var scene = tmp;
    var allHosts = AutoAdaptUtils_getInstance().findAllAutoAdaptHostsInScene(scene, entity);
    return findAllHostsContainingPointSortedBySize(allHosts, point);
  };
  function findClosestHostContainingPoint(hosts, point) {
    return firstOrNull_0(findAllHostsContainingPointSortedBySize(hosts, point));
  }
  function findAllHostsContainingPointSortedBySize(hosts, point) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(hosts.length);
    var inductionVariable = 0;
    var last = hosts.length;
    while (inductionVariable < last) {
      var item = hosts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
      var entity = item.af();
      var zone = item.bf();
      var rotatedPolyhedron = TransformUtils_instance.applyWorldTransform(zone, entity);
      var boundingBox = rotatedPolyhedron.axisAlignedBoundingBox;
      var tmp$ret$0 = new Pair(entity, boundingBox);
      destination.q(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
      var boundingBox_0 = element.bf();
      if (boundingBox_0.containsPoint(point)) {
        destination_0.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
    var tmp0_iterator_0 = destination_0.t();
    while (tmp0_iterator_0.u()) {
      var item_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
      var entity_0 = item_0.af();
      var boundingBox_1 = item_0.bf();
      var tmp$ret$6 = new Pair(entity_0, boundingBox_1.size.size);
      destination_1.q(tmp$ret$6);
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = findAllHostsContainingPointSortedBySize$lambda;
    var tmp$ret$9 = new sam$kotlin_Comparator$0_0(tmp);
    var this_0 = sortedWith(destination_1, tmp$ret$9);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator_1 = this_0.t();
    while (tmp0_iterator_1.u()) {
      var item_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
      var tmp$ret$11 = item_1.ye_1;
      destination_2.q(tmp$ret$11);
    }
    return copyToArray(destination_2);
  }
  function EntityWithSensorZone(entity, zone) {
    this.entity = entity;
    this.zone = zone;
  }
  protoOf(EntityWithSensorZone).r23 = function () {
    return this.entity;
  };
  protoOf(EntityWithSensorZone).m2z = function () {
    return this.zone;
  };
  protoOf(EntityWithSensorZone).af = function () {
    return this.entity;
  };
  protoOf(EntityWithSensorZone).bf = function () {
    return this.zone;
  };
  protoOf(EntityWithSensorZone).n2z = function (entity, zone) {
    return new EntityWithSensorZone(entity, zone);
  };
  protoOf(EntityWithSensorZone).copy = function (entity, zone, $super) {
    entity = entity === VOID ? this.entity : entity;
    zone = zone === VOID ? this.zone : zone;
    return this.n2z(entity, zone);
  };
  protoOf(EntityWithSensorZone).toString = function () {
    return 'EntityWithSensorZone(entity=' + this.entity + ', zone=' + this.zone + ')';
  };
  protoOf(EntityWithSensorZone).hashCode = function () {
    var result = this.entity.hashCode();
    result = imul(result, 31) + hashCode(this.zone) | 0;
    return result;
  };
  protoOf(EntityWithSensorZone).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityWithSensorZone))
      return false;
    var tmp0_other_with_cast = other instanceof EntityWithSensorZone ? other : THROW_CCE();
    if (!this.entity.equals(tmp0_other_with_cast.entity))
      return false;
    if (!equals(this.zone, tmp0_other_with_cast.zone))
      return false;
    return true;
  };
  function sam$kotlin_Comparator$0_0(function_0) {
    this.o2z_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).u1j = function (a, b) {
    return this.o2z_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function findAllHostsContainingPointSortedBySize$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
    var size = a.bf();
    var tmp = size;
    // Inline function 'com.ikea.core.stl.autoadapt.findAllHostsContainingPointSortedBySize.<anonymous>' call
    var size_0 = b.bf();
    return compareValues(tmp, size_0);
  }
  function findClosestHost($this, hosts, point) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(hosts.length);
    var inductionVariable = 0;
    var last = hosts.length;
    while (inductionVariable < last) {
      var item = hosts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.findClosestHost.<anonymous>' call
      var testEntity = item.af();
      var testPosition = get_worldPosition(testEntity);
      var distance = point.minus(testPosition);
      var tmp$ret$0 = new Pair(distance.size, testEntity);
      destination.q(tmp$ret$0);
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = AutoAdaptUtils$findClosestHost$lambda;
    var tmp$ret$3 = new sam$kotlin_Comparator$0_1(tmp);
    var this_0 = sortedWith(destination, tmp$ret$3);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var item_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.findClosestHost.<anonymous>' call
      var testEntity_0 = item_0.bf();
      destination_0.q(testEntity_0);
    }
    return firstOrNull_1(destination_0);
  }
  function sam$kotlin_Comparator$0_1(function_0) {
    this.p2z_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_1).u1j = function (a, b) {
    return this.p2z_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function sam$kotlin_Comparator$0_2(function_0) {
    this.q2z_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_2).u1j = function (a, b) {
    return this.q2z_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function AutoAdaptUtils$findClosestHost$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.findClosestHost.<anonymous>' call
    var distance = a.af();
    var tmp = distance;
    // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.findClosestHost.<anonymous>' call
    var distance_0 = b.af();
    return compareValues(tmp, distance_0);
  }
  function AutoAdaptUtils$getAutoAdaptSnapCandidates$lambda($guest) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.getAutoAdaptSnapCandidates.<anonymous>' call
      var tmp = b.id === $guest.id;
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.getAutoAdaptSnapCandidates.<anonymous>' call
      var tmp$ret$1 = a.id === $guest.id;
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function AutoAdaptUtils() {
    AutoAdaptUtils_instance = this;
    this.r2z_1 = new SnapSettings(false, false, false, true);
    this.s2z_1 = new SnapSettings(false, false, false, false);
  }
  protoOf(AutoAdaptUtils).findClosestAutoAdaptHost = function (hierarchy, entity, point) {
    var tmp0_elvis_lhs = get_parentComponent(hierarchy);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var scene = tmp;
    var allHosts = this.findAllAutoAdaptHostsInScene(scene, entity);
    var tmp1_elvis_lhs = findClosestHostContainingPoint(allHosts, point);
    return tmp1_elvis_lhs == null ? findClosestHost(this, allHosts, point) : tmp1_elvis_lhs;
  };
  protoOf(AutoAdaptUtils).findAllAutoAdaptHostsInScene = function (scene, entity) {
    var myHierarchy = get_hierarchy(entity);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = scene.allDescendants();
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.findAllAutoAdaptHostsInScene.<anonymous>' call
      if (!contains(myHierarchy, element)) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.findAllAutoAdaptHostsInScene.<anonymous>' call
      var autoAdaptHostComponent = element_0.__getComponentForKotlin(127);
      var tmp;
      if (!(autoAdaptHostComponent == null)) {
        tmp = new EntityWithSensorZone(element_0, autoAdaptHostComponent.hostZone);
      } else {
        tmp = null;
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.q(tmp0_safe_receiver);
      }
    }
    return copyToArray(destination_0);
  };
  protoOf(AutoAdaptUtils).getAutoAdaptVariants = function (entity) {
    return get_variantEntities(entity);
  };
  protoOf(AutoAdaptUtils).isAutoAdapted = function (entity) {
    return get_hasAutoAdapted(entity);
  };
  protoOf(AutoAdaptUtils).getAutoAdaptOriginalEntity = function (entity) {
    return get_autoAdaptOriginalEntity(entity);
  };
  protoOf(AutoAdaptUtils).t2z = function (guest, host, snapSettings) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_variantEntities(guest);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.getAutoAdaptSnapCandidates.<anonymous>' call
      TransformUtils_instance.setWorldTransform(element, get_worldTransform(guest));
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = get_variantEntities(guest);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = AutoAdaptUtils$getAutoAdaptSnapCandidates$lambda(guest);
    var tmp$ret$0 = new sam$kotlin_Comparator$0_2(tmp);
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_1 = sortedWith_0(this_0, tmp$ret$0);
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_1.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.getAutoAdaptSnapCandidates.<anonymous>' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_2 = SnapUtils_instance.matchingSnapCandidatesOnHost(element_0, host, snapSettings);
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator_0 = this_2.t();
      while (tmp0_iterator_0.u()) {
        var element_1 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.getAutoAdaptSnapCandidates.<anonymous>.<anonymous>' call
        if (!element_1.isAlignmentSnap) {
          destination_0.q(element_1);
        }
      }
      var list = destination_0;
      addAll_0(destination, list);
    }
    var candidates = copyToArray(destination);
    return candidates;
  };
  protoOf(AutoAdaptUtils).getAutoAdaptSnapCandidates = function (guest, host, snapSettings, $super) {
    snapSettings = snapSettings === VOID ? this.s2z_1 : snapSettings;
    return this.t2z(guest, host, snapSettings);
  };
  protoOf(AutoAdaptUtils).u2z = function (guest, hierarchyRoot, snapSettings) {
    var originalTransform = get_worldTransform(guest);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = get_variantEntities(guest);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.getAutoAdaptCandidatesInHierarchy.<anonymous>' call
      TransformUtils_instance.setWorldTransform(element, originalTransform);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_1 = get_hierarchy(hierarchyRoot);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.AutoAdaptUtils.getAutoAdaptCandidatesInHierarchy.<anonymous>.<anonymous>' call
        var list = SnapUtils_instance.matchingSnapCandidatesOnHost(element, element_0, snapSettings);
        addAll_0(destination_0, list);
      }
      var c = copyToArray(destination_0);
      SnapUtils_instance.replaceAlignmentSnapsWithRealSnapsWherePossible(c);
      var list_0 = toList(c);
      addAll_0(destination, list_0);
    }
    var candidatesIncludingAlignments = copyToArray(destination);
    return candidatesIncludingAlignments;
  };
  protoOf(AutoAdaptUtils).getAutoAdaptCandidatesInHierarchy = function (guest, hierarchyRoot, snapSettings, $super) {
    snapSettings = snapSettings === VOID ? this.r2z_1 : snapSettings;
    return this.u2z(guest, hierarchyRoot, snapSettings);
  };
  var AutoAdaptUtils_instance;
  function AutoAdaptUtils_getInstance() {
    if (AutoAdaptUtils_instance == null)
      new AutoAdaptUtils();
    return AutoAdaptUtils_instance;
  }
  function get_variantEntities(_this__u8e3s4) {
    if (!_this__u8e3s4.hasComponent(126)) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      return [_this__u8e3s4];
    }
    _this__u8e3s4.addComponent(new AutoAdaptSessionComponent());
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(128);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v2z_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [_this__u8e3s4];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function get_hasAutoAdapted(_this__u8e3s4) {
    return !(get_autoAdaptOriginalEntity(_this__u8e3s4) == null) ? !equals(get_autoAdaptOriginalEntity(_this__u8e3s4), _this__u8e3s4) : false;
  }
  function get_autoAdaptOriginalEntity(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(129);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.originalEntity;
  }
  function get_variants(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(126);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.variants;
  }
  function Companion_9() {
    this.w2z_1 = 132;
  }
  var Companion_instance_42;
  function Companion_getInstance_18() {
    return Companion_instance_42;
  }
  function AutoAdaptChildFailedEventComponent() {
    this.x2z_1 = 132;
  }
  protoOf(AutoAdaptChildFailedEventComponent).x1k = function () {
    return this.x2z_1;
  };
  protoOf(AutoAdaptChildFailedEventComponent).eq = function (other) {
    return false;
  };
  function sam$kotlin_Comparator$0_3(function_0) {
    this.y2z_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_3).u1j = function (a, b) {
    return this.y2z_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function AutoAdaptChildrenSystem$PreferSameConnectorsStrategy$sortAndSelect$lambda(this$0) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.PreferSameConnectorsStrategy.sortAndSelect.<anonymous>' call
      var tmp = b.guestConnector.key === this$0.z2z_1.guestConnector;
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.PreferSameConnectorsStrategy.sortAndSelect.<anonymous>' call
      var tmp$ret$1 = a.guestConnector.key === this$0.z2z_1.guestConnector;
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function AutoAdaptChildrenSystem$PreferSameConnectorsStrategy$sortAndSelect$lambda_0(this$0) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.PreferSameConnectorsStrategy.sortAndSelect.<anonymous>' call
      var tmp = b.hostConnector.key === this$0.z2z_1.hostConnector;
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.PreferSameConnectorsStrategy.sortAndSelect.<anonymous>' call
      var tmp$ret$1 = a.hostConnector.key === this$0.z2z_1.hostConnector;
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function onPostSnapAutoAdaptVariant($this, entity) {
    var tmp0_elvis_lhs = get_connectionRootEntity(entity);
    var root = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    if (!get_hasAutoAdapted(root))
      return Unit_instance;
    var tmp1_safe_receiver = get_autoAdaptOriginalEntity(root);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.onPostSnapAutoAdaptVariant.<anonymous>' call
      tmp = getChildrenToResnap($this, tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var childrenToResnap = tmp_0;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = childrenToResnap.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.onPostSnapAutoAdaptVariant.<anonymous>' call
      reSnap($this, element, root);
    }
  }
  function reSnap($this, childInfo, host) {
    var tmp0_elvis_lhs = $this.coreServices.entityManager.findEntity(childInfo.originalEntityId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Could not find entity any more';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var originalChildEntity = tmp;
    var tmp_0 = Companion_getInstance_19().l30_1;
    tmp_0.debug(AutoAdaptChildrenSystem$reSnap$lambda(originalChildEntity, host));
    var assemblyEntities = HierarchyUtils_instance.getAssemblyEntities(host);
    var tmp1_safe_receiver = childInfo.hostPartKey;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.reSnap.<anonymous>' call
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = assemblyEntities.length;
        while (inductionVariable < last) {
          var element = assemblyEntities[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.reSnap.<anonymous>.<anonymous>' call
          if (get_partKey(element) === tmp1_safe_receiver) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp_1 = tmp$ret$1;
    }
    var tmp2_elvis_lhs = tmp_1;
    var realHost = tmp2_elvis_lhs == null ? host : tmp2_elvis_lhs;
    originalChildEntity.addComponent(new AutoAdaptSessionComponent());
    var preferredGuest = getPreferredGuestVariant($this, originalChildEntity);
    var candidates = AutoAdaptUtils_getInstance().getAutoAdaptSnapCandidates(preferredGuest, realHost, new SnapSettings(true));
    var sortedCandidates = (new PreferSameConnectorsStrategy(childInfo)).sortAndSelect(candidates);
    var result = $this.coreServices.validations.getFirstValidSnapAction(sortedCandidates, false);
    var validCandidate = result.snapActionCandidate;
    if (!(validCandidate == null)) {
      validCandidate.createAction().perform();
      var tmp_2 = Companion_getInstance_19().l30_1;
      tmp_2.debug(AutoAdaptChildrenSystem$reSnap$lambda_0(validCandidate));
    } else {
      var tmp_3 = Companion_getInstance_19().l30_1;
      tmp_3.debug(AutoAdaptChildrenSystem$reSnap$lambda_1(result));
      originalChildEntity.addComponent(new AutoAdaptChildFailedEventComponent());
      originalChildEntity.removeComponent(125);
      Companion_getInstance_1();
      originalChildEntity.removeComponent(104);
      originalChildEntity.removeComponent(132);
    }
  }
  function getPreferredGuestVariant($this, originalEntity) {
    var forceAutoAdapt = originalEntity.hasComponent(130);
    // Inline function 'kotlin.takeIf' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getPreferredGuestVariant.<anonymous>' call
    if (forceAutoAdapt) {
      tmp = forceAutoAdapt;
    } else {
      tmp = null;
    }
    var tmp_0;
    if (tmp == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getPreferredGuestVariant.<anonymous>' call
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var indexedObject = get_variantEntities(originalEntity);
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getPreferredGuestVariant.<anonymous>.<anonymous>' call
          var tmp_1 = get_productRef(element);
          var tmp0_safe_receiver = get_variants(originalEntity);
          if (tmp_1 == (tmp0_safe_receiver == null ? null : first(tmp0_safe_receiver))) {
            tmp$ret$3 = element;
            break $l$block;
          }
        }
        tmp$ret$3 = null;
      }
      var tmp0_elvis_lhs = tmp$ret$3;
      tmp_0 = tmp0_elvis_lhs == null ? originalEntity : tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var guest = tmp1_elvis_lhs == null ? originalEntity : tmp1_elvis_lhs;
    return guest;
  }
  function getChildrenToResnap($this, entity) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_immediateConnectionRootDescendants(entity);
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getChildrenToResnap.<anonymous>' call
      if (!get_isPropping(element)) {
        destination.q(element);
      }
    }
    var children = destination;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = children.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.autoadapt.autoadaptchildren.AutoAdaptChildrenSystem.getChildrenToResnap.<anonymous>' call
      var tmp0_safe_receiver = createChildInfo($this, element_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.q(tmp0_safe_receiver);
      }
    }
    return destination_0;
  }
  function createChildInfo($this, entity) {
    var tmp0_safe_receiver = get_highestPriorityConnection(entity);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var partKey = get_partKey(tmp0_safe_receiver.hostConnectorEntity);
      return new ChildInfo(entity.id, tmp0_safe_receiver.guestConnector.key, tmp0_safe_receiver.hostConnector.key, partKey, getChildrenToResnap($this, entity));
    }
    return null;
  }
  function ChildInfo(originalEntityId, guestConnector, hostConnector, hostPartKey, childrenToResnap) {
    this.originalEntityId = originalEntityId;
    this.guestConnector = guestConnector;
    this.hostConnector = hostConnector;
    this.hostPartKey = hostPartKey;
    this.childrenToResnap = childrenToResnap;
  }
  protoOf(ChildInfo).m30 = function () {
    return this.originalEntityId;
  };
  protoOf(ChildInfo).p1v = function () {
    return this.guestConnector;
  };
  protoOf(ChildInfo).r1v = function () {
    return this.hostConnector;
  };
  protoOf(ChildInfo).n30 = function () {
    return this.hostPartKey;
  };
  protoOf(ChildInfo).o30 = function () {
    return this.childrenToResnap;
  };
  protoOf(ChildInfo).af = function () {
    return this.originalEntityId;
  };
  protoOf(ChildInfo).bf = function () {
    return this.guestConnector;
  };
  protoOf(ChildInfo).g1k = function () {
    return this.hostConnector;
  };
  protoOf(ChildInfo).h1k = function () {
    return this.hostPartKey;
  };
  protoOf(ChildInfo).i1k = function () {
    return this.childrenToResnap;
  };
  protoOf(ChildInfo).p30 = function (originalEntityId, guestConnector, hostConnector, hostPartKey, childrenToResnap) {
    return new ChildInfo(originalEntityId, guestConnector, hostConnector, hostPartKey, childrenToResnap);
  };
  protoOf(ChildInfo).copy = function (originalEntityId, guestConnector, hostConnector, hostPartKey, childrenToResnap, $super) {
    originalEntityId = originalEntityId === VOID ? this.originalEntityId : originalEntityId;
    guestConnector = guestConnector === VOID ? this.guestConnector : guestConnector;
    hostConnector = hostConnector === VOID ? this.hostConnector : hostConnector;
    hostPartKey = hostPartKey === VOID ? this.hostPartKey : hostPartKey;
    childrenToResnap = childrenToResnap === VOID ? this.childrenToResnap : childrenToResnap;
    return this.p30(originalEntityId, guestConnector, hostConnector, hostPartKey, childrenToResnap);
  };
  protoOf(ChildInfo).toString = function () {
    return 'ChildInfo(originalEntityId=' + this.originalEntityId + ', guestConnector=' + this.guestConnector + ', hostConnector=' + this.hostConnector + ', hostPartKey=' + this.hostPartKey + ', childrenToResnap=' + this.childrenToResnap + ')';
  };
  protoOf(ChildInfo).hashCode = function () {
    var result = this.originalEntityId;
    result = imul(result, 31) + getStringHashCode(this.guestConnector) | 0;
    result = imul(result, 31) + getStringHashCode(this.hostConnector) | 0;
    result = imul(result, 31) + (this.hostPartKey == null ? 0 : getStringHashCode(this.hostPartKey)) | 0;
    result = imul(result, 31) + hashCode(this.childrenToResnap) | 0;
    return result;
  };
  protoOf(ChildInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ChildInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ChildInfo ? other : THROW_CCE();
    if (!(this.originalEntityId === tmp0_other_with_cast.originalEntityId))
      return false;
    if (!(this.guestConnector === tmp0_other_with_cast.guestConnector))
      return false;
    if (!(this.hostConnector === tmp0_other_with_cast.hostConnector))
      return false;
    if (!(this.hostPartKey == tmp0_other_with_cast.hostPartKey))
      return false;
    if (!equals(this.childrenToResnap, tmp0_other_with_cast.childrenToResnap))
      return false;
    return true;
  };
  function PreferSameConnectorsStrategy(childInfo) {
    this.z2z_1 = childInfo;
  }
  protoOf(PreferSameConnectorsStrategy).sortAndSelect = function (snaps) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = AutoAdaptChildrenSystem$PreferSameConnectorsStrategy$sortAndSelect$lambda(this);
    var tmp$ret$0 = new sam$kotlin_Comparator$0_3(tmp);
    var this_0 = sortedWith_0(snaps, tmp$ret$0);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_0 = AutoAdaptChildrenSystem$PreferSameConnectorsStrategy$sortAndSelect$lambda_0(this);
    var tmp$ret$2 = new sam$kotlin_Comparator$0_3(tmp_0);
    var this_1 = sortedWith(this_0, tmp$ret$2);
    return copyToArray(this_1);
  };
  function Companion_10() {
    Companion_instance_43 = this;
    this.ID = 'AutoAdaptChildrenSystem';
    this.l30_1 = LoggerState_getInstance().m1m('AutoAdaptChildrenSystem');
  }
  protoOf(Companion_10).u1n = function () {
    return this.ID;
  };
  var Companion_instance_43;
  function Companion_getInstance_19() {
    if (Companion_instance_43 == null)
      new Companion_10();
    return Companion_instance_43;
  }
  function AutoAdaptChildrenSystem$reSnap$lambda($originalChildEntity, $host) {
    return function () {
      return 'AutoAdaptChildrenSystem Re-snapping ' + get_displayName($originalChildEntity) + ' to ' + get_displayName($host);
    };
  }
  function AutoAdaptChildrenSystem$reSnap$lambda_0($validCandidate) {
    return function () {
      var tmp = 'AutoAdaptChildrenSystem successfully snapped ' + get_displayName($validCandidate.guest) + ' to ';
      var tmp0_safe_receiver = get_parent($validCandidate.guest);
      return tmp + (tmp0_safe_receiver == null ? null : get_displayName(tmp0_safe_receiver));
    };
  }
  function AutoAdaptChildrenSystem$reSnap$lambda_1($result) {
    return function () {
      return 'AutoAdaptChildrenSystem Could not re-snap: ' + $result;
    };
  }
  function AutoAdaptChildrenSystem(coreServices) {
    Companion_getInstance_19();
    Companion_getInstance_1();
    SystemBase.call(this, 'AutoAdaptChildrenSystem', 104);
    this.coreServices = coreServices;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    Companion_getInstance_1();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i30_1 = [104];
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    Companion_getInstance_0();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.j30_1 = ['ConnectionParentingSystem', 'UpdateHostConnectionsSystem'];
    var tmp_1 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1.k30_1 = ['CleanCacheOnFinishedAutoAdaptSystem'];
  }
  protoOf(AutoAdaptChildrenSystem).k2z = function () {
    return this.coreServices;
  };
  protoOf(AutoAdaptChildrenSystem).w1o = function () {
    return this.i30_1;
  };
  protoOf(AutoAdaptChildrenSystem).x1o = function () {
    return this.j30_1;
  };
  protoOf(AutoAdaptChildrenSystem).y1o = function () {
    return this.k30_1;
  };
  protoOf(AutoAdaptChildrenSystem).onAddComponent = function (entity, newComponent) {
    onPostSnapAutoAdaptVariant(this, entity);
  };
  function Companion_11() {
    Companion_instance_44 = this;
    this.q30_1 = 'AutoAdaptDisposeFailedChildrenSystem';
    this.r30_1 = LoggerState_getInstance().m1m('AutoAdaptDisposeFailedChildrenSystem');
  }
  var Companion_instance_44;
  function Companion_getInstance_20() {
    if (Companion_instance_44 == null)
      new Companion_11();
    return Companion_instance_44;
  }
  function AutoAdaptDisposeFailedChildrenSystem$onRemoveComponent$lambda($entity) {
    return function () {
      return 'AutoAdaptDisposeFailedChildrenSystem Disposing entity ' + get_displayName($entity) + ' because auto adapt failed';
    };
  }
  function AutoAdaptDisposeFailedChildrenSystem() {
    Companion_getInstance_20();
    SystemBase.call(this, 'AutoAdaptDisposeFailedChildrenSystem', 132);
  }
  protoOf(AutoAdaptDisposeFailedChildrenSystem).onRemoveComponent = function (entity, oldComponent) {
    if (entity.isDisposed)
      return Unit_instance;
    var tmp = Companion_getInstance_20().r30_1;
    tmp.debug(AutoAdaptDisposeFailedChildrenSystem$onRemoveComponent$lambda(entity));
    entity.dispose();
  };
  function Companion_12() {
    this.s30_1 = 'AutoAdaptCacheSystem';
  }
  var Companion_instance_45;
  function Companion_getInstance_21() {
    return Companion_instance_45;
  }
  function AutoAdaptCacheSystem(productManager) {
    SystemBase.call(this, 'AutoAdaptCacheSystem', 125);
    this.b31_1 = productManager;
  }
  protoOf(AutoAdaptCacheSystem).onAddComponent = function (entity, newComponent) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(126);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.variants;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var variantProductRefs = tmp;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(variantProductRefs.length);
    var inductionVariable = 0;
    var last = variantProductRefs.length;
    while (inductionVariable < last) {
      var item = variantProductRefs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'com.ikea.core.stl.autoadapt.cache.AutoAdaptCacheSystem.onAddComponent.<anonymous>' call
        if (item === get_productRef(entity)) {
          tmp$ret$0 = entity;
          break $l$block_0;
        }
        var tmp0_elvis_lhs = this.b31_1.createEntity(item);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$0 = null;
          break $l$block_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var variantEntity = tmp_0;
        variantEntity.addComponentInternal(newComponent);
        variantEntity.addComponent(new AutoAdaptVariantComponent(entity));
        tmp$ret$0 = variantEntity;
      }
      destination.q(tmp$ret$0);
    }
    var this_0 = filterNotNull(destination);
    var variants = copyToArray(this_0);
    var tmp_1;
    if (contains(variants, entity)) {
      tmp_1 = variants;
    } else {
      // Inline function 'kotlin.collections.plus' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$7 = [entity];
      tmp_1 = variants.concat(tmp$ret$7);
    }
    var actualVariants = tmp_1;
    var cachedVariantsComponent = new AutoAdaptCachedVariantsComponent(actualVariants);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = variants.length;
    while (inductionVariable_0 < last_0) {
      var element = variants[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.cache.AutoAdaptCacheSystem.onAddComponent.<anonymous>' call
      element.addComponent(cachedVariantsComponent);
    }
  };
  protoOf(AutoAdaptCacheSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    this.onRemoveComponent(entity, oldComponent);
    this.onAddComponent(entity, newComponent);
  };
  protoOf(AutoAdaptCacheSystem).onRemoveComponent = function (entity, oldComponent) {
    var cache = entity.__getComponentForKotlin(128);
    var tmp1_safe_receiver = cache == null ? null : cache.v2z_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.cache.AutoAdaptCacheSystem.onRemoveComponent.<anonymous>' call
        element.removeComponentInternal(125);
        element.removeComponent(129);
        element.removeComponent(128);
        if (!element.equals(entity)) {
          element.dispose();
        }
      }
    }
    entity.removeComponent(129);
  };
  function Companion_13() {
    this.c31_1 = 128;
  }
  var Companion_instance_46;
  function Companion_getInstance_22() {
    return Companion_instance_46;
  }
  function AutoAdaptCachedVariantsComponent(variants) {
    this.v2z_1 = variants;
  }
  protoOf(AutoAdaptCachedVariantsComponent).x1k = function () {
    return 128;
  };
  protoOf(AutoAdaptCachedVariantsComponent).eq = function (other) {
    var otherC = other instanceof AutoAdaptCachedVariantsComponent ? other : THROW_CCE();
    var tmp;
    if (otherC.v2z_1.length === this.v2z_1.length) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.all' call
        var indexedObject = otherC.v2z_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.autoadapt.cache.AutoAdaptCachedVariantsComponent.eq.<anonymous>' call
          if (!contains(this.v2z_1, element)) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Companion_14() {
    this.d31_1 = 125;
  }
  var Companion_instance_47;
  function Companion_getInstance_23() {
    return Companion_instance_47;
  }
  function AutoAdaptSessionComponent() {
  }
  protoOf(AutoAdaptSessionComponent).x1k = function () {
    return 125;
  };
  protoOf(AutoAdaptSessionComponent).eq = function (other) {
    return true;
  };
  function Companion_15() {
    this.e31_1 = 'CleanCacheOnFinishedAutoAdaptSystem';
  }
  var Companion_instance_48;
  function Companion_getInstance_24() {
    return Companion_instance_48;
  }
  function CleanCacheOnFinishedAutoAdaptSystem() {
    Companion_getInstance_1();
    SystemBase2.call(this, 'CleanCacheOnFinishedAutoAdaptSystem', 104, 66);
  }
  protoOf(CleanCacheOnFinishedAutoAdaptSystem).onAddComponent = function (entity, newComponent) {
    if (!entity.hasComponent(125))
      return Unit_instance;
    var original = get_autoAdaptOriginalEntity(entity);
    if (!(original == null) ? get_hasAutoAdapted(entity) : false) {
      ConnectionUtils_instance.disconnect(original);
    }
    entity.removeComponent(125);
  };
  protoOf(CleanCacheOnFinishedAutoAdaptSystem).onRemoveComponent2 = function (entity, oldComponent) {
    oldComponent.entity.removeComponent(125);
  };
  function Companion_16() {
    this.id = 126;
  }
  protoOf(Companion_16).s1k = function () {
    return this.id;
  };
  var Companion_instance_49;
  function Companion_getInstance_25() {
    return Companion_instance_49;
  }
  function AutoAdaptGuestComponent(variants, groupName) {
    groupName = groupName === VOID ? 'auto adapt group' : groupName;
    this.groupName = groupName;
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = distinct_0(variants);
    tmp.variants = copyToArray(this_0);
  }
  protoOf(AutoAdaptGuestComponent).f31 = function () {
    return this.groupName;
  };
  protoOf(AutoAdaptGuestComponent).g31 = function () {
    return this.variants;
  };
  protoOf(AutoAdaptGuestComponent).x1k = function () {
    return 126;
  };
  protoOf(AutoAdaptGuestComponent).eq = function (other) {
    var otherC = other instanceof AutoAdaptGuestComponent ? other : THROW_CCE();
    var tmp;
    if (other.groupName === this.groupName ? otherC.variants.length === this.variants.length : false) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.all' call
        var indexedObject = otherC.variants;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.autoadapt.component.AutoAdaptGuestComponent.eq.<anonymous>' call
          if (!contains(this.variants, element)) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Companion_17() {
    this.id = 127;
  }
  protoOf(Companion_17).s1k = function () {
    return this.id;
  };
  var Companion_instance_50;
  function Companion_getInstance_26() {
    return Companion_instance_50;
  }
  function AutoAdaptHostComponent(hostZone) {
    this.hostZone = hostZone;
  }
  protoOf(AutoAdaptHostComponent).h31 = function () {
    return this.hostZone;
  };
  protoOf(AutoAdaptHostComponent).x1k = function () {
    return 127;
  };
  protoOf(AutoAdaptHostComponent).eq = function (other) {
    return equals((other instanceof AutoAdaptHostComponent ? other : THROW_CCE()).hostZone, this.hostZone);
  };
  function Companion_18() {
    this.id = 133;
  }
  protoOf(Companion_18).s1k = function () {
    return this.id;
  };
  var Companion_instance_51;
  function Companion_getInstance_27() {
    return Companion_instance_51;
  }
  function AutoAdaptProductSpecificationsComponent(specifications) {
    this.specifications = specifications;
    this.i31_1 = 133;
  }
  protoOf(AutoAdaptProductSpecificationsComponent).j31 = function () {
    return this.specifications;
  };
  protoOf(AutoAdaptProductSpecificationsComponent).x1k = function () {
    return this.i31_1;
  };
  protoOf(AutoAdaptProductSpecificationsComponent).eq = function (other) {
    return this.equals(other);
  };
  protoOf(AutoAdaptProductSpecificationsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof AutoAdaptProductSpecificationsComponent))
      THROW_CCE();
    if (!contentEquals(this.specifications, other.specifications))
      return false;
    if (!(this.i31_1 === other.i31_1))
      return false;
    return true;
  };
  protoOf(AutoAdaptProductSpecificationsComponent).hashCode = function () {
    var result = contentHashCode(this.specifications);
    result = imul(31, result) + this.i31_1 | 0;
    return result;
  };
  protoOf(AutoAdaptProductSpecificationsComponent).af = function () {
    return this.specifications;
  };
  protoOf(AutoAdaptProductSpecificationsComponent).k31 = function (specifications) {
    return new AutoAdaptProductSpecificationsComponent(specifications);
  };
  protoOf(AutoAdaptProductSpecificationsComponent).copy = function (specifications, $super) {
    specifications = specifications === VOID ? this.specifications : specifications;
    return this.k31(specifications);
  };
  protoOf(AutoAdaptProductSpecificationsComponent).toString = function () {
    return 'AutoAdaptProductSpecificationsComponent(specifications=' + toString(this.specifications) + ')';
  };
  function SpecificationPair(productRef, specification) {
    this.productRef = productRef;
    this.specification = specification;
  }
  protoOf(SpecificationPair).j1l = function () {
    return this.productRef;
  };
  protoOf(SpecificationPair).l31 = function () {
    return this.specification;
  };
  protoOf(SpecificationPair).af = function () {
    return this.productRef;
  };
  protoOf(SpecificationPair).bf = function () {
    return this.specification;
  };
  protoOf(SpecificationPair).m31 = function (productRef, specification) {
    return new SpecificationPair(productRef, specification);
  };
  protoOf(SpecificationPair).copy = function (productRef, specification, $super) {
    productRef = productRef === VOID ? this.productRef : productRef;
    specification = specification === VOID ? this.specification : specification;
    return this.m31(productRef, specification);
  };
  protoOf(SpecificationPair).toString = function () {
    return 'SpecificationPair(productRef=' + this.productRef + ', specification=' + this.specification + ')';
  };
  protoOf(SpecificationPair).hashCode = function () {
    var result = getStringHashCode(this.productRef);
    result = imul(result, 31) + this.specification.hashCode() | 0;
    return result;
  };
  protoOf(SpecificationPair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SpecificationPair))
      return false;
    var tmp0_other_with_cast = other instanceof SpecificationPair ? other : THROW_CCE();
    if (!(this.productRef === tmp0_other_with_cast.productRef))
      return false;
    if (!this.specification.equals(tmp0_other_with_cast.specification))
      return false;
    return true;
  };
  function Companion_19() {
    this.id = 129;
  }
  protoOf(Companion_19).s1k = function () {
    return this.id;
  };
  var Companion_instance_52;
  function Companion_getInstance_28() {
    return Companion_instance_52;
  }
  function AutoAdaptVariantComponent(originalEntity) {
    this.originalEntity = originalEntity;
  }
  protoOf(AutoAdaptVariantComponent).n31 = function () {
    return this.originalEntity;
  };
  protoOf(AutoAdaptVariantComponent).x1k = function () {
    return 129;
  };
  protoOf(AutoAdaptVariantComponent).eq = function (other) {
    return (other instanceof AutoAdaptVariantComponent ? other : THROW_CCE()).originalEntity.equals(this.originalEntity);
  };
  function Companion_20() {
    this.id = 130;
  }
  protoOf(Companion_20).s1k = function () {
    return this.id;
  };
  var Companion_instance_53;
  function Companion_getInstance_29() {
    return Companion_instance_53;
  }
  function ForceAutoAdaptWhenParentIsDraggedComponent() {
  }
  protoOf(ForceAutoAdaptWhenParentIsDraggedComponent).x1k = function () {
    return 130;
  };
  protoOf(ForceAutoAdaptWhenParentIsDraggedComponent).eq = function (other) {
    return true;
  };
  function Companion_21() {
    this.id = 131;
  }
  protoOf(Companion_21).s1k = function () {
    return this.id;
  };
  var Companion_instance_54;
  function Companion_getInstance_30() {
    return Companion_instance_54;
  }
  function ReplacedWithAutoAdaptEventComponent(oldEntity) {
    this.oldEntity = oldEntity;
    this.h2z_1 = 131;
  }
  protoOf(ReplacedWithAutoAdaptEventComponent).y1l = function () {
    return this.oldEntity;
  };
  protoOf(ReplacedWithAutoAdaptEventComponent).x1k = function () {
    return this.h2z_1;
  };
  protoOf(ReplacedWithAutoAdaptEventComponent).eq = function (other) {
    if (!(other instanceof ReplacedWithAutoAdaptEventComponent))
      return false;
    return other.oldEntity.equals(this.oldEntity);
  };
  function snapOrAutoAdapt($this, draggedRoot) {
    var tmp0_elvis_lhs = AutoAdaptUtils_getInstance().findClosestAutoAdaptHost($this.coreServices.sceneManager.scene, draggedRoot, get_worldPosition(draggedRoot));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var hoveredHost = tmp;
    var oldParent = get_parent(draggedRoot);
    var candidates = AutoAdaptUtils_getInstance().getAutoAdaptSnapCandidates(draggedRoot, hoveredHost);
    var sortedCandidates = sortAndSelect($this, candidates);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = sortedCandidates.length;
    while (inductionVariable < last) {
      var element = sortedCandidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.autoadapt.drag.AutoAdaptDragStrategy.snapOrAutoAdapt.<anonymous>' call
      if (!element.guestRoot.equals(draggedRoot)) {
        setParent(draggedRoot, null);
      }
      var result = $this.coreServices.validations.evaluateSnapCandidate(element, true);
      if (result.valid) {
        if (draggedRoot.equals(element.guestRoot)) {
          setParent(draggedRoot, oldParent);
        } else {
          loadModelOfValidVariant($this, element.guestRoot);
          updateDraggedComponents($this, draggedRoot, element.guestRoot);
          setParent(element.guestRoot, $this.coreServices.sceneManager.scene);
          element.perform();
        }
        return new ValidAutoAdaptDragStrategyResult(element.guestRoot, element, result.warnings);
      }
    }
    setParent(draggedRoot, oldParent);
    return null;
  }
  function sortAndSelect($this, candidates) {
    var sortedCandidates = $this.s31_1.sortCandidates(candidates);
    if (any_0(sortedCandidates))
      return sortedCandidates;
    return $this.t31_1.sortCandidates(candidates);
  }
  function updateDraggedComponents($this, draggedRootEntity, foundEntityVariant) {
    draggedRootEntity.removeComponent(IsDraggedComponent_instance.id);
    foundEntityVariant.addComponent(IsDraggedComponent_instance);
    resumeViewerUpdatesOnDraggedEntity($this.coreServices.sceneManager);
    $this.coreServices.sceneManager.scene.addComponent(new SomethingIsDraggedComponent(foundEntityVariant));
    pauseViewerUpdatesOnDraggedEntity($this.coreServices.sceneManager);
  }
  function loadModelOfValidVariant($this, entity) {
    var tmp0_safe_receiver = $this.coreServices.coreModules.viewer();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.autoadapt.drag.AutoAdaptDragStrategy.loadModelOfValidVariant.<anonymous>' call
      if (!entity.hasComponent(20)) {
        ModelUtils_getInstance().loadModelFromModelInfo(entity, tmp0_safe_receiver);
      }
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = get_children(entity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.drag.AutoAdaptDragStrategy.loadModelOfValidVariant.<anonymous>.<anonymous>' call
        loadModelOfValidVariant($this, element);
      }
    }
  }
  function AutoAdaptDragStrategy(coreServices) {
    AbstractDragStrategy.call(this);
    this.p31_1 = coreServices;
    this.q31_1 = 'AutoAdaptDragStrategy';
    this.r31_1 = null;
    this.s31_1 = (new SnapSorterBuilder()).addInActivationDistanceFilter().addOriginalVariantCriterion().addConnectorPriorityCriterion(Companion_getInstance_69().onlyInActivationDistance).addDistanceCriterion().build();
    this.t31_1 = (new SnapSorterBuilder()).addConnectorPriorityCriterion(Companion_getInstance_69().all).addDistanceCriterion().build();
  }
  protoOf(AutoAdaptDragStrategy).k2z = function () {
    return this.p31_1;
  };
  protoOf(AutoAdaptDragStrategy).mb = function () {
    return this.q31_1;
  };
  protoOf(AutoAdaptDragStrategy).dragStart = function (draggedRootEntity) {
    var tmp0_elvis_lhs = get_variants(draggedRootEntity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var variants = tmp;
    // Inline function 'kotlin.collections.isEmpty' call
    if (variants.length === 0)
      return Unit_instance;
    this.r31_1 = draggedRootEntity.id;
    draggedRootEntity.addComponent(new AutoAdaptSessionComponent());
  };
  protoOf(AutoAdaptDragStrategy).dragMove = function (dragState) {
    var variants = get_variants(dragState.draggedRootEntity);
    if (variants == null)
      return null;
    // Inline function 'kotlin.collections.isEmpty' call
    if (variants.length === 0)
      return null;
    return snapOrAutoAdapt(this, dragState.draggedRootEntity);
  };
  function connectorsFromSpecifications($this, variants) {
    var tmp = asSequence_0(variants);
    return map(tmp, DragSurfaceCanHostWithAutoAdaptSelector$connectorsFromSpecifications$lambda);
  }
  function Companion_22() {
    Companion_instance_55 = this;
    this.logger = LoggerState_getInstance().m1m('DragSurfaceCanHostWithAutoAdaptSelector');
  }
  protoOf(Companion_22).x1i = function () {
    return this.logger;
  };
  var Companion_instance_55;
  function Companion_getInstance_31() {
    if (Companion_instance_55 == null)
      new Companion_22();
    return Companion_instance_55;
  }
  function DragSurfaceCanHostWithAutoAdaptSelector$lambda() {
    return "System with id '" + 'AutoAdaptProductSpecificationSystem' + "' not enabled which is " + 'required for this system to work. Did you forget to run ' + "'new AutoAdaptProductSpecificationsSystem(entityManager, productManager)'";
  }
  function DragSurfaceCanHostWithAutoAdaptSelector$canProjectDragOn$lambda(snappingGuest) {
    var tmp0_safe_receiver = get_connectorsComponent(snappingGuest);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function DragSurfaceCanHostWithAutoAdaptSelector$connectorsFromSpecifications$lambda(specificationPair) {
    Companion_getInstance_2();
    var tmp0_safe_receiver = specificationPair.specification._findComponentKt(11);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function DragSurfaceCanHostWithAutoAdaptSelector(entityManager) {
    Companion_getInstance_31();
    DragSurfaceCanHostSelector.call(this);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = entityManager.getSystemsRegistered();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.autoadapt.drag.DragSurfaceCanHostWithAutoAdaptSelector.<anonymous>' call
        var tmp = element.id;
        if (tmp === 'AutoAdaptProductSpecificationSystem') {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    var requiredSystemEnabled = tmp$ret$1;
    if (!requiredSystemEnabled) {
      var tmp_0 = Companion_getInstance_31().logger;
      tmp_0.warn(DragSurfaceCanHostWithAutoAdaptSelector$lambda);
    }
  }
  protoOf(DragSurfaceCanHostWithAutoAdaptSelector).canProjectDragOn = function (draggedEntity, dragSurface) {
    var tmp0_safe_receiver = get_connectorsComponent(dragSurface.entity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectors;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var hostConnectors = tmp;
    var tmp_0 = get_snappingGuestEntitiesSequence(draggedEntity);
    var childSequence = map(tmp_0, DragSurfaceCanHostWithAutoAdaptSelector$canProjectDragOn$lambda);
    var tmp2_safe_receiver = draggedEntity.__getComponentForKotlin(133);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.specifications;
    var tmp_1;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    var variants = tmp_1;
    var variantConnectorsSequence = connectorsFromSpecifications(this, variants);
    return this.hasMatchingConnector(plus(childSequence, variantConnectorsSequence), hostConnectors, dragSurface.connectorKeys);
  };
  function ValidAutoAdaptDragStrategyResult(entity, snapCandidate, warnings) {
    ValidDragStrategyResult.call(this, entity, snapCandidate, warnings);
  }
  protoOf(ValidAutoAdaptDragStrategyResult).performFinalSnapAction = function (state, coreServices) {
    var tmp0_elvis_lhs = get_snapRoot(state.originalDraggableRoot);
    var originalEntity = tmp0_elvis_lhs == null ? state.originalDraggableRoot : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = get_snapRoot(state.draggedRootEntity);
    var snappedEntity = tmp1_elvis_lhs == null ? state.draggedRootEntity : tmp1_elvis_lhs;
    var hasEntityChange = !originalEntity.equals(snappedEntity);
    if (hasEntityChange) {
      setParentMaintainWorldTransform(this.snapCandidate.guestRoot, null);
    }
    var snapActionCandidateFromStartDrag = this.snapCandidate.withInitialTransform(state.initialTransform);
    var hasTransformChange = !get_worldTransform(snapActionCandidateFromStartDrag.guest).equals(state.initialTransform);
    var tmp;
    if (hasEntityChange) {
      setParentMaintainWorldTransform(snappedEntity, null);
      TransformUtils_instance.setWorldTransform(originalEntity, state.initialTransform);
      this.snapCandidate.createAction().perform();
      tmp = true;
    } else if (hasTransformChange) {
      snapActionCandidateFromStartDrag.createAction().perform();
      tmp = true;
    } else {
      setParent(snappedEntity, state.originalParent);
      TransformUtils_instance.setWorldTransform(snappedEntity, state.initialTransform);
      var tmp2_safe_receiver = get_parent(snappedEntity);
      var oldParentComponent = tmp2_safe_receiver == null ? null : get_parentComponent(tmp2_safe_receiver);
      var tmp4_safe_receiver = oldParentComponent == null ? null : oldParentComponent.children;
      if ((tmp4_safe_receiver == null ? null : contains(tmp4_safe_receiver, snappedEntity)) === false) {
        var newParentComponent = oldParentComponent.addChild(snappedEntity);
        ensureNotNull(get_parent(snappedEntity)).addComponent(newParentComponent);
      }
      tmp = false;
    }
    return tmp;
  };
  function drawLines($this, entity, lines) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(lines.length);
    var inductionVariable = 0;
    var last = lines.length;
    while (inductionVariable < last) {
      var item = lines[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.debug.DebugLineDrawingSystem.drawLines.<anonymous>' call
      var tmp0_safe_receiver = $this.coreServices.coreModules.viewer();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createUiLine(item.start, item.end, item.color, item.thickness);
      var tmp;
      if (tmp1_elvis_lhs == null) {
        throw Exception_init_$Create$('Something went wrong when drawing debug lines in ' + $this.id + ', viewer returned a null line id.');
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var lineId = tmp;
      destination.q(lineId);
    }
    var lineIds = copyToArray(destination);
    entity.addComponent(new ViewerLineIdsComponent(lineIds));
  }
  function cleanLines($this, lineIds) {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = lineIds.length;
    while (inductionVariable < last) {
      var element = lineIds[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.debug.DebugLineDrawingSystem.cleanLines.<anonymous>' call
      var tmp0_safe_receiver = $this.coreServices.coreModules.viewer();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.removeUiLine(element);
      }
    }
  }
  function Companion_23() {
    Companion_instance_56 = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = LoggerState_getInstance().m1m('LineDrawingSystem');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.debug.Companion.logger.<anonymous>' call
    this_0.level = LogLevel_DEBUG_getInstance();
    tmp.g32_1 = this_0;
    this.ID = 'DebugLineDrawingSystem';
  }
  protoOf(Companion_23).u1n = function () {
    return this.ID;
  };
  var Companion_instance_56;
  function Companion_getInstance_32() {
    if (Companion_instance_56 == null)
      new Companion_23();
    return Companion_instance_56;
  }
  function DebugLineDrawingSystem$onAddComponent$lambda() {
    return 'Added debug line component to an entity that already has a ViewerLineIds component.';
  }
  function DebugLineDrawingSystem$onUpdateComponent$lambda(this$0) {
    return function () {
      return 'Did not find ViewerLineIdsComponent when updating DebugLinesComponent in ' + this$0.id + '.';
    };
  }
  function DebugLineDrawingSystem$onRemoveComponent$lambda(this$0) {
    return function () {
      return 'Did not find ViewerLineIdsComponent when removing DebugLinesComponent in ' + this$0.id + '.';
    };
  }
  function DebugLineDrawingSystem(coreServices) {
    Companion_getInstance_32();
    SystemBase2.call(this, 'Line Drawing System', 92, 123);
    this.coreServices = coreServices;
  }
  protoOf(DebugLineDrawingSystem).k2z = function () {
    return this.coreServices;
  };
  protoOf(DebugLineDrawingSystem).onAddComponent = function (entity, newComponent) {
    if (entity.hasComponent(93)) {
      var tmp = Companion_getInstance_32().g32_1;
      tmp.warn(DebugLineDrawingSystem$onAddComponent$lambda);
      return Unit_instance;
    }
    drawLines(this, entity, newComponent.lines);
  };
  protoOf(DebugLineDrawingSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(93);
    var lineIds = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lineIds;
    if (!(lineIds == null)) {
      cleanLines(this, lineIds);
      entity.removeComponent(93);
      drawLines(this, entity, newComponent.lines);
    } else {
      var tmp = Companion_getInstance_32().g32_1;
      tmp.warn(DebugLineDrawingSystem$onUpdateComponent$lambda(this));
    }
  };
  protoOf(DebugLineDrawingSystem).onRemoveComponent = function (entity, oldComponent) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(93);
    var lineIds = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lineIds;
    if (!(lineIds == null)) {
      cleanLines(this, lineIds);
      entity.removeComponent(93);
    } else {
      var tmp = Companion_getInstance_32().g32_1;
      tmp.warn(DebugLineDrawingSystem$onRemoveComponent$lambda(this));
    }
  };
  protoOf(DebugLineDrawingSystem).onAddComponent2 = function (entity, newComponent) {
    var tmp0_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.getComponent(93);
    }
    var tmp1_safe_receiver = tmp;
    var oldLineIds = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.lineIds;
    if (!(oldLineIds == null)) {
      cleanLines(this, oldLineIds);
    }
    var newEntity = newComponent.entity;
    var tmp_0;
    if (newEntity == null) {
      tmp_0 = null;
    } else {
      tmp_0 = newEntity.__getComponentForKotlin(92);
    }
    var tmp3_safe_receiver = tmp_0;
    var newLines = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.lines;
    if (!(newEntity == null) ? !(newLines == null) : false) {
      drawLines(this, newEntity, newLines);
    }
  };
  protoOf(DebugLineDrawingSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(DebugLineDrawingSystem).onRemoveComponent2 = function (entity, oldComponent) {
  };
  function LoggingEntityManagerWatcher(entityManager, componentId) {
    this.h32_1 = entityManager;
    this.i32_1 = componentId;
    this.h32_1.addWatcher(this);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.j32_1 = ArrayList_init_$Create$();
    this.k32_1 = 0;
  }
  protoOf(LoggingEntityManagerWatcher).l32 = function () {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = this.j32_1;
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.b1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.debug.LoggingEntityManagerWatcher.checkTrace.<anonymous>' call
        if (element.v1o() === this.i32_1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    var shouldPrint = tmp$ret$0;
    if (shouldPrint) {
      this.m32();
      this.h32_1.removeWatcher(this);
    }
    this.j32_1.z();
  };
  protoOf(LoggingEntityManagerWatcher).m32 = function () {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    var indent = 0;
    var tmp0_iterator = this.j32_1.t();
    while (tmp0_iterator.u()) {
      var trace = tmp0_iterator.w();
      if (equals(trace, DoneEntry_instance)) {
        indent = indent - 1 | 0;
      } else {
        result.q(repeat(' ', imul(indent, 2)) + trace.n32());
        indent = indent + 1 | 0;
      }
    }
    println(joinToString_0(result, '\n'));
  };
  protoOf(LoggingEntityManagerWatcher).beforeAddComponent = function (entity, component) {
    this.j32_1.q(new AddEntry(entity, component));
    this.k32_1 = this.k32_1 + 1 | 0;
  };
  protoOf(LoggingEntityManagerWatcher).afterAddComponent = function (entity, component) {
    this.j32_1.q(DoneEntry_instance);
    this.k32_1 = this.k32_1 - 1 | 0;
    if (this.k32_1 === 0) {
      this.l32();
    }
  };
  protoOf(LoggingEntityManagerWatcher).beforeRemoveComponent = function (entity, componentId) {
    this.j32_1.q(new RemoveEntry(entity, componentId));
    this.k32_1 = this.k32_1 + 1 | 0;
  };
  protoOf(LoggingEntityManagerWatcher).afterRemoveComponent = function (entity, componentId) {
    this.j32_1.q(DoneEntry_instance);
    this.k32_1 = this.k32_1 - 1 | 0;
    if (this.k32_1 === 0) {
      this.l32();
    }
  };
  protoOf(LoggingEntityManagerWatcher).beforeNotifyOnAdd = function (componentListener) {
    this.j32_1.q(new CallEntry(componentListener, 'onAdd'));
  };
  protoOf(LoggingEntityManagerWatcher).afterNotifyOnAdd = function (componentListener) {
    this.j32_1.q(DoneEntry_instance);
  };
  protoOf(LoggingEntityManagerWatcher).beforeNotifyOnUpdate = function (componentListener) {
    this.j32_1.q(new CallEntry(componentListener, 'onUpdate'));
  };
  protoOf(LoggingEntityManagerWatcher).afterNotifyOnUpdate = function (componentListener) {
    this.j32_1.q(DoneEntry_instance);
  };
  protoOf(LoggingEntityManagerWatcher).beforeNotifyOnRemove = function (componentListener) {
    this.j32_1.q(new CallEntry(componentListener, 'onRemove'));
  };
  protoOf(LoggingEntityManagerWatcher).afterNotifyOnRemove = function (componentListener) {
    this.j32_1.q(DoneEntry_instance);
  };
  function DoneEntry() {
    this.o32_1 = -1;
    this.p32_1 = '';
  }
  protoOf(DoneEntry).v1o = function () {
    return this.o32_1;
  };
  protoOf(DoneEntry).n32 = function () {
    return this.p32_1;
  };
  var DoneEntry_instance;
  function DoneEntry_getInstance() {
    return DoneEntry_instance;
  }
  function AddEntry(entity, component) {
    this.q32_1 = entity;
    this.r32_1 = component;
    this.s32_1 = this.r32_1.typeId;
    this.t32_1 = 'Adding ' + getKClassFromExpression(this.r32_1).v6() + ' (' + this.r32_1.typeId + ') to ' + get_displayName(this.q32_1);
  }
  protoOf(AddEntry).v1o = function () {
    return this.s32_1;
  };
  protoOf(AddEntry).n32 = function () {
    return this.t32_1;
  };
  function RemoveEntry(entity, componentId) {
    this.u32_1 = entity;
    this.v32_1 = componentId;
    this.w32_1 = 'Removing ' + componentName(this.v32_1) + ' from ' + get_displayName(this.u32_1);
  }
  protoOf(RemoveEntry).v1o = function () {
    return this.v32_1;
  };
  protoOf(RemoveEntry).n32 = function () {
    return this.w32_1;
  };
  function CallEntry(listener, method) {
    this.x32_1 = listener;
    this.y32_1 = -1;
    this.z32_1 = 'Calling ' + method + ' on ' + (!(this.x32_1.ownerSystem == null) ? ensureNotNull(this.x32_1.ownerSystem).id : getKClassFromExpression(this.x32_1).v6());
  }
  protoOf(CallEntry).v1o = function () {
    return this.y32_1;
  };
  protoOf(CallEntry).n32 = function () {
    return this.z32_1;
  };
  function idForAdd($this, componentListener) {
    var tmp0_safe_receiver = componentListener.ownerSystem;
    return '' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id) + ' add ' + componentListener.componentId;
  }
  function idForUpdate($this, componentListener) {
    var tmp0_safe_receiver = componentListener.ownerSystem;
    return '' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id) + ' update ' + componentListener.componentId;
  }
  function idForRemove($this, componentListener) {
    var tmp0_safe_receiver = componentListener.ownerSystem;
    return '' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id) + ' remove ' + componentListener.componentId;
  }
  function MeasuringEntityManagerWatcher(entityManager) {
    this.entityManager = entityManager;
    this.measurer = new Measurer();
  }
  protoOf(MeasuringEntityManagerWatcher).p1i = function () {
    return this.entityManager;
  };
  protoOf(MeasuringEntityManagerWatcher).j2t = function () {
    return this.measurer;
  };
  protoOf(MeasuringEntityManagerWatcher).beforeAddComponent = function (entity, component) {
  };
  protoOf(MeasuringEntityManagerWatcher).afterAddComponent = function (entity, component) {
  };
  protoOf(MeasuringEntityManagerWatcher).beforeRemoveComponent = function (entity, componentId) {
  };
  protoOf(MeasuringEntityManagerWatcher).afterRemoveComponent = function (entity, componentId) {
  };
  protoOf(MeasuringEntityManagerWatcher).beforeNotifyOnAdd = function (componentListener) {
    this.measurer.start(idForAdd(this, componentListener));
  };
  protoOf(MeasuringEntityManagerWatcher).afterNotifyOnAdd = function (componentListener) {
    this.measurer.stop(idForAdd(this, componentListener));
  };
  protoOf(MeasuringEntityManagerWatcher).beforeNotifyOnUpdate = function (componentListener) {
    this.measurer.start(idForUpdate(this, componentListener));
  };
  protoOf(MeasuringEntityManagerWatcher).afterNotifyOnUpdate = function (componentListener) {
    this.measurer.stop(idForUpdate(this, componentListener));
  };
  protoOf(MeasuringEntityManagerWatcher).beforeNotifyOnRemove = function (componentListener) {
    this.measurer.start(idForRemove(this, componentListener));
  };
  protoOf(MeasuringEntityManagerWatcher).afterNotifyOnRemove = function (componentListener) {
    this.measurer.stop(idForRemove(this, componentListener));
  };
  function calculateEndTransform($this, point, entity) {
    return new Transform(point, get_worldTransform(entity).rotation);
  }
  function Companion_24() {
  }
  protoOf(Companion_24).basedOnEntity = function (entity, point, rayFromCameraToDragPoint) {
    var tmp0_elvis_lhs = get_snapRoot(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = "Can't drag an entity with no draggable root. The entity or any of its ancestor needs to have the Draggable component";
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var draggedEntity = tmp;
    var tmp1_originalParent = get_parent(draggedEntity);
    var tmp2_initialTransform = get_worldTransform(draggedEntity);
    var tmp3_dragEndTransform = calculateEndTransform(this, point, draggedEntity);
    return new DragState(entity, draggedEntity, tmp1_originalParent, point, tmp2_initialTransform, tmp3_dragEndTransform, rayFromCameraToDragPoint);
  };
  var Companion_instance_57;
  function Companion_getInstance_33() {
    return Companion_instance_57;
  }
  function DragState(originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult) {
    validDragStrategyResult = validDragStrategyResult === VOID ? null : validDragStrategyResult;
    this.originalDraggedEntity = originalDraggedEntity;
    this.draggedRootEntity = draggedRootEntity;
    this.originalParent = originalParent;
    this.dragPoint = dragPoint;
    this.initialTransform = initialTransform;
    this.dragEndTransform = dragEndTransform;
    this.rayFromCameraToDragPoint = rayFromCameraToDragPoint;
    this.validDragStrategyResult = validDragStrategyResult;
  }
  protoOf(DragState).a33 = function () {
    return this.originalDraggedEntity;
  };
  protoOf(DragState).b33 = function () {
    return this.draggedRootEntity;
  };
  protoOf(DragState).c33 = function () {
    return this.originalParent;
  };
  protoOf(DragState).d33 = function () {
    return this.dragPoint;
  };
  protoOf(DragState).l2q = function () {
    return this.initialTransform;
  };
  protoOf(DragState).e33 = function () {
    return this.dragEndTransform;
  };
  protoOf(DragState).h24 = function () {
    return this.rayFromCameraToDragPoint;
  };
  protoOf(DragState).f33 = function () {
    return this.validDragStrategyResult;
  };
  protoOf(DragState).g33 = function () {
    var tmp0_elvis_lhs = get_snapRoot(this.originalDraggedEntity);
    return tmp0_elvis_lhs == null ? this.originalDraggedEntity : tmp0_elvis_lhs;
  };
  protoOf(DragState).h33 = function () {
    var tmp0_safe_receiver = this.validDragStrategyResult;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.snapCandidate;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.endTransform;
    return tmp2_elvis_lhs == null ? this.initialTransform : tmp2_elvis_lhs;
  };
  protoOf(DragState).updateDragChange = function (point, rayFromCameraToDragPoint) {
    return this.copy(VOID, VOID, VOID, point, VOID, calculateEndTransform(Companion_instance_57, point, this.draggedRootEntity), rayFromCameraToDragPoint);
  };
  protoOf(DragState).updateWithDragStrategyResult = function (entity, validDragStrategyResult) {
    var tmp0_elvis_lhs = get_snapRoot(entity);
    return this.copy(VOID, tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs, VOID, VOID, VOID, VOID, VOID, validDragStrategyResult);
  };
  protoOf(DragState).af = function () {
    return this.originalDraggedEntity;
  };
  protoOf(DragState).bf = function () {
    return this.draggedRootEntity;
  };
  protoOf(DragState).g1k = function () {
    return this.originalParent;
  };
  protoOf(DragState).h1k = function () {
    return this.dragPoint;
  };
  protoOf(DragState).i1k = function () {
    return this.initialTransform;
  };
  protoOf(DragState).j1k = function () {
    return this.dragEndTransform;
  };
  protoOf(DragState).k1k = function () {
    return this.rayFromCameraToDragPoint;
  };
  protoOf(DragState).p1z = function () {
    return this.validDragStrategyResult;
  };
  protoOf(DragState).i33 = function (originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult) {
    return new DragState(originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult);
  };
  protoOf(DragState).copy = function (originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult, $super) {
    originalDraggedEntity = originalDraggedEntity === VOID ? this.originalDraggedEntity : originalDraggedEntity;
    draggedRootEntity = draggedRootEntity === VOID ? this.draggedRootEntity : draggedRootEntity;
    originalParent = originalParent === VOID ? this.originalParent : originalParent;
    dragPoint = dragPoint === VOID ? this.dragPoint : dragPoint;
    initialTransform = initialTransform === VOID ? this.initialTransform : initialTransform;
    dragEndTransform = dragEndTransform === VOID ? this.dragEndTransform : dragEndTransform;
    rayFromCameraToDragPoint = rayFromCameraToDragPoint === VOID ? this.rayFromCameraToDragPoint : rayFromCameraToDragPoint;
    validDragStrategyResult = validDragStrategyResult === VOID ? this.validDragStrategyResult : validDragStrategyResult;
    return this.i33(originalDraggedEntity, draggedRootEntity, originalParent, dragPoint, initialTransform, dragEndTransform, rayFromCameraToDragPoint, validDragStrategyResult);
  };
  protoOf(DragState).toString = function () {
    return 'DragState(originalDraggedEntity=' + this.originalDraggedEntity + ', draggedRootEntity=' + this.draggedRootEntity + ', originalParent=' + this.originalParent + ', dragPoint=' + this.dragPoint + ', initialTransform=' + this.initialTransform + ', dragEndTransform=' + this.dragEndTransform + ', rayFromCameraToDragPoint=' + this.rayFromCameraToDragPoint + ', validDragStrategyResult=' + this.validDragStrategyResult + ')';
  };
  protoOf(DragState).hashCode = function () {
    var result = this.originalDraggedEntity.hashCode();
    result = imul(result, 31) + this.draggedRootEntity.hashCode() | 0;
    result = imul(result, 31) + (this.originalParent == null ? 0 : this.originalParent.hashCode()) | 0;
    result = imul(result, 31) + this.dragPoint.hashCode() | 0;
    result = imul(result, 31) + this.initialTransform.hashCode() | 0;
    result = imul(result, 31) + this.dragEndTransform.hashCode() | 0;
    result = imul(result, 31) + this.rayFromCameraToDragPoint.hashCode() | 0;
    result = imul(result, 31) + (this.validDragStrategyResult == null ? 0 : hashCode(this.validDragStrategyResult)) | 0;
    return result;
  };
  protoOf(DragState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DragState))
      return false;
    var tmp0_other_with_cast = other instanceof DragState ? other : THROW_CCE();
    if (!this.originalDraggedEntity.equals(tmp0_other_with_cast.originalDraggedEntity))
      return false;
    if (!this.draggedRootEntity.equals(tmp0_other_with_cast.draggedRootEntity))
      return false;
    if (!equals(this.originalParent, tmp0_other_with_cast.originalParent))
      return false;
    if (!this.dragPoint.equals(tmp0_other_with_cast.dragPoint))
      return false;
    if (!this.initialTransform.equals(tmp0_other_with_cast.initialTransform))
      return false;
    if (!this.dragEndTransform.equals(tmp0_other_with_cast.dragEndTransform))
      return false;
    if (!this.rayFromCameraToDragPoint.equals(tmp0_other_with_cast.rayFromCameraToDragPoint))
      return false;
    if (!equals(this.validDragStrategyResult, tmp0_other_with_cast.validDragStrategyResult))
      return false;
    return true;
  };
  function Companion_25() {
    this.id = 69;
  }
  protoOf(Companion_25).s1k = function () {
    return this.id;
  };
  var Companion_instance_58;
  function Companion_getInstance_34() {
    return Companion_instance_58;
  }
  function DragStateComponent(dragState) {
    this.dragState = dragState;
    this.j33_1 = false;
  }
  protoOf(DragStateComponent).k33 = function () {
    return this.dragState;
  };
  protoOf(DragStateComponent).x1k = function () {
    return 69;
  };
  protoOf(DragStateComponent).eq = function (other) {
    return false;
  };
  protoOf(DragStateComponent).a1l = function () {
    return this.j33_1;
  };
  function Companion_26() {
    Companion_instance_59 = this;
    this.ID = 'DragSurfaceNormalVisualizationSystem';
    this.l33_1 = 500.0;
    this.m33_1 = 20.0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = LoggerState_getInstance().m1m('DragSurfaceNormalVisualizationSystem');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.dragging.Companion.logger.<anonymous>' call
    this_0.level = LogLevel_DEBUG_getInstance();
    tmp.n33_1 = this_0;
  }
  protoOf(Companion_26).u1n = function () {
    return this.ID;
  };
  var Companion_instance_59;
  function Companion_getInstance_35() {
    if (Companion_instance_59 == null)
      new Companion_26();
    return Companion_instance_59;
  }
  function drawLinesForEntity($this, entity, dragSurfaceComponent) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var lines = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = dragSurfaceComponent.surfaces;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawLinesForEntity.<anonymous>' call
      drawNormals($this, element.surface, lines);
      drawSurfaceEdges($this, element.surface, lines);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$1 = copyToArray(lines);
    entity.addComponent(new DebugLinesComponent(tmp$ret$1));
  }
  function drawNormals($this, polyhedron, lines) {
    if (polyhedron instanceof ConvexPolyhedron) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var indexedObject = polyhedron.faces;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var item = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawNormals.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var faceCenter = Companion_getInstance_4().ZERO;
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject_0 = item.indices;
        var inductionVariable_0 = 0;
        var last_0 = indexedObject_0.length;
        while (inductionVariable_0 < last_0) {
          var element = indexedObject_0[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawNormals.<anonymous>.<anonymous>' call
          faceCenter = faceCenter.plus(polyhedron.vertices[element]);
        }
        var tmp = faceCenter;
        // Inline function 'kotlin.collections.count' call
        var tmp$ret$0 = item.indices.length;
        faceCenter = tmp.__divIntForKotlin(tmp$ret$0);
        var faceNormal = polyhedron.normals[tmp1];
        var tmp_0;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = faceNormal.dot(Companion_getInstance_4().RIGHT);
        if (Math.abs(this_0) > 0.0) {
          tmp_0 = faceNormal.cross(Companion_getInstance_4().FORWARD);
        } else {
          tmp_0 = faceNormal.cross(Companion_getInstance_4().RIGHT);
        }
        var right = tmp_0;
        var end = faceCenter.plus(faceNormal.times(500.0));
        var color = getSurfaceColor($this, faceNormal);
        lines.q(new DebugLine(faceCenter, end, color, 20.0));
        lines.q(new DebugLine(end, end.minus(faceNormal.plus(right).times(0.1).times(500.0)), color, 20.0));
        lines.q(new DebugLine(end, end.minus(faceNormal.minus(right).times(0.1).times(500.0)), color, 20.0));
      }
    } else {
      if (polyhedron instanceof PolyhedronGroup) {
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject_1 = polyhedron.polyhedra;
        var inductionVariable_1 = 0;
        var last_1 = indexedObject_1.length;
        while (inductionVariable_1 < last_1) {
          var element_0 = indexedObject_1[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawNormals.<anonymous>' call
          drawNormals($this, element_0, lines);
        }
      }
    }
  }
  function getSurfaceColor($this, faceNormal) {
    // Inline function 'kotlin.math.abs' call
    var x = faceNormal.X;
    var tmp = Math.abs(x);
    // Inline function 'kotlin.math.abs' call
    var x_0 = faceNormal.Y;
    var tmp_0 = Math.abs(x_0);
    // Inline function 'kotlin.math.abs' call
    var x_1 = faceNormal.Z;
    var tmp$ret$2 = Math.abs(x_1);
    var color = new Vector(tmp, tmp_0, tmp$ret$2);
    return color;
  }
  function drawSurfaceEdges($this, polyhedron, lines) {
    if (polyhedron instanceof ConvexPolyhedron) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var indexedObject = polyhedron.faces;
      var inductionVariable = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable < last_0) {
        var item = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawSurfaceEdges.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var faceNormal = polyhedron.normals[tmp1];
        var color = getSurfaceColor($this, faceNormal);
        var inductionVariable_0 = 1;
        var last_1 = item.indices.length;
        if (inductionVariable_0 < last_1)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var previous = polyhedron.vertices[item.indices[i - 1 | 0]];
            var next = polyhedron.vertices[item.indices[i]];
            lines.q(new DebugLine(previous, next, color, 20.0));
          }
           while (inductionVariable_0 < last_1);
        if (item.indices.length > 1) {
          var first_0 = polyhedron.vertices[first(item.indices)];
          var last_2 = polyhedron.vertices[last(item.indices)];
          lines.q(new DebugLine(first_0, last_2, color, 20.0));
        }
      }
    } else {
      if (polyhedron instanceof PolyhedronGroup) {
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject_0 = polyhedron.polyhedra;
        var inductionVariable_1 = 0;
        var last_3 = indexedObject_0.length;
        while (inductionVariable_1 < last_3) {
          var element = indexedObject_0[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.drawSurfaceEdges.<anonymous>' call
          drawSurfaceEdges($this, element, lines);
        }
      }
    }
  }
  function DragSurfaceNormalVisualizationSystem(coreServices) {
    Companion_getInstance_35();
    var tmp = InSceneComponent_instance.id;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [92];
    SystemBase2.call(this, 'DragSurfaceNormalVisualizationSystem', 91, tmp, tmp$ret$2);
    this.w33_1 = coreServices;
  }
  protoOf(DragSurfaceNormalVisualizationSystem).enable = function () {
    protoOf(SystemBase2).enable.call(this);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.w33_1.entityManager.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.enable.<anonymous>' call
      if (element.hasComponent(74)) {
        var dragSurface = element.__getComponentForKotlin(91);
        if (!(dragSurface == null)) {
          this.onAddComponent(element, dragSurface);
        }
      }
    }
  };
  protoOf(DragSurfaceNormalVisualizationSystem).disable = function () {
    protoOf(SystemBase2).disable.call(this);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.w33_1.entityManager.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSurfaceNormalVisualizationSystem.disable.<anonymous>' call
      if (element.hasComponent(74)) {
        var dragSurface = element.__getComponentForKotlin(91);
        if (!(dragSurface == null)) {
          this.onRemoveComponent(element, dragSurface);
        }
      }
    }
  };
  protoOf(DragSurfaceNormalVisualizationSystem).onAddComponent = function (entity, newComponent) {
    if (get_isInScene(entity)) {
      drawLinesForEntity(this, entity, newComponent);
    }
  };
  protoOf(DragSurfaceNormalVisualizationSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (get_isInScene(entity)) {
      drawLinesForEntity(this, entity, newComponent);
    }
  };
  protoOf(DragSurfaceNormalVisualizationSystem).onRemoveComponent = function (entity, oldComponent) {
    entity.removeComponent(92);
  };
  protoOf(DragSurfaceNormalVisualizationSystem).onAddComponent2 = function (entity, newComponent) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(91);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      drawLinesForEntity(this, entity, tmp0_safe_receiver);
    }
  };
  protoOf(DragSurfaceNormalVisualizationSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(91);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      drawLinesForEntity(this, entity, tmp0_safe_receiver);
    }
  };
  protoOf(DragSurfaceNormalVisualizationSystem).onRemoveComponent2 = function (entity, oldComponent) {
    entity.removeComponent(92);
  };
  function createDebugSurfaces($this, entity, newComponent) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = newComponent.surfaces;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSurfaceVisualizationSystem.createDebugSurfaces.<anonymous>' call
      var tmp$ret$0 = item.surface;
      destination.q(tmp$ret$0);
    }
    var allPolyhedrons = copyToArray(destination);
    var polygons = PolyhedronUtils_getInstance().getPolygonsFromPolyhedrons(allPolyhedrons);
    entity.addComponent(new DebugSurfacesComponent(polygons));
  }
  function Companion_27() {
    this.ID = 'DragSurfaceVisualizationSystem';
  }
  protoOf(Companion_27).u1n = function () {
    return this.ID;
  };
  var Companion_instance_60;
  function Companion_getInstance_36() {
    return Companion_instance_60;
  }
  function DragSurfaceVisualizationSystem(entityManager) {
    var tmp = InSceneComponent_instance.id;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = ['DebugSurfaceDrawingSystem'];
    SystemBase2.call(this, 'DragSurfaceVisualizationSystem', 91, tmp, VOID, VOID, tmp$ret$2);
    this.f34_1 = entityManager;
  }
  protoOf(DragSurfaceVisualizationSystem).enable = function () {
    protoOf(SystemBase2).enable.call(this);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.f34_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSurfaceVisualizationSystem.enable.<anonymous>' call
      var dragSurface = element.__getComponentForKotlin(91);
      if (!(dragSurface == null)) {
        this.onAddComponent(element, dragSurface);
      }
    }
  };
  protoOf(DragSurfaceVisualizationSystem).disable = function () {
    protoOf(SystemBase2).disable.call(this);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.f34_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSurfaceVisualizationSystem.disable.<anonymous>' call
      var dragSurface = element.__getComponentForKotlin(91);
      if (!(dragSurface == null)) {
        this.onRemoveComponent(element, dragSurface);
      }
    }
  };
  protoOf(DragSurfaceVisualizationSystem).onAddComponent = function (entity, newComponent) {
    if (get_isInScene(entity)) {
      createDebugSurfaces(this, entity, newComponent);
    }
  };
  protoOf(DragSurfaceVisualizationSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (get_isInScene(entity)) {
      entity.removeComponent(120);
      createDebugSurfaces(this, entity, newComponent);
    }
  };
  protoOf(DragSurfaceVisualizationSystem).onRemoveComponent = function (entity, oldComponent) {
    entity.removeComponent(120);
  };
  protoOf(DragSurfaceVisualizationSystem).onAddComponent2 = function (entity, newComponent) {
    entity.removeComponent(120);
    var worldDragSurfacesComponent = entity.__getComponentForKotlin(91);
    if (!(worldDragSurfacesComponent == null)) {
      createDebugSurfaces(this, entity, worldDragSurfacesComponent);
    }
  };
  protoOf(DragSurfaceVisualizationSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    entity.removeComponent(120);
    var worldDragSurfacesComponent = entity.__getComponentForKotlin(91);
    if (!(worldDragSurfacesComponent == null)) {
      createDebugSurfaces(this, entity, worldDragSurfacesComponent);
    }
  };
  protoOf(DragSurfaceVisualizationSystem).onRemoveComponent2 = function (entity, oldComponent) {
    entity.removeComponent(120);
  };
  function createDragSurface($this, entity) {
    var prevComponent = entity.__getComponentForKotlin(74);
    var tmp1_elvis_lhs = prevComponent == null ? null : prevComponent.basedOnCollider;
    var allowedToUpdate = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
    if (allowedToUpdate) {
      var tmp2_safe_receiver = get_colliderShapeComponent(entity);
      var collider = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.polyhedron;
      if (collider == null) {
        $this.entityManager.removeComponent(entity, 74);
        return Unit_instance;
      }
      var tmp3_safe_receiver = get_connectorsComponent(entity);
      var connectors = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.hostConnectors;
      if (connectors == null ? true : connectors.b1()) {
        $this.entityManager.removeComponent(entity, 74);
        return Unit_instance;
      }
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [new DragSurface(collider, null)];
      $this.entityManager.addComponent(entity, new DragSurfacesComponent(tmp$ret$2, true));
    }
  }
  function DragSurfacesUpdateSystem(entityManager) {
    Companion_getInstance_2();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [74];
    SystemBase2.call(this, 'DragSurfaceUpdateSystem', 19, 11, tmp$ret$2);
    this.entityManager = entityManager;
    this.enable();
  }
  protoOf(DragSurfacesUpdateSystem).p1i = function () {
    return this.entityManager;
  };
  protoOf(DragSurfacesUpdateSystem).onAddComponent = function (entity, newComponent) {
    createDragSurface(this, entity);
  };
  protoOf(DragSurfacesUpdateSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    createDragSurface(this, entity);
  };
  protoOf(DragSurfacesUpdateSystem).onRemoveComponent = function (entity, oldComponent) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(74);
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.basedOnCollider) === true) {
      this.entityManager.removeComponent(entity, 74);
    }
  };
  protoOf(DragSurfacesUpdateSystem).onAddComponent2 = function (entity, newComponent) {
    createDragSurface(this, entity);
  };
  protoOf(DragSurfacesUpdateSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    createDragSurface(this, entity);
  };
  protoOf(DragSurfacesUpdateSystem).onRemoveComponent2 = function (entity, oldComponent) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(74);
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.basedOnCollider) === true) {
      this.entityManager.removeComponent(entity, 74);
    }
  };
  function _get_sceneManager__lxhb6y($this) {
    return $this.w34_1.sceneManager;
  }
  function _get_history__d61b7h($this) {
    return $this.w34_1.coreModules.history();
  }
  function _get_state__b8zcm8($this) {
    var tmp = _get_sceneManager__lxhb6y($this).scene;
    var tmp0_safe_receiver = tmp.__getComponentForKotlin(69);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dragState;
  }
  function dragStart_0($this, entity, event) {
    var tmp0_elvis_lhs = get_snapRoot(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var snapRoot = tmp;
    var newState = Companion_instance_57.basedOnEntity(entity, event.point, event.rayFromCameraToDragPoint);
    updateDragState($this, newState);
    if (addDragComponents($this, snapRoot, newState)) {
      runDragStartOnStrategies($this);
    }
  }
  function addDragComponents($this, draggableRootEntity, state) {
    var tmp = _get_sceneManager__lxhb6y($this).scene;
    if (tmp.hasComponent(66)) {
      var tmp_0 = Companion_getInstance_37().b35_1;
      tmp_0.info(DragSystem$addDragComponents$lambda);
      return false;
    }
    _get_sceneManager__lxhb6y($this).scene.addComponent(new DragStateComponent(state));
    _get_sceneManager__lxhb6y($this).scene.addComponent(new SomethingIsDraggedComponent(draggableRootEntity));
    draggableRootEntity.addComponent(IsDraggedComponent_instance);
    return true;
  }
  function dragMove($this, event) {
    var tmp0_elvis_lhs = _get_state__b8zcm8($this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var dragState = tmp;
    pauseViewerUpdatesOnDraggedEntity(_get_sceneManager__lxhb6y($this));
    var tmp_0 = _get_sceneManager__lxhb6y($this).scene;
    if (!tmp_0.hasComponent(66)) {
      var tmp_1 = Companion_getInstance_37().b35_1;
      tmp_1.error(DragSystem$dragMove$lambda);
    }
    var newDragState = dragState.updateDragChange(event.point, event.rayFromCameraToDragPoint);
    updateDragState($this, newDragState);
    runDragMoveOnStrategies($this, newDragState);
    resumeViewerUpdatesOnDraggedEntity(_get_sceneManager__lxhb6y($this));
  }
  function dragStop_0($this) {
    var tmp0_elvis_lhs = _get_state__b8zcm8($this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var dragState = tmp;
    var tmp_0 = _get_sceneManager__lxhb6y($this).scene;
    if (!tmp_0.hasComponent(66)) {
      var tmp_1 = Companion_getInstance_37().b35_1;
      tmp_1.error(DragSystem$dragStop$lambda);
    }
    if (isDragStartedEarlier($this)) {
      var tmp1_safe_receiver = dragState.validDragStrategyResult;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.performFinalSnapAction(dragState, $this.w34_1);
      var snapResult = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
      if (!snapResult) {
        var tmp3_safe_receiver = _get_history__d61b7h($this);
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.discardLatestSnapshot();
        }
      }
      runDragStopOnStrategies($this);
    }
    var tmp_2;
    var tmp4_safe_receiver = _get_state__b8zcm8($this);
    var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.draggedRootEntity;
    if (!((tmp5_safe_receiver == null ? null : tmp5_safe_receiver.isDisposed) === true)) {
      var tmp6_safe_receiver = _get_state__b8zcm8($this);
      tmp_2 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.draggedRootEntity;
    } else {
      tmp_2 = null;
    }
    var draggedRoot = tmp_2;
    if (draggedRoot == null)
      null;
    else
      draggedRoot.removeComponent(IsDraggedComponent_instance.id);
    var tmp_3 = _get_sceneManager__lxhb6y($this).scene;
    tmp_3.removeComponent(66);
    var tmp_4 = _get_sceneManager__lxhb6y($this).scene;
    tmp_4.removeComponent(69);
    updateDragState($this, null);
  }
  function runDragStartOnStrategies($this) {
    var tmp0_safe_receiver = _get_state__b8zcm8($this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var indexedObject = $this.x34_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.DragSystem.runDragStartOnStrategies.<anonymous>.<anonymous>' call
        element.dragStart(tmp0_safe_receiver.draggedRootEntity);
      }
    }
  }
  function runDragMoveOnStrategies($this, dragState) {
    var draggedRoot = dragState.draggedRootEntity;
    var worldTransformBefore = get_worldTransform(draggedRoot);
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = $this.x34_1;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DragSystem.runDragMoveOnStrategies.<anonymous>' call
      if (element.isEnabled) {
        destination.q(element);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.dragging.DragSystem.runDragMoveOnStrategies.<anonymous>' call
      TransformUtils_instance.setWorldTransform(draggedRoot, dragState.dragEndTransform);
      var validSnap = element_0.dragMove(dragState);
      if (!(validSnap == null)) {
        var tmp0_safe_receiver = $this.y34_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.performPostProcess(validSnap, dragState);
        validSnap = tmp1_elvis_lhs == null ? validSnap : tmp1_elvis_lhs;
        validSnap.snapCandidate.perform();
        var newDragState = dragState.updateWithDragStrategyResult(validSnap.entity, validSnap);
        updateDragState($this, newDragState);
        triggerMovedToValidSnapPositionComponent(newDragState.draggedRootEntity, validSnap.snapCandidate);
        return Unit_instance;
      }
    }
    TransformUtils_instance.setWorldTransform(draggedRoot, worldTransformBefore);
  }
  function updateDragState($this, newState) {
    if (!(newState == null)) {
      _get_sceneManager__lxhb6y($this).scene.addComponent(new DragStateComponent(newState));
    } else {
      var tmp = _get_sceneManager__lxhb6y($this).scene;
      tmp.removeComponent(69);
    }
  }
  function runDragStopOnStrategies($this) {
    var tmp0_safe_receiver = _get_state__b8zcm8($this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var indexedObject = $this.x34_1;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.DragSystem.runDragStopOnStrategies.<anonymous>.<anonymous>' call
        element.dragStop(tmp0_safe_receiver.draggedRootEntity);
      }
    }
  }
  function isDragStartedEarlier($this) {
    return !(_get_state__b8zcm8($this) == null);
  }
  function Companion_28() {
    Companion_instance_61 = this;
    this.b35_1 = LoggerState_getInstance().m1m('DragSystem');
    this.ID = 'DragSystem';
  }
  protoOf(Companion_28).u1n = function () {
    return this.ID;
  };
  protoOf(Companion_28).createStandardDragSystem = function (coreServices) {
    // Inline function 'kotlin.arrayOf' call
    var tmp = new SnapClosestDragStrategy(coreServices);
    var tmp_0 = new SnapClosestWithSubConnectorsDragStrategy(coreServices);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [tmp, tmp_0, new ResolveCollisionsDragStrategy(31, coreServices), new SnapCardinalDirectionsDragStrategy(coreServices)];
    return new DragSystem(coreServices, tmp$ret$2);
  };
  protoOf(Companion_28).createAutoAdaptDragSystem = function (coreServices) {
    // Inline function 'kotlin.arrayOf' call
    var tmp = new AutoAdaptDragStrategy(coreServices);
    var tmp_0 = new SnapClosestDragStrategy(coreServices);
    var tmp_1 = new SnapClosestWithSubConnectorsDragStrategy(coreServices);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [tmp, tmp_0, tmp_1, new ResolveCollisionsDragStrategy(31, coreServices), new SnapCardinalDirectionsDragStrategy(coreServices)];
    return new DragSystem(coreServices, tmp$ret$2);
  };
  var Companion_instance_61;
  function Companion_getInstance_37() {
    if (Companion_instance_61 == null)
      new Companion_28();
    return Companion_instance_61;
  }
  function DragSystem$addDragComponents$lambda() {
    return 'Something is already dragged, ignoring drag start';
  }
  function DragSystem$dragMove$lambda() {
    return 'Illegal state: No SomethingIsDraggedComponent found in scene. dragMove was probably called before dragStart';
  }
  function DragSystem$dragStop$lambda() {
    return 'Illegal state: No SomethingIsDraggedComponent found in scene. dragEnd was probably called before dragStart';
  }
  function DragSystem(coreServices, dragStrategies) {
    Companion_getInstance_37();
    SystemBase.call(this, 'DragSystem', 85);
    this.w34_1 = coreServices;
    this.x34_1 = dragStrategies;
    this.y34_1 = new HigherPriorityAlignmentPostProcess(this.w34_1);
    this.z34_1 = new TakeSnapshotBeforeDragSystem(this.w34_1);
    new NoDragConverterDetector(this.w34_1.entityManager);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a35_1 = [66, 69, IsDraggedComponent_instance.id];
  }
  protoOf(DragSystem).onRegister = function () {
    protoOf(SystemBase).onRegister.call(this);
    this.z34_1.register(this.w34_1.entityManager);
  };
  protoOf(DragSystem).onUnregister = function () {
    protoOf(SystemBase).onUnregister.call(this);
    this.z34_1.unregister(this.w34_1.entityManager);
  };
  protoOf(DragSystem).enable = function () {
    protoOf(SystemBase).enable.call(this);
    this.z34_1.enable();
  };
  protoOf(DragSystem).disable = function () {
    protoOf(SystemBase).disable.call(this);
    this.z34_1.disable();
  };
  protoOf(DragSystem).onAddComponent = function (entity, newComponent) {
    dragStart_0(this, entity, newComponent);
  };
  protoOf(DragSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    dragMove(this, newComponent);
  };
  protoOf(DragSystem).onRemoveComponent = function (entity, oldComponent) {
    dragStop_0(this);
  };
  protoOf(DragSystem).w1o = function () {
    return this.a35_1;
  };
  protoOf(DragSystem).setPostProcessStrategy = function (postProcessDragStrategy) {
    this.y34_1 = postProcessDragStrategy;
  };
  protoOf(DragSystem).getDragStrategies = function () {
    return this.x34_1;
  };
  function _get_viewer__pq1i9z($this) {
    return $this.k35_1.coreModules.viewer();
  }
  function updateGhost($this, dragState) {
    var entity = dragState.draggedRootEntity;
    var transform = dragState.dragEndTransform;
    var offset = dragState.rayFromCameraToDragPoint.direction.times(0.4);
    if ($this.p35_1 == null) {
      $this.p35_1 = createGhost($this, entity);
      var tmp0_safe_receiver = $this.p35_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.setVisible(true);
    }
    var tmp1_safe_receiver = $this.p35_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.DrawDragGhostSystem.updateGhost.<anonymous>' call
      tmp1_safe_receiver.setPosition(transform.position.plus(offset)).setRotation(transform.rotation);
    }
  }
  function createGhost($this, entity) {
    var rootEntityTransform = get_worldTransform(entity);
    var tmp0_safe_receiver = _get_viewer__pq1i9z($this);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createEmpty();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var rootNode = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = filterInHierarchy(entity, DrawDragGhostSystem$createGhost$lambda);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.DrawDragGhostSystem.createGhost.<anonymous>' call
      var tmp0_safe_receiver_0 = element.__getComponentForKotlin(13);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_safe_receiver_1 = tmp0_safe_receiver_0.modelUrl;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_0;
          if (get_isPropping(entity)) {
            tmp_0 = Companion_getInstance_3().EMPTY_AABB;
          } else {
            var tmp0_safe_receiver_2 = get_colliderShapeComponent(entity);
            var tmp1_safe_receiver = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.polyhedron;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
            tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_3().EMPTY_AABB : tmp2_elvis_lhs;
          }
          var aabb = tmp_0;
          var tmp3_safe_receiver = entity.__getComponentForKotlin(Companion_instance_14.id);
          var modelTransform = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.transform;
          var tmp_1 = get_worldTransform(element).delta(rootEntityTransform);
          var tmp5_elvis_lhs = modelTransform == null ? null : modelTransform.transform;
          var deltaTransform = tmp_1.concatenate(tmp5_elvis_lhs == null ? Companion_getInstance_5().IDENTITY : tmp5_elvis_lhs);
          var tmp7_elvis_lhs = modelTransform == null ? null : modelTransform.scale;
          var scale = tmp7_elvis_lhs == null ? Companion_getInstance_4().ONE : tmp7_elvis_lhs;
          var onModelLoaded = DrawDragGhostSystem$createGhost$lambda_0(scale, deltaTransform, rootNode);
          var tmp8_safe_receiver = _get_viewer__pq1i9z($this);
          if (tmp8_safe_receiver == null)
            null;
          else {
            tmp8_safe_receiver.createGhostModel(tmp0_safe_receiver_1, onModelLoaded, $this.l35_1, $this.m35_1, $this.n35_1, $this.o35_1, aabb.size);
          }
        }
      }
    }
    return rootNode;
  }
  function Companion_29() {
    this.ID = 'DrawDragGhostSystem';
    this.OFFSET_ALONG_VIEW_DIRECTION = 0.4;
  }
  protoOf(Companion_29).u1n = function () {
    return this.ID;
  };
  protoOf(Companion_29).r35 = function () {
    return this.OFFSET_ALONG_VIEW_DIRECTION;
  };
  var Companion_instance_62;
  function Companion_getInstance_38() {
    return Companion_instance_62;
  }
  function DrawDragGhostSystem$createGhost$lambda(it) {
    return it.hasComponent(13);
  }
  function DrawDragGhostSystem$createGhost$lambda_0($scale, $deltaTransform, $rootNode) {
    return function (viewerObject) {
      viewerObject.setScaleV($scale).setPosition($deltaTransform.position).setRotation($deltaTransform.rotation).setVisible(true).setParent($rootNode);
      return Unit_instance;
    };
  }
  function DrawDragGhostSystem(coreServices, r, g, b, alpha) {
    r = r === VOID ? 0.0 : r;
    g = g === VOID ? 0.0 : g;
    b = b === VOID ? 1.0 : b;
    alpha = alpha === VOID ? 0.5 : alpha;
    SystemBase.call(this, 'DrawDragGhostSystem', 69);
    this.k35_1 = coreServices;
    this.l35_1 = r;
    this.m35_1 = g;
    this.n35_1 = b;
    this.o35_1 = alpha;
    this.p35_1 = null;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q35_1 = [];
  }
  protoOf(DrawDragGhostSystem).onAddComponent = function (entity, newComponent) {
    updateGhost(this, newComponent.dragState);
  };
  protoOf(DrawDragGhostSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    updateGhost(this, newComponent.dragState);
  };
  protoOf(DrawDragGhostSystem).onRemoveComponent = function (entity, oldComponent) {
    var tmp0_safe_receiver = this.p35_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.deleteObject();
    }
    this.p35_1 = null;
  };
  protoOf(DrawDragGhostSystem).w1o = function () {
    return this.q35_1;
  };
  function HigherPriorityAlignmentPostProcess(coreServices) {
    this.s35_1 = coreServices;
  }
  protoOf(HigherPriorityAlignmentPostProcess).performPostProcess = function (validResult, dragState) {
    TransformUtils_instance.setWorldTransform(dragState.draggedRootEntity, validResult.snapCandidate.endTransform);
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = SnapUtils_instance.matchingSnapActionCandidatesInScene(dragState.draggedRootEntity, this.s35_1.sceneManager);
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
        if (!(element.alignmentInitiatorCandidate == null)) {
          destination.q(element);
        }
      }
      // Inline function 'kotlin.collections.filterTo' call
      var this_1 = toList_0(destination);
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator = this_1.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
        if (element_0.priority > validResult.snapCandidate.priority) {
          destination_0.q(element_0);
        }
      }
      var iterator = destination_0.t();
      if (!iterator.u()) {
        tmp$ret$6 = null;
        break $l$block_0;
      }
      var maxElem = iterator.w();
      if (!iterator.u()) {
        tmp$ret$6 = maxElem;
        break $l$block_0;
      }
      // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
      var maxValue = maxElem.priority;
      do {
        var e = iterator.w();
        // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
        var v = e.priority;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator.u());
      tmp$ret$6 = maxElem;
    }
    var tmp0_safe_receiver = tmp$ret$6;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.HigherPriorityAlignmentPostProcess.performPostProcess.<anonymous>' call
      tmp = this.s35_1.validations.evaluateSnapCandidate(tmp0_safe_receiver);
    }
    var newCandidateResult = tmp;
    var validCandidate = newCandidateResult == null ? null : newCandidateResult.snapActionCandidate;
    if (!(validCandidate == null)) {
      var newValidResult = new ValidDragStrategyResult(validCandidate.guestRoot, validCandidate, newCandidateResult.warnings);
      return newValidResult;
    }
    return validResult;
  };
  function IsDraggedComponent() {
    this.t35_1 = false;
  }
  protoOf(IsDraggedComponent).x1k = function () {
    return this.id;
  };
  protoOf(IsDraggedComponent).s1k = function () {
    return 65;
  };
  protoOf(IsDraggedComponent).a1l = function () {
    return this.t35_1;
  };
  protoOf(IsDraggedComponent).eq = function (other) {
    return true;
  };
  var IsDraggedComponent_instance;
  function IsDraggedComponent_getInstance() {
    return IsDraggedComponent_instance;
  }
  function get_isBeingDragged(_this__u8e3s4) {
    var tmp0_safe_receiver = get_snapRoot(_this__u8e3s4);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.hasComponent(65);
    }
    return tmp === true;
  }
  function PostProcessDragStrategy() {
  }
  function Companion_30() {
    this.u35_1 = 'TakeSnapshotBeforeDragSystem';
  }
  var Companion_instance_63;
  function Companion_getInstance_39() {
    return Companion_instance_63;
  }
  function TakeSnapshotBeforeDragSystem(coreServices) {
    SystemBase.call(this, 'TakeSnapshotBeforeDragSystem', 85);
    this.d36_1 = coreServices;
  }
  protoOf(TakeSnapshotBeforeDragSystem).onAddComponent = function (entity, newComponent) {
    if (get_snapRoot(entity) == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.d36_1.coreModules.history();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.takeSnapshot('drag start');
    }
  };
  function _get_validationService__6mut63($this) {
    return $this.coreServices.validations;
  }
  function AbstractDragStrategy() {
    this.u31_1 = true;
  }
  protoOf(AbstractDragStrategy).p1i = function () {
    return this.coreServices.entityManager;
  };
  protoOf(AbstractDragStrategy).y1n = function () {
    return this.u31_1;
  };
  protoOf(AbstractDragStrategy).enable = function () {
    this.u31_1 = true;
  };
  protoOf(AbstractDragStrategy).disable = function () {
    this.u31_1 = false;
  };
  protoOf(AbstractDragStrategy).v31 = function (guestEntity, hostEntity) {
    var tmp0_elvis_lhs = get_snapRoot(guestEntity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_instance_15.noSnappingEntity(guestEntity);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var snappingGuest = tmp;
    var snapsByDistance = SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_DISTANCE.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(snappingGuest, hostEntity));
    var tmp1_elvis_lhs = firstOrNull_0(snapsByDistance);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Companion_instance_15.noSnapCandidates(guestEntity);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var snapActionCandidate = tmp_0;
    return _get_validationService__6mut63(this).evaluateSnapCandidate(snapActionCandidate);
  };
  protoOf(AbstractDragStrategy).w31 = function (guestEntity) {
    var tmp0_elvis_lhs = get_snapRoot(guestEntity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_instance_15.noSnappingEntity(guestEntity);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var snappingGuest = tmp;
    var snapsByDistance = SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_DISTANCE.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidatesInScene(snappingGuest, this.coreServices.sceneManager));
    var tmp1_elvis_lhs = firstOrNull_0(snapsByDistance);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Companion_instance_15.noSnapCandidates(guestEntity);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var snapActionCandidate = tmp_0;
    return _get_validationService__6mut63(this).evaluateSnapCandidate(snapActionCandidate);
  };
  function DragStrategy() {
  }
  function FreeMoveComponent() {
    this.id = 67;
  }
  protoOf(FreeMoveComponent).x1k = function () {
    return 67;
  };
  protoOf(FreeMoveComponent).eq = function (other) {
    return true;
  };
  protoOf(FreeMoveComponent).s1k = function () {
    return this.id;
  };
  var FreeMoveComponent_instance;
  function FreeMoveComponent_getInstance() {
    return FreeMoveComponent_instance;
  }
  function FreeMoveDragStrategy(coreServices) {
    AbstractDragStrategy.call(this);
    this.f36_1 = coreServices;
    this.g36_1 = 'FreeMoveDragStrategy';
  }
  protoOf(FreeMoveDragStrategy).k2z = function () {
    return this.f36_1;
  };
  protoOf(FreeMoveDragStrategy).mb = function () {
    return this.g36_1;
  };
  protoOf(FreeMoveDragStrategy).dragMove = function (dragState) {
    if (!dragState.draggedRootEntity.hasComponent(67)) {
      return null;
    }
    var tmp0_safe_receiver = get_highestPriorityConnection(dragState.draggedRootEntity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectorEntity;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_parent(dragState.draggedRootEntity) : tmp1_elvis_lhs;
    var currentHost = tmp2_elvis_lhs == null ? this.f36_1.sceneManager.scene : tmp2_elvis_lhs;
    var snap = SnapUtils_instance.createForcedSnapActionCandidate(dragState.draggedRootEntity, currentHost);
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return new ValidDragStrategyResult(dragState.draggedRootEntity, snap, tmp$ret$0);
  };
  function findSnapWhereEntityDoesNotCollide($this, draggedEntity, delta) {
    var tmp0_elvis_lhs = get_snapRoot(draggedEntity);
    var entity = tmp0_elvis_lhs == null ? draggedEntity : tmp0_elvis_lhs;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = CollisionUtils_instance.getAllCollisions(entity, delta, hierarchyExceptSubTreeArray($this.j36_1.sceneManager.root, entity));
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.dragstrategy.ResolveCollisionsDragStrategy.findSnapWhereEntityDoesNotCollide.<anonymous>' call
      var validSnapResult = null;
      var snapResult = $this.v31(entity, element.other);
      if (snapResult.valid) {
        validSnapResult = snapResult;
      } else {
        var tmp0_safe_receiver = get_snapRoot(draggedEntity);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
        var worldTransformBefore = tmp1_elvis_lhs == null ? Companion_getInstance_5().IDENTITY : tmp1_elvis_lhs;
        var testTransform = new Transform(get_worldPosition(draggedEntity).plus(element.interpenetration), get_worldTransform(draggedEntity).rotation);
        TransformUtils_instance.setWorldTransform(draggedEntity, testTransform);
        var snapToAnythingSnapResult = $this.w31(draggedEntity);
        if (snapToAnythingSnapResult.valid)
          validSnapResult = snapToAnythingSnapResult;
        TransformUtils_instance.setWorldTransform(draggedEntity, worldTransformBefore);
      }
      if (!(validSnapResult == null))
        return validSnapResult;
    }
    return null;
  }
  function hasConnectionThatDemandsContinuous($this, entity) {
    return !($this.i36_1 === -1) ? entity.hasComponent($this.i36_1) : false;
  }
  function ResolveCollisionsDragStrategy(resolveCollisionFeatureTag, coreServices) {
    AbstractDragStrategy.call(this);
    this.i36_1 = resolveCollisionFeatureTag;
    this.j36_1 = coreServices;
    this.k36_1 = 'ResolveCollisionsDragStrategy';
    this.l36_1 = false;
  }
  protoOf(ResolveCollisionsDragStrategy).k2z = function () {
    return this.j36_1;
  };
  protoOf(ResolveCollisionsDragStrategy).mb = function () {
    return this.k36_1;
  };
  protoOf(ResolveCollisionsDragStrategy).dragStart = function (draggedRootEntity) {
    this.l36_1 = hasConnectionThatDemandsContinuous(this, draggedRootEntity);
  };
  protoOf(ResolveCollisionsDragStrategy).dragStop = function (draggedRootEntity) {
    this.l36_1 = false;
  };
  protoOf(ResolveCollisionsDragStrategy).dragMove = function (dragState) {
    if (!this.l36_1) {
      return null;
    }
    var lastValidWorld = dragState.lastValidWorldTransform;
    var delta = dragState.dragEndTransform.position.minus(lastValidWorld.position);
    var validSnapResult = findSnapWhereEntityDoesNotCollide(this, dragState.draggedRootEntity, delta);
    var dragStrategyResult = Companion_instance_64.fromSnapResult(validSnapResult);
    return dragStrategyResult;
  };
  function tryLocalDirection($this, localDirection, host, draggedEntity, lastValidWorld, dragDelta, hostConnectorWorld) {
    var dragDeltaProjectedLocally = dragDelta.projectOn(hostConnectorWorld.transformVector(localDirection));
    var candidatePosition = lastValidWorld.position.plus(dragDeltaProjectedLocally);
    TransformUtils_instance.setWorldTransform(draggedEntity, new Transform(candidatePosition, get_worldTransform(draggedEntity).rotation));
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var indexedObject = SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(draggedEntity, host));
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapCardinalDirectionsDragStrategy.tryLocalDirection.<anonymous>' call
        if (element.inActivationDistance()) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var localProjectedCandidate = tmp$ret$1;
    var tmp;
    if (localProjectedCandidate == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapCardinalDirectionsDragStrategy.tryLocalDirection.<anonymous>' call
      tmp = $this.o36_1.evaluateSnapCandidate(localProjectedCandidate);
    }
    var result = tmp;
    var dragStrategyResult = Companion_instance_64.fromSnapResult(result);
    return dragStrategyResult;
  }
  function SnapCardinalDirectionsDragStrategy(coreServices) {
    AbstractDragStrategy.call(this);
    this.n36_1 = coreServices;
    this.o36_1 = this.n36_1.validations;
    this.p36_1 = 'SnapCardinalDirectionsDragStrategy';
  }
  protoOf(SnapCardinalDirectionsDragStrategy).k2z = function () {
    return this.n36_1;
  };
  protoOf(SnapCardinalDirectionsDragStrategy).mb = function () {
    return this.p36_1;
  };
  protoOf(SnapCardinalDirectionsDragStrategy).dragMove = function (dragState) {
    var draggedEntity = dragState.draggedRootEntity;
    var tmp0_safe_receiver = dragState.validDragStrategyResult;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.snapCandidate;
    var tmp3_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hostConnector;
    var tmp;
    if (tmp3_elvis_lhs == null) {
      var tmp2_safe_receiver = get_highestPriorityConnection(draggedEntity);
      tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hostConnector;
    } else {
      tmp = tmp3_elvis_lhs;
    }
    var tmp4_elvis_lhs = tmp;
    var tmp_0;
    if (tmp4_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp4_elvis_lhs;
    }
    var hostConnector = tmp_0;
    if (!(hostConnector instanceof SurfaceConnector))
      return null;
    var tmp5_safe_receiver = dragState.validDragStrategyResult;
    var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.snapCandidate;
    var tmp8_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.host;
    var tmp_1;
    if (tmp8_elvis_lhs == null) {
      var tmp7_safe_receiver = get_highestPriorityConnection(draggedEntity);
      tmp_1 = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.hostConnectorEntity;
    } else {
      tmp_1 = tmp8_elvis_lhs;
    }
    var tmp9_elvis_lhs = tmp_1;
    var tmp_2;
    if (tmp9_elvis_lhs == null) {
      return null;
    } else {
      tmp_2 = tmp9_elvis_lhs;
    }
    var host = tmp_2;
    var lastValidWorldTransform = dragState.lastValidWorldTransform;
    var dragDelta = dragState.dragEndTransform.position.minus(lastValidWorldTransform.position);
    var hostConnectorWorld = get_worldTransform(host).concatenate(hostConnector.transform);
    var horizontalResult = tryLocalDirection(this, Companion_getInstance_4().RIGHT, host, draggedEntity, lastValidWorldTransform, dragDelta, hostConnectorWorld);
    if (!(horizontalResult == null))
      return horizontalResult;
    var verticalResult = tryLocalDirection(this, Companion_getInstance_4().FORWARD, host, draggedEntity, lastValidWorldTransform, dragDelta, hostConnectorWorld);
    if (!(verticalResult == null))
      return verticalResult;
    return null;
  };
  function sortedSnaps($this, entity) {
    var includeAlignment = $this.includeAlignmentConnectorsOutsideActivationDistance;
    var tmp0_safe_receiver = get_snapRoot(entity);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestDragStrategy.sortedSnaps.<anonymous>' call
      tmp = SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidatesInScene(tmp0_safe_receiver, $this.r36_1.sceneManager, new SnapSettings(VOID, VOID, VOID, includeAlignment)));
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var matchingSnapActionCandidates = tmp_0;
    return toList(matchingSnapActionCandidates);
  }
  function SnapClosestDragStrategy(coreServices) {
    AbstractDragStrategy.call(this);
    this.r36_1 = coreServices;
    this.includeAlignmentConnectorsOutsideActivationDistance = false;
    this.s36_1 = 'SnapClosestDragStrategy';
    this.t36_1 = this.r36_1.validations;
    this.rotationCostInMm = 500.0;
  }
  protoOf(SnapClosestDragStrategy).k2z = function () {
    return this.r36_1;
  };
  protoOf(SnapClosestDragStrategy).u36 = function (_set____db54di) {
    this.includeAlignmentConnectorsOutsideActivationDistance = _set____db54di;
  };
  protoOf(SnapClosestDragStrategy).u2r = function () {
    return this.includeAlignmentConnectorsOutsideActivationDistance;
  };
  protoOf(SnapClosestDragStrategy).mb = function () {
    return this.s36_1;
  };
  protoOf(SnapClosestDragStrategy).v36 = function (_set____db54di) {
    this.rotationCostInMm = _set____db54di;
  };
  protoOf(SnapClosestDragStrategy).w36 = function () {
    return this.rotationCostInMm;
  };
  protoOf(SnapClosestDragStrategy).dragMove = function (dragState) {
    var snapCandidates = sortedSnaps(this, dragState.draggedRootEntity);
    var distanceToLastValidSnap = dragState.lastValidWorldTransform.position.minus(dragState.dragEndTransform.position).size;
    var foundSnap = null;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = snapCandidates.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestDragStrategy.dragMove.<anonymous>' call
      var tmp0_safe_receiver = element.alignmentInitiatorCandidate;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestDragStrategy.dragMove.<anonymous>.<anonymous>' call
        tmp = tmp0_safe_receiver.hostConnector.activationDistance + tmp0_safe_receiver.guestConnector.activationDistance;
      }
      var tmp1_elvis_lhs = tmp;
      var activationDistance = tmp1_elvis_lhs == null ? element.hostConnector.activationDistance + element.guestConnector.activationDistance : tmp1_elvis_lhs;
      var deltaRotation = dragState.lastValidWorldTransform.rotation.inverse().times(element.endTransform.rotation);
      var distanceFromEndDragToSnap = element.endTransform.position.minus(dragState.dragEndTransform.position).size + (deltaRotation.almostEquals(Companion_getInstance_6().IDENTITY) ? 0.0 : this.rotationCostInMm);
      var isCloserThanLastValidSnap = distanceFromEndDragToSnap - activationDistance < distanceToLastValidSnap;
      if (isCloserThanLastValidSnap) {
        destination.q(element);
      }
    }
    var tmp0_iterator_0 = destination.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestDragStrategy.dragMove.<anonymous>' call
      if (foundSnap == null) {
        var res = this.t36_1.evaluateSnapCandidate(element_0);
        if (res.valid) {
          foundSnap = res;
        }
      }
    }
    var dragStrategyResult = Companion_instance_64.fromSnapResult(foundSnap);
    return dragStrategyResult;
  };
  function findValidSnapAmongSubConnectors($this, entity, rayFromCameraToDragPoint) {
    var tmp0_elvis_lhs = findHoveredHost($this, entity, rayFromCameraToDragPoint);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var hoveredHost = tmp;
    var result = {_v: null};
    forEachInHierarchy(hoveredHost, SnapClosestWithSubConnectorsDragStrategy$findValidSnapAmongSubConnectors$lambda(result, $this, entity));
    var dragResult = Companion_instance_64.fromSnapResult(result._v);
    return dragResult;
  }
  function findHoveredHost($this, entity, rayFromCameraToDragPoint) {
    var tmp0_elvis_lhs = RaycastUtils_instance.raycast(rayFromCameraToDragPoint, $this.b37_1.root, entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    return findWithComponentInUpwardsHierarchy(result.entity, FrameComponent_getInstance().id);
  }
  function sortedSnaps_0($this, entity, host) {
    var tmp0_safe_receiver = get_snapRoot(entity);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestWithSubConnectorsDragStrategy.sortedSnaps.<anonymous>' call
      tmp = SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(tmp0_safe_receiver, host, new SnapSettings(true)));
    }
    var matchingSnapActionCandidates = tmp;
    return matchingSnapActionCandidates;
  }
  function SnapClosestWithSubConnectorsDragStrategy$findValidSnapAmongSubConnectors$lambda($result, this$0, $entity) {
    return function (host) {
      var tmp;
      if ($result._v == null) {
        var tmp0_safe_receiver = sortedSnaps_0(this$0, $entity, host);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable = 0;
          var last = tmp0_safe_receiver.length;
          while (inductionVariable < last) {
            var element = tmp0_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.stl.dragging.dragstrategy.SnapClosestWithSubConnectorsDragStrategy.findValidSnapAmongSubConnectors.<anonymous>.<anonymous>' call
            if ($result._v == null) {
              var res = this$0.a37_1.evaluateSnapCandidate(element, true);
              if (res.valid) {
                $result._v = res;
              }
            }
          }
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SnapClosestWithSubConnectorsDragStrategy(coreServices) {
    AbstractDragStrategy.call(this);
    this.y36_1 = coreServices;
    this.z36_1 = 'SnapClosestWithSubConnectorsDragStrategy';
    this.a37_1 = this.y36_1.validations;
    this.b37_1 = this.y36_1.sceneManager;
  }
  protoOf(SnapClosestWithSubConnectorsDragStrategy).k2z = function () {
    return this.y36_1;
  };
  protoOf(SnapClosestWithSubConnectorsDragStrategy).mb = function () {
    return this.z36_1;
  };
  protoOf(SnapClosestWithSubConnectorsDragStrategy).dragMove = function (dragState) {
    return findValidSnapAmongSubConnectors(this, dragState.draggedRootEntity, dragState.rayFromCameraToDragPoint);
  };
  function Companion_31() {
  }
  protoOf(Companion_31).fromSnapResult = function (result) {
    var validCandidate = result == null ? null : result.snapActionCandidate;
    var tmp;
    if (validCandidate == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.dragstrategy.Companion.fromSnapResult.<anonymous>' call
      tmp = new ValidDragStrategyResult(validCandidate.guestRoot, validCandidate, result.warnings);
    }
    return tmp;
  };
  var Companion_instance_64;
  function Companion_getInstance_40() {
    return Companion_instance_64;
  }
  function ValidDragStrategyResult(entity, snapCandidate, warnings) {
    this.entity = entity;
    this.snapCandidate = snapCandidate;
    var tmp = this;
    var tmp_0;
    if (warnings == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = warnings;
    }
    tmp.warnings = tmp_0;
  }
  protoOf(ValidDragStrategyResult).r23 = function () {
    return this.entity;
  };
  protoOf(ValidDragStrategyResult).x31 = function () {
    return this.snapCandidate;
  };
  protoOf(ValidDragStrategyResult).r2t = function () {
    return this.warnings;
  };
  protoOf(ValidDragStrategyResult).performFinalSnapAction = function (state, coreServices) {
    var snapCandidate = this.snapCandidate.withInitialTransform(state.initialTransform);
    var hasTransformChange = !get_worldTransform(snapCandidate.guest).equals(state.initialTransform);
    var hasParentChange = !equals(get_parent(snapCandidate.guest), snapCandidate.host);
    var tmp;
    if (hasTransformChange ? true : hasParentChange) {
      snapCandidate.createAction().perform();
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function CanvasTo3DDragConverterSystem_init_$Init$(coreServices, projector, $this) {
    CanvasTo3DDragConverterSystem.call($this, coreServices.entityManager, coreServices.sceneManager, projector);
    return $this;
  }
  function CanvasTo3DDragConverterSystemFromCoreServices(coreServices, projector) {
    return CanvasTo3DDragConverterSystem_init_$Init$(coreServices, projector, objectCreate(protoOf(CanvasTo3DDragConverterSystem)));
  }
  function vectorFromGrabPointToDragPoint($this, entity, grabPoint) {
    var tmp0_elvis_lhs = get_draggableRootEntity(entity);
    var dragRoot = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    return get_dragProjectionPoint(dragRoot).minus(grabPoint);
  }
  function sendDragEvent($this, entity, currentlyDraggedEntity, event) {
    adjustDragOffsetWhenRotationChanges($this, entity, currentlyDraggedEntity, $this.p37_1);
    var worldGrabOffset = get_worldTransform(entity).transformVector(getLocalGrabOffset($this, entity));
    var offsetRay = Companion_instance_16.createFromPoints(event.cameraPosition, event.planePoint.plus(worldGrabOffset));
    var tmp0_elvis_lhs = $this.m37_1.project(offsetRay, entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var projectionHit = tmp;
    var movementDelta = projectionHit.minus(get_dragProjectionPoint(currentlyDraggedEntity));
    var newWorldPosition = get_worldPosition(currentlyDraggedEntity).plus(movementDelta);
    $this.p37_1 = calculateEndTransform_0($this, currentlyDraggedEntity, newWorldPosition);
    var ray = Companion_instance_16.createFromPoints(event.cameraPosition, newWorldPosition);
    var moveDragEvent = new WorldSpaceDragEventComponent(newWorldPosition, ray);
    $this.k37_1.addComponent(entity, moveDragEvent);
  }
  function getLocalGrabOffset($this, entity) {
    var grabOffsetComponent = entity.__getComponentForKotlin(94);
    var tmp1_elvis_lhs = grabOffsetComponent == null ? null : grabOffsetComponent.localGrabOffset;
    var localGrabOffset = tmp1_elvis_lhs == null ? Companion_getInstance_4().ZERO : tmp1_elvis_lhs;
    return localGrabOffset;
  }
  function findCurrentlyDraggedEntity($this) {
    var tmp = $this.l37_1.scene;
    var dragStateComponent = tmp.__getComponentForKotlin(69);
    var tmp1_safe_receiver = dragStateComponent == null ? null : dragStateComponent.dragState;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.validDragStrategyResult;
    var candidateSnapAction = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.snapCandidate;
    var tmp4_safe_receiver = candidateSnapAction == null ? null : candidateSnapAction.guest;
    var tmp7_elvis_lhs = tmp4_safe_receiver == null ? null : get_draggableRootEntity(tmp4_safe_receiver);
    var tmp_0;
    if (tmp7_elvis_lhs == null) {
      var tmp6_safe_receiver = dragStateComponent == null ? null : dragStateComponent.dragState;
      tmp_0 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.draggedRootEntity;
    } else {
      tmp_0 = tmp7_elvis_lhs;
    }
    var realEntity = tmp_0;
    return realEntity;
  }
  function calculateEndTransform_0($this, entity, newPoint) {
    var tmp0_safe_receiver = get_snapRoot(entity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
    var currentTransform = tmp1_elvis_lhs == null ? get_worldTransform(entity) : tmp1_elvis_lhs;
    return new Transform(newPoint, currentTransform.rotation);
  }
  function adjustDragOffsetWhenRotationChanges($this, entity, realEntity, lastTransform) {
    var tmp0_elvis_lhs = get_draggableRootEntity(realEntity);
    var dragRoot = tmp0_elvis_lhs == null ? realEntity : tmp0_elvis_lhs;
    var currentTransform = get_worldTransform(dragRoot);
    if (!lastTransform.rotation.almostEquals(currentTransform.rotation)) {
      var localZRotationDelta = lastTransform.delta(currentTransform).rotation.eulerDegrees.Z;
      if (almostEquals(localZRotationDelta, 180.0) ? true : almostEquals(localZRotationDelta, -180.0)) {
        var tmp1_safe_receiver = entity.__getComponentForKotlin(94);
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.localGrabOffset;
        var oldOffset = tmp2_elvis_lhs == null ? Companion_getInstance_4().ZERO : tmp2_elvis_lhs;
        var newOffset = oldOffset.with(-oldOffset.X, -oldOffset.Y);
        entity.addComponent(new GrabOffsetComponent(newOffset));
      }
    }
  }
  function Companion_32() {
    Companion_instance_65 = this;
    this.ID = 'CanvasTo3DDragConverterSystem';
    this.s37_1 = LoggerState_getInstance().m1m('CanvasTo3DDragConverterSystem');
  }
  protoOf(Companion_32).u1n = function () {
    return this.ID;
  };
  var Companion_instance_65;
  function Companion_getInstance_41() {
    if (Companion_instance_65 == null)
      new Companion_32();
    return Companion_instance_65;
  }
  function CanvasTo3DDragConverterSystem(entityManager, sceneManager, projector) {
    Companion_getInstance_41();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [94, 85];
    SystemBase.call(this, 'CanvasTo3DDragConverterSystem', 84, tmp$ret$2);
    this.k37_1 = entityManager;
    this.l37_1 = sceneManager;
    this.m37_1 = projector;
    this.n37_1 = new DragSurfacesUpdateSystem(this.k37_1);
    this.o37_1 = new DragSurfaceUpdatesListenerSystem(this.m37_1, this.l37_1);
    this.p37_1 = Companion_getInstance_5().IDENTITY;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q37_1 = [85];
  }
  protoOf(CanvasTo3DDragConverterSystem).onRegister = function () {
    protoOf(SystemBase).onRegister.call(this);
    this.n37_1.register(this.k37_1);
    this.o37_1.register(this.k37_1);
  };
  protoOf(CanvasTo3DDragConverterSystem).onUnregister = function () {
    protoOf(SystemBase).onUnregister.call(this);
    this.n37_1.unregister(this.k37_1);
    this.o37_1.unregister(this.k37_1);
  };
  protoOf(CanvasTo3DDragConverterSystem).enable = function () {
    protoOf(SystemBase).enable.call(this);
    this.n37_1.enable();
    this.o37_1.enable();
  };
  protoOf(CanvasTo3DDragConverterSystem).disable = function () {
    protoOf(SystemBase).disable.call(this);
    this.n37_1.disable();
    this.o37_1.disable();
  };
  protoOf(CanvasTo3DDragConverterSystem).onAddComponent = function (entity, newComponent) {
    var tmp0_safe_receiver = get_draggableRootEntity(entity);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.CanvasTo3DDragConverterSystem.onAddComponent.<anonymous>' call
      var grabPoint = newComponent.planePoint;
      var worldGrabOffset = vectorFromGrabPointToDragPoint(this, entity, grabPoint);
      var localGrabOffset = get_worldTransform(entity).inverseTransformVector(worldGrabOffset);
      entity.addComponent(new GrabOffsetComponent(localGrabOffset));
      this.p37_1 = get_worldTransform(tmp0_safe_receiver);
      sendDragEvent(this, entity, tmp0_safe_receiver, newComponent);
    }
  };
  protoOf(CanvasTo3DDragConverterSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    var tmp0_elvis_lhs = findCurrentlyDraggedEntity(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var draggedEntity = tmp;
    sendDragEvent(this, entity, draggedEntity, newComponent);
  };
  protoOf(CanvasTo3DDragConverterSystem).onRemoveComponent = function (entity, oldComponent) {
    this.k37_1.removeComponent(entity, 85);
  };
  protoOf(CanvasTo3DDragConverterSystem).w1o = function () {
    return this.q37_1;
  };
  protoOf(CanvasTo3DDragConverterSystem).setProjector = function (converter) {
    this.m37_1 = converter;
  };
  protoOf(CanvasTo3DDragConverterSystem).getProjector = function () {
    return this.m37_1;
  };
  function get_dragProjectionPoint(_this__u8e3s4) {
    var tmp0_elvis_lhs = get_draggableRootEntity(_this__u8e3s4);
    var dragRoot = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    var tmp1_safe_receiver = dragRoot.__getComponentForKotlin(113);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return TransformUtils_instance.worldTransform(_this__u8e3s4).transformPosition(tmp1_safe_receiver.projectionPoint);
    }
    var outgoingConnections = ConnectionUtils_instance.getExistingOutgoingGuestConnections(dragRoot);
    var connectionPoint = any_0(outgoingConnections) ? centerOfConnections(outgoingConnections) : get_worldPosition(_this__u8e3s4);
    return connectionPoint;
  }
  function DragSurfaceCanHostSelector$canProjectDragOn$lambda(snappingGuest) {
    var tmp0_safe_receiver = get_connectorsComponent(snappingGuest);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function DragSurfaceCanHostSelector() {
  }
  protoOf(DragSurfaceCanHostSelector).shouldBeTested = function (dragSurface) {
    return true;
  };
  protoOf(DragSurfaceCanHostSelector).canProjectDragOn = function (draggedEntity, dragSurface) {
    var tmp0_safe_receiver = get_connectorsComponent(dragSurface.entity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectors;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var hostConnectors = tmp;
    var tmp_0 = get_snappingGuestEntitiesSequence(draggedEntity);
    var childSequence = map(tmp_0, DragSurfaceCanHostSelector$canProjectDragOn$lambda);
    return this.hasMatchingConnector(childSequence, hostConnectors, dragSurface.connectorKeys);
  };
  protoOf(DragSurfaceCanHostSelector).hasMatchingConnector = function (guestConnectorSequence, hostConnectors, connectorKeys) {
    var tmp$ret$5;
    $l$block_3: {
      // Inline function 'kotlin.sequences.any' call
      var tmp0_iterator = guestConnectorSequence.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceCanHostSelector.hasMatchingConnector.<anonymous>' call
        var tmp$ret$0;
        $l$block_2: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(element, Collection)) {
            tmp = element.b1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          var tmp0_iterator_0 = element.t();
          while (tmp0_iterator_0.u()) {
            var element_0 = tmp0_iterator_0.w();
            // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceCanHostSelector.hasMatchingConnector.<anonymous>.<anonymous>' call
            var tmp$ret$1;
            $l$block_1: {
              // Inline function 'kotlin.collections.any' call
              var tmp_0;
              if (isInterface(hostConnectors, Collection)) {
                tmp_0 = hostConnectors.b1();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$1 = false;
                break $l$block_1;
              }
              var tmp0_iterator_1 = hostConnectors.t();
              while (tmp0_iterator_1.u()) {
                var element_1 = tmp0_iterator_1.w();
                // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceCanHostSelector.hasMatchingConnector.<anonymous>.<anonymous>.<anonymous>' call
                if ((connectorKeys == null ? true : contains(connectorKeys, element_1.key)) ? element_0.hasMatchingTags(element_1) : false) {
                  tmp$ret$1 = true;
                  break $l$block_1;
                }
              }
              tmp$ret$1 = false;
            }
            if (tmp$ret$1) {
              tmp$ret$0 = true;
              break $l$block_2;
            }
          }
          tmp$ret$0 = false;
        }
        if (tmp$ret$0) {
          tmp$ret$5 = true;
          break $l$block_3;
        }
      }
      tmp$ret$5 = false;
    }
    return tmp$ret$5;
  };
  function get_snappingGuestEntitiesSequence(_this__u8e3s4) {
    var tmp = hierarchyExceptSubTreesWithComponentSequence(_this__u8e3s4, 47);
    return filter(tmp, _get_snappingGuestEntitiesSequence_$lambda_24h0hk);
  }
  function _get_snappingGuestEntitiesSequence_$lambda_24h0hk(it) {
    var tmp0_safe_receiver = get_connectorsComponent(it);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
    return (tmp1_safe_receiver == null ? null : any(tmp1_safe_receiver)) === true;
  }
  function DragSurfaceEntityPair(entity, surface, connectorKeys) {
    this.entity = entity;
    this.surface = surface;
    this.connectorKeys = connectorKeys;
  }
  protoOf(DragSurfaceEntityPair).r23 = function () {
    return this.entity;
  };
  protoOf(DragSurfaceEntityPair).o23 = function () {
    return this.surface;
  };
  protoOf(DragSurfaceEntityPair).p23 = function () {
    return this.connectorKeys;
  };
  protoOf(DragSurfaceEntityPair).af = function () {
    return this.entity;
  };
  protoOf(DragSurfaceEntityPair).bf = function () {
    return this.surface;
  };
  protoOf(DragSurfaceEntityPair).g1k = function () {
    return this.connectorKeys;
  };
  protoOf(DragSurfaceEntityPair).t37 = function (entity, surface, connectorKeys) {
    return new DragSurfaceEntityPair(entity, surface, connectorKeys);
  };
  protoOf(DragSurfaceEntityPair).copy = function (entity, surface, connectorKeys, $super) {
    entity = entity === VOID ? this.entity : entity;
    surface = surface === VOID ? this.surface : surface;
    connectorKeys = connectorKeys === VOID ? this.connectorKeys : connectorKeys;
    return this.t37(entity, surface, connectorKeys);
  };
  protoOf(DragSurfaceEntityPair).toString = function () {
    return 'DragSurfaceEntityPair(entity=' + this.entity + ', surface=' + this.surface + ', connectorKeys=' + toString(this.connectorKeys) + ')';
  };
  protoOf(DragSurfaceEntityPair).hashCode = function () {
    var result = this.entity.hashCode();
    result = imul(result, 31) + hashCode(this.surface) | 0;
    result = imul(result, 31) + (this.connectorKeys == null ? 0 : hashCode(this.connectorKeys)) | 0;
    return result;
  };
  protoOf(DragSurfaceEntityPair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DragSurfaceEntityPair))
      return false;
    var tmp0_other_with_cast = other instanceof DragSurfaceEntityPair ? other : THROW_CCE();
    if (!this.entity.equals(tmp0_other_with_cast.entity))
      return false;
    if (!equals(this.surface, tmp0_other_with_cast.surface))
      return false;
    if (!equals(this.connectorKeys, tmp0_other_with_cast.connectorKeys))
      return false;
    return true;
  };
  function hasMatchingConnector($this, guestConnectorSequence, dragSurface) {
    var tmp$ret$3;
    $l$block_1: {
      // Inline function 'kotlin.sequences.any' call
      var tmp0_iterator = guestConnectorSequence.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceOnlyRoomSelector.hasMatchingConnector.<anonymous>' call
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(element, Collection)) {
            tmp = element.b1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator_0 = element.t();
          while (tmp0_iterator_0.u()) {
            var element_0 = tmp0_iterator_0.w();
            // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.DragSurfaceOnlyRoomSelector.hasMatchingConnector.<anonymous>.<anonymous>' call
            var tmp_0;
            var tmp_1;
            var tmp0_safe_receiver = dragSurface.connectorKeys;
            if ((tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver)) === 'floor') {
              var tmp_2 = element_0.demands();
              RoomConnectorConstants_getInstance();
              tmp_1 = !contains(tmp_2, 'floor');
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = false;
            } else {
              var tmp_3;
              var tmp1_safe_receiver = dragSurface.connectorKeys;
              if ((tmp1_safe_receiver == null ? null : firstOrNull_0(tmp1_safe_receiver)) === 'ceiling') {
                var tmp_4 = element_0.demands();
                RoomConnectorConstants_getInstance();
                tmp_3 = !contains(tmp_4, 'ceiling');
              } else {
                tmp_3 = false;
              }
              if (tmp_3) {
                tmp_0 = false;
              } else {
                tmp_0 = true;
              }
            }
            if (tmp_0) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        if (tmp$ret$0) {
          tmp$ret$3 = true;
          break $l$block_1;
        }
      }
      tmp$ret$3 = false;
    }
    return tmp$ret$3;
  }
  function Companion_33() {
    this.CEILING_CONNECTOR_KEY_PLACEHOLDER = 'ceiling';
    this.FLOOR_CONNECTOR_KEY_PLACEHOLDER = 'floor';
  }
  protoOf(Companion_33).u37 = function () {
    return this.CEILING_CONNECTOR_KEY_PLACEHOLDER;
  };
  protoOf(Companion_33).v37 = function () {
    return this.FLOOR_CONNECTOR_KEY_PLACEHOLDER;
  };
  protoOf(Companion_33).isFloorOrCeiling = function (dragSurface) {
    var tmp;
    var tmp0_safe_receiver = dragSurface.connectorKeys;
    if ((tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver)) === 'floor') {
      tmp = true;
    } else {
      var tmp1_safe_receiver = dragSurface.connectorKeys;
      tmp = (tmp1_safe_receiver == null ? null : firstOrNull_0(tmp1_safe_receiver)) === 'ceiling';
    }
    return tmp;
  };
  var Companion_instance_66;
  function Companion_getInstance_42() {
    return Companion_instance_66;
  }
  function DragSurfaceOnlyRoomSelector$canProjectDragOn$lambda(snappingGuest) {
    var tmp0_safe_receiver = get_connectorsComponent(snappingGuest);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestConnectors;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function DragSurfaceOnlyRoomSelector() {
  }
  protoOf(DragSurfaceOnlyRoomSelector).shouldBeTested = function (dragSurface) {
    return get_isRoom(dragSurface.entity) ? true : get_isRoomPart(dragSurface.entity);
  };
  protoOf(DragSurfaceOnlyRoomSelector).canProjectDragOn = function (draggedEntity, dragSurface) {
    var tmp = get_snappingGuestEntitiesSequence(draggedEntity);
    var guestConnectorSequence = map(tmp, DragSurfaceOnlyRoomSelector$canProjectDragOn$lambda);
    return hasMatchingConnector(this, guestConnectorSequence, dragSurface);
  };
  function DragSurfaceSelector() {
  }
  function calculateCursorDelta($this, entity, projectionHit) {
    var tmp0_elvis_lhs = get_draggableRootEntity(entity);
    var realEntity = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    return get_worldPosition(realEntity).minus(projectionHit);
  }
  function rotateDragPointCursorDelta($this, entity, lastTransform, projectionHit) {
    var tmp0_safe_receiver = get_snapRoot(entity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
    var currentTransform = tmp1_elvis_lhs == null ? get_worldTransform(entity) : tmp1_elvis_lhs;
    if (!lastTransform.rotation.almostEquals(currentTransform.rotation)) {
      $this.h38_1 = calculateCursorDelta($this, entity, projectionHit);
    }
  }
  function setEndTransform($this, entity, newPoint) {
    var tmp0_safe_receiver = get_snapRoot(entity);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
    var currentTransform = tmp1_elvis_lhs == null ? get_worldTransform(entity) : tmp1_elvis_lhs;
    return new Transform(newPoint.plus($this.h38_1), currentTransform.rotation);
  }
  function sendEvent($this, endTransform, cameraPosition, entity) {
    var moveDragEvent = new WorldSpaceDragEventComponent(endTransform.position, Companion_instance_16.createFromPoints(cameraPosition, endTransform.position));
    $this.e38_1.addComponent(entity, moveDragEvent);
  }
  function Companion_34() {
    this.ID = 'LegacyCanvasTo3DDragConverterSystem';
  }
  protoOf(Companion_34).u1n = function () {
    return this.ID;
  };
  var Companion_instance_67;
  function Companion_getInstance_43() {
    return Companion_instance_67;
  }
  function LegacyCanvasTo3DDragConverterSystem(entityManager, sceneManager, projector) {
    SystemBase.call(this, 'LegacyCanvasTo3DDragConverterSystem', 84);
    this.e38_1 = entityManager;
    this.f38_1 = projector;
    this.g38_1 = new DragSurfaceUpdatesListenerSystem(this.f38_1, sceneManager);
    this.h38_1 = Companion_getInstance_4().ZERO;
    this.i38_1 = Companion_getInstance_5().IDENTITY;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j38_1 = [85];
  }
  protoOf(LegacyCanvasTo3DDragConverterSystem).onRegister = function () {
    protoOf(SystemBase).onRegister.call(this);
    this.g38_1.register(this.e38_1);
  };
  protoOf(LegacyCanvasTo3DDragConverterSystem).onUnregister = function () {
    protoOf(SystemBase).onUnregister.call(this);
    this.g38_1.unregister(this.e38_1);
  };
  protoOf(LegacyCanvasTo3DDragConverterSystem).enable = function () {
    protoOf(SystemBase).enable.call(this);
    this.g38_1.enable();
  };
  protoOf(LegacyCanvasTo3DDragConverterSystem).disable = function () {
    protoOf(SystemBase).disable.call(this);
    this.g38_1.disable();
  };
  protoOf(LegacyCanvasTo3DDragConverterSystem).onAddComponent = function (entity, newComponent) {
    var tmp0_elvis_lhs = get_draggableRootEntity(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var draggedEntity = tmp;
    this.h38_1 = Companion_getInstance_4().ZERO;
    this.i38_1 = Companion_getInstance_5().IDENTITY;
    var tmp1_elvis_lhs = this.f38_1.project(newComponent.rayFromCameraToDragEnd, entity);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var projectionHit = tmp_0;
    this.h38_1 = calculateCursorDelta(this, entity, projectionHit);
    var endPoint = projectionHit.plus(this.h38_1);
    this.i38_1 = new Transform(endPoint, get_worldTransform(draggedEntity).rotation);
    sendEvent(this, this.i38_1, newComponent.cameraPosition, entity);
  };
  protoOf(LegacyCanvasTo3DDragConverterSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    var tmp0_elvis_lhs = get_draggableRootEntity(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var draggedEntity = tmp;
    var tmp1_elvis_lhs = this.f38_1.project(newComponent.rayFromCameraToDragEnd, entity);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var projectionHit = tmp_0;
    rotateDragPointCursorDelta(this, draggedEntity, this.i38_1, projectionHit);
    this.i38_1 = setEndTransform(this, draggedEntity, projectionHit);
    sendEvent(this, this.i38_1, newComponent.cameraPosition, entity);
  };
  protoOf(LegacyCanvasTo3DDragConverterSystem).onRemoveComponent = function (entity, oldComponent) {
    this.e38_1.removeComponent(entity, 85);
  };
  protoOf(LegacyCanvasTo3DDragConverterSystem).w1o = function () {
    return this.j38_1;
  };
  protoOf(LegacyCanvasTo3DDragConverterSystem).setProjector = function (projector) {
    this.f38_1 = projector;
  };
  protoOf(LegacyCanvasTo3DDragConverterSystem).getProjector = function () {
    return this.f38_1;
  };
  function checkIfWorldDragWasDetected($this) {
    if ($this.s38_1 ? !$this.t38_1 : false) {
      var tmp = Companion_getInstance_7().logger;
      tmp.warn(NoDragConverterDetector$checkIfWorldDragWasDetected$lambda);
    }
    $this.disable();
  }
  function NoDragConverterDetector$checkIfWorldDragWasDetected$lambda() {
    return 'No converter for canvas drags to 3d drags detected. Did you forget to initiate ' + 'CanvasTo3DDragConverterSystem' + ' ?';
  }
  function NoDragConverterDetector(entityManager) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    SystemBase2.call(this, 'NoDragConverterDetector', 84, 85, tmp$ret$2, null, null);
    this.register(entityManager);
    this.s38_1 = false;
    this.t38_1 = false;
  }
  protoOf(NoDragConverterDetector).onAddComponent = function (entity, newComponent) {
    this.s38_1 = true;
  };
  protoOf(NoDragConverterDetector).onUpdateComponent = function (entity, oldComponent, newComponent) {
    checkIfWorldDragWasDetected(this);
  };
  protoOf(NoDragConverterDetector).onRemoveComponent = function (entity, oldComponent) {
  };
  protoOf(NoDragConverterDetector).onAddComponent2 = function (entity, newComponent) {
    this.t38_1 = true;
  };
  protoOf(NoDragConverterDetector).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(NoDragConverterDetector).onRemoveComponent2 = function (entity, oldComponent) {
  };
  function Companion_35() {
    this.id = 113;
  }
  protoOf(Companion_35).s1k = function () {
    return this.id;
  };
  var Companion_instance_68;
  function Companion_getInstance_44() {
    return Companion_instance_68;
  }
  function DragProjectionPointComponent(projectionPoint) {
    this.projectionPoint = projectionPoint;
  }
  protoOf(DragProjectionPointComponent).u38 = function () {
    return this.projectionPoint;
  };
  protoOf(DragProjectionPointComponent).x1k = function () {
    return 113;
  };
  protoOf(DragProjectionPointComponent).eq = function (other) {
    return (other instanceof DragProjectionPointComponent ? other : THROW_CCE()).projectionPoint.equals(this.projectionPoint);
  };
  function Companion_36() {
    this.id = 94;
  }
  protoOf(Companion_36).s1k = function () {
    return this.id;
  };
  var Companion_instance_69;
  function Companion_getInstance_45() {
    return Companion_instance_69;
  }
  function GrabOffsetComponent(localGrabOffset) {
    this.localGrabOffset = localGrabOffset;
    this.r37_1 = 94;
  }
  protoOf(GrabOffsetComponent).v38 = function () {
    return this.localGrabOffset;
  };
  protoOf(GrabOffsetComponent).x1k = function () {
    return this.r37_1;
  };
  protoOf(GrabOffsetComponent).eq = function (other) {
    var tmp0_safe_receiver = other instanceof GrabOffsetComponent ? other : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.localGrabOffset;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.equals(this.localGrabOffset);
    return tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
  };
  protoOf(GrabOffsetComponent).af = function () {
    return this.localGrabOffset;
  };
  protoOf(GrabOffsetComponent).w38 = function (localGrabOffset) {
    return new GrabOffsetComponent(localGrabOffset);
  };
  protoOf(GrabOffsetComponent).copy = function (localGrabOffset, $super) {
    localGrabOffset = localGrabOffset === VOID ? this.localGrabOffset : localGrabOffset;
    return this.w38(localGrabOffset);
  };
  protoOf(GrabOffsetComponent).toString = function () {
    return 'GrabOffsetComponent(localGrabOffset=' + this.localGrabOffset + ')';
  };
  protoOf(GrabOffsetComponent).hashCode = function () {
    return this.localGrabOffset.hashCode();
  };
  protoOf(GrabOffsetComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GrabOffsetComponent))
      return false;
    var tmp0_other_with_cast = other instanceof GrabOffsetComponent ? other : THROW_CCE();
    if (!this.localGrabOffset.equals(tmp0_other_with_cast.localGrabOffset))
      return false;
    return true;
  };
  function AnyDragSurfaceProjector_init_$Init$(coreServices, dragSurfaceSelector, $this) {
    dragSurfaceSelector = dragSurfaceSelector === VOID ? new DragSurfaceOnlyRoomSelector() : dragSurfaceSelector;
    AnyDragSurfaceProjector.call($this, coreServices.sceneManager, coreServices.entityManager, dragSurfaceSelector);
    return $this;
  }
  function AnyDragSurfaceProjectorFromCoreServices(coreServices, dragSurfaceSelector) {
    return AnyDragSurfaceProjector_init_$Init$(coreServices, dragSurfaceSelector, objectCreate(protoOf(AnyDragSurfaceProjector)));
  }
  function _get_cachedSurfacesEntity__1g8lxc($this) {
    if ($this.d39_1.isDisposed) {
      $this.d39_1 = $this.y38_1.createEntity();
      initCachedServiceEntity($this);
    }
    return $this.d39_1;
  }
  function initCachedServiceEntity($this) {
    setParent($this.d39_1, $this.x38_1.scene);
    $this.d39_1.addComponent(new UnserializableEntityComponent());
    $this.d39_1.addComponent(new DisplayNameComponent('Drag Surface Cache'));
  }
  function getSurfaces($this) {
    var tmp0_safe_receiver = get_projectorSurfacesComponent(_get_cachedSurfacesEntity__1g8lxc($this));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.surfaces;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function getRoomSurfaces($this) {
    var tmp0_safe_receiver = get_projectorSurfacesComponent(_get_cachedSurfacesEntity__1g8lxc($this));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.roomSurfaces;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function addSurfacesToCache($this, surfaces, roomSurfaces) {
    var tmp0_elvis_lhs = get_projectorSurfacesComponent(_get_cachedSurfacesEntity__1g8lxc($this));
    var component = tmp0_elvis_lhs == null ? new DragSurfaceEntityPairsCacheComponent() : tmp0_elvis_lhs;
    var newSurfaces = plus_0(component.surfaces, surfaces);
    var newRoomSurfaces = plus_0(component.roomSurfaces, roomSurfaces);
    _get_cachedSurfacesEntity__1g8lxc($this).addComponentInternal(new DragSurfaceEntityPairsCacheComponent(newSurfaces, newRoomSurfaces));
  }
  function selectDragPlane($this, ray, draggedEntity) {
    var bestDist = Infinity;
    var oldRayHit = equals($this.b39_1, draggedEntity) ? $this.a39_1 : null;
    $this.a39_1 = null;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = getSurfaces($this);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      $l$block_0: {
        // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.selectDragPlane.<anonymous>' call
        var surfaceEntity = element.af();
        var surfacePlane = element.bf();
        if (surfaceEntity.equals(draggedEntity) ? true : isDescendantOf(surfaceEntity, draggedEntity)) {
          break $l$block_0;
        }
        var tmp1_elvis_lhs = surfacePlane.raycast(ray);
        var tmp;
        if (tmp1_elvis_lhs == null) {
          break $l$block_0;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var rayResult = tmp;
        if ($this.z38_1.canProjectDragOn(draggedEntity, element)) {
          var distance = rayResult.point.distanceTo(ray.origin);
          if (distance < bestDist) {
            bestDist = distance;
            $this.a39_1 = rayResult;
          }
        }
      }
    }
    if ($this.a39_1 == null) {
      $this.a39_1 = tryToFindHitPointOutsideDragSurfaces($this, draggedEntity, ray, oldRayHit);
    }
    $this.b39_1 = draggedEntity;
  }
  function tryToFindHitPointOutsideDragSurfaces($this, draggedEntity, ray, oldRayHit) {
    var bestRoomHit = raycastAgainstRoom($this, draggedEntity, ray);
    var currentExtendedDragPlaneHit = findRayHitByExtendingLastDragPlane($this, oldRayHit, ray);
    var onlyHitRoom = currentExtendedDragPlaneHit == null ? !(bestRoomHit == null) : false;
    var onlyHitExtendedPlane = !(currentExtendedDragPlaneHit == null) ? bestRoomHit == null : false;
    var hitBothRoomAndExtendedPlane = !(currentExtendedDragPlaneHit == null) ? !(bestRoomHit == null) : false;
    var tmp;
    if (onlyHitRoom) {
      tmp = bestRoomHit == null ? null : bestRoomHit.asRaycastResult();
    } else if (onlyHitExtendedPlane) {
      tmp = currentExtendedDragPlaneHit;
    } else if (hitBothRoomAndExtendedPlane) {
      tmp = bestRoomHit == null ? null : bestRoomHit.asRaycastResult();
    } else if (!(oldRayHit == null)) {
      tmp = oldRayHit;
    } else {
      tmp = new RaycastResult(get_worldPosition(draggedEntity), ray.direction);
    }
    return tmp;
  }
  function raycastAgainstRoom($this, draggedEntity, ray) {
    var bestRoomHit = null;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = getRoomSurfaces($this);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      $l$block_0: {
        // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.raycastAgainstRoom.<anonymous>' call
        var roomEntity = element.af();
        var roomPlane = element.bf();
        if (roomEntity.equals(draggedEntity) ? true : isDescendantOf(roomEntity, draggedEntity)) {
          break $l$block_0;
        }
        var tmp1_elvis_lhs = roomPlane.raycast(ray);
        var tmp;
        if (tmp1_elvis_lhs == null) {
          break $l$block_0;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var rayResult = tmp;
        var distance = rayResult.point.distanceTo(ray.origin);
        var tmp2_safe_receiver = bestRoomHit;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.distance;
        var tmp_0;
        if (tmp3_elvis_lhs == null) {
          tmp_0 = 1.7976931348623157E308;
        } else {
          tmp_0 = tmp3_elvis_lhs;
        }
        if (distance < tmp_0) {
          bestRoomHit = new RaycastHit(rayResult.point, roomEntity, distance, rayResult.surfaceNormal);
        }
      }
    }
    return bestRoomHit;
  }
  function findRayHitByExtendingLastDragPlane($this, oldRayHit, ray) {
    var currentExtendedDragPlaneHit = null;
    if (!(oldRayHit == null)) {
      var lastDragPlane = new Plane(oldRayHit.point, oldRayHit.surfaceNormal);
      var rayResult = lastDragPlane.raycast(ray);
      if (!(rayResult == null)) {
        currentExtendedDragPlaneHit = rayResult;
      }
    }
    return currentExtendedDragPlaneHit;
  }
  function Companion_37() {
    Companion_instance_70 = this;
    this.e39_1 = LoggerState_getInstance().m1m('AnyDragSurfaceProjector');
  }
  var Companion_instance_70;
  function Companion_getInstance_46() {
    if (Companion_instance_70 == null)
      new Companion_37();
    return Companion_instance_70;
  }
  function AnyDragSurfaceProjector(sceneManager, entityManager, dragSurfaceSelector) {
    Companion_getInstance_46();
    dragSurfaceSelector = dragSurfaceSelector === VOID ? new DragSurfaceOnlyRoomSelector() : dragSurfaceSelector;
    this.x38_1 = sceneManager;
    this.y38_1 = entityManager;
    this.z38_1 = dragSurfaceSelector;
    this.a39_1 = null;
    this.b39_1 = null;
    this.c39_1 = new DragSurfaceOnlyRoomSelector();
    this.d39_1 = this.y38_1.createEntity();
    initCachedServiceEntity(this);
  }
  protoOf(AnyDragSurfaceProjector).onDragSurfacesAdded = function (worldDragSurfacesComponent, entity) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = worldDragSurfacesComponent.surfaces;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
      var tmp$ret$0 = new DragSurfaceEntityPair(entity, item.surface, item.connectorKeys);
      destination.q(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
      if (!this.c39_1.shouldBeTested(element)) {
        destination_0.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = destination_0.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
      if (this.z38_1.shouldBeTested(element_0)) {
        destination_1.q(element_0);
      }
    }
    var surfaces = destination_1;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = worldDragSurfacesComponent.surfaces;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$_0(this_1.length);
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
      var tmp$ret$9 = new DragSurfaceEntityPair(entity, item_0.surface, item_0.connectorKeys);
      destination_2.q(tmp$ret$9);
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = destination_2.t();
    while (tmp0_iterator_1.u()) {
      var element_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesAdded.<anonymous>' call
      if (this.c39_1.shouldBeTested(element_1)) {
        destination_3.q(element_1);
      }
    }
    var roomSurfaces = destination_3;
    addSurfacesToCache(this, surfaces, roomSurfaces);
  };
  protoOf(AnyDragSurfaceProjector).onDragSurfacesRemoved = function (entity) {
    var tmp0_elvis_lhs = get_projectorSurfacesComponent(_get_cachedSurfacesEntity__1g8lxc(this));
    var component = tmp0_elvis_lhs == null ? new DragSurfaceEntityPairsCacheComponent() : tmp0_elvis_lhs;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = component.surfaces;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesRemoved.<anonymous>' call
      if (!element.entity.equals(entity)) {
        destination.q(element);
      }
    }
    var surfaces = copyToArray(destination);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = component.roomSurfaces;
    var destination_0 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.AnyDragSurfaceProjector.onDragSurfacesRemoved.<anonymous>' call
      if (!element_0.entity.equals(entity)) {
        destination_0.q(element_0);
      }
    }
    var roomSurfaces = copyToArray(destination_0);
    _get_cachedSurfacesEntity__1g8lxc(this).addComponentInternal(new DragSurfaceEntityPairsCacheComponent(surfaces, roomSurfaces));
  };
  protoOf(AnyDragSurfaceProjector).project = function (ray, entity) {
    selectDragPlane(this, ray, entity);
    var tmp0_safe_receiver = this.a39_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.point;
  };
  function Companion_38() {
  }
  protoOf(Companion_38).s1k = function () {
    return 81;
  };
  var Companion_instance_71;
  function Companion_getInstance_47() {
    return Companion_instance_71;
  }
  function DragSurfaceEntityPairsCacheComponent(surfaces, roomSurfaces) {
    var tmp;
    if (surfaces === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = surfaces;
    }
    surfaces = tmp;
    var tmp_0;
    if (roomSurfaces === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = roomSurfaces;
    }
    roomSurfaces = tmp_0;
    this.surfaces = surfaces;
    this.roomSurfaces = roomSurfaces;
  }
  protoOf(DragSurfaceEntityPairsCacheComponent).x1k = function () {
    return Companion_instance_71.id;
  };
  protoOf(DragSurfaceEntityPairsCacheComponent).eq = function (other) {
    return false;
  };
  function get_projectorSurfacesComponent(_this__u8e3s4) {
    return _this__u8e3s4.__getComponentForKotlin(Companion_instance_71.id);
  }
  function DragSurfaceProjector() {
  }
  function addSurfaceIfExists($this, entity) {
    var tmp0_elvis_lhs = entity.__getComponentForKotlin(91);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var component = tmp;
    $this.n39_1.onDragSurfacesAdded(component, entity);
  }
  function Companion_39() {
    this.ID = 'MultiWallConvertScreenDragsSystem';
  }
  protoOf(Companion_39).u1n = function () {
    return this.ID;
  };
  var Companion_instance_72;
  function Companion_getInstance_48() {
    return Companion_instance_72;
  }
  function DragSurfaceUpdatesListenerSystem$enable$lambda(it) {
    return it.hasComponent(91);
  }
  function DragSurfaceUpdatesListenerSystem(dragSurfacesChangedListener, sceneManager) {
    SystemBase2.call(this, 'MultiWallConvertScreenDragsSystem', 91, 5);
    this.n39_1 = dragSurfacesChangedListener;
    this.o39_1 = sceneManager;
    this.enable();
  }
  protoOf(DragSurfaceUpdatesListenerSystem).enable = function () {
    protoOf(SystemBase2).enable.call(this);
    // Inline function 'kotlin.sequences.forEach' call
    var tmp = get_hierarchySequence(this.o39_1.root);
    var tmp0_iterator = filter(tmp, DragSurfaceUpdatesListenerSystem$enable$lambda).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.dragging.viewerDragConversion.projector.DragSurfaceUpdatesListenerSystem.enable.<anonymous>' call
      addSurfaceIfExists(this, element);
    }
  };
  protoOf(DragSurfaceUpdatesListenerSystem).onAddComponent = function (entity, newComponent) {
    if (get_isInScene(entity)) {
      this.n39_1.onDragSurfacesAdded(newComponent, entity);
    }
  };
  protoOf(DragSurfaceUpdatesListenerSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (get_isInScene(entity)) {
      this.n39_1.onDragSurfacesRemoved(entity);
      this.n39_1.onDragSurfacesAdded(newComponent, entity);
    }
  };
  protoOf(DragSurfaceUpdatesListenerSystem).onRemoveComponent = function (entity, oldComponent) {
    this.n39_1.onDragSurfacesRemoved(entity);
  };
  protoOf(DragSurfaceUpdatesListenerSystem).onAddComponent2 = function (entity, newComponent) {
    var worldDragSurfacesComponent = entity.__getComponentForKotlin(91);
    if (!(worldDragSurfacesComponent == null)) {
      this.n39_1.onDragSurfacesAdded(worldDragSurfacesComponent, entity);
    }
  };
  protoOf(DragSurfaceUpdatesListenerSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(DragSurfaceUpdatesListenerSystem).onRemoveComponent2 = function (entity, oldComponent) {
    var worldDragSurfacesComponent = entity.__getComponentForKotlin(91);
    if (!(worldDragSurfacesComponent == null)) {
      this.n39_1.onDragSurfacesRemoved(entity);
    }
  };
  function DragSurfacesChangedListener() {
  }
  function entityHit($this, entity, ray) {
    var hit = RaycastUtils_instance.raycast(ray, entity);
    var cameraNormal = ray.direction.__timesIntForKotlin(-1);
    var tmp;
    if (hit == null) {
      var entityPlane = new Plane(get_worldPosition(entity), cameraNormal);
      var tmp0_safe_receiver = entityPlane.raycast(ray);
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.point;
    } else {
      tmp = hit.point;
    }
    var hitPoint = tmp;
    return hitPoint;
  }
  function XYPlaneProjector() {
  }
  protoOf(XYPlaneProjector).onDragSurfacesAdded = function (worldDragSurfacesComponent, entity) {
  };
  protoOf(XYPlaneProjector).onDragSurfacesRemoved = function (entity) {
  };
  protoOf(XYPlaneProjector).project = function (ray, entity) {
    var tmp0_elvis_lhs = entityHit(this, entity, ray);
    var planePoint = tmp0_elvis_lhs == null ? get_worldPosition(entity) : tmp0_elvis_lhs;
    var frontDragPlane = new Plane(planePoint, Companion_getInstance_4().FORWARD);
    var backDragPlane = new Plane(planePoint, Companion_getInstance_4().BACK);
    var tmp1_elvis_lhs = frontDragPlane.raycast(ray);
    var intersection = tmp1_elvis_lhs == null ? backDragPlane.raycast(ray) : tmp1_elvis_lhs;
    return intersection == null ? null : intersection.point;
  };
  function Companion_40() {
    this.id = 62;
  }
  protoOf(Companion_40).s1k = function () {
    return this.id;
  };
  var Companion_instance_73;
  function Companion_getInstance_49() {
    return Companion_instance_73;
  }
  function FunctionalMarginComponent(worldPolyhedron) {
    this.worldPolyhedron = worldPolyhedron;
  }
  protoOf(FunctionalMarginComponent).g1n = function () {
    return this.worldPolyhedron;
  };
  protoOf(FunctionalMarginComponent).x1k = function () {
    return 62;
  };
  protoOf(FunctionalMarginComponent).eq = function (other) {
    var o = other instanceof FunctionalMarginComponent ? other : THROW_CCE();
    return equals(o.worldPolyhedron, this.worldPolyhedron);
  };
  protoOf(FunctionalMarginComponent).af = function () {
    return this.worldPolyhedron;
  };
  protoOf(FunctionalMarginComponent).h1n = function (worldPolyhedron) {
    return new FunctionalMarginComponent(worldPolyhedron);
  };
  protoOf(FunctionalMarginComponent).copy = function (worldPolyhedron, $super) {
    worldPolyhedron = worldPolyhedron === VOID ? this.worldPolyhedron : worldPolyhedron;
    return this.h1n(worldPolyhedron);
  };
  protoOf(FunctionalMarginComponent).toString = function () {
    return 'FunctionalMarginComponent(worldPolyhedron=' + this.worldPolyhedron + ')';
  };
  protoOf(FunctionalMarginComponent).hashCode = function () {
    return hashCode(this.worldPolyhedron);
  };
  protoOf(FunctionalMarginComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FunctionalMarginComponent))
      return false;
    var tmp0_other_with_cast = other instanceof FunctionalMarginComponent ? other : THROW_CCE();
    if (!equals(this.worldPolyhedron, tmp0_other_with_cast.worldPolyhedron))
      return false;
    return true;
  };
  function Companion_41() {
    this.id = 61;
  }
  protoOf(Companion_41).s1k = function () {
    return this.id;
  };
  var Companion_instance_74;
  function Companion_getInstance_50() {
    return Companion_instance_74;
  }
  function FunctionalMarginShapeComponent(margin) {
    this.margin = margin;
  }
  protoOf(FunctionalMarginShapeComponent).p39 = function () {
    return this.margin;
  };
  protoOf(FunctionalMarginShapeComponent).shape = function (me) {
    var oobb = get_objectOrientedBoundingBoxForHierarchy(me);
    return oobb.applyMargin(this.margin);
  };
  protoOf(FunctionalMarginShapeComponent).x1k = function () {
    return 61;
  };
  protoOf(FunctionalMarginShapeComponent).eq = function (other) {
    var o = other instanceof FunctionalMarginShapeComponent ? other : THROW_CCE();
    return o.margin.equals(this.margin);
  };
  protoOf(FunctionalMarginShapeComponent).af = function () {
    return this.margin;
  };
  protoOf(FunctionalMarginShapeComponent).q39 = function (margin) {
    return new FunctionalMarginShapeComponent(margin);
  };
  protoOf(FunctionalMarginShapeComponent).copy = function (margin, $super) {
    margin = margin === VOID ? this.margin : margin;
    return this.q39(margin);
  };
  protoOf(FunctionalMarginShapeComponent).toString = function () {
    return 'FunctionalMarginShapeComponent(margin=' + this.margin + ')';
  };
  protoOf(FunctionalMarginShapeComponent).hashCode = function () {
    return this.margin.hashCode();
  };
  protoOf(FunctionalMarginShapeComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FunctionalMarginShapeComponent))
      return false;
    var tmp0_other_with_cast = other instanceof FunctionalMarginShapeComponent ? other : THROW_CCE();
    if (!this.margin.equals(tmp0_other_with_cast.margin))
      return false;
    return true;
  };
  function Companion_42() {
    this.ID = 'FunctionalMarginSystem';
  }
  protoOf(Companion_42).u1n = function () {
    return this.ID;
  };
  var Companion_instance_75;
  function Companion_getInstance_51() {
    return Companion_instance_75;
  }
  function updateFunctionalMarginShape($this, entity) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(61);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.functionalmargins.FunctionalMarginSystem.updateFunctionalMarginShape.<anonymous>' call
      var shape = TransformUtils_instance.applyWorldTransform(tmp0_safe_receiver.shape(entity), entity);
      entity.addComponent(new FunctionalMarginComponent(shape));
    }
  }
  function FunctionalMarginSystem() {
    SystemBase2.call(this, 'FunctionalMarginSystem', 10, 61);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z39_1 = [62];
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.a3a_1 = ['TransformSystem'];
  }
  protoOf(FunctionalMarginSystem).w1o = function () {
    return this.z39_1;
  };
  protoOf(FunctionalMarginSystem).x1o = function () {
    return this.a3a_1;
  };
  protoOf(FunctionalMarginSystem).onAddComponent = function (entity, newComponent) {
    updateFunctionalMarginShape(this, entity);
  };
  protoOf(FunctionalMarginSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    updateFunctionalMarginShape(this, entity);
  };
  protoOf(FunctionalMarginSystem).onRemoveComponent = function (entity, oldComponent) {
    updateFunctionalMarginShape(this, entity);
  };
  protoOf(FunctionalMarginSystem).onAddComponent2 = function (entity, newComponent) {
    updateFunctionalMarginShape(this, entity);
  };
  protoOf(FunctionalMarginSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    updateFunctionalMarginShape(this, entity);
  };
  protoOf(FunctionalMarginSystem).onRemoveComponent2 = function (entity, oldComponent) {
    entity.removeComponent(62);
  };
  function Companion_43() {
    this.ID = 'FunctionalMargin';
  }
  protoOf(Companion_43).u1n = function () {
    return this.ID;
  };
  var Companion_instance_76;
  function Companion_getInstance_52() {
    return Companion_instance_76;
  }
  function validate_0($this, entity, snapActionCandidate) {
    var root = $this.findRoot(snapActionCandidate, entity);
    var tmp1_elvis_lhs = snapActionCandidate == null ? null : snapActionCandidate.host;
    var parent = tmp1_elvis_lhs == null ? get_parent(entity) : tmp1_elvis_lhs;
    var meAndMyHierarchy = get_hierarchy(entity);
    var tmp;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.none' call
      var inductionVariable = 0;
      var last = meAndMyHierarchy.length;
      while (inductionVariable < last) {
        var element = meAndMyHierarchy[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.functionalmargins.FunctionalMarginValidation.validate.<anonymous>' call
        if (element.hasComponent(61)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    if (tmp$ret$1) {
      tmp = findInHierarchy(root, FunctionalMarginValidation$validate$lambda) == null;
    } else {
      tmp = false;
    }
    if (tmp) {
      return null;
    }
    var warn = {_v: null};
    var tmp2_safe_receiver = get_snapRoot(entity);
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : get_hierarchy(tmp2_safe_receiver);
    var snapRootHierarchy = tmp3_elvis_lhs == null ? meAndMyHierarchy : tmp3_elvis_lhs;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = meAndMyHierarchy.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = meAndMyHierarchy[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      $l$block_0: {
        // Inline function 'com.ikea.core.stl.functionalmargins.FunctionalMarginValidation.validate.<anonymous>' call
        var tmp0_safe_receiver = element_0.__getComponentForKotlin(62);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp0_safe_receiver_0 = findInHierarchy(root, FunctionalMarginValidation$validate$lambda_0(snapRootHierarchy, tmp1_safe_receiver));
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp0_safe_receiver_1 = get_collider(tmp0_safe_receiver_0);
            var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.worldPolyhedron;
            var penetration = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.penetration(tmp1_safe_receiver);
            warn._v = new FunctionalMarginWarning(tmp0_safe_receiver_0, $this, penetration == null ? Companion_getInstance_4().ZERO : penetration);
            break $l$block_0;
          }
        }
      }
    }
    var myColliders$delegate = lazy(FunctionalMarginValidation$validate$lambda_1(meAndMyHierarchy));
    var tmp_0;
    if (warn._v == null) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !validate$lambda(myColliders$delegate).b1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp4_safe_receiver = $this.e3a_1;
      if (tmp4_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (!tmp4_safe_receiver.isDisposed) {
          validate$checkZoneCollisionWithMe(warn, parent, $this, snapRootHierarchy, myColliders$delegate, tmp4_safe_receiver);
          tmp_1 = Unit_instance;
        }
      }
      if (warn._v == null) {
        findInHierarchy(root, FunctionalMarginValidation$validate$checkZoneCollisionWithMe$ref(warn, parent, $this, snapRootHierarchy, myColliders$delegate));
      }
    }
    var tmp_2 = $this;
    var tmp5_safe_receiver = warn._v;
    tmp_2.e3a_1 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.otherEntity;
    return warn._v;
  }
  function validate$lambda($myColliders$delegate) {
    // Inline function 'kotlin.getValue' call
    getLocalDelegateReference('myColliders', KProperty0, false, function () {
      return THROW_ISE();
    });
    return $myColliders$delegate.u2();
  }
  function validate$checkZoneCollisionWithMe(warn, parent, this$0, snapRootHierarchy, myColliders$delegate, other) {
    if (!(warn._v == null))
      return false;
    if ((!(parent == null) ? !this$0.c3a_1 : false) ? hierarchyContains(other, parent) : false)
      return false;
    if (contains(snapRootHierarchy, other))
      return false;
    var funcZone = other.__getComponentForKotlin(62);
    var tmp;
    if (!(funcZone == null)) {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.any' call
        var this_0 = validate$lambda(myColliders$delegate);
        var tmp_0;
        if (isInterface(this_0, Collection)) {
          tmp_0 = this_0.b1();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block;
        }
        var tmp0_iterator = this_0.t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          var pen = element.penetration(funcZone.worldPolyhedron);
          if (!(pen == null)) {
            warn._v = new FunctionalMarginWarning(other, this$0, pen);
            return true;
          }
          return false;
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    var found = tmp;
    return found;
  }
  function FunctionalMarginValidation$validate$lambda(it) {
    return it.hasComponent(62);
  }
  function FunctionalMarginValidation$validate$lambda_0($snapRootHierarchy, $worldFuncZone) {
    return function (other) {
      var tmp;
      if (!contains($snapRootHierarchy, other)) {
        var tmp0_safe_receiver = get_collider(other);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
        tmp = !((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.penetration($worldFuncZone)) == null);
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function FunctionalMarginValidation$validate$lambda_1($meAndMyHierarchy) {
    return function () {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_0 = $meAndMyHierarchy;
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.functionalmargins.FunctionalMarginValidation.validate.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver = get_collider(element);
        var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver_0);
        }
      }
      return destination;
    };
  }
  function FunctionalMarginValidation$validate$checkZoneCollisionWithMe$ref($warn, $parent, this$0, $snapRootHierarchy, $myColliders$delegate) {
    var l = function (p0) {
      return validate$checkZoneCollisionWithMe($warn, $parent, this$0, $snapRootHierarchy, $myColliders$delegate, p0);
    };
    l.callableName = 'checkZoneCollisionWithMe';
    return l;
  }
  function FunctionalMarginValidation(generateWarningsForAncestors, entityManager) {
    ValidationImpl.call(this);
    this.c3a_1 = generateWarningsForAncestors;
    this.entityManager = entityManager;
    this.d3a_1 = 'FunctionalMargin';
    this.e3a_1 = null;
  }
  protoOf(FunctionalMarginValidation).p1i = function () {
    return this.entityManager;
  };
  protoOf(FunctionalMarginValidation).s1k = function () {
    return this.d3a_1;
  };
  protoOf(FunctionalMarginValidation).validateCurrentState = function (entity) {
    return validate_0(this, entity, null);
  };
  protoOf(FunctionalMarginValidation).validateSnap = function (snapActionCandidate) {
    return validate_0(this, snapActionCandidate.guestRoot, snapActionCandidate);
  };
  function Companion_44() {
    this.ID = 'FunctionalMarginWarning intersects';
  }
  protoOf(Companion_44).u1n = function () {
    return this.ID;
  };
  var Companion_instance_77;
  function Companion_getInstance_53() {
    return Companion_instance_77;
  }
  function FunctionalMarginWarning(otherEntity, functionalMarginRule, penetration) {
    ValidationResult.call(this, ValidationResultType_WARNING_getInstance(), get_productRefOrEmptyString(otherEntity), functionalMarginRule);
    this.otherEntity = otherEntity;
    this.functionalMarginRule = functionalMarginRule;
    this.penetration = penetration;
  }
  protoOf(FunctionalMarginWarning).f3a = function () {
    return this.otherEntity;
  };
  protoOf(FunctionalMarginWarning).g3a = function () {
    return this.functionalMarginRule;
  };
  protoOf(FunctionalMarginWarning).h3a = function () {
    return this.penetration;
  };
  protoOf(FunctionalMarginWarning).toString = function () {
    return this.id + ' ';
  };
  protoOf(FunctionalMarginWarning).s1k = function () {
    return 'FunctionalMarginWarning intersects';
  };
  protoOf(FunctionalMarginWarning).af = function () {
    return this.otherEntity;
  };
  protoOf(FunctionalMarginWarning).bf = function () {
    return this.functionalMarginRule;
  };
  protoOf(FunctionalMarginWarning).g1k = function () {
    return this.penetration;
  };
  protoOf(FunctionalMarginWarning).i3a = function (otherEntity, functionalMarginRule, penetration) {
    return new FunctionalMarginWarning(otherEntity, functionalMarginRule, penetration);
  };
  protoOf(FunctionalMarginWarning).copy = function (otherEntity, functionalMarginRule, penetration, $super) {
    otherEntity = otherEntity === VOID ? this.otherEntity : otherEntity;
    functionalMarginRule = functionalMarginRule === VOID ? this.functionalMarginRule : functionalMarginRule;
    penetration = penetration === VOID ? this.penetration : penetration;
    return this.i3a(otherEntity, functionalMarginRule, penetration);
  };
  protoOf(FunctionalMarginWarning).hashCode = function () {
    var result = this.otherEntity.hashCode();
    result = imul(result, 31) + hashCode(this.functionalMarginRule) | 0;
    result = imul(result, 31) + this.penetration.hashCode() | 0;
    return result;
  };
  protoOf(FunctionalMarginWarning).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FunctionalMarginWarning))
      return false;
    var tmp0_other_with_cast = other instanceof FunctionalMarginWarning ? other : THROW_CCE();
    if (!this.otherEntity.equals(tmp0_other_with_cast.otherEntity))
      return false;
    if (!equals(this.functionalMarginRule, tmp0_other_with_cast.functionalMarginRule))
      return false;
    if (!this.penetration.equals(tmp0_other_with_cast.penetration))
      return false;
    return true;
  };
  function FunctionalZone(id, layer, polyhedron) {
    this.id = id;
    this.layer = layer;
    this.polyhedron = polyhedron;
  }
  protoOf(FunctionalZone).s1k = function () {
    return this.id;
  };
  protoOf(FunctionalZone).j3a = function () {
    return this.layer;
  };
  protoOf(FunctionalZone).i1n = function () {
    return this.polyhedron;
  };
  protoOf(FunctionalZone).af = function () {
    return this.id;
  };
  protoOf(FunctionalZone).bf = function () {
    return this.layer;
  };
  protoOf(FunctionalZone).g1k = function () {
    return this.polyhedron;
  };
  protoOf(FunctionalZone).k3a = function (id, layer, polyhedron) {
    return new FunctionalZone(id, layer, polyhedron);
  };
  protoOf(FunctionalZone).copy = function (id, layer, polyhedron, $super) {
    id = id === VOID ? this.id : id;
    layer = layer === VOID ? this.layer : layer;
    polyhedron = polyhedron === VOID ? this.polyhedron : polyhedron;
    return this.k3a(id, layer, polyhedron);
  };
  protoOf(FunctionalZone).toString = function () {
    return 'FunctionalZone(id=' + this.id + ', layer=' + this.layer + ', polyhedron=' + this.polyhedron + ')';
  };
  protoOf(FunctionalZone).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(result, 31) + getStringHashCode(this.layer) | 0;
    result = imul(result, 31) + hashCode(this.polyhedron) | 0;
    return result;
  };
  protoOf(FunctionalZone).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FunctionalZone))
      return false;
    var tmp0_other_with_cast = other instanceof FunctionalZone ? other : THROW_CCE();
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    if (!(this.layer === tmp0_other_with_cast.layer))
      return false;
    if (!equals(this.polyhedron, tmp0_other_with_cast.polyhedron))
      return false;
    return true;
  };
  function Companion_45() {
    this.id = 121;
  }
  protoOf(Companion_45).s1k = function () {
    return this.id;
  };
  var Companion_instance_78;
  function Companion_getInstance_54() {
    return Companion_instance_78;
  }
  function FunctionalZonesLocalComponent(zones) {
    this.zones = zones;
  }
  protoOf(FunctionalZonesLocalComponent).l3a = function () {
    return this.zones;
  };
  protoOf(FunctionalZonesLocalComponent).x1k = function () {
    return 121;
  };
  protoOf(FunctionalZonesLocalComponent).eq = function (other) {
    var o = other instanceof FunctionalZonesLocalComponent ? other : THROW_CCE();
    return contentEquals(o.zones, this.zones);
  };
  protoOf(FunctionalZonesLocalComponent).equals = function (other) {
    var tmp;
    if (other instanceof FunctionalZonesLocalComponent) {
      tmp = this.eq(other);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(FunctionalZonesLocalComponent).hashCode = function () {
    return contentHashCode(this.zones);
  };
  protoOf(FunctionalZonesLocalComponent).getWorldSpaceZones = function (transform) {
    // Inline function 'com.ikea.core.utils.mapToArray' call
    var this_0 = this.zones;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this_0.length;
    var arr = fillArrayVal(Array(size), null);
    var inductionVariable = 0;
    var last = this_0.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.functionalzones.FunctionalZonesLocalComponent.getWorldSpaceZones.<anonymous>' call
        var zone = this_0[i];
        arr[i] = new FunctionalZone(zone.id, zone.layer, zone.polyhedron.transform(transform));
      }
       while (inductionVariable <= last);
    var tmp$ret$2 = isArray(arr) ? arr : THROW_CCE();
    return new FunctionalZonesWorldComponent(tmp$ret$2);
  };
  function Companion_46() {
    this.ID = 'FunctionalZonesLocalToWorldSystem';
  }
  protoOf(Companion_46).u1n = function () {
    return this.ID;
  };
  var Companion_instance_79;
  function Companion_getInstance_55() {
    return Companion_instance_79;
  }
  function updateFunctionalZonesInWorldSpace($this, entity) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(121);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.functionalzones.FunctionalZonesLocalToWorldSystem.updateFunctionalZonesInWorldSpace.<anonymous>' call
      var worldSpaceZonesComponent = tmp0_safe_receiver.getWorldSpaceZones(get_worldTransform(entity));
      $this.entityManager.addComponent(entity, worldSpaceZonesComponent);
    }
  }
  function FunctionalZonesLocalToWorldSystem(entityManager) {
    SystemBase2.call(this, 'FunctionalZonesLocalToWorldSystem', 10, 121);
    this.entityManager = entityManager;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u3a_1 = [122];
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.v3a_1 = ['TransformSystem'];
  }
  protoOf(FunctionalZonesLocalToWorldSystem).p1i = function () {
    return this.entityManager;
  };
  protoOf(FunctionalZonesLocalToWorldSystem).w1o = function () {
    return this.u3a_1;
  };
  protoOf(FunctionalZonesLocalToWorldSystem).x1o = function () {
    return this.v3a_1;
  };
  protoOf(FunctionalZonesLocalToWorldSystem).onAddComponent = function (entity, newComponent) {
    updateFunctionalZonesInWorldSpace(this, entity);
  };
  protoOf(FunctionalZonesLocalToWorldSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    updateFunctionalZonesInWorldSpace(this, entity);
  };
  protoOf(FunctionalZonesLocalToWorldSystem).onRemoveComponent = function (entity, oldComponent) {
    updateFunctionalZonesInWorldSpace(this, entity);
  };
  protoOf(FunctionalZonesLocalToWorldSystem).onAddComponent2 = function (entity, newComponent) {
    updateFunctionalZonesInWorldSpace(this, entity);
  };
  protoOf(FunctionalZonesLocalToWorldSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    updateFunctionalZonesInWorldSpace(this, entity);
  };
  protoOf(FunctionalZonesLocalToWorldSystem).onRemoveComponent2 = function (entity, oldComponent) {
    this.entityManager.removeComponent(entity, 122);
  };
  function Companion_47() {
    this.id = 122;
  }
  protoOf(Companion_47).s1k = function () {
    return this.id;
  };
  var Companion_instance_80;
  function Companion_getInstance_56() {
    return Companion_instance_80;
  }
  function FunctionalZonesWorldComponent(zones) {
    this.zones = zones;
  }
  protoOf(FunctionalZonesWorldComponent).l3a = function () {
    return this.zones;
  };
  protoOf(FunctionalZonesWorldComponent).x1k = function () {
    return 122;
  };
  protoOf(FunctionalZonesWorldComponent).eq = function (other) {
    var o = other instanceof FunctionalZonesWorldComponent ? other : THROW_CCE();
    return contentEquals(o.zones, this.zones);
  };
  protoOf(FunctionalZonesWorldComponent).equals = function (other) {
    var tmp;
    if (other instanceof FunctionalZonesWorldComponent) {
      tmp = this.eq(other);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(FunctionalZonesWorldComponent).hashCode = function () {
    return contentHashCode(this.zones);
  };
  function setChildrenFromParents($this, productsData) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var childrenMap = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = productsData.length;
    while (inductionVariable < last) {
      var element = productsData[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.setChildrenFromParents.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = element.parents;
      var inductionVariable_0 = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = indexedObject[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.icf.ICFDataService.setChildrenFromParents.<anonymous>.<anonymous>' call
        var childrenList = childrenMap.b3(element_0.id);
        if (childrenList == null) {
          // Inline function 'kotlin.collections.set' call
          var key = element_0.id;
          var value = mutableListOf([element.entity]);
          childrenMap.r2(key, value);
        } else {
          childrenList.q(element.entity);
        }
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(productsData.length);
    var inductionVariable_1 = 0;
    var last_1 = productsData.length;
    while (inductionVariable_1 < last_1) {
      var item = productsData[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.setChildrenFromParents.<anonymous>' call
      var tmp0_safe_receiver = childrenMap.b3(item.entity.id);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp = copyToArray(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var children = tmp_0;
      var tmp$ret$3 = item.copy(VOID, VOID, VOID, children);
      destination.q(tmp$ret$3);
    }
    return copyToArray(destination);
  }
  function createIntegerIds($this, productsData) {
    var nextId = 1;
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(productsData.length), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = productsData.length;
    while (inductionVariable < last) {
      var element = productsData[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.createIntegerIds.<anonymous>' call
      var newId = nextId;
      nextId = nextId + 1 | 0;
      var pair = to(element.entity.id, newId);
      destination.r2(pair.ye_1, pair.ze_1);
    }
    var entityIdToIntId = destination;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(productsData.length);
    var inductionVariable_0 = 0;
    var last_0 = productsData.length;
    while (inductionVariable_0 < last_0) {
      var item = productsData[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.createIntegerIds.<anonymous>' call
      var tmp0_elvis_lhs = entityIdToIntId.b3(item.entity.id);
      var tmp1_id = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_0 = item.children;
      var destination_1 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = 0;
      var last_1 = this_0.length;
      while (inductionVariable_1 < last_1) {
        var element_0 = this_0[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.icf.ICFDataService.createIntegerIds.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver = entityIdToIntId.b3(element_0.id);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_1.q(tmp0_safe_receiver);
        }
      }
      var tmp2_children_ids = copyToArray(destination_1);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_1 = item.parents;
      var destination_2 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_2 = 0;
      var last_2 = this_1.length;
      while (inductionVariable_2 < last_2) {
        var element_1 = this_1[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.icf.ICFDataService.createIntegerIds.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_0 = entityIdToIntId.b3(element_1.id);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_2.q(tmp0_safe_receiver_0);
        }
      }
      var tmp3_parent_ids = copyToArray(destination_2);
      var tmp$ret$13 = item.copy(tmp1_id, VOID, VOID, VOID, tmp3_parent_ids, tmp2_children_ids);
      destination_0.q(tmp$ret$13);
    }
    return copyToArray(destination_0);
  }
  function dataForEntity($this, entity, includedEntities) {
    var tmp = getParents($this, entity, includedEntities);
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp_1 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp_2 = [];
    var tmp0_safe_receiver = get_colliderShapeComponent(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.polyhedron;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.axisAlignedBoundingBox;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.size;
    return new ICFProductData(0, entity, tmp, tmp_0, tmp_1, tmp_2, tmp3_elvis_lhs == null ? Companion_getInstance_4().ZERO : tmp3_elvis_lhs, get_worldTransform(entity));
  }
  function getParents($this, entity, includedEntities) {
    var tmp;
    // Inline function 'kotlin.collections.isEmpty' call
    if (get_guestConnections(entity).length === 0) {
      tmp = getParentIdsFromChildCompoment($this, entity, includedEntities);
    } else {
      tmp = getParentIdsFromConnections($this, get_guestConnections(entity), includedEntities);
    }
    return tmp;
  }
  function getParentIdsFromChildCompoment($this, entity, includedEntities) {
    var tmp0_elvis_lhs = get_parent(entity);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var tmp_0;
    if (contains(includedEntities, parent.id)) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = [parent];
    } else {
      tmp_0 = getParents($this, parent, includedEntities);
    }
    return tmp_0;
  }
  function getParentIdsFromConnections($this, allParentConnections, includedEntities) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(allParentConnections.length);
    var inductionVariable = 0;
    var last = allParentConnections.length;
    while (inductionVariable < last) {
      var item = allParentConnections[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.getParentIdsFromConnections.<anonymous>' call
      var tmp$ret$0 = item.hostConnectorEntity;
      destination.q(tmp$ret$0);
    }
    var set = HashSet_init_$Create$();
    var list = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var e = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.getParentIdsFromConnections.<anonymous>' call
      var key = e.id;
      if (set.q(key)) {
        list.q(e);
      }
    }
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = list.t();
    while (tmp0_iterator_0.u()) {
      var element = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.getParentIdsFromConnections.<anonymous>' call
      var tmp;
      if (contains(includedEntities, element.id)) {
        tmp = listOf(element);
      } else {
        tmp = toList(getParents($this, element, includedEntities));
      }
      var list_0 = tmp;
      addAll_0(destination_0, list_0);
    }
    return copyToArray(destination_0);
  }
  function Companion_48() {
    Companion_instance_81 = this;
    this.logger = LoggerState_getInstance().m1m('ICFDataService');
  }
  protoOf(Companion_48).x1i = function () {
    return this.logger;
  };
  var Companion_instance_81;
  function Companion_getInstance_57() {
    if (Companion_instance_81 == null)
      new Companion_48();
    return Companion_instance_81;
  }
  function ICFDataService$getICFDataForEntities$lambda($entitiesNotInScene) {
    return function () {
      return 'One or more entities passed could not be found in scene: ' + $entitiesNotInScene;
    };
  }
  function ICFDataService(sceneManager) {
    Companion_getInstance_57();
    this.sceneManager = sceneManager;
  }
  protoOf(ICFDataService).q1i = function () {
    return this.sceneManager;
  };
  protoOf(ICFDataService).getICFDataForEntities = function (entityIds) {
    var entitiesInScene = this.sceneManager.entities;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(entitiesInScene.length);
    var inductionVariable = 0;
    var last = entitiesInScene.length;
    while (inductionVariable < last) {
      var item = entitiesInScene[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.getICFDataForEntities.<anonymous>' call
      var tmp$ret$0 = item.id;
      destination.q(tmp$ret$0);
    }
    var entityIdsInScene = destination;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = entityIds.length;
    while (inductionVariable_0 < last_0) {
      var element = entityIds[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.getICFDataForEntities.<anonymous>' call
      if (!entityIdsInScene.p(element)) {
        destination_0.q(element);
      }
    }
    var entitiesNotInScene = destination_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!entitiesNotInScene.b1()) {
      var tmp = Companion_getInstance_57().logger;
      tmp.error(ICFDataService$getICFDataForEntities$lambda(entitiesNotInScene));
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.sceneManager.entities;
    var destination_1 = ArrayList_init_$Create$();
    var inductionVariable_1 = 0;
    var last_1 = this_0.length;
    while (inductionVariable_1 < last_1) {
      var element_0 = this_0[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.getICFDataForEntities.<anonymous>' call
      if (contains(entityIds, element_0.id)) {
        destination_1.q(element_0);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_1, 10));
    var tmp0_iterator = destination_1.t();
    while (tmp0_iterator.u()) {
      var item_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.icf.ICFDataService.getICFDataForEntities.<anonymous>' call
      var tmp$ret$10 = dataForEntity(this, item_0, entityIds);
      destination_2.q(tmp$ret$10);
    }
    var productsData = copyToArray(destination_2);
    var dataWithChildren = setChildrenFromParents(this, productsData);
    return createIntegerIds(this, dataWithChildren);
  };
  function ICFProductData(id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform) {
    this.id = id;
    this.entity = entity;
    this.parents = parents;
    this.children = children;
    this.parent_ids = parent_ids;
    this.children_ids = children_ids;
    this.colliderDimensions = colliderDimensions;
    this.transform = transform;
    this.w3a_1 = 0;
  }
  protoOf(ICFProductData).s1k = function () {
    return this.id;
  };
  protoOf(ICFProductData).r23 = function () {
    return this.entity;
  };
  protoOf(ICFProductData).x3a = function () {
    return this.parents;
  };
  protoOf(ICFProductData).c1k = function () {
    return this.children;
  };
  protoOf(ICFProductData).y3a = function () {
    return this.parent_ids;
  };
  protoOf(ICFProductData).z3a = function () {
    return this.children_ids;
  };
  protoOf(ICFProductData).a3b = function () {
    return this.colliderDimensions;
  };
  protoOf(ICFProductData).d1x = function () {
    return this.transform;
  };
  protoOf(ICFProductData).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ICFProductData))
      THROW_CCE();
    return this.entity.id === other.entity.id;
  };
  protoOf(ICFProductData).hashCode = function () {
    if (this.w3a_1 === 0) {
      this.w3a_1 = this.entity.id;
    }
    return this.w3a_1;
  };
  protoOf(ICFProductData).af = function () {
    return this.id;
  };
  protoOf(ICFProductData).bf = function () {
    return this.entity;
  };
  protoOf(ICFProductData).g1k = function () {
    return this.parents;
  };
  protoOf(ICFProductData).h1k = function () {
    return this.children;
  };
  protoOf(ICFProductData).i1k = function () {
    return this.parent_ids;
  };
  protoOf(ICFProductData).j1k = function () {
    return this.children_ids;
  };
  protoOf(ICFProductData).k1k = function () {
    return this.colliderDimensions;
  };
  protoOf(ICFProductData).p1z = function () {
    return this.transform;
  };
  protoOf(ICFProductData).b3b = function (id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform) {
    return new ICFProductData(id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform);
  };
  protoOf(ICFProductData).copy = function (id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform, $super) {
    id = id === VOID ? this.id : id;
    entity = entity === VOID ? this.entity : entity;
    parents = parents === VOID ? this.parents : parents;
    children = children === VOID ? this.children : children;
    parent_ids = parent_ids === VOID ? this.parent_ids : parent_ids;
    children_ids = children_ids === VOID ? this.children_ids : children_ids;
    colliderDimensions = colliderDimensions === VOID ? this.colliderDimensions : colliderDimensions;
    transform = transform === VOID ? this.transform : transform;
    return this.b3b(id, entity, parents, children, parent_ids, children_ids, colliderDimensions, transform);
  };
  protoOf(ICFProductData).toString = function () {
    return 'ICFProductData(id=' + this.id + ', entity=' + this.entity + ', parents=' + toString(this.parents) + ', children=' + toString(this.children) + ', parent_ids=' + toString(this.parent_ids) + ', children_ids=' + toString(this.children_ids) + ', colliderDimensions=' + this.colliderDimensions + ', transform=' + this.transform + ')';
  };
  function Companion_49() {
    this.id = 112;
  }
  protoOf(Companion_49).s1k = function () {
    return this.id;
  };
  var Companion_instance_82;
  function Companion_getInstance_58() {
    return Companion_instance_82;
  }
  function LabelComponent(text) {
    this.text = text;
  }
  protoOf(LabelComponent).c3b = function () {
    return this.text;
  };
  protoOf(LabelComponent).x1k = function () {
    return 112;
  };
  protoOf(LabelComponent).eq = function (other) {
    return this.text === (other instanceof LabelComponent ? other : THROW_CCE()).text;
  };
  function DebugLogger(level, levelToThrowException) {
    level = level === VOID ? LogLevel_DEBUG_getInstance() : level;
    levelToThrowException = levelToThrowException === VOID ? LogLevel_ERROR_getInstance() : levelToThrowException;
    this.d3b_1 = level;
    this.levelToThrowException = levelToThrowException;
    this.latestLoggedMessage = null;
  }
  protoOf(DebugLogger).d2b = function (_set____db54di) {
    this.d3b_1 = _set____db54di;
  };
  protoOf(DebugLogger).e2b = function () {
    return this.d3b_1;
  };
  protoOf(DebugLogger).e3b = function (_set____db54di) {
    this.levelToThrowException = _set____db54di;
  };
  protoOf(DebugLogger).f3b = function () {
    return this.levelToThrowException;
  };
  protoOf(DebugLogger).g3b = function (newLevel) {
    this.levelToThrowException = values()[newLevel];
  };
  protoOf(DebugLogger).h3b = function () {
    return this.levelToThrowException.x9_1;
  };
  protoOf(DebugLogger).i3b = function (_set____db54di) {
    this.latestLoggedMessage = _set____db54di;
  };
  protoOf(DebugLogger).j3b = function () {
    return this.latestLoggedMessage;
  };
  protoOf(DebugLogger).debug = function (f) {
    if (this.d3b_1.y9(LogLevel_DEBUG_getInstance()) <= 0) {
      this.latestLoggedMessage = f();
      echoStandardConsole(this.latestLoggedMessage);
    }
    if (this.levelToThrowException.y9(LogLevel_DEBUG_getInstance()) <= 0)
      throw new LoggerException(toString_0(f()));
  };
  protoOf(DebugLogger).error = function (f) {
    if (this.d3b_1.y9(LogLevel_ERROR_getInstance()) <= 0) {
      this.latestLoggedMessage = f();
      echoStandardConsole(this.latestLoggedMessage);
    }
    if (this.levelToThrowException.y9(LogLevel_ERROR_getInstance()) <= 0)
      throw new LoggerException(toString_0(f()));
  };
  protoOf(DebugLogger).warn = function (f) {
    if (this.d3b_1.y9(LogLevel_WARN_getInstance()) <= 0) {
      this.latestLoggedMessage = f();
      echoStandardConsole(this.latestLoggedMessage);
    }
    if (this.levelToThrowException.y9(LogLevel_WARN_getInstance()) <= 0)
      throw new LoggerException(toString_0(f()));
  };
  protoOf(DebugLogger).info = function (f) {
    if (this.d3b_1.y9(LogLevel_INFO_getInstance()) <= 0) {
      this.latestLoggedMessage = f();
      echoStandardConsole(this.latestLoggedMessage);
    }
    if (this.levelToThrowException.y9(LogLevel_INFO_getInstance()) <= 0)
      throw new LoggerException(toString_0(f()));
  };
  function LoggerException(msg) {
    msg = msg === VOID ? null : msg;
    Exception_init_$Init$(msg, this);
    captureStack(this, LoggerException);
  }
  function Companion_50() {
    this.id = 114;
  }
  protoOf(Companion_50).s1k = function () {
    return this.id;
  };
  var Companion_instance_83;
  function Companion_getInstance_59() {
    return Companion_instance_83;
  }
  function ColoredOutlineComponent(r, g, b) {
    r = r === VOID ? 0.0 : r;
    g = g === VOID ? 0.0 : g;
    b = b === VOID ? 1.0 : b;
    this.r = r;
    this.g = g;
    this.b = b;
  }
  protoOf(ColoredOutlineComponent).k3b = function () {
    return this.r;
  };
  protoOf(ColoredOutlineComponent).l3b = function () {
    return this.g;
  };
  protoOf(ColoredOutlineComponent).m3b = function () {
    return this.b;
  };
  protoOf(ColoredOutlineComponent).x1k = function () {
    return 114;
  };
  protoOf(ColoredOutlineComponent).eq = function (other) {
    var tmp;
    var tmp_0;
    if ((other instanceof ColoredOutlineComponent ? other : THROW_CCE()).r === this.r) {
      tmp_0 = other.g === this.g;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = other.b === this.b;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ColoredOutlineSystem() {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    SystemBase.call(this, 'ColoredOutlineSystem', 114, tmp$ret$0);
  }
  protoOf(ColoredOutlineSystem).onAddComponent = function (entity, newComponent) {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(entity, 28).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.outlines.ColoredOutlineSystem.onAddComponent.<anonymous>' call
      var tmp0_safe_receiver = get_viewerObject(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_safe_receiver.setOutlined(true);
        tmp0_safe_receiver.setOutlinedObjectColor(newComponent.r, newComponent.g, newComponent.b);
      }
    }
  };
  protoOf(ColoredOutlineSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    this.onAddComponent(entity, newComponent);
  };
  protoOf(ColoredOutlineSystem).onRemoveComponent = function (entity, oldComponent) {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(entity, 28).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.outlines.ColoredOutlineSystem.onRemoveComponent.<anonymous>' call
      var tmp0_safe_receiver = get_viewerObject(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_safe_receiver.removeOutlinedObjectColor();
        tmp0_safe_receiver.setOutlined(get_isSelected(entity));
      }
    }
  };
  function Companion_51() {
    this.id = 111;
  }
  protoOf(Companion_51).s1k = function () {
    return this.id;
  };
  var Companion_instance_84;
  function Companion_getInstance_60() {
    return Companion_instance_84;
  }
  function OutlineBlockingComponent() {
  }
  protoOf(OutlineBlockingComponent).x1k = function () {
    return 111;
  };
  protoOf(OutlineBlockingComponent).eq = function (other) {
    return true;
  };
  function Companion_52() {
    this.ID = 'OutlineEntityGroupDeselectSystem';
  }
  protoOf(Companion_52).u1n = function () {
    return this.ID;
  };
  var Companion_instance_85;
  function Companion_getInstance_61() {
    return Companion_instance_85;
  }
  function removeOutlineFromMembers($this, newComponent) {
    var indexedObject = newComponent.members;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var member = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp;
      if (!member.hasComponent(SelectedComponent_instance.id)) {
        tmp = member.hasComponent(14);
      } else {
        tmp = false;
      }
      if (tmp) {
        member.removeComponent(14);
      }
    }
  }
  function OutlineEntityGroupDeselectSystem(entityManager) {
    Companion_getInstance();
    SystemBase.call(this, 'OutlineEntityGroupDeselectSystem', 38);
    this.entityManager = entityManager;
  }
  protoOf(OutlineEntityGroupDeselectSystem).p1i = function () {
    return this.entityManager;
  };
  protoOf(OutlineEntityGroupDeselectSystem).onAddComponent = function (entity, newComponent) {
    removeOutlineFromMembers(this, newComponent);
  };
  protoOf(OutlineEntityGroupDeselectSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    removeOutlineFromMembers(this, newComponent);
  };
  protoOf(OutlineEntityGroupDeselectSystem).onRemoveComponent = function (entity, oldComponent) {
  };
  function Companion_53() {
    this.ID = 'OutlineSelectedSystem';
  }
  protoOf(Companion_53).u1n = function () {
    return this.ID;
  };
  var Companion_instance_86;
  function Companion_getInstance_62() {
    return Companion_instance_86;
  }
  function OutlineSelectedSystem() {
    SystemBase.call(this, 'OutlineSelectedSystem', SelectedComponent_instance.id);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d3c_1 = [14];
  }
  protoOf(OutlineSelectedSystem).onAddComponent = function (entity, newComponent) {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(entity, 0).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.outlines.OutlineSelectedSystem.onAddComponent.<anonymous>' call
      if (element.hasComponent(57)) {
        element.addComponent(new OutlinedComponent());
      }
    }
  };
  protoOf(OutlineSelectedSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(OutlineSelectedSystem).onRemoveComponent = function (entity, oldComponent) {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = hierarchyExceptSubTreesWithComponentSequence(entity, 0).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.outlines.OutlineSelectedSystem.onRemoveComponent.<anonymous>' call
      element.removeComponent(14);
    }
  };
  protoOf(OutlineSelectedSystem).w1o = function () {
    return this.d3c_1;
  };
  function onStartedDragging_0($this, entity) {
    setBlockingOnEntity($this, entity, false);
  }
  function onStoppedDragging_0($this, entity) {
    updateOutline($this, entity);
  }
  function updateOutline($this, childEntity) {
    var doOutline = hasComponentInUpwardsHierarchy(childEntity, 14);
    outlineEntity($this, childEntity, doOutline);
    setBlockingOnEntity($this, childEntity, !doOutline);
  }
  function handleChildComponentChanged($this, childEntity, any) {
    updateOutline($this, childEntity);
  }
  function handleChildComponentChanged_0($this, childEntity, any, newChildComponent) {
    handleChildComponentChanged($this, childEntity, newChildComponent);
  }
  function handleOutlineRemoved($this, entity, removed) {
    if (!hasComponentInUpwardsHierarchy(entity, 14)) {
      outlineEntity($this, entity, false);
      setBlockingOnEntity($this, entity, true);
    }
  }
  function handleOutlineAdded($this, entity, added) {
    outlineEntity($this, entity, true);
    setBlockingOnEntity($this, entity, false);
  }
  function outlineEntity($this, entity, doOutline) {
    outlineEntity$setOutlined(doOutline, entity);
  }
  function setBlockingOnEntity($this, entity, doBlock) {
    setBlockingOnEntity$setBlocking(doBlock, entity);
  }
  function outlineEntity$setOutlined($doOutline, sub) {
    var tmp0_safe_receiver = get_viewerObject(sub);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.setOutlined($doOutline);
    var tmp1_safe_receiver = get_parentComponent(sub);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.children;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.outlines.OutlineSystem.outlineEntity.setOutlined.<anonymous>' call
        if (!element.hasComponent(14)) {
          outlineEntity$setOutlined($doOutline, element);
        }
      }
    }
  }
  function setBlockingOnEntity$setBlocking($doBlock, sub) {
    var tmp0_safe_receiver = get_viewerObject(sub);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.setBlockOutlined($doBlock);
    var tmp1_safe_receiver = get_parentComponent(sub);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.children;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.outlines.OutlineSystem.setBlockingOnEntity.setBlocking.<anonymous>' call
        if (!element.hasComponent(14)) {
          setBlockingOnEntity$setBlocking($doBlock, element);
        }
      }
    }
  }
  function OutlineSystem() {
    // Inline function 'kotlin.emptyArray' call
    var tmp = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = ['HierarchySystem', 'SceneGraphSystem'];
    SystemBase4.call(this, 'OutlineSystem', 85, 14, 17, 20, tmp, tmp$ret$3, null);
  }
  protoOf(OutlineSystem).onAddComponent = function (entity, newComponent) {
    onStartedDragging_0(this, entity);
  };
  protoOf(OutlineSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(OutlineSystem).onRemoveComponent = function (entity, oldComponent) {
    onStoppedDragging_0(this, entity);
  };
  protoOf(OutlineSystem).onAddComponent2 = function (entity, newComponent) {
    handleOutlineAdded(this, entity, newComponent);
  };
  protoOf(OutlineSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(OutlineSystem).onRemoveComponent2 = function (entity, oldComponent) {
    handleOutlineRemoved(this, entity, oldComponent);
  };
  protoOf(OutlineSystem).onAddComponent3 = function (entity, newComponent) {
    handleChildComponentChanged(this, entity, newComponent);
  };
  protoOf(OutlineSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
    handleChildComponentChanged_0(this, entity, oldComponent, newComponent);
  };
  protoOf(OutlineSystem).onRemoveComponent3 = function (entity, oldComponent) {
  };
  protoOf(OutlineSystem).onAddComponent4 = function (entity, newComponent) {
    updateOutline(this, entity);
  };
  protoOf(OutlineSystem).onUpdateComponent4 = function (entity, oldComponent, newComponent) {
    updateOutline(this, entity);
  };
  protoOf(OutlineSystem).onRemoveComponent4 = function (entity, oldComponent) {
  };
  function Companion_54() {
    this.id = 14;
  }
  protoOf(Companion_54).s1k = function () {
    return this.id;
  };
  var Companion_instance_87;
  function Companion_getInstance_63() {
    return Companion_instance_87;
  }
  function OutlinedComponent() {
  }
  protoOf(OutlinedComponent).x1k = function () {
    return 14;
  };
  protoOf(OutlinedComponent).eq = function (other) {
    return true;
  };
  function moveTo($this, entity, position) {
    var tmp0_elvis_lhs = get_snapRoot(entity);
    var entityToMove = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    TransformUtils_instance.setWorldTransform(entityToMove, new Transform(position, get_worldRotation(entityToMove)));
  }
  function doPlacement($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy) {
    entityToPlace.addComponent(new AutoAdaptSessionComponent());
    $this.f3c_1.addComponent(entityToPlace, new SnapCandidateComponent());
    var snapValidationResult = tryFindValidSnap($this, hosts, entityToPlace, sortByWarnings, sortAndSelectStrategy);
    var placementResult = Companion_instance_88.fromValidSnapActionCandidateOrErrors(snapValidationResult);
    var tmp0_safe_receiver = snapValidationResult.snapActionCandidate;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createAction();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.perform();
    }
    var tmp2_elvis_lhs = placementResult.placedEntity;
    var actualEntity = tmp2_elvis_lhs == null ? entityToPlace : tmp2_elvis_lhs;
    actualEntity.removeComponent(Companion_instance_21.id);
    actualEntity.removeComponent(125);
    return placementResult;
  }
  function doPlacement$default($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy, $super) {
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE : sortAndSelectStrategy;
    return doPlacement($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy);
  }
  function tryFindValidSnap($this, hosts, entityToPlace, sortByWarnings, sortAndSelectStrategy) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(hosts.length === 0)) {
      tmp = tryFindFirstValidSnapResult($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy);
    } else {
      tmp = tryAllHosts($this, entityToPlace, sortByWarnings);
    }
    var result = tmp;
    return result;
  }
  function tryFindValidSnap$default($this, hosts, entityToPlace, sortByWarnings, sortAndSelectStrategy, $super) {
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE : sortAndSelectStrategy;
    return tryFindValidSnap($this, hosts, entityToPlace, sortByWarnings, sortAndSelectStrategy);
  }
  function tryFindFirstValidSnapResult($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var allResults = ArrayList_init_$Create$();
    // Inline function 'kotlin.sequences.find' call
    var tmp = asSequence_0(hosts);
    var tmp_0 = map(tmp, AutoAdaptPlacementActor$tryFindFirstValidSnapResult$lambda($this, entityToPlace, sortByWarnings, sortAndSelectStrategy));
    var this_0 = onEach(tmp_0, AutoAdaptPlacementActor$tryFindFirstValidSnapResult$lambda_0(allResults));
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryFindFirstValidSnapResult.<anonymous>' call
        if (element.valid) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var goodResult = tmp$ret$2;
    if (!(goodResult == null))
      return goodResult;
    var tmp_1;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!allResults.b1()) {
      // Inline function 'kotlin.collections.reduce' call
      var iterator = allResults.t();
      if (!iterator.u())
        throw UnsupportedOperationException_init_$Create$("Empty collection can't be reduced.");
      var accumulator = iterator.w();
      while (iterator.u()) {
        // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryFindFirstValidSnapResult.<anonymous>' call
        var prevResult = accumulator;
        var nextResult = iterator.w();
        accumulator = prevResult.combineFailures(nextResult);
      }
      tmp_1 = accumulator;
    } else {
      // Inline function 'kotlin.emptyArray' call
      var tmp_2 = [];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$10 = [Companion_instance_0.fail('No hosts to snap to', get_productRef(entityToPlace), null)];
      tmp_1 = new ValidSnapActionCandidateOrErrors(null, tmp_2, tmp$ret$10);
    }
    return tmp_1;
  }
  function tryFindFirstValidSnapResult$default($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy, $super) {
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE : sortAndSelectStrategy;
    return tryFindFirstValidSnapResult($this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy);
  }
  function tryAllHosts($this, entityToPlace, sortByWarnings) {
    var variants = get_variantEntities(entityToPlace);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = $this.g3c_1.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
      if (element.hasComponent(127)) {
        destination.q(element);
      }
    }
    var allHosts = destination;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = variants.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = variants[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
      // Inline function 'kotlin.collections.asIterable' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_1 = ArrayList_init_$Create$();
      var tmp0_iterator = allHosts.t();
      while (tmp0_iterator.u()) {
        var element_1 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>.<anonymous>' call
        var list = asSequence_0(SnapUtils_instance.matchingSnapActionCandidates(element_0, element_1, new SnapSettings(true, VOID, VOID, true)));
        addAll_1(destination_1, list);
      }
      var list_0 = destination_1;
      addAll_0(destination_0, list_0);
    }
    var snaps = destination_0;
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = AutoAdaptPlacementActor$tryAllHosts$lambda;
    var tmp$ret$10 = new sam$kotlin_Comparator$0_4(tmp);
    var this_1 = sortedWith(snaps, tmp$ret$10);
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = AutoAdaptPlacementActor$tryAllHosts$lambda_0($this);
    var tmp$ret$12 = new sam$kotlin_Comparator$0_4(tmp_0);
    var this_2 = sortedWith(this_1, tmp$ret$12);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_1 = AutoAdaptPlacementActor$tryAllHosts$lambda_1;
    var tmp$ret$14 = new sam$kotlin_Comparator$0_4(tmp_1);
    var this_3 = sortedWith(this_2, tmp$ret$14);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_2 = AutoAdaptPlacementActor$tryAllHosts$lambda_2(entityToPlace);
    var tmp$ret$16 = new sam$kotlin_Comparator$0_4(tmp_2);
    var sortedSnaps = sortedWith(this_3, tmp$ret$16);
    var goodResult = null;
    var warningResult = null;
    var failedResult = null;
    // Inline function 'kotlin.collections.find' call
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator_0 = sortedSnaps.t();
      while (tmp0_iterator_0.u()) {
        var element_2 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
        if (goodResult == null) {
          var myResult = $this.i3c_1.evaluateSnapCandidate(element_2);
          if (myResult.valid) {
            var tmp_3;
            if (!sortByWarnings) {
              tmp_3 = true;
            } else {
              // Inline function 'kotlin.collections.isEmpty' call
              tmp_3 = myResult.warnings.length === 0;
            }
            if (tmp_3) {
              goodResult = myResult;
            } else {
              if (warningResult == null ? true : myResult.warnings.length < ensureNotNull(warningResult).warnings.length) {
                warningResult = myResult;
              }
            }
          } else {
            var tmp0_safe_receiver = failedResult;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.combineFailures(myResult);
            failedResult = tmp1_elvis_lhs == null ? myResult : tmp1_elvis_lhs;
          }
        }
        if (!(goodResult == null)) {
          break $l$block;
        }
      }
    }
    var tmp$ret$31;
    $l$block_2: {
      // Inline function 'com.ikea.core.utils.otherwise' call
      var this_4 = goodResult;
      if (this_4 == null) {
        // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
        var tmp$ret$29;
        $l$block_1: {
          // Inline function 'com.ikea.core.utils.otherwise' call
          var this_5 = warningResult;
          if (this_5 == null) {
            // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>.<anonymous>' call
            var tmp$ret$27;
            $l$block_0: {
              // Inline function 'com.ikea.core.utils.otherwise' call
              var this_6 = failedResult;
              if (this_6 == null) {
                // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.emptyArray' call
                var tmp_4 = [];
                // Inline function 'kotlin.arrayOf' call
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$25 = [Companion_instance_0.fail('No hosts to snap to', get_productRef(entityToPlace), null)];
                tmp$ret$27 = new ValidSnapActionCandidateOrErrors(null, tmp_4, tmp$ret$25);
                break $l$block_0;
              }
              tmp$ret$27 = this_6;
            }
            tmp$ret$29 = tmp$ret$27;
            break $l$block_1;
          }
          tmp$ret$29 = this_5;
        }
        tmp$ret$31 = tmp$ret$29;
        break $l$block_2;
      }
      tmp$ret$31 = this_4;
    }
    return tmp$ret$31;
  }
  function recommendationDistance($this, candidate) {
    var result = Companion_getInstance_4().ZERO;
    var tmp = candidate.guestRoot;
    var tmp0_safe_receiver = tmp.__getComponentForKotlin(59);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = tmp0_safe_receiver.offsetY - candidate.endTransform.position.Y;
      var diff = Math.abs(this_0);
      result = new Vector(0.0, diff, 0.0);
    }
    var tmp_0 = candidate.guestRoot;
    if (tmp_0.__getComponentForKotlin(60) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      $this.j3c_1.warn(AutoAdaptPlacementActor$recommendationDistance$lambda);
    }
    return result;
  }
  function sam$kotlin_Comparator$0_4(function_0) {
    this.k3c_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_4).u1j = function (a, b) {
    return this.k3c_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function AutoAdaptPlacementActor$tryFindFirstValidSnapResult$lambda(this$0, $entityToPlace, $sortByWarnings, $sortAndSelectStrategy) {
    return function (it) {
      return this$0.e3c_1.findValidSnapActionWithAutoAdapt($entityToPlace, it, new SnapSettings($sortByWarnings, VOID, VOID, $sortByWarnings), $sortByWarnings, $sortAndSelectStrategy);
    };
  }
  function AutoAdaptPlacementActor$tryFindFirstValidSnapResult$lambda_0($allResults) {
    return function (it) {
      $allResults.q(it);
      return Unit_instance;
    };
  }
  function AutoAdaptPlacementActor$tryAllHosts$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    var tmp = a.movement.size;
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    var tmp$ret$1 = b.movement.size;
    return compareValues(tmp, tmp$ret$1);
  }
  function AutoAdaptPlacementActor$tryAllHosts$lambda_0(this$0) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
      var tmp = recommendationDistance(this$0, a).size;
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
      var tmp$ret$1 = recommendationDistance(this$0, b).size;
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function AutoAdaptPlacementActor$tryAllHosts$lambda_1(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    var tmp = b.priority;
    // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
    var tmp$ret$1 = a.priority;
    return compareValues(tmp, tmp$ret$1);
  }
  function AutoAdaptPlacementActor$tryAllHosts$lambda_2($entityToPlace) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
      var tmp = b.guest.equals($entityToPlace);
      // Inline function 'com.ikea.core.stl.placement.AutoAdaptPlacementActor.tryAllHosts.<anonymous>' call
      var tmp$ret$1 = a.guest.equals($entityToPlace);
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function AutoAdaptPlacementActor$recommendationDistance$lambda() {
    return 'PositionFromParent is not yet implemented';
  }
  function AutoAdaptPlacementActor(autoAdaptService, entityManager, sceneManager, productManager, validationService) {
    this.e3c_1 = autoAdaptService;
    this.f3c_1 = entityManager;
    this.g3c_1 = sceneManager;
    this.h3c_1 = productManager;
    this.i3c_1 = validationService;
    this.j3c_1 = LoggerState_getInstance().m1m('AutoAdaptPlacementActor');
  }
  protoOf(AutoAdaptPlacementActor).autoAdaptToScene = function (entityToPlace, sortAndSelectStrategy) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return doPlacement(this, entityToPlace, tmp$ret$0, true, sortAndSelectStrategy);
  };
  protoOf(AutoAdaptPlacementActor).autoAdaptToPosition = function (entityToPlace, initialPosition, sortByWarnings, sortAndSelectStrategy) {
    moveTo(this, entityToPlace, initialPosition);
    var hosts = this.e3c_1.findAutoAdaptHostsContainingPoint(entityToPlace, initialPosition);
    return doPlacement(this, entityToPlace, hosts, sortByWarnings, sortAndSelectStrategy);
  };
  protoOf(AutoAdaptPlacementActor).autoAdaptToHost = function (entityToPlace, host, sortAndSelectStrategy) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [host];
    return doPlacement(this, entityToPlace, tmp$ret$2, true, sortAndSelectStrategy);
  };
  protoOf(AutoAdaptPlacementActor).autoAdaptToTargets = function (entityToPlace, targets, sortAndSelectStrategy) {
    return doPlacement(this, entityToPlace, targets, true, sortAndSelectStrategy);
  };
  function trySnap($this, coreServices, snapActionCandidates, guest) {
    var validSnaps = SpaceFinderUtils_getInstance().getNewValidCandidatesOnSameConnectorsUsingSearchDirections(coreServices.validations, snapActionCandidates, 5);
    var bestValidResult = $this.l3c_1.bestResult(validSnaps);
    var bestValidCandidate = bestValidResult == null ? null : bestValidResult.snapActionCandidate;
    if (bestValidCandidate == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      bestValidCandidate.createAction().perform();
      return Companion_instance_88.fromValidSnapActionCandidateOrErrors(bestValidResult);
    }
    var topCandidate = $this.l3c_1.bestCandidate(snapActionCandidates);
    if (!(topCandidate == null)) {
      var failedResult = coreServices.validations.evaluateSnapCandidate(topCandidate, false);
      return Companion_instance_88.fromValidSnapActionCandidateOrErrors(failedResult);
    }
    return Companion_instance_88.failWithMessage('No valid snap found', get_productRefOrEmptyString(guest));
  }
  function PlacementHelper() {
    PlacementHelper_instance = this;
    this.l3c_1 = (new SnapSorterBuilder()).addConnectorPriorityCriterion(Companion_getInstance_69().all).addOriginalVariantCriterion().addDistanceCriterion().build();
  }
  protoOf(PlacementHelper).snapToScene = function (guest, coreServices) {
    var snapActionCandidates = AutoAdaptUtils_getInstance().getAutoAdaptCandidatesInHierarchy(guest, coreServices.sceneManager.scene, new SnapSettings(true, VOID, VOID, true));
    return trySnap(this, coreServices, snapActionCandidates, guest);
  };
  protoOf(PlacementHelper).snapToHost = function (guest, host, coreServices) {
    var snapActionCandidates = AutoAdaptUtils_getInstance().getAutoAdaptCandidatesInHierarchy(guest, host);
    return trySnap(this, coreServices, snapActionCandidates, guest);
  };
  var PlacementHelper_instance;
  function PlacementHelper_getInstance() {
    if (PlacementHelper_instance == null)
      new PlacementHelper();
    return PlacementHelper_instance;
  }
  function Companion_55() {
  }
  protoOf(Companion_55).fromValidationResult = function (warningsAndErrors, placedEntity) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = warningsAndErrors.length;
    while (inductionVariable < last) {
      var element = warningsAndErrors[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.Companion.fromValidationResult.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_WARNING_getInstance())) {
        destination.q(element);
      }
    }
    var warnings = copyToArray(destination);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = warningsAndErrors.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = warningsAndErrors[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.Companion.fromValidationResult.<anonymous>' call
      if (element_0.resultType.equals(ValidationResultType_FAIL_getInstance())) {
        destination_0.q(element_0);
      }
    }
    var errors = copyToArray(destination_0);
    return new PlacementResult(warnings, errors, placedEntity);
  };
  protoOf(Companion_55).fromValidSnapActionCandidateOrErrors = function (result) {
    var tmp0_safe_receiver = result.snapActionCandidate;
    return new PlacementResult(result.warnings, result.errors, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.guestRoot);
  };
  protoOf(Companion_55).ok = function (placedEntity) {
    // Inline function 'kotlin.emptyArray' call
    var tmp = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    return new PlacementResult(tmp, tmp$ret$1, placedEntity);
  };
  protoOf(Companion_55).m3c = function (message, productRef, rule) {
    // Inline function 'kotlin.emptyArray' call
    var tmp = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [new ValidationResultFail(message, productRef, rule)];
    return new PlacementResult(tmp, tmp$ret$3, null);
  };
  protoOf(Companion_55).failWithMessage = function (message, productRef, rule, $super) {
    rule = rule === VOID ? null : rule;
    return this.m3c(message, productRef, rule);
  };
  protoOf(Companion_55).failWithErrors = function (results) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return new PlacementResult(tmp$ret$0, results, null);
  };
  protoOf(Companion_55).warn = function (message, placedEntity, productRef, rule) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [new ValidationResultWarning(message, productRef, rule)];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$3 = [];
    return new PlacementResult(tmp, tmp$ret$3, placedEntity);
  };
  var Companion_instance_88;
  function Companion_getInstance_64() {
    return Companion_instance_88;
  }
  function PlacementResult(warnings, errors, entity) {
    this.warnings = warnings;
    this.errors = errors;
    var tmp = this;
    var tmp1_elvis_lhs = entity == null ? null : get_snapRoot(entity);
    tmp.placedEntity = tmp1_elvis_lhs == null ? entity : tmp1_elvis_lhs;
  }
  protoOf(PlacementResult).r2t = function () {
    return this.warnings;
  };
  protoOf(PlacementResult).s2t = function () {
    return this.errors;
  };
  protoOf(PlacementResult).t2t = function () {
    return none(this.errors);
  };
  protoOf(PlacementResult).n3c = function () {
    return this.placedEntity;
  };
  protoOf(PlacementResult).toString = function () {
    var tmp0_safe_receiver = firstOrNull_0(this.errors);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return 'Placement error ' + tmp0_safe_receiver;
    }
    var tmp1_safe_receiver = firstOrNull_0(this.warnings);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return 'Placement warning ' + tmp1_safe_receiver;
    }
    return 'Placement OK';
  };
  function get_logger() {
    _init_properties_PlacementService_kt__rip640();
    return logger;
  }
  var logger;
  function noAutoAdaptServiceResult($this, productRef) {
    return Companion_instance_88.failWithMessage('No AutoAdaptService, so no auto adapting allowed', productRef, null);
  }
  function autoAdaptToScene($this, entityToPlace, sortAndSelectStrategy) {
    if ($this.p3c_1 == null)
      return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
    if ($this.q3c_1 == null)
      return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
    return $this.q3c_1.autoAdaptToScene(entityToPlace, sortAndSelectStrategy);
  }
  function autoAdaptToPosition($this, entityToPlace, initialPosition, sortByWarnings, sortAndSelectStrategy) {
    if ($this.p3c_1 == null)
      return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
    if ($this.q3c_1 == null)
      return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
    return $this.q3c_1.autoAdaptToPosition(entityToPlace, initialPosition, sortByWarnings, sortAndSelectStrategy);
  }
  function autoAdaptToTarget($this, entityToPlace, target, sortAndSelectStrategy) {
    if ($this.p3c_1 == null)
      return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
    if ($this.q3c_1 == null)
      return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
    return $this.q3c_1.autoAdaptToHost(entityToPlace, target, sortAndSelectStrategy);
  }
  function canAutoAdapt($this, entityToPlace) {
    var tmp;
    if (!($this.p3c_1 == null)) {
      tmp = entityToPlace.hasComponent(126);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function getInitialPosition($this, entityToPlace, closeTo) {
    var tmp1_safe_receiver = recommendedPosition(entityToPlace, closeTo == null ? get_worldPosition(entityToPlace) : closeTo);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp1_safe_receiver;
    }
    if (closeTo == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return closeTo;
    }
    var tmp3_safe_receiver = get_axisAlignedBoundingBoxForHierarchy(entityToPlace);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return new Vector(VOID, -tmp3_safe_receiver.min.Y);
    }
    return Companion_getInstance_4().ZERO;
  }
  function autoAdaptToTargets($this, entityToPlace, targets, sortAndSelectStrategy) {
    if ($this.p3c_1 == null)
      return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
    if ($this.q3c_1 == null)
      return noAutoAdaptServiceResult($this, get_productRefOrEmptyString(entityToPlace));
    return $this.q3c_1.autoAdaptToTargets(entityToPlace, targets, sortAndSelectStrategy);
  }
  function PlacementService$snapToTarget$lambda(this$0, $entityToPlace, $sortAndSelectStrategy) {
    return function (host) {
      var tmp;
      if (canAutoAdapt(this$0, $entityToPlace)) {
        tmp = autoAdaptToTarget(this$0, $entityToPlace, host, $sortAndSelectStrategy);
      } else {
        tmp = this$0.r3c_1.snapToTarget($entityToPlace, host, $sortAndSelectStrategy);
      }
      return tmp;
    };
  }
  function PlacementService$snapToConnector$lambda($guestConnectorKey) {
    return function (it) {
      var tmp0_safe_receiver = get_connectorsComponent(it);
      return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey($guestConnectorKey);
    };
  }
  function PlacementService$snapToConnector$lambda_0($hostConnectorKey) {
    return function (it) {
      var tmp0_safe_receiver = get_connectorsComponent(it);
      return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getConnectorByKey($hostConnectorKey);
    };
  }
  function PlacementService$dissolveEntity$lambda() {
    return 'Trying to dissolve an entity with no parent, which is not allowed. Use ConnectionUtils.disconnectAndDisposeEntityAndHierarchy() instead.';
  }
  function PlacementService$replaceProductParts$lambda(_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd) {
    return Unit_instance;
  }
  function PlacementService(coreServices, autoAdaptService) {
    autoAdaptService = autoAdaptService === VOID ? null : autoAdaptService;
    this.o3c_1 = coreServices;
    this.p3c_1 = autoAdaptService;
    var tmp = this;
    var tmp_0;
    if (this.p3c_1 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.placement.PlacementService.autoAdaptPlacementActor.<anonymous>' call
      tmp_0 = new AutoAdaptPlacementActor(this.p3c_1, this.o3c_1.entityManager, this.o3c_1.sceneManager, this.o3c_1.productManager, this.o3c_1.validations);
    }
    tmp.q3c_1 = tmp_0;
    this.r3c_1 = new SnapPlacementActor(this.o3c_1.entityManager, this.o3c_1.sceneManager, this.o3c_1.validations);
  }
  protoOf(PlacementService).s3c = function (entityToPlace, initialPosition, ignoreWarnings, searchDirections, sortAndSelectStrategy) {
    var result = canAutoAdapt(this, entityToPlace) ? autoAdaptToPosition(this, entityToPlace, initialPosition, !ignoreWarnings, sortAndSelectStrategy) : null;
    if (result == null ? true : !result.valid) {
      result = this.r3c_1.snapToSceneFromPosition(entityToPlace, initialPosition, !ignoreWarnings, searchDirections, sortAndSelectStrategy);
    }
    return result;
  };
  protoOf(PlacementService).snapToPosition = function (entityToPlace, initialPosition, ignoreWarnings, searchDirections, sortAndSelectStrategy, $super) {
    var tmp;
    if (searchDirections === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [Companion_getInstance_4().LEFT, Companion_getInstance_4().RIGHT, Companion_getInstance_4().UP, Companion_getInstance_4().DOWN, Companion_getInstance_4().BACK, Companion_getInstance_4().FORWARD];
    } else {
      tmp = searchDirections;
    }
    searchDirections = tmp;
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE : sortAndSelectStrategy;
    return this.s3c(entityToPlace, initialPosition, ignoreWarnings, searchDirections, sortAndSelectStrategy);
  };
  protoOf(PlacementService).t3c = function (entityToPlace, closeTo, searchDirections, sortAndSelectStrategy) {
    var originalTransform = get_worldTransform(entityToPlace);
    var recommendedPos = getInitialPosition(this, entityToPlace, closeTo);
    TransformUtils_instance.setWorldTransform(entityToPlace, new Transform(recommendedPos, originalTransform.rotation));
    var result = canAutoAdapt(this, entityToPlace) ? autoAdaptToScene(this, entityToPlace, sortAndSelectStrategy) : null;
    if (result == null ? true : !result.valid) {
      result = this.r3c_1.snapToSceneFromPosition(entityToPlace, recommendedPos, true, searchDirections, sortAndSelectStrategy);
    }
    if (!result.valid) {
      TransformUtils_instance.setWorldTransform(entityToPlace, originalTransform);
    }
    return result;
  };
  protoOf(PlacementService).snapToScene = function (entityToPlace, closeTo, searchDirections, sortAndSelectStrategy, $super) {
    closeTo = closeTo === VOID ? null : closeTo;
    var tmp;
    if (searchDirections === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [Companion_getInstance_4().LEFT, Companion_getInstance_4().RIGHT, Companion_getInstance_4().UP, Companion_getInstance_4().DOWN, Companion_getInstance_4().BACK, Companion_getInstance_4().FORWARD];
    } else {
      tmp = searchDirections;
    }
    searchDirections = tmp;
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_THEN_DISTANCE : sortAndSelectStrategy;
    return this.t3c(entityToPlace, closeTo, searchDirections, sortAndSelectStrategy);
  };
  protoOf(PlacementService).u3c = function (entityToPlace, target, sortAndSelectStrategy) {
    var originalTransform = get_worldTransform(entityToPlace);
    var tmp0_elvis_lhs = recommendedPosition(entityToPlace, get_worldPosition(entityToPlace));
    var recommendedPos = tmp0_elvis_lhs == null ? originalTransform.position : tmp0_elvis_lhs;
    TransformUtils_instance.setWorldTransform(entityToPlace, new Transform(recommendedPos, originalTransform.rotation));
    var snapExact = PlacementService$snapToTarget$lambda(this, entityToPlace, sortAndSelectStrategy);
    var exactResult = snapExact(target);
    if (exactResult.valid) {
      return exactResult;
    }
    var eligibleHosts = minus(hierarchyExceptSubTreesWithComponentSequence(target, 28), target);
    var tmp1_iterator = eligibleHosts.t();
    while (tmp1_iterator.u()) {
      var host = tmp1_iterator.w();
      var result = snapExact(host);
      if (result.valid) {
        return result;
      }
    }
    TransformUtils_instance.setWorldTransform(entityToPlace, originalTransform);
    return exactResult;
  };
  protoOf(PlacementService).snapToTarget = function (entityToPlace, target, sortAndSelectStrategy, $super) {
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_THEN_DISTANCE : sortAndSelectStrategy;
    return this.u3c(entityToPlace, target, sortAndSelectStrategy);
  };
  protoOf(PlacementService).v3c = function (entityToPlace, targets, sortAndSelectStrategy) {
    var originalTransform = get_worldTransform(entityToPlace);
    var tmp0_elvis_lhs = recommendedPosition(entityToPlace, get_worldPosition(entityToPlace));
    var recommendedPos = tmp0_elvis_lhs == null ? originalTransform.position : tmp0_elvis_lhs;
    TransformUtils_instance.setWorldTransform(entityToPlace, new Transform(recommendedPos, originalTransform.rotation));
    entityToPlace.addComponent(new RestrictAllowedRequiredHostsComponent(targets));
    var tmp;
    if (canAutoAdapt(this, entityToPlace)) {
      tmp = autoAdaptToTargets(this, entityToPlace, targets, sortAndSelectStrategy);
    } else {
      tmp = this.r3c_1.snapToTargets(entityToPlace, targets, sortAndSelectStrategy);
    }
    var result = tmp;
    var tmp1_elvis_lhs = result.placedEntity;
    (tmp1_elvis_lhs == null ? entityToPlace : tmp1_elvis_lhs).removeComponent(Companion_instance_2.id);
    return result;
  };
  protoOf(PlacementService).snapToTargets = function (entityToPlace, targets, sortAndSelectStrategy, $super) {
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_THEN_DISTANCE : sortAndSelectStrategy;
    return this.v3c(entityToPlace, targets, sortAndSelectStrategy);
  };
  protoOf(PlacementService).alignToTarget = function (entityToPlace, target) {
    return this.r3c_1.alignToTarget(entityToPlace, target);
  };
  protoOf(PlacementService).alignToTargetSpecificConnectors = function (entityToPlace, entityAlignmentConnectorKey, target, targetAlignmentConnectorKey) {
    return this.r3c_1.alignToTarget(entityToPlace, target, entityAlignmentConnectorKey, targetAlignmentConnectorKey);
  };
  protoOf(PlacementService).addToScene = function (entityToPlace) {
    this.o3c_1.entityManager.addComponent(entityToPlace, new ChildComponent(this.o3c_1.sceneManager.scene));
    return Companion_instance_88.ok(entityToPlace);
  };
  protoOf(PlacementService).w3c = function (entityToPlace, position, rotationEulerDegrees) {
    var pos = position == null ? Companion_getInstance_4().ZERO : position;
    var rot = rotationEulerDegrees == null ? Companion_getInstance_4().ZERO : rotationEulerDegrees;
    this.o3c_1.entityManager.addComponent(entityToPlace, LocalTransformComponentFromPosAndRot(pos, Companion_getInstance_6().fromEulerDegreesVector(rot)));
    setParent(entityToPlace, this.o3c_1.sceneManager.scene);
  };
  protoOf(PlacementService).forcePlaceEntity = function (entityToPlace, position, rotationEulerDegrees, $super) {
    position = position === VOID ? null : position;
    rotationEulerDegrees = rotationEulerDegrees === VOID ? null : rotationEulerDegrees;
    return this.w3c(entityToPlace, position, rotationEulerDegrees);
  };
  protoOf(PlacementService).x3c = function (entityToPlace, target, sortAndSelectStrategy) {
    var originalTransform = get_worldTransform(entityToPlace);
    var tmp0_elvis_lhs = recommendedPosition(entityToPlace, get_worldPosition(entityToPlace));
    var recommendedPos = tmp0_elvis_lhs == null ? originalTransform.position : tmp0_elvis_lhs;
    TransformUtils_instance.setWorldTransform(entityToPlace, new Transform(recommendedPos, originalTransform.rotation));
    var exactResult = this.r3c_1.forceSnapToTarget(entityToPlace, target, sortAndSelectStrategy);
    if (exactResult.valid) {
      return exactResult;
    }
    var eligibleHosts = minus(hierarchyExceptSubTreesWithComponentSequence(target, 28), target);
    var tmp1_iterator = eligibleHosts.t();
    while (tmp1_iterator.u()) {
      var host = tmp1_iterator.w();
      var result = this.r3c_1.forceSnapToTarget(entityToPlace, host, sortAndSelectStrategy);
      if (result.valid) {
        return result;
      }
    }
    TransformUtils_instance.setWorldTransform(entityToPlace, originalTransform);
    return exactResult;
  };
  protoOf(PlacementService).forceSnapEntity = function (entityToPlace, target, sortAndSelectStrategy, $super) {
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_THEN_DISTANCE : sortAndSelectStrategy;
    return this.x3c(entityToPlace, target, sortAndSelectStrategy);
  };
  protoOf(PlacementService).y3c = function (hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey) {
    SnapUtils_instance.createForcedSnapActionCandidate(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey).createAction().perform();
  };
  protoOf(PlacementService).forceSnapEntityWithConnectors = function (hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey, $super) {
    connectorOnHostKey = connectorOnHostKey === VOID ? '' : connectorOnHostKey;
    connectorOnGuestKey = connectorOnGuestKey === VOID ? '' : connectorOnGuestKey;
    return this.y3c(hostEntity, guestEntity, connectorOnHostKey, connectorOnGuestKey);
  };
  protoOf(PlacementService).snapToConnector = function (guestEntity, guestConnectorKey, hostEntity, hostConnectorKey) {
    var tmp = get_hierarchySequence(guestEntity);
    var guestConnector = firstOrNull(mapNotNull(tmp, PlacementService$snapToConnector$lambda(guestConnectorKey)));
    var tmp_0 = get_hierarchySequence(hostEntity);
    var hostConnector = firstOrNull(mapNotNull(tmp_0, PlacementService$snapToConnector$lambda_0(hostConnectorKey)));
    var tmp_1;
    if (!(hostConnector == null) ? !(guestConnector == null) : false) {
      tmp_1 = this.r3c_1.snapToConnector(guestEntity, guestConnector, hostEntity, hostConnector);
    } else if (guestConnector == null) {
      tmp_1 = Companion_instance_88.failWithMessage('guestEntity ' + guestEntity + ' has no connector with key ' + guestConnectorKey, '', null);
    } else if (hostConnector == null) {
      tmp_1 = Companion_instance_88.failWithMessage('hostEntity ' + hostEntity + ' has no connector with key ' + hostConnectorKey, '', null);
    } else {
      tmp_1 = Companion_instance_88.failWithMessage('guestEntity ' + guestEntity + ' has no connector with key ' + guestConnectorKey + ' and hostEntity ' + hostEntity + ' has no connector with key ' + hostConnectorKey, '', null);
    }
    return tmp_1;
  };
  protoOf(PlacementService).dissolveEntity = function (dissolvingEntity) {
    var dissolvingEntityParent = get_parent(dissolvingEntity);
    if (dissolvingEntityParent == null) {
      var tmp = get_logger();
      tmp.warn(PlacementService$dissolveEntity$lambda);
      // Inline function 'kotlin.emptyArray' call
      return [];
    }
    var dissolvingEntityDescendants = get_immediateConnectionRootDescendants(dissolvingEntity);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = dissolvingEntityDescendants.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.placement.PlacementService.dissolveEntity.<anonymous>' call
      ConnectionUtils_instance.disconnect(element);
    }
    ConnectionUtils_instance.disconnectAndDisposeEntityAndHierarchy(dissolvingEntity);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(dissolvingEntityDescendants, 10));
    var tmp0_iterator_0 = dissolvingEntityDescendants.t();
    while (tmp0_iterator_0.u()) {
      var item = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.placement.PlacementService.dissolveEntity.<anonymous>' call
      var tmp0_elvis_lhs = get_snapRoot(item);
      var entityRoot = tmp0_elvis_lhs == null ? item : tmp0_elvis_lhs;
      var candidates = SnapUtils_instance.matchingSnapActionCandidates(entityRoot, dissolvingEntityParent, new SnapSettings(true, false, true, true));
      var sortedCandidates = SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_DISTANCE.sortAndSelect(candidates);
      var result = this.o3c_1.validations.getFirstValidSnapAction(sortedCandidates);
      var tmp1_safe_receiver = result.snapActionCandidate;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.createAction();
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.perform();
      }
      var tmp$ret$1 = new PlacementResult(result.warnings, result.errors, item);
      destination.q(tmp$ret$1);
    }
    var results = destination;
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(results);
  };
  protoOf(PlacementService).replaceEntity = function (entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter) {
    return ReplaceUtils_instance.replaceEntity(entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, this.o3c_1);
  };
  protoOf(PlacementService).fastReplaceEntity = function (entityToRemove, entityToAdd) {
    return ReplaceUtils_instance.fastReplaceEntity(entityToRemove, entityToAdd, this.o3c_1);
  };
  protoOf(PlacementService).z3c = function (connectionRoot, partsMap, onReplace) {
    return ReplaceAssemblyPartUtils_getInstance().replaceProductParts(connectionRoot, partsMap, this.o3c_1, onReplace);
  };
  protoOf(PlacementService).replaceProductParts = function (connectionRoot, partsMap, onReplace, $super) {
    var tmp;
    if (onReplace === VOID) {
      tmp = PlacementService$replaceProductParts$lambda;
    } else {
      tmp = onReplace;
    }
    onReplace = tmp;
    return this.z3c(connectionRoot, partsMap, onReplace);
  };
  function recommendedPosition(_this__u8e3s4, originalPosition) {
    _init_properties_PlacementService_kt__rip640();
    var result = null;
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(59);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      result = originalPosition.copy(VOID, tmp0_safe_receiver.offsetY);
    }
    if (_this__u8e3s4.__getComponentForKotlin(60) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp = get_logger();
      tmp.warn(recommendedPosition$lambda);
    }
    return result;
  }
  function recommendedPosition$lambda() {
    _init_properties_PlacementService_kt__rip640();
    return 'PositionFromParent is not yet implemented';
  }
  var properties_initialized_PlacementService_kt_qk8kha;
  function _init_properties_PlacementService_kt__rip640() {
    if (!properties_initialized_PlacementService_kt_qk8kha) {
      properties_initialized_PlacementService_kt_qk8kha = true;
      logger = LoggerState_getInstance().m1m('PlacementService');
    }
  }
  function Companion_56() {
    this.id = 58;
  }
  protoOf(Companion_56).s1k = function () {
    return this.id;
  };
  var Companion_instance_89;
  function Companion_getInstance_65() {
    return Companion_instance_89;
  }
  function PlacementZoneByHeightComponent(minY, maxY) {
    this.minY = minY;
    this.maxY = maxY;
    this.a3d_1 = 58;
  }
  protoOf(PlacementZoneByHeightComponent).b3d = function () {
    return this.minY;
  };
  protoOf(PlacementZoneByHeightComponent).c3d = function () {
    return this.maxY;
  };
  protoOf(PlacementZoneByHeightComponent).x1k = function () {
    return this.a3d_1;
  };
  protoOf(PlacementZoneByHeightComponent).eq = function (other) {
    var o = other instanceof PlacementZoneByHeightComponent ? other : THROW_CCE();
    return o.minY === this.minY ? o.maxY === this.maxY : false;
  };
  protoOf(PlacementZoneByHeightComponent).af = function () {
    return this.minY;
  };
  protoOf(PlacementZoneByHeightComponent).bf = function () {
    return this.maxY;
  };
  protoOf(PlacementZoneByHeightComponent).d3d = function (minY, maxY) {
    return new PlacementZoneByHeightComponent(minY, maxY);
  };
  protoOf(PlacementZoneByHeightComponent).copy = function (minY, maxY, $super) {
    minY = minY === VOID ? this.minY : minY;
    maxY = maxY === VOID ? this.maxY : maxY;
    return this.d3d(minY, maxY);
  };
  protoOf(PlacementZoneByHeightComponent).toString = function () {
    return 'PlacementZoneByHeightComponent(minY=' + this.minY + ', maxY=' + this.maxY + ')';
  };
  protoOf(PlacementZoneByHeightComponent).hashCode = function () {
    var result = this.minY;
    result = imul(result, 31) + this.maxY | 0;
    return result;
  };
  protoOf(PlacementZoneByHeightComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacementZoneByHeightComponent))
      return false;
    var tmp0_other_with_cast = other instanceof PlacementZoneByHeightComponent ? other : THROW_CCE();
    if (!(this.minY === tmp0_other_with_cast.minY))
      return false;
    if (!(this.maxY === tmp0_other_with_cast.maxY))
      return false;
    return true;
  };
  function Companion_57() {
    this.id = 59;
  }
  protoOf(Companion_57).s1k = function () {
    return this.id;
  };
  var Companion_instance_90;
  function Companion_getInstance_66() {
    return Companion_instance_90;
  }
  function RecommendedInitialPositionFromFloorComponent(offsetY) {
    this.offsetY = offsetY;
  }
  protoOf(RecommendedInitialPositionFromFloorComponent).e3d = function () {
    return this.offsetY;
  };
  protoOf(RecommendedInitialPositionFromFloorComponent).x1k = function () {
    return 59;
  };
  protoOf(RecommendedInitialPositionFromFloorComponent).eq = function (other) {
    var o = other instanceof RecommendedInitialPositionFromFloorComponent ? other : THROW_CCE();
    return o.offsetY === this.offsetY;
  };
  protoOf(RecommendedInitialPositionFromFloorComponent).af = function () {
    return this.offsetY;
  };
  protoOf(RecommendedInitialPositionFromFloorComponent).f3d = function (offsetY) {
    return new RecommendedInitialPositionFromFloorComponent(offsetY);
  };
  protoOf(RecommendedInitialPositionFromFloorComponent).copy = function (offsetY, $super) {
    offsetY = offsetY === VOID ? this.offsetY : offsetY;
    return this.f3d(offsetY);
  };
  protoOf(RecommendedInitialPositionFromFloorComponent).toString = function () {
    return 'RecommendedInitialPositionFromFloorComponent(offsetY=' + this.offsetY + ')';
  };
  protoOf(RecommendedInitialPositionFromFloorComponent).hashCode = function () {
    return this.offsetY;
  };
  protoOf(RecommendedInitialPositionFromFloorComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RecommendedInitialPositionFromFloorComponent))
      return false;
    var tmp0_other_with_cast = other instanceof RecommendedInitialPositionFromFloorComponent ? other : THROW_CCE();
    if (!(this.offsetY === tmp0_other_with_cast.offsetY))
      return false;
    return true;
  };
  function Companion_58() {
    this.id = 60;
  }
  protoOf(Companion_58).s1k = function () {
    return this.id;
  };
  var Companion_instance_91;
  function Companion_getInstance_67() {
    return Companion_instance_91;
  }
  function RecommendedInitialPositionFromParentComponent(referencePoint, offsetX, offsetY, offsetZ) {
    this.referencePoint = referencePoint;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    this.offsetZ = offsetZ;
  }
  protoOf(RecommendedInitialPositionFromParentComponent).g3d = function () {
    return this.referencePoint;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).h3d = function () {
    return this.offsetX;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).e3d = function () {
    return this.offsetY;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).i3d = function () {
    return this.offsetZ;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).x1k = function () {
    return 60;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).eq = function (other) {
    var o = other instanceof RecommendedInitialPositionFromParentComponent ? other : THROW_CCE();
    return ((o.referencePoint.equals(this.referencePoint) ? o.offsetX == this.offsetX : false) ? o.offsetY == this.offsetY : false) ? o.offsetZ == this.offsetZ : false;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).af = function () {
    return this.referencePoint;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).bf = function () {
    return this.offsetX;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).g1k = function () {
    return this.offsetY;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).h1k = function () {
    return this.offsetZ;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).j3d = function (referencePoint, offsetX, offsetY, offsetZ) {
    return new RecommendedInitialPositionFromParentComponent(referencePoint, offsetX, offsetY, offsetZ);
  };
  protoOf(RecommendedInitialPositionFromParentComponent).copy = function (referencePoint, offsetX, offsetY, offsetZ, $super) {
    referencePoint = referencePoint === VOID ? this.referencePoint : referencePoint;
    offsetX = offsetX === VOID ? this.offsetX : offsetX;
    offsetY = offsetY === VOID ? this.offsetY : offsetY;
    offsetZ = offsetZ === VOID ? this.offsetZ : offsetZ;
    return this.j3d(referencePoint, offsetX, offsetY, offsetZ);
  };
  protoOf(RecommendedInitialPositionFromParentComponent).toString = function () {
    return 'RecommendedInitialPositionFromParentComponent(referencePoint=' + this.referencePoint + ', offsetX=' + this.offsetX + ', offsetY=' + this.offsetY + ', offsetZ=' + this.offsetZ + ')';
  };
  protoOf(RecommendedInitialPositionFromParentComponent).hashCode = function () {
    var result = this.referencePoint.hashCode();
    result = imul(result, 31) + (this.offsetX == null ? 0 : this.offsetX) | 0;
    result = imul(result, 31) + (this.offsetY == null ? 0 : this.offsetY) | 0;
    result = imul(result, 31) + (this.offsetZ == null ? 0 : this.offsetZ) | 0;
    return result;
  };
  protoOf(RecommendedInitialPositionFromParentComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RecommendedInitialPositionFromParentComponent))
      return false;
    var tmp0_other_with_cast = other instanceof RecommendedInitialPositionFromParentComponent ? other : THROW_CCE();
    if (!this.referencePoint.equals(tmp0_other_with_cast.referencePoint))
      return false;
    if (!(this.offsetX == tmp0_other_with_cast.offsetX))
      return false;
    if (!(this.offsetY == tmp0_other_with_cast.offsetY))
      return false;
    if (!(this.offsetZ == tmp0_other_with_cast.offsetZ))
      return false;
    return true;
  };
  function getNewPositionToTheSide($this, otherAabb, candidate, ownAabb, direction) {
    var tmp;
    if (direction.equals(Companion_getInstance_4().LEFT) ? true : direction.equals(Companion_getInstance_4().RIGHT)) {
      var dist = otherAabb.center.X + direction.normalize().X * (otherAabb.size.X * 0.5 + ownAabb.size.X * 0.5) - ownAabb.center.X;
      var hostConnectorWorldSpaceRot = get_worldRotation(candidate.host).times(candidate.hostConnector.transform.rotation);
      var tmp_0 = direction.rotate(hostConnectorWorldSpaceRot);
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp$ret$0 = Math.abs(dist);
      var movement = tmp_0.times(tmp$ret$0);
      tmp = candidate.endTransform.position.plus(movement);
    } else if (direction.equals(Companion_getInstance_4().UP) ? true : direction.equals(Companion_getInstance_4().DOWN)) {
      tmp = candidate.endTransform.position.plus(new Vector(VOID, otherAabb.center.Y + direction.normalize().Y * (otherAabb.size.Y * 0.5 + ownAabb.size.Y * 0.5) - ownAabb.center.Y));
    } else {
      tmp = candidate.endTransform.position.plus(new Vector(VOID, VOID, otherAabb.center.Z + direction.normalize().Z * (otherAabb.size.Z * 0.5 + ownAabb.size.Z * 0.5) - ownAabb.center.Z));
    }
    return tmp;
  }
  function SearchDirectionsUtils() {
  }
  protoOf(SearchDirectionsUtils).findNewPositionOnSidesOfCollidingEntity = function (entity, candidate, collisionValidationResult, searchDirections, prioritizeSolvingRoomCollisions) {
    candidate.perform();
    var tmp0_elvis_lhs = get_axisAlignedBoundingBoxForHierarchy(entity);
    var ownAabb = tmp0_elvis_lhs == null ? new AxisAlignedBox(Companion_getInstance_4().ZERO, Companion_getInstance_4().ZERO) : tmp0_elvis_lhs;
    candidate.rollback();
    var tmp;
    if (prioritizeSolvingRoomCollisions) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.any' call
        var indexedObject = collisionValidationResult.collisions;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.placement.SearchDirectionsUtils.findNewPositionOnSidesOfCollidingEntity.<anonymous>' call
          if (get_isRoom(element.other)) {
            tmp$ret$1 = true;
            break $l$block;
          }
        }
        tmp$ret$1 = false;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'kotlin.math.max' call
      // Inline function 'kotlin.math.max' call
      var a = ownAabb.width;
      var b = ownAabb.height;
      var a_0 = Math.max(a, b);
      var b_0 = ownAabb.depth;
      var largest = Math.max(a_0, b_0);
      var hostConnectorWorldSpaceRot = get_worldRotation(candidate.host).times(candidate.hostConnector.transform.rotation);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(searchDirections.length);
      var inductionVariable_0 = 0;
      var last_0 = searchDirections.length;
      while (inductionVariable_0 < last_0) {
        var item = searchDirections[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.placement.SearchDirectionsUtils.findNewPositionOnSidesOfCollidingEntity.<anonymous>' call
        var tmp$ret$4 = candidate.endTransform.position.plus(item.normalize().rotate(hostConnectorWorldSpaceRot).times(largest).times(0.5));
        destination.q(tmp$ret$4);
      }
      var newPositions = destination;
      return newPositions;
    }
    var otherAabb = collisionValidationResult.aabbOfAllCollidedWith;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(searchDirections.length);
    var inductionVariable_1 = 0;
    var last_1 = searchDirections.length;
    while (inductionVariable_1 < last_1) {
      var item_0 = searchDirections[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.SearchDirectionsUtils.findNewPositionOnSidesOfCollidingEntity.<anonymous>' call
      var tmp$ret$7 = getNewPositionToTheSide(SearchDirectionsUtils_instance, otherAabb, candidate, ownAabb, item_0);
      destination_0.q(tmp$ret$7);
    }
    return destination_0;
  };
  var SearchDirectionsUtils_instance;
  function SearchDirectionsUtils_getInstance() {
    return SearchDirectionsUtils_instance;
  }
  function findBestCandidatesInTarget($this, entityToPlace, target, snapActionCandidates, sortAndSelectStrategy) {
    var result = $this.findBestCandidateAndSnap(entityToPlace, snapActionCandidates, true);
    var tmp;
    if (!result.valid) {
      var tmp_0 = get_worldPosition(entityToPlace);
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [Companion_getInstance_4().LEFT, Companion_getInstance_4().RIGHT, Companion_getInstance_4().UP, Companion_getInstance_4().DOWN, Companion_getInstance_4().BACK, Companion_getInstance_4().FORWARD];
      tmp = $this.snapToHostFromPosition(entityToPlace, target, tmp_0, true, tmp$ret$2, sortAndSelectStrategy);
    } else {
      tmp = result;
    }
    return tmp;
  }
  function getSnapActionCandidates($this, snappingGuestEntity, target, sortAndSelectStrategy) {
    var tmp;
    if (snappingGuestEntity == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.getSnapActionCandidates.<anonymous>' call
      tmp = sortAndSelectStrategy.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(snappingGuestEntity, target, $this.snapSettings));
    }
    return tmp;
  }
  function getSnappingEntity($this, entityToAdd) {
    var tmp3_elvis_lhs = get_snapRoot(entityToAdd);
    var tmp;
    if (tmp3_elvis_lhs == null) {
      var tmp0_safe_receiver = get_parentComponent(entityToAdd);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.first' call
          var inductionVariable = 0;
          var last = tmp1_safe_receiver.length;
          while (inductionVariable < last) {
            var element = tmp1_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.getSnappingEntity.<anonymous>' call
            if (!(get_connectorsComponent(element) == null)) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          throw NoSuchElementException_init_$Create$('Array contains no element matching the predicate.');
        }
        tmp_0 = tmp$ret$1;
      }
      var tmp2_safe_receiver = tmp_0;
      tmp = tmp2_safe_receiver == null ? null : get_snapRoot(tmp2_safe_receiver);
    } else {
      tmp = tmp3_elvis_lhs;
    }
    return tmp;
  }
  function findBestSnap($this, snapActionCandidates, addedEntity, sortAndSelectStrategy, sortByWarnings, searchDirections) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (snapActionCandidates.length === 0) {
      return failDueToNoSnaps($this, addedEntity);
    }
    $this.k3d_1.addComponent(addedEntity, new SnapCandidateComponent());
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(snapActionCandidates.length);
    var inductionVariable = 0;
    var last = snapActionCandidates.length;
    while (inductionVariable < last) {
      var item = snapActionCandidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestSnap.<anonymous>' call
      var tmp$ret$1 = validate_1($this, item, $this.m3d_1);
      destination.q(tmp$ret$1);
    }
    var validatedCandidates = destination;
    var bestSoFar = null;
    var tmp0_iterator = validatedCandidates.t();
    while (tmp0_iterator.u()) {
      var cr = tmp0_iterator.w();
      if (cr.valid()) {
        bestSoFar = best($this, cr, bestSoFar, sortAndSelectStrategy, sortByWarnings);
      } else if (cr.candidate.hostConnector.isContinuousConnector ? cr.candidate.alignmentInitiatorCandidate == null : false) {
        bestSoFar = findBestValidPositionOnConnector$default($this, validatedCandidates, bestSoFar, listOf(cr), addedEntity, cr.candidate, searchDirections, $this.m3d_1, sortAndSelectStrategy, sortByWarnings);
      }
    }
    var tmp;
    if (!(bestSoFar == null)) {
      var warnings = bestSoFar.results;
      tmp = performSnapAction($this, addedEntity, bestSoFar.candidate, warnings);
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator_0 = validatedCandidates.t();
      while (tmp0_iterator_0.u()) {
        var element = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestSnap.<anonymous>' call
        var list = toList(element.results);
        addAll_0(destination_0, list);
      }
      var allResults = copyToArray(destination_0);
      tmp = performSnapAction($this, addedEntity, null, allResults);
    }
    var placementResult = tmp;
    $this.k3d_1.removeComponent(addedEntity, Companion_instance_21.id);
    return placementResult;
  }
  function validate_1($this, candidate, validationService) {
    var candidateResult = new CandidateResult(candidate, validationService.validateSnap(candidate));
    return candidateResult;
  }
  function getAlignmentCandidatesThatResolvesCollision($this, candidates, failedCandidateResult) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = failedCandidateResult.results;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.getAlignmentCandidatesThatResolvesCollision.<anonymous>' call
      if (element instanceof CollisionValidationResult) {
        var tmp0_safe_receiver = firstOrNull_0(element.collisions);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.other;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList_init_$Create$();
          var tmp0_iterator = candidates.t();
          while (tmp0_iterator.u()) {
            var element_0 = tmp0_iterator.w();
            // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.getAlignmentCandidatesThatResolvesCollision.<anonymous>.<anonymous>.<anonymous>' call
            var tmp;
            var tmp0_safe_receiver_0 = element_0.candidate.alignmentInitiatorCandidate;
            if (equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.host, tmp1_safe_receiver)) {
              tmp = element_0.valid();
            } else {
              tmp = false;
            }
            if (tmp) {
              destination.q(element_0);
            }
          }
          return destination;
        }
      }
    }
    return emptyList();
  }
  function CandidateResult(candidate, results) {
    this.candidate = candidate;
    this.results = results;
    this.n3d_1 = 0;
  }
  protoOf(CandidateResult).o3d = function () {
    return this.candidate;
  };
  protoOf(CandidateResult).p3d = function () {
    return this.results;
  };
  protoOf(CandidateResult).valid = function () {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.none' call
      var indexedObject = this.results;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.placement.CandidateResult.valid.<anonymous>' call
        if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  };
  protoOf(CandidateResult).countWarnings = function () {
    // Inline function 'kotlin.collections.count' call
    var count = 0;
    var indexedObject = this.results;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.CandidateResult.countWarnings.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_WARNING_getInstance())) {
        count = count + 1 | 0;
      }
    }
    return count;
  };
  protoOf(CandidateResult).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof CandidateResult))
      THROW_CCE();
    if (!equals(this.candidate, other.candidate))
      return false;
    return true;
  };
  protoOf(CandidateResult).hashCode = function () {
    if (this.n3d_1 === 0)
      this.n3d_1 = hashCode(this.candidate);
    return this.n3d_1;
  };
  protoOf(CandidateResult).af = function () {
    return this.candidate;
  };
  protoOf(CandidateResult).bf = function () {
    return this.results;
  };
  protoOf(CandidateResult).q3d = function (candidate, results) {
    return new CandidateResult(candidate, results);
  };
  protoOf(CandidateResult).copy = function (candidate, results, $super) {
    candidate = candidate === VOID ? this.candidate : candidate;
    results = results === VOID ? this.results : results;
    return this.q3d(candidate, results);
  };
  protoOf(CandidateResult).toString = function () {
    return 'CandidateResult(candidate=' + this.candidate + ', results=' + toString(this.results) + ')';
  };
  function findBestValidPositionOnConnector($this, validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sortAndSelectStrategy, sortByWarnings, triedPositions, level) {
    if (level >= 5) {
      var tmp = Companion_getInstance_68().logger;
      tmp.info(SnapPlacementActor$findBestValidPositionOnConnector$lambda(level));
      return bestSoFar;
    }
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = failed.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
      var list = getAlignmentCandidatesThatResolvesCollision($this, validatedCandidates, element);
      addAll_0(destination, list);
    }
    var validAlignments = destination;
    var localBest = null;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = validAlignments.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
      localBest = best($this, element_0, localBest, sortAndSelectStrategy, sortByWarnings);
    }
    var tmp0_safe_receiver = localBest;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return best($this, tmp0_safe_receiver, bestSoFar, sortAndSelectStrategy, sortByWarnings);
    }
    var initialTransform = get_worldTransform(entityToAdd);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterNot' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = failed.t();
    while (tmp0_iterator_1.u()) {
      var element_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
      var list_0 = findNewPositionThatMightSatisfyFailedResult($this, element_1, entityToAdd, searchDirections, level);
      addAll_0(destination_0, list_0);
    }
    // Inline function 'kotlin.collections.filterNotTo' call
    var this_0 = distinct(destination_0);
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_2 = this_0.t();
    while (tmp0_iterator_2.u()) {
      var element_2 = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
      if (!triedPositions.p(element_2)) {
        destination_1.q(element_2);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var tmp0_iterator_3 = destination_1.t();
    while (tmp0_iterator_3.u()) {
      var element_3 = tmp0_iterator_3.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
      if (bestSoFar == null ? true : initialTransform.position.distanceTo(element_3) < bestSoFar.candidate.movement.size) {
        destination_2.q(element_3);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_4 = destination_2.t();
    while (tmp0_iterator_4.u()) {
      var element_4 = tmp0_iterator_4.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
      if (SnapUtils_instance.isNewPositionOnHostConnector(candidate, element_4)) {
        destination_3.q(element_4);
      }
    }
    var newPositions = destination_3;
    if (newPositions.b1() ? !(bestSoFar == null) : false) {
      return bestSoFar;
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(newPositions, 10));
    var tmp0_iterator_5 = newPositions.t();
    while (tmp0_iterator_5.u()) {
      var item = tmp0_iterator_5.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
      var newCandidate = SnapUtils_instance.createCandidate(candidate.guest, candidate.guestConnector, candidate.host, candidate.hostConnector, candidate.endTransform.copy(item), VOID, VOID, initialTransform);
      var tmp$ret$16 = validate_1($this, newCandidate, validationService);
      destination_4.q(tmp$ret$16);
    }
    var newResults = destination_4;
    localBest = null;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_5 = ArrayList_init_$Create$();
    var tmp0_iterator_6 = newResults.t();
    while (tmp0_iterator_6.u()) {
      var element_5 = tmp0_iterator_6.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
      if (element_5.valid()) {
        destination_5.q(element_5);
      }
    }
    var tmp0_iterator_7 = destination_5.t();
    while (tmp0_iterator_7.u()) {
      var element_6 = tmp0_iterator_7.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findBestValidPositionOnConnector.<anonymous>' call
      localBest = best($this, element_6, localBest, sortAndSelectStrategy, sortByWarnings);
    }
    var tmp1_safe_receiver = localBest;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return best($this, tmp1_safe_receiver, bestSoFar, sortAndSelectStrategy, sortByWarnings);
    }
    return findBestValidPositionOnConnector($this, validatedCandidates, bestSoFar, newResults, entityToAdd, candidate, searchDirections, validationService, sortAndSelectStrategy, sortByWarnings, plus_1(triedPositions, newPositions), level + 1 | 0);
  }
  function findBestValidPositionOnConnector$default($this, validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sortAndSelectStrategy, sortByWarnings, triedPositions, level, $super) {
    triedPositions = triedPositions === VOID ? emptyList() : triedPositions;
    level = level === VOID ? 0 : level;
    return findBestValidPositionOnConnector($this, validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sortAndSelectStrategy, sortByWarnings, triedPositions, level);
  }
  function findNewPositionThatMightSatisfyFailedResult($this, failed, entityToAdd, searchDirections, level) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = failed.results;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.findNewPositionThatMightSatisfyFailedResult.<anonymous>' call
      var tmp;
      if (element instanceof CollisionValidationResult) {
        tmp = SearchDirectionsUtils_instance.findNewPositionOnSidesOfCollidingEntity(entityToAdd, failed.candidate, element, searchDirections, level === 0);
      } else {
        tmp = emptyList();
      }
      var list = tmp;
      addAll_0(destination, list);
    }
    return destination;
  }
  function best($this, candidate, bestSoFar, sortAndSelectStrategy, sortByWarnings) {
    if (!candidate.valid())
      return bestSoFar;
    if (bestSoFar == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (sortByWarnings ? candidate.countWarnings() < bestSoFar.countWarnings() : false) {
        tmp = candidate;
      } else {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [bestSoFar.candidate, candidate.candidate];
        var first = firstOrNull_0(sortAndSelectStrategy.sortAndSelect(tmp$ret$2));
        tmp = equals(first, candidate.candidate) ? candidate : bestSoFar;
      }
      return tmp;
    }
    return candidate;
  }
  function moveToPosition($this, entity, position) {
    var tmp0_elvis_lhs = get_snapRoot(entity);
    var snapRoot = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    if (snapRoot.equals(entity)) {
      TransformUtils_instance.setWorldTransform(entity, new Transform(position, get_worldRotation(entity)));
    } else {
      var delta = position.minus(get_worldPosition(entity));
      TransformUtils_instance.setWorldTransform(snapRoot, new Transform(get_worldPosition(snapRoot).plus(delta), get_worldRotation(snapRoot)));
    }
  }
  function failDueToNoSnaps($this, entity) {
    return Companion_instance_88.failWithMessage('Found no snap action candidates', get_productRefOrEmptyString(entity), null);
  }
  function performSnapAction($this, entity, snapActionCandidate, results) {
    if (snapActionCandidate == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var snapAction = snapActionCandidate.createAction();
      snapAction.perform();
      var tmp;
      if (any_0(results)) {
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        tmp = new PlacementResult(results, tmp$ret$0, snapActionCandidate.guest);
      } else {
        tmp = Companion_instance_88.ok(entity);
      }
      return tmp;
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = results.length;
    while (inductionVariable < last) {
      var element = results[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.performSnapAction.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
        destination.q(element);
      }
    }
    var errors = copyToArray(destination);
    var tmp_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(errors.length === 0)) {
      tmp_0 = Companion_instance_88.failWithErrors(errors);
    } else {
      tmp_0 = failDueToNoSnaps($this, entity);
    }
    return tmp_0;
  }
  function Companion_59() {
    Companion_instance_92 = this;
    this.MAX_SEARCH_LVL_SNAP_TO_SCENE = 5;
    this.logger = LoggerState_getInstance().m1m('SnapPlacementActor');
  }
  protoOf(Companion_59).r3d = function () {
    return this.MAX_SEARCH_LVL_SNAP_TO_SCENE;
  };
  protoOf(Companion_59).x1i = function () {
    return this.logger;
  };
  var Companion_instance_92;
  function Companion_getInstance_68() {
    if (Companion_instance_92 == null)
      new Companion_59();
    return Companion_instance_92;
  }
  function SnapPlacementActor$snapToTargets$lambda(this$0, $entityToPlace, $snapActionCandidates, $sortAndSelectStrategy) {
    return function (target) {
      return findBestCandidatesInTarget(this$0, $entityToPlace, target, $snapActionCandidates, $sortAndSelectStrategy);
    };
  }
  function SnapPlacementActor$findBestValidPositionOnConnector$lambda($level) {
    return function () {
      return 'Reached too deep (lvl: ' + $level + ') when searching for non colliding placement';
    };
  }
  function SnapPlacementActor(entityManager, sceneManager, validationService) {
    Companion_getInstance_68();
    this.k3d_1 = entityManager;
    this.l3d_1 = sceneManager;
    this.m3d_1 = validationService;
    this.snapSettings = new SnapSettings(true, false, false, true);
  }
  protoOf(SnapPlacementActor).s3d = function () {
    return this.snapSettings;
  };
  protoOf(SnapPlacementActor).t3d = function (entityToPlace, target, entityAlignmentConnectorKey, targetAlignmentConnectorKey) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = SnapUtils_instance.matchingSnapActionCandidatesInScene(entityToPlace, this.l3d_1, this.snapSettings);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
      if (element.hostConnector.isContinuousConnector) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
      var tmp = element_0.guestConnector.type;
      if (tmp === 0) {
        destination_0.q(element_0);
      }
    }
    var continuousCandidates = destination_0;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = SnapUtils_instance.matchingSnapCandidatesOnHost(entityToPlace, target, this.snapSettings);
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = this_1.t();
    while (tmp0_iterator_0.u()) {
      var element_1 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
      var tmp_0 = element_1.guestConnector.type;
      if (tmp_0 === 2) {
        destination_1.q(element_1);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = destination_1.t();
    while (tmp0_iterator_1.u()) {
      var element_2 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
      if (entityAlignmentConnectorKey == null ? true : element_2.guestConnector.key === entityAlignmentConnectorKey) {
        destination_2.q(element_2);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_2 = destination_2.t();
    while (tmp0_iterator_2.u()) {
      var element_3 = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
      if (targetAlignmentConnectorKey == null ? true : element_3.hostConnector.key === targetAlignmentConnectorKey) {
        destination_3.q(element_3);
      }
    }
    var alignmentCandidates = toList_0(destination_3);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_4 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_3 = alignmentCandidates.t();
    while (tmp0_iterator_3.u()) {
      var element_4 = tmp0_iterator_3.w();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.alignToTarget.<anonymous>' call
      var tmp0_safe_receiver = SnapUtils_instance.tryToReplaceAlignmentWithRealCandidate(element_4, continuousCandidates);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_4.q(tmp0_safe_receiver);
      }
    }
    var foundAlignedCandidates = copyToArray(destination_4);
    this.k3d_1.addComponent(entityToPlace, new SnapCandidateComponent());
    var tmp0_container = this.m3d_1.getFirstValidSnapAction(foundAlignedCandidates, true);
    var candidate = tmp0_container.af();
    var results = tmp0_container.bf();
    var placementResult = performSnapAction(this, entityToPlace, candidate, results);
    this.k3d_1.removeComponent(entityToPlace, Companion_instance_21.id);
    return placementResult;
  };
  protoOf(SnapPlacementActor).alignToTarget = function (entityToPlace, target, entityAlignmentConnectorKey, targetAlignmentConnectorKey, $super) {
    entityAlignmentConnectorKey = entityAlignmentConnectorKey === VOID ? null : entityAlignmentConnectorKey;
    targetAlignmentConnectorKey = targetAlignmentConnectorKey === VOID ? null : targetAlignmentConnectorKey;
    return this.t3d(entityToPlace, target, entityAlignmentConnectorKey, targetAlignmentConnectorKey);
  };
  protoOf(SnapPlacementActor).snapToTarget = function (entityToPlace, target, sortAndSelectStrategy) {
    var snappingGuestEntity = getSnappingEntity(this, entityToPlace);
    var tmp0_elvis_lhs = getSnapActionCandidates(this, snappingGuestEntity, target, sortAndSelectStrategy);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var snapActionCandidates = tmp;
    return findBestCandidatesInTarget(this, entityToPlace, target, snapActionCandidates, sortAndSelectStrategy);
  };
  protoOf(SnapPlacementActor).forceSnapToTarget = function (entity, target, sortAndSelectStrategy) {
    var snappingGuestEntity = getSnappingEntity(this, entity);
    var tmp0_safe_receiver = getSnapActionCandidates(this, snappingGuestEntity, target, sortAndSelectStrategy);
    var snapActionCandidate = tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
    if (snapActionCandidate == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.k3d_1.addComponent(entity, new SnapCandidateComponent());
      if (get_parent(entity) == null) {
        this.k3d_1.addComponent(entity, new ChildComponent(this.l3d_1.scene));
      }
      var snapAction = snapActionCandidate.createAction();
      snapAction.perform();
      this.k3d_1.removeComponent(entity, Companion_instance_21.id);
      return Companion_instance_88.ok(entity);
    }
    return Companion_instance_88.failWithMessage('No possible snapActions in target', get_productRefOrEmptyString(entity), null);
  };
  protoOf(SnapPlacementActor).snapToTargets = function (entityToPlace, targets, sortAndSelectStrategy) {
    var tmp0_elvis_lhs = getSnappingEntity(this, entityToPlace);
    var snappingGuestEntity = tmp0_elvis_lhs == null ? entityToPlace : tmp0_elvis_lhs;
    var snapActionCandidates = sortAndSelectStrategy.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidatesMultipleHosts(snappingGuestEntity, targets, new SnapSettings(true, false, true, true)));
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'com.ikea.core.utils.otherwise' call
      // Inline function 'kotlin.sequences.find' call
      var tmp = asSequence_0(targets);
      var this_0 = map(tmp, SnapPlacementActor$snapToTargets$lambda(this, entityToPlace, snapActionCandidates, sortAndSelectStrategy));
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var tmp0_iterator = this_0.t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.snapToTargets.<anonymous>' call
          if (element.valid) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var this_1 = tmp$ret$1;
      if (this_1 == null) {
        // Inline function 'com.ikea.core.stl.placement.SnapPlacementActor.snapToTargets.<anonymous>' call
        tmp$ret$4 = Companion_instance_88.failWithMessage('No valid snap for entity', get_productRefOrEmptyString(entityToPlace), null);
        break $l$block_0;
      }
      tmp$ret$4 = this_1;
    }
    return tmp$ret$4;
  };
  protoOf(SnapPlacementActor).u3d = function (addedEntity, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy) {
    moveToPosition(this, addedEntity, initialPosition);
    var tmp0_elvis_lhs = get_snapRoot(addedEntity);
    var snappingGuestEntity = tmp0_elvis_lhs == null ? addedEntity : tmp0_elvis_lhs;
    var snapActionCandidates = sortAndSelectStrategy.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidatesInScene(snappingGuestEntity, this.l3d_1, this.snapSettings));
    return findBestSnap(this, snapActionCandidates, addedEntity, sortAndSelectStrategy, sortByWarnings, searchDirections);
  };
  protoOf(SnapPlacementActor).snapToSceneFromPosition = function (addedEntity, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy, $super) {
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE : sortAndSelectStrategy;
    return this.u3d(addedEntity, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy);
  };
  protoOf(SnapPlacementActor).v3d = function (addedEntity, target, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy) {
    moveToPosition(this, addedEntity, initialPosition);
    var tmp0_elvis_lhs = get_snapRoot(addedEntity);
    var snappingGuestEntity = tmp0_elvis_lhs == null ? addedEntity : tmp0_elvis_lhs;
    var snapActionCandidates = sortAndSelectStrategy.sortAndSelect(SnapUtils_instance.matchingSnapActionCandidates(snappingGuestEntity, target, this.snapSettings));
    return findBestSnap(this, snapActionCandidates, addedEntity, sortAndSelectStrategy, sortByWarnings, searchDirections);
  };
  protoOf(SnapPlacementActor).snapToHostFromPosition = function (addedEntity, target, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy, $super) {
    sortAndSelectStrategy = sortAndSelectStrategy === VOID ? SnapActionCandidateSortAndSelectStrategies_getInstance().SORT_BY_PRIORITY_IN_ACTIVATION_DISTANCE_THEN_DISTANCE : sortAndSelectStrategy;
    return this.v3d(addedEntity, target, initialPosition, sortByWarnings, searchDirections, sortAndSelectStrategy);
  };
  protoOf(SnapPlacementActor).findBestCandidateAndSnap = function (entity, snapActionCandidates, sortByWarnings) {
    if (snapActionCandidates == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.k3d_1.addComponent(entity, new SnapCandidateComponent());
      var res = this.m3d_1.getFirstValidSnapAction(snapActionCandidates, sortByWarnings);
      // Inline function 'kotlin.collections.plus' call
      var this_0 = res.errors;
      var elements = res.warnings;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = this_0.concat(elements);
      var placementResult = performSnapAction(this, entity, res.snapActionCandidate, tmp$ret$1);
      this.k3d_1.removeComponent(entity, Companion_instance_21.id);
      return placementResult;
    }
    return failDueToNoSnaps(this, entity);
  };
  protoOf(SnapPlacementActor).snapToConnector = function (guestEntity, guestConnector, hostEntity, hostConnector) {
    var snapActionCandidate = SnapUtils_instance.createSnapCandidate(guestEntity, guestConnector, hostEntity, hostConnector);
    var tmp;
    if (!(snapActionCandidate == null)) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [snapActionCandidate];
      tmp = this.findBestCandidateAndSnap(guestEntity, tmp$ret$2, true);
    } else {
      tmp = failDueToNoSnaps(this, guestEntity);
    }
    return tmp;
  };
  function DistanceCriterion() {
    SortCriterionBase.call(this);
  }
  protoOf(DistanceCriterion).w3d = function (a, b) {
    var tmp;
    if (a.movement.size < b.movement.size) {
      tmp = 1;
    } else if (a.movement.size > b.movement.size) {
      tmp = -1;
    } else {
      tmp = 0;
    }
    return tmp;
  };
  function FilterCriterion() {
  }
  function InActivationDistanceFilter() {
  }
  protoOf(InActivationDistanceFilter).filterCandidates = function (candidates) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = candidates.length;
    while (inductionVariable < last) {
      var element = candidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.snapsorting.InActivationDistanceFilter.filterCandidates.<anonymous>' call
      if (this.filterCandidate(element)) {
        destination.q(element);
      }
    }
    return copyToArray(destination);
  };
  protoOf(InActivationDistanceFilter).filterCandidate = function (candidate) {
    return (candidate == null ? null : candidate.inActivationDistance()) === true;
  };
  function OriginalVariantCriterion() {
    SortCriterionBase.call(this);
  }
  protoOf(OriginalVariantCriterion).w3d = function (a, b) {
    var tmp;
    if (get_hasAutoAdapted(a.guestRoot) === get_hasAutoAdapted(b.guestRoot)) {
      tmp = 0;
    } else if (!get_hasAutoAdapted(a.guestRoot)) {
      tmp = 1;
    } else {
      tmp = -1;
    }
    return tmp;
  };
  function PriorityCriterionSettings$Companion$all$1() {
    this.x3d_1 = false;
  }
  protoOf(PriorityCriterionSettings$Companion$all$1).y3d = function () {
    return this.x3d_1;
  };
  function PriorityCriterionSettings$Companion$onlyInActivationDistance$1() {
    this.z3d_1 = true;
  }
  protoOf(PriorityCriterionSettings$Companion$onlyInActivationDistance$1).y3d = function () {
    return this.z3d_1;
  };
  function Companion_60() {
    Companion_instance_93 = this;
    var tmp = this;
    tmp.all = new PriorityCriterionSettings$Companion$all$1();
    var tmp_0 = this;
    tmp_0.onlyInActivationDistance = new PriorityCriterionSettings$Companion$onlyInActivationDistance$1();
  }
  protoOf(Companion_60).a3e = function () {
    return this.all;
  };
  protoOf(Companion_60).y3d = function () {
    return this.onlyInActivationDistance;
  };
  var Companion_instance_93;
  function Companion_getInstance_69() {
    if (Companion_instance_93 == null)
      new Companion_60();
    return Companion_instance_93;
  }
  function PriorityCriterionSettings() {
  }
  function PriorityCriterion(settings) {
    SortCriterionBase.call(this);
    this.b3e_1 = settings;
  }
  protoOf(PriorityCriterion).w3d = function (a, b) {
    var tmp;
    if (a.inActivationDistance() ? true : !this.b3e_1.onlyInActivationDistance) {
      tmp = a.priority;
    } else {
      tmp = IntCompanionObject_instance.MIN_VALUE;
    }
    var aPrio = tmp;
    var tmp_0;
    if (b.inActivationDistance() ? true : !this.b3e_1.onlyInActivationDistance) {
      tmp_0 = b.priority;
    } else {
      tmp_0 = IntCompanionObject_instance.MIN_VALUE;
    }
    var bPrio = tmp_0;
    return compareTo(aPrio, bPrio);
  };
  function recommendationDistance_0($this, candidate) {
    var result = 0.0;
    var tmp = candidate.guestRoot;
    var tmp0_safe_receiver = tmp.__getComponentForKotlin(59);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = tmp0_safe_receiver.offsetY - candidate.endTransform.position.Y;
      result = Math.abs(this_0);
    }
    var tmp_0 = candidate.guestRoot;
    if (tmp_0.__getComponentForKotlin(60) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      $this.c3e_1.warn(RecommendedDistanceFromFloorCriterion$recommendationDistance$lambda);
    }
    return result;
  }
  function RecommendedDistanceFromFloorCriterion$recommendationDistance$lambda() {
    return 'PositionFromParent is not yet implemented';
  }
  function RecommendedDistanceFromFloorCriterion() {
    SortCriterionBase.call(this);
    this.c3e_1 = LoggerState_getInstance().m1m('RecommendedDistanceCriterion');
  }
  protoOf(RecommendedDistanceFromFloorCriterion).w3d = function (a, b) {
    var aDist = recommendationDistance_0(this, a);
    var bDist = recommendationDistance_0(this, b);
    return compareTo(bDist, aDist);
  };
  function bestResult($this, a, b) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var tmp0_iterator = $this.d3e_1.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestResult.<anonymous>' call
        var result = element.bestResult(a, b);
        if (!(result == null)) {
          tmp$ret$1 = result;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var best = tmp$ret$1;
    return best;
  }
  function bestCandidate($this, a, b) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var tmp0_iterator = $this.d3e_1.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestCandidate.<anonymous>' call
        var result = element.bestCandidate(a, b);
        if (!(result == null)) {
          tmp$ret$1 = result;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function sam$kotlin_Comparator$0_5(function_0) {
    this.f3e_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_5).u1j = function (a, b) {
    return this.f3e_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_5).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function sam$kotlin_Comparator$0_6(function_0) {
    this.g3e_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_6).u1j = function (a, b) {
    return this.g3e_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_6).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function SnapSorter$sortResults$lambda(this$0) {
    return function (a, b) {
      var best = bestResult(this$0, a, b);
      var tmp;
      if (best == null) {
        tmp = 0;
      } else if (equals(best, a)) {
        tmp = -1;
      } else {
        tmp = 1;
      }
      return tmp;
    };
  }
  function SnapSorter$sortCandidates$lambda(this$0) {
    return function (a, b) {
      var best = bestCandidate(this$0, a, b);
      var tmp;
      if (best == null) {
        tmp = 0;
      } else if (equals(best, a)) {
        tmp = -1;
      } else {
        tmp = 1;
      }
      return tmp;
    };
  }
  function SnapSorter(sortCriteria, filters) {
    this.d3e_1 = sortCriteria;
    this.e3e_1 = filters;
  }
  protoOf(SnapSorter).filterResults = function (results) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = results.length;
    while (inductionVariable < last) {
      var element = results[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.filterResults.<anonymous>' call
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var this_0 = this.e3e_1;
        var tmp;
        if (isInterface(this_0, Collection)) {
          tmp = this_0.b1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var tmp0_iterator = this_0.t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.filterResults.<anonymous>.<anonymous>' call
          if (!element_0.filterCandidate(element.snapActionCandidate)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      if (tmp$ret$0) {
        destination.q(element);
      }
    }
    return copyToArray(destination);
  };
  protoOf(SnapSorter).filterCandidates = function (snapCandidates) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = snapCandidates.length;
    while (inductionVariable < last) {
      var element = snapCandidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.filterCandidates.<anonymous>' call
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var this_0 = this.e3e_1;
        var tmp;
        if (isInterface(this_0, Collection)) {
          tmp = this_0.b1();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var tmp0_iterator = this_0.t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.filterCandidates.<anonymous>.<anonymous>' call
          if (!element_0.filterCandidate(element)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      if (tmp$ret$0) {
        destination.q(element);
      }
    }
    return copyToArray(destination);
  };
  protoOf(SnapSorter).sortResults = function (results) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = this.filterResults(results);
    var tmp_0 = SnapSorter$sortResults$lambda(this);
    var this_0 = sortedWith_0(tmp, new sam$kotlin_Comparator$0_5(tmp_0));
    return copyToArray(this_0);
  };
  protoOf(SnapSorter).sortCandidates = function (snapCandidates) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = this.filterCandidates(snapCandidates);
    var tmp_0 = SnapSorter$sortCandidates$lambda(this);
    var this_0 = sortedWith_0(tmp, new sam$kotlin_Comparator$0_6(tmp_0));
    return copyToArray(this_0);
  };
  protoOf(SnapSorter).bestCandidate = function (snapCandidates) {
    var bestSoFar = null;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = snapCandidates.length;
    while (inductionVariable < last) {
      var element = snapCandidates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestCandidate.<anonymous>' call
      var tmp0_safe_receiver = bestSoFar;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestCandidate.<anonymous>.<anonymous>' call
        tmp = bestCandidate(this, tmp0_safe_receiver, element);
      }
      var tmp1_elvis_lhs = tmp;
      bestSoFar = tmp1_elvis_lhs == null ? element : tmp1_elvis_lhs;
    }
    return bestSoFar;
  };
  protoOf(SnapSorter).bestResult = function (results) {
    var bestSoFar = null;
    var failingBestSoFar = null;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = results.length;
    while (inductionVariable < last) {
      var element = results[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestResult.<anonymous>' call
      if (element.valid) {
        var tmp0_safe_receiver = bestSoFar;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestResult.<anonymous>.<anonymous>' call
          tmp = bestResult(this, tmp0_safe_receiver, element);
        }
        var tmp1_elvis_lhs = tmp;
        bestSoFar = tmp1_elvis_lhs == null ? element : tmp1_elvis_lhs;
      } else {
        var tmp_0;
        if (bestSoFar == null) {
          var tmp2_safe_receiver = failingBestSoFar;
          var tmp_1;
          if (tmp2_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ikea.core.stl.placement.snapsorting.SnapSorter.bestResult.<anonymous>.<anonymous>' call
            tmp_1 = bestResult(this, tmp2_safe_receiver, element);
          }
          var tmp3_elvis_lhs = tmp_1;
          tmp_0 = tmp3_elvis_lhs == null ? element : tmp3_elvis_lhs;
        } else {
          tmp_0 = null;
        }
        failingBestSoFar = tmp_0;
      }
    }
    var tmp0_elvis_lhs = bestSoFar;
    return tmp0_elvis_lhs == null ? failingBestSoFar : tmp0_elvis_lhs;
  };
  function SnapSorterBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.h3e_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.i3e_1 = ArrayList_init_$Create$();
  }
  protoOf(SnapSorterBuilder).build = function () {
    return new SnapSorter(this.h3e_1, this.i3e_1);
  };
  protoOf(SnapSorterBuilder).addInActivationDistanceFilter = function () {
    this.i3e_1.q(new InActivationDistanceFilter());
    return this;
  };
  protoOf(SnapSorterBuilder).addDistanceCriterion = function () {
    this.h3e_1.q(new DistanceCriterion());
    return this;
  };
  protoOf(SnapSorterBuilder).addOriginalVariantCriterion = function () {
    this.h3e_1.q(new OriginalVariantCriterion());
    return this;
  };
  protoOf(SnapSorterBuilder).addConnectorPriorityCriterion = function (settings) {
    this.h3e_1.q(new PriorityCriterion(settings));
    return this;
  };
  protoOf(SnapSorterBuilder).addRecommendedDistanceFromFloorCriterion = function () {
    this.h3e_1.q(new RecommendedDistanceFromFloorCriterion());
    return this;
  };
  protoOf(SnapSorterBuilder).addWarningsCriterion = function () {
    this.h3e_1.q(new WarningsCriterion());
    return this;
  };
  protoOf(SnapSorterBuilder).addCustomCriterion = function (sortCriterion) {
    this.h3e_1.q(sortCriterion);
    return this;
  };
  protoOf(SnapSorterBuilder).addCustomFilter = function (filterCriterion) {
    this.i3e_1.q(filterCriterion);
    return this;
  };
  function SortCriterion() {
  }
  function SortCriterionBase() {
  }
  protoOf(SortCriterionBase).bestResult = function (a, b) {
    var tmp0_elvis_lhs = a.snapActionCandidate;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return b;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var aSnap = tmp;
    var tmp1_elvis_lhs = b.snapActionCandidate;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return a;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var bSnap = tmp_0;
    var c = this.w3d(aSnap, bSnap);
    var tmp_1;
    if (c === 0) {
      tmp_1 = null;
    } else if (c > 0) {
      tmp_1 = a;
    } else {
      tmp_1 = b;
    }
    return tmp_1;
  };
  protoOf(SortCriterionBase).bestCandidate = function (a, b) {
    var c = this.w3d(a, b);
    var tmp;
    if (c === 0) {
      tmp = null;
    } else if (c > 0) {
      tmp = a;
    } else {
      tmp = b;
    }
    return tmp;
  };
  function WarningsCriterion() {
  }
  protoOf(WarningsCriterion).bestResult = function (a, b) {
    if (a.snapActionCandidate == null ? b.snapActionCandidate == null : false) {
      return null;
    }
    if (a.snapActionCandidate == null)
      return b;
    if (b.snapActionCandidate == null)
      return a;
    var aWarnings = a.warnings.length;
    var bWarnings = b.warnings.length;
    var tmp;
    if (aWarnings > bWarnings) {
      tmp = b;
    } else if (aWarnings < bWarnings) {
      tmp = a;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(WarningsCriterion).bestCandidate = function (a, b) {
    return null;
  };
  function sam$kotlin_Comparator$0_7(function_0) {
    this.j3e_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_7).u1j = function (a, b) {
    return this.j3e_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_7).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function sam$kotlin_Comparator$0_8(function_0) {
    this.k3e_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_8).u1j = function (a, b) {
    return this.k3e_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_8).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function SpaceFinderUtils$getNewValidCandidatesOnSameConnectorsUsingSearchDirections$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    var tmp = a.ye_1.movement.size;
    // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    var tmp$ret$1 = b.ye_1.movement.size;
    return compareValues(tmp, tmp$ret$1);
  }
  function SpaceFinderUtils$getNewValidCandidatesOnSameConnectorsUsingSearchDirections$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    var tmp = a.movement.size;
    // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
    var tmp$ret$1 = b.movement.size;
    return compareValues(tmp, tmp$ret$1);
  }
  function SpaceFinderUtils$getNewCandidatesOnSameConnectorUsingSearchDirections$lambda($candidateWithContinuousHost) {
    return function (a, b) {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewCandidatesOnSameConnectorUsingSearchDirections.<anonymous>' call
      var tmp = $candidateWithContinuousHost.endTransform.position.distanceTo(a);
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewCandidatesOnSameConnectorUsingSearchDirections.<anonymous>' call
      var tmp$ret$1 = $candidateWithContinuousHost.endTransform.position.distanceTo(b);
      return compareValues(tmp, tmp$ret$1);
    };
  }
  function SpaceFinderUtils() {
    SpaceFinderUtils_instance = this;
    this.l3e_1 = LoggerState_getInstance().m1m('SpaceFinderUtils');
  }
  protoOf(SpaceFinderUtils).getNewValidCandidatesOnSameConnectorsUsingSearchDirections = function (validationService, originalSnaps, iterations) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    var testedHostConnectors = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.collections.mutableListOf' call
    var searchDirectionCandidates = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(originalSnaps.length);
    var inductionVariable = 0;
    var last = originalSnaps.length;
    while (inductionVariable < last) {
      var item = originalSnaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
      var tmp$ret$2 = new Pair(item, validationService.evaluateSnapCandidate(item, true));
      destination.q(tmp$ret$2);
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = SpaceFinderUtils$getNewValidCandidatesOnSameConnectorsUsingSearchDirections$lambda;
    var tmp$ret$5 = new sam$kotlin_Comparator$0_7(tmp);
    var results = sortedWith(destination, tmp$ret$5);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = results.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
      if (!element.ze_1.valid) {
        destination_0.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
    var tmp0_iterator_0 = destination_0.t();
    while (tmp0_iterator_0.u()) {
      var item_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
      var tmp$ret$10 = item_0.ye_1;
      destination_1.q(tmp$ret$10);
    }
    var invalidSnaps = copyToArray(destination_1);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = results.t();
    while (tmp0_iterator_1.u()) {
      var element_0 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
      if (element_0.ze_1.valid) {
        destination_2.q(element_0);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_2, 10));
    var tmp0_iterator_2 = destination_2.t();
    while (tmp0_iterator_2.u()) {
      var item_1 = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
      var tmp$ret$17 = item_1.ze_1;
      destination_3.q(tmp$ret$17);
    }
    var originallyValidSnaps = destination_3;
    // Inline function 'kotlin.collections.find' call
    var this_0 = validationService.validations;
    var tmp$ret$21;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_0 = 0;
      var last_0 = this_0.length;
      while (inductionVariable_0 < last_0) {
        var element_1 = this_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
        var tmp_0;
        if (element_1 instanceof CollisionValidation) {
          tmp_0 = element_1.isEnabled;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$21 = element_1;
          break $l$block;
        }
      }
      tmp$ret$21 = null;
    }
    var tmp_1 = tmp$ret$21;
    var collisionValidation = (tmp_1 == null ? true : tmp_1 instanceof CollisionValidation) ? tmp_1 : THROW_CCE();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = SpaceFinderUtils$getNewValidCandidatesOnSameConnectorsUsingSearchDirections$lambda_0;
    var tmp$ret$23 = new sam$kotlin_Comparator$0_7(tmp_2);
    var tmp0_iterator_3 = sortedWith_0(invalidSnaps, tmp$ret$23).t();
    while (tmp0_iterator_3.u()) {
      var element_2 = tmp0_iterator_3.w();
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
      var isCandidateForSearchDirections = element_2.hostConnector.isContinuousConnector ? !testedHostConnectors.p(element_2.hostConnector) : false;
      if (isCandidateForSearchDirections) {
        var newCandidates = SpaceFinderUtils_getInstance().getNewCandidatesOnSameConnectorUsingSearchDirections(element_2, iterations, collisionValidation);
        addAll(searchDirectionCandidates, newCandidates);
        testedHostConnectors.q(element_2.hostConnector);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(searchDirectionCandidates, 10));
    var tmp0_iterator_4 = searchDirectionCandidates.t();
    while (tmp0_iterator_4.u()) {
      var item_2 = tmp0_iterator_4.w();
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
      var tmp$ret$25 = validationService.evaluateSnapCandidate(item_2, true);
      destination_4.q(tmp$ret$25);
    }
    var validatedSearchDirectionSnaps = destination_4;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_5 = ArrayList_init_$Create$();
    var tmp0_iterator_5 = validatedSearchDirectionSnaps.t();
    while (tmp0_iterator_5.u()) {
      var element_3 = tmp0_iterator_5.w();
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewValidCandidatesOnSameConnectorsUsingSearchDirections.<anonymous>' call
      if (element_3.valid) {
        destination_5.q(element_3);
      }
    }
    var this_1 = plus_1(originallyValidSnaps, destination_5);
    var validSnaps = copyToArray(this_1);
    return validSnaps;
  };
  protoOf(SpaceFinderUtils).m3e = function (candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut) {
    var guestWorld = candidateWithContinuousHost.endTransform;
    var hostWorld = get_worldTransform(candidateWithContinuousHost.host);
    var sizeWorldSpace = guestWorld.transformVector(get_objectOrientedBoundingBoxForHierarchy(candidateWithContinuousHost.guestRoot).size);
    var hostConnectorWorldTransform = hostWorld.concatenate(candidateWithContinuousHost.hostConnector.transform);
    var sizeHostConnectorSpace = hostConnectorWorldTransform.inverseTransformVector(sizeWorldSpace);
    var guestPositionInHostConnectorSpace = hostConnectorWorldTransform.inverseTransformPosition(guestWorld.position);
    var collidedSizeLocalSpace = get_objectOrientedBoundingBoxForHierarchy(entityCollidedWith);
    var collidedSizeWorldSpace = collidedSizeLocalSpace.transform(get_worldTransform(entityCollidedWith));
    var collidedSizeConnectorSpace = collidedSizeWorldSpace.transform(hostConnectorWorldTransform.inverse()).axisAlignedBoundingBox;
    var diffBetweenEntities = collidedSizeConnectorSpace.center.minus(guestPositionInHostConnectorSpace);
    // Inline function 'kotlin.math.sign' call
    var x = directionConnectorSpace.dot(diffBetweenEntities);
    var signMove = sign(x);
    // Inline function 'kotlin.math.abs' call
    var x_0 = directionConnectorSpace.dot(diffBetweenEntities);
    var moveToSamePosition = signMove * Math.abs(x_0);
    // Inline function 'kotlin.math.abs' call
    var x_1 = sizeHostConnectorSpace.dot(directionConnectorSpace);
    var moveDueToOwnSize = Math.abs(x_1);
    var extraSizeMultiplesMovedOutVector = moveDueToOwnSize * extraSizeMultiplesMovedOut;
    // Inline function 'kotlin.math.abs' call
    var x_2 = collidedSizeConnectorSpace.size.dot(directionConnectorSpace);
    var move = moveToSamePosition + Math.abs(x_2) / 2 + moveDueToOwnSize / 2 + extraSizeMultiplesMovedOutVector;
    var moveWorldSpace = hostConnectorWorldTransform.transformVector(directionConnectorSpace.times(move));
    var worldSpacePosition = candidateWithContinuousHost.endTransform.position.plus(moveWorldSpace);
    return worldSpacePosition;
  };
  protoOf(SpaceFinderUtils).getPositionToDirectionOfCollision = function (candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut, $super) {
    extraSizeMultiplesMovedOut = extraSizeMultiplesMovedOut === VOID ? 0 : extraSizeMultiplesMovedOut;
    return this.m3e(candidateWithContinuousHost, directionConnectorSpace, entityCollidedWith, extraSizeMultiplesMovedOut);
  };
  protoOf(SpaceFinderUtils).n3e = function (candidateWithContinuousHost, iterations, collisionValidation) {
    if (!candidateWithContinuousHost.hostConnector.isContinuousConnector) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    }
    var size = get_objectOrientedBoundingBoxForHierarchy(candidateWithContinuousHost.guestRoot).size;
    // Inline function 'kotlin.collections.mutableListOf' call
    var positions = ArrayList_init_$Create$();
    candidateWithContinuousHost.perform();
    var collisionResult = collisionValidation == null ? null : collisionValidation.validateSnap(candidateWithContinuousHost);
    candidateWithContinuousHost.rollback();
    var tmp2_safe_receiver = collisionResult == null ? null : collisionResult.collisions;
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = tmp2_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp2_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewCandidatesOnSameConnectorUsingSearchDirections.<anonymous>' call
          var tmp_0;
          if (!element.other.hasComponent(RoomComponent_instance.id)) {
            tmp_0 = !element.other.hasComponent(103);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$3 = element;
            break $l$block;
          }
        }
        tmp$ret$3 = null;
      }
      tmp = tmp$ret$3;
    }
    var tmp3_safe_receiver = tmp;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.other;
    var entityCollidedWith = tmp4_safe_receiver == null ? null : get_snapRoot(tmp4_safe_receiver);
    if (!(entityCollidedWith == null)) {
      var iterationsOnSide = iterations / 2 | 0;
      var leftPos = this.getPositionToDirectionOfCollision(candidateWithContinuousHost, Companion_getInstance_4().LEFT, entityCollidedWith, iterationsOnSide);
      var leftSidePositions = this.getPositionsOnConnector(candidateWithContinuousHost, size, iterationsOnSide, leftPos, false);
      addAll(positions, leftSidePositions);
      var rightPos = this.getPositionToDirectionOfCollision(candidateWithContinuousHost, Companion_getInstance_4().RIGHT, entityCollidedWith, iterationsOnSide);
      var rightSidePositions = this.getPositionsOnConnector(candidateWithContinuousHost, size, iterationsOnSide, rightPos, false);
      addAll(positions, rightSidePositions);
      var forwardPos = this.getPositionToDirectionOfCollision(candidateWithContinuousHost, Companion_getInstance_4().FORWARD, entityCollidedWith, iterationsOnSide);
      var forwardSidePositions = this.getPositionsOnConnector(candidateWithContinuousHost, size, iterationsOnSide, forwardPos, false);
      addAll(positions, forwardSidePositions);
      var backwardPos = this.getPositionToDirectionOfCollision(candidateWithContinuousHost, Companion_getInstance_4().BACK, entityCollidedWith, iterationsOnSide);
      var backSidePositions = this.getPositionsOnConnector(candidateWithContinuousHost, size, iterationsOnSide, backwardPos, false);
      addAll(positions, backSidePositions);
    } else {
      var newPositions = this.getPositionsOnConnector(candidateWithContinuousHost, size, iterations);
      addAll(positions, newPositions);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = SpaceFinderUtils$getNewCandidatesOnSameConnectorUsingSearchDirections$lambda(candidateWithContinuousHost);
    var tmp$ret$5 = new sam$kotlin_Comparator$0_8(tmp_1);
    var this_0 = sortedWith(positions, tmp$ret$5);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getNewCandidatesOnSameConnectorUsingSearchDirections.<anonymous>' call
      var tmp$ret$7 = candidateWithContinuousHost.withNewPosition(item);
      destination.q(tmp$ret$7);
    }
    var newCandidates = copyToArray(destination);
    return newCandidates;
  };
  protoOf(SpaceFinderUtils).getNewCandidatesOnSameConnectorUsingSearchDirections = function (candidateWithContinuousHost, iterations, collisionValidation, $super) {
    collisionValidation = collisionValidation === VOID ? null : collisionValidation;
    return this.n3e(candidateWithContinuousHost, iterations, collisionValidation);
  };
  protoOf(SpaceFinderUtils).o3e = function (candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition) {
    var hostWorld = get_worldTransform(candidateWithContinuousHost.host);
    var hostConnectorWorldTransform = hostWorld.concatenate(candidateWithContinuousHost.hostConnector.transform);
    var endTransform = overridePosition == null ? candidateWithContinuousHost.endTransform : new Transform(overridePosition, candidateWithContinuousHost.endTransform.rotation);
    var guestEndTransformWorld = endTransform.concatenate(candidateWithContinuousHost.guestRootToGuestDeltaTransform);
    var guestConnectorWorldPos = guestEndTransformWorld.transformPosition(candidateWithContinuousHost.guestConnector.transform.position);
    var guestConnectorHostSpacePos = hostWorld.inverseTransformPosition(guestConnectorWorldPos);
    var hostConnector = candidateWithContinuousHost.hostConnector;
    var tmp;
    if (hostConnector instanceof EdgeConnector) {
      var transformedSizeWorld = endTransform.transformVector(size);
      var transformedSizeHostLocal = hostWorld.inverseTransformVector(transformedSizeWorld);
      var sizeAlongHostConnector = hostConnector.direction.dot(transformedSizeHostLocal);
      var incrementHostSpace = hostConnector.direction.times(sizeAlongHostConnector);
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_0 = numberRangeToNumber(-iterations | 0, iterations);
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getPositionsOnConnector.<anonymous>' call
        var incrementLocalSpace = incrementHostSpace.__timesIntForKotlin(element);
        var isOnConnector = hostConnector.contains(guestConnectorHostSpacePos.plus(incrementLocalSpace));
        var tmp_0;
        if ((ignoreSamePosition ? element === 0 : false) ? true : !isOnConnector) {
          tmp_0 = null;
        } else {
          var posWorldSpace = endTransform.position.plus(hostWorld.transformVector(incrementLocalSpace));
          tmp_0 = posWorldSpace;
        }
        var tmp0_safe_receiver = tmp_0;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver);
        }
      }
      tmp = destination;
    } else {
      if (hostConnector instanceof SurfaceConnector) {
        var rightGuestSpace = endTransform.inverseTransformVector(hostConnectorWorldTransform.right);
        var forwardGuestSpace = endTransform.inverseTransformVector(hostConnectorWorldTransform.forward);
        var moveAmountRight = rightGuestSpace.dot(size);
        var moveAmountForward = forwardGuestSpace.dot(size);
        var right = hostConnectorWorldTransform.right.times(moveAmountRight);
        var forward = hostConnectorWorldTransform.forward.times(moveAmountForward);
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var this_1 = numberRangeToNumber(-iterations | 0, iterations);
        var destination_0 = ArrayList_init_$Create$();
        var tmp0_iterator_0 = this_1.t();
        while (tmp0_iterator_0.u()) {
          var element_0 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getPositionsOnConnector.<anonymous>' call
          // Inline function 'kotlin.collections.mapNotNull' call
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var this_2 = numberRangeToNumber(-iterations | 0, iterations);
          var destination_1 = ArrayList_init_$Create$();
          // Inline function 'kotlin.collections.forEach' call
          var tmp0_iterator_1 = this_2.t();
          while (tmp0_iterator_1.u()) {
            var element_1 = tmp0_iterator_1.w();
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'com.ikea.core.stl.placement.utils.SpaceFinderUtils.getPositionsOnConnector.<anonymous>.<anonymous>' call
            var incrementWorldSpace = right.__timesIntForKotlin(element_0).plus(forward.__timesIntForKotlin(element_1));
            var incrementLocalSpace_0 = hostWorld.inverseTransformVector(incrementWorldSpace);
            var isOnConnector_0 = hostConnector.contains(guestConnectorHostSpacePos.plus(incrementLocalSpace_0));
            var tmp_1;
            if (((ignoreSamePosition ? element_0 === 0 : false) ? element_1 === 0 : false) ? true : !isOnConnector_0) {
              tmp_1 = null;
            } else {
              var posWorldSpace_0 = endTransform.position.plus(incrementWorldSpace);
              tmp_1 = posWorldSpace_0;
            }
            var tmp0_safe_receiver_0 = tmp_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              destination_1.q(tmp0_safe_receiver_0);
            }
          }
          var list = destination_1;
          addAll_0(destination_0, list);
        }
        tmp = destination_0;
      } else {
        tmp = emptyList();
      }
    }
    var result = tmp;
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(result);
  };
  protoOf(SpaceFinderUtils).getPositionsOnConnector = function (candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition, $super) {
    overridePosition = overridePosition === VOID ? null : overridePosition;
    ignoreSamePosition = ignoreSamePosition === VOID ? true : ignoreSamePosition;
    return this.o3e(candidateWithContinuousHost, size, iterations, overridePosition, ignoreSamePosition);
  };
  var SpaceFinderUtils_instance;
  function SpaceFinderUtils_getInstance() {
    if (SpaceFinderUtils_instance == null)
      new SpaceFinderUtils();
    return SpaceFinderUtils_instance;
  }
  function ProppingData(productRef, spec, colliderBox, guestConnector, demands) {
    this.productRef = productRef;
    this.spec = spec;
    this.colliderBox = colliderBox;
    this.guestConnector = guestConnector;
    this.demands = demands;
  }
  protoOf(ProppingData).j1l = function () {
    return this.productRef;
  };
  protoOf(ProppingData).p3e = function () {
    return this.spec;
  };
  protoOf(ProppingData).q3e = function () {
    return this.colliderBox;
  };
  protoOf(ProppingData).p1v = function () {
    return this.guestConnector;
  };
  protoOf(ProppingData).r3e = function () {
    return this.demands;
  };
  protoOf(ProppingData).height = function () {
    return numberToInt(this.colliderBox.axisAlignedBoundingBox.height);
  };
  protoOf(ProppingData).af = function () {
    return this.productRef;
  };
  protoOf(ProppingData).bf = function () {
    return this.spec;
  };
  protoOf(ProppingData).g1k = function () {
    return this.colliderBox;
  };
  protoOf(ProppingData).h1k = function () {
    return this.guestConnector;
  };
  protoOf(ProppingData).i1k = function () {
    return this.demands;
  };
  protoOf(ProppingData).s3e = function (productRef, spec, colliderBox, guestConnector, demands) {
    return new ProppingData(productRef, spec, colliderBox, guestConnector, demands);
  };
  protoOf(ProppingData).copy = function (productRef, spec, colliderBox, guestConnector, demands, $super) {
    productRef = productRef === VOID ? this.productRef : productRef;
    spec = spec === VOID ? this.spec : spec;
    colliderBox = colliderBox === VOID ? this.colliderBox : colliderBox;
    guestConnector = guestConnector === VOID ? this.guestConnector : guestConnector;
    demands = demands === VOID ? this.demands : demands;
    return this.s3e(productRef, spec, colliderBox, guestConnector, demands);
  };
  protoOf(ProppingData).toString = function () {
    return 'ProppingData(productRef=' + this.productRef + ', spec=' + this.spec + ', colliderBox=' + this.colliderBox + ', guestConnector=' + this.guestConnector + ', demands=' + this.demands + ')';
  };
  protoOf(ProppingData).hashCode = function () {
    var result = getStringHashCode(this.productRef);
    result = imul(result, 31) + this.spec.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.colliderBox) | 0;
    result = imul(result, 31) + this.guestConnector.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.demands) | 0;
    return result;
  };
  protoOf(ProppingData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProppingData))
      return false;
    var tmp0_other_with_cast = other instanceof ProppingData ? other : THROW_CCE();
    if (!(this.productRef === tmp0_other_with_cast.productRef))
      return false;
    if (!this.spec.equals(tmp0_other_with_cast.spec))
      return false;
    if (!equals(this.colliderBox, tmp0_other_with_cast.colliderBox))
      return false;
    if (!this.guestConnector.equals(tmp0_other_with_cast.guestConnector))
      return false;
    if (!(this.demands === tmp0_other_with_cast.demands))
      return false;
    return true;
  };
  function Companion_61() {
    this.ID = 2;
  }
  protoOf(Companion_61).u1n = function () {
    return this.ID;
  };
  var Companion_instance_94;
  function Companion_getInstance_70() {
    return Companion_instance_94;
  }
  function ProppingHostConnectorsComponent(proppingHostConnectors) {
    this.proppingHostConnectors = proppingHostConnectors;
  }
  protoOf(ProppingHostConnectorsComponent).t3e = function () {
    return this.proppingHostConnectors;
  };
  protoOf(ProppingHostConnectorsComponent).x1k = function () {
    return 2;
  };
  protoOf(ProppingHostConnectorsComponent).eq = function (other) {
    if (!(other instanceof ProppingHostConnectorsComponent))
      THROW_CCE();
    return contentEquals(this.proppingHostConnectors, other.proppingHostConnectors);
  };
  function get_proppingHostConnectors(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(2);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.proppingHostConnectors;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function get_proppingHostEntitiesInHierarchy(_this__u8e3s4) {
    var tmp = HierarchyUtils_instance;
    return tmp.getDescendantsWithComponent(_this__u8e3s4, 2);
  }
  function ProppingHostConnectorData(propHoldingEntity, proppingHostConnector) {
    this.propHoldingEntity = propHoldingEntity;
    this.proppingHostConnector = proppingHostConnector;
  }
  protoOf(ProppingHostConnectorData).u3e = function () {
    return this.propHoldingEntity;
  };
  protoOf(ProppingHostConnectorData).v3e = function () {
    return this.proppingHostConnector;
  };
  protoOf(ProppingHostConnectorData).af = function () {
    return this.propHoldingEntity;
  };
  protoOf(ProppingHostConnectorData).bf = function () {
    return this.proppingHostConnector;
  };
  protoOf(ProppingHostConnectorData).w3e = function (propHoldingEntity, proppingHostConnector) {
    return new ProppingHostConnectorData(propHoldingEntity, proppingHostConnector);
  };
  protoOf(ProppingHostConnectorData).copy = function (propHoldingEntity, proppingHostConnector, $super) {
    propHoldingEntity = propHoldingEntity === VOID ? this.propHoldingEntity : propHoldingEntity;
    proppingHostConnector = proppingHostConnector === VOID ? this.proppingHostConnector : proppingHostConnector;
    return this.w3e(propHoldingEntity, proppingHostConnector);
  };
  protoOf(ProppingHostConnectorData).toString = function () {
    return 'ProppingHostConnectorData(propHoldingEntity=' + this.propHoldingEntity + ', proppingHostConnector=' + this.proppingHostConnector + ')';
  };
  protoOf(ProppingHostConnectorData).hashCode = function () {
    var result = this.propHoldingEntity.hashCode();
    result = imul(result, 31) + this.proppingHostConnector.hashCode() | 0;
    return result;
  };
  protoOf(ProppingHostConnectorData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProppingHostConnectorData))
      return false;
    var tmp0_other_with_cast = other instanceof ProppingHostConnectorData ? other : THROW_CCE();
    if (!this.propHoldingEntity.equals(tmp0_other_with_cast.propHoldingEntity))
      return false;
    if (!this.proppingHostConnector.equals(tmp0_other_with_cast.proppingHostConnector))
      return false;
    return true;
  };
  function Companion_62() {
    this.ID = 87;
  }
  protoOf(Companion_62).u1n = function () {
    return this.ID;
  };
  var Companion_instance_95;
  function Companion_getInstance_71() {
    return Companion_instance_95;
  }
  function ProppingInfoComponent(propHolderInfos) {
    this.propHolderInfos = propHolderInfos;
  }
  protoOf(ProppingInfoComponent).x3e = function () {
    return this.propHolderInfos;
  };
  protoOf(ProppingInfoComponent).x1k = function () {
    return 87;
  };
  protoOf(ProppingInfoComponent).eq = function (other) {
    return false;
  };
  protoOf(ProppingInfoComponent).af = function () {
    return this.propHolderInfos;
  };
  protoOf(ProppingInfoComponent).y3e = function (propHolderInfos) {
    return new ProppingInfoComponent(propHolderInfos);
  };
  protoOf(ProppingInfoComponent).copy = function (propHolderInfos, $super) {
    propHolderInfos = propHolderInfos === VOID ? this.propHolderInfos : propHolderInfos;
    return this.y3e(propHolderInfos);
  };
  protoOf(ProppingInfoComponent).toString = function () {
    return 'ProppingInfoComponent(propHolderInfos=' + this.propHolderInfos + ')';
  };
  protoOf(ProppingInfoComponent).hashCode = function () {
    return hashCode(this.propHolderInfos);
  };
  protoOf(ProppingInfoComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProppingInfoComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ProppingInfoComponent ? other : THROW_CCE();
    if (!equals(this.propHolderInfos, tmp0_other_with_cast.propHolderInfos))
      return false;
    return true;
  };
  function PropHolderInfo(connector, propping, colliderBox, oldPropping, shapeComponent) {
    shapeComponent = shapeComponent === VOID ? null : shapeComponent;
    this.connector = connector;
    this.propping = propping;
    this.colliderBox = colliderBox;
    this.oldPropping = oldPropping;
    this.shapeComponent = shapeComponent;
  }
  protoOf(PropHolderInfo).n1k = function () {
    return this.connector;
  };
  protoOf(PropHolderInfo).z3e = function () {
    return this.propping;
  };
  protoOf(PropHolderInfo).q3e = function () {
    return this.colliderBox;
  };
  protoOf(PropHolderInfo).a3f = function () {
    return this.oldPropping;
  };
  protoOf(PropHolderInfo).b3f = function () {
    return this.shapeComponent;
  };
  protoOf(PropHolderInfo).af = function () {
    return this.connector;
  };
  protoOf(PropHolderInfo).bf = function () {
    return this.propping;
  };
  protoOf(PropHolderInfo).g1k = function () {
    return this.colliderBox;
  };
  protoOf(PropHolderInfo).h1k = function () {
    return this.oldPropping;
  };
  protoOf(PropHolderInfo).i1k = function () {
    return this.shapeComponent;
  };
  protoOf(PropHolderInfo).c3f = function (connector, propping, colliderBox, oldPropping, shapeComponent) {
    return new PropHolderInfo(connector, propping, colliderBox, oldPropping, shapeComponent);
  };
  protoOf(PropHolderInfo).copy = function (connector, propping, colliderBox, oldPropping, shapeComponent, $super) {
    connector = connector === VOID ? this.connector : connector;
    propping = propping === VOID ? this.propping : propping;
    colliderBox = colliderBox === VOID ? this.colliderBox : colliderBox;
    oldPropping = oldPropping === VOID ? this.oldPropping : oldPropping;
    shapeComponent = shapeComponent === VOID ? this.shapeComponent : shapeComponent;
    return this.c3f(connector, propping, colliderBox, oldPropping, shapeComponent);
  };
  protoOf(PropHolderInfo).toString = function () {
    return 'PropHolderInfo(connector=' + this.connector + ', propping=' + this.propping + ', colliderBox=' + this.colliderBox + ', oldPropping=' + this.oldPropping + ', shapeComponent=' + this.shapeComponent + ')';
  };
  protoOf(PropHolderInfo).hashCode = function () {
    var result = this.connector.hashCode();
    result = imul(result, 31) + (this.propping == null ? 0 : this.propping.hashCode()) | 0;
    result = imul(result, 31) + (this.colliderBox == null ? 0 : hashCode(this.colliderBox)) | 0;
    result = imul(result, 31) + (this.oldPropping == null ? 0 : this.oldPropping.hashCode()) | 0;
    result = imul(result, 31) + (this.shapeComponent == null ? 0 : this.shapeComponent.hashCode()) | 0;
    return result;
  };
  protoOf(PropHolderInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PropHolderInfo))
      return false;
    var tmp0_other_with_cast = other instanceof PropHolderInfo ? other : THROW_CCE();
    if (!this.connector.equals(tmp0_other_with_cast.connector))
      return false;
    if (!equals(this.propping, tmp0_other_with_cast.propping))
      return false;
    if (!equals(this.colliderBox, tmp0_other_with_cast.colliderBox))
      return false;
    if (!equals(this.oldPropping, tmp0_other_with_cast.oldPropping))
      return false;
    if (!equals(this.shapeComponent, tmp0_other_with_cast.shapeComponent))
      return false;
    return true;
  };
  function getPropHolderInfo(_this__u8e3s4, connector) {
    var tmp0_safe_receiver = _this__u8e3s4.__getComponentForKotlin(87);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.propHolderInfos;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp1_safe_receiver.t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'com.ikea.core.stl.propping.getPropHolderInfo.<anonymous>' call
          if (element.connector.key === connector.key) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    return tmp;
  }
  function getPropping(_this__u8e3s4, connector) {
    var tmp0_safe_receiver = getPropHolderInfo(_this__u8e3s4, connector);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.propping;
  }
  function setPropping(_this__u8e3s4, proppingHostConnector, propping) {
    setProppingProperty(_this__u8e3s4, proppingHostConnector, setPropping$lambda(propping));
    if (!(propping == null)) {
      clearOldPropping(_this__u8e3s4, proppingHostConnector);
    }
  }
  function getColliderBox(_this__u8e3s4, connector) {
    var tmp0_safe_receiver = getPropHolderInfo(_this__u8e3s4, connector);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.colliderBox;
  }
  function getOldPropping(_this__u8e3s4, connector) {
    var tmp0_safe_receiver = getPropHolderInfo(_this__u8e3s4, connector);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.oldPropping;
  }
  function setOldPropping(_this__u8e3s4, proppingHostConnector, oldPropping) {
    setProppingProperty(_this__u8e3s4, proppingHostConnector, setOldPropping$lambda(oldPropping));
  }
  function removePropping(_this__u8e3s4, proppingHostConnector) {
    var tmp0_elvis_lhs = getPropping(_this__u8e3s4, proppingHostConnector);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentPropping = tmp;
    var tmp1_safe_receiver = getOldPropping(_this__u8e3s4, proppingHostConnector);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.dispose();
    }
    setOldPropping(_this__u8e3s4, proppingHostConnector, currentPropping);
    currentPropping.removeComponent(RenderedComponent_instance.id);
    setPropping(_this__u8e3s4, proppingHostConnector, null);
  }
  function clearOldPropping(_this__u8e3s4, proppingHostConnector) {
    var oldPropping = getOldPropping(_this__u8e3s4, proppingHostConnector);
    setProppingProperty(_this__u8e3s4, proppingHostConnector, clearOldPropping$lambda);
    if (!((oldPropping == null ? null : oldPropping.isDisposed) === true)) {
      if (oldPropping == null)
        null;
      else {
        oldPropping.dispose();
      }
    }
  }
  function restoreOldPropping(_this__u8e3s4, proppingHostConnector) {
    var propping = getOldPropping(_this__u8e3s4, proppingHostConnector);
    setOldPropping(_this__u8e3s4, proppingHostConnector, null);
    if (propping == null)
      null;
    else {
      setParentMaintainWorldTransform(propping, _this__u8e3s4);
    }
    setPropping(_this__u8e3s4, proppingHostConnector, propping);
    var tmp1_safe_receiver = getShapeComponent(_this__u8e3s4, proppingHostConnector);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.propping.restoreOldPropping.<anonymous>' call
      propping == null || propping.addComponent(tmp1_safe_receiver);
    }
    if (_this__u8e3s4.hasComponent(9)) {
      if (propping == null)
        null;
      else
        propping.addComponent(RenderedComponent_instance);
    }
    setOldPropping(_this__u8e3s4, proppingHostConnector, null);
  }
  function getShapeComponent(_this__u8e3s4, connector) {
    var tmp0_safe_receiver = getPropHolderInfo(_this__u8e3s4, connector);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.shapeComponent;
  }
  function setProppingProperty(_this__u8e3s4, connector, a) {
    var tmp;
    if (_this__u8e3s4.hasComponent(87)) {
      tmp = _this__u8e3s4.getComponentUnsafe(87);
    } else {
      _this__u8e3s4.addComponent(new ProppingInfoComponent(emptyList()));
      tmp = _this__u8e3s4.getComponentUnsafe(87);
    }
    var proppingComponent = tmp;
    var propHolderInfos = proppingComponent.propHolderInfos;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var tmp0_iterator = propHolderInfos.t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.propping.setProppingProperty.<anonymous>' call
        if (item.connector.key === connector.key) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    var propHolderInfoIndex = tmp$ret$1;
    var newPropHolderInfo = a(propHolderInfos.f1(propHolderInfoIndex));
    var newPropHoldInfos = toMutableList(propHolderInfos);
    newPropHoldInfos.o(propHolderInfoIndex, newPropHolderInfo);
    _this__u8e3s4.addComponent(new ProppingInfoComponent(newPropHoldInfos));
  }
  function setPropping$lambda($propping) {
    return function (it) {
      return it.copy(VOID, $propping);
    };
  }
  function setOldPropping$lambda($oldPropping) {
    return function (it) {
      return it.copy(VOID, VOID, VOID, $oldPropping);
    };
  }
  function clearOldPropping$lambda(it) {
    return it.copy(VOID, VOID, VOID, null);
  }
  function ProppingSubSystem(proppingSystem) {
    Companion_getInstance_72();
    var tmp = 'ProppingSystem' + '-internal';
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = ['HierarchySystem', 'TransformSystem', 'SceneGraphSystem'];
    SystemBase2.call(this, tmp, 66, 73, tmp_0, tmp$ret$3, null);
    this.proppingSystem = proppingSystem;
  }
  protoOf(ProppingSubSystem).onAddComponent = function (entity, newComponent) {
    this.proppingSystem.a3g(newComponent);
  };
  protoOf(ProppingSubSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(ProppingSubSystem).onRemoveComponent = function (entity, oldComponent) {
    this.proppingSystem.b3g();
  };
  protoOf(ProppingSubSystem).onAddComponent2 = function (entity, newComponent) {
  };
  protoOf(ProppingSubSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ProppingSubSystem).onRemoveComponent2 = function (entity, oldComponent) {
    this.proppingSystem.b3g();
  };
  function onStartedDragging_1($this, draggedEntity) {
    if (!$this.isEnabled)
      return Unit_instance;
    var draggedHierarchy = get_hierarchy(draggedEntity);
    if (get_isPropping(draggedEntity)) {
      var tmp = $this;
      var tmp0_safe_receiver = get_parent(draggedEntity);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_proppingHostConnectors(tmp0_safe_receiver);
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable = 0;
          var last = tmp1_safe_receiver.length;
          while (inductionVariable < last) {
            var element = tmp1_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onStartedDragging.<anonymous>' call
            if (equals(getPropping(element.propHoldingEntity, element.proppingHostConnector), draggedEntity)) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp_0 = tmp$ret$1;
      }
      tmp.z3f_1 = tmp_0;
      var tmp2_safe_receiver = get_viewerObject(draggedEntity);
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.setEnabled(false);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_0 = 0;
    var last_0 = draggedHierarchy.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = draggedHierarchy[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onStartedDragging.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = get_proppingHostConnectors(element_0);
      var inductionVariable_1 = 0;
      var last_1 = indexedObject.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = indexedObject[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onStartedDragging.<anonymous>.<anonymous>' call
        var propping = getPropping(element_1.propHoldingEntity, element_1.proppingHostConnector);
        if (!(propping == null) ? !equals(propping, draggedEntity) : false) {
          removePropping(element_1.propHoldingEntity, element_1.proppingHostConnector);
        }
      }
    }
  }
  function onDragMove($this) {
    var tmp0_safe_receiver = $this.y3f_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.__getComponentForKotlin(24);
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.worldPolyhedron;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var movedPolyhedron = tmp_0;
    var tmp3_safe_receiver = $this.y3f_1;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : get_hierarchy(tmp3_safe_receiver);
    var tmp_1;
    if (tmp4_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_1 = tmp4_elvis_lhs;
    }
    var movedHierarchy = tmp_1;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_proppingHostEntitiesInHierarchy($this.t3f_1.sceneManager.scene);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onDragMove.<anonymous>' call
      var tmp$ret$0 = get_proppingHostConnectors(item);
      destination.q(tmp$ret$0);
    }
    var tmp$ret$3 = copyToArray(destination);
    var tmp0_iterator = flatten(tmp$ret$3).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      $l$block_1: {
        // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onDragMove.<anonymous>' call
        if (!element.propHoldingEntity.hasComponent(9)) {
          break $l$block_1;
        }
        var tmp0_elvis_lhs = getPropHolderInfo(element.propHoldingEntity, element.proppingHostConnector);
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          break $l$block_1;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var propInfo = tmp_2;
        if (contains(movedHierarchy, element.propHoldingEntity)) {
          break $l$block_1;
        }
        var tmp1_safe_receiver_0 = propInfo.colliderBox;
        var tmp2_safe_receiver = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.penetration(movedPolyhedron);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.notZero();
        var hit = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
        if (hit) {
          var tmp4_safe_receiver = propInfo.propping;
          if (tmp4_safe_receiver == null)
            null;
          else
            tmp4_safe_receiver.removeComponent(RenderedComponent_instance.id);
        } else {
          var tmp5_safe_receiver = propInfo.propping;
          if (tmp5_safe_receiver == null)
            null;
          else
            tmp5_safe_receiver.addComponent(RenderedComponent_instance);
        }
      }
    }
  }
  function onStoppedDragging_1($this, originalEntity) {
    var theEntityThatWasDraggedIsNoLongerInScene = !get_isInScene(originalEntity);
    if (theEntityThatWasDraggedIsNoLongerInScene) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = get_proppingHostConnectors(originalEntity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onStoppedDragging.<anonymous>' call
        var propInfo = getPropHolderInfo(originalEntity, element.proppingHostConnector);
        var tmp1_safe_receiver = propInfo == null ? null : propInfo.oldPropping;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          setOldPropping(originalEntity, element.proppingHostConnector, null);
          $this.t3f_1.entityManager.disposeEntity(tmp1_safe_receiver);
        }
      }
    }
    var tmp0_safe_receiver = $this.z3f_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var propInfo_0 = getPropHolderInfo(tmp0_safe_receiver.propHoldingEntity, tmp0_safe_receiver.proppingHostConnector);
      var tmp1_safe_receiver_0 = propInfo_0 == null ? null : propInfo_0.oldPropping;
      var tmp2_safe_receiver = tmp1_safe_receiver_0 == null ? null : get_viewerObject(tmp1_safe_receiver_0);
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.setEnabled(true);
      }
      removePropping(tmp0_safe_receiver.propHoldingEntity, tmp0_safe_receiver.proppingHostConnector);
    }
    $this.z3f_1 = null;
  }
  function handleAddedEntityToScene($this, entity) {
    if (get_isPropping(entity))
      return Unit_instance;
    var tmp;
    if (entity.hasComponent(2)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      tmp = !(getProppingCollidingWithEntity($this, entity).length === 0);
    }
    var needToUpdatePropping = tmp;
    if (needToUpdatePropping) {
      $this.b3g();
    }
  }
  function onDisconnect($this, entity) {
    if (entity.isDisposed ? true : get_isPropping(entity))
      return Unit_instance;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_proppingHostConnectors(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onDisconnect.<anonymous>' call
      var propInfo = getPropHolderInfo(element.propHoldingEntity, element.proppingHostConnector);
      var tmp1_safe_receiver = propInfo == null ? null : propInfo.propping;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (!get_isBeingDragged(tmp1_safe_receiver)) {
          $this.t3f_1.entityManager.disposeEntity(tmp1_safe_receiver);
          tmp = Unit_instance;
        }
      }
    }
  }
  function clearProps($this) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_proppingHostEntitiesInHierarchy($this.t3f_1.sceneManager.scene);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.clearProps.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject_0 = get_proppingHostConnectors(element);
      var inductionVariable_0 = 0;
      var last_0 = indexedObject_0.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = indexedObject_0[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.propping.ProppingSystem.clearProps.<anonymous>.<anonymous>' call
        removePropping(element, element_0.proppingHostConnector);
      }
    }
  }
  function getProppingCollidingWithEntity($this, entity) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(24);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var movedPolyhedron = tmp;
    var entityHierarchy = get_hierarchy(entity);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = get_proppingHostEntitiesInHierarchy($this.t3f_1.sceneManager.scene);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.getProppingCollidingWithEntity.<anonymous>' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_1 = get_proppingHostConnectors(element);
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'com.ikea.core.stl.propping.ProppingSystem.getProppingCollidingWithEntity.<anonymous>.<anonymous>' call
          if (!element_0.propHoldingEntity.hasComponent(9)) {
            tmp$ret$1 = false;
            break $l$block_0;
          }
          if (contains(entityHierarchy, element_0.propHoldingEntity)) {
            tmp$ret$1 = false;
            break $l$block_0;
          }
          var propInfo = getPropHolderInfo(element, element_0.proppingHostConnector);
          var tmp1_safe_receiver = propInfo == null ? null : propInfo.colliderBox;
          var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.penetration(movedPolyhedron);
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.notZero();
          tmp$ret$1 = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
        }
        if (tmp$ret$1) {
          destination_0.q(element_0);
        }
      }
      var list = destination_0;
      addAll_0(destination, list);
    }
    return copyToArray(destination);
  }
  function Companion_63() {
    Companion_instance_96 = this;
    this.ID = 'ProppingSystem';
    this.TAG_PROPPING = 'propping-connector';
    this.c3g_1 = LoggerState_getInstance().m1m('ProppingSystem');
  }
  protoOf(Companion_63).u1n = function () {
    return this.ID;
  };
  protoOf(Companion_63).d3g = function () {
    return this.TAG_PROPPING;
  };
  var Companion_instance_96;
  function Companion_getInstance_72() {
    if (Companion_instance_96 == null)
      new Companion_63();
    return Companion_instance_96;
  }
  function ProppingSystem$lambda$lambda(map) {
    var tmp = map.t2();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = map.u2().f3g_1.p2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      var tmp_0 = sum;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.<anonymous>.<anonymous>.<anonymous>' call
      sum = tmp_0 + element.n() | 0;
    }
    return tmp + ': ' + sum;
  }
  function ProppingSystem$lambda(this$0) {
    return function () {
      var tmp = this$0.x3f_1.q2();
      var mappedProps = joinToString_0(tmp, ' | ', VOID, VOID, VOID, VOID, ProppingSystem$lambda$lambda);
      return 'loaded props ' + mappedProps;
    };
  }
  function ProppingSystem(proppingCatalog, coreServices) {
    Companion_getInstance_72();
    Companion_getInstance_1();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [];
    // Inline function 'kotlin.arrayOf' call
    Companion_getInstance_0();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = ['ConnectionParentingSystem', 'UpdateHostConnectionsSystem', 'TakeSnapshotBeforeDragSystem'];
    // Inline function 'kotlin.arrayOf' call
    Companion_getInstance_37();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = ['DragSystem'];
    SystemBase2.call(this, 'ProppingSystem', 85, 104, tmp, tmp_0, tmp$ret$8);
    this.t3f_1 = coreServices;
    this.u3f_1 = new ProppingSubSystem(this);
    this.v3f_1 = new SetPropHolderInfoSystem();
    this.w3f_1 = new SetProppingHostConnectorDataSystem(this.t3f_1.sceneManager);
    this.y3f_1 = null;
    this.z3f_1 = null;
    this.x3f_1 = ProppingUtils_instance.g3g(proppingCatalog);
    var tmp_1 = Companion_getInstance_72().c3g_1;
    tmp_1.info(ProppingSystem$lambda(this));
    this.b3g();
  }
  protoOf(ProppingSystem).onRegister = function () {
    protoOf(SystemBase2).onRegister.call(this);
    this.u3f_1.register(this.t3f_1.entityManager);
    this.v3f_1.register(this.t3f_1.entityManager);
    this.w3f_1.register(this.t3f_1.entityManager);
  };
  protoOf(ProppingSystem).onUnregister = function () {
    protoOf(SystemBase2).onUnregister.call(this);
    this.u3f_1.unregister(this.t3f_1.entityManager);
    this.v3f_1.unregister(this.t3f_1.entityManager);
    this.w3f_1.unregister(this.t3f_1.entityManager);
  };
  protoOf(ProppingSystem).enable = function () {
    protoOf(SystemBase2).enable.call(this);
    this.u3f_1.enable();
    this.v3f_1.enable();
    this.w3f_1.enable();
    this.b3g();
  };
  protoOf(ProppingSystem).disable = function () {
    this.u3f_1.disable();
    this.v3f_1.disable();
    this.w3f_1.disable();
    protoOf(SystemBase2).disable.call(this);
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_proppingHostEntitiesInHierarchy(this.t3f_1.sceneManager.scene);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.disable.<anonymous>' call
      var tmp$ret$0 = get_proppingHostConnectors(item);
      destination.q(tmp$ret$0);
    }
    var tmp$ret$3 = copyToArray(destination);
    var tmp0_iterator = flatten(tmp$ret$3).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.disable.<anonymous>' call
      var propHolderInfo = getPropHolderInfo(element.propHoldingEntity, element.proppingHostConnector);
      var tmp1_safe_receiver = propHolderInfo == null ? null : propHolderInfo.propping;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.t3f_1.entityManager.disposeEntity(tmp1_safe_receiver);
        setPropping(element.propHoldingEntity, element.proppingHostConnector, null);
      }
    }
  };
  protoOf(ProppingSystem).onAddComponent = function (entity, newComponent) {
    onStartedDragging_1(this, entity);
  };
  protoOf(ProppingSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    onDragMove(this);
  };
  protoOf(ProppingSystem).onRemoveComponent = function (entity, oldComponent) {
    onStoppedDragging_1(this, entity);
  };
  protoOf(ProppingSystem).onAddComponent2 = function (entity, newComponent) {
    if (get_isPropping(entity))
      return Unit_instance;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_snapRootSubTree(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onAddComponent2.<anonymous>' call
      handleAddedEntityToScene(this, element);
    }
  };
  protoOf(ProppingSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    if (get_isPropping(entity))
      return Unit_instance;
    this.b3g();
  };
  protoOf(ProppingSystem).onRemoveComponent2 = function (entity, oldComponent) {
    if (get_isPropping(entity))
      return Unit_instance;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_snapRootSubTree(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingSystem.onRemoveComponent2.<anonymous>' call
      onDisconnect(this, element);
    }
  };
  protoOf(ProppingSystem).dispose = function () {
    this.disable();
    this.unregister(this.t3f_1.entityManager);
  };
  protoOf(ProppingSystem).a3g = function (c) {
    this.y3f_1 = c.entity;
  };
  protoOf(ProppingSystem).b3g = function () {
    if (!this.isEnabled)
      return Unit_instance;
    clearProps(this);
    ProppingUtils_instance.h3g(this.x3f_1, this.t3f_1.entityManager, this.t3f_1.sceneManager, this.t3f_1.productManager);
  };
  function createAndAddPropping($this, proppingHostConnectorData, data, productManager) {
    var propHoldingEntity = proppingHostConnectorData.propHoldingEntity;
    var proppingHostConnector = proppingHostConnectorData.proppingHostConnector;
    var propInfoBefore = getPropHolderInfo(propHoldingEntity, proppingHostConnector);
    var oldProppingBefore = propInfoBefore == null ? null : propInfoBefore.oldPropping;
    removePropping(propHoldingEntity, proppingHostConnector);
    var wantToAddBackOldPropping = !(oldProppingBefore == null) ? get_productRef(oldProppingBefore) === data.productRef : false;
    if (wantToAddBackOldPropping) {
      restoreOldPropping(propHoldingEntity, proppingHostConnector);
      if ((oldProppingBefore == null ? null : get_isHanging(oldProppingBefore)) === true) {
        var tmp2_safe_receiver = get_guestConnectors(oldProppingBefore);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : firstOrNull_1(tmp2_safe_receiver);
        var tmp;
        if (tmp3_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp3_elvis_lhs;
        }
        adjustToHangDown($this, oldProppingBefore, tmp, propHoldingEntity, proppingHostConnector);
      }
      return Unit_instance;
    }
    clearOldPropping(propHoldingEntity, proppingHostConnector);
    var newPropping = productManager.createFromSpecification(data.productRef, data.spec);
    setPropping(propHoldingEntity, proppingHostConnector, newPropping);
    if (newPropping == null)
      return Unit_instance;
    setParentMaintainWorldTransform(newPropping, proppingHostConnectorData.propHoldingEntity);
    // Inline function 'kotlin.collections.find' call
    var this_0 = ensureNotNull(get_connectorsComponent(newPropping)).guestConnectors;
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.propping.ProppingUtils.createAndAddPropping.<anonymous>' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var indexedObject = element.demands();
          var inductionVariable = 0;
          var last = indexedObject.length;
          while (inductionVariable < last) {
            var element_0 = indexedObject[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.stl.propping.ProppingUtils.createAndAddPropping.<anonymous>.<anonymous>' call
            if (element_0 === data.demands) {
              tmp$ret$1 = true;
              break $l$block;
            }
          }
          tmp$ret$1 = false;
        }
        if (tmp$ret$1) {
          tmp$ret$3 = element;
          break $l$block_0;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp$ret$4 = tmp$ret$3;
    var guestConnector = ensureNotNull(tmp$ret$4);
    var snapCandidate = SnapUtils_instance.createCandidate(newPropping, guestConnector, proppingHostConnectorData.propHoldingEntity, proppingHostConnector);
    snapCandidate.createAction().perform();
    if (get_isHanging(newPropping)) {
      adjustToHangDown($this, newPropping, snapCandidate.guestConnector, snapCandidate.host, snapCandidate.hostConnector);
    }
  }
  function adjustToHangDown($this, propping, guestConnector, host, hostConnector) {
    if (!get_isHanging(propping))
      return Unit_instance;
    if (get_worldTransform(propping).up.equals(Companion_getInstance_4().UP))
      return Unit_instance;
    var localRot = get_localTransform(propping).rotation;
    var tmp0_safe_receiver = get_parent(propping);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_worldTransform(tmp0_safe_receiver);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rotation;
    var parentRotation = tmp2_elvis_lhs == null ? Companion_getInstance_6().IDENTITY : tmp2_elvis_lhs;
    var yAngle = localRot.toEuler().Y + parentRotation.toEuler().Y;
    var rotationAroundY = Companion_getInstance_6().fromEuler(new Radians(0.0), new Radians(yAngle), new Radians(0.0));
    var newLocalRot = rotationAroundY.times(parentRotation.inverse());
    var adjustment = Companion_getInstance_4().UP.times(hostConnector.worldSpaceOffsetOnHanging).rotate(parentRotation.inverse());
    var newLocalPos = hostConnector.transform.position.plus(adjustment).minus(guestConnector.transform.position.rotate(newLocalRot));
    propping.addComponent(LocalTransformComponentFromPosAndRot(newLocalPos, newLocalRot));
    if (!propping.hasComponent(28))
      return Unit_instance;
    var connectorsDeltaTransform = hostConnector.getDeltaTransformToGuestConnectorEntity(host, propping, guestConnector);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [new Connection(propping, guestConnector, host, hostConnector, connectorsDeltaTransform)];
    propping.addComponent(new GuestConnectionsComponent(tmp$ret$2));
    var tmp3_safe_receiver = get_viewerObject(propping);
    if (tmp3_safe_receiver == null)
      null;
    else
      tmp3_safe_receiver.setPosition(get_worldPosition(propping));
    var tmp4_safe_receiver = get_viewerObject(propping);
    if (tmp4_safe_receiver == null)
      null;
    else
      tmp4_safe_receiver.setRotation(get_worldRotation(propping));
  }
  function addProppingColliders($this, proppingHostEntity, proppingHostConnector) {
    var tmp0_elvis_lhs = getPropHolderInfo(proppingHostEntity, proppingHostConnector);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var propInfo = tmp;
    var tmp1_elvis_lhs = propInfo.propping;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var propping = tmp_0;
    var tmp2_elvis_lhs = propInfo.shapeComponent;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var shapeComponent = tmp_1;
    propping.addComponent(shapeComponent);
  }
  function removeProppingColliders($this, proppingHostEntity, proppingHostConnector) {
    var tmp0_elvis_lhs = getPropHolderInfo(proppingHostEntity, proppingHostConnector);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var propInfo = tmp;
    var tmp1_elvis_lhs = propInfo.propping;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var propping = tmp_0;
    var tmp2_safe_receiver = propping.__getComponentForKotlin(24);
    var colliderBox = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.worldPolyhedron;
    var shapeComponent = get_colliderShapeComponent(propping);
    propping.removeComponent(19);
    propping.removeComponent(24);
    propping.removeComponent(47);
    propping.removeComponent(3);
    setProppingProperty(proppingHostEntity, proppingHostConnector, ProppingUtils$removeProppingColliders$lambda(colliderBox, shapeComponent));
  }
  function ProppingUtils$removeProppingColliders$lambda($colliderBox, $shapeComponent) {
    return function (it) {
      return it.copy(VOID, VOID, $colliderBox, VOID, $shapeComponent);
    };
  }
  function ProppingUtils() {
  }
  protoOf(ProppingUtils).g3g = function (proppingCatalog) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var demandToProppingData = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = proppingCatalog.allProductRefs();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      $l$block_1: {
        // Inline function 'com.ikea.core.stl.propping.ProppingUtils.calculateAvailableProppingMap.<anonymous>' call
        var tmp0_elvis_lhs = proppingCatalog.productSpecification(element);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$block_1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var spec = tmp;
        var tmp1_safe_receiver = spec._findComponentKt(19);
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.polyhedron;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          break $l$block_1;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var colliderBox = tmp_0;
        var tmp3_elvis_lhs = spec._findComponentKt(11);
        var tmp_1;
        if (tmp3_elvis_lhs == null) {
          break $l$block_1;
        } else {
          tmp_1 = tmp3_elvis_lhs;
        }
        var snappable = tmp_1;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_0 = snappable.guestConnectors;
        var destination = ArrayList_init_$Create$();
        var tmp0_iterator = this_0.t();
        while (tmp0_iterator.u()) {
          var element_0 = tmp0_iterator.w();
          // Inline function 'com.ikea.core.stl.propping.ProppingUtils.calculateAvailableProppingMap.<anonymous>.<anonymous>' call
          Companion_getInstance_72();
          if (element_0.hasTag('propping-connector')) {
            destination.q(element_0);
          }
        }
        var tmp0_iterator_0 = destination.t();
        while (tmp0_iterator_0.u()) {
          var element_1 = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.stl.propping.ProppingUtils.calculateAvailableProppingMap.<anonymous>.<anonymous>' call
          var demand = element_1.demands()[0];
          demandToProppingData.q(new ProppingData(element, spec, colliderBox, element_1, demand));
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(demandToProppingData, 10));
    var tmp0_iterator_1 = demandToProppingData.t();
    while (tmp0_iterator_1.u()) {
      var item = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.stl.propping.ProppingUtils.calculateAvailableProppingMap.<anonymous>' call
      var tmp$ret$5 = item.demands;
      destination_0.q(tmp$ret$5);
    }
    var demandKeys = toSet(destination_0);
    // Inline function 'kotlin.collections.mutableMapOf' call
    var demandToProppingMap = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_2 = demandKeys.t();
    while (tmp0_iterator_2.u()) {
      var element_2 = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.stl.propping.ProppingUtils.calculateAvailableProppingMap.<anonymous>' call
      // Inline function 'kotlin.collections.groupBy' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_1 = ArrayList_init_$Create$();
      var tmp0_iterator_3 = demandToProppingData.t();
      while (tmp0_iterator_3.u()) {
        var element_3 = tmp0_iterator_3.w();
        // Inline function 'com.ikea.core.stl.propping.ProppingUtils.calculateAvailableProppingMap.<anonymous>.<anonymous>' call
        if (element_3.demands === element_2) {
          destination_1.q(element_3);
        }
      }
      // Inline function 'kotlin.collections.groupByTo' call
      var destination_2 = LinkedHashMap_init_$Create$();
      var tmp0_iterator_4 = destination_1.t();
      while (tmp0_iterator_4.u()) {
        var element_4 = tmp0_iterator_4.w();
        // Inline function 'com.ikea.core.stl.propping.ProppingUtils.calculateAvailableProppingMap.<anonymous>.<anonymous>' call
        var key = element_4.height();
        // Inline function 'kotlin.collections.getOrPut' call
        var value = destination_2.b3(key);
        var tmp_2;
        if (value == null) {
          // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
          var answer = ArrayList_init_$Create$();
          destination_2.r2(key, answer);
          tmp_2 = answer;
        } else {
          tmp_2 = value;
        }
        var list = tmp_2;
        list.q(element_4);
      }
      var props = destination_2;
      var sizes = sorted(toList_0(props.o2()));
      // Inline function 'kotlin.collections.set' call
      var value_0 = new ProppingsAvailableForDemand(sizes, props);
      demandToProppingMap.r2(element_2, value_0);
    }
    return demandToProppingMap;
  };
  protoOf(ProppingUtils).i3g = function (holder, proppingsAvailableForDemand, entityManager, sceneEntities) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = proppingsAvailableForDemand.f3g_1.p2();
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.propping.ProppingUtils.findProppingsThatFit.<anonymous>' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator_0 = element.t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.propping.ProppingUtils.findProppingsThatFit.<anonymous>.<anonymous>' call
        if (ProppingUtils_instance.j3g(holder, element_0, entityManager, sceneEntities)) {
          destination_0.q(element_0);
        }
      }
      var list = destination_0;
      addAll_0(destination, list);
    }
    return destination;
  };
  protoOf(ProppingUtils).j3g = function (holder, propping, entityManager, sceneEntities) {
    var e = entityManager.createEntity();
    var worldTransform = propping.guestConnector.calculateEndTransform(get_worldTransform(holder.propHoldingEntity), holder.proppingHostConnector, Companion_getInstance_5().IDENTITY, Companion_getInstance_5().IDENTITY);
    setParent(e, holder.propHoldingEntity);
    TransformUtils_instance.setWorldTransform(e, worldTransform);
    e.addComponentInternal(new DisplayNameComponent('Propping fit test'));
    e.addComponent(new ColliderShapeComponent(propping.colliderBox));
    if (propping.spec.hasComponent(AlwaysHangDownComponent_instance.id)) {
      e.addComponent(AlwaysHangDownComponent_instance);
      adjustToHangDown(this, e, propping.guestConnector, holder.propHoldingEntity, holder.proppingHostConnector);
    }
    var collision = CollisionUtils_instance.getFirstCollision(e, null, sceneEntities);
    entityManager.disposeEntity(e);
    return collision == null;
  };
  protoOf(ProppingUtils).h3g = function (demandToProppingMap, entityManager, sceneManager, productManager) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_proppingHostEntitiesInHierarchy(sceneManager.scene);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.ProppingUtils.addProppingWherePossible.<anonymous>' call
      var tmp$ret$0 = get_proppingHostConnectors(item);
      destination.q(tmp$ret$0);
    }
    var tmp$ret$3 = copyToArray(destination);
    var proppingHolders = flatten(tmp$ret$3);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = proppingHolders.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.propping.ProppingUtils.addProppingWherePossible.<anonymous>' call
      addProppingColliders(ProppingUtils_instance, element.propHoldingEntity, element.proppingHostConnector);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = proppingHolders.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      $l$block_6: {
        // Inline function 'com.ikea.core.stl.propping.ProppingUtils.addProppingWherePossible.<anonymous>' call
        var proppingHostConnector = element_0.proppingHostConnector;
        var propHoldingEntity = element_0.propHoldingEntity;
        // Inline function 'kotlin.collections.get' call
        var key = firstOrNull_0(proppingHostConnector.offers());
        var tmp0_elvis_lhs = (isInterface(demandToProppingMap, Map) ? demandToProppingMap : THROW_CCE()).b3(key);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$block_6;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var proppingsAvailableForDemand = tmp;
        if (proppingsAvailableForDemand.f3g_1.b1()) {
          break $l$block_6;
        }
        var potentialProppingsThatFit = ProppingUtils_instance.i3g(element_0, proppingsAvailableForDemand, entityManager, sceneManager.entities);
        var propInfoBefore = getPropHolderInfo(propHoldingEntity, proppingHostConnector);
        var tmp_0;
        if (!((propInfoBefore == null ? null : propInfoBefore.oldPropping) == null)) {
          var tmp$ret$6;
          $l$block_2: {
            // Inline function 'kotlin.collections.any' call
            var tmp_1;
            if (isInterface(potentialProppingsThatFit, Collection)) {
              tmp_1 = potentialProppingsThatFit.b1();
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp$ret$6 = false;
              break $l$block_2;
            }
            var tmp0_iterator_1 = potentialProppingsThatFit.t();
            while (tmp0_iterator_1.u()) {
              var element_1 = tmp0_iterator_1.w();
              // Inline function 'com.ikea.core.stl.propping.ProppingUtils.addProppingWherePossible.<anonymous>.<anonymous>' call
              if (element_1.productRef === get_productRef(propInfoBefore.oldPropping)) {
                tmp$ret$6 = true;
                break $l$block_2;
              }
            }
            tmp$ret$6 = false;
          }
          tmp_0 = tmp$ret$6;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          restoreOldPropping(propHoldingEntity, proppingHostConnector);
          if (get_isHanging(propInfoBefore.oldPropping)) {
            var tmp2_safe_receiver = get_guestConnectors(propInfoBefore.oldPropping);
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : firstOrNull_1(tmp2_safe_receiver);
            var tmp_2;
            if (tmp3_elvis_lhs == null) {
              break $l$block_6;
            } else {
              tmp_2 = tmp3_elvis_lhs;
            }
            var guestConnector = tmp_2;
            adjustToHangDown(ProppingUtils_instance, propInfoBefore.oldPropping, guestConnector, propHoldingEntity, proppingHostConnector);
          }
          break $l$block_6;
        }
        if (any(potentialProppingsThatFit)) {
          // Inline function 'kotlin.let' call
          var tmp$ret$11;
          $l$block_5: {
            // Inline function 'kotlin.collections.maxBy' call
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(potentialProppingsThatFit, 10));
            var tmp0_iterator_2 = potentialProppingsThatFit.t();
            while (tmp0_iterator_2.u()) {
              var item_0 = tmp0_iterator_2.w();
              // Inline function 'com.ikea.core.stl.propping.ProppingUtils.addProppingWherePossible.<anonymous>.<anonymous>' call
              var tmp$ret$8 = new Pair(Default_getInstance().ah(item_0.height()), item_0);
              destination_0.q(tmp$ret$8);
            }
            var iterator = destination_0.t();
            if (!iterator.u())
              throw NoSuchElementException_init_$Create$_0();
            var maxElem = iterator.w();
            if (!iterator.u()) {
              tmp$ret$11 = maxElem;
              break $l$block_5;
            }
            // Inline function 'com.ikea.core.stl.propping.ProppingUtils.addProppingWherePossible.<anonymous>.<anonymous>' call
            var maxValue = maxElem.ye_1;
            do {
              var e = iterator.w();
              // Inline function 'com.ikea.core.stl.propping.ProppingUtils.addProppingWherePossible.<anonymous>.<anonymous>' call
              var v = e.ye_1;
              if (compareTo(maxValue, v) < 0) {
                maxElem = e;
                maxValue = v;
              }
            }
             while (iterator.u());
            tmp$ret$11 = maxElem;
          }
          // Inline function 'kotlin.contracts.contract' call
          var selectedPropping = tmp$ret$11.ze_1;
          createAndAddPropping(ProppingUtils_instance, element_0, selectedPropping, productManager);
          break $l$block_6;
        }
        var tmp4_safe_receiver = getOldPropping(propHoldingEntity, proppingHostConnector);
        if (tmp4_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          entityManager.disposeEntity(tmp4_safe_receiver);
          clearOldPropping(propHoldingEntity, proppingHostConnector);
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_3 = proppingHolders.t();
    while (tmp0_iterator_3.u()) {
      var element_2 = tmp0_iterator_3.w();
      // Inline function 'com.ikea.core.stl.propping.ProppingUtils.addProppingWherePossible.<anonymous>' call
      removeProppingColliders(ProppingUtils_instance, element_2.propHoldingEntity, element_2.proppingHostConnector);
    }
  };
  var ProppingUtils_instance;
  function ProppingUtils_getInstance() {
    return ProppingUtils_instance;
  }
  function ProppingsAvailableForDemand(allSizes, heightProppingForSize) {
    this.e3g_1 = allSizes;
    this.f3g_1 = heightProppingForSize;
  }
  protoOf(ProppingsAvailableForDemand).toString = function () {
    return 'ProppingsAvailableForDemand(allSizes=' + this.e3g_1 + ', heightProppingForSize=' + this.f3g_1 + ')';
  };
  protoOf(ProppingsAvailableForDemand).hashCode = function () {
    var result = hashCode(this.e3g_1);
    result = imul(result, 31) + hashCode(this.f3g_1) | 0;
    return result;
  };
  protoOf(ProppingsAvailableForDemand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProppingsAvailableForDemand))
      return false;
    var tmp0_other_with_cast = other instanceof ProppingsAvailableForDemand ? other : THROW_CCE();
    if (!equals(this.e3g_1, tmp0_other_with_cast.e3g_1))
      return false;
    if (!equals(this.f3g_1, tmp0_other_with_cast.f3g_1))
      return false;
    return true;
  };
  function Companion_64() {
    this.k3g_1 = 'SetPropHolderInfoSystem';
  }
  var Companion_instance_97;
  function Companion_getInstance_73() {
    return Companion_instance_97;
  }
  function SetPropHolderInfoSystem() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [87];
    SystemBase.call(this, 'SetPropHolderInfoSystem', 2, tmp$ret$2);
  }
  protoOf(SetPropHolderInfoSystem).s1k = function () {
    return 'SetPropHolderInfoSystem';
  };
  protoOf(SetPropHolderInfoSystem).onAddComponent = function (entity, newComponent) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = newComponent.proppingHostConnectors;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.SetPropHolderInfoSystem.onAddComponent.<anonymous>' call
      var tmp$ret$0 = new PropHolderInfo(item.proppingHostConnector, null, null, null);
      destination.q(tmp$ret$0);
    }
    var newInfoComponent = new ProppingInfoComponent(destination);
    entity.addComponent(newInfoComponent);
  };
  protoOf(SetPropHolderInfoSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(SetPropHolderInfoSystem).onRemoveComponent = function (entity, oldComponent) {
  };
  function handleEntityAddedToScene($this, entity) {
    var tmp0_safe_receiver = get_connectorsComponent(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectors;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = tmp1_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.propping.SetProppingHostConnectorDataSystem.handleEntityAddedToScene.<anonymous>' call
        Companion_getInstance_72();
        if (element.hasTag('propping-connector')) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator_0 = tmp2_safe_receiver.t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.propping.SetProppingHostConnectorDataSystem.handleEntityAddedToScene.<anonymous>' call
        var tmp_1 = element_0.allSubConnectors;
        var list = map(tmp_1, SetProppingHostConnectorDataSystem$handleEntityAddedToScene$lambda(entity));
        addAll_1(destination_0, list);
      }
      tmp_0 = destination_0;
    }
    var proppingHostConnectorData = tmp_0;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(proppingHostConnectorData == null ? true : proppingHostConnectorData.b1())) {
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$7 = copyToArray(proppingHostConnectorData);
      entity.addComponent(new ProppingHostConnectorsComponent(tmp$ret$7));
    }
  }
  function Companion_65() {
    this.t3g_1 = 'SetPropHolderDataSystem';
  }
  var Companion_instance_98;
  function Companion_getInstance_74() {
    return Companion_instance_98;
  }
  function SetProppingHostConnectorDataSystem$handleEntityAddedToScene$lambda($entity) {
    return function (subHostConnector) {
      return new ProppingHostConnectorData($entity, subHostConnector);
    };
  }
  function SetProppingHostConnectorDataSystem(sceneManager) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [2];
    SystemBase.call(this, 'SetPropHolderDataSystem', 5, tmp$ret$2);
    this.c3h_1 = sceneManager;
  }
  protoOf(SetProppingHostConnectorDataSystem).s1k = function () {
    return 'SetPropHolderDataSystem';
  };
  protoOf(SetProppingHostConnectorDataSystem).enable = function () {
    protoOf(SystemBase).enable.call(this);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.c3h_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.propping.SetProppingHostConnectorDataSystem.enable.<anonymous>' call
      handleEntityAddedToScene(this, element);
    }
  };
  protoOf(SetProppingHostConnectorDataSystem).onAddComponent = function (entity, newComponent) {
    handleEntityAddedToScene(this, entity);
  };
  protoOf(SetProppingHostConnectorDataSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(SetProppingHostConnectorDataSystem).onRemoveComponent = function (entity, oldComponent) {
  };
  function Companion_66() {
    this.id = 33;
  }
  protoOf(Companion_66).s1k = function () {
    return this.id;
  };
  var Companion_instance_99;
  function Companion_getInstance_75() {
    return Companion_instance_99;
  }
  function CommunicationSizeComponent(size) {
    this.size = size;
  }
  protoOf(CommunicationSizeComponent).n = function () {
    return this.size;
  };
  protoOf(CommunicationSizeComponent).x1k = function () {
    return 33;
  };
  protoOf(CommunicationSizeComponent).eq = function (other) {
    return (other instanceof CommunicationSizeComponent ? other : THROW_CCE()).size.equals(this.size);
  };
  function DoorComponent() {
    DoorComponent_instance = this;
    this.o2y_1 = this.id;
  }
  protoOf(DoorComponent).x1k = function () {
    return this.o2y_1;
  };
  protoOf(DoorComponent).s1k = function () {
    return 30;
  };
  protoOf(DoorComponent).eq = function (other) {
    return true;
  };
  var DoorComponent_instance;
  function DoorComponent_getInstance() {
    if (DoorComponent_instance == null)
      new DoorComponent();
    return DoorComponent_instance;
  }
  function DoorFrontComponent() {
    DoorFrontComponent_instance = this;
    this.d3h_1 = this.id;
  }
  protoOf(DoorFrontComponent).x1k = function () {
    return this.d3h_1;
  };
  protoOf(DoorFrontComponent).s1k = function () {
    return 32;
  };
  protoOf(DoorFrontComponent).eq = function (other) {
    return true;
  };
  var DoorFrontComponent_instance;
  function DoorFrontComponent_getInstance() {
    if (DoorFrontComponent_instance == null)
      new DoorFrontComponent();
    return DoorFrontComponent_instance;
  }
  function DrawerComponent() {
    DrawerComponent_instance = this;
    this.e3h_1 = this.id;
  }
  protoOf(DrawerComponent).x1k = function () {
    return this.e3h_1;
  };
  protoOf(DrawerComponent).s1k = function () {
    return 50;
  };
  protoOf(DrawerComponent).eq = function (other) {
    return true;
  };
  var DrawerComponent_instance;
  function DrawerComponent_getInstance() {
    if (DrawerComponent_instance == null)
      new DrawerComponent();
    return DrawerComponent_instance;
  }
  function FrameComponent() {
    FrameComponent_instance = this;
    this.f3h_1 = this.id;
  }
  protoOf(FrameComponent).x1k = function () {
    return this.f3h_1;
  };
  protoOf(FrameComponent).s1k = function () {
    return 31;
  };
  protoOf(FrameComponent).eq = function (other) {
    return true;
  };
  var FrameComponent_instance;
  function FrameComponent_getInstance() {
    if (FrameComponent_instance == null)
      new FrameComponent();
    return FrameComponent_instance;
  }
  function HandleComponent() {
    HandleComponent_instance = this;
    this.g3h_1 = this.id;
  }
  protoOf(HandleComponent).x1k = function () {
    return this.g3h_1;
  };
  protoOf(HandleComponent).s1k = function () {
    return 39;
  };
  protoOf(HandleComponent).eq = function (other) {
    return true;
  };
  var HandleComponent_instance;
  function HandleComponent_getInstance() {
    if (HandleComponent_instance == null)
      new HandleComponent();
    return HandleComponent_instance;
  }
  function IncludedHandleComponent() {
    IncludedHandleComponent_instance = this;
    this.h3h_1 = this.id;
  }
  protoOf(IncludedHandleComponent).x1k = function () {
    return this.h3h_1;
  };
  protoOf(IncludedHandleComponent).s1k = function () {
    return 46;
  };
  protoOf(IncludedHandleComponent).eq = function (other) {
    return true;
  };
  var IncludedHandleComponent_instance;
  function IncludedHandleComponent_getInstance() {
    if (IncludedHandleComponent_instance == null)
      new IncludedHandleComponent();
    return IncludedHandleComponent_instance;
  }
  function LegComponent() {
    LegComponent_instance = this;
    this.i3h_1 = this.id;
  }
  protoOf(LegComponent).x1k = function () {
    return this.i3h_1;
  };
  protoOf(LegComponent).s1k = function () {
    return 48;
  };
  protoOf(LegComponent).eq = function (other) {
    return true;
  };
  var LegComponent_instance;
  function LegComponent_getInstance() {
    if (LegComponent_instance == null)
      new LegComponent();
    return LegComponent_instance;
  }
  function Companion_67() {
    this.id = 63;
  }
  protoOf(Companion_67).s1k = function () {
    return this.id;
  };
  var Companion_instance_100;
  function Companion_getInstance_76() {
    return Companion_instance_100;
  }
  function LightComponent(type) {
    this.type = type;
    this.j3h_1 = 63;
  }
  protoOf(LightComponent).a1x = function () {
    return this.type;
  };
  protoOf(LightComponent).x1k = function () {
    return this.j3h_1;
  };
  protoOf(LightComponent).eq = function (other) {
    return this.j3h_1 === other.typeId;
  };
  function rollbackAndCollectFailedResult($this, replacePartsResult, failedReplaces, connectionRoot) {
    // Inline function 'kotlin.collections.onEach' call
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.onEach.<anonymous>' call
    var tmp0_iterator = replacePartsResult.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.rollbackAndCollectFailedResult.<anonymous>' call
      if (element.valid) {
        var tmp0_safe_receiver = element.rollback;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          tmp0_safe_receiver();
        }
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(failedReplaces, 10));
    var tmp0_iterator_0 = failedReplaces.t();
    while (tmp0_iterator_0.u()) {
      var item = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.rollbackAndCollectFailedResult.<anonymous>' call
      var tmp0_elvis_lhs = item.newEntity;
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? item.originalEntity : tmp0_elvis_lhs;
      var ent = tmp1_elvis_lhs == null ? connectionRoot : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = item.errorMessage;
      var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? get_displayName(ent) : tmp2_elvis_lhs;
      var msg = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      var tmp$ret$3 = Companion_instance_0.fail(msg, get_productRef(ent), null);
      destination.q(tmp$ret$3);
    }
    var errors = copyToArray(destination);
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$7 = [];
    return new PlacementResult(tmp$ret$7, errors, null);
  }
  function findPart($this, connectionRoot, partKey) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_descendants(connectionRoot);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.findPart.<anonymous>' call
        if (get_partKey(element) === partKey) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function internalCreateActionForReplaceProductPart($this, connectionRoot, partKey, entityToRemove, entityToAdd, productManager, entityManager, validationService, sceneManager) {
    var tmp0_elvis_lhs = getAssemblyStructure($this, connectionRoot, productManager);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_instance_101.fail(null, 'Can only replace part if the product root has an assembly structure', entityToRemove, entityToAdd);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var assemblyStructure = tmp;
    var oldParent = entityToRemove == null ? null : get_parent(entityToRemove);
    var tmp2_elvis_lhs = findPartAndParentPart$default($this, assemblyStructure.parts, partKey);
    var tmp3_container = tmp2_elvis_lhs == null ? new Pair(null, null) : tmp2_elvis_lhs;
    var assemblyPart = tmp3_container.af();
    var parentPart = tmp3_container.bf();
    var tmp_0;
    if (assemblyPart == null) {
      $this.l3h_1.warn(ReplaceAssemblyPartUtils$internalCreateActionForReplaceProductPart$lambda(partKey, connectionRoot));
      tmp_0 = new ReplacePartResult(true, null, null, null, null);
    } else if (!(entityToRemove == null)) {
      if (oldParent == null)
        return Companion_instance_101.fail(null, 'Old part did not have a parent. This is an illegal state', entityToRemove, entityToAdd);
      var tmp_1;
      if (entityToAdd == null) {
        tmp_1 = createRemovePartAction($this, entityToRemove, assemblyPart, oldParent, entityToAdd, entityManager, validationService);
      } else {
        tmp_1 = createReplacePartAction($this, entityToAdd, entityToRemove, assemblyPart, oldParent, entityManager, validationService, sceneManager);
      }
      tmp_0 = tmp_1;
    } else if (!(entityToAdd == null)) {
      tmp_0 = createAddPartAction($this, parentPart, connectionRoot, entityToAdd, assemblyPart, entityToRemove, entityManager, validationService);
    } else {
      tmp_0 = new ReplacePartResult(true, null, null, null, null);
    }
    return tmp_0;
  }
  function getAssemblyStructure($this, connectionRoot, productManager) {
    var connectionRootProductRef = get_productRef(connectionRoot);
    var tmp;
    if (connectionRootProductRef == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.getAssemblyStructure.<anonymous>' call
      tmp = productManager.productSpecification(connectionRootProductRef);
    }
    var oldAssemblySpecification = tmp;
    var tmp_0;
    if (oldAssemblySpecification == null) {
      tmp_0 = null;
    } else {
      tmp_0 = oldAssemblySpecification._findComponentKt(12);
    }
    var structureFromSpecification = tmp_0;
    var tmp_1;
    if (structureFromSpecification == null) {
      tmp_1 = connectionRoot.__getComponentForKotlin(12);
    } else {
      tmp_1 = structureFromSpecification;
    }
    return tmp_1;
  }
  function createAddPartAction($this, parentPart, connectionRoot, entityToAdd, assemblyPart, entityToRemove, entityManager, validationService) {
    var tmp;
    if (parentPart == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.createAddPartAction.<anonymous>' call
      // Inline function 'kotlin.sequences.find' call
      var this_0 = hierarchyExceptSubTreesWithComponentSequence(connectionRoot, 28);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var tmp0_iterator = this_0.t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.createAddPartAction.<anonymous>.<anonymous>' call
          if (get_partKey(element) === parentPart.partKey) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    var tmp1_elvis_lhs = tmp;
    var parent = tmp1_elvis_lhs == null ? connectionRoot : tmp1_elvis_lhs;
    var replaceAction = new AddPartAction(entityToAdd, assemblyPart, parent, entityManager, validationService);
    var tmp_0 = Companion_instance_101;
    return tmp_0.ok(replaceAction, AddPartAction$rollback$ref(replaceAction), entityToRemove, entityToAdd);
  }
  function createReplacePartAction($this, entityToAdd, entityToRemove, assemblyPart, oldParent, entityManager, validationService, sceneManager) {
    TransformUtils_instance.setWorldTransform(entityToAdd, get_worldTransform(entityToRemove));
    var replaceAction = new ReplacePartAction(entityToRemove, entityToAdd, assemblyPart, oldParent, entityManager, validationService, sceneManager);
    var tmp = Companion_instance_101;
    return tmp.ok(replaceAction, ReplacePartAction$rollback$ref(replaceAction), entityToRemove, entityToAdd);
  }
  function createRemovePartAction($this, entityToRemove, assemblyPart, oldParent, entityToAdd, entityManager, validationService) {
    var removePartAction = new RemovePartAction(entityToRemove, assemblyPart, oldParent, entityManager, validationService);
    var tmp = Companion_instance_101;
    return tmp.ok(removePartAction, RemovePartAction$rollback$ref(removePartAction), entityToRemove, entityToAdd);
  }
  function findPartAndParentPart($this, assemblyParts, partKey, parentPart) {
    var tmp;
    if (assemblyParts == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = assemblyParts.length;
      while (inductionVariable < last) {
        var element = assemblyParts[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.findPartAndParentPart.<anonymous>' call
        var tmp_0;
        if (element.partKey === partKey) {
          tmp_0 = new Pair(element, parentPart);
        } else {
          tmp_0 = findPartAndParentPart(ReplaceAssemblyPartUtils_getInstance(), element.children, partKey, element);
        }
        var tmp0_safe_receiver = tmp_0;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver);
        }
      }
      tmp = destination;
    }
    var tmp1_safe_receiver = tmp;
    return tmp1_safe_receiver == null ? null : firstOrNull_1(tmp1_safe_receiver);
  }
  function findPartAndParentPart$default($this, assemblyParts, partKey, parentPart, $super) {
    parentPart = parentPart === VOID ? null : parentPart;
    return findPartAndParentPart($this, assemblyParts, partKey, parentPart);
  }
  function ReplaceAssemblyPartUtils$replaceProductParts$lambda(_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd) {
    return Unit_instance;
  }
  function ReplaceAssemblyPartUtils$createActionForReplaceProductPart$lambda($msg) {
    return function () {
      return $msg;
    };
  }
  function ReplaceAssemblyPartUtils$internalCreateActionForReplaceProductPart$lambda($partKey, $connectionRoot) {
    return function () {
      return 'partKey ' + $partKey + ' does not exist in the product hierarchy of ' + $connectionRoot + '. Will be ignored.';
    };
  }
  function AddPartAction$rollback$ref($boundThis) {
    var l = function () {
      $boundThis.rollback();
      return Unit_instance;
    };
    l.callableName = 'rollback';
    return l;
  }
  function ReplacePartAction$rollback$ref($boundThis) {
    var l = function () {
      $boundThis.rollback();
      return Unit_instance;
    };
    l.callableName = 'rollback';
    return l;
  }
  function RemovePartAction$rollback$ref($boundThis) {
    var l = function () {
      $boundThis.rollback();
      return Unit_instance;
    };
    l.callableName = 'rollback';
    return l;
  }
  function ReplaceAssemblyPartUtils() {
    ReplaceAssemblyPartUtils_instance = this;
    this.k3h_1 = '';
    this.l3h_1 = LoggerState_getInstance().m1m('ReplaceAssemblyPartUtils');
  }
  protoOf(ReplaceAssemblyPartUtils).m3h = function (connectionRoot, partsMap, coreServices, onReplace) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(partsMap.length);
    var inductionVariable = 0;
    var last = partsMap.length;
    while (inductionVariable < last) {
      var item = partsMap[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.replaceProductParts.<anonymous>' call
      var result = ReplaceAssemblyPartUtils_getInstance().createActionForReplaceProductPart(connectionRoot, item.partKey, item.productRef, coreServices);
      var tmp0_safe_receiver = result.action;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.perform();
      }
      destination.q(result);
    }
    var replacePartsResults = destination;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = replacePartsResults.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.replaceProductParts.<anonymous>' call
      if (!element.valid) {
        destination_0.q(element);
      }
    }
    var failedReplaces = destination_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!failedReplaces.b1()) {
      return rollbackAndCollectFailedResult(this, replacePartsResults, failedReplaces, connectionRoot);
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_1 = ArrayList_init_$Create$();
      var tmp0_iterator_0 = replacePartsResults.t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.replaceProductParts.<anonymous>' call
        if (element_0.valid ? !(element_0.action == null) : false) {
          destination_1.q(element_0);
        }
      }
      var validReplaceResults = destination_1;
      // Inline function 'kotlin.collections.onEach' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.onEach.<anonymous>' call
      var tmp0_iterator_1 = validReplaceResults.t();
      while (tmp0_iterator_1.u()) {
        var element_1 = tmp0_iterator_1.w();
        // Inline function 'com.ikea.core.stl.replace.ReplaceAssemblyPartUtils.replaceProductParts.<anonymous>' call
        if (!(element_1.originalEntity == null) ? !(element_1.newEntity == null) : false) {
          onReplace(element_1.originalEntity, element_1.newEntity);
        }
      }
      RelativeConnectorRepositioner_instance.repositionRelativeConnectorsFromBounds(connectionRoot);
    }
    return Companion_instance_88.ok(connectionRoot);
  };
  protoOf(ReplaceAssemblyPartUtils).replaceProductParts = function (connectionRoot, partsMap, coreServices, onReplace, $super) {
    var tmp;
    if (onReplace === VOID) {
      tmp = ReplaceAssemblyPartUtils$replaceProductParts$lambda;
    } else {
      tmp = onReplace;
    }
    onReplace = tmp;
    return this.m3h(connectionRoot, partsMap, coreServices, onReplace);
  };
  protoOf(ReplaceAssemblyPartUtils).createActionForReplaceProductPart = function (connectionRoot, partKey, productRef, coreServices) {
    var originalPart = findPart(this, connectionRoot, partKey);
    var notSameProduct = !(productRef === (originalPart == null ? null : get_productRef(originalPart)));
    var tmp;
    if (originalPart == null ? productRef === '' : false) {
      tmp = new ReplacePartResult(true, null, null, originalPart);
    } else if (notSameProduct) {
      var tmp_0;
      if (productRef === '') {
        tmp_0 = null;
      } else {
        var newEntity = coreServices.productManager.createEntity(productRef);
        if (newEntity == null) {
          var msg = 'Trying to replace ' + (originalPart == null ? null : get_productRef(originalPart)) + ' with an invalid product ref.';
          this.l3h_1.error(ReplaceAssemblyPartUtils$createActionForReplaceProductPart$lambda(msg));
          return Companion_instance_101.fail(null, msg, originalPart, null);
        }
        tmp_0 = newEntity;
      }
      var newPart = tmp_0;
      tmp = internalCreateActionForReplaceProductPart(this, connectionRoot, partKey, originalPart, newPart, coreServices.productManager, coreServices.entityManager, coreServices.validations, coreServices.sceneManager);
    } else {
      tmp = new ReplacePartResult(true, null, null, null, originalPart);
    }
    return tmp;
  };
  var ReplaceAssemblyPartUtils_instance;
  function ReplaceAssemblyPartUtils_getInstance() {
    if (ReplaceAssemblyPartUtils_instance == null)
      new ReplaceAssemblyPartUtils();
    return ReplaceAssemblyPartUtils_instance;
  }
  function Companion_68() {
  }
  protoOf(Companion_68).fail = function (rollback, errorMessage, originalEntity, newEntity) {
    return new ReplacePartResult(false, null, rollback, errorMessage, originalEntity, newEntity);
  };
  protoOf(Companion_68).ok = function (action, rollback, originalEntity, newEntity) {
    return new ReplacePartResult(true, action, rollback, null, originalEntity, newEntity);
  };
  var Companion_instance_101;
  function Companion_getInstance_77() {
    return Companion_instance_101;
  }
  function ReplacePartResult(valid, action, rollback, errorMessage, originalEntity, newEntity) {
    rollback = rollback === VOID ? null : rollback;
    errorMessage = errorMessage === VOID ? null : errorMessage;
    originalEntity = originalEntity === VOID ? null : originalEntity;
    newEntity = newEntity === VOID ? null : newEntity;
    this.valid = valid;
    this.action = action;
    this.rollback = rollback;
    this.errorMessage = errorMessage;
    this.originalEntity = originalEntity;
    this.newEntity = newEntity;
  }
  protoOf(ReplacePartResult).t2t = function () {
    return this.valid;
  };
  protoOf(ReplacePartResult).n3h = function () {
    return this.action;
  };
  protoOf(ReplacePartResult).o3h = function () {
    return this.rollback;
  };
  protoOf(ReplacePartResult).p3h = function () {
    return this.errorMessage;
  };
  protoOf(ReplacePartResult).n31 = function () {
    return this.originalEntity;
  };
  protoOf(ReplacePartResult).e1j = function () {
    return this.newEntity;
  };
  protoOf(ReplacePartResult).af = function () {
    return this.valid;
  };
  protoOf(ReplacePartResult).bf = function () {
    return this.action;
  };
  protoOf(ReplacePartResult).g1k = function () {
    return this.rollback;
  };
  protoOf(ReplacePartResult).h1k = function () {
    return this.errorMessage;
  };
  protoOf(ReplacePartResult).i1k = function () {
    return this.originalEntity;
  };
  protoOf(ReplacePartResult).j1k = function () {
    return this.newEntity;
  };
  protoOf(ReplacePartResult).q3h = function (valid, action, rollback, errorMessage, originalEntity, newEntity) {
    return new ReplacePartResult(valid, action, rollback, errorMessage, originalEntity, newEntity);
  };
  protoOf(ReplacePartResult).copy = function (valid, action, rollback, errorMessage, originalEntity, newEntity, $super) {
    valid = valid === VOID ? this.valid : valid;
    action = action === VOID ? this.action : action;
    rollback = rollback === VOID ? this.rollback : rollback;
    errorMessage = errorMessage === VOID ? this.errorMessage : errorMessage;
    originalEntity = originalEntity === VOID ? this.originalEntity : originalEntity;
    newEntity = newEntity === VOID ? this.newEntity : newEntity;
    return this.q3h(valid, action, rollback, errorMessage, originalEntity, newEntity);
  };
  protoOf(ReplacePartResult).toString = function () {
    return 'ReplacePartResult(valid=' + this.valid + ', action=' + this.action + ', rollback=' + this.rollback + ', errorMessage=' + this.errorMessage + ', originalEntity=' + this.originalEntity + ', newEntity=' + this.newEntity + ')';
  };
  protoOf(ReplacePartResult).hashCode = function () {
    var result = getBooleanHashCode(this.valid);
    result = imul(result, 31) + (this.action == null ? 0 : hashCode(this.action)) | 0;
    result = imul(result, 31) + (this.rollback == null ? 0 : hashCode(this.rollback)) | 0;
    result = imul(result, 31) + (this.errorMessage == null ? 0 : getStringHashCode(this.errorMessage)) | 0;
    result = imul(result, 31) + (this.originalEntity == null ? 0 : this.originalEntity.hashCode()) | 0;
    result = imul(result, 31) + (this.newEntity == null ? 0 : this.newEntity.hashCode()) | 0;
    return result;
  };
  protoOf(ReplacePartResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReplacePartResult))
      return false;
    var tmp0_other_with_cast = other instanceof ReplacePartResult ? other : THROW_CCE();
    if (!(this.valid === tmp0_other_with_cast.valid))
      return false;
    if (!equals(this.action, tmp0_other_with_cast.action))
      return false;
    if (!equals(this.rollback, tmp0_other_with_cast.rollback))
      return false;
    if (!(this.errorMessage == tmp0_other_with_cast.errorMessage))
      return false;
    if (!equals(this.originalEntity, tmp0_other_with_cast.originalEntity))
      return false;
    if (!equals(this.newEntity, tmp0_other_with_cast.newEntity))
      return false;
    return true;
  };
  function ReplacePlacementResult(replacedEntityResult, childrenResult) {
    this.replacedEntityResult = replacedEntityResult;
    this.childrenResult = childrenResult;
    this.r3h_1 = 0;
  }
  protoOf(ReplacePlacementResult).s3h = function () {
    return this.replacedEntityResult;
  };
  protoOf(ReplacePlacementResult).t3h = function () {
    return this.childrenResult;
  };
  protoOf(ReplacePlacementResult).equals = function (other) {
    return this === other;
  };
  protoOf(ReplacePlacementResult).hashCode = function () {
    if (this.r3h_1 === 0) {
      this.r3h_1 = hashCode(this.replacedEntityResult) + contentHashCode(this.childrenResult) | 0;
    }
    return this.r3h_1;
  };
  protoOf(ReplacePlacementResult).af = function () {
    return this.replacedEntityResult;
  };
  protoOf(ReplacePlacementResult).bf = function () {
    return this.childrenResult;
  };
  protoOf(ReplacePlacementResult).u3h = function (replacedEntityResult, childrenResult) {
    return new ReplacePlacementResult(replacedEntityResult, childrenResult);
  };
  protoOf(ReplacePlacementResult).copy = function (replacedEntityResult, childrenResult, $super) {
    replacedEntityResult = replacedEntityResult === VOID ? this.replacedEntityResult : replacedEntityResult;
    childrenResult = childrenResult === VOID ? this.childrenResult : childrenResult;
    return this.u3h(replacedEntityResult, childrenResult);
  };
  protoOf(ReplacePlacementResult).toString = function () {
    return 'ReplacePlacementResult(replacedEntityResult=' + this.replacedEntityResult + ', childrenResult=' + toString(this.childrenResult) + ')';
  };
  function replaceEntityInternal($this, entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, doItFast, coreServices) {
    var hostedEntitiesBeforeReplace = get_guests(entityToRemove);
    TransformUtils_instance.setWorldTransform(entityToAdd, get_worldTransform(entityToRemove));
    var replaceAction = doItFast ? new FastReplaceAction(entityToRemove, entityToAdd, coreServices.entityManager, null, coreServices.sceneManager) : new ReplaceAction(entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, null, coreServices.sceneManager);
    replaceAction.perform();
    if (get_parent(entityToAdd) == null) {
      var tmp = Companion_instance_88;
      var tmp0_elvis_lhs = get_productRef(entityToAdd);
      var tmp_0 = tmp.failWithMessage('The new entity could not snap to scene', tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs);
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$0 = [];
      return new ReplacePlacementResult(tmp_0, tmp$ret$0);
    }
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.core.stl.replace.ReplaceUtils.replaceEntityInternal.<anonymous>' call
    coreServices.validations;
    var mainResult = Companion_instance_88.fromValidationResult(coreServices.validations.validateCurrentState(entityToAdd, false), entityToAdd);
    var childrenResult = validateChildren($this, entityToAdd, hostedEntitiesBeforeReplace, coreServices.validations);
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3 = copyToArray(childrenResult);
    return new ReplacePlacementResult(mainResult, tmp$ret$3);
  }
  function validateChildren($this, entityToAdd, childrenBeforeReplace, validationService) {
    var hostedEntitiesAfterReplace = get_guests(entityToAdd);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = childrenBeforeReplace.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.replace.ReplaceUtils.validateChildren.<anonymous>' call
      if (!element.isDisposed) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.t();
    while (tmp0_iterator_0.u()) {
      var item = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.replace.ReplaceUtils.validateChildren.<anonymous>' call
      var existsAfterReplace = hostedEntitiesAfterReplace.p(item);
      var tmp;
      if (existsAfterReplace) {
        tmp = validationService == null ? null : validationService.validateCurrentState(item);
      } else {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = [new ValidationResultFail('Descendant entity ' + item + ' was removed during replace. Possibly because no matching connectors were found', get_productRefOrEmptyString(item), null)];
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var validationResults = tmp_0;
      var tmp$ret$7 = Companion_instance_88.fromValidationResult(validationResults, item);
      destination_0.q(tmp$ret$7);
    }
    return destination_0;
  }
  function ReplaceUtils() {
  }
  protoOf(ReplaceUtils).replaceEntity = function (entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, coreServices) {
    var tmp0_safe_receiver = get_parent(entityToRemove);
    var doItFast = (tmp0_safe_receiver == null ? null : get_isAutomaticGroup(tmp0_safe_receiver)) === true;
    return replaceEntityInternal(this, entityToRemove, entityToAdd, allowedMovementsOfChildrenInMilliMeter, doItFast, coreServices);
  };
  protoOf(ReplaceUtils).fastReplaceEntity = function (entityToRemove, entityToAdd, coreServices) {
    var tmp0_safe_receiver = get_parent(entityToRemove);
    var doItFast = (tmp0_safe_receiver == null ? null : get_isAutomaticGroup(tmp0_safe_receiver)) === true;
    return replaceEntityInternal(this, entityToRemove, entityToAdd, 0.0, doItFast, coreServices);
  };
  var ReplaceUtils_instance;
  function ReplaceUtils_getInstance() {
    return ReplaceUtils_instance;
  }
  function RoomComponentDeserializer() {
    this.v3h_1 = true;
  }
  protoOf(RoomComponentDeserializer).a1m = function () {
    return this.v3h_1;
  };
  protoOf(RoomComponentDeserializer).canHandle = function (serializationKey) {
    var tmp;
    Companion_getInstance_87();
    if (serializationKey === 'RoomDimensionsComponent') {
      tmp = true;
    } else {
      Companion_getInstance_88();
      if (serializationKey === 'RoomGeometry') {
        tmp = true;
      } else {
        tmp = false;
      }
    }
    return tmp;
  };
  protoOf(RoomComponentDeserializer).deserialize = function (serializationKey, json) {
    var tmp;
    Companion_getInstance_87();
    if (serializationKey === 'RoomDimensionsComponent') {
      tmp = Companion_getInstance_87().fromJson(json);
    } else {
      Companion_getInstance_88();
      if (serializationKey === 'RoomGeometry') {
        tmp = Companion_getInstance_88().fromJson(json);
      } else {
        var message = 'No component deserializer found even though we promised that we had one';
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    return tmp;
  };
  function RoomConnectorConstants() {
    RoomConnectorConstants_instance = this;
    this.w3h_1 = 'continuous';
    this.FLOOR_CONNECTOR_KEY = 'ground';
    this.CEILING_CONNECTOR_KEY = 'ceiling';
    this.BACK_WALL_KEY = 'back-wall';
    this.LEFT_WALL_KEY = 'left-wall';
    this.RIGHT_WALL_KEY = 'right-wall';
    this.FRONT_WALL_KEY = 'front-wall';
    this.BACK_WALL_FLOOR_EDGE_KEY = 'back-wall-floor-edge';
    this.LEFT_WALL_FLOOR_EDGE_KEY = 'left-wall-floor-edge';
    this.RIGHT_WALL_FLOOR_EDGE_KEY = 'right-wall-floor-edge';
    this.FRONT_WALL_FLOOR_EDGE_KEY = 'front-wall-floor-edge';
    this.BACK_WALL_CEILING_EDGE_KEY = 'back-wall-ceiling-edge';
    this.LEFT_WALL_CEILING_EDGE_KEY = 'left-wall-ceiling-edge';
    this.RIGHT_WALL_CEILING_EDGE_KEY = 'right-wall-ceiling-edge';
    this.FRONT_WALL_CEILING_EDGE_KEY = 'front-wall-ceiling-edge';
    this.LEFT_BACK_CORNER_KEY = 'back-left-corner';
    this.RIGHT_BACK_CORNER_KEY = 'back-right-corner';
    this.LEFT_FRONT_CORNER_KEY = 'front-left-corner';
    this.RIGHT_FRONT_CORNER_KEY = 'front-right-corner';
    this.LEFT_BACK_CEILING_CORNER_KEY = 'back-left-corner-ceiling';
    this.RIGHT_BACK_CEILING_CORNER_KEY = 'back-right-corner-ceiling';
    this.LEFT_FRONT_CEILING_CORNER_KEY = 'front-left-corner-ceiling';
    this.RIGHT_FRONT_CEILING_CORNER_KEY = 'front-right-corner-ceiling';
    this.EDGE_WALL_CEILING_OFFER = 'wall-ceiling-edge';
    this.EDGE_WALL_FLOOR_OFFER = 'wall-floor-edge';
    this.EDGE_WALL_WALL_OFFER = 'wall-wall-edge';
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.EDGE_WALL_CEILING_OFFERS = ['wall-ceiling-edge', 'continuous'];
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.EDGE_WALL_FLOOR_OFFERS = ['wall-floor-edge', 'continuous'];
    var tmp_1 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1.EDGE_WALL_WALL_OFFERS = ['wall-wall-edge', 'continuous'];
    this.POINT_WALL_FLOOR_OFFER = 'wall-corner';
    this.POINT_WALL_CEILING_OFFER = 'ceiling-corner';
    this.WALL_OFFER = 'wall';
    this.FLOOR_OFFER = 'floor';
    this.CEILING_OFFER = 'ceiling';
    var tmp_2 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_2.FLOOR_OFFERS = ['floor', 'continuous'];
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.WALL_OFFERS = ['wall', 'continuous'];
    var tmp_4 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4.CEILING_OFFERS = ['ceiling', 'continuous'];
  }
  protoOf(RoomConnectorConstants).x3h = function () {
    return this.FLOOR_CONNECTOR_KEY;
  };
  protoOf(RoomConnectorConstants).y3h = function () {
    return this.CEILING_CONNECTOR_KEY;
  };
  protoOf(RoomConnectorConstants).z3h = function () {
    return this.BACK_WALL_KEY;
  };
  protoOf(RoomConnectorConstants).a3i = function () {
    return this.LEFT_WALL_KEY;
  };
  protoOf(RoomConnectorConstants).b3i = function () {
    return this.RIGHT_WALL_KEY;
  };
  protoOf(RoomConnectorConstants).c3i = function () {
    return this.FRONT_WALL_KEY;
  };
  protoOf(RoomConnectorConstants).d3i = function () {
    return this.BACK_WALL_FLOOR_EDGE_KEY;
  };
  protoOf(RoomConnectorConstants).e3i = function () {
    return this.LEFT_WALL_FLOOR_EDGE_KEY;
  };
  protoOf(RoomConnectorConstants).f3i = function () {
    return this.RIGHT_WALL_FLOOR_EDGE_KEY;
  };
  protoOf(RoomConnectorConstants).g3i = function () {
    return this.FRONT_WALL_FLOOR_EDGE_KEY;
  };
  protoOf(RoomConnectorConstants).h3i = function () {
    return this.BACK_WALL_CEILING_EDGE_KEY;
  };
  protoOf(RoomConnectorConstants).i3i = function () {
    return this.LEFT_WALL_CEILING_EDGE_KEY;
  };
  protoOf(RoomConnectorConstants).j3i = function () {
    return this.RIGHT_WALL_CEILING_EDGE_KEY;
  };
  protoOf(RoomConnectorConstants).k3i = function () {
    return this.FRONT_WALL_CEILING_EDGE_KEY;
  };
  protoOf(RoomConnectorConstants).l3i = function () {
    return this.LEFT_BACK_CORNER_KEY;
  };
  protoOf(RoomConnectorConstants).m3i = function () {
    return this.RIGHT_BACK_CORNER_KEY;
  };
  protoOf(RoomConnectorConstants).n3i = function () {
    return this.LEFT_FRONT_CORNER_KEY;
  };
  protoOf(RoomConnectorConstants).o3i = function () {
    return this.RIGHT_FRONT_CORNER_KEY;
  };
  protoOf(RoomConnectorConstants).p3i = function () {
    return this.LEFT_BACK_CEILING_CORNER_KEY;
  };
  protoOf(RoomConnectorConstants).q3i = function () {
    return this.RIGHT_BACK_CEILING_CORNER_KEY;
  };
  protoOf(RoomConnectorConstants).r3i = function () {
    return this.LEFT_FRONT_CEILING_CORNER_KEY;
  };
  protoOf(RoomConnectorConstants).s3i = function () {
    return this.RIGHT_FRONT_CEILING_CORNER_KEY;
  };
  protoOf(RoomConnectorConstants).t3i = function () {
    return this.EDGE_WALL_CEILING_OFFER;
  };
  protoOf(RoomConnectorConstants).u3i = function () {
    return this.EDGE_WALL_FLOOR_OFFER;
  };
  protoOf(RoomConnectorConstants).v3i = function () {
    return this.EDGE_WALL_WALL_OFFER;
  };
  protoOf(RoomConnectorConstants).w3i = function () {
    return this.EDGE_WALL_CEILING_OFFERS;
  };
  protoOf(RoomConnectorConstants).x3i = function () {
    return this.EDGE_WALL_FLOOR_OFFERS;
  };
  protoOf(RoomConnectorConstants).y3i = function () {
    return this.EDGE_WALL_WALL_OFFERS;
  };
  protoOf(RoomConnectorConstants).z3i = function () {
    return this.POINT_WALL_FLOOR_OFFER;
  };
  protoOf(RoomConnectorConstants).a3j = function () {
    return this.POINT_WALL_CEILING_OFFER;
  };
  protoOf(RoomConnectorConstants).b3j = function () {
    return this.WALL_OFFER;
  };
  protoOf(RoomConnectorConstants).c3j = function () {
    return this.FLOOR_OFFER;
  };
  protoOf(RoomConnectorConstants).d3j = function () {
    return this.CEILING_OFFER;
  };
  protoOf(RoomConnectorConstants).e3j = function () {
    return this.FLOOR_OFFERS;
  };
  protoOf(RoomConnectorConstants).f3j = function () {
    return this.WALL_OFFERS;
  };
  protoOf(RoomConnectorConstants).g3j = function () {
    return this.CEILING_OFFERS;
  };
  protoOf(RoomConnectorConstants).hasFloorPlacement = function (connection) {
    return connection.hostConnector.isOffering('floor') ? true : connection.hostConnector.isOffering('wall-floor-edge');
  };
  protoOf(RoomConnectorConstants).hasWallPlacement = function (connection) {
    return connection.hostConnector.isOffering('wall');
  };
  protoOf(RoomConnectorConstants).hasCornerPlacement = function (connection) {
    return connection.hostConnector.isOffering(this.POINT_WALL_FLOOR_OFFER);
  };
  var RoomConnectorConstants_instance;
  function RoomConnectorConstants_getInstance() {
    if (RoomConnectorConstants_instance == null)
      new RoomConnectorConstants();
    return RoomConnectorConstants_instance;
  }
  function Companion_69() {
    Companion_instance_102 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h3j_1 = [new ReferenceArraySerializer(getKClass(CoreRoomSurface), $serializer_getInstance_2()), null, null, new ReferenceArraySerializer(getKClass(CoreRoomEdge), $serializer_getInstance_4()), new ReferenceArraySerializer(getKClass(CoreRoomVertex), $serializer_getInstance_5()), new ReferenceArraySerializer(getKClass(CoreRoomObstacle), $serializer_getInstance_6())];
  }
  protoOf(Companion_69).l17 = function () {
    return $serializer_getInstance_1();
  };
  var Companion_instance_102;
  function Companion_getInstance_78() {
    if (Companion_instance_102 == null)
      new Companion_69();
    return Companion_instance_102;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.CoreRoomGeometryData', this, 6);
    tmp0_serialDesc.cv('walls', false);
    tmp0_serialDesc.cv('floor', false);
    tmp0_serialDesc.cv('ceiling', false);
    tmp0_serialDesc.cv('edges', false);
    tmp0_serialDesc.cv('vertices', false);
    tmp0_serialDesc.cv('obstacles', true);
    this.i3j_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ok = function () {
    return this.i3j_1;
  };
  protoOf($serializer).rv = function () {
    var tmp0_cached = Companion_getInstance_78().h3j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], $serializer_getInstance_2(), $serializer_getInstance_2(), tmp0_cached[3], tmp0_cached[4], tmp0_cached[5]];
  };
  protoOf($serializer).qk = function (decoder) {
    var tmp0_desc = this.i3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.nn(tmp0_desc);
    var tmp11_cached = Companion_getInstance_78().h3j_1;
    if (tmp10_input.do()) {
      tmp4_local0 = tmp10_input.zn(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.zn(tmp0_desc, 1, $serializer_getInstance_2(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.zn(tmp0_desc, 2, $serializer_getInstance_2(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.zn(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zn(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.zn(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.zn(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.zn(tmp0_desc, 1, $serializer_getInstance_2(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.zn(tmp0_desc, 2, $serializer_getInstance_2(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.zn(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zn(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.zn(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.on(tmp0_desc);
    return CoreRoomGeometryData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer).j3j = function (encoder, value) {
    var tmp0_desc = this.i3j_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_78().h3j_1;
    tmp1_output.ep(tmp0_desc, 0, tmp2_cached[0], value.walls);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_2(), value.floor);
    tmp1_output.ep(tmp0_desc, 2, $serializer_getInstance_2(), value.ceiling);
    tmp1_output.ep(tmp0_desc, 3, tmp2_cached[3], value.edges);
    tmp1_output.ep(tmp0_desc, 4, tmp2_cached[4], value.vertices);
    var tmp;
    if (tmp1_output.kp(tmp0_desc, 5)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$0 = [];
      tmp = !equals(value.obstacles, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.ep(tmp0_desc, 5, tmp2_cached[5], value.obstacles);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer).pk = function (encoder, value) {
    return this.j3j(encoder, value instanceof CoreRoomGeometryData ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_1() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function CoreRoomGeometryData_init_$Init$(seen1, walls, floor, ceiling, edges, vertices, obstacles, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_1().i3j_1);
    }
    $this.walls = walls;
    $this.floor = floor;
    $this.ceiling = ceiling;
    $this.edges = edges;
    $this.vertices = vertices;
    if (0 === (seen1 & 32)) {
      var tmp = $this;
      // Inline function 'kotlin.emptyArray' call
      tmp.obstacles = [];
    } else
      $this.obstacles = obstacles;
    return $this;
  }
  function CoreRoomGeometryData_init_$Create$(seen1, walls, floor, ceiling, edges, vertices, obstacles, serializationConstructorMarker) {
    return CoreRoomGeometryData_init_$Init$(seen1, walls, floor, ceiling, edges, vertices, obstacles, serializationConstructorMarker, objectCreate(protoOf(CoreRoomGeometryData)));
  }
  function CoreRoomGeometryData(walls, floor, ceiling, edges, vertices, obstacles) {
    Companion_getInstance_78();
    var tmp;
    if (obstacles === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = obstacles;
    }
    obstacles = tmp;
    this.walls = walls;
    this.floor = floor;
    this.ceiling = ceiling;
    this.edges = edges;
    this.vertices = vertices;
    this.obstacles = obstacles;
  }
  protoOf(CoreRoomGeometryData).k3j = function () {
    return this.walls;
  };
  protoOf(CoreRoomGeometryData).l3j = function () {
    return this.floor;
  };
  protoOf(CoreRoomGeometryData).m3j = function () {
    return this.ceiling;
  };
  protoOf(CoreRoomGeometryData).n3j = function () {
    return this.edges;
  };
  protoOf(CoreRoomGeometryData).b23 = function () {
    return this.vertices;
  };
  protoOf(CoreRoomGeometryData).o3j = function () {
    return this.obstacles;
  };
  protoOf(CoreRoomGeometryData).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof CoreRoomGeometryData))
      THROW_CCE();
    if (!contentEquals(this.walls, other.walls))
      return false;
    if (!this.floor.equals(other.floor))
      return false;
    if (!this.ceiling.equals(other.ceiling))
      return false;
    if (!contentEquals(this.edges, other.edges))
      return false;
    if (!contentEquals(this.vertices, other.vertices))
      return false;
    if (!contentEquals(this.obstacles, other.obstacles))
      return false;
    return true;
  };
  protoOf(CoreRoomGeometryData).hashCode = function () {
    var result = contentHashCode(this.walls);
    result = imul(11, result) + this.floor.hashCode() | 0;
    result = imul(23, result) + this.ceiling.hashCode() | 0;
    result = imul(31, result) + contentHashCode(this.edges) | 0;
    result = imul(19, result) + contentHashCode(this.vertices) | 0;
    return result;
  };
  protoOf(CoreRoomGeometryData).af = function () {
    return this.walls;
  };
  protoOf(CoreRoomGeometryData).bf = function () {
    return this.floor;
  };
  protoOf(CoreRoomGeometryData).g1k = function () {
    return this.ceiling;
  };
  protoOf(CoreRoomGeometryData).h1k = function () {
    return this.edges;
  };
  protoOf(CoreRoomGeometryData).i1k = function () {
    return this.vertices;
  };
  protoOf(CoreRoomGeometryData).j1k = function () {
    return this.obstacles;
  };
  protoOf(CoreRoomGeometryData).p3j = function (walls, floor, ceiling, edges, vertices, obstacles) {
    return new CoreRoomGeometryData(walls, floor, ceiling, edges, vertices, obstacles);
  };
  protoOf(CoreRoomGeometryData).copy = function (walls, floor, ceiling, edges, vertices, obstacles, $super) {
    walls = walls === VOID ? this.walls : walls;
    floor = floor === VOID ? this.floor : floor;
    ceiling = ceiling === VOID ? this.ceiling : ceiling;
    edges = edges === VOID ? this.edges : edges;
    vertices = vertices === VOID ? this.vertices : vertices;
    obstacles = obstacles === VOID ? this.obstacles : obstacles;
    return this.p3j(walls, floor, ceiling, edges, vertices, obstacles);
  };
  protoOf(CoreRoomGeometryData).toString = function () {
    return 'CoreRoomGeometryData(walls=' + toString(this.walls) + ', floor=' + this.floor + ', ceiling=' + this.ceiling + ', edges=' + toString(this.edges) + ', vertices=' + toString(this.vertices) + ', obstacles=' + toString(this.obstacles) + ')';
  };
  function CoreRoomGeometry() {
  }
  function Companion_70() {
  }
  protoOf(Companion_70).l17 = function () {
    return $serializer_getInstance_2();
  };
  var Companion_instance_103;
  function Companion_getInstance_79() {
    return Companion_instance_103;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.CoreRoomSurface', this, 2);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('s', false);
    this.q3j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ok = function () {
    return this.q3j_1;
  };
  protoOf($serializer_0).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_3()];
  };
  protoOf($serializer_0).qk = function (decoder) {
    var tmp0_desc = this.q3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return CoreRoomSurface_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_0).r3j = function (encoder, value) {
    var tmp0_desc = this.q3j_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_3(), value.surfaceGeometry);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_0).pk = function (encoder, value) {
    return this.r3j(encoder, value instanceof CoreRoomSurface ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_2() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function CoreRoomSurface_init_$Init$(seen1, id, surfaceGeometry, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_2().q3j_1);
    }
    $this.id = id;
    $this.surfaceGeometry = surfaceGeometry;
    return $this;
  }
  function CoreRoomSurface_init_$Create$(seen1, id, surfaceGeometry, serializationConstructorMarker) {
    return CoreRoomSurface_init_$Init$(seen1, id, surfaceGeometry, serializationConstructorMarker, objectCreate(protoOf(CoreRoomSurface)));
  }
  function CoreRoomSurface(id, surfaceGeometry) {
    this.id = id;
    this.surfaceGeometry = surfaceGeometry;
  }
  protoOf(CoreRoomSurface).s1k = function () {
    return this.id;
  };
  protoOf(CoreRoomSurface).s3j = function () {
    return this.surfaceGeometry;
  };
  protoOf(CoreRoomSurface).af = function () {
    return this.id;
  };
  protoOf(CoreRoomSurface).bf = function () {
    return this.surfaceGeometry;
  };
  protoOf(CoreRoomSurface).t3j = function (id, surfaceGeometry) {
    return new CoreRoomSurface(id, surfaceGeometry);
  };
  protoOf(CoreRoomSurface).copy = function (id, surfaceGeometry, $super) {
    id = id === VOID ? this.id : id;
    surfaceGeometry = surfaceGeometry === VOID ? this.surfaceGeometry : surfaceGeometry;
    return this.t3j(id, surfaceGeometry);
  };
  protoOf(CoreRoomSurface).toString = function () {
    return 'CoreRoomSurface(id=' + this.id + ', surfaceGeometry=' + this.surfaceGeometry + ')';
  };
  protoOf(CoreRoomSurface).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(result, 31) + this.surfaceGeometry.hashCode() | 0;
    return result;
  };
  protoOf(CoreRoomSurface).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CoreRoomSurface))
      return false;
    var tmp0_other_with_cast = other instanceof CoreRoomSurface ? other : THROW_CCE();
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    if (!this.surfaceGeometry.equals(tmp0_other_with_cast.surfaceGeometry))
      return false;
    return true;
  };
  function Companion_71() {
    Companion_instance_104 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u3j_1 = [new ReferenceArraySerializer(getKClass(Vector), $serializer_getInstance())];
  }
  protoOf(Companion_71).l17 = function () {
    return $serializer_getInstance_3();
  };
  var Companion_instance_104;
  function Companion_getInstance_80() {
    if (Companion_instance_104 == null)
      new Companion_71();
    return Companion_instance_104;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.RoomSurfaceGeometryImpl', this, 1);
    tmp0_serialDesc.cv('p', false);
    this.v3j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ok = function () {
    return this.v3j_1;
  };
  protoOf($serializer_1).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_80().u3j_1[0]];
  };
  protoOf($serializer_1).qk = function (decoder) {
    var tmp0_desc = this.v3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.nn(tmp0_desc);
    var tmp6_cached = Companion_getInstance_80().u3j_1;
    if (tmp5_input.do()) {
      tmp4_local0 = tmp5_input.zn(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.zn(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.on(tmp0_desc);
    return RoomSurfaceGeometryImpl_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).w3j = function (encoder, value) {
    var tmp0_desc = this.v3j_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_80().u3j_1;
    tmp1_output.ep(tmp0_desc, 0, tmp2_cached[0], value.points);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_1).pk = function (encoder, value) {
    return this.w3j(encoder, value instanceof RoomSurfaceGeometryImpl ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_3() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function RoomSurfaceGeometryImpl_init_$Init$(seen1, points, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_3().v3j_1);
    }
    $this.points = points;
    return $this;
  }
  function RoomSurfaceGeometryImpl_init_$Create$(seen1, points, serializationConstructorMarker) {
    return RoomSurfaceGeometryImpl_init_$Init$(seen1, points, serializationConstructorMarker, objectCreate(protoOf(RoomSurfaceGeometryImpl)));
  }
  function RoomSurfaceGeometryImpl(points) {
    Companion_getInstance_80();
    this.points = points;
  }
  protoOf(RoomSurfaceGeometryImpl).x3j = function () {
    return this.points;
  };
  protoOf(RoomSurfaceGeometryImpl).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof RoomSurfaceGeometryImpl))
      THROW_CCE();
    if (!contentEquals(this.points, other.points))
      return false;
    return true;
  };
  protoOf(RoomSurfaceGeometryImpl).hashCode = function () {
    return contentHashCode(this.points);
  };
  protoOf(RoomSurfaceGeometryImpl).af = function () {
    return this.points;
  };
  protoOf(RoomSurfaceGeometryImpl).y3j = function (points) {
    return new RoomSurfaceGeometryImpl(points);
  };
  protoOf(RoomSurfaceGeometryImpl).copy = function (points, $super) {
    points = points === VOID ? this.points : points;
    return this.y3j(points);
  };
  protoOf(RoomSurfaceGeometryImpl).toString = function () {
    return 'RoomSurfaceGeometryImpl(points=' + toString(this.points) + ')';
  };
  function Companion_72() {
  }
  protoOf(Companion_72).l17 = function () {
    return $serializer_getInstance_4();
  };
  var Companion_instance_105;
  function Companion_getInstance_81() {
    return Companion_instance_105;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.CoreRoomEdge', this, 5);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('s1', false);
    tmp0_serialDesc.cv('s2', false);
    tmp0_serialDesc.cv('p1', false);
    tmp0_serialDesc.cv('p2', false);
    this.z3j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ok = function () {
    return this.z3j_1;
  };
  protoOf($serializer_2).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance(), $serializer_getInstance()];
  };
  protoOf($serializer_2).qk = function (decoder) {
    var tmp0_desc = this.z3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.nn(tmp0_desc);
    if (tmp9_input.do()) {
      tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.xn(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zn(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zn(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.xn(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zn(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zn(tmp0_desc, 4, $serializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.on(tmp0_desc);
    return CoreRoomEdge_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_2).a3k = function (encoder, value) {
    var tmp0_desc = this.z3j_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.cp(tmp0_desc, 1, value.surfaceId1);
    tmp1_output.cp(tmp0_desc, 2, value.surfaceId2);
    tmp1_output.ep(tmp0_desc, 3, $serializer_getInstance(), value.point1);
    tmp1_output.ep(tmp0_desc, 4, $serializer_getInstance(), value.point2);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_2).pk = function (encoder, value) {
    return this.a3k(encoder, value instanceof CoreRoomEdge ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_4() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function CoreRoomEdge_init_$Init$(seen1, id, surfaceId1, surfaceId2, point1, point2, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen1))) {
      throwMissingFieldException(seen1, 31, $serializer_getInstance_4().z3j_1);
    }
    $this.id = id;
    $this.surfaceId1 = surfaceId1;
    $this.surfaceId2 = surfaceId2;
    $this.point1 = point1;
    $this.point2 = point2;
    return $this;
  }
  function CoreRoomEdge_init_$Create$(seen1, id, surfaceId1, surfaceId2, point1, point2, serializationConstructorMarker) {
    return CoreRoomEdge_init_$Init$(seen1, id, surfaceId1, surfaceId2, point1, point2, serializationConstructorMarker, objectCreate(protoOf(CoreRoomEdge)));
  }
  function CoreRoomEdge(id, surfaceId1, surfaceId2, point1, point2) {
    this.id = id;
    this.surfaceId1 = surfaceId1;
    this.surfaceId2 = surfaceId2;
    this.point1 = point1;
    this.point2 = point2;
  }
  protoOf(CoreRoomEdge).s1k = function () {
    return this.id;
  };
  protoOf(CoreRoomEdge).b3k = function () {
    return this.surfaceId1;
  };
  protoOf(CoreRoomEdge).c3k = function () {
    return this.surfaceId2;
  };
  protoOf(CoreRoomEdge).d3k = function () {
    return this.point1;
  };
  protoOf(CoreRoomEdge).e3k = function () {
    return this.point2;
  };
  protoOf(CoreRoomEdge).af = function () {
    return this.id;
  };
  protoOf(CoreRoomEdge).bf = function () {
    return this.surfaceId1;
  };
  protoOf(CoreRoomEdge).g1k = function () {
    return this.surfaceId2;
  };
  protoOf(CoreRoomEdge).h1k = function () {
    return this.point1;
  };
  protoOf(CoreRoomEdge).i1k = function () {
    return this.point2;
  };
  protoOf(CoreRoomEdge).f3k = function (id, surfaceId1, surfaceId2, point1, point2) {
    return new CoreRoomEdge(id, surfaceId1, surfaceId2, point1, point2);
  };
  protoOf(CoreRoomEdge).copy = function (id, surfaceId1, surfaceId2, point1, point2, $super) {
    id = id === VOID ? this.id : id;
    surfaceId1 = surfaceId1 === VOID ? this.surfaceId1 : surfaceId1;
    surfaceId2 = surfaceId2 === VOID ? this.surfaceId2 : surfaceId2;
    point1 = point1 === VOID ? this.point1 : point1;
    point2 = point2 === VOID ? this.point2 : point2;
    return this.f3k(id, surfaceId1, surfaceId2, point1, point2);
  };
  protoOf(CoreRoomEdge).toString = function () {
    return 'CoreRoomEdge(id=' + this.id + ', surfaceId1=' + this.surfaceId1 + ', surfaceId2=' + this.surfaceId2 + ', point1=' + this.point1 + ', point2=' + this.point2 + ')';
  };
  protoOf(CoreRoomEdge).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(result, 31) + getStringHashCode(this.surfaceId1) | 0;
    result = imul(result, 31) + getStringHashCode(this.surfaceId2) | 0;
    result = imul(result, 31) + this.point1.hashCode() | 0;
    result = imul(result, 31) + this.point2.hashCode() | 0;
    return result;
  };
  protoOf(CoreRoomEdge).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CoreRoomEdge))
      return false;
    var tmp0_other_with_cast = other instanceof CoreRoomEdge ? other : THROW_CCE();
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    if (!(this.surfaceId1 === tmp0_other_with_cast.surfaceId1))
      return false;
    if (!(this.surfaceId2 === tmp0_other_with_cast.surfaceId2))
      return false;
    if (!this.point1.equals(tmp0_other_with_cast.point1))
      return false;
    if (!this.point2.equals(tmp0_other_with_cast.point2))
      return false;
    return true;
  };
  function Companion_73() {
    Companion_instance_106 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g3k_1 = [null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().u7(), StringSerializer_getInstance()), new ReferenceArraySerializer(PrimitiveClasses_getInstance().u7(), StringSerializer_getInstance())];
  }
  protoOf(Companion_73).l17 = function () {
    return $serializer_getInstance_5();
  };
  var Companion_instance_106;
  function Companion_getInstance_82() {
    if (Companion_instance_106 == null)
      new Companion_73();
    return Companion_instance_106;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.CoreRoomVertex', this, 4);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('p', false);
    tmp0_serialDesc.cv('s', false);
    tmp0_serialDesc.cv('e', false);
    this.h3k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ok = function () {
    return this.h3k_1;
  };
  protoOf($serializer_3).rv = function () {
    var tmp0_cached = Companion_getInstance_82().g3k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance(), tmp0_cached[2], tmp0_cached[3]];
  };
  protoOf($serializer_3).qk = function (decoder) {
    var tmp0_desc = this.h3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.nn(tmp0_desc);
    var tmp9_cached = Companion_getInstance_82().g3k_1;
    if (tmp8_input.do()) {
      tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zn(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zn(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zn(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zn(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zn(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zn(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.on(tmp0_desc);
    return CoreRoomVertex_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_3).i3k = function (encoder, value) {
    var tmp0_desc = this.h3k_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    var tmp2_cached = Companion_getInstance_82().g3k_1;
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance(), value.point);
    tmp1_output.ep(tmp0_desc, 2, tmp2_cached[2], value.surfaces);
    tmp1_output.ep(tmp0_desc, 3, tmp2_cached[3], value.edges);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_3).pk = function (encoder, value) {
    return this.i3k(encoder, value instanceof CoreRoomVertex ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_5() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function CoreRoomVertex_init_$Init$(seen1, id, point, surfaces, edges, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_5().h3k_1);
    }
    $this.id = id;
    $this.point = point;
    $this.surfaces = surfaces;
    $this.edges = edges;
    return $this;
  }
  function CoreRoomVertex_init_$Create$(seen1, id, point, surfaces, edges, serializationConstructorMarker) {
    return CoreRoomVertex_init_$Init$(seen1, id, point, surfaces, edges, serializationConstructorMarker, objectCreate(protoOf(CoreRoomVertex)));
  }
  function CoreRoomVertex(id, point, surfaces, edges) {
    Companion_getInstance_82();
    this.id = id;
    this.point = point;
    this.surfaces = surfaces;
    this.edges = edges;
  }
  protoOf(CoreRoomVertex).s1k = function () {
    return this.id;
  };
  protoOf(CoreRoomVertex).g24 = function () {
    return this.point;
  };
  protoOf(CoreRoomVertex).l23 = function () {
    return this.surfaces;
  };
  protoOf(CoreRoomVertex).n3j = function () {
    return this.edges;
  };
  protoOf(CoreRoomVertex).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof CoreRoomVertex))
      THROW_CCE();
    if (!(this.id === other.id))
      return false;
    if (!this.point.equals(other.point))
      return false;
    if (!contentEquals(this.surfaces, other.surfaces))
      return false;
    if (!contentEquals(this.edges, other.edges))
      return false;
    return true;
  };
  protoOf(CoreRoomVertex).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(31, result) + this.point.hashCode() | 0;
    result = imul(31, result) + contentHashCode(this.surfaces) | 0;
    result = imul(31, result) + contentHashCode(this.edges) | 0;
    return result;
  };
  protoOf(CoreRoomVertex).af = function () {
    return this.id;
  };
  protoOf(CoreRoomVertex).bf = function () {
    return this.point;
  };
  protoOf(CoreRoomVertex).g1k = function () {
    return this.surfaces;
  };
  protoOf(CoreRoomVertex).h1k = function () {
    return this.edges;
  };
  protoOf(CoreRoomVertex).j3k = function (id, point, surfaces, edges) {
    return new CoreRoomVertex(id, point, surfaces, edges);
  };
  protoOf(CoreRoomVertex).copy = function (id, point, surfaces, edges, $super) {
    id = id === VOID ? this.id : id;
    point = point === VOID ? this.point : point;
    surfaces = surfaces === VOID ? this.surfaces : surfaces;
    edges = edges === VOID ? this.edges : edges;
    return this.j3k(id, point, surfaces, edges);
  };
  protoOf(CoreRoomVertex).toString = function () {
    return 'CoreRoomVertex(id=' + this.id + ', point=' + this.point + ', surfaces=' + toString(this.surfaces) + ', edges=' + toString(this.edges) + ')';
  };
  function Companion_74() {
  }
  protoOf(Companion_74).l17 = function () {
    return $serializer_getInstance_6();
  };
  var Companion_instance_107;
  function Companion_getInstance_83() {
    return Companion_instance_107;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.CoreRoomObstacle', this, 3);
    tmp0_serialDesc.cv('id', false);
    tmp0_serialDesc.cv('t', false);
    tmp0_serialDesc.cv('b', false);
    this.k3k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ok = function () {
    return this.k3k_1;
  };
  protoOf($serializer_4).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_7()];
  };
  protoOf($serializer_4).qk = function (decoder) {
    var tmp0_desc = this.k3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, $serializer_getInstance_7(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xn(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zn(tmp0_desc, 2, $serializer_getInstance_7(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return CoreRoomObstacle_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_4).l3k = function (encoder, value) {
    var tmp0_desc = this.k3k_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.cp(tmp0_desc, 0, value.id);
    tmp1_output.cp(tmp0_desc, 1, value.type);
    tmp1_output.ep(tmp0_desc, 2, $serializer_getInstance_7(), value.boundingBox);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_4).pk = function (encoder, value) {
    return this.l3k(encoder, value instanceof CoreRoomObstacle ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_6() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function CoreRoomObstacle_init_$Init$(seen1, id, type, boundingBox, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_6().k3k_1);
    }
    $this.id = id;
    $this.type = type;
    $this.boundingBox = boundingBox;
    return $this;
  }
  function CoreRoomObstacle_init_$Create$(seen1, id, type, boundingBox, serializationConstructorMarker) {
    return CoreRoomObstacle_init_$Init$(seen1, id, type, boundingBox, serializationConstructorMarker, objectCreate(protoOf(CoreRoomObstacle)));
  }
  function CoreRoomObstacle(id, type, boundingBox) {
    this.id = id;
    this.type = type;
    this.boundingBox = boundingBox;
  }
  protoOf(CoreRoomObstacle).s1k = function () {
    return this.id;
  };
  protoOf(CoreRoomObstacle).a1x = function () {
    return this.type;
  };
  protoOf(CoreRoomObstacle).m3k = function () {
    return this.boundingBox;
  };
  protoOf(CoreRoomObstacle).af = function () {
    return this.id;
  };
  protoOf(CoreRoomObstacle).bf = function () {
    return this.type;
  };
  protoOf(CoreRoomObstacle).g1k = function () {
    return this.boundingBox;
  };
  protoOf(CoreRoomObstacle).n3k = function (id, type, boundingBox) {
    return new CoreRoomObstacle(id, type, boundingBox);
  };
  protoOf(CoreRoomObstacle).copy = function (id, type, boundingBox, $super) {
    id = id === VOID ? this.id : id;
    type = type === VOID ? this.type : type;
    boundingBox = boundingBox === VOID ? this.boundingBox : boundingBox;
    return this.n3k(id, type, boundingBox);
  };
  protoOf(CoreRoomObstacle).toString = function () {
    return 'CoreRoomObstacle(id=' + this.id + ', type=' + this.type + ', boundingBox=' + this.boundingBox + ')';
  };
  protoOf(CoreRoomObstacle).hashCode = function () {
    var result = getStringHashCode(this.id);
    result = imul(result, 31) + getStringHashCode(this.type) | 0;
    result = imul(result, 31) + this.boundingBox.hashCode() | 0;
    return result;
  };
  protoOf(CoreRoomObstacle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CoreRoomObstacle))
      return false;
    var tmp0_other_with_cast = other instanceof CoreRoomObstacle ? other : THROW_CCE();
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    if (!(this.type === tmp0_other_with_cast.type))
      return false;
    if (!this.boundingBox.equals(tmp0_other_with_cast.boundingBox))
      return false;
    return true;
  };
  function Companion_75() {
  }
  protoOf(Companion_75).l17 = function () {
    return $serializer_getInstance_7();
  };
  var Companion_instance_108;
  function Companion_getInstance_84() {
    return Companion_instance_108;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.CoreRoomBoundingBox', this, 2);
    tmp0_serialDesc.cv('s', false);
    tmp0_serialDesc.cv('t', false);
    this.o3k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ok = function () {
    return this.o3k_1;
  };
  protoOf($serializer_5).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), $serializer_getInstance_0()];
  };
  protoOf($serializer_5).qk = function (decoder) {
    var tmp0_desc = this.o3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zn(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return CoreRoomBoundingBox_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).p3k = function (encoder, value) {
    var tmp0_desc = this.o3k_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ep(tmp0_desc, 0, $serializer_getInstance(), value.size);
    tmp1_output.ep(tmp0_desc, 1, $serializer_getInstance_0(), value.transform);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_5).pk = function (encoder, value) {
    return this.p3k(encoder, value instanceof CoreRoomBoundingBox ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_7() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function CoreRoomBoundingBox_init_$Init$(seen1, size, transform, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_7().o3k_1);
    }
    $this.size = size;
    $this.transform = transform;
    return $this;
  }
  function CoreRoomBoundingBox_init_$Create$(seen1, size, transform, serializationConstructorMarker) {
    return CoreRoomBoundingBox_init_$Init$(seen1, size, transform, serializationConstructorMarker, objectCreate(protoOf(CoreRoomBoundingBox)));
  }
  function CoreRoomBoundingBox(size, transform) {
    this.size = size;
    this.transform = transform;
  }
  protoOf(CoreRoomBoundingBox).n = function () {
    return this.size;
  };
  protoOf(CoreRoomBoundingBox).d1x = function () {
    return this.transform;
  };
  protoOf(CoreRoomBoundingBox).af = function () {
    return this.size;
  };
  protoOf(CoreRoomBoundingBox).bf = function () {
    return this.transform;
  };
  protoOf(CoreRoomBoundingBox).q3k = function (size, transform) {
    return new CoreRoomBoundingBox(size, transform);
  };
  protoOf(CoreRoomBoundingBox).copy = function (size, transform, $super) {
    size = size === VOID ? this.size : size;
    transform = transform === VOID ? this.transform : transform;
    return this.q3k(size, transform);
  };
  protoOf(CoreRoomBoundingBox).toString = function () {
    return 'CoreRoomBoundingBox(size=' + this.size + ', transform=' + this.transform + ')';
  };
  protoOf(CoreRoomBoundingBox).hashCode = function () {
    var result = this.size.hashCode();
    result = imul(result, 31) + this.transform.hashCode() | 0;
    return result;
  };
  protoOf(CoreRoomBoundingBox).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CoreRoomBoundingBox))
      return false;
    var tmp0_other_with_cast = other instanceof CoreRoomBoundingBox ? other : THROW_CCE();
    if (!this.size.equals(tmp0_other_with_cast.size))
      return false;
    if (!this.transform.equals(tmp0_other_with_cast.transform))
      return false;
    return true;
  };
  function RoomGeometryData() {
  }
  function RoomSurface() {
  }
  function RoomEdge() {
  }
  function RoomCorner() {
  }
  function RoomObstacle() {
  }
  function RoomPoint3D() {
  }
  function RoomRotation() {
  }
  function RoomBoundingBox() {
  }
  function RoomTransform() {
  }
  function getOrCreateConfigEntity($this) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = $this.entityManager.entities;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.RoomService.getOrCreateConfigEntity.<anonymous>' call
        if (element.hasComponent(75)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var currentEntity = tmp$ret$1;
    var tmp;
    if (!(currentEntity == null)) {
      tmp = currentEntity;
    } else {
      var entity = $this.entityManager.createEntity();
      entity.addComponent(new DisplayNameComponent('RoomService config entity'));
      entity.addComponent(new DisabledRoomConnectorsConfigComponent(emptyList()));
      tmp = entity;
    }
    return tmp;
  }
  function addDisabledConnector($this, keys) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = _get_disabledRoomConnectorsConfigComponent__5usulp($this.w3k_1, $this);
    var tmp0_iterator = keys.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.RoomService.addDisabledConnector.<anonymous>' call
      var tmp0_safe_receiver = accumulator;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.addEnabledConnector(element);
      var tmp;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      accumulator = tmp;
    }
    var tmp0_elvis_lhs = accumulator;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var newValue = tmp_0;
    $this.w3k_1.addComponent(newValue);
  }
  function removeDisabledConnector($this, keys) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = _get_disabledRoomConnectorsConfigComponent__5usulp($this.w3k_1, $this);
    var tmp0_iterator = keys.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.RoomService.removeDisabledConnector.<anonymous>' call
      var tmp0_safe_receiver = accumulator;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.removeEnabledConnector(element);
      var tmp;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      accumulator = tmp;
    }
    var tmp0_elvis_lhs = accumulator;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var newValue = tmp_0;
    $this.w3k_1.addComponent(newValue);
  }
  function generateDisabledConnectorsComponent($this, room) {
    var tmp0_elvis_lhs = _get_disabledRoomConnectorsConfigComponent__5usulp($this.w3k_1, $this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var disabledRoomConnectorsComponent = tmp;
    var tmp2_elvis_lhs = room == null ? $this.getRoom() : room;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var actualRoom = tmp_0;
    var tmp3_safe_receiver = get_connectorsComponent(actualRoom);
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.connectors;
    var tmp_1;
    if (tmp4_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp4_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp4_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.RoomService.generateDisabledConnectorsComponent.<anonymous>' call
        if (disabledRoomConnectorsComponent.connectorKeys.p(element.key)) {
          destination.q(element);
        }
      }
      tmp_1 = destination;
    }
    var tmp5_safe_receiver = tmp_1;
    var tmp_2;
    if (tmp5_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp5_safe_receiver, 10));
      var tmp0_iterator = tmp5_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var item = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.room.RoomService.generateDisabledConnectorsComponent.<anonymous>' call
        var tmp$ret$3 = item.key;
        destination_0.q(tmp$ret$3);
      }
      tmp_2 = destination_0;
    }
    var tmp6_elvis_lhs = tmp_2;
    var disabledRoomConnectors = tmp6_elvis_lhs == null ? emptyList() : tmp6_elvis_lhs;
    var tmp_3;
    if (any(disabledRoomConnectors)) {
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$6 = copyToArray(disabledRoomConnectors);
      tmp_3 = new DisabledConnectorsComponent(tmp$ret$6);
    } else {
      tmp_3 = null;
    }
    return tmp_3;
  }
  function generateDisabledConnectorsComponent$default($this, room, $super) {
    room = room === VOID ? null : room;
    return generateDisabledConnectorsComponent($this, room);
  }
  function _get_disabledRoomConnectorsConfigComponent__5usulp(_this__u8e3s4, $this) {
    return _this__u8e3s4.__getComponentForKotlin(75);
  }
  function RoomService$getRoom$lambda(it) {
    return it.hasComponent(RoomComponent_instance.id);
  }
  function RoomService(entityManager, sceneManager) {
    this.entityManager = entityManager;
    this.sceneManager = sceneManager;
    this.w3k_1 = getOrCreateConfigEntity(this);
  }
  protoOf(RoomService).p1i = function () {
    return this.entityManager;
  };
  protoOf(RoomService).q1i = function () {
    return this.sceneManager;
  };
  protoOf(RoomService).getRoom = function () {
    var tmp = this.sceneManager.root;
    return findInHierarchy(tmp, RoomService$getRoom$lambda);
  };
  protoOf(RoomService).createOrUpdateRectangularRoom = function (dimensions) {
    var oldRoom = this.getRoom();
    var tmp;
    if (oldRoom == null) {
      var room = this.entityManager.createEntity();
      tmp = room;
    } else {
      tmp = oldRoom;
    }
    var room_0 = tmp;
    var coreRoomGeometryData = Companion_getInstance_95().generateRectangularRoom(dimensions);
    this.entityManager.addComponent(room_0, new RoomGeometryComponent(coreRoomGeometryData));
    setParent(room_0, this.sceneManager.scene);
    return room_0;
  };
  protoOf(RoomService).y3k = function (roomGeometryData, scale) {
    var tmp0_elvis_lhs = Companion_getInstance_95().interfaceFormatToInternalFormat(roomGeometryData, scale);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coreRoomGeometryData = tmp;
    var oldRoom = this.getRoom();
    var tmp_0;
    if (oldRoom == null) {
      var room = this.entityManager.createEntity();
      tmp_0 = room;
    } else {
      tmp_0 = oldRoom;
    }
    var room_0 = tmp_0;
    this.entityManager.addComponent(room_0, new RoomGeometryComponent(coreRoomGeometryData));
    setParent(room_0, this.sceneManager.scene);
    return room_0;
  };
  protoOf(RoomService).createOrUpdateRoomFromGeometry = function (roomGeometryData, scale, $super) {
    scale = scale === VOID ? 1000.0 : scale;
    return this.y3k(roomGeometryData, scale);
  };
  protoOf(RoomService).enableFloorConnectors = function () {
    var tmp0_safe_receiver = this.getRoom();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_connectorsComponent(tmp0_safe_receiver);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.connectors;
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.RoomService.enableFloorConnectors.<anonymous>' call
        RoomConnectorConstants_getInstance();
        if (element.isOffering('floor')) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var tmp3_elvis_lhs = tmp;
    var tmp_0;
    if (tmp3_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp3_elvis_lhs;
    }
    var floorConnectors = tmp_0;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(floorConnectors, 10));
    var tmp0_iterator = floorConnectors.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.RoomService.enableFloorConnectors.<anonymous>' call
      var tmp$ret$3 = item.key;
      destination_0.q(tmp$ret$3);
    }
    removeDisabledConnector(this, destination_0);
    this.applyDisabledConnectorsConfigToRoom();
  };
  protoOf(RoomService).disableFloorConnectors = function () {
    var tmp0_safe_receiver = this.getRoom();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_connectorsComponent(tmp0_safe_receiver);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.connectors;
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.find' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var inductionVariable = 0;
        var last = tmp2_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp2_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.room.RoomService.disableFloorConnectors.<anonymous>' call
          RoomConnectorConstants_getInstance();
          if (element.isOffering('floor')) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    var tmp3_elvis_lhs = tmp;
    var tmp_0;
    if (tmp3_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp3_elvis_lhs;
    }
    var floorConnector = tmp_0;
    addDisabledConnector(this, listOf(floorConnector.key));
    this.applyDisabledConnectorsConfigToRoom();
  };
  protoOf(RoomService).setEnabledStateForRoomConnector = function (connectorKey, enabled) {
    if (enabled) {
      removeDisabledConnector(this, listOf(connectorKey));
    } else {
      addDisabledConnector(this, listOf(connectorKey));
    }
    this.applyDisabledConnectorsConfigToRoom();
  };
  protoOf(RoomService).enableAllRoomConnectors = function () {
    this.w3k_1.addComponent(new DisabledRoomConnectorsConfigComponent(emptyList()));
    this.applyDisabledConnectorsConfigToRoom();
  };
  protoOf(RoomService).disableAllRoomConnectors = function () {
    var tmp0_safe_receiver = this.getRoom();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_connectorsComponent(tmp0_safe_receiver);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.connectors;
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(tmp2_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.RoomService.disableAllRoomConnectors.<anonymous>' call
        var tmp$ret$0 = item.key;
        destination.q(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp3_elvis_lhs = tmp;
    var allConnectors = tmp3_elvis_lhs == null ? emptyList() : tmp3_elvis_lhs;
    this.w3k_1.addComponent(new DisabledRoomConnectorsConfigComponent(allConnectors));
    this.applyDisabledConnectorsConfigToRoom();
  };
  protoOf(RoomService).roomSurfaceConnectorsWithNormal = function (normal) {
    var tmp0_elvis_lhs = this.getRoom();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var room = tmp;
    var normalizedNormal = normal.normalize();
    var tmp1_safe_receiver = get_connectorsComponent(room);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.connectors;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.room.RoomService.roomSurfaceConnectorsWithNormal.<anonymous>' call
        var tmp0_safe_receiver = element instanceof SurfaceConnector ? element : null;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver);
        }
      }
      tmp_0 = destination;
    }
    var tmp3_safe_receiver = tmp_0;
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var tmp0_iterator = tmp3_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.room.RoomService.roomSurfaceConnectorsWithNormal.<anonymous>' call
        var surfaceNormal = element_0.plane.normal.normalize();
        if (surfaceNormal.equals(normalizedNormal)) {
          destination_0.q(element_0);
        }
      }
      tmp_1 = destination_0;
    }
    var tmp4_safe_receiver = tmp_1;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_2 = copyToArray(tmp4_safe_receiver);
    }
    var tmp5_elvis_lhs = tmp_2;
    var tmp_3;
    if (tmp5_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_3 = [];
    } else {
      tmp_3 = tmp5_elvis_lhs;
    }
    return tmp_3;
  };
  protoOf(RoomService).roomConnectorsForSurface = function (surfaceConnector) {
    var tmp0_elvis_lhs = this.getRoom();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var room = tmp;
    var tmp1_elvis_lhs = room.__getComponentForKotlin(76);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var roomConnectorRelations = tmp_0;
    var tmp2_safe_receiver = get_connectorsComponent(room);
    return roomConnectorRelations.connectorsForSurface(surfaceConnector, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.connectors);
  };
  protoOf(RoomService).z3k = function (room) {
    var safeRoom = room == null ? this.getRoom() : room;
    var disabledConnectorsComponent = generateDisabledConnectorsComponent(this, safeRoom);
    if (disabledConnectorsComponent == null) {
      if (safeRoom == null)
        null;
      else {
        safeRoom.removeComponent(71);
      }
    } else {
      var tmp;
      if (safeRoom == null) {
        tmp = null;
      } else {
        tmp = safeRoom.__getComponentForKotlin(71);
      }
      if (!(tmp == null)) {
        safeRoom.removeComponent(71);
      }
      if (safeRoom == null)
        null;
      else
        safeRoom.addComponent(disabledConnectorsComponent);
    }
  };
  protoOf(RoomService).applyDisabledConnectorsConfigToRoom = function (room, $super) {
    room = room === VOID ? null : room;
    return this.z3k(room);
  };
  function Companion_76() {
    this.id = 75;
  }
  protoOf(Companion_76).s1k = function () {
    return this.id;
  };
  var Companion_instance_109;
  function Companion_getInstance_85() {
    return Companion_instance_109;
  }
  function DisabledRoomConnectorsConfigComponent(connectorKeys) {
    this.connectorKeys = connectorKeys;
    this.x3k_1 = 75;
  }
  protoOf(DisabledRoomConnectorsConfigComponent).x1k = function () {
    return this.x3k_1;
  };
  protoOf(DisabledRoomConnectorsConfigComponent).eq = function (other) {
    return (other instanceof DisabledRoomConnectorsConfigComponent ? other : THROW_CCE()).equals(this);
  };
  protoOf(DisabledRoomConnectorsConfigComponent).addEnabledConnector = function (key) {
    var tmp;
    if (this.connectorKeys.p(key)) {
      tmp = this;
    } else {
      tmp = this.copy(plus_2(this.connectorKeys, key));
    }
    return tmp;
  };
  protoOf(DisabledRoomConnectorsConfigComponent).removeEnabledConnector = function (key) {
    var tmp;
    if (this.connectorKeys.p(key)) {
      tmp = this.copy(minus_0(this.connectorKeys, key));
    } else {
      tmp = this;
    }
    return tmp;
  };
  protoOf(DisabledRoomConnectorsConfigComponent).a3l = function (connectorKeys) {
    return new DisabledRoomConnectorsConfigComponent(connectorKeys);
  };
  protoOf(DisabledRoomConnectorsConfigComponent).copy = function (connectorKeys, $super) {
    connectorKeys = connectorKeys === VOID ? this.connectorKeys : connectorKeys;
    return this.a3l(connectorKeys);
  };
  protoOf(DisabledRoomConnectorsConfigComponent).toString = function () {
    return 'DisabledRoomConnectorsConfigComponent(connectorKeys=' + this.connectorKeys + ')';
  };
  protoOf(DisabledRoomConnectorsConfigComponent).hashCode = function () {
    return hashCode(this.connectorKeys);
  };
  protoOf(DisabledRoomConnectorsConfigComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DisabledRoomConnectorsConfigComponent))
      return false;
    var tmp0_other_with_cast = other instanceof DisabledRoomConnectorsConfigComponent ? other : THROW_CCE();
    if (!equals(this.connectorKeys, tmp0_other_with_cast.connectorKeys))
      return false;
    return true;
  };
  function RoomComponent() {
  }
  protoOf(RoomComponent).x1k = function () {
    return this.id;
  };
  protoOf(RoomComponent).s1k = function () {
    return 53;
  };
  protoOf(RoomComponent).eq = function (other) {
    return true;
  };
  var RoomComponent_instance;
  function RoomComponent_getInstance() {
    return RoomComponent_instance;
  }
  function get_isRoom(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(RoomComponent_instance.id);
  }
  function filterConnectors($this, connectors, keys) {
    var tmp;
    if (connectors == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = connectors.length;
      while (inductionVariable < last) {
        var element = connectors[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.component.RoomConnectorRelationsComponent.filterConnectors.<anonymous>' call
        if ((keys == null ? null : contains(keys, element.key)) === true) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = tmp1_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.room.component.RoomConnectorRelationsComponent.filterConnectors.<anonymous>' call
        var tmp0_safe_receiver = element_0 instanceof Connector ? element_0 : null;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_0.q(tmp0_safe_receiver);
        }
      }
      tmp_0 = destination_0;
    }
    var tmp2_elvis_lhs = tmp_0;
    return tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
  }
  function Companion_77() {
    this.id = 76;
  }
  protoOf(Companion_77).s1k = function () {
    return this.id;
  };
  var Companion_instance_110;
  function Companion_getInstance_86() {
    return Companion_instance_110;
  }
  function RoomConnectorRelationsComponent(connectorsFromSurfaceKey, connectorsFromEdgeKey, connectorsFromCornerKey) {
    this.b3l_1 = connectorsFromSurfaceKey;
    this.c3l_1 = connectorsFromEdgeKey;
    this.d3l_1 = connectorsFromCornerKey;
  }
  protoOf(RoomConnectorRelationsComponent).x1k = function () {
    return 76;
  };
  protoOf(RoomConnectorRelationsComponent).eq = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomConnectorRelationsComponent))
      THROW_CCE();
    if (!equals(this.b3l_1, other.b3l_1))
      return false;
    if (!equals(this.c3l_1, other.c3l_1))
      return false;
    if (!equals(this.d3l_1, other.d3l_1))
      return false;
    return true;
  };
  protoOf(RoomConnectorRelationsComponent).connectorKeysForSurface = function (connectorKey) {
    return this.b3l_1.b3(connectorKey);
  };
  protoOf(RoomConnectorRelationsComponent).connectorsForSurface = function (connector, roomConnectors) {
    var relatedToSurface = this.connectorKeysForSurface(connector.p22_1);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = filterConnectors(this, roomConnectors, relatedToSurface == null ? null : relatedToSurface.edgeKeys);
    var edges = copyToArray(this_0);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = filterConnectors(this, roomConnectors, relatedToSurface == null ? null : relatedToSurface.cornerKeys);
    var corners = copyToArray(this_1);
    return new RoomConnectorsForSurface(connector, edges, corners);
  };
  protoOf(RoomConnectorRelationsComponent).connectorKeysForEdge = function (connectorKey) {
    return this.c3l_1.b3(connectorKey);
  };
  protoOf(RoomConnectorRelationsComponent).connectorsForEdge = function (connector, roomConnectors) {
    var relatedToEdge = this.connectorKeysForEdge(connector.y1y_1);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = filterConnectors(this, roomConnectors, relatedToEdge == null ? null : relatedToEdge.surfaceKeys);
    var surfaces = copyToArray(this_0);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = filterConnectors(this, roomConnectors, relatedToEdge == null ? null : relatedToEdge.cornerKeys);
    var corners = copyToArray(this_1);
    return new RoomConnectorsForEdge(connector, corners, surfaces);
  };
  protoOf(RoomConnectorRelationsComponent).connectorKeysForCorner = function (connectorKey) {
    return this.d3l_1.b3(connectorKey);
  };
  protoOf(RoomConnectorRelationsComponent).connectorsForCorner = function (connector, roomConnectors) {
    var relatedToCorner = this.connectorKeysForCorner(connector.b20_1);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = filterConnectors(this, roomConnectors, relatedToCorner == null ? null : relatedToCorner.edgeKeys);
    var edges = copyToArray(this_0);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = filterConnectors(this, roomConnectors, relatedToCorner == null ? null : relatedToCorner.surfaceKeys);
    var surfaces = copyToArray(this_1);
    return new RoomConnectorsForCorner(connector, edges, surfaces);
  };
  function RoomConnectorKeysForSurface(surfaceKey, edgeKeys, cornerKeys) {
    this.surfaceKey = surfaceKey;
    this.edgeKeys = edgeKeys;
    this.cornerKeys = cornerKeys;
  }
  protoOf(RoomConnectorKeysForSurface).e3l = function () {
    return this.surfaceKey;
  };
  protoOf(RoomConnectorKeysForSurface).f3l = function () {
    return this.edgeKeys;
  };
  protoOf(RoomConnectorKeysForSurface).g3l = function () {
    return this.cornerKeys;
  };
  protoOf(RoomConnectorKeysForSurface).af = function () {
    return this.surfaceKey;
  };
  protoOf(RoomConnectorKeysForSurface).bf = function () {
    return this.edgeKeys;
  };
  protoOf(RoomConnectorKeysForSurface).g1k = function () {
    return this.cornerKeys;
  };
  protoOf(RoomConnectorKeysForSurface).h3l = function (surfaceKey, edgeKeys, cornerKeys) {
    return new RoomConnectorKeysForSurface(surfaceKey, edgeKeys, cornerKeys);
  };
  protoOf(RoomConnectorKeysForSurface).copy = function (surfaceKey, edgeKeys, cornerKeys, $super) {
    surfaceKey = surfaceKey === VOID ? this.surfaceKey : surfaceKey;
    edgeKeys = edgeKeys === VOID ? this.edgeKeys : edgeKeys;
    cornerKeys = cornerKeys === VOID ? this.cornerKeys : cornerKeys;
    return this.h3l(surfaceKey, edgeKeys, cornerKeys);
  };
  protoOf(RoomConnectorKeysForSurface).toString = function () {
    return 'RoomConnectorKeysForSurface(surfaceKey=' + this.surfaceKey + ', edgeKeys=' + toString(this.edgeKeys) + ', cornerKeys=' + toString(this.cornerKeys) + ')';
  };
  protoOf(RoomConnectorKeysForSurface).hashCode = function () {
    var result = getStringHashCode(this.surfaceKey);
    result = imul(result, 31) + hashCode(this.edgeKeys) | 0;
    result = imul(result, 31) + hashCode(this.cornerKeys) | 0;
    return result;
  };
  protoOf(RoomConnectorKeysForSurface).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomConnectorKeysForSurface))
      return false;
    var tmp0_other_with_cast = other instanceof RoomConnectorKeysForSurface ? other : THROW_CCE();
    if (!(this.surfaceKey === tmp0_other_with_cast.surfaceKey))
      return false;
    if (!equals(this.edgeKeys, tmp0_other_with_cast.edgeKeys))
      return false;
    if (!equals(this.cornerKeys, tmp0_other_with_cast.cornerKeys))
      return false;
    return true;
  };
  function RoomConnectorKeysForEdge(edgeKey, cornerKeys, surfaceKeys) {
    this.edgeKey = edgeKey;
    this.cornerKeys = cornerKeys;
    this.surfaceKeys = surfaceKeys;
  }
  protoOf(RoomConnectorKeysForEdge).i3l = function () {
    return this.edgeKey;
  };
  protoOf(RoomConnectorKeysForEdge).g3l = function () {
    return this.cornerKeys;
  };
  protoOf(RoomConnectorKeysForEdge).j3l = function () {
    return this.surfaceKeys;
  };
  protoOf(RoomConnectorKeysForEdge).af = function () {
    return this.edgeKey;
  };
  protoOf(RoomConnectorKeysForEdge).bf = function () {
    return this.cornerKeys;
  };
  protoOf(RoomConnectorKeysForEdge).g1k = function () {
    return this.surfaceKeys;
  };
  protoOf(RoomConnectorKeysForEdge).h3l = function (edgeKey, cornerKeys, surfaceKeys) {
    return new RoomConnectorKeysForEdge(edgeKey, cornerKeys, surfaceKeys);
  };
  protoOf(RoomConnectorKeysForEdge).copy = function (edgeKey, cornerKeys, surfaceKeys, $super) {
    edgeKey = edgeKey === VOID ? this.edgeKey : edgeKey;
    cornerKeys = cornerKeys === VOID ? this.cornerKeys : cornerKeys;
    surfaceKeys = surfaceKeys === VOID ? this.surfaceKeys : surfaceKeys;
    return this.h3l(edgeKey, cornerKeys, surfaceKeys);
  };
  protoOf(RoomConnectorKeysForEdge).toString = function () {
    return 'RoomConnectorKeysForEdge(edgeKey=' + this.edgeKey + ', cornerKeys=' + toString(this.cornerKeys) + ', surfaceKeys=' + toString(this.surfaceKeys) + ')';
  };
  protoOf(RoomConnectorKeysForEdge).hashCode = function () {
    var result = getStringHashCode(this.edgeKey);
    result = imul(result, 31) + hashCode(this.cornerKeys) | 0;
    result = imul(result, 31) + hashCode(this.surfaceKeys) | 0;
    return result;
  };
  protoOf(RoomConnectorKeysForEdge).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomConnectorKeysForEdge))
      return false;
    var tmp0_other_with_cast = other instanceof RoomConnectorKeysForEdge ? other : THROW_CCE();
    if (!(this.edgeKey === tmp0_other_with_cast.edgeKey))
      return false;
    if (!equals(this.cornerKeys, tmp0_other_with_cast.cornerKeys))
      return false;
    if (!equals(this.surfaceKeys, tmp0_other_with_cast.surfaceKeys))
      return false;
    return true;
  };
  function RoomConnectorKeysForCorner(cornerKey, edgeKeys, surfaceKeys) {
    this.cornerKey = cornerKey;
    this.edgeKeys = edgeKeys;
    this.surfaceKeys = surfaceKeys;
  }
  protoOf(RoomConnectorKeysForCorner).k3l = function () {
    return this.cornerKey;
  };
  protoOf(RoomConnectorKeysForCorner).f3l = function () {
    return this.edgeKeys;
  };
  protoOf(RoomConnectorKeysForCorner).j3l = function () {
    return this.surfaceKeys;
  };
  protoOf(RoomConnectorKeysForCorner).af = function () {
    return this.cornerKey;
  };
  protoOf(RoomConnectorKeysForCorner).bf = function () {
    return this.edgeKeys;
  };
  protoOf(RoomConnectorKeysForCorner).g1k = function () {
    return this.surfaceKeys;
  };
  protoOf(RoomConnectorKeysForCorner).h3l = function (cornerKey, edgeKeys, surfaceKeys) {
    return new RoomConnectorKeysForCorner(cornerKey, edgeKeys, surfaceKeys);
  };
  protoOf(RoomConnectorKeysForCorner).copy = function (cornerKey, edgeKeys, surfaceKeys, $super) {
    cornerKey = cornerKey === VOID ? this.cornerKey : cornerKey;
    edgeKeys = edgeKeys === VOID ? this.edgeKeys : edgeKeys;
    surfaceKeys = surfaceKeys === VOID ? this.surfaceKeys : surfaceKeys;
    return this.h3l(cornerKey, edgeKeys, surfaceKeys);
  };
  protoOf(RoomConnectorKeysForCorner).toString = function () {
    return 'RoomConnectorKeysForCorner(cornerKey=' + this.cornerKey + ', edgeKeys=' + toString(this.edgeKeys) + ', surfaceKeys=' + toString(this.surfaceKeys) + ')';
  };
  protoOf(RoomConnectorKeysForCorner).hashCode = function () {
    var result = getStringHashCode(this.cornerKey);
    result = imul(result, 31) + hashCode(this.edgeKeys) | 0;
    result = imul(result, 31) + hashCode(this.surfaceKeys) | 0;
    return result;
  };
  protoOf(RoomConnectorKeysForCorner).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomConnectorKeysForCorner))
      return false;
    var tmp0_other_with_cast = other instanceof RoomConnectorKeysForCorner ? other : THROW_CCE();
    if (!(this.cornerKey === tmp0_other_with_cast.cornerKey))
      return false;
    if (!equals(this.edgeKeys, tmp0_other_with_cast.edgeKeys))
      return false;
    if (!equals(this.surfaceKeys, tmp0_other_with_cast.surfaceKeys))
      return false;
    return true;
  };
  function RoomConnectorsForSurface(surface, edges, corners) {
    this.surface = surface;
    this.edges = edges;
    this.corners = corners;
  }
  protoOf(RoomConnectorsForSurface).o23 = function () {
    return this.surface;
  };
  protoOf(RoomConnectorsForSurface).n3j = function () {
    return this.edges;
  };
  protoOf(RoomConnectorsForSurface).r3k = function () {
    return this.corners;
  };
  protoOf(RoomConnectorsForSurface).af = function () {
    return this.surface;
  };
  protoOf(RoomConnectorsForSurface).bf = function () {
    return this.edges;
  };
  protoOf(RoomConnectorsForSurface).g1k = function () {
    return this.corners;
  };
  protoOf(RoomConnectorsForSurface).l3l = function (surface, edges, corners) {
    return new RoomConnectorsForSurface(surface, edges, corners);
  };
  protoOf(RoomConnectorsForSurface).copy = function (surface, edges, corners, $super) {
    surface = surface === VOID ? this.surface : surface;
    edges = edges === VOID ? this.edges : edges;
    corners = corners === VOID ? this.corners : corners;
    return this.l3l(surface, edges, corners);
  };
  protoOf(RoomConnectorsForSurface).toString = function () {
    return 'RoomConnectorsForSurface(surface=' + this.surface + ', edges=' + toString(this.edges) + ', corners=' + toString(this.corners) + ')';
  };
  protoOf(RoomConnectorsForSurface).hashCode = function () {
    var result = this.surface.hashCode();
    result = imul(result, 31) + hashCode(this.edges) | 0;
    result = imul(result, 31) + hashCode(this.corners) | 0;
    return result;
  };
  protoOf(RoomConnectorsForSurface).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomConnectorsForSurface))
      return false;
    var tmp0_other_with_cast = other instanceof RoomConnectorsForSurface ? other : THROW_CCE();
    if (!this.surface.equals(tmp0_other_with_cast.surface))
      return false;
    if (!equals(this.edges, tmp0_other_with_cast.edges))
      return false;
    if (!equals(this.corners, tmp0_other_with_cast.corners))
      return false;
    return true;
  };
  function RoomConnectorsForEdge(edge, corners, surfaces) {
    this.edge = edge;
    this.corners = corners;
    this.surfaces = surfaces;
  }
  protoOf(RoomConnectorsForEdge).m3l = function () {
    return this.edge;
  };
  protoOf(RoomConnectorsForEdge).r3k = function () {
    return this.corners;
  };
  protoOf(RoomConnectorsForEdge).l23 = function () {
    return this.surfaces;
  };
  protoOf(RoomConnectorsForEdge).af = function () {
    return this.edge;
  };
  protoOf(RoomConnectorsForEdge).bf = function () {
    return this.corners;
  };
  protoOf(RoomConnectorsForEdge).g1k = function () {
    return this.surfaces;
  };
  protoOf(RoomConnectorsForEdge).n3l = function (edge, corners, surfaces) {
    return new RoomConnectorsForEdge(edge, corners, surfaces);
  };
  protoOf(RoomConnectorsForEdge).copy = function (edge, corners, surfaces, $super) {
    edge = edge === VOID ? this.edge : edge;
    corners = corners === VOID ? this.corners : corners;
    surfaces = surfaces === VOID ? this.surfaces : surfaces;
    return this.n3l(edge, corners, surfaces);
  };
  protoOf(RoomConnectorsForEdge).toString = function () {
    return 'RoomConnectorsForEdge(edge=' + this.edge + ', corners=' + toString(this.corners) + ', surfaces=' + toString(this.surfaces) + ')';
  };
  protoOf(RoomConnectorsForEdge).hashCode = function () {
    var result = this.edge.hashCode();
    result = imul(result, 31) + hashCode(this.corners) | 0;
    result = imul(result, 31) + hashCode(this.surfaces) | 0;
    return result;
  };
  protoOf(RoomConnectorsForEdge).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomConnectorsForEdge))
      return false;
    var tmp0_other_with_cast = other instanceof RoomConnectorsForEdge ? other : THROW_CCE();
    if (!this.edge.equals(tmp0_other_with_cast.edge))
      return false;
    if (!equals(this.corners, tmp0_other_with_cast.corners))
      return false;
    if (!equals(this.surfaces, tmp0_other_with_cast.surfaces))
      return false;
    return true;
  };
  function RoomConnectorsForCorner(corner, edges, surfaces) {
    this.corner = corner;
    this.edges = edges;
    this.surfaces = surfaces;
  }
  protoOf(RoomConnectorsForCorner).o3l = function () {
    return this.corner;
  };
  protoOf(RoomConnectorsForCorner).n3j = function () {
    return this.edges;
  };
  protoOf(RoomConnectorsForCorner).l23 = function () {
    return this.surfaces;
  };
  protoOf(RoomConnectorsForCorner).af = function () {
    return this.corner;
  };
  protoOf(RoomConnectorsForCorner).bf = function () {
    return this.edges;
  };
  protoOf(RoomConnectorsForCorner).g1k = function () {
    return this.surfaces;
  };
  protoOf(RoomConnectorsForCorner).p3l = function (corner, edges, surfaces) {
    return new RoomConnectorsForCorner(corner, edges, surfaces);
  };
  protoOf(RoomConnectorsForCorner).copy = function (corner, edges, surfaces, $super) {
    corner = corner === VOID ? this.corner : corner;
    edges = edges === VOID ? this.edges : edges;
    surfaces = surfaces === VOID ? this.surfaces : surfaces;
    return this.p3l(corner, edges, surfaces);
  };
  protoOf(RoomConnectorsForCorner).toString = function () {
    return 'RoomConnectorsForCorner(corner=' + this.corner + ', edges=' + toString(this.edges) + ', surfaces=' + toString(this.surfaces) + ')';
  };
  protoOf(RoomConnectorsForCorner).hashCode = function () {
    var result = this.corner.hashCode();
    result = imul(result, 31) + hashCode(this.edges) | 0;
    result = imul(result, 31) + hashCode(this.surfaces) | 0;
    return result;
  };
  protoOf(RoomConnectorsForCorner).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomConnectorsForCorner))
      return false;
    var tmp0_other_with_cast = other instanceof RoomConnectorsForCorner ? other : THROW_CCE();
    if (!this.corner.equals(tmp0_other_with_cast.corner))
      return false;
    if (!equals(this.edges, tmp0_other_with_cast.edges))
      return false;
    if (!equals(this.surfaces, tmp0_other_with_cast.surfaces))
      return false;
    return true;
  };
  function RoomDimensionsComponent$Companion$serializer$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    return Unit_instance;
  }
  function Companion_78() {
    Companion_instance_111 = this;
    this.id = 41;
    this.serializationKey = 'RoomDimensionsComponent';
    var tmp = this;
    tmp.q3l_1 = Json(VOID, RoomDimensionsComponent$Companion$serializer$lambda);
  }
  protoOf(Companion_78).s1k = function () {
    return this.id;
  };
  protoOf(Companion_78).p1l = function () {
    return this.serializationKey;
  };
  protoOf(Companion_78).fromJson = function (json) {
    return this.q3l_1.l15(this.l17(), json);
  };
  protoOf(Companion_78).l17 = function () {
    return $serializer_getInstance_8();
  };
  var Companion_instance_111;
  function Companion_getInstance_87() {
    if (Companion_instance_111 == null)
      new Companion_78();
    return Companion_instance_111;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.component.RoomDimensionsComponent', this, 2);
    tmp0_serialDesc.cv('d', false);
    tmp0_serialDesc.cv('serializable', true);
    this.r3l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ok = function () {
    return this.r3l_1;
  };
  protoOf($serializer_6).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), BooleanSerializer_getInstance()];
  };
  protoOf($serializer_6).qk = function (decoder) {
    var tmp0_desc = this.r3l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.nn(tmp0_desc);
    if (tmp6_input.do()) {
      tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.pn(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zn(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.pn(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.on(tmp0_desc);
    return RoomDimensionsComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_6).s3l = function (encoder, value) {
    var tmp0_desc = this.r3l_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ep(tmp0_desc, 0, $serializer_getInstance(), value.dimensions);
    if (tmp1_output.kp(tmp0_desc, 1) ? true : !(value.t3l_1 === false)) {
      tmp1_output.uo(tmp0_desc, 1, value.t3l_1);
    }
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_6).pk = function (encoder, value) {
    return this.s3l(encoder, value instanceof RoomDimensionsComponent ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_8() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function RoomDimensionsComponent_init_$Init$(seen1, dimensions, serializable, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_8().r3l_1);
    }
    $this.dimensions = dimensions;
    if (0 === (seen1 & 2))
      $this.t3l_1 = false;
    else
      $this.t3l_1 = serializable;
    return $this;
  }
  function RoomDimensionsComponent_init_$Create$(seen1, dimensions, serializable, serializationConstructorMarker) {
    return RoomDimensionsComponent_init_$Init$(seen1, dimensions, serializable, serializationConstructorMarker, objectCreate(protoOf(RoomDimensionsComponent)));
  }
  function RoomDimensionsComponent(dimensions) {
    Companion_getInstance_87();
    this.dimensions = dimensions;
    this.t3l_1 = false;
  }
  protoOf(RoomDimensionsComponent).u3l = function () {
    return this.dimensions;
  };
  protoOf(RoomDimensionsComponent).x1k = function () {
    return 41;
  };
  protoOf(RoomDimensionsComponent).z1k = function () {
    return this.t3l_1;
  };
  protoOf(RoomDimensionsComponent).toJson = function (parse) {
    return Companion_getInstance_87().q3l_1.k15(Companion_getInstance_87().l17(), this);
  };
  protoOf(RoomDimensionsComponent).toJsonElement = function () {
    return Companion_getInstance_87().q3l_1.k15(Companion_getInstance_87().l17(), this);
  };
  protoOf(RoomDimensionsComponent).serializationKey = function () {
    return 'RoomDimensionsComponent';
  };
  protoOf(RoomDimensionsComponent).eq = function (other) {
    return (other instanceof RoomDimensionsComponent ? other : THROW_CCE()).dimensions.equals(this.dimensions);
  };
  protoOf(RoomDimensionsComponent).af = function () {
    return this.dimensions;
  };
  protoOf(RoomDimensionsComponent).w38 = function (dimensions) {
    return new RoomDimensionsComponent(dimensions);
  };
  protoOf(RoomDimensionsComponent).copy = function (dimensions, $super) {
    dimensions = dimensions === VOID ? this.dimensions : dimensions;
    return this.w38(dimensions);
  };
  protoOf(RoomDimensionsComponent).toString = function () {
    return 'RoomDimensionsComponent(dimensions=' + this.dimensions + ')';
  };
  protoOf(RoomDimensionsComponent).hashCode = function () {
    return this.dimensions.hashCode();
  };
  protoOf(RoomDimensionsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomDimensionsComponent))
      return false;
    var tmp0_other_with_cast = other instanceof RoomDimensionsComponent ? other : THROW_CCE();
    if (!this.dimensions.equals(tmp0_other_with_cast.dimensions))
      return false;
    return true;
  };
  function RoomGeometryComponent$Companion$serializer$lambda($this$Json) {
    $this$Json.f16_1 = false;
    $this$Json.h16_1 = true;
    $this$Json.l16_1 = 'itemType';
    return Unit_instance;
  }
  function Companion_79() {
    Companion_instance_112 = this;
    this.id = 70;
    this.serializationKey = 'RoomGeometry';
    var tmp = this;
    tmp.v3l_1 = Json(VOID, RoomGeometryComponent$Companion$serializer$lambda);
  }
  protoOf(Companion_79).s1k = function () {
    return this.id;
  };
  protoOf(Companion_79).p1l = function () {
    return this.serializationKey;
  };
  protoOf(Companion_79).fromJson = function (json) {
    return this.v3l_1.l15(this.l17(), json);
  };
  protoOf(Companion_79).l17 = function () {
    return $serializer_getInstance_9();
  };
  var Companion_instance_112;
  function Companion_getInstance_88() {
    if (Companion_instance_112 == null)
      new Companion_79();
    return Companion_instance_112;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.core.stl.room.component.RoomGeometryComponent', this, 1);
    tmp0_serialDesc.cv('data', false);
    this.w3l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ok = function () {
    return this.w3l_1;
  };
  protoOf($serializer_7).rv = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1()];
  };
  protoOf($serializer_7).qk = function (decoder) {
    var tmp0_desc = this.w3l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp7_input = decoder.nn(tmp0_desc);
    if (tmp7_input.do()) {
      tmp4_local0 = tmp7_input.zn(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.eo(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.zn(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.on(tmp0_desc);
    return RoomGeometryComponent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_7).x3l = function (encoder, value) {
    var tmp0_desc = this.w3l_1;
    var tmp1_output = encoder.nn(tmp0_desc);
    tmp1_output.ep(tmp0_desc, 0, $serializer_getInstance_1(), value.roomGeometryData);
    tmp1_output.on(tmp0_desc);
  };
  protoOf($serializer_7).pk = function (encoder, value) {
    return this.x3l(encoder, value instanceof RoomGeometryComponent ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_9() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function RoomGeometryComponent_init_$Init$(seen1, roomGeometryData, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_9().w3l_1);
    }
    $this.roomGeometryData = roomGeometryData;
    $this.surfaces = Companion_getInstance_95().generateWallMap($this.roomGeometryData);
    $this.dimensions = Companion_getInstance_92().getDimensions($this.roomGeometryData);
    return $this;
  }
  function RoomGeometryComponent_init_$Create$(seen1, roomGeometryData, serializationConstructorMarker) {
    return RoomGeometryComponent_init_$Init$(seen1, roomGeometryData, serializationConstructorMarker, objectCreate(protoOf(RoomGeometryComponent)));
  }
  function RoomGeometryComponent(roomGeometryData) {
    Companion_getInstance_88();
    this.roomGeometryData = roomGeometryData;
    this.surfaces = Companion_getInstance_95().generateWallMap(this.roomGeometryData);
    this.dimensions = Companion_getInstance_92().getDimensions(this.roomGeometryData);
  }
  protoOf(RoomGeometryComponent).y3l = function () {
    return this.roomGeometryData;
  };
  protoOf(RoomGeometryComponent).toJson = function (parse) {
    return Companion_getInstance_88().v3l_1.k15(Companion_getInstance_88().l17(), this);
  };
  protoOf(RoomGeometryComponent).serializationKey = function () {
    return 'RoomGeometry';
  };
  protoOf(RoomGeometryComponent).l23 = function () {
    return this.surfaces;
  };
  protoOf(RoomGeometryComponent).u3l = function () {
    return this.dimensions;
  };
  protoOf(RoomGeometryComponent).x1k = function () {
    return 70;
  };
  protoOf(RoomGeometryComponent).eq = function (other) {
    return (other instanceof RoomGeometryComponent ? other : THROW_CCE()).roomGeometryData.equals(this.roomGeometryData);
  };
  protoOf(RoomGeometryComponent).af = function () {
    return this.roomGeometryData;
  };
  protoOf(RoomGeometryComponent).z3l = function (roomGeometryData) {
    return new RoomGeometryComponent(roomGeometryData);
  };
  protoOf(RoomGeometryComponent).copy = function (roomGeometryData, $super) {
    roomGeometryData = roomGeometryData === VOID ? this.roomGeometryData : roomGeometryData;
    return this.z3l(roomGeometryData);
  };
  protoOf(RoomGeometryComponent).toString = function () {
    return 'RoomGeometryComponent(roomGeometryData=' + this.roomGeometryData + ')';
  };
  protoOf(RoomGeometryComponent).hashCode = function () {
    return this.roomGeometryData.hashCode();
  };
  protoOf(RoomGeometryComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomGeometryComponent))
      return false;
    var tmp0_other_with_cast = other instanceof RoomGeometryComponent ? other : THROW_CCE();
    if (!this.roomGeometryData.equals(tmp0_other_with_cast.roomGeometryData))
      return false;
    return true;
  };
  function Companion_80() {
    this.id = 103;
  }
  protoOf(Companion_80).s1k = function () {
    return this.id;
  };
  var Companion_instance_113;
  function Companion_getInstance_89() {
    return Companion_instance_113;
  }
  function RoomPartComponent(type) {
    this.type = type;
  }
  protoOf(RoomPartComponent).a1x = function () {
    return this.type;
  };
  protoOf(RoomPartComponent).x1k = function () {
    return 103;
  };
  protoOf(RoomPartComponent).eq = function (other) {
    return (other instanceof RoomPartComponent ? other : THROW_CCE()).type === this.type;
  };
  protoOf(RoomPartComponent).af = function () {
    return this.type;
  };
  protoOf(RoomPartComponent).q1l = function (type) {
    return new RoomPartComponent(type);
  };
  protoOf(RoomPartComponent).copy = function (type, $super) {
    type = type === VOID ? this.type : type;
    return this.q1l(type);
  };
  protoOf(RoomPartComponent).toString = function () {
    return 'RoomPartComponent(type=' + this.type + ')';
  };
  protoOf(RoomPartComponent).hashCode = function () {
    return getStringHashCode(this.type);
  };
  protoOf(RoomPartComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomPartComponent))
      return false;
    var tmp0_other_with_cast = other instanceof RoomPartComponent ? other : THROW_CCE();
    if (!(this.type === tmp0_other_with_cast.type))
      return false;
    return true;
  };
  function get_isRoomPart(_this__u8e3s4) {
    return _this__u8e3s4.hasComponent(103);
  }
  function RoomRefToRoomComponentInterceptor() {
    this.a3m_1 = true;
  }
  protoOf(RoomRefToRoomComponentInterceptor).a1m = function () {
    return this.a3m_1;
  };
  protoOf(RoomRefToRoomComponentInterceptor).productSpecification = function (productRef) {
    return null;
  };
  protoOf(RoomRefToRoomComponentInterceptor).rangeId = function () {
    return 'RoomCatalog';
  };
  protoOf(RoomRefToRoomComponentInterceptor).rangeVersion = function () {
    return '0.1';
  };
  protoOf(RoomRefToRoomComponentInterceptor).toString = function () {
    return this.rangeId() + ' ' + this.rangeVersion();
  };
  protoOf(RoomRefToRoomComponentInterceptor).allProductRefs = function () {
    // Inline function 'kotlin.emptyArray' call
    return [];
  };
  protoOf(RoomRefToRoomComponentInterceptor).beforeBuildingEntities = function (serializableTree, catalogVersion) {
    if (serializableTree.version === '1.0') {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = serializableTree.entities.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.room.interceptor.RoomRefToRoomComponentInterceptor.beforeBuildingEntities.<anonymous>' call
        if ((element.ref === 'room-10000x2500x10000' ? true : element.ref === 'room-5000x2500x4000') ? true : element.ref === 'room') {
          var component = new RoomDimensionsComponent(__VectorIntConstructorKotlin(5000, 2500, 4000));
          var tmp0_safe_receiver = element.serializedComponents;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver.r2(component.serializationKey(), component.toJsonElement());
        }
      }
    }
    if (serializableTree.version === '1.2') {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = serializableTree.entities.t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.room.interceptor.RoomRefToRoomComponentInterceptor.beforeBuildingEntities.<anonymous>' call
        if ((element_0.ref === 'room-10000x2500x10000' ? true : element_0.ref === 'room-5000x2500x4000') ? true : element_0.ref === 'room') {
          var tmp0_elvis_lhs = element_0.components;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.emptyArray' call
            tmp = [];
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var oldComponents = tmp;
          var component_0 = new RoomDimensionsComponent(__VectorIntConstructorKotlin(5000, 2500, 4000));
          // Inline function 'kotlin.collections.plus' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$4 = [component_0];
          element_0.components = oldComponents.concat(tmp$ret$4);
        }
      }
    }
  };
  function Companion_81() {
    this.ID = 'RoomDimensionToGeometrySystem';
  }
  protoOf(Companion_81).u1n = function () {
    return this.ID;
  };
  var Companion_instance_114;
  function Companion_getInstance_90() {
    return Companion_instance_114;
  }
  function createGeometry($this, room, dimensions) {
    var roomGeometryData = Companion_getInstance_95().generateRectangularRoom(dimensions);
    $this.entityManager.addComponent(room, RoomComponent_instance);
    $this.entityManager.addComponent(room, new RoomGeometryComponent(roomGeometryData));
    $this.entityManager.addComponent(room, StaticComponent_getInstance());
    Companion_getInstance_87();
    $this.entityManager.removeComponent(room, 41);
  }
  function RoomDimensionToGeometrySystem(entityManager) {
    Companion_getInstance_87();
    SystemBase.call(this, 'RoomDimensionToGeometrySystem', 41);
    this.entityManager = entityManager;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j3m_1 = ['RoomSystem'];
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.k3m_1 = [70, 53];
  }
  protoOf(RoomDimensionToGeometrySystem).p1i = function () {
    return this.entityManager;
  };
  protoOf(RoomDimensionToGeometrySystem).onAddComponent = function (entity, newComponent) {
    createGeometry(this, entity, newComponent.dimensions);
  };
  protoOf(RoomDimensionToGeometrySystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    createGeometry(this, entity, newComponent.dimensions);
  };
  protoOf(RoomDimensionToGeometrySystem).onRemoveComponent = function (entity, oldComponent) {
  };
  protoOf(RoomDimensionToGeometrySystem).y1o = function () {
    return this.j3m_1;
  };
  protoOf(RoomDimensionToGeometrySystem).w1o = function () {
    return this.k3m_1;
  };
  function RoomServiceDragSystem(entityManager) {
    SystemBase.call(this, 'RoomServiceDragSystem', 70);
    this.entityManager = entityManager;
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.entityManager.entities;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.system.RoomServiceDragSystem.<anonymous>' call
        if (element.hasComponent(70)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.onAddComponent(tmp0_safe_receiver, ensureNotNull(tmp0_safe_receiver.__getComponentForKotlin(70)));
    }
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t3m_1 = [74];
  }
  protoOf(RoomServiceDragSystem).p1i = function () {
    return this.entityManager;
  };
  protoOf(RoomServiceDragSystem).onAddComponent = function (entity, newComponent) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = newComponent.roomGeometryData.walls;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.system.RoomServiceDragSystem.onAddComponent.<anonymous>' call
      var tmp$ret$0 = PolyhedronUtils_getInstance().singleSidedPolyhedronFromPolygon(item.surfaceGeometry.points);
      destination.q(tmp$ret$0);
    }
    var walls = destination;
    var floor = PolyhedronUtils_getInstance().singleSidedPolyhedronFromPolygon(newComponent.roomGeometryData.floor.surfaceGeometry.points);
    var ceiling = PolyhedronUtils_getInstance().singleSidedPolyhedronFromPolygon(newComponent.roomGeometryData.ceiling.surfaceGeometry.points);
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(walls, 10));
    var tmp0_iterator = walls.t();
    while (tmp0_iterator.u()) {
      var item_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.system.RoomServiceDragSystem.onAddComponent.<anonymous>' call
      var tmp$ret$3 = new DragSurface(item_0, null);
      destination_0.q(tmp$ret$3);
    }
    var this_1 = copyToArray(destination_0);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = ['floor'];
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$13 = [new DragSurface(floor, tmp$ret$9)];
    var this_2 = this_1.concat(tmp$ret$13);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$17 = ['ceiling'];
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$21 = [new DragSurface(ceiling, tmp$ret$17)];
    var surfaces = this_2.concat(tmp$ret$21);
    entity.addComponent(new DragSurfacesComponent(surfaces));
  };
  protoOf(RoomServiceDragSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    this.onAddComponent(entity, newComponent);
  };
  protoOf(RoomServiceDragSystem).onRemoveComponent = function (entity, oldComponent) {
    entity.removeComponent(74);
  };
  protoOf(RoomServiceDragSystem).w1o = function () {
    return this.t3m_1;
  };
  function Companion_82() {
    this.ID = 'RoomSystem';
  }
  protoOf(Companion_82).u1n = function () {
    return this.ID;
  };
  var Companion_instance_115;
  function Companion_getInstance_91() {
    return Companion_instance_115;
  }
  function removeOldData($this, room) {
    Companion_getInstance_2();
    $this.d3n_1.removeComponent(room, 11);
    $this.d3n_1.removeComponent(room, 19);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = filterInHierarchy(room, RoomSystem$removeOldData$lambda);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.system.RoomSystem.removeOldData.<anonymous>' call
      $this.d3n_1.disposeEntity(element);
    }
  }
  function addStandardRoomComponents($this, room) {
    $this.d3n_1.addComponent(room, RoomComponent_instance);
    $this.d3n_1.addComponent(room, new ConnectionRootComponent());
    $this.d3n_1.addComponent(room, new SnapRootComponent());
    $this.d3n_1.addComponent(room, new DisplayNameComponent('Room'));
    $this.d3n_1.addComponent(room, StaticComponent_getInstance());
  }
  function generateRoom($this, room, roomGeometryComponent) {
    addStandardRoomComponents($this, room);
    var roomGeometry = roomGeometryComponent.roomGeometryData;
    var colliders = generateColliders($this, roomGeometry);
    var connectorComponents = generateConnectors($this, roomGeometryComponent);
    var obstacles = generateObstacleEntities($this, roomGeometry);
    var i = 0;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(colliders.length);
    var inductionVariable = 0;
    var last = colliders.length;
    while (inductionVariable < last) {
      var item = colliders[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.system.RoomSystem.generateRoom.<anonymous>' call
      var tmp0 = i;
      i = tmp0 + 1 | 0;
      var tmp$ret$0 = 'room-' + tmp0;
      destination.q(tmp$ret$0);
    }
    var colliderIds = copyToArray(destination);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = obstacles.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.system.RoomSystem.generateRoom.<anonymous>' call
      setParentMaintainWorldTransform(element, room);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = connectorComponents.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.room.system.RoomSystem.generateRoom.<anonymous>' call
      $this.d3n_1.addComponent(room, element_0);
    }
    $this.d3n_1.addComponent(room, new ColliderShapeComponent(new PolyhedronGroup(colliders), colliderIds));
    $this.d3n_1.addComponent(room, RoomComponent_instance);
    $this.d3n_1.addComponent(room, StaticComponent_getInstance());
    $this.d3n_1.addComponent(room, new DisplayNameComponent('Room'));
    $this.roomService.applyDisabledConnectorsConfigToRoom(room);
  }
  function generateObstacleEntities($this, roomGeometry) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = roomGeometry.obstacles;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.system.RoomSystem.generateObstacleEntities.<anonymous>' call
      var obstaclePolyhedron = CuboidFromSize(item.boundingBox.size);
      var transform = new Transform(item.boundingBox.transform.position, item.boundingBox.transform.rotation);
      var obstacleEntity = $this.d3n_1.createEntity();
      obstacleEntity.addComponent(new DisplayNameComponent(item.type + '-' + item.id));
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [item.type + '-' + item.id];
      obstacleEntity.addComponent(new ColliderShapeComponent(obstaclePolyhedron, tmp$ret$2));
      obstacleEntity.addComponent(new LocalTransformComponent(transform));
      obstacleEntity.addComponent(new WorldTransformComponent(transform));
      obstacleEntity.addComponent(new RoomPartComponent(item.type));
      destination.q(obstacleEntity);
    }
    return destination;
  }
  function generateColliders($this, roomGeometry) {
    var generateWallColliders = Companion_getInstance_92().generateWallColliders(roomGeometry.walls);
    var floorPolyhedron = Companion_getInstance_92().generateSurfaceCollider(roomGeometry.floor.surfaceGeometry);
    var ceilingPolyhedron = Companion_getInstance_92().generateSurfaceCollider(roomGeometry.ceiling.surfaceGeometry);
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return generateWallColliders.concat(floorPolyhedron).concat(ceilingPolyhedron);
  }
  function generateConnectors($this, roomGeometryComponent) {
    var roomGeometryData = roomGeometryComponent.roomGeometryData;
    var generatedWallConnectors = Companion_instance_118.generateWallConnectors(roomGeometryData.walls);
    var generatedEdgeConnectors = Companion_instance_118.generateEdgeConnectors(roomGeometryData.edges, roomGeometryComponent.surfaces);
    var generatedPointConnectors = Companion_instance_118.generatePointConnectors(roomGeometryData.vertices, roomGeometryComponent.surfaces);
    var floorConnector = Companion_instance_118.generateFloorConnector(roomGeometryData.floor);
    var ceilingConnector = Companion_instance_118.generateCeilingConnector(roomGeometryData.ceiling);
    var tmp = Companion_instance_117;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [floorConnector];
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = generatedWallConnectors.concat(tmp$ret$3);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [ceilingConnector];
    var tmp$ret$9 = tmp$ret$5.concat(tmp$ret$8);
    var connectorMappings = tmp.createRelationsComponent(tmp$ret$9, generatedEdgeConnectors, generatedPointConnectors);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(generatedEdgeConnectors.length);
    var inductionVariable = 0;
    var last = generatedEdgeConnectors.length;
    while (inductionVariable < last) {
      var item = generatedEdgeConnectors[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.system.RoomSystem.generateConnectors.<anonymous>' call
      var tmp$ret$10 = item.connector;
      destination.q(tmp$ret$10);
    }
    var tmp_0 = destination;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(generatedPointConnectors.length);
    var inductionVariable_0 = 0;
    var last_0 = generatedPointConnectors.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = generatedPointConnectors[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.system.RoomSystem.generateConnectors.<anonymous>' call
      var tmp$ret$13 = item_0.connector;
      destination_0.q(tmp$ret$13);
    }
    var tmp_1 = plus_1(tmp_0, destination_0);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(generatedWallConnectors.length);
    var inductionVariable_1 = 0;
    var last_1 = generatedWallConnectors.length;
    while (inductionVariable_1 < last_1) {
      var item_1 = generatedWallConnectors[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.system.RoomSystem.generateConnectors.<anonymous>' call
      var tmp$ret$16 = item_1.connector;
      destination_1.q(tmp$ret$16);
    }
    var this_0 = plus_2(plus_2(plus_1(tmp_1, destination_1), floorConnector.connector), ceilingConnector.connector);
    var connectors = copyToArray(this_0);
    return listOf_0([connectorMappings, new ConnectorsComponent(connectors)]);
  }
  function RoomSystem$removeOldData$lambda(it) {
    return get_isRoomPart(it);
  }
  function RoomSystem(roomService, coreServices) {
    Companion_getInstance_88();
    SystemBase.call(this, 'RoomSystem', 70);
    this.roomService = roomService;
    this.c3n_1 = coreServices;
    this.d3n_1 = this.c3n_1.entityManager;
    this.e3n_1 = new RoomDimensionToGeometrySystem(this.d3n_1);
    this.f3n_1 = new RoomServiceDragSystem(this.d3n_1);
    this.g3n_1 = new RoomComponentDeserializer();
    this.h3n_1 = new RoomRefToRoomComponentInterceptor();
    this.enable();
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i3n_1 = [11, 53, 19];
  }
  protoOf(RoomSystem).j3n = function () {
    return this.roomService;
  };
  protoOf(RoomSystem).onRegister = function () {
    protoOf(SystemBase).onRegister.call(this);
    this.e3n_1.register(this.d3n_1);
    this.f3n_1.register(this.d3n_1);
  };
  protoOf(RoomSystem).onUnregister = function () {
    protoOf(SystemBase).onUnregister.call(this);
    this.e3n_1.unregister(this.d3n_1);
    this.f3n_1.unregister(this.d3n_1);
  };
  protoOf(RoomSystem).enable = function () {
    protoOf(SystemBase).enable.call(this);
    this.e3n_1.enable();
    this.f3n_1.enable();
    this.c3n_1.componentDeserializerRegistry.register(this.g3n_1);
    this.c3n_1.productManager.addCatalog(this.h3n_1);
  };
  protoOf(RoomSystem).disable = function () {
    protoOf(SystemBase).disable.call(this);
    this.e3n_1.disable();
    this.f3n_1.disable();
    this.c3n_1.componentDeserializerRegistry.unregister(this.g3n_1);
    this.c3n_1.productManager.removeCatalog(this.h3n_1);
  };
  protoOf(RoomSystem).onAddComponent = function (room, newRoomGeometryComponent) {
    generateRoom(this, room, newRoomGeometryComponent);
  };
  protoOf(RoomSystem).onUpdateComponent = function (room, oldComponent, newComponent) {
    removeOldData(this, room);
    generateRoom(this, room, newComponent);
  };
  protoOf(RoomSystem).onRemoveComponent = function (room, oldComponent) {
    removeOldData(this, room);
  };
  protoOf(RoomSystem).w1o = function () {
    return this.i3n_1;
  };
  function RoomColliderUtilities$Companion$generateWallColliders$lambda($e) {
    return function () {
      return $e.message;
    };
  }
  function RoomColliderUtilities$Companion$generateWallColliders$lambda_0() {
    return 'Could not generate wall collider. Adding empty collider.';
  }
  function RoomColliderUtilities$Companion$generateWallColliders$lambda_1($wall) {
    return function () {
      return 'Wall surface geometry: ' + $wall.surfaceGeometry;
    };
  }
  function Companion_83() {
    Companion_instance_116 = this;
    this.logger = LoggerState_getInstance().m1m('RoomColliderUtilities');
  }
  protoOf(Companion_83).x1i = function () {
    return this.logger;
  };
  protoOf(Companion_83).generateWallColliders = function (walls) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var generatedColliders = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = walls.length;
    while (inductionVariable < last) {
      var wall = walls[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      try {
        var colliders = this.generateSurfaceCollider(wall.surfaceGeometry);
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = colliders.length;
        while (inductionVariable_0 < last_0) {
          var element = colliders[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.core.stl.room.utils.Companion.generateWallColliders.<anonymous>' call
          generatedColliders.q(element);
        }
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          this.logger.error(RoomColliderUtilities$Companion$generateWallColliders$lambda(e));
          this.logger.error(RoomColliderUtilities$Companion$generateWallColliders$lambda_0);
          this.logger.error(RoomColliderUtilities$Companion$generateWallColliders$lambda_1(wall));
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(generatedColliders);
  };
  protoOf(Companion_83).generateSurfaceCollider = function (surfaceGeometry) {
    var thickness = 30.0;
    var tmp;
    if (PolyhedronUtils_getInstance().isConvexPolygon(surfaceGeometry.points)) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [PolyhedronUtils_getInstance().polyhedronFromPolygon(surfaceGeometry.points, thickness)];
    } else {
      var triangles = PolyhedronUtils_getInstance().earClipTriangulation(surfaceGeometry.points);
      // Inline function 'kotlin.collections.mutableListOf' call
      var polyhedrons = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = triangles.length;
      while (inductionVariable < last) {
        var element = triangles[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.generateSurfaceCollider.<anonymous>' call
        polyhedrons.q(PolyhedronUtils_getInstance().polyhedronFromPolygon(element, thickness));
      }
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp = copyToArray(polyhedrons);
    }
    return tmp;
  };
  protoOf(Companion_83).getDimensions = function (convertedData) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = convertedData.walls;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.getDimensions.<anonymous>' call
      var list = toList(element.surfaceGeometry.points);
      addAll_0(destination, list);
    }
    var vertices = copyToArray(destination);
    return Companion_getInstance_3().fromVertices(vertices);
  };
  var Companion_instance_116;
  function Companion_getInstance_92() {
    if (Companion_instance_116 == null)
      new Companion_83();
    return Companion_instance_116;
  }
  function RoomColliderUtilities() {
    Companion_getInstance_92();
  }
  function RoomConnectorPair(connector, geometry) {
    this.connector = connector;
    this.geometry = geometry;
  }
  protoOf(RoomConnectorPair).n1k = function () {
    return this.connector;
  };
  protoOf(RoomConnectorPair).k3n = function () {
    return this.geometry;
  };
  protoOf(RoomConnectorPair).af = function () {
    return this.connector;
  };
  protoOf(RoomConnectorPair).bf = function () {
    return this.geometry;
  };
  protoOf(RoomConnectorPair).l3n = function (connector, geometry) {
    return new RoomConnectorPair(connector, geometry);
  };
  protoOf(RoomConnectorPair).copy = function (connector, geometry, $super) {
    connector = connector === VOID ? this.connector : connector;
    geometry = geometry === VOID ? this.geometry : geometry;
    return this.l3n(connector, geometry);
  };
  protoOf(RoomConnectorPair).toString = function () {
    return 'RoomConnectorPair(connector=' + this.connector + ', geometry=' + this.geometry + ')';
  };
  protoOf(RoomConnectorPair).hashCode = function () {
    var result = this.connector.hashCode();
    result = imul(result, 31) + hashCode(this.geometry) | 0;
    return result;
  };
  protoOf(RoomConnectorPair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RoomConnectorPair))
      return false;
    var tmp0_other_with_cast = other instanceof RoomConnectorPair ? other : THROW_CCE();
    if (!equals(this.connector, tmp0_other_with_cast.connector))
      return false;
    if (!equals(this.geometry, tmp0_other_with_cast.geometry))
      return false;
    return true;
  };
  function collectRoomConnectorsForCorner($this, cornerToSurface, cornerToEdge) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(cornerToSurface.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = cornerToSurface.q2().t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.utils.Companion.collectRoomConnectorsForCorner.<anonymous>' call
      var corner = item.t2();
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_0 = item.u2();
      var surfaces = copyToArray(this_0);
      var tmp0_safe_receiver = cornerToEdge.b3(item.t2());
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp = copyToArray(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var edges = tmp_0;
      var tmp$ret$4 = to(corner, new RoomConnectorKeysForCorner(corner, edges, surfaces));
      destination.q(tmp$ret$4);
    }
    return toMap(destination);
  }
  function collectRoomConnectorsForEdge($this, edgeToSurface, edgeToCorner) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(edgeToSurface.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = edgeToSurface.q2().t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.utils.Companion.collectRoomConnectorsForEdge.<anonymous>' call
      var edge = item.t2();
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_0 = item.u2();
      var surfaces = copyToArray(this_0);
      var tmp0_safe_receiver = edgeToCorner.b3(item.t2());
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp = copyToArray(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var corners = tmp_0;
      var tmp$ret$4 = to(edge, new RoomConnectorKeysForEdge(edge, corners, surfaces));
      destination.q(tmp$ret$4);
    }
    return toMap(destination);
  }
  function collectRommConnectorsForSurface($this, surfaceToEdge, surfaceToCorner) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(surfaceToEdge.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = surfaceToEdge.q2().t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.utils.Companion.collectRommConnectorsForSurface.<anonymous>' call
      var surface = item.t2();
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_0 = item.u2();
      var edges = copyToArray(this_0);
      var tmp0_safe_receiver = surfaceToCorner.b3(item.t2());
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp = copyToArray(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var corners = tmp_0;
      var tmp$ret$4 = to(surface, new RoomConnectorKeysForSurface(surface, edges, corners));
      destination.q(tmp$ret$4);
    }
    return toMap(destination);
  }
  function addConnector($this, mapSet, key, connectorKey) {
    // Inline function 'kotlin.collections.getOrPut' call
    var value = mapSet.b3(key);
    var tmp;
    if (value == null) {
      // Inline function 'com.ikea.core.stl.room.utils.Companion.addConnector.<anonymous>' call
      // Inline function 'kotlin.collections.mutableSetOf' call
      var answer = LinkedHashSet_init_$Create$();
      mapSet.r2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var current = tmp;
    current.q(connectorKey);
  }
  function Companion_84() {
  }
  protoOf(Companion_84).createRelationsComponent = function (surfacesPairs, edgePairs, cornerPairs) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    var edgeToSurface = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var edgeToCorner = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var surfaceToEdge = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var surfaceToCorner = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var cornerToEdge = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var cornerToSurface = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = surfacesPairs.length;
    while (inductionVariable < last) {
      var element = surfacesPairs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.createRelationsComponent.<anonymous>' call
      var surfaceConnector = element.connector;
      var surfaceGeometry = element.geometry;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = edgePairs.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = edgePairs[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.createRelationsComponent.<anonymous>.<anonymous>' call
        if (element_0.geometry.surfaceId1 === surfaceGeometry.id ? true : element_0.geometry.surfaceId2 === surfaceGeometry.id) {
          destination.q(element_0);
        }
      }
      var edges = destination;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList_init_$Create$();
      var inductionVariable_1 = 0;
      var last_1 = cornerPairs.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = cornerPairs[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.createRelationsComponent.<anonymous>.<anonymous>' call
        var cornerGeometry = element_1.bf();
        if (contains(element.geometry.surfaceGeometry.points, cornerGeometry.point)) {
          destination_0.q(element_1);
        }
      }
      var surfaceCorners = destination_0;
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = edges.t();
      while (tmp0_iterator.u()) {
        var element_2 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.room.utils.Companion.createRelationsComponent.<anonymous>.<anonymous>' call
        var edgeConnectorKey = element_2.connector.y1y_1;
        addConnector(Companion_instance_117, surfaceToEdge, surfaceConnector.p22_1, edgeConnectorKey);
        addConnector(Companion_instance_117, edgeToSurface, edgeConnectorKey, surfaceConnector.p22_1);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_1 = ArrayList_init_$Create$();
        var inductionVariable_2 = 0;
        var last_2 = cornerPairs.length;
        while (inductionVariable_2 < last_2) {
          var element_3 = cornerPairs[inductionVariable_2];
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          // Inline function 'com.ikea.core.stl.room.utils.Companion.createRelationsComponent.<anonymous>.<anonymous>.<anonymous>' call
          var cornerConnector = element_3.af();
          var edgeGeometry = element_2.geometry;
          if (cornerConnector.d20_1.position.equals(edgeGeometry.point1) ? true : cornerConnector.d20_1.position.equals(edgeGeometry.point2)) {
            destination_1.q(element_3);
          }
        }
        var cornersForEdge = destination_1;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(cornersForEdge, 10));
        var tmp0_iterator_0 = cornersForEdge.t();
        while (tmp0_iterator_0.u()) {
          var item = tmp0_iterator_0.w();
          // Inline function 'com.ikea.core.stl.room.utils.Companion.createRelationsComponent.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$15 = item.connector.b20_1;
          destination_2.q(tmp$ret$15);
        }
        var tmp0_iterator_1 = destination_2.t();
        while (tmp0_iterator_1.u()) {
          var element_4 = tmp0_iterator_1.w();
          // Inline function 'com.ikea.core.stl.room.utils.Companion.createRelationsComponent.<anonymous>.<anonymous>.<anonymous>' call
          addConnector(Companion_instance_117, edgeToCorner, edgeConnectorKey, element_4);
          addConnector(Companion_instance_117, cornerToEdge, element_4, edgeConnectorKey);
        }
      }
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(surfaceCorners, 10));
      var tmp0_iterator_2 = surfaceCorners.t();
      while (tmp0_iterator_2.u()) {
        var item_0 = tmp0_iterator_2.w();
        // Inline function 'com.ikea.core.stl.room.utils.Companion.createRelationsComponent.<anonymous>.<anonymous>' call
        var tmp$ret$18 = item_0.connector.b20_1;
        destination_3.q(tmp$ret$18);
      }
      var tmp0_iterator_3 = destination_3.t();
      while (tmp0_iterator_3.u()) {
        var element_5 = tmp0_iterator_3.w();
        // Inline function 'com.ikea.core.stl.room.utils.Companion.createRelationsComponent.<anonymous>.<anonymous>' call
        addConnector(Companion_instance_117, surfaceToCorner, surfaceConnector.p22_1, element_5);
        addConnector(Companion_instance_117, cornerToSurface, element_5, surfaceConnector.p22_1);
      }
    }
    var surfaceToConnectorsMap = collectRommConnectorsForSurface(this, surfaceToEdge, surfaceToCorner);
    var edgeToConnectorsMap = collectRoomConnectorsForEdge(this, edgeToSurface, edgeToCorner);
    var cornerToConnectorsMap = collectRoomConnectorsForCorner(this, cornerToSurface, cornerToEdge);
    return new RoomConnectorRelationsComponent(surfaceToConnectorsMap, edgeToConnectorsMap, cornerToConnectorsMap);
  };
  var Companion_instance_117;
  function Companion_getInstance_93() {
    return Companion_instance_117;
  }
  function RoomConnectorRelationsMapper() {
  }
  function includesSurfaceWithNormal($this, surfaces, normal) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = surfaces.length;
      while (inductionVariable < last) {
        var element = surfaces[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.includesSurfaceWithNormal.<anonymous>' call
        var points = element.surfaceGeometry.points;
        var surfaceNormal = PolyhedronUtils_getInstance().surfaceNormal(points);
        if (surfaceNormal.equals(normal)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function generateOfferStringForFloorCornerAngle($this, surfaceGeometries, corner) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(surfaceGeometries.length);
    var inductionVariable = 0;
    var last = surfaceGeometries.length;
    while (inductionVariable < last) {
      var item = surfaceGeometries[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.generateOfferStringForFloorCornerAngle.<anonymous>' call
      var points = item.surfaceGeometry.points;
      var normal = PolyhedronUtils_getInstance().generateNormalFromCounterClockwiseTriangle(points[0], points[1], points[2]);
      var tmp$ret$0 = new Wall(item, normal);
      destination.q(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.utils.Companion.generateOfferStringForFloorCornerAngle.<anonymous>' call
      var normal_0 = element.component2();
      if (almostEquals(normal_0.Y, 0.0, 1.0E-4)) {
        destination_0.q(element);
      }
    }
    var walls = destination_0;
    var tmp;
    if (walls.n() === 2) {
      var tmp0_container = pickWallsInOrder($this, walls.f1(0), walls.f1(1), corner);
      var firstWall = tmp0_container.af();
      var secondWall = tmp0_container.bf();
      var degreeInt = roundToInt((new Radians(firstWall.normal.signedAngle(secondWall.normal))).toDegree().value);
      var tmp_0;
      if (degreeInt < 0) {
        tmp_0 = 360 + degreeInt | 0;
      } else {
        tmp_0 = degreeInt;
      }
      var positiveAngle = tmp_0;
      tmp = '' + positiveAngle + '-degrees';
    } else {
      tmp = null;
    }
    return tmp;
  }
  function pickWallsInOrder($this, wall1, wall2, corner) {
    var wall1NextVertex = nextVertexFrom($this, corner, wall1);
    var tmp;
    if (wall1NextVertex.Y === corner.point.Y) {
      tmp = new Pair(wall1, wall2);
    } else {
      tmp = new Pair(wall2, wall1);
    }
    return tmp;
  }
  function nextVertexFrom($this, corner, wall1) {
    var points = wall1.surface.surfaceGeometry.points;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var inductionVariable = 0;
      var last = points.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.stl.room.utils.Companion.nextVertexFrom.<anonymous>' call
          if (points[index].equals(corner.point)) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    var index_0 = tmp$ret$1;
    var nextIndex = (index_0 + 1 | 0) % points.length | 0;
    return points[nextIndex];
  }
  function Wall(surface, normal) {
    this.surface = surface;
    this.normal = normal;
  }
  protoOf(Wall).component2 = function () {
    return this.normal;
  };
  protoOf(Wall).m3n = function (surface, normal) {
    return new Wall(surface, normal);
  };
  protoOf(Wall).copy = function (surface, normal, $super) {
    surface = surface === VOID ? this.surface : surface;
    normal = normal === VOID ? this.normal : normal;
    return this.m3n(surface, normal);
  };
  protoOf(Wall).toString = function () {
    return 'Wall(surface=' + this.surface + ', normal=' + this.normal + ')';
  };
  protoOf(Wall).hashCode = function () {
    var result = this.surface.hashCode();
    result = imul(result, 31) + this.normal.hashCode() | 0;
    return result;
  };
  protoOf(Wall).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Wall))
      return false;
    var tmp0_other_with_cast = other instanceof Wall ? other : THROW_CCE();
    if (!this.surface.equals(tmp0_other_with_cast.surface))
      return false;
    if (!this.normal.equals(tmp0_other_with_cast.normal))
      return false;
    return true;
  };
  function Companion_85() {
  }
  protoOf(Companion_85).generateWallConnectors = function (walls) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(walls.length);
    var inductionVariable = 0;
    var last = walls.length;
    while (inductionVariable < last) {
      var item = walls[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.generateWallConnectors.<anonymous>' call
      var wallConnector = Companion_instance_118.generateSurfaceConnector(item.id, item.surfaceGeometry);
      var tmp$ret$0 = new RoomConnectorPair(wallConnector, item);
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(Companion_85).generateEdgeConnectors = function (edges, surfaces) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(edges.length);
    var inductionVariable = 0;
    var last = edges.length;
    while (inductionVariable < last) {
      var item = edges[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.generateEdgeConnectors.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filterKeys' call
      var result = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = surfaces.q2().t();
      while (tmp0_iterator.u()) {
        var entry = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.room.utils.Companion.generateEdgeConnectors.<anonymous>.<anonymous>' call
        var it = entry.t2();
        if (it === item.surfaceId1 ? true : it === item.surfaceId2) {
          result.r2(entry.t2(), entry.u2());
        }
      }
      var this_0 = result.p2();
      var surfacesForThisEdge = copyToArray(this_0);
      var tmp;
      if (includesSurfaceWithNormal(Companion_instance_118, surfacesForThisEdge, Companion_getInstance_4().DOWN)) {
        tmp = RoomConnectorConstants_getInstance().EDGE_WALL_CEILING_OFFERS;
      } else if (includesSurfaceWithNormal(Companion_instance_118, surfacesForThisEdge, Companion_getInstance_4().UP)) {
        tmp = RoomConnectorConstants_getInstance().EDGE_WALL_FLOOR_OFFERS;
      } else {
        tmp = RoomConnectorConstants_getInstance().EDGE_WALL_WALL_OFFERS;
      }
      var offers = tmp;
      var normal = Companion_instance_118.generateMeanNormalFromAdjacentSurfaces(surfacesForThisEdge);
      var tmp$ret$4 = new RoomConnectorPair(Companion_instance_118.generateEdge(item, normal.unaryMinus(), Companion_getInstance_4().UP, offers), item);
      destination.q(tmp$ret$4);
    }
    return copyToArray(destination);
  };
  protoOf(Companion_85).generateFloorConnector = function (floorGeometryData) {
    var tmp0_key = floorGeometryData.id;
    var tmp2_offersArray = RoomConnectorConstants_getInstance().FLOOR_OFFERS;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp3_demandsArray = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_tagArray = [];
    var tmp5_vertices = floorGeometryData.surfaceGeometry.points;
    var connector = new SurfaceConnector(tmp0_key, 1, tmp5_vertices, VOID, VOID, true, tmp4_tagArray, tmp2_offersArray, tmp3_demandsArray);
    return new RoomConnectorPair(connector, floorGeometryData);
  };
  protoOf(Companion_85).generateCeilingConnector = function (ceilingGeometryData) {
    var tmp0_key = ceilingGeometryData.id;
    var tmp2_offersArray = RoomConnectorConstants_getInstance().CEILING_OFFERS;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp3_demandsArray = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_tagArray = [];
    var tmp5_vertices = ceilingGeometryData.surfaceGeometry.points;
    var connector = new SurfaceConnector(tmp0_key, 1, tmp5_vertices, VOID, VOID, true, tmp4_tagArray, tmp2_offersArray, tmp3_demandsArray);
    return new RoomConnectorPair(connector, ceilingGeometryData);
  };
  protoOf(Companion_85).generateSurfaceConnector = function (id, surfaceGeometry) {
    var tmp1_vertices = surfaceGeometry.points;
    var tmp2_offersArray = RoomConnectorConstants_getInstance().WALL_OFFERS;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp3_demandsArray = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_tagArray = [];
    return new SurfaceConnector(id, 1, tmp1_vertices, VOID, VOID, true, tmp4_tagArray, tmp2_offersArray, tmp3_demandsArray);
  };
  protoOf(Companion_85).generateEdge = function (edge, forwards, upwards, offers) {
    var edgeRotation = Companion_getInstance_6().fromEulerDegrees(new Degrees(90.0)).times(Companion_getInstance_6().fromLookDirectionUnsafe(forwards, upwards));
    return new EdgeConnector(edge.id, 1, edge.point1, edge.point2, edgeRotation, VOID, VOID, VOID, VOID, offers);
  };
  protoOf(Companion_85).generatePointConnectors = function (points, surfaces) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(points.length);
    var inductionVariable = 0;
    var last = points.length;
    while (inductionVariable < last) {
      var item = points[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.generatePointConnectors.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.filterKeys' call
      var result = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = surfaces.q2().t();
      while (tmp0_iterator.u()) {
        var entry = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.room.utils.Companion.generatePointConnectors.<anonymous>.<anonymous>' call
        var it = entry.t2();
        if (contains(item.surfaces, it)) {
          result.r2(entry.t2(), entry.u2());
        }
      }
      var this_0 = result.p2();
      var surfacesForThisPoint = copyToArray(this_0);
      var isCeiling = includesSurfaceWithNormal(Companion_instance_118, surfacesForThisPoint, Companion_getInstance_4().DOWN);
      var tmp;
      if (isCeiling) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = [RoomConnectorConstants_getInstance().POINT_WALL_CEILING_OFFER];
      } else if (includesSurfaceWithNormal(Companion_instance_118, surfacesForThisPoint, Companion_getInstance_4().UP)) {
        var offerForCornerAngle = generateOfferStringForFloorCornerAngle(Companion_instance_118, surfacesForThisPoint, item);
        var tmp_0;
        if (!(offerForCornerAngle == null)) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = [RoomConnectorConstants_getInstance().POINT_WALL_FLOOR_OFFER, offerForCornerAngle];
        } else {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = [RoomConnectorConstants_getInstance().POINT_WALL_FLOOR_OFFER];
        }
        tmp = tmp_0;
      } else {
        // Inline function 'kotlin.emptyArray' call
        tmp = [];
      }
      var offers = tmp;
      var pointNormal = Companion_instance_118.generateMeanNormalFromAdjacentSurfaces(surfacesForThisPoint);
      var tmp$ret$14 = new RoomConnectorPair(Companion_instance_118.generatePoint(item, pointNormal.X0Z.normalize().unaryMinus(), Companion_getInstance_4().UP, offers), item);
      destination.q(tmp$ret$14);
    }
    return copyToArray(destination);
  };
  protoOf(Companion_85).generatePoint = function (point, connectorUp, roomUp, offers) {
    var pointRotation = Companion_getInstance_6().fromLookDirection(connectorUp, roomUp);
    var connectorTransform = new Transform(point.point, pointRotation);
    return new PointConnector(point.id, 1, connectorTransform, VOID, VOID, VOID, VOID, offers);
  };
  protoOf(Companion_85).generateMeanNormalFromAdjacentSurfaces = function (surfaceGeometries) {
    var meanNormal = Companion_getInstance_4().ZERO;
    var inductionVariable = 0;
    var last = surfaceGeometries.length;
    while (inductionVariable < last) {
      var surface = surfaceGeometries[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var points = surface.surfaceGeometry.points;
      meanNormal = meanNormal.plus(PolyhedronUtils_getInstance().surfaceNormal(points));
    }
    return meanNormal.normalize();
  };
  var Companion_instance_118;
  function Companion_getInstance_94() {
    return Companion_instance_118;
  }
  function RoomConnectorUtilities() {
  }
  function validateAndFixNoCollinearPointsInSurface($this, originalSurface) {
    var vertices = originalSurface;
    var previousIndex = vertices.length - 1 | 0;
    // Inline function 'kotlin.collections.mutableListOf' call
    var listOfVerticesToRemove = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = vertices.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (vertices[index].minus(vertices[previousIndex]).cross(vertices[(index + 1 | 0) % vertices.length | 0].minus(vertices[index])).size < 0.001) {
          $this.n3n_1.warn(RoomGeometryUtilities$Companion$validateAndFixNoCollinearPointsInSurface$lambda(index));
          listOfVerticesToRemove.q(index);
        }
        previousIndex = index;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.count' call
    if (listOfVerticesToRemove.n() > 0) {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = get_indices(vertices);
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.room.utils.Companion.validateAndFixNoCollinearPointsInSurface.<anonymous>' call
        if (!listOfVerticesToRemove.p(element)) {
          destination.q(element);
        }
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.t();
      while (tmp0_iterator_0.u()) {
        var item = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.room.utils.Companion.validateAndFixNoCollinearPointsInSurface.<anonymous>' call
        var tmp$ret$5 = vertices[item];
        destination_0.q(tmp$ret$5);
      }
      return copyToArray(destination_0);
    }
    return originalSurface;
  }
  function validatePlanarSurface($this, coreRoomSurface) {
    var polygon = coreRoomSurface.surfaceGeometry.points;
    var planeNormal = PolyhedronUtils_getInstance().surfaceNormal(polygon);
    var polygonPlane = new Plane(polygon[0], planeNormal);
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var inductionVariable = 0;
    var last = polygon.length;
    while (inductionVariable < last) {
      var item = polygon[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.validatePlanarSurface.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      if (!polygonPlane.contains(item))
        throw Exception_init_$Create$('Polygon supplied to ' + coreRoomSurface.id + ' is not planar, please ensure that each surface in RoomGeometryFormat is planar. The non-planar vertex was found at index ' + tmp1);
    }
  }
  function convertId($this, oldId) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = $this.connectorKeyMap.b3(oldId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'com.ikea.core.stl.room.utils.Companion.convertId.<anonymous>' call
      tmp = oldId;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function convertFromPoint3DToVector(_this__u8e3s4, $this, scale) {
    return new Vector(_this__u8e3s4.x * scale, _this__u8e3s4.y * scale, _this__u8e3s4.z * scale);
  }
  function RoomGeometryUtilities$Companion$interfaceFormatToInternalFormat$lambda() {
    return "A surface with type 'FLOOR' and a surface with type 'CEILING' is both required";
  }
  function RoomGeometryUtilities$Companion$validateAndFixNoCollinearPointsInSurface$lambda($index) {
    return function () {
      return 'Vertex supplied to room geometry at index ' + $index + ' is collinear, removing vertex.';
    };
  }
  function Companion_86() {
    Companion_instance_119 = this;
    this.n3n_1 = LoggerState_getInstance().m1m('RoomGeometryUtilities');
    this.connectorKeyMap = mapOf([to('z-', 'back-wall'), to('x-', 'left-wall'), to('x+', 'right-wall'), to('z+', 'front-wall'), to('z-floor', 'back-wall-floor-edge'), to('x-floor', 'left-wall-floor-edge'), to('x+floor', 'right-wall-floor-edge'), to('z+floor', 'front-wall-floor-edge'), to('c-z-x-floor', 'back-left-corner'), to('c-z-x+floor', 'back-right-corner'), to('c-z+x-floor', 'front-left-corner'), to('c-x+z+floor', 'front-right-corner')]);
  }
  protoOf(Companion_86).generateWallMap = function (convertedData) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = convertedData.walls;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.generateWallMap.<anonymous>' call
      destination.q(item);
    }
    var allWallSurfaces = destination;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [convertedData.floor, convertedData.ceiling];
    var allSurfaces = plus_3(allWallSurfaces, tmp$ret$5);
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(allSurfaces, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(capacity);
    var tmp0_iterator = allSurfaces.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.utils.Companion.generateWallMap.<anonymous>' call
      var tmp$ret$6 = element.id;
      destination_0.r2(tmp$ret$6, element);
    }
    return destination_0;
  };
  protoOf(Companion_86).generateRectangularRoom = function (dimensions) {
    var right = dimensions.X / 2;
    var left = -(dimensions.X / 2);
    var front = dimensions.Z;
    var up = dimensions.Y;
    var backRightCeiling = new Vector(right, up, 0.0);
    var frontRightCeiling = new Vector(right, up, front);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var rightWallVertices = [new Vector(right, 0.0, front), frontRightCeiling, backRightCeiling, new Vector(right, 0.0, 0.0)];
    RoomConnectorConstants_getInstance();
    var rightWall = new CoreRoomSurface('right-wall', new RoomSurfaceGeometryImpl(rightWallVertices));
    var backLeftCeiling = new Vector(left, up, 0.0);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var backWallVertices = [new Vector(left, 0.0, 0.0), new Vector(right, 0.0, 0.0), backRightCeiling, backLeftCeiling];
    RoomConnectorConstants_getInstance();
    var backWall = new CoreRoomSurface('back-wall', new RoomSurfaceGeometryImpl(backWallVertices));
    var frontLeftCeiling = new Vector(left, up, front);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var leftWallVertices = [new Vector(left, 0.0, front), new Vector(left, 0.0, 0.0), backLeftCeiling, frontLeftCeiling];
    RoomConnectorConstants_getInstance();
    var leftWall = new CoreRoomSurface('left-wall', new RoomSurfaceGeometryImpl(leftWallVertices));
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var frontWallVertices = [new Vector(right, 0.0, front), new Vector(left, 0.0, front), frontLeftCeiling, frontRightCeiling];
    RoomConnectorConstants_getInstance();
    var frontWall = new CoreRoomSurface('front-wall', new RoomSurfaceGeometryImpl(frontWallVertices));
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var floorVertices = [new Vector(left, 0.0, 0.0), new Vector(left, 0.0, front), new Vector(right, 0.0, front), new Vector(right, 0.0, 0.0)];
    RoomConnectorConstants_getInstance();
    var floor = new CoreRoomSurface('ground', new RoomSurfaceGeometryImpl(floorVertices));
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ceilingVertices = [backLeftCeiling, backRightCeiling, frontRightCeiling, frontLeftCeiling];
    RoomConnectorConstants_getInstance();
    var ceiling = new CoreRoomSurface('ceiling', new RoomSurfaceGeometryImpl(ceilingVertices));
    RoomConnectorConstants_getInstance();
    var backEdge = new CoreRoomEdge('back-wall-floor-edge', backWall.id, floor.id, new Vector(left, 0.0, 0.0), new Vector(right, 0.0, 0.0));
    RoomConnectorConstants_getInstance();
    var leftEdge = new CoreRoomEdge('left-wall-floor-edge', leftWall.id, floor.id, new Vector(left, 0.0, front), new Vector(left, 0.0, 0.0));
    RoomConnectorConstants_getInstance();
    var rightEdge = new CoreRoomEdge('right-wall-floor-edge', rightWall.id, floor.id, new Vector(right, 0.0, front), new Vector(right, 0.0, 0.0));
    RoomConnectorConstants_getInstance();
    var frontEdge = new CoreRoomEdge('front-wall-floor-edge', frontWall.id, floor.id, new Vector(left, 0.0, front), new Vector(right, 0.0, front));
    RoomConnectorConstants_getInstance();
    var backCeilingEdge = new CoreRoomEdge('back-wall-ceiling-edge', backWall.id, ceiling.id, backLeftCeiling, backRightCeiling);
    RoomConnectorConstants_getInstance();
    var leftCeilingEdge = new CoreRoomEdge('left-wall-ceiling-edge', leftWall.id, ceiling.id, frontLeftCeiling, backLeftCeiling);
    RoomConnectorConstants_getInstance();
    var rightCeilingEdge = new CoreRoomEdge('right-wall-ceiling-edge', rightWall.id, ceiling.id, frontRightCeiling, backRightCeiling);
    RoomConnectorConstants_getInstance();
    var frontCeilingEdge = new CoreRoomEdge('front-wall-ceiling-edge', frontWall.id, ceiling.id, frontLeftCeiling, frontRightCeiling);
    RoomConnectorConstants_getInstance();
    var tmp = new Vector(left, 0.0, 0.0);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [backWall.id, leftWall.id, floor.id];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$23 = [backEdge.id, leftEdge.id];
    var backLeftVertex = new CoreRoomVertex('back-left-corner', tmp, tmp_0, tmp$ret$23);
    RoomConnectorConstants_getInstance();
    var tmp_1 = new Vector(right, 0.0, 0.0);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_2 = [backWall.id, rightWall.id, floor.id];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$29 = [backEdge.id, rightEdge.id];
    var backRightVertex = new CoreRoomVertex('back-right-corner', tmp_1, tmp_2, tmp$ret$29);
    RoomConnectorConstants_getInstance();
    var tmp_3 = new Vector(right, 0.0, front);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_4 = [frontWall.id, rightWall.id, floor.id];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$35 = [frontEdge.id, leftEdge.id];
    var frontRightVertex = new CoreRoomVertex('front-right-corner', tmp_3, tmp_4, tmp$ret$35);
    RoomConnectorConstants_getInstance();
    var tmp_5 = new Vector(left, 0.0, front);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_6 = [frontWall.id, leftWall.id, floor.id];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$41 = [frontEdge.id, rightEdge.id];
    var frontLeftVertex = new CoreRoomVertex('front-left-corner', tmp_5, tmp_6, tmp$ret$41);
    RoomConnectorConstants_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_7 = [backWall.id, leftWall.id, ceiling.id];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$47 = [backCeilingEdge.id, leftCeilingEdge.id];
    var backLeftCeilingVertex = new CoreRoomVertex('back-left-corner-ceiling', backLeftCeiling, tmp_7, tmp$ret$47);
    RoomConnectorConstants_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_8 = [backWall.id, rightWall.id, ceiling.id];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$53 = [backCeilingEdge.id, rightCeilingEdge.id];
    var backRightCeilingVertex = new CoreRoomVertex('back-right-corner-ceiling', backRightCeiling, tmp_8, tmp$ret$53);
    RoomConnectorConstants_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_9 = [frontWall.id, rightWall.id, ceiling.id];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$59 = [frontCeilingEdge.id, leftCeilingEdge.id];
    var frontRightCeilingVertex = new CoreRoomVertex('front-right-corner-ceiling', frontRightCeiling, tmp_9, tmp$ret$59);
    RoomConnectorConstants_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_10 = [frontWall.id, leftWall.id, ceiling.id];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$65 = [frontCeilingEdge.id, rightCeilingEdge.id];
    var frontLeftCeilingVertex = new CoreRoomVertex('front-left-corner-ceiling', frontLeftCeiling, tmp_10, tmp$ret$65);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_11 = [rightWall, backWall, leftWall, frontWall];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_12 = [backEdge, leftEdge, rightEdge, frontEdge, backCeilingEdge, leftCeilingEdge, rightCeilingEdge, frontCeilingEdge];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_13 = [backLeftVertex, backRightVertex, frontRightVertex, frontLeftVertex, backLeftCeilingVertex, backRightCeilingVertex, frontRightCeilingVertex, frontLeftCeilingVertex];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$75 = [];
    return new CoreRoomGeometryData(tmp_11, floor, ceiling, tmp_12, tmp_13, tmp$ret$75);
  };
  protoOf(Companion_86).interfaceFormatToInternalFormat = function (roomGeometryData, scale) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = roomGeometryData.surfaces;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
      if (element.type === 'WALL') {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var item = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
      var tmp = convertId(Companion_getInstance_95(), item.id);
      var tmp_0 = Companion_getInstance_95();
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = item.vertices;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(this_1.length);
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var item_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>.<anonymous>' call
        var tmp$ret$3 = convertFromPoint3DToVector(item_0, Companion_getInstance_95(), scale);
        destination_1.q(tmp$ret$3);
      }
      var tmp$ret$6 = copyToArray(destination_1);
      var tmp$ret$7 = new CoreRoomSurface(tmp, new RoomSurfaceGeometryImpl(validateAndFixNoCollinearPointsInSurface(tmp_0, tmp$ret$6)));
      destination_0.q(tmp$ret$7);
    }
    var convertedWalls = copyToArray(destination_0);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable_1 = 0;
    var last_1 = convertedWalls.length;
    while (inductionVariable_1 < last_1) {
      var element_0 = convertedWalls[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
      validatePlanarSurface(Companion_getInstance_95(), element_0);
    }
    var tmp0_safe_receiver = roomGeometryData.obstacles;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_2 = ArrayList_init_$Create$_0(tmp0_safe_receiver.length);
      var inductionVariable_2 = 0;
      var last_2 = tmp0_safe_receiver.length;
      while (inductionVariable_2 < last_2) {
        var item_1 = tmp0_safe_receiver[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
        var inputRotation = item_1.boundingBox.transform.rotation;
        var inputPosition = item_1.boundingBox.transform.position;
        var rotation = QuaternionFromDouble(inputRotation.w, inputRotation.x, inputRotation.y, inputRotation.z);
        var localPosition = convertFromPoint3DToVector(inputPosition, Companion_getInstance_95(), scale);
        var tmp$ret$11 = new CoreRoomObstacle(item_1.id, item_1.type, new CoreRoomBoundingBox(convertFromPoint3DToVector(item_1.boundingBox.size, Companion_getInstance_95(), scale), new Transform(localPosition, rotation)));
        destination_2.q(tmp$ret$11);
      }
      tmp_1 = destination_2;
    }
    var tmp1_safe_receiver = tmp_1;
    var tmp_2;
    if (tmp1_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_2 = copyToArray(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp_2;
    var tmp_3;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_3 = [];
    } else {
      tmp_3 = tmp2_elvis_lhs;
    }
    var obstacles = tmp_3;
    // Inline function 'kotlin.collections.find' call
    var this_2 = roomGeometryData.surfaces;
    var tmp$ret$17;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_3 = 0;
      var last_3 = this_2.length;
      while (inductionVariable_3 < last_3) {
        var element_1 = this_2[inductionVariable_3];
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
        if (element_1.type === 'FLOOR') {
          tmp$ret$17 = element_1;
          break $l$block;
        }
      }
      tmp$ret$17 = null;
    }
    var floor = tmp$ret$17;
    // Inline function 'kotlin.collections.find' call
    var this_3 = roomGeometryData.surfaces;
    var tmp$ret$20;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_4 = 0;
      var last_4 = this_3.length;
      while (inductionVariable_4 < last_4) {
        var element_2 = this_3[inductionVariable_4];
        inductionVariable_4 = inductionVariable_4 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
        if (element_2.type === 'CEILING') {
          tmp$ret$20 = element_2;
          break $l$block_0;
        }
      }
      tmp$ret$20 = null;
    }
    var ceiling = tmp$ret$20;
    var tmp_4;
    if (!(floor == null) ? !(ceiling == null) : false) {
      var tmp_5 = convertId(this, floor.id);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_4 = floor.vertices;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList_init_$Create$_0(this_4.length);
      var inductionVariable_5 = 0;
      var last_5 = this_4.length;
      while (inductionVariable_5 < last_5) {
        var item_2 = this_4[inductionVariable_5];
        inductionVariable_5 = inductionVariable_5 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
        var tmp$ret$22 = convertFromPoint3DToVector(item_2, Companion_getInstance_95(), scale);
        destination_3.q(tmp$ret$22);
      }
      var tmp$ret$25 = copyToArray(destination_3);
      var convertedFloor = new CoreRoomSurface(tmp_5, new RoomSurfaceGeometryImpl(validateAndFixNoCollinearPointsInSurface(this, tmp$ret$25)));
      validatePlanarSurface(this, convertedFloor);
      var tmp_6 = convertId(this, ceiling.id);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_5 = ceiling.vertices;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_4 = ArrayList_init_$Create$_0(this_5.length);
      var inductionVariable_6 = 0;
      var last_6 = this_5.length;
      while (inductionVariable_6 < last_6) {
        var item_3 = this_5[inductionVariable_6];
        inductionVariable_6 = inductionVariable_6 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
        var tmp$ret$26 = convertFromPoint3DToVector(item_3, Companion_getInstance_95(), scale);
        destination_4.q(tmp$ret$26);
      }
      var tmp$ret$29 = copyToArray(destination_4);
      var convertedCeiling = new CoreRoomSurface(tmp_6, new RoomSurfaceGeometryImpl(validateAndFixNoCollinearPointsInSurface(this, tmp$ret$29)));
      validatePlanarSurface(this, convertedCeiling);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_6 = roomGeometryData.edges;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_5 = ArrayList_init_$Create$_0(this_6.length);
      var inductionVariable_7 = 0;
      var last_7 = this_6.length;
      while (inductionVariable_7 < last_7) {
        var item_4 = this_6[inductionVariable_7];
        inductionVariable_7 = inductionVariable_7 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
        var tmp$ret$30 = new CoreRoomEdge(convertId(Companion_getInstance_95(), item_4.id), convertId(Companion_getInstance_95(), item_4.surface1), convertId(Companion_getInstance_95(), item_4.surface2), convertFromPoint3DToVector(item_4.vertex1, Companion_getInstance_95(), scale), convertFromPoint3DToVector(item_4.vertex2, Companion_getInstance_95(), scale));
        destination_5.q(tmp$ret$30);
      }
      var convertedEdges = copyToArray(destination_5);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_7 = roomGeometryData.corners;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_6 = ArrayList_init_$Create$_0(this_7.length);
      var inductionVariable_8 = 0;
      var last_8 = this_7.length;
      while (inductionVariable_8 < last_8) {
        var item_5 = this_7[inductionVariable_8];
        inductionVariable_8 = inductionVariable_8 + 1 | 0;
        // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>' call
        var tmp_7 = convertId(Companion_getInstance_95(), item_5.id);
        var tmp_8 = convertFromPoint3DToVector(item_5.position, Companion_getInstance_95(), scale);
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_8 = item_5.surfaces;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_7 = ArrayList_init_$Create$_0(this_8.length);
        var inductionVariable_9 = 0;
        var last_9 = this_8.length;
        while (inductionVariable_9 < last_9) {
          var item_6 = this_8[inductionVariable_9];
          inductionVariable_9 = inductionVariable_9 + 1 | 0;
          // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>.<anonymous>' call
          var tmp$ret$34 = convertId(Companion_getInstance_95(), item_6);
          destination_7.q(tmp$ret$34);
        }
        var tmp_9 = copyToArray(destination_7);
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_9 = item_5.edges;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_8 = ArrayList_init_$Create$_0(this_9.length);
        var inductionVariable_10 = 0;
        var last_10 = this_9.length;
        while (inductionVariable_10 < last_10) {
          var item_7 = this_9[inductionVariable_10];
          inductionVariable_10 = inductionVariable_10 + 1 | 0;
          // Inline function 'com.ikea.core.stl.room.utils.Companion.interfaceFormatToInternalFormat.<anonymous>.<anonymous>' call
          var tmp$ret$38 = convertId(Companion_getInstance_95(), item_7);
          destination_8.q(tmp$ret$38);
        }
        var tmp$ret$41 = copyToArray(destination_8);
        var tmp$ret$42 = new CoreRoomVertex(tmp_7, tmp_8, tmp_9, tmp$ret$41);
        destination_6.q(tmp$ret$42);
      }
      var convertedVertices = copyToArray(destination_6);
      tmp_4 = new CoreRoomGeometryData(convertedWalls, convertedFloor, convertedCeiling, convertedEdges, convertedVertices, obstacles);
    } else {
      this.n3n_1.warn(RoomGeometryUtilities$Companion$interfaceFormatToInternalFormat$lambda);
      tmp_4 = null;
    }
    return tmp_4;
  };
  protoOf(Companion_86).o3n = function () {
    return this.connectorKeyMap;
  };
  var Companion_instance_119;
  function Companion_getInstance_95() {
    if (Companion_instance_119 == null)
      new Companion_86();
    return Companion_instance_119;
  }
  function RoomGeometryUtilities() {
    Companion_getInstance_95();
  }
  function StandardSelectionService(entityManager) {
    this.entityManager = entityManager;
    this.p3n_1 = this.entityManager.createEntity();
    this.entityManager.addComponent(this.p3n_1, new DisplayNameComponent('Config-StandardSelectionService'));
  }
  protoOf(StandardSelectionService).p1i = function () {
    return this.entityManager;
  };
  protoOf(StandardSelectionService).isMultiSelect = function () {
    return this.p3n_1.hasComponent(MultiSelectionEnabledComponent_instance.id);
  };
  protoOf(StandardSelectionService).setMultiSelect = function (multiSelect) {
    if (multiSelect) {
      this.entityManager.addComponent(this.p3n_1, MultiSelectionEnabledComponent_instance);
    } else {
      this.entityManager.removeComponent(this.p3n_1, MultiSelectionEnabledComponent_instance.id);
    }
  };
  protoOf(StandardSelectionService).select = function (entity) {
    var tmp0_safe_receiver = get_selectableRoot(entity);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.addComponent(SelectedComponent_instance);
  };
  protoOf(StandardSelectionService).toggle = function (entity) {
    var tmp0_elvis_lhs = get_selectableRoot(entity);
    var e = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    if (e.hasComponent(SelectedComponent_instance.id)) {
      this.unselect(e);
    } else {
      this.select(e);
    }
  };
  protoOf(StandardSelectionService).unselect = function (entity) {
    this.entityManager.removeComponent(entity, SelectedComponent_instance.id);
  };
  protoOf(StandardSelectionService).unselectAll = function () {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.entityManager.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.unselect(element);
    }
  };
  function StandardSelectionSystem_init_$Init$(coreServices, $this) {
    StandardSelectionSystem.call($this, coreServices.entityManager, coreServices.sceneManager);
    return $this;
  }
  function StandardSelectionSystemFromCoreServices(coreServices) {
    return StandardSelectionSystem_init_$Init$(coreServices, objectCreate(protoOf(StandardSelectionSystem)));
  }
  function onClickNothing($this) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.y3n_1.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.selection.StandardSelectionSystem.onClickNothing.<anonymous>' call
      $this.y3n_1.removeComponent(element, SelectedComponent_instance.id);
    }
  }
  function onEntityClicked($this, entity) {
    var tmp0_elvis_lhs = get_selectableRoot(entity);
    var selectableRootEntity = tmp0_elvis_lhs == null ? entity : tmp0_elvis_lhs;
    if (selectableRootEntity.hasComponent(SelectedComponent_instance.id)) {
      $this.y3n_1.removeComponent(selectableRootEntity, SelectedComponent_instance.id);
    } else {
      if (selectableRootEntity.hasComponent(1)) {
        $this.y3n_1.addComponent(selectableRootEntity, SelectedComponent_instance);
      }
    }
  }
  function onEntityReplaced($this, oldEntity, entity) {
    var tmp;
    if (oldEntity.hasComponent(SelectedComponent_instance.id)) {
      tmp = entity.hasComponent(1);
    } else {
      tmp = false;
    }
    if (tmp) {
      oldEntity.removeComponent(SelectedComponent_instance.id);
      entity.addComponent(SelectedComponent_instance);
    }
  }
  function onEntityDeleted($this, entity) {
    entity.removeComponent(SelectedComponent_instance.id);
  }
  function onEntitySelected($this, entity) {
    if (!$this.a3o_1) {
      // Inline function 'kotlin.collections.forEach' call
      var indexedObject = $this.y3n_1.entities;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.selection.StandardSelectionSystem.onEntitySelected.<anonymous>' call
        if (!entity.equals(element)) {
          $this.y3n_1.removeComponent(element, SelectedComponent_instance.id);
        }
      }
    }
  }
  function Companion_87() {
    this.ID = 'StandardSelectionSystem';
  }
  protoOf(Companion_87).u1n = function () {
    return this.ID;
  };
  var Companion_instance_120;
  function Companion_getInstance_96() {
    return Companion_instance_120;
  }
  function StandardSelectionSystem$onEntityDeleted$ref($boundThis) {
    var l = function (p0) {
      onEntityDeleted($boundThis, p0);
      return Unit_instance;
    };
    l.callableName = 'onEntityDeleted';
    return l;
  }
  function StandardSelectionSystem(entityManager, sceneManager) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [0];
    SystemBase4.call(this, 'StandardSelectionSystem', 131, 86, 0, 56, tmp$ret$2, null, null);
    this.y3n_1 = entityManager;
    this.z3n_1 = sceneManager;
    this.a3o_1 = false;
    this.y3n_1.subscribeEntityRemoved(StandardSelectionSystem$onEntityDeleted$ref(this));
    var tmp = this;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = this.y3n_1.entities;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.selection.StandardSelectionSystem.<anonymous>' call
        if (element.hasComponent(56)) {
          tmp$ret$4 = true;
          break $l$block;
        }
      }
      tmp$ret$4 = false;
    }
    tmp.a3o_1 = tmp$ret$4;
  }
  protoOf(StandardSelectionSystem).onAddComponent = function (entity, newComponent) {
    onEntityReplaced(this, newComponent.oldEntity, entity);
  };
  protoOf(StandardSelectionSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(StandardSelectionSystem).onRemoveComponent = function (entity, oldComponent) {
  };
  protoOf(StandardSelectionSystem).onAddComponent2 = function (entity, newComponent) {
    if (this.z3n_1.scene.equals(entity)) {
      onClickNothing(this);
    } else {
      onEntityClicked(this, entity);
    }
  };
  protoOf(StandardSelectionSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(StandardSelectionSystem).onRemoveComponent2 = function (entity, oldComponent) {
  };
  protoOf(StandardSelectionSystem).onAddComponent3 = function (entity, newComponent) {
    onEntitySelected(this, entity);
  };
  protoOf(StandardSelectionSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
  };
  protoOf(StandardSelectionSystem).onRemoveComponent3 = function (entity, oldComponent) {
  };
  protoOf(StandardSelectionSystem).onAddComponent4 = function (entity, newComponent) {
    this.a3o_1 = true;
  };
  protoOf(StandardSelectionSystem).onUpdateComponent4 = function (entity, oldComponent, newComponent) {
  };
  protoOf(StandardSelectionSystem).onRemoveComponent4 = function (entity, oldComponent) {
    this.a3o_1 = false;
  };
  function StlSystemIds() {
    this.ALIGNMENT_CONNECTION_CREATION_SYSTEM = 'AlignmentConnectionCreationSystem';
    this.ALIGNMENT_LINES_SYSTEM_ID = 'AlignmentLinesSystem';
    this.DRAG_SYSTEM_ID = 'DragSystem';
    this.HANDLE_ROTATION_SYSTEM_ID = 'HandleRotationSystem';
    this.FUNCTIONAL_MARGIN_SYSTEM_ID = 'FunctionalMarginSystem';
    this.OUTLINE_SELECTED_SYSTEM_ID = 'OutlineSelectedSystem';
    this.PROPPING_SYSTEM_ID = 'ProppingSystem';
    this.ROOM_SYSTEM_ID = 'RoomSystem';
    this.ROOM_DIMENSION_TO_GEOMETRY_SYSTEM_ID = 'RoomDimensionToGeometrySystem';
    this.LEGACY_CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM = 'LegacyCanvasTo3DDragConverterSystem';
    this.CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM = 'CanvasTo3DDragConverterSystem';
    this.AUTO_ADAPT_PRODUCT_SPECIFICATION_SYSTEM_ID = 'AutoAdaptProductSpecificationSystem';
    this.STANDARD_SELECTION_SYSTEM_SYSTEM_ID = 'StandardSelectionSystem';
    this.AUTO_ADAPT_DISPOSE_FAILED_CHILDREN_SYSTEM_ID = 'AutoAdaptDisposeFailedChildrenSystem';
  }
  protoOf(StlSystemIds).b3o = function () {
    return this.ALIGNMENT_CONNECTION_CREATION_SYSTEM;
  };
  protoOf(StlSystemIds).c3o = function () {
    return this.ALIGNMENT_LINES_SYSTEM_ID;
  };
  protoOf(StlSystemIds).d3o = function () {
    return this.DRAG_SYSTEM_ID;
  };
  protoOf(StlSystemIds).e3o = function () {
    return this.HANDLE_ROTATION_SYSTEM_ID;
  };
  protoOf(StlSystemIds).f3o = function () {
    return this.FUNCTIONAL_MARGIN_SYSTEM_ID;
  };
  protoOf(StlSystemIds).g3o = function () {
    return this.OUTLINE_SELECTED_SYSTEM_ID;
  };
  protoOf(StlSystemIds).h3o = function () {
    return this.PROPPING_SYSTEM_ID;
  };
  protoOf(StlSystemIds).i3o = function () {
    return this.ROOM_SYSTEM_ID;
  };
  protoOf(StlSystemIds).j3o = function () {
    return this.ROOM_DIMENSION_TO_GEOMETRY_SYSTEM_ID;
  };
  protoOf(StlSystemIds).k3o = function () {
    return this.LEGACY_CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM;
  };
  protoOf(StlSystemIds).l3o = function () {
    return this.CANVAS_TO_3D_DRAG_CONVERTER_SYSTEM;
  };
  protoOf(StlSystemIds).m3o = function () {
    return this.AUTO_ADAPT_PRODUCT_SPECIFICATION_SYSTEM_ID;
  };
  protoOf(StlSystemIds).n3o = function () {
    return this.STANDARD_SELECTION_SYSTEM_SYSTEM_ID;
  };
  protoOf(StlSystemIds).o3o = function () {
    return this.AUTO_ADAPT_DISPOSE_FAILED_CHILDREN_SYSTEM_ID;
  };
  var StlSystemIds_instance;
  function StlSystemIds_getInstance() {
    return StlSystemIds_instance;
  }
  function Companion_88() {
    Companion_instance_121 = this;
    this.accumulatedDelta = Companion_getInstance_4().ZERO;
    this.originalPosition = Companion_getInstance_4().ZERO;
  }
  protoOf(Companion_88).p3o = function (_set____db54di) {
    this.accumulatedDelta = _set____db54di;
  };
  protoOf(Companion_88).q3o = function () {
    return this.accumulatedDelta;
  };
  protoOf(Companion_88).r3o = function (_set____db54di) {
    this.originalPosition = _set____db54di;
  };
  protoOf(Companion_88).s3o = function () {
    return this.originalPosition;
  };
  protoOf(Companion_88).t3o = function (_this__u8e3s4, coreServices, delta, steps) {
    return simulateEntireDragInSteps(_this__u8e3s4, coreServices, delta, steps);
  };
  protoOf(Companion_88).simulateEntireDragInSteps = function (_this__u8e3s4, coreServices, delta, steps, $super) {
    steps = steps === VOID ? 100 : steps;
    return this.t3o(_this__u8e3s4, coreServices, delta, steps);
  };
  protoOf(Companion_88).simulateEntireDrag = function (_this__u8e3s4, coreServices, delta) {
    return simulateEntireDrag(_this__u8e3s4, coreServices, delta);
  };
  protoOf(Companion_88).simulateStartDrag = function (_this__u8e3s4, coreServices) {
    return simulateStartDrag(_this__u8e3s4, coreServices);
  };
  protoOf(Companion_88).simulateOngoingDrag = function (_this__u8e3s4, coreServices, delta) {
    return simulateOngoingDrag(_this__u8e3s4, coreServices, delta);
  };
  protoOf(Companion_88).simulateEndDrag = function (_this__u8e3s4, coreServices) {
    return simulateEndDrag(_this__u8e3s4, coreServices);
  };
  var Companion_instance_121;
  function Companion_getInstance_97() {
    if (Companion_instance_121 == null)
      new Companion_88();
    return Companion_instance_121;
  }
  function DragExtensions() {
    Companion_getInstance_97();
  }
  function simulateEntireDragInSteps(_this__u8e3s4, coreServices, totalDelta, steps) {
    steps = steps === VOID ? 100 : steps;
    simulateStartDrag(_this__u8e3s4, coreServices);
    var delta = totalDelta.__divIntForKotlin(steps);
    var inductionVariable = 1;
    if (inductionVariable <= steps)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        simulateOngoingDrag(_this__u8e3s4, coreServices, delta);
      }
       while (!(i === steps));
    simulateEndDrag(_this__u8e3s4, coreServices);
  }
  function simulateEntireDrag(_this__u8e3s4, coreServices, delta) {
    simulateStartDrag(_this__u8e3s4, coreServices);
    simulateOngoingDrag(_this__u8e3s4, coreServices, delta);
    simulateEndDrag(_this__u8e3s4, coreServices);
  }
  function rayFromMiddleOfRoomToDragPoint(point, coreServices) {
    var defaultCamPos = __VectorIntConstructorKotlin(0, 0, 2000);
    var defaultRay = new Ray(defaultCamPos, point.minus(defaultCamPos));
    // Inline function 'kotlin.collections.find' call
    var this_0 = coreServices.sceneManager.entities;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.test.rayFromMiddleOfRoomToDragPoint.<anonymous>' call
        Companion_getInstance_88();
        if (element.hasComponent(70)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return defaultRay;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var room = tmp;
    Companion_getInstance_88();
    var tmp1_elvis_lhs = room.__getComponentForKotlin(70);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return defaultRay;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var roomDimensions = tmp_0;
    var middleOfRoom = new Vector(0.0, roomDimensions.dimensions.height / 2, roomDimensions.dimensions.depth / 2);
    return new Ray(middleOfRoom, point.minus(middleOfRoom));
  }
  function simulateStartDrag(_this__u8e3s4, coreServices, point) {
    point = point === VOID ? null : point;
    var tmp0_elvis_lhs = get_draggableRootEntity(_this__u8e3s4);
    var draggedEntity = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    var dragPoint = point == null ? get_worldPosition(draggedEntity) : point;
    Companion_getInstance_97().accumulatedDelta = Companion_getInstance_4().ZERO;
    Companion_getInstance_97().originalPosition = dragPoint;
    draggedEntity.addComponent(new WorldSpaceDragEventComponent(dragPoint, rayFromMiddleOfRoomToDragPoint(dragPoint, coreServices)));
  }
  function simulateOngoingDrag(_this__u8e3s4, coreServices, delta) {
    var tmp0_elvis_lhs = get_draggableRootEntity(_this__u8e3s4);
    var draggedEntity = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    var tmp1_this = Companion_getInstance_97();
    tmp1_this.accumulatedDelta = tmp1_this.accumulatedDelta.plus(delta);
    var point = Companion_getInstance_97().originalPosition.plus(Companion_getInstance_97().accumulatedDelta);
    draggedEntity.addComponent(new WorldSpaceDragEventComponent(point, rayFromMiddleOfRoomToDragPoint(point, coreServices)));
  }
  function simulateEndDrag(_this__u8e3s4, coreServices) {
    var tmp0_elvis_lhs = get_draggableRootEntity(_this__u8e3s4);
    var draggedEntity = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    Companion_getInstance_97().accumulatedDelta = Companion_getInstance_4().ZERO;
    Companion_getInstance_97().originalPosition = Companion_getInstance_4().ZERO;
    coreServices.entityManager.removeComponent(draggedEntity, 85);
  }
  function ViewerDragState() {
    ViewerDragState_instance = this;
    this.worldCameraPosition = Companion_getInstance_4().ZERO;
    this.accumulatedDelta = Companion_getInstance_4().ZERO;
    this.originalPosition = Companion_getInstance_4().ZERO;
  }
  protoOf(ViewerDragState).u3o = function (_set____db54di) {
    this.worldCameraPosition = _set____db54di;
  };
  protoOf(ViewerDragState).v3o = function () {
    return this.worldCameraPosition;
  };
  protoOf(ViewerDragState).p3o = function (_set____db54di) {
    this.accumulatedDelta = _set____db54di;
  };
  protoOf(ViewerDragState).q3o = function () {
    return this.accumulatedDelta;
  };
  protoOf(ViewerDragState).r3o = function (_set____db54di) {
    this.originalPosition = _set____db54di;
  };
  protoOf(ViewerDragState).s3o = function () {
    return this.originalPosition;
  };
  protoOf(ViewerDragState).reset = function () {
    this.worldCameraPosition = Companion_getInstance_4().ZERO;
    this.accumulatedDelta = Companion_getInstance_4().ZERO;
    this.originalPosition = Companion_getInstance_4().ZERO;
  };
  var ViewerDragState_instance;
  function ViewerDragState_getInstance() {
    if (ViewerDragState_instance == null)
      new ViewerDragState();
    return ViewerDragState_instance;
  }
  function simulateEntireViewerDragInSteps(_this__u8e3s4, coreServices, totalDelta, localGrabPoint, worldCameraPosition, steps) {
    localGrabPoint = localGrabPoint === VOID ? Companion_getInstance_4().ZERO : localGrabPoint;
    worldCameraPosition = worldCameraPosition === VOID ? Companion_getInstance_4().BACK.__timesIntForKotlin(8000).plus(Companion_getInstance_4().UP.times(1000.0)) : worldCameraPosition;
    steps = steps === VOID ? 100 : steps;
    simulateViewerStartDrag(_this__u8e3s4, coreServices, localGrabPoint, worldCameraPosition);
    var delta = totalDelta.__divIntForKotlin(steps);
    var inductionVariable = 1;
    if (inductionVariable <= steps)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        simulateViewerOngoingDrag(_this__u8e3s4, coreServices, delta);
      }
       while (!(i === steps));
    simulateViewerEndDrag(_this__u8e3s4, coreServices);
  }
  function simulateViewerStartDrag(_this__u8e3s4, coreServices, localGrabPoint, worldCameraPosition) {
    localGrabPoint = localGrabPoint === VOID ? Companion_getInstance_4().ZERO : localGrabPoint;
    worldCameraPosition = worldCameraPosition === VOID ? Companion_getInstance_4().BACK.__timesIntForKotlin(3000) : worldCameraPosition;
    var dragPoint = get_worldTransform(_this__u8e3s4).transformPosition(localGrabPoint);
    ViewerDragState_getInstance().accumulatedDelta = Companion_getInstance_4().ZERO;
    ViewerDragState_getInstance().originalPosition = dragPoint;
    ViewerDragState_getInstance().worldCameraPosition = worldCameraPosition;
    var normal = worldCameraPosition.minus(dragPoint).normalize();
    coreServices.entityManager.addComponent(_this__u8e3s4, new ViewerDragEventComponent(dragPoint, normal, Companion_getInstance_4().ZERO, worldCameraPosition));
  }
  function simulateViewerOngoingDrag(_this__u8e3s4, coreServices, delta) {
    var tmp0_this = ViewerDragState_getInstance();
    tmp0_this.accumulatedDelta = tmp0_this.accumulatedDelta.plus(delta);
    var point = ViewerDragState_getInstance().originalPosition.plus(ViewerDragState_getInstance().accumulatedDelta);
    var normal = ViewerDragState_getInstance().worldCameraPosition.minus(point).normalize();
    coreServices.entityManager.addComponent(_this__u8e3s4, new ViewerDragEventComponent(point, normal, Companion_getInstance_4().ZERO, ViewerDragState_getInstance().worldCameraPosition));
  }
  function simulateViewerEndDrag(_this__u8e3s4, coreServices) {
    ViewerDragState_getInstance().reset();
    coreServices.entityManager.removeComponent(_this__u8e3s4, 84);
  }
  function Companion_89() {
    this.ID = 'AllowedNumberOfChildrenOfType';
  }
  protoOf(Companion_89).u1n = function () {
    return this.ID;
  };
  var Companion_instance_122;
  function Companion_getInstance_98() {
    return Companion_instance_122;
  }
  function validate_2($this, entity, snapActionCandidate) {
    var tmp1_elvis_lhs = snapActionCandidate == null ? null : snapActionCandidate.host;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_parent(entity) : tmp1_elvis_lhs;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var parent = tmp;
    var ancestor = oldestAncestorWithComponent(parent, $this, $this.x3o_1);
    if (ancestor == null) {
      return null;
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_children(ancestor);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.validation.AllowedNumberOfChildrenOfTypeValidation.validate.<anonymous>' call
      if (!element.equals(entity)) {
        destination.q(element);
      }
    }
    var currentChildrenWithComponent = countDescendantsWithComponent($this, destination, $this.y3o_1);
    var tmp3_safe_receiver = entity.__getComponentForKotlin(129);
    var originalEntity = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.originalEntity;
    var interestingChild = countEntitiesInHierarchyWithComponent($this, originalEntity == null ? entity : originalEntity, $this.y3o_1);
    var totalChildrenWithComponent = currentChildrenWithComponent + interestingChild | 0;
    var tmp_0;
    if (totalChildrenWithComponent <= $this.z3o_1) {
      tmp_0 = null;
    } else {
      tmp_0 = new InvalidNumberOfChildren('To many (max: ' + $this.z3o_1 + ') children with component ' + $this.y3o_1 + ' to parent with component ' + $this.x3o_1 + '. Children before: ' + currentChildrenWithComponent + '. Children now: ' + totalChildrenWithComponent, get_productRefOrEmptyString(entity), $this);
    }
    return tmp_0;
  }
  function countEntitiesInHierarchyWithComponent($this, entity, componentId) {
    var sum = 0;
    if (entity.hasComponent(componentId)) {
      sum = sum + 1 | 0;
    }
    var tmp = sum;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var indexedObject = get_descendants(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_0 = sum_0;
      // Inline function 'com.ikea.core.stl.validation.AllowedNumberOfChildrenOfTypeValidation.countEntitiesInHierarchyWithComponent.<anonymous>' call
      sum_0 = tmp_0 + countEntitiesInHierarchyWithComponent($this, element, componentId) | 0;
    }
    sum = tmp + sum_0 | 0;
    return sum;
  }
  function countDescendantsWithComponent($this, descendants, componentId) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = descendants.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      var tmp = sum;
      // Inline function 'com.ikea.core.stl.validation.AllowedNumberOfChildrenOfTypeValidation.countDescendantsWithComponent.<anonymous>' call
      sum = tmp + countEntitiesInHierarchyWithComponent($this, element, componentId) | 0;
    }
    return sum;
  }
  function oldestAncestorWithComponent(_this__u8e3s4, $this, componentId) {
    var tmp0_safe_receiver = get_parent(_this__u8e3s4);
    var ancestorWithComponent = tmp0_safe_receiver == null ? null : oldestAncestorWithComponent(tmp0_safe_receiver, $this, componentId);
    if (!(ancestorWithComponent == null)) {
      return ancestorWithComponent;
    }
    if (_this__u8e3s4.hasComponent(componentId)) {
      return _this__u8e3s4;
    }
    return null;
  }
  function AllowedNumberOfChildrenOfTypeValidation(hostComponentId, childComponentId, allowedChildrenCnt) {
    ValidationImpl.call(this);
    this.x3o_1 = hostComponentId;
    this.y3o_1 = childComponentId;
    this.z3o_1 = allowedChildrenCnt;
    this.a3p_1 = 'AllowedNumberOfChildrenOfType';
  }
  protoOf(AllowedNumberOfChildrenOfTypeValidation).s1k = function () {
    return this.a3p_1;
  };
  protoOf(AllowedNumberOfChildrenOfTypeValidation).validateCurrentState = function (entity) {
    return validate_2(this, entity, null);
  };
  protoOf(AllowedNumberOfChildrenOfTypeValidation).validateSnap = function (snapActionCandidate) {
    return validate_2(this, snapActionCandidate.guestRoot, snapActionCandidate);
  };
  function Companion_90() {
    this.ID = 'DisallowSeparateRequiredHosts';
  }
  protoOf(Companion_90).u1n = function () {
    return this.ID;
  };
  var Companion_instance_123;
  function Companion_getInstance_99() {
    return Companion_instance_123;
  }
  function validate_3($this, entity, snapActionCandidate) {
    if (!entity.hasComponent($this.c3p_1))
      return null;
    var tmp1_elvis_lhs = snapActionCandidate == null ? null : snapActionCandidate.guestRoot;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? get_snapRoot(entity) : tmp1_elvis_lhs;
    var guestRoot = tmp2_elvis_lhs == null ? entity : tmp2_elvis_lhs;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = ConnectionUtils_instance.calculateAllConnectionsToHierarchy(guestRoot, $this.d3p_1.root);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.validation.DisallowSeparateRequiredHostsValidation.validate.<anonymous>' call
      if (element.guestConnector.required) {
        destination.q(element);
      }
    }
    var requiredConnections = destination;
    var tmp3_safe_receiver = firstOrNull_1(requiredConnections);
    var firstRequiredHostRoot = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.hostConnectionRoot;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = requiredConnections.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.validation.DisallowSeparateRequiredHostsValidation.validate.<anonymous>' call
      if (!element_0.hostConnectionRoot.equals(firstRequiredHostRoot)) {
        var tmp = Companion_instance_0;
        return tmp.fail('' + DisallowSeparateRequiredHostsValidation$_init_$ref_9l13xe() + ' failed for ' + entity + ' as it tried to snap to more than one different host with required connectors', get_productRefOrEmptyString(entity), $this);
      }
    }
    return null;
  }
  function DisallowSeparateRequiredHostsValidation$_init_$ref_9l13xe() {
    var l = function (p0, p1) {
      return new DisallowSeparateRequiredHostsValidation(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function DisallowSeparateRequiredHostsValidation(component, sceneManager) {
    ValidationImpl.call(this);
    this.c3p_1 = component;
    this.d3p_1 = sceneManager;
    this.e3p_1 = 'DisallowSeparateRequiredHosts';
  }
  protoOf(DisallowSeparateRequiredHostsValidation).s1k = function () {
    return this.e3p_1;
  };
  protoOf(DisallowSeparateRequiredHostsValidation).validateCurrentState = function (entity) {
    return validate_3(this, entity, null);
  };
  protoOf(DisallowSeparateRequiredHostsValidation).validateSnap = function (snapActionCandidate) {
    return validate_3(this, snapActionCandidate.guestRoot, snapActionCandidate);
  };
  function Companion_91() {
    this.ID = 'InvalidNumberOfChildren';
  }
  protoOf(Companion_91).u1n = function () {
    return this.ID;
  };
  var Companion_instance_124;
  function Companion_getInstance_100() {
    return Companion_instance_124;
  }
  function InvalidNumberOfChildren(message, productRef, rule) {
    ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), productRef, rule);
    this.f3p_1 = message;
  }
  protoOf(InvalidNumberOfChildren).s1k = function () {
    return 'InvalidNumberOfChildren';
  };
  protoOf(InvalidNumberOfChildren).toString = function () {
    return this.id + ': ' + this.f3p_1;
  };
  function Companion_92() {
    this.ID = 'PlacementZone';
  }
  protoOf(Companion_92).u1n = function () {
    return this.ID;
  };
  var Companion_instance_125;
  function Companion_getInstance_101() {
    return Companion_instance_125;
  }
  function validate_4($this, entity, snapActionCandidate) {
    var tmp1_safe_receiver = snapActionCandidate == null ? null : snapActionCandidate.endTransform;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.position;
    var tmp6_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.Y;
    var tmp;
    if (tmp6_elvis_lhs == null) {
      var tmp3_safe_receiver = entity.__getComponentForKotlin(10);
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.transform;
      var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.position;
      tmp = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.Y;
    } else {
      tmp = tmp6_elvis_lhs;
    }
    var tmp7_elvis_lhs = tmp;
    var tmp_0;
    if (tmp7_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp7_elvis_lhs;
    }
    var worldY = tmp_0;
    var tmp8_safe_receiver = entity.__getComponentForKotlin(58);
    if (tmp8_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_1;
      if (tmp8_safe_receiver.minY > worldY ? true : tmp8_safe_receiver.maxY < worldY) {
        return new PlacementZoneWarning(get_productRefOrEmptyString(entity), $this);
      }
    }
    return null;
  }
  function PlacementZoneValidation() {
    ValidationImpl.call(this);
    this.h3p_1 = 'PlacementZone';
  }
  protoOf(PlacementZoneValidation).s1k = function () {
    return this.h3p_1;
  };
  protoOf(PlacementZoneValidation).validateCurrentState = function (entity) {
    return validate_4(this, entity, null);
  };
  protoOf(PlacementZoneValidation).validateSnap = function (snapActionCandidate) {
    return validate_4(this, snapActionCandidate.guestRoot, snapActionCandidate);
  };
  function PlacementZoneWarning(ref, placementZoneRule) {
    ValidationResult.call(this, ValidationResultType_WARNING_getInstance(), ref, placementZoneRule);
    this.ref = ref;
    this.placementZoneRule = placementZoneRule;
  }
  protoOf(PlacementZoneWarning).w2m = function () {
    return this.ref;
  };
  protoOf(PlacementZoneWarning).i3p = function () {
    return this.placementZoneRule;
  };
  protoOf(PlacementZoneWarning).s1k = function () {
    return 'PlacementZoneWarning';
  };
  protoOf(PlacementZoneWarning).toString = function () {
    return 'The product ' + this.ref + ' is not placed within its Placement Zone';
  };
  protoOf(PlacementZoneWarning).af = function () {
    return this.ref;
  };
  protoOf(PlacementZoneWarning).bf = function () {
    return this.placementZoneRule;
  };
  protoOf(PlacementZoneWarning).j3p = function (ref, placementZoneRule) {
    return new PlacementZoneWarning(ref, placementZoneRule);
  };
  protoOf(PlacementZoneWarning).copy = function (ref, placementZoneRule, $super) {
    ref = ref === VOID ? this.ref : ref;
    placementZoneRule = placementZoneRule === VOID ? this.placementZoneRule : placementZoneRule;
    return this.j3p(ref, placementZoneRule);
  };
  protoOf(PlacementZoneWarning).hashCode = function () {
    var result = getStringHashCode(this.ref);
    result = imul(result, 31) + hashCode(this.placementZoneRule) | 0;
    return result;
  };
  protoOf(PlacementZoneWarning).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacementZoneWarning))
      return false;
    var tmp0_other_with_cast = other instanceof PlacementZoneWarning ? other : THROW_CCE();
    if (!(this.ref === tmp0_other_with_cast.ref))
      return false;
    if (!equals(this.placementZoneRule, tmp0_other_with_cast.placementZoneRule))
      return false;
    return true;
  };
  function Companion_93() {
    this.ID = 'RequiredConnectorsSatisfied';
  }
  protoOf(Companion_93).u1n = function () {
    return this.ID;
  };
  var Companion_instance_126;
  function Companion_getInstance_102() {
    return Companion_instance_126;
  }
  function validate_5($this, entity, snapActionCandidate) {
    if (!hasRequiredConnectors($this, entity)) {
      return null;
    }
    var root = $this.findRoot(snapActionCandidate, entity);
    var hostEntities = filterInHierarchy(root, RequiredConnectorsSatisfiedValidation$validate$lambda);
    var hostCandidate = snapActionCandidate == null ? null : snapActionCandidate.host;
    if (hostCandidate == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (!contains(hostEntities, hostCandidate)) {
        // Inline function 'kotlin.collections.plus' call
        var this_0 = hostEntities;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = [snapActionCandidate.host];
        hostEntities = this_0.concat(tmp$ret$3);
        tmp = Unit_instance;
      }
    }
    var failedConnectors = ConnectorUtils_instance.findUnfulfilledRequiredConnectors(hostEntities, entity);
    var tmp_0;
    // Inline function 'kotlin.collections.isEmpty' call
    if (failedConnectors.length === 0) {
      tmp_0 = null;
    } else {
      tmp_0 = new RequiredConnectorsValidationResult(failedConnectors, entity, $this);
    }
    return tmp_0;
  }
  function hasRequiredConnectors($this, entity) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = hierarchyExceptSubTreesWithComponentArray(entity, 47);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.validation.RequiredConnectorsSatisfiedValidation.hasRequiredConnectors.<anonymous>' call
        var tmp0_safe_receiver = get_connectorsComponent(element);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.requiredConnectors;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp = !tmp1_safe_receiver.b1();
        }
        if (tmp === true) {
          tmp$ret$2 = true;
          break $l$block;
        }
      }
      tmp$ret$2 = false;
    }
    return tmp$ret$2;
  }
  function RequiredConnectorsSatisfiedValidation$validate$lambda(it) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_safe_receiver = get_connectorsComponent(it);
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostConnectors;
    return !(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs).b1();
  }
  function RequiredConnectorsSatisfiedValidation() {
    ValidationImpl.call(this);
    this.l3p_1 = 'RequiredConnectorsSatisfied';
  }
  protoOf(RequiredConnectorsSatisfiedValidation).s1k = function () {
    return this.l3p_1;
  };
  protoOf(RequiredConnectorsSatisfiedValidation).validateCurrentState = function (entity) {
    return validate_5(this, entity, null);
  };
  protoOf(RequiredConnectorsSatisfiedValidation).validateSnap = function (snapActionCandidate) {
    return validate_5(this, snapActionCandidate.guestRoot, snapActionCandidate);
  };
  function Companion_94() {
    this.ID = 'RequiredConnectorsValidationResult';
  }
  protoOf(Companion_94).u1n = function () {
    return this.ID;
  };
  var Companion_instance_127;
  function Companion_getInstance_103() {
    return Companion_instance_127;
  }
  function RequiredConnectorsValidationResult$toString$lambda(connector) {
    return toString(connector);
  }
  function RequiredConnectorsValidationResult(unfulfilledConnectors, entity, rule) {
    ValidationResult.call(this, ValidationResultType_FAIL_getInstance(), get_productRef(entity), rule);
    this.unfulfilledConnectors = unfulfilledConnectors;
    this.entity = entity;
  }
  protoOf(RequiredConnectorsValidationResult).m3p = function () {
    return this.unfulfilledConnectors;
  };
  protoOf(RequiredConnectorsValidationResult).r23 = function () {
    return this.entity;
  };
  protoOf(RequiredConnectorsValidationResult).s1k = function () {
    return 'RequiredConnectorsValidationResult';
  };
  protoOf(RequiredConnectorsValidationResult).toString = function () {
    var tmp = get_productRefOrEmptyString(this.entity);
    var tmp_0 = get_worldTransform(this.entity);
    return 'Product ' + tmp + ' did not find required connectors needed to support it at ' + tmp_0 + '. Non satisfied connectors: [' + joinToString(this.unfulfilledConnectors, VOID, VOID, VOID, VOID, VOID, RequiredConnectorsValidationResult$toString$lambda) + ']';
  };
  function ValidationResultIds() {
    this.InvalidNumberOfChildrenId = 'InvalidNumberOfChildren';
    this.CollisionValidationResultId = 'CollisionValidationResult';
    this.FunctionalMarginWarningId = 'FunctionalMarginWarning intersects';
    this.RequiredConnectorsValidationResultId = 'RequiredConnectorsValidationResult';
    this.NoValidConnectorAvailableValidationResultId = 'NoValidConnectorAvailableValidationResult';
    this.UnknownErrorValidationResultId = 'UnknownErrorValidationResult';
    this.InvalidDoorPairsResultId = 'InvalidDoorPairsResult';
  }
  protoOf(ValidationResultIds).n3p = function () {
    return this.InvalidNumberOfChildrenId;
  };
  protoOf(ValidationResultIds).o3p = function () {
    return this.CollisionValidationResultId;
  };
  protoOf(ValidationResultIds).p3p = function () {
    return this.FunctionalMarginWarningId;
  };
  protoOf(ValidationResultIds).q3p = function () {
    return this.RequiredConnectorsValidationResultId;
  };
  protoOf(ValidationResultIds).r3p = function () {
    return this.NoValidConnectorAvailableValidationResultId;
  };
  protoOf(ValidationResultIds).s3p = function () {
    return this.UnknownErrorValidationResultId;
  };
  protoOf(ValidationResultIds).t3p = function () {
    return this.InvalidDoorPairsResultId;
  };
  protoOf(ValidationResultIds).isCollisionValidationResult = function (validationResult) {
    return validationResult.id === 'CollisionValidationResult';
  };
  protoOf(ValidationResultIds).isInvalidNumberOfChildrenValidationResult = function (validationResult) {
    return validationResult.id === 'InvalidNumberOfChildren';
  };
  protoOf(ValidationResultIds).isChildConnectionValidationResult = function (validationResult) {
    var tmp0_safe_receiver = validationResult.failedRule;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id;
    return tmp === 'ChildConnection';
  };
  protoOf(ValidationResultIds).isFunctionalMarginWarningValidationResult = function (validationResult) {
    return validationResult.id === 'FunctionalMarginWarning intersects';
  };
  protoOf(ValidationResultIds).isRequiredConnectorsValidationResult = function (validationResult) {
    return validationResult.id === 'RequiredConnectorsValidationResult';
  };
  protoOf(ValidationResultIds).isNoValidConnectorAvailableValidationResult = function (validationResult) {
    return validationResult.id === 'NoValidConnectorAvailableValidationResult';
  };
  protoOf(ValidationResultIds).isUnknownErrorValidationResult = function (validationResult) {
    return validationResult.id === 'UnknownErrorValidationResult';
  };
  protoOf(ValidationResultIds).isInvalidDoorPairsResult = function (validationResult) {
    return validationResult.id === 'InvalidDoorPairsResult';
  };
  var ValidationResultIds_instance;
  function ValidationResultIds_getInstance() {
    return ValidationResultIds_instance;
  }
  function ValidationRuleIds() {
    this.CollisionValidationRuleId = 'Collision';
    this.ChildConnectionValidationId = 'ChildConnection';
    this.ManualGroupConnectorValidationId = 'ManualGroupConnectorValidation';
    this.RequiredConnectorsSatisfiedValidationId = 'RequiredConnectorsSatisfied';
    this.AllowedDoorPairsValidationId = 'AllowedDoorPairs';
    this.FunctionalMarginValidationId = 'FunctionalMargin';
    this.AllowedNumberOfChildrenOfTypeValidationId = 'AllowedNumberOfChildrenOfType';
    this.DisallowSeparateRequiredHostsValidationId = 'DisallowSeparateRequiredHosts';
    this.PlacementZoneValidationId = 'PlacementZone';
  }
  protoOf(ValidationRuleIds).u3p = function () {
    return this.CollisionValidationRuleId;
  };
  protoOf(ValidationRuleIds).v3p = function () {
    return this.ChildConnectionValidationId;
  };
  protoOf(ValidationRuleIds).w3p = function () {
    return this.ManualGroupConnectorValidationId;
  };
  protoOf(ValidationRuleIds).x3p = function () {
    return this.RequiredConnectorsSatisfiedValidationId;
  };
  protoOf(ValidationRuleIds).y3p = function () {
    return this.AllowedDoorPairsValidationId;
  };
  protoOf(ValidationRuleIds).z3p = function () {
    return this.FunctionalMarginValidationId;
  };
  protoOf(ValidationRuleIds).a3q = function () {
    return this.AllowedNumberOfChildrenOfTypeValidationId;
  };
  protoOf(ValidationRuleIds).b3q = function () {
    return this.DisallowSeparateRequiredHostsValidationId;
  };
  protoOf(ValidationRuleIds).c3q = function () {
    return this.PlacementZoneValidationId;
  };
  var ValidationRuleIds_instance;
  function ValidationRuleIds_getInstance() {
    return ValidationRuleIds_instance;
  }
  function toggle($this, system) {
    if (system.isEnabled) {
      system.disable();
    } else {
      system.enable();
    }
  }
  function setEnabled($this, system, enabled) {
    if (!system.isEnabled) {
      if (enabled) {
        system.enable();
      }
    } else {
      if (!enabled) {
        system.disable();
      }
    }
  }
  function setEnabled$default($this, system, enabled, $super) {
    enabled = enabled === VOID ? true : enabled;
    return setEnabled($this, system, enabled);
  }
  function CoreVisualization(coreServices, colliderVisualizer, connectorVisualizer) {
    this.coreServices = coreServices;
    var systems = this.coreServices.entityManager.getSystemsRegistered();
    var tmp = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = systems.length;
      while (inductionVariable < last) {
        var element = systems[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_0 = element.id;
        if (tmp_0 === 'EntityColliderVisualizationSystem') {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp_1 = tmp$ret$1;
    var tmp0_elvis_lhs = (tmp_1 == null ? true : tmp_1 instanceof EntityColliderVisualizationSystem) ? tmp_1 : THROW_CCE();
    var tmp_2;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_0 = new EntityColliderVisualizationSystem(this.coreServices, colliderVisualizer);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_0.disable();
      tmp_2 = this_0;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    tmp.entityColliderVisualizationSystem = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_0 = 0;
      var last_0 = systems.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = systems[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_4 = element_0.id;
        if (tmp_4 === 'EntityCollisionVisualizationSystem') {
          tmp$ret$6 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$6 = null;
    }
    var tmp_5 = tmp$ret$6;
    var tmp1_elvis_lhs = (tmp_5 == null ? true : tmp_5 instanceof EntityCollisionVisualizationSystem) ? tmp_5 : THROW_CCE();
    var tmp_6;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_1 = new EntityCollisionVisualizationSystem(this.coreServices);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_1);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_1.disable();
      tmp_6 = this_1;
    } else {
      tmp_6 = tmp1_elvis_lhs;
    }
    tmp_3.entityCollisionVisualizationSystem = tmp_6;
    var tmp_7 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$11;
    $l$block_1: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_1 = 0;
      var last_1 = systems.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = systems[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_8 = element_1.id;
        Companion_getInstance_124();
        if (tmp_8 === 'EntityConnectorVisualizationSystem') {
          tmp$ret$11 = element_1;
          break $l$block_1;
        }
      }
      tmp$ret$11 = null;
    }
    var tmp_9 = tmp$ret$11;
    var tmp2_elvis_lhs = (tmp_9 == null ? true : tmp_9 instanceof EntityConnectorVisualizationSystem) ? tmp_9 : THROW_CCE();
    var tmp_10;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_2 = new EntityConnectorVisualizationSystem(this.coreServices, connectorVisualizer);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_2);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_2.disable();
      tmp_10 = this_2;
    } else {
      tmp_10 = tmp2_elvis_lhs;
    }
    tmp_7.entityConnectorVisualizationSystem = tmp_10;
    var tmp_11 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$16;
    $l$block_2: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_2 = 0;
      var last_2 = systems.length;
      while (inductionVariable_2 < last_2) {
        var element_2 = systems[inductionVariable_2];
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_12 = element_2.id;
        if (tmp_12 === 'ColliderVisualizationSystem') {
          tmp$ret$16 = element_2;
          break $l$block_2;
        }
      }
      tmp$ret$16 = null;
    }
    var tmp_13 = tmp$ret$16;
    var tmp3_elvis_lhs = (tmp_13 == null ? true : tmp_13 instanceof ColliderVisualizationSystem) ? tmp_13 : THROW_CCE();
    var tmp_14;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_3 = new ColliderVisualizationSystem(this.coreServices);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_3);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_3.disable();
      tmp_14 = this_3;
    } else {
      tmp_14 = tmp3_elvis_lhs;
    }
    tmp_11.colliderVisualizationSystem = tmp_14;
    var tmp_15 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$21;
    $l$block_3: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_3 = 0;
      var last_3 = systems.length;
      while (inductionVariable_3 < last_3) {
        var element_3 = systems[inductionVariable_3];
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_16 = element_3.id;
        if (tmp_16 === 'ConnectorVisualizationSystem') {
          tmp$ret$21 = element_3;
          break $l$block_3;
        }
      }
      tmp$ret$21 = null;
    }
    var tmp_17 = tmp$ret$21;
    var tmp4_elvis_lhs = (tmp_17 == null ? true : tmp_17 instanceof ConnectorVisualizationSystem) ? tmp_17 : THROW_CCE();
    var tmp_18;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_4 = new ConnectorVisualizationSystem(this.coreServices);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_4);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_4.disable();
      tmp_18 = this_4;
    } else {
      tmp_18 = tmp4_elvis_lhs;
    }
    tmp_15.connectorVisualizationSystem = tmp_18;
    var tmp_19 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$26;
    $l$block_4: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_4 = 0;
      var last_4 = systems.length;
      while (inductionVariable_4 < last_4) {
        var element_4 = systems[inductionVariable_4];
        inductionVariable_4 = inductionVariable_4 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_20 = element_4.id;
        if (tmp_20 === 'FunctionalMarginVisualizationSystem') {
          tmp$ret$26 = element_4;
          break $l$block_4;
        }
      }
      tmp$ret$26 = null;
    }
    var tmp_21 = tmp$ret$26;
    var tmp5_elvis_lhs = (tmp_21 == null ? true : tmp_21 instanceof FunctionalMarginVisualizationSystem) ? tmp_21 : THROW_CCE();
    var tmp_22;
    if (tmp5_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_5 = new FunctionalMarginVisualizationSystem(this.coreServices);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_5);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_5.disable();
      tmp_22 = this_5;
    } else {
      tmp_22 = tmp5_elvis_lhs;
    }
    tmp_19.functionalMarginVisualizationSystem = tmp_22;
    var tmp_23 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$31;
    $l$block_5: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_5 = 0;
      var last_5 = systems.length;
      while (inductionVariable_5 < last_5) {
        var element_5 = systems[inductionVariable_5];
        inductionVariable_5 = inductionVariable_5 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_24 = element_5.id;
        if (tmp_24 === 'AutoAdaptHostZoneVisualizationSystem') {
          tmp$ret$31 = element_5;
          break $l$block_5;
        }
      }
      tmp$ret$31 = null;
    }
    var tmp_25 = tmp$ret$31;
    var tmp6_elvis_lhs = (tmp_25 == null ? true : tmp_25 instanceof AutoAdaptHostZoneVisualizationSystem) ? tmp_25 : THROW_CCE();
    var tmp_26;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_6 = new AutoAdaptHostZoneVisualizationSystem(this.coreServices);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_6);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_6.disable();
      tmp_26 = this_6;
    } else {
      tmp_26 = tmp6_elvis_lhs;
    }
    tmp_23.autoAdaptHostZoneVisualizationSystem = tmp_26;
    var tmp_27 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$36;
    $l$block_6: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_6 = 0;
      var last_6 = systems.length;
      while (inductionVariable_6 < last_6) {
        var element_6 = systems[inductionVariable_6];
        inductionVariable_6 = inductionVariable_6 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_28 = element_6.id;
        Companion_getInstance_35();
        if (tmp_28 === 'DragSurfaceNormalVisualizationSystem') {
          tmp$ret$36 = element_6;
          break $l$block_6;
        }
      }
      tmp$ret$36 = null;
    }
    var tmp7_elvis_lhs = tmp$ret$36;
    var tmp_29;
    if (tmp7_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_7 = new DragSurfaceNormalVisualizationSystem(this.coreServices);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_7);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_7.disable();
      tmp_29 = this_7;
    } else {
      tmp_29 = tmp7_elvis_lhs;
    }
    var tmp_30 = tmp_29;
    tmp_27.dragSurfaceNormalVisualizationSystem = tmp_30 instanceof DragSurfaceNormalVisualizationSystem ? tmp_30 : THROW_CCE();
    var tmp_31 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$41;
    $l$block_7: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_7 = 0;
      var last_7 = systems.length;
      while (inductionVariable_7 < last_7) {
        var element_7 = systems[inductionVariable_7];
        inductionVariable_7 = inductionVariable_7 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_32 = element_7.id;
        if (tmp_32 === 'DragProjectionPointVisualizationSystem') {
          tmp$ret$41 = element_7;
          break $l$block_7;
        }
      }
      tmp$ret$41 = null;
    }
    var tmp8_elvis_lhs = tmp$ret$41;
    var tmp_33;
    if (tmp8_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_8 = new DragProjectionPointVisualizationSystem(this.coreServices);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_8);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_8.disable();
      tmp_33 = this_8;
    } else {
      tmp_33 = tmp8_elvis_lhs;
    }
    var tmp_34 = tmp_33;
    tmp_31.dragProjectionPointVisualizationSystem = tmp_34 instanceof DragProjectionPointVisualizationSystem ? tmp_34 : THROW_CCE();
    var tmp_35 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$46;
    $l$block_8: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_8 = 0;
      var last_8 = systems.length;
      while (inductionVariable_8 < last_8) {
        var element_8 = systems[inductionVariable_8];
        inductionVariable_8 = inductionVariable_8 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_36 = element_8.id;
        if (tmp_36 === 'FunctionalZoneVisualizationSystem') {
          tmp$ret$46 = element_8;
          break $l$block_8;
        }
      }
      tmp$ret$46 = null;
    }
    var tmp9_elvis_lhs = tmp$ret$46;
    var tmp_37;
    if (tmp9_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_9 = new FunctionalZoneVisualizationSystem(this.coreServices);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_9);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_9.disable();
      tmp_37 = this_9;
    } else {
      tmp_37 = tmp9_elvis_lhs;
    }
    var tmp_38 = tmp_37;
    tmp_35.functionalZoneVisualizationSystem = tmp_38 instanceof FunctionalZoneVisualizationSystem ? tmp_38 : THROW_CCE();
    var tmp_39 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$51;
    $l$block_9: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_9 = 0;
      var last_9 = systems.length;
      while (inductionVariable_9 < last_9) {
        var element_9 = systems[inductionVariable_9];
        inductionVariable_9 = inductionVariable_9 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        var tmp_40 = element_9.id;
        Companion_getInstance_32();
        if (tmp_40 === 'DebugLineDrawingSystem') {
          tmp$ret$51 = element_9;
          break $l$block_9;
        }
      }
      tmp$ret$51 = null;
    }
    var tmp10_elvis_lhs = tmp$ret$51;
    var tmp_41;
    if (tmp10_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_10 = new DebugLineDrawingSystem(this.coreServices);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_10);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_10.disable();
      tmp_41 = this_10;
    } else {
      tmp_41 = tmp10_elvis_lhs;
    }
    var tmp_42 = tmp_41;
    tmp_39.debugLineDrawingSystem = tmp_42 instanceof DebugLineDrawingSystem ? tmp_42 : THROW_CCE();
    var tmp_43 = this;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$56;
    $l$block_10: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable_10 = 0;
      var last_10 = systems.length;
      while (inductionVariable_10 < last_10) {
        var element_10 = systems[inductionVariable_10];
        inductionVariable_10 = inductionVariable_10 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
        if (element_10.id === Companion_instance_60.ID) {
          tmp$ret$56 = element_10;
          break $l$block_10;
        }
      }
      tmp$ret$56 = null;
    }
    var tmp11_elvis_lhs = tmp$ret$56;
    var tmp_44;
    if (tmp11_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.also' call
      var this_11 = new DragSurfaceVisualizationSystem(this.coreServices.entityManager);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this.coreServices.entityManager.registerSystem(this_11);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.CoreVisualization.<anonymous>' call
      this_11.disable();
      tmp_44 = this_11;
    } else {
      tmp_44 = tmp11_elvis_lhs;
    }
    var tmp_45 = tmp_44;
    tmp_43.dragSurfaceVisualizationSystem = tmp_45 instanceof DragSurfaceVisualizationSystem ? tmp_45 : THROW_CCE();
    this.autoAdaptHostZoneVisualizationSystem.alpha = 0.5;
    this.functionalMarginVisualizationSystem.alpha = 0.5;
  }
  protoOf(CoreVisualization).k2z = function () {
    return this.coreServices;
  };
  protoOf(CoreVisualization).o3q = function () {
    return this.entityColliderVisualizationSystem;
  };
  protoOf(CoreVisualization).p3q = function () {
    return this.entityCollisionVisualizationSystem;
  };
  protoOf(CoreVisualization).q3q = function () {
    return this.entityConnectorVisualizationSystem;
  };
  protoOf(CoreVisualization).r3q = function () {
    return this.colliderVisualizationSystem;
  };
  protoOf(CoreVisualization).s3q = function () {
    return this.connectorVisualizationSystem;
  };
  protoOf(CoreVisualization).t3q = function () {
    return this.debugLineDrawingSystem;
  };
  protoOf(CoreVisualization).u3q = function () {
    return this.functionalMarginVisualizationSystem;
  };
  protoOf(CoreVisualization).v3q = function () {
    return this.autoAdaptHostZoneVisualizationSystem;
  };
  protoOf(CoreVisualization).w3q = function () {
    return this.dragSurfaceNormalVisualizationSystem;
  };
  protoOf(CoreVisualization).x3q = function () {
    return this.dragSurfaceVisualizationSystem;
  };
  protoOf(CoreVisualization).y3q = function () {
    return this.dragProjectionPointVisualizationSystem;
  };
  protoOf(CoreVisualization).z3q = function () {
    return this.functionalZoneVisualizationSystem;
  };
  protoOf(CoreVisualization).toggleEntityColliders = function () {
    return toggle(this, this.entityColliderVisualizationSystem);
  };
  protoOf(CoreVisualization).toggleEntityCollisions = function () {
    return toggle(this, this.entityCollisionVisualizationSystem);
  };
  protoOf(CoreVisualization).toggleEntityConnectors = function () {
    return toggle(this, this.entityConnectorVisualizationSystem);
  };
  protoOf(CoreVisualization).toggleColliders = function () {
    toggle(this, this.colliderVisualizationSystem);
    if (this.colliderVisualizationSystem.isEnabled) {
      setEnabled$default(this, this.entityColliderVisualizationSystem);
      setEnabled$default(this, this.entityCollisionVisualizationSystem);
    }
  };
  protoOf(CoreVisualization).toggleConnectors = function () {
    toggle(this, this.connectorVisualizationSystem);
    if (this.connectorVisualizationSystem.isEnabled) {
      setEnabled$default(this, this.entityConnectorVisualizationSystem);
    }
  };
  protoOf(CoreVisualization).toggleAutoAdaptHostZone = function () {
    return toggle(this, this.autoAdaptHostZoneVisualizationSystem);
  };
  protoOf(CoreVisualization).toggleFunctionalMargin = function () {
    return toggle(this, this.functionalMarginVisualizationSystem);
  };
  protoOf(CoreVisualization).toggleDragSurfaces = function () {
    return toggle(this, this.dragSurfaceNormalVisualizationSystem);
  };
  protoOf(CoreVisualization).toggleDragProjectionPoint = function () {
    return toggle(this, this.dragProjectionPointVisualizationSystem);
  };
  protoOf(CoreVisualization).toggleDragSurfaceVisualizationSystem = function () {
    return toggle(this, this.dragSurfaceVisualizationSystem);
  };
  protoOf(CoreVisualization).toggleDebugLineDrawingSystem = function () {
    return toggle(this, this.debugLineDrawingSystem);
  };
  protoOf(CoreVisualization).toggleFunctionalZone = function () {
    return toggle(this, this.functionalZoneVisualizationSystem);
  };
  protoOf(CoreVisualization).setVisualizationState = function (state) {
    setEnabled(this, this.entityColliderVisualizationSystem, state.colliderVisualizationEnabled);
    setEnabled(this, this.colliderVisualizationSystem, state.visualizeAllColliders);
    setEnabled(this, this.entityCollisionVisualizationSystem, state.collisionVisualizationEnabled);
    setEnabled(this, this.entityConnectorVisualizationSystem, state.connectorVisualizationEnabled);
    setEnabled(this, this.connectorVisualizationSystem, state.visualizeAllConnectors);
    this.connectorVisualizationSystem.connectorActivationDistanceVisualizationEnabled = state.connectorActivationDistanceVisualizationEnabled;
    this.connectorVisualizationSystem.connectorTransformVisualizationEnabled = state.connectorTransformVisualizationEnabled;
    setEnabled(this, this.functionalMarginVisualizationSystem, state.functionalMarginVisualizationEnabled);
    setEnabled(this, this.autoAdaptHostZoneVisualizationSystem, state.autoAdaptHostZoneVisualizationEnabled);
    setEnabled(this, this.dragSurfaceNormalVisualizationSystem, state.dragSurfaceNormalVisualizationEnabled);
    setEnabled(this, this.dragProjectionPointVisualizationSystem, state.dragProjectionPointVisualizationEnabled);
    setEnabled(this, this.functionalZoneVisualizationSystem, state.functionalZoneVisualizationEnabled);
    setEnabled(this, this.debugLineDrawingSystem, state.debugLineDrawingSystem);
    setEnabled(this, this.dragSurfaceVisualizationSystem, state.dragSurfaceVisualizationSystem);
  };
  protoOf(CoreVisualization).getVisualizationState = function () {
    return new VisualizationState(this.entityColliderVisualizationSystem.isEnabled, this.colliderVisualizationSystem.isEnabled, this.entityCollisionVisualizationSystem.isEnabled, this.entityConnectorVisualizationSystem.isEnabled, this.connectorVisualizationSystem.isEnabled, this.connectorVisualizationSystem.connectorActivationDistanceVisualizationEnabled, this.connectorVisualizationSystem.connectorTransformVisualizationEnabled, this.functionalMarginVisualizationSystem.isEnabled, this.autoAdaptHostZoneVisualizationSystem.isEnabled, this.debugLineDrawingSystem.isEnabled, this.dragSurfaceVisualizationSystem.isEnabled);
  };
  function VisualizationState(colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem) {
    colliderVisualizationEnabled = colliderVisualizationEnabled === VOID ? false : colliderVisualizationEnabled;
    visualizeAllColliders = visualizeAllColliders === VOID ? false : visualizeAllColliders;
    collisionVisualizationEnabled = collisionVisualizationEnabled === VOID ? false : collisionVisualizationEnabled;
    connectorVisualizationEnabled = connectorVisualizationEnabled === VOID ? false : connectorVisualizationEnabled;
    visualizeAllConnectors = visualizeAllConnectors === VOID ? false : visualizeAllConnectors;
    connectorActivationDistanceVisualizationEnabled = connectorActivationDistanceVisualizationEnabled === VOID ? false : connectorActivationDistanceVisualizationEnabled;
    connectorTransformVisualizationEnabled = connectorTransformVisualizationEnabled === VOID ? false : connectorTransformVisualizationEnabled;
    functionalMarginVisualizationEnabled = functionalMarginVisualizationEnabled === VOID ? false : functionalMarginVisualizationEnabled;
    autoAdaptHostZoneVisualizationEnabled = autoAdaptHostZoneVisualizationEnabled === VOID ? false : autoAdaptHostZoneVisualizationEnabled;
    dragSurfaceNormalVisualizationEnabled = dragSurfaceNormalVisualizationEnabled === VOID ? false : dragSurfaceNormalVisualizationEnabled;
    dragProjectionPointVisualizationEnabled = dragProjectionPointVisualizationEnabled === VOID ? false : dragProjectionPointVisualizationEnabled;
    functionalZoneVisualizationEnabled = functionalZoneVisualizationEnabled === VOID ? false : functionalZoneVisualizationEnabled;
    debugLineDrawingSystem = debugLineDrawingSystem === VOID ? false : debugLineDrawingSystem;
    dragSurfaceVisualizationSystem = dragSurfaceVisualizationSystem === VOID ? false : dragSurfaceVisualizationSystem;
    this.colliderVisualizationEnabled = colliderVisualizationEnabled;
    this.visualizeAllColliders = visualizeAllColliders;
    this.collisionVisualizationEnabled = collisionVisualizationEnabled;
    this.connectorVisualizationEnabled = connectorVisualizationEnabled;
    this.visualizeAllConnectors = visualizeAllConnectors;
    this.connectorActivationDistanceVisualizationEnabled = connectorActivationDistanceVisualizationEnabled;
    this.connectorTransformVisualizationEnabled = connectorTransformVisualizationEnabled;
    this.functionalMarginVisualizationEnabled = functionalMarginVisualizationEnabled;
    this.autoAdaptHostZoneVisualizationEnabled = autoAdaptHostZoneVisualizationEnabled;
    this.dragSurfaceNormalVisualizationEnabled = dragSurfaceNormalVisualizationEnabled;
    this.dragProjectionPointVisualizationEnabled = dragProjectionPointVisualizationEnabled;
    this.functionalZoneVisualizationEnabled = functionalZoneVisualizationEnabled;
    this.debugLineDrawingSystem = debugLineDrawingSystem;
    this.dragSurfaceVisualizationSystem = dragSurfaceVisualizationSystem;
  }
  protoOf(VisualizationState).a3r = function () {
    return this.colliderVisualizationEnabled;
  };
  protoOf(VisualizationState).b3r = function () {
    return this.visualizeAllColliders;
  };
  protoOf(VisualizationState).c3r = function () {
    return this.collisionVisualizationEnabled;
  };
  protoOf(VisualizationState).d3r = function () {
    return this.connectorVisualizationEnabled;
  };
  protoOf(VisualizationState).e3r = function () {
    return this.visualizeAllConnectors;
  };
  protoOf(VisualizationState).f3r = function () {
    return this.connectorActivationDistanceVisualizationEnabled;
  };
  protoOf(VisualizationState).g3r = function () {
    return this.connectorTransformVisualizationEnabled;
  };
  protoOf(VisualizationState).h3r = function () {
    return this.functionalMarginVisualizationEnabled;
  };
  protoOf(VisualizationState).i3r = function () {
    return this.autoAdaptHostZoneVisualizationEnabled;
  };
  protoOf(VisualizationState).j3r = function () {
    return this.dragSurfaceNormalVisualizationEnabled;
  };
  protoOf(VisualizationState).k3r = function () {
    return this.dragProjectionPointVisualizationEnabled;
  };
  protoOf(VisualizationState).l3r = function () {
    return this.functionalZoneVisualizationEnabled;
  };
  protoOf(VisualizationState).t3q = function () {
    return this.debugLineDrawingSystem;
  };
  protoOf(VisualizationState).x3q = function () {
    return this.dragSurfaceVisualizationSystem;
  };
  protoOf(VisualizationState).af = function () {
    return this.colliderVisualizationEnabled;
  };
  protoOf(VisualizationState).bf = function () {
    return this.visualizeAllColliders;
  };
  protoOf(VisualizationState).g1k = function () {
    return this.collisionVisualizationEnabled;
  };
  protoOf(VisualizationState).h1k = function () {
    return this.connectorVisualizationEnabled;
  };
  protoOf(VisualizationState).i1k = function () {
    return this.visualizeAllConnectors;
  };
  protoOf(VisualizationState).j1k = function () {
    return this.connectorActivationDistanceVisualizationEnabled;
  };
  protoOf(VisualizationState).k1k = function () {
    return this.connectorTransformVisualizationEnabled;
  };
  protoOf(VisualizationState).p1z = function () {
    return this.functionalMarginVisualizationEnabled;
  };
  protoOf(VisualizationState).q1z = function () {
    return this.autoAdaptHostZoneVisualizationEnabled;
  };
  protoOf(VisualizationState).r1z = function () {
    return this.dragSurfaceNormalVisualizationEnabled;
  };
  protoOf(VisualizationState).s1z = function () {
    return this.dragProjectionPointVisualizationEnabled;
  };
  protoOf(VisualizationState).t1z = function () {
    return this.functionalZoneVisualizationEnabled;
  };
  protoOf(VisualizationState).s21 = function () {
    return this.debugLineDrawingSystem;
  };
  protoOf(VisualizationState).t21 = function () {
    return this.dragSurfaceVisualizationSystem;
  };
  protoOf(VisualizationState).m3r = function (colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem) {
    return new VisualizationState(colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem);
  };
  protoOf(VisualizationState).copy = function (colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem, $super) {
    colliderVisualizationEnabled = colliderVisualizationEnabled === VOID ? this.colliderVisualizationEnabled : colliderVisualizationEnabled;
    visualizeAllColliders = visualizeAllColliders === VOID ? this.visualizeAllColliders : visualizeAllColliders;
    collisionVisualizationEnabled = collisionVisualizationEnabled === VOID ? this.collisionVisualizationEnabled : collisionVisualizationEnabled;
    connectorVisualizationEnabled = connectorVisualizationEnabled === VOID ? this.connectorVisualizationEnabled : connectorVisualizationEnabled;
    visualizeAllConnectors = visualizeAllConnectors === VOID ? this.visualizeAllConnectors : visualizeAllConnectors;
    connectorActivationDistanceVisualizationEnabled = connectorActivationDistanceVisualizationEnabled === VOID ? this.connectorActivationDistanceVisualizationEnabled : connectorActivationDistanceVisualizationEnabled;
    connectorTransformVisualizationEnabled = connectorTransformVisualizationEnabled === VOID ? this.connectorTransformVisualizationEnabled : connectorTransformVisualizationEnabled;
    functionalMarginVisualizationEnabled = functionalMarginVisualizationEnabled === VOID ? this.functionalMarginVisualizationEnabled : functionalMarginVisualizationEnabled;
    autoAdaptHostZoneVisualizationEnabled = autoAdaptHostZoneVisualizationEnabled === VOID ? this.autoAdaptHostZoneVisualizationEnabled : autoAdaptHostZoneVisualizationEnabled;
    dragSurfaceNormalVisualizationEnabled = dragSurfaceNormalVisualizationEnabled === VOID ? this.dragSurfaceNormalVisualizationEnabled : dragSurfaceNormalVisualizationEnabled;
    dragProjectionPointVisualizationEnabled = dragProjectionPointVisualizationEnabled === VOID ? this.dragProjectionPointVisualizationEnabled : dragProjectionPointVisualizationEnabled;
    functionalZoneVisualizationEnabled = functionalZoneVisualizationEnabled === VOID ? this.functionalZoneVisualizationEnabled : functionalZoneVisualizationEnabled;
    debugLineDrawingSystem = debugLineDrawingSystem === VOID ? this.debugLineDrawingSystem : debugLineDrawingSystem;
    dragSurfaceVisualizationSystem = dragSurfaceVisualizationSystem === VOID ? this.dragSurfaceVisualizationSystem : dragSurfaceVisualizationSystem;
    return this.m3r(colliderVisualizationEnabled, visualizeAllColliders, collisionVisualizationEnabled, connectorVisualizationEnabled, visualizeAllConnectors, connectorActivationDistanceVisualizationEnabled, connectorTransformVisualizationEnabled, functionalMarginVisualizationEnabled, autoAdaptHostZoneVisualizationEnabled, dragSurfaceNormalVisualizationEnabled, dragProjectionPointVisualizationEnabled, functionalZoneVisualizationEnabled, debugLineDrawingSystem, dragSurfaceVisualizationSystem);
  };
  protoOf(VisualizationState).toString = function () {
    return 'VisualizationState(colliderVisualizationEnabled=' + this.colliderVisualizationEnabled + ', visualizeAllColliders=' + this.visualizeAllColliders + ', collisionVisualizationEnabled=' + this.collisionVisualizationEnabled + ', connectorVisualizationEnabled=' + this.connectorVisualizationEnabled + ', visualizeAllConnectors=' + this.visualizeAllConnectors + ', connectorActivationDistanceVisualizationEnabled=' + this.connectorActivationDistanceVisualizationEnabled + ', connectorTransformVisualizationEnabled=' + this.connectorTransformVisualizationEnabled + ', functionalMarginVisualizationEnabled=' + this.functionalMarginVisualizationEnabled + ', autoAdaptHostZoneVisualizationEnabled=' + this.autoAdaptHostZoneVisualizationEnabled + ', dragSurfaceNormalVisualizationEnabled=' + this.dragSurfaceNormalVisualizationEnabled + ', dragProjectionPointVisualizationEnabled=' + this.dragProjectionPointVisualizationEnabled + ', functionalZoneVisualizationEnabled=' + this.functionalZoneVisualizationEnabled + ', debugLineDrawingSystem=' + this.debugLineDrawingSystem + ', dragSurfaceVisualizationSystem=' + this.dragSurfaceVisualizationSystem + ')';
  };
  protoOf(VisualizationState).hashCode = function () {
    var result = getBooleanHashCode(this.colliderVisualizationEnabled);
    result = imul(result, 31) + getBooleanHashCode(this.visualizeAllColliders) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.collisionVisualizationEnabled) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.connectorVisualizationEnabled) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.visualizeAllConnectors) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.connectorActivationDistanceVisualizationEnabled) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.connectorTransformVisualizationEnabled) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.functionalMarginVisualizationEnabled) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.autoAdaptHostZoneVisualizationEnabled) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.dragSurfaceNormalVisualizationEnabled) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.dragProjectionPointVisualizationEnabled) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.functionalZoneVisualizationEnabled) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.debugLineDrawingSystem) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.dragSurfaceVisualizationSystem) | 0;
    return result;
  };
  protoOf(VisualizationState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VisualizationState))
      return false;
    var tmp0_other_with_cast = other instanceof VisualizationState ? other : THROW_CCE();
    if (!(this.colliderVisualizationEnabled === tmp0_other_with_cast.colliderVisualizationEnabled))
      return false;
    if (!(this.visualizeAllColliders === tmp0_other_with_cast.visualizeAllColliders))
      return false;
    if (!(this.collisionVisualizationEnabled === tmp0_other_with_cast.collisionVisualizationEnabled))
      return false;
    if (!(this.connectorVisualizationEnabled === tmp0_other_with_cast.connectorVisualizationEnabled))
      return false;
    if (!(this.visualizeAllConnectors === tmp0_other_with_cast.visualizeAllConnectors))
      return false;
    if (!(this.connectorActivationDistanceVisualizationEnabled === tmp0_other_with_cast.connectorActivationDistanceVisualizationEnabled))
      return false;
    if (!(this.connectorTransformVisualizationEnabled === tmp0_other_with_cast.connectorTransformVisualizationEnabled))
      return false;
    if (!(this.functionalMarginVisualizationEnabled === tmp0_other_with_cast.functionalMarginVisualizationEnabled))
      return false;
    if (!(this.autoAdaptHostZoneVisualizationEnabled === tmp0_other_with_cast.autoAdaptHostZoneVisualizationEnabled))
      return false;
    if (!(this.dragSurfaceNormalVisualizationEnabled === tmp0_other_with_cast.dragSurfaceNormalVisualizationEnabled))
      return false;
    if (!(this.dragProjectionPointVisualizationEnabled === tmp0_other_with_cast.dragProjectionPointVisualizationEnabled))
      return false;
    if (!(this.functionalZoneVisualizationEnabled === tmp0_other_with_cast.functionalZoneVisualizationEnabled))
      return false;
    if (!(this.debugLineDrawingSystem === tmp0_other_with_cast.debugLineDrawingSystem))
      return false;
    if (!(this.dragSurfaceVisualizationSystem === tmp0_other_with_cast.dragSurfaceVisualizationSystem))
      return false;
    return true;
  };
  function Companion_95() {
    this.id = 109;
  }
  protoOf(Companion_95).s1k = function () {
    return this.id;
  };
  var Companion_instance_128;
  function Companion_getInstance_104() {
    return Companion_instance_128;
  }
  function ColliderVisualizationConfigComponent(includeRoom) {
    this.includeRoom = includeRoom;
  }
  protoOf(ColliderVisualizationConfigComponent).n3r = function () {
    return this.includeRoom;
  };
  protoOf(ColliderVisualizationConfigComponent).x1k = function () {
    return 109;
  };
  protoOf(ColliderVisualizationConfigComponent).eq = function (other) {
    var o = other instanceof ColliderVisualizationConfigComponent ? other : THROW_CCE();
    return o.includeRoom === this.includeRoom;
  };
  protoOf(ColliderVisualizationConfigComponent).af = function () {
    return this.includeRoom;
  };
  protoOf(ColliderVisualizationConfigComponent).o3r = function (includeRoom) {
    return new ColliderVisualizationConfigComponent(includeRoom);
  };
  protoOf(ColliderVisualizationConfigComponent).copy = function (includeRoom, $super) {
    includeRoom = includeRoom === VOID ? this.includeRoom : includeRoom;
    return this.o3r(includeRoom);
  };
  protoOf(ColliderVisualizationConfigComponent).toString = function () {
    return 'ColliderVisualizationConfigComponent(includeRoom=' + this.includeRoom + ')';
  };
  protoOf(ColliderVisualizationConfigComponent).hashCode = function () {
    return getBooleanHashCode(this.includeRoom);
  };
  protoOf(ColliderVisualizationConfigComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColliderVisualizationConfigComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ColliderVisualizationConfigComponent ? other : THROW_CCE();
    if (!(this.includeRoom === tmp0_other_with_cast.includeRoom))
      return false;
    return true;
  };
  function Companion_96() {
  }
  protoOf(Companion_96).s1k = function () {
    return 23;
  };
  var Companion_instance_129;
  function Companion_getInstance_105() {
    return Companion_instance_129;
  }
  function ColliderVisualizationNodeComponent(ownerEntity, color, collidingBoundIds) {
    this.ownerEntity = ownerEntity;
    this.color = color;
    this.collidingBoundIds = collidingBoundIds;
  }
  protoOf(ColliderVisualizationNodeComponent).p3r = function () {
    return this.ownerEntity;
  };
  protoOf(ColliderVisualizationNodeComponent).h23 = function () {
    return this.color;
  };
  protoOf(ColliderVisualizationNodeComponent).q3r = function () {
    return this.collidingBoundIds;
  };
  protoOf(ColliderVisualizationNodeComponent).x1k = function () {
    return Companion_instance_129.id;
  };
  protoOf(ColliderVisualizationNodeComponent).eq = function (other) {
    return (other instanceof ColliderVisualizationNodeComponent ? other : THROW_CCE()).equals(this);
  };
  protoOf(ColliderVisualizationNodeComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ColliderVisualizationNodeComponent))
      THROW_CCE();
    if (!this.ownerEntity.equals(other.ownerEntity))
      return false;
    if (!equals(this.color, other.color))
      return false;
    if (!contentEquals(this.collidingBoundIds, other.collidingBoundIds))
      return false;
    return true;
  };
  protoOf(ColliderVisualizationNodeComponent).hashCode = function () {
    var result = this.ownerEntity.hashCode();
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.color;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + contentHashCode(this.collidingBoundIds) | 0;
    return result;
  };
  protoOf(ColliderVisualizationNodeComponent).af = function () {
    return this.ownerEntity;
  };
  protoOf(ColliderVisualizationNodeComponent).bf = function () {
    return this.color;
  };
  protoOf(ColliderVisualizationNodeComponent).g1k = function () {
    return this.collidingBoundIds;
  };
  protoOf(ColliderVisualizationNodeComponent).r3r = function (ownerEntity, color, collidingBoundIds) {
    return new ColliderVisualizationNodeComponent(ownerEntity, color, collidingBoundIds);
  };
  protoOf(ColliderVisualizationNodeComponent).copy = function (ownerEntity, color, collidingBoundIds, $super) {
    ownerEntity = ownerEntity === VOID ? this.ownerEntity : ownerEntity;
    color = color === VOID ? this.color : color;
    collidingBoundIds = collidingBoundIds === VOID ? this.collidingBoundIds : collidingBoundIds;
    return this.r3r(ownerEntity, color, collidingBoundIds);
  };
  protoOf(ColliderVisualizationNodeComponent).toString = function () {
    return 'ColliderVisualizationNodeComponent(ownerEntity=' + this.ownerEntity + ', color=' + this.color + ', collidingBoundIds=' + toString(this.collidingBoundIds) + ')';
  };
  function Companion_97() {
    this.id = 98;
  }
  protoOf(Companion_97).s1k = function () {
    return this.id;
  };
  var Companion_instance_130;
  function Companion_getInstance_106() {
    return Companion_instance_130;
  }
  function ColliderVisualizerViewerObjectsComponent(viewerObjets) {
    this.viewerObjets = viewerObjets;
    this.s3r_1 = false;
  }
  protoOf(ColliderVisualizerViewerObjectsComponent).t3r = function () {
    return this.viewerObjets;
  };
  protoOf(ColliderVisualizerViewerObjectsComponent).x1k = function () {
    return 98;
  };
  protoOf(ColliderVisualizerViewerObjectsComponent).eq = function (other) {
    return true;
  };
  protoOf(ColliderVisualizerViewerObjectsComponent).a1l = function () {
    return this.s3r_1;
  };
  protoOf(ColliderVisualizerViewerObjectsComponent).af = function () {
    return this.viewerObjets;
  };
  protoOf(ColliderVisualizerViewerObjectsComponent).u3r = function (viewerObjets) {
    return new ColliderVisualizerViewerObjectsComponent(viewerObjets);
  };
  protoOf(ColliderVisualizerViewerObjectsComponent).copy = function (viewerObjets, $super) {
    viewerObjets = viewerObjets === VOID ? this.viewerObjets : viewerObjets;
    return this.u3r(viewerObjets);
  };
  protoOf(ColliderVisualizerViewerObjectsComponent).toString = function () {
    return 'ColliderVisualizerViewerObjectsComponent(viewerObjets=' + this.viewerObjets + ')';
  };
  protoOf(ColliderVisualizerViewerObjectsComponent).hashCode = function () {
    return hashCode(this.viewerObjets);
  };
  protoOf(ColliderVisualizerViewerObjectsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColliderVisualizerViewerObjectsComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ColliderVisualizerViewerObjectsComponent ? other : THROW_CCE();
    if (!equals(this.viewerObjets, tmp0_other_with_cast.viewerObjets))
      return false;
    return true;
  };
  function Companion_98() {
    this.id = 110;
  }
  protoOf(Companion_98).s1k = function () {
    return this.id;
  };
  var Companion_instance_131;
  function Companion_getInstance_107() {
    return Companion_instance_131;
  }
  function ConnectorVisualizationConfigComponent(includeRoom) {
    this.includeRoom = includeRoom;
  }
  protoOf(ConnectorVisualizationConfigComponent).n3r = function () {
    return this.includeRoom;
  };
  protoOf(ConnectorVisualizationConfigComponent).x1k = function () {
    return 110;
  };
  protoOf(ConnectorVisualizationConfigComponent).eq = function (other) {
    var o = other instanceof ConnectorVisualizationConfigComponent ? other : THROW_CCE();
    return o.includeRoom === this.includeRoom;
  };
  protoOf(ConnectorVisualizationConfigComponent).af = function () {
    return this.includeRoom;
  };
  protoOf(ConnectorVisualizationConfigComponent).o3r = function (includeRoom) {
    return new ConnectorVisualizationConfigComponent(includeRoom);
  };
  protoOf(ConnectorVisualizationConfigComponent).copy = function (includeRoom, $super) {
    includeRoom = includeRoom === VOID ? this.includeRoom : includeRoom;
    return this.o3r(includeRoom);
  };
  protoOf(ConnectorVisualizationConfigComponent).toString = function () {
    return 'ConnectorVisualizationConfigComponent(includeRoom=' + this.includeRoom + ')';
  };
  protoOf(ConnectorVisualizationConfigComponent).hashCode = function () {
    return getBooleanHashCode(this.includeRoom);
  };
  protoOf(ConnectorVisualizationConfigComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConnectorVisualizationConfigComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ConnectorVisualizationConfigComponent ? other : THROW_CCE();
    if (!(this.includeRoom === tmp0_other_with_cast.includeRoom))
      return false;
    return true;
  };
  function Companion_99() {
  }
  protoOf(Companion_99).s1k = function () {
    return 22;
  };
  var Companion_instance_132;
  function Companion_getInstance_108() {
    return Companion_instance_132;
  }
  function ConnectorVisualizationNodeComponent(ownerEntity, data, offersFilter, demandsFilter) {
    this.ownerEntity = ownerEntity;
    this.data = data;
    this.offersFilter = offersFilter;
    this.demandsFilter = demandsFilter;
  }
  protoOf(ConnectorVisualizationNodeComponent).p3r = function () {
    return this.ownerEntity;
  };
  protoOf(ConnectorVisualizationNodeComponent).v3r = function () {
    return this.data;
  };
  protoOf(ConnectorVisualizationNodeComponent).w3r = function () {
    return this.offersFilter;
  };
  protoOf(ConnectorVisualizationNodeComponent).x3r = function () {
    return this.demandsFilter;
  };
  protoOf(ConnectorVisualizationNodeComponent).x1k = function () {
    return Companion_instance_132.id;
  };
  protoOf(ConnectorVisualizationNodeComponent).eq = function (other) {
    return (other instanceof ConnectorVisualizationNodeComponent ? other : THROW_CCE()).equals(this);
  };
  protoOf(ConnectorVisualizationNodeComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ConnectorVisualizationNodeComponent))
      THROW_CCE();
    if (!this.ownerEntity.equals(other.ownerEntity))
      return false;
    if (!(this.data == null)) {
      if (other.data == null)
        return false;
      if (!contentEquals(this.data, other.data))
        return false;
    } else if (!(other.data == null))
      return false;
    if (!(this.offersFilter == null)) {
      if (other.offersFilter == null)
        return false;
      if (!contentEquals(this.offersFilter, other.offersFilter))
        return false;
    } else if (!(other.offersFilter == null))
      return false;
    if (!(this.demandsFilter == null)) {
      if (other.demandsFilter == null)
        return false;
      if (!contentEquals(this.demandsFilter, other.demandsFilter))
        return false;
    } else if (!(other.demandsFilter == null))
      return false;
    return true;
  };
  protoOf(ConnectorVisualizationNodeComponent).hashCode = function () {
    var result = this.ownerEntity.hashCode();
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.data;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contentHashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.offersFilter;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : contentHashCode(tmp2_safe_receiver);
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_1 = imul(31, result);
    var tmp4_safe_receiver = this.demandsFilter;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : contentHashCode(tmp4_safe_receiver);
    result = tmp_1 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    return result;
  };
  protoOf(ConnectorVisualizationNodeComponent).af = function () {
    return this.ownerEntity;
  };
  protoOf(ConnectorVisualizationNodeComponent).bf = function () {
    return this.data;
  };
  protoOf(ConnectorVisualizationNodeComponent).g1k = function () {
    return this.offersFilter;
  };
  protoOf(ConnectorVisualizationNodeComponent).h1k = function () {
    return this.demandsFilter;
  };
  protoOf(ConnectorVisualizationNodeComponent).y3r = function (ownerEntity, data, offersFilter, demandsFilter) {
    return new ConnectorVisualizationNodeComponent(ownerEntity, data, offersFilter, demandsFilter);
  };
  protoOf(ConnectorVisualizationNodeComponent).copy = function (ownerEntity, data, offersFilter, demandsFilter, $super) {
    ownerEntity = ownerEntity === VOID ? this.ownerEntity : ownerEntity;
    data = data === VOID ? this.data : data;
    offersFilter = offersFilter === VOID ? this.offersFilter : offersFilter;
    demandsFilter = demandsFilter === VOID ? this.demandsFilter : demandsFilter;
    return this.y3r(ownerEntity, data, offersFilter, demandsFilter);
  };
  protoOf(ConnectorVisualizationNodeComponent).toString = function () {
    return 'ConnectorVisualizationNodeComponent(ownerEntity=' + this.ownerEntity + ', data=' + toString(this.data) + ', offersFilter=' + toString(this.offersFilter) + ', demandsFilter=' + toString(this.demandsFilter) + ')';
  };
  function Companion_100() {
    this.id = 99;
  }
  protoOf(Companion_100).s1k = function () {
    return this.id;
  };
  var Companion_instance_133;
  function Companion_getInstance_109() {
    return Companion_instance_133;
  }
  function ConnectorVisualizerViewerObjectsComponent(viewerObjets) {
    this.viewerObjets = viewerObjets;
    this.z3r_1 = false;
  }
  protoOf(ConnectorVisualizerViewerObjectsComponent).t3r = function () {
    return this.viewerObjets;
  };
  protoOf(ConnectorVisualizerViewerObjectsComponent).x1k = function () {
    return 99;
  };
  protoOf(ConnectorVisualizerViewerObjectsComponent).eq = function (other) {
    return true;
  };
  protoOf(ConnectorVisualizerViewerObjectsComponent).a1l = function () {
    return this.z3r_1;
  };
  protoOf(ConnectorVisualizerViewerObjectsComponent).af = function () {
    return this.viewerObjets;
  };
  protoOf(ConnectorVisualizerViewerObjectsComponent).u3r = function (viewerObjets) {
    return new ConnectorVisualizerViewerObjectsComponent(viewerObjets);
  };
  protoOf(ConnectorVisualizerViewerObjectsComponent).copy = function (viewerObjets, $super) {
    viewerObjets = viewerObjets === VOID ? this.viewerObjets : viewerObjets;
    return this.u3r(viewerObjets);
  };
  protoOf(ConnectorVisualizerViewerObjectsComponent).toString = function () {
    return 'ConnectorVisualizerViewerObjectsComponent(viewerObjets=' + this.viewerObjets + ')';
  };
  protoOf(ConnectorVisualizerViewerObjectsComponent).hashCode = function () {
    return hashCode(this.viewerObjets);
  };
  protoOf(ConnectorVisualizerViewerObjectsComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConnectorVisualizerViewerObjectsComponent))
      return false;
    var tmp0_other_with_cast = other instanceof ConnectorVisualizerViewerObjectsComponent ? other : THROW_CCE();
    if (!equals(this.viewerObjets, tmp0_other_with_cast.viewerObjets))
      return false;
    return true;
  };
  function Companion_101() {
    this.id = 83;
  }
  protoOf(Companion_101).s1k = function () {
    return this.id;
  };
  var Companion_instance_134;
  function Companion_getInstance_110() {
    return Companion_instance_134;
  }
  function DecoratorComponent(placeholder, decorator, model, modelVisible, decoratorVisible) {
    modelVisible = modelVisible === VOID ? true : modelVisible;
    decoratorVisible = decoratorVisible === VOID ? false : decoratorVisible;
    this.placeholder = placeholder;
    this.decorator = decorator;
    this.model = model;
    this.modelVisible = modelVisible;
    this.decoratorVisible = decoratorVisible;
  }
  protoOf(DecoratorComponent).a3s = function () {
    return this.placeholder;
  };
  protoOf(DecoratorComponent).b3s = function () {
    return this.decorator;
  };
  protoOf(DecoratorComponent).u2h = function () {
    return this.model;
  };
  protoOf(DecoratorComponent).c3s = function () {
    return this.modelVisible;
  };
  protoOf(DecoratorComponent).d3s = function () {
    return this.decoratorVisible;
  };
  protoOf(DecoratorComponent).x1k = function () {
    return 83;
  };
  protoOf(DecoratorComponent).eq = function (other) {
    var o = other instanceof DecoratorComponent ? other : THROW_CCE();
    if (!(o.modelVisible === this.modelVisible))
      return false;
    if (!(o.decoratorVisible === this.decoratorVisible))
      return false;
    return (equals(o.placeholder, this.placeholder) ? equals(o.decorator, this.decorator) : false) ? equals(o.model, this.model) : false;
  };
  protoOf(DecoratorComponent).af = function () {
    return this.placeholder;
  };
  protoOf(DecoratorComponent).bf = function () {
    return this.decorator;
  };
  protoOf(DecoratorComponent).g1k = function () {
    return this.model;
  };
  protoOf(DecoratorComponent).h1k = function () {
    return this.modelVisible;
  };
  protoOf(DecoratorComponent).i1k = function () {
    return this.decoratorVisible;
  };
  protoOf(DecoratorComponent).e3s = function (placeholder, decorator, model, modelVisible, decoratorVisible) {
    return new DecoratorComponent(placeholder, decorator, model, modelVisible, decoratorVisible);
  };
  protoOf(DecoratorComponent).copy = function (placeholder, decorator, model, modelVisible, decoratorVisible, $super) {
    placeholder = placeholder === VOID ? this.placeholder : placeholder;
    decorator = decorator === VOID ? this.decorator : decorator;
    model = model === VOID ? this.model : model;
    modelVisible = modelVisible === VOID ? this.modelVisible : modelVisible;
    decoratorVisible = decoratorVisible === VOID ? this.decoratorVisible : decoratorVisible;
    return this.e3s(placeholder, decorator, model, modelVisible, decoratorVisible);
  };
  protoOf(DecoratorComponent).toString = function () {
    return 'DecoratorComponent(placeholder=' + this.placeholder + ', decorator=' + this.decorator + ', model=' + this.model + ', modelVisible=' + this.modelVisible + ', decoratorVisible=' + this.decoratorVisible + ')';
  };
  protoOf(DecoratorComponent).hashCode = function () {
    var result = hashCode(this.placeholder);
    result = imul(result, 31) + hashCode(this.decorator) | 0;
    result = imul(result, 31) + (this.model == null ? 0 : hashCode(this.model)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.modelVisible) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.decoratorVisible) | 0;
    return result;
  };
  protoOf(DecoratorComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DecoratorComponent))
      return false;
    var tmp0_other_with_cast = other instanceof DecoratorComponent ? other : THROW_CCE();
    if (!equals(this.placeholder, tmp0_other_with_cast.placeholder))
      return false;
    if (!equals(this.decorator, tmp0_other_with_cast.decorator))
      return false;
    if (!equals(this.model, tmp0_other_with_cast.model))
      return false;
    if (!(this.modelVisible === tmp0_other_with_cast.modelVisible))
      return false;
    if (!(this.decoratorVisible === tmp0_other_with_cast.decoratorVisible))
      return false;
    return true;
  };
  function Companion_102() {
    this.id = 78;
  }
  protoOf(Companion_102).s1k = function () {
    return this.id;
  };
  var Companion_instance_135;
  function Companion_getInstance_111() {
    return Companion_instance_135;
  }
  function EntityColliderVisualizationComponent(color, collidingBoundIds, isGenerated) {
    color = color === VOID ? new Color('#1784ba', 0.0901, 0.5176, 0.7294) : color;
    var tmp;
    if (collidingBoundIds === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = collidingBoundIds;
    }
    collidingBoundIds = tmp;
    isGenerated = isGenerated === VOID ? false : isGenerated;
    this.color = color;
    this.collidingBoundIds = collidingBoundIds;
    this.isGenerated = isGenerated;
    this.f3s_1 = false;
  }
  protoOf(EntityColliderVisualizationComponent).h23 = function () {
    return this.color;
  };
  protoOf(EntityColliderVisualizationComponent).q3r = function () {
    return this.collidingBoundIds;
  };
  protoOf(EntityColliderVisualizationComponent).g3s = function () {
    return this.isGenerated;
  };
  protoOf(EntityColliderVisualizationComponent).x1k = function () {
    return 78;
  };
  protoOf(EntityColliderVisualizationComponent).a1l = function () {
    return this.f3s_1;
  };
  protoOf(EntityColliderVisualizationComponent).eq = function (other) {
    if (!(other instanceof EntityColliderVisualizationComponent))
      THROW_CCE();
    if (!(this.color.color === other.color.color))
      return false;
    if (!contentEquals(this.collidingBoundIds, other.collidingBoundIds))
      return false;
    return true;
  };
  protoOf(EntityColliderVisualizationComponent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof EntityColliderVisualizationComponent))
      THROW_CCE();
    if (!(this.color.color === other.color.color))
      return false;
    if (!contentEquals(this.collidingBoundIds, other.collidingBoundIds))
      return false;
    return true;
  };
  protoOf(EntityColliderVisualizationComponent).hashCode = function () {
    var result = this.color.hashCode();
    result = imul(31, result) + contentHashCode(this.collidingBoundIds) | 0;
    return result;
  };
  protoOf(EntityColliderVisualizationComponent).af = function () {
    return this.color;
  };
  protoOf(EntityColliderVisualizationComponent).bf = function () {
    return this.collidingBoundIds;
  };
  protoOf(EntityColliderVisualizationComponent).g1k = function () {
    return this.isGenerated;
  };
  protoOf(EntityColliderVisualizationComponent).i3s = function (color, collidingBoundIds, isGenerated) {
    return new EntityColliderVisualizationComponent(color, collidingBoundIds, isGenerated);
  };
  protoOf(EntityColliderVisualizationComponent).copy = function (color, collidingBoundIds, isGenerated, $super) {
    color = color === VOID ? this.color : color;
    collidingBoundIds = collidingBoundIds === VOID ? this.collidingBoundIds : collidingBoundIds;
    isGenerated = isGenerated === VOID ? this.isGenerated : isGenerated;
    return this.i3s(color, collidingBoundIds, isGenerated);
  };
  protoOf(EntityColliderVisualizationComponent).toString = function () {
    return 'EntityColliderVisualizationComponent(color=' + this.color + ', collidingBoundIds=' + toString(this.collidingBoundIds) + ', isGenerated=' + this.isGenerated + ')';
  };
  function Companion_103() {
    this.id = 77;
  }
  protoOf(Companion_103).s1k = function () {
    return this.id;
  };
  var Companion_instance_136;
  function Companion_getInstance_112() {
    return Companion_instance_136;
  }
  function EntityConnectorVisualizationComponent(data) {
    data = data === VOID ? null : data;
    this.data = data;
    this.j3s_1 = 77;
    this.k3s_1 = false;
  }
  protoOf(EntityConnectorVisualizationComponent).v3r = function () {
    return this.data;
  };
  protoOf(EntityConnectorVisualizationComponent).x1k = function () {
    return this.j3s_1;
  };
  protoOf(EntityConnectorVisualizationComponent).a1l = function () {
    return this.k3s_1;
  };
  protoOf(EntityConnectorVisualizationComponent).eq = function (other) {
    if (this === other)
      return true;
    if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof EntityConnectorVisualizationComponent))
      THROW_CCE();
    if (!contentEquals(this.data, other.data))
      return false;
    return true;
  };
  function ConnectorVisualizationData() {
  }
  function Companion_104() {
  }
  protoOf(Companion_104).s1k = function () {
    return 108;
  };
  var Companion_instance_137;
  function Companion_getInstance_113() {
    return Companion_instance_137;
  }
  function PolyhedronVisualizationNodeComponent() {
  }
  protoOf(PolyhedronVisualizationNodeComponent).x1k = function () {
    return Companion_instance_137.id;
  };
  protoOf(PolyhedronVisualizationNodeComponent).eq = function (other) {
    return true;
  };
  function Companion_105() {
    this.ID = 'AutoAdaptHostZoneVisualizationSystem';
  }
  protoOf(Companion_105).u1n = function () {
    return this.ID;
  };
  var Companion_instance_138;
  function Companion_getInstance_114() {
    return Companion_instance_138;
  }
  function AutoAdaptHostZoneVisualizationSystem(coreServices) {
    PolyhedronVisualizationSystem.call(this, 'AutoAdaptHostZoneVisualizationSystem', coreServices);
  }
  protoOf(AutoAdaptHostZoneVisualizationSystem).getPolyhedron = function (entity) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(127);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hostZone;
  };
  protoOf(AutoAdaptHostZoneVisualizationSystem).getColor = function (entity, polyhedron) {
    var blue = 0.5 + Default_getInstance().bh(0.3, 0.5);
    return new Color('autoadapthostzone', 0.0, 0.0, blue);
  };
  function Companion_106() {
    this.ID = 'DragProjectionPointVisualizationSystem';
  }
  protoOf(Companion_106).u1n = function () {
    return this.ID;
  };
  var Companion_instance_139;
  function Companion_getInstance_115() {
    return Companion_instance_139;
  }
  function DragProjectionPointVisualizationSystem(coreServices) {
    PolyhedronVisualizationSystem.call(this, 'DragProjectionPointVisualizationSystem', coreServices);
  }
  protoOf(DragProjectionPointVisualizationSystem).getPolyhedron = function (entity) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(113);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.projectionPoint;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var projectionPoint = tmp;
    return CuboidFromSizeAndCenter(__VectorIntConstructorKotlin(50, 50, 50), projectionPoint);
  };
  protoOf(DragProjectionPointVisualizationSystem).getColor = function (entity, polyhedron) {
    return new Color('dragprojectionpoint', 1.0, 0.0, 0.0);
  };
  function Companion_107() {
    this.ID = 'FunctionalMarginVisualizationSystem';
  }
  protoOf(Companion_107).u1n = function () {
    return this.ID;
  };
  var Companion_instance_140;
  function Companion_getInstance_116() {
    return Companion_instance_140;
  }
  function FunctionalMarginVisualizationSystem(coreServices) {
    PolyhedronVisualizationSystem.call(this, 'FunctionalMarginVisualizationSystem', coreServices);
  }
  protoOf(FunctionalMarginVisualizationSystem).getPolyhedron = function (entity) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(61);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.shape(entity);
  };
  protoOf(FunctionalMarginVisualizationSystem).getColor = function (entity, polyhedron) {
    var green = Default_getInstance().bh(0.5, 1.0);
    return new Color('functionalmargin', 0.0, green, 0.0);
  };
  function Companion_108() {
    this.ID = 'FunctionalZoneVisualizationSystem';
  }
  protoOf(Companion_108).u1n = function () {
    return this.ID;
  };
  var Companion_instance_141;
  function Companion_getInstance_117() {
    return Companion_instance_141;
  }
  function FunctionalZoneVisualizationSystem(coreServices) {
    PolyhedronVisualizationSystem.call(this, 'FunctionalZoneVisualizationSystem', coreServices);
  }
  protoOf(FunctionalZoneVisualizationSystem).getPolyhedron = function (entity) {
    var tmp0_elvis_lhs = entity.__getComponentForKotlin(121);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var functionalZonesComponent = tmp;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = functionalZonesComponent.zones;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.FunctionalZoneVisualizationSystem.getPolyhedron.<anonymous>' call
      var tmp$ret$0 = item.polyhedron;
      destination.q(tmp$ret$0);
    }
    var polyhedrons = copyToArray(destination);
    return new PolyhedronGroup(polyhedrons);
  };
  protoOf(FunctionalZoneVisualizationSystem).getColor = function (entity, polyhedron) {
    var blue = Default_getInstance().bh(0.5, 0.8);
    return new Color('functional zone', 0.9, 0.9, blue);
  };
  function Companion_109() {
    this.id = 102;
  }
  protoOf(Companion_109).s1k = function () {
    return this.id;
  };
  var Companion_instance_142;
  function Companion_getInstance_118() {
    return Companion_instance_142;
  }
  function PolyhedronVisualizationHolderComponent(systemId) {
    this.systemId = systemId;
    this.v3s_1 = 102;
  }
  protoOf(PolyhedronVisualizationHolderComponent).w3s = function () {
    return this.systemId;
  };
  protoOf(PolyhedronVisualizationHolderComponent).x1k = function () {
    return this.v3s_1;
  };
  protoOf(PolyhedronVisualizationHolderComponent).eq = function (other) {
    var tmp0_safe_receiver = other instanceof PolyhedronVisualizationHolderComponent ? other : null;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.systemId) === this.systemId;
  };
  protoOf(PolyhedronVisualizationHolderComponent).af = function () {
    return this.systemId;
  };
  protoOf(PolyhedronVisualizationHolderComponent).q1l = function (systemId) {
    return new PolyhedronVisualizationHolderComponent(systemId);
  };
  protoOf(PolyhedronVisualizationHolderComponent).copy = function (systemId, $super) {
    systemId = systemId === VOID ? this.systemId : systemId;
    return this.q1l(systemId);
  };
  protoOf(PolyhedronVisualizationHolderComponent).toString = function () {
    return 'PolyhedronVisualizationHolderComponent(systemId=' + this.systemId + ')';
  };
  protoOf(PolyhedronVisualizationHolderComponent).hashCode = function () {
    return getStringHashCode(this.systemId);
  };
  protoOf(PolyhedronVisualizationHolderComponent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PolyhedronVisualizationHolderComponent))
      return false;
    var tmp0_other_with_cast = other instanceof PolyhedronVisualizationHolderComponent ? other : THROW_CCE();
    if (!(this.systemId === tmp0_other_with_cast.systemId))
      return false;
    return true;
  };
  function _get_viewer__pq1i9z_0($this) {
    return $this.l3q_1.coreModules.viewer();
  }
  function createAllVisualizations($this) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = $this.l3q_1.sceneManager.entities;
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createAllVisualizations.<anonymous>' call
      if (element.hasComponent(InSceneComponent_instance.id)) {
        destination.q(element);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createAllVisualizations.<anonymous>' call
      createPolyhedronVisualization($this, element_0);
    }
  }
  function clearVisualizationEntities($this) {
    clearEntityHierarchy($this, $this.l3q_1.sceneManager.scene);
  }
  function hasHolderComponent($this, it) {
    var tmp0_safe_receiver = it.__getComponentForKotlin(102);
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.systemId) === $this.id;
  }
  function clearEntityHierarchy($this, entity) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_descendants(entity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.clearEntityHierarchy.<anonymous>' call
      if (hasHolderComponent($this, element)) {
        destination.q(element);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.clearEntityHierarchy.<anonymous>' call
      var tmp0_safe_receiver = element_0.__getComponentForKotlin(Companion_instance_29.id);
      var viewerObject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.viewerObject;
      $this.m3q_1.disposeEntity(element_0);
      if (viewerObject == null)
        null;
      else {
        viewerObject.deleteObject();
      }
    }
  }
  function createPolyhedronVisualization($this, entity) {
    var poly = $this.getPolyhedron(entity);
    if (poly == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>' call
      var tmp0_safe_receiver = _get_viewer__pq1i9z_0($this);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var parent = createHolderEntity($this, entity);
        var viewerObject = createPolyhedronVisualization$default($this, tmp0_safe_receiver, poly, parent);
        var tmp0_safe_receiver_0 = get_viewerObject(entity);
        if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.getVisible()) === false) {
          if (viewerObject == null)
            null;
          else
            viewerObject.setVisible(false);
        }
        var tmp_0;
        if (!(viewerObject == null)) {
          parent.addComponent(new ViewerObjectComponent(viewerObject));
          tmp_0 = Unit_instance;
        }
        tmp = Unit_instance;
      }
    }
  }
  function createHolderEntity($this, entity) {
    var visualizerHolder = $this.m3q_1.createEntity();
    setParent(visualizerHolder, entity);
    visualizerHolder.addComponent(new DisplayNameComponent('PolyhedronVisualizerNode[' + $this.id + ']'));
    visualizerHolder.addComponent(RenderedComponent_instance);
    visualizerHolder.addComponent(new PolyhedronVisualizationHolderComponent($this.id));
    visualizerHolder.addComponent(new PolyhedronVisualizationNodeComponent());
    visualizerHolder.addComponent(new UnserializableEntityComponent());
    return visualizerHolder;
  }
  function createPolyhedronVisualization_0($this, viewer, polyhedron, entity, parent) {
    var color = $this.getColor(entity, polyhedron);
    if (polyhedron instanceof ConvexPolyhedron)
      return createPolyhedronVisualization_2($this, viewer, polyhedron, entity, parent, color);
    else {
      if (polyhedron instanceof PolyhedronGroup)
        return createPolyhedronVisualization_1($this, viewer, polyhedron, entity, parent, color);
    }
    return null;
  }
  function createPolyhedronVisualization$default($this, viewer, polyhedron, entity, parent, $super) {
    parent = parent === VOID ? viewer.createSphere(0.001) : parent;
    return createPolyhedronVisualization_0($this, viewer, polyhedron, entity, parent);
  }
  function createPolyhedronVisualization_1($this, viewer, polyhedron, entity, parent, color) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = polyhedron.polyhedra;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>' call
      if (element instanceof ConvexPolyhedron) {
        createPolyhedronVisualization_2($this, viewer, element, entity, parent, color);
      }
    }
    return parent;
  }
  function createPolyhedronVisualization_2($this, viewer, polyhedron, entity, parent, color) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (polyhedron.vertices.length === 0)
      return null;
    var vertices = polyhedron.vertices;
    // Inline function 'kotlin.collections.map' call
    var this_0 = polyhedron.faces;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = item.indices;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(this_1.length);
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var item_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>.<anonymous>' call
        var tmp$ret$1 = vertices[item_0];
        destination_0.q(tmp$ret$1);
      }
      var tmp$ret$5 = copyToArray(destination_0);
      destination.q(tmp$ret$5);
    }
    var vectorFaces = destination;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(vectorFaces, 10));
    var tmp0_iterator = vectorFaces.t();
    while (tmp0_iterator.u()) {
      var item_1 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization.<anonymous>' call
      var normal = PolyhedronUtils_getInstance().surfaceNormal(item_1);
      var viewerObject = viewer.createSurface(item_1, normal, entity);
      viewerObject.setBaseColor(color.r, color.g, color.b);
      setTransparency($this, viewerObject);
      destination_1.q(viewerObject);
    }
    var viewerObjects = destination_1;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$11 = copyToArray(viewerObjects);
    var group = viewer.groupMeshes(tmp$ret$11, entity);
    group.setParent(parent);
    return parent;
  }
  function setTransparency($this, viewerObject) {
    return viewerObject.setTransparency($this.alpha);
  }
  function PolyhedronVisualizationSystem(id, coreServices) {
    var tmp = InSceneComponent_instance.id;
    SystemBase3.call(this, id, tmp, 82, Companion_instance_31.id);
    this.l3q_1 = coreServices;
    this.m3q_1 = this.l3q_1.entityManager;
    this.alpha = 0.8;
    this.colorRandomizationAmount = 0.5;
    var tmp_0 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.n3q_1 = [];
  }
  protoOf(PolyhedronVisualizationSystem).r3s = function (_set____db54di) {
    this.alpha = _set____db54di;
  };
  protoOf(PolyhedronVisualizationSystem).s3s = function () {
    return this.alpha;
  };
  protoOf(PolyhedronVisualizationSystem).t3s = function (_set____db54di) {
    this.colorRandomizationAmount = _set____db54di;
  };
  protoOf(PolyhedronVisualizationSystem).u3s = function () {
    return this.colorRandomizationAmount;
  };
  protoOf(PolyhedronVisualizationSystem).enable = function () {
    if (this.isEnabled)
      return Unit_instance;
    protoOf(SystemBase3).enable.call(this);
    createAllVisualizations(this);
  };
  protoOf(PolyhedronVisualizationSystem).disable = function () {
    if (!this.isEnabled)
      return Unit_instance;
    protoOf(SystemBase3).disable.call(this);
    clearVisualizationEntities(this);
  };
  protoOf(PolyhedronVisualizationSystem).w1o = function () {
    return this.n3q_1;
  };
  protoOf(PolyhedronVisualizationSystem).onAddComponent = function (entity, newComponent) {
    createPolyhedronVisualization(this, entity);
  };
  protoOf(PolyhedronVisualizationSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    createPolyhedronVisualization(this, entity);
  };
  protoOf(PolyhedronVisualizationSystem).onRemoveComponent = function (entity, oldComponent) {
    clearEntityHierarchy(this, entity);
  };
  protoOf(PolyhedronVisualizationSystem).onAddComponent2 = function (entity, newComponent) {
    createAllVisualizations(this);
  };
  protoOf(PolyhedronVisualizationSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    this.onRemoveComponent2(entity, oldComponent);
    this.onAddComponent2(entity, newComponent);
  };
  protoOf(PolyhedronVisualizationSystem).onRemoveComponent2 = function (entity, oldComponent) {
    clearVisualizationEntities(this);
  };
  protoOf(PolyhedronVisualizationSystem).onAddComponent3 = function (entity, newComponent) {
    clearVisualizationEntities(this);
  };
  protoOf(PolyhedronVisualizationSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
  };
  protoOf(PolyhedronVisualizationSystem).onRemoveComponent3 = function (entity, oldComponent) {
    clearVisualizationEntities(this);
    createAllVisualizations(this);
  };
  function Companion_110() {
    this.ID = 'ColliderVisualizationSystem';
  }
  protoOf(Companion_110).u1n = function () {
    return this.ID;
  };
  protoOf(Companion_110).createEntityColliderVisualizationComponent = function () {
    return new EntityColliderVisualizationComponent(VOID, VOID, true);
  };
  var Companion_instance_143;
  function Companion_getInstance_119() {
    return Companion_instance_143;
  }
  function ColliderVisualizationSystem(coreServices) {
    ForcedComponentBaseSystem.call(this, 'ColliderVisualizationSystem', 78, Companion_instance_143.createEntityColliderVisualizationComponent(), coreServices);
    this.configEntity.addComponent(new ColliderVisualizationConfigComponent(false));
    this.enable();
  }
  protoOf(ColliderVisualizationSystem).n3t = function (value) {
    var wasEnabled = this.isEnabled;
    this.disable();
    this.configEntity.addComponent(new ColliderVisualizationConfigComponent(value));
    if (wasEnabled) {
      this.enable();
    }
  };
  protoOf(ColliderVisualizationSystem).n3r = function () {
    return this.configEntity.getComponentUnsafe(109).includeRoom;
  };
  protoOf(ColliderVisualizationSystem).entityIsEligibleForComponent = function (entity) {
    var tmp;
    if (entity.hasComponent(RoomComponent_instance.id) ? !this.includeRoom : false) {
      tmp = false;
    } else {
      var tmp_0;
      if (entity.hasComponent(103)) {
        tmp_0 = !this.includeRoom;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = false;
      } else {
        if (entity.hasComponent(Companion_instance_129.id)) {
          tmp = false;
        } else {
          if (!get_isInScene(entity)) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  };
  function ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1($showActivationDistance, $showTransform) {
    this.r3t_1 = '';
    this.s3t_1 = '';
    this.t3t_1 = false;
    this.u3t_1 = true;
    this.v3t_1 = false;
    var tmp = this;
    tmp.w3t_1 = $showActivationDistance == null ? false : $showActivationDistance;
    var tmp_0 = this;
    tmp_0.x3t_1 = $showTransform == null ? false : $showTransform;
  }
  protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).z21 = function () {
    return this.r3t_1;
  };
  protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).l3s = function () {
    return this.s3t_1;
  };
  protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).m3s = function () {
    return this.t3t_1;
  };
  protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).n3s = function () {
    return this.u3t_1;
  };
  protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).o3s = function () {
    return this.v3t_1;
  };
  protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).p3s = function () {
    return this.w3t_1;
  };
  protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1).q3s = function () {
    return this.x3t_1;
  };
  function setEnabledFeatures($this, activationDistanceActivate, transformActivate) {
    $this.setConfigComponent(Companion_instance_144.createEntityConnectorVisualizationComponent(activationDistanceActivate, transformActivate));
  }
  function Companion_111() {
    this.ID = 'ConnectorVisualizationSystem';
  }
  protoOf(Companion_111).u1n = function () {
    return this.ID;
  };
  protoOf(Companion_111).y3t = function (showActivationDistance, showTransform) {
    var data = new ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1(showActivationDistance, showTransform);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [data];
    return new EntityConnectorVisualizationComponent(tmp$ret$2);
  };
  protoOf(Companion_111).createEntityConnectorVisualizationComponent = function (showActivationDistance, showTransform, $super) {
    showActivationDistance = showActivationDistance === VOID ? null : showActivationDistance;
    showTransform = showTransform === VOID ? null : showTransform;
    return this.y3t(showActivationDistance, showTransform);
  };
  var Companion_instance_144;
  function Companion_getInstance_120() {
    return Companion_instance_144;
  }
  function ConnectorVisualizationSystem(coreServices) {
    ForcedComponentBaseSystem.call(this, 'ConnectorVisualizationSystem', 77, Companion_instance_144.createEntityConnectorVisualizationComponent(), coreServices);
    this.h3u_1 = coreServices.entityManager;
    this.configEntity.addComponent(new ConnectorVisualizationConfigComponent(false));
    this.enable();
  }
  protoOf(ConnectorVisualizationSystem).n3t = function (value) {
    var wasEnabled = this.isEnabled;
    this.disable();
    this.configEntity.addComponent(new ConnectorVisualizationConfigComponent(value));
    if (wasEnabled) {
      this.enable();
    }
  };
  protoOf(ConnectorVisualizationSystem).n3r = function () {
    return this.configEntity.getComponentUnsafe(110).includeRoom;
  };
  protoOf(ConnectorVisualizationSystem).entityIsEligibleForComponent = function (entity) {
    var tmp;
    if (entity.hasComponent(RoomComponent_instance.id) ? !this.includeRoom : false) {
      tmp = false;
    } else {
      var tmp_0;
      if (entity.hasComponent(103)) {
        tmp_0 = !this.includeRoom;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = false;
      } else {
        if (entity.hasComponent(Companion_instance_132.id)) {
          tmp = false;
        } else {
          if (!get_isInScene(entity)) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  };
  protoOf(ConnectorVisualizationSystem).i3u = function (value) {
    setEnabledFeatures(this, value, this.connectorTransformVisualizationEnabled);
  };
  protoOf(ConnectorVisualizationSystem).f3r = function () {
    var tmp0_safe_receiver = this.getForcedComponentConfigUnsafe(77).data;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[0];
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.showActivationDistance;
    return tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
  };
  protoOf(ConnectorVisualizationSystem).j3u = function (value) {
    setEnabledFeatures(this, this.connectorActivationDistanceVisualizationEnabled, value);
  };
  protoOf(ConnectorVisualizationSystem).g3r = function () {
    var tmp0_safe_receiver = this.getForcedComponentConfigUnsafe(77).data;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[0];
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.showTransform;
    return tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
  };
  function generateColliderShapeBounds($this, entity, ids, polyhedron, colliderVisualizer, color, collidingBoundIds) {
    var tmp;
    if (polyhedron instanceof ConvexPolyhedron) {
      var tmp_0 = ids[0];
      var tmp1_safe_receiver = get_viewerObject(entity);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.getScale();
      var tmp3_safe_receiver = createVisualization($this, entity, tmp_0, polyhedron, colliderVisualizer, tmp2_elvis_lhs == null ? Companion_getInstance_4().ONE : tmp2_elvis_lhs, color, collidingBoundIds);
      var tmp_1;
      if (tmp3_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateColliderShapeBounds.<anonymous>' call
        var id = tmp3_safe_receiver.af();
        var viewerObject = tmp3_safe_receiver.bf();
        tmp_1 = mapOf_0(to(id, viewerObject));
      }
      var tmp4_elvis_lhs = tmp_1;
      tmp = tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs;
    } else {
      if (polyhedron instanceof PolyhedronGroup) {
        // Inline function 'kotlin.collections.associate' call
        // Inline function 'kotlin.collections.mapIndexedNotNull' call
        // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
        var this_0 = polyhedron.polyhedra;
        var destination = ArrayList_init_$Create$();
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var item = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateColliderShapeBounds.<anonymous>' call
          var tmp_2;
          var tmp_3;
          if (item instanceof ConvexPolyhedron) {
            tmp_3 = ids.length > tmp1;
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            var tmp_4 = Companion_instance_145;
            var tmp_5 = ids[tmp1];
            var tmp0_safe_receiver = get_viewerObject(entity);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getScale();
            tmp_2 = createVisualization(tmp_4, entity, tmp_5, item, colliderVisualizer, tmp1_elvis_lhs == null ? Companion_getInstance_4().ONE : tmp1_elvis_lhs, color, collidingBoundIds);
          } else {
            throw Error_init_$Create$('Unsupported collider type or no id');
          }
          var tmp0_safe_receiver_0 = tmp_2;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            destination.q(tmp0_safe_receiver_0);
          }
        }
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_0 = LinkedHashMap_init_$Create$_0(capacity);
        var tmp0_iterator = destination.t();
        while (tmp0_iterator.u()) {
          var element = tmp0_iterator.w();
          // Inline function 'kotlin.collections.plusAssign' call
          // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateColliderShapeBounds.<anonymous>' call
          var id_0 = element.af();
          var viewerObject_0 = element.bf();
          var pair = to(id_0, viewerObject_0);
          destination_0.r2(pair.ye_1, pair.ze_1);
        }
        tmp = destination_0;
      } else {
        tmp = emptyMap();
      }
    }
    return tmp;
  }
  function createVisualization($this, entity, id, polyhedron, colliderVisualizer, scale, color, collidingBoundIds) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (polyhedron.vertices.length === 0)
      return null;
    var tmp0_safe_receiver = colliderVisualizer.createColliderVisualization(entity, polyhedron, color, contains(collidingBoundIds, id));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp0_safe_receiver.setScale(1.0 / scale.X, 1.0 / scale.Y, 1.0 / scale.Z);
      tmp0_safe_receiver.setVisible(true);
      return new Pair(id, tmp0_safe_receiver);
    }
    return tmp;
  }
  function _get_sceneManager__lxhb6y_0($this) {
    return $this.coreServices.sceneManager;
  }
  function hasNoVisualization($this, entity) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = get_children(entity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.hasNoVisualization.<anonymous>' call
        if (element.hasComponent(98)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return !tmp$ret$1;
  }
  function hasNewVisualizationData($this, entity, colliderVisualizationData) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var indexedObject = get_children(entity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.hasNewVisualizationData.<anonymous>' call
        var result = _get_colliderVisualizationNode__i436cf(element, $this);
        if (!(result == null)) {
          tmp$ret$1 = result;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var currentVisualizationNodeData = tmp$ret$1;
    var newVisualizationNodeData = generateNodeData($this, entity, colliderVisualizationData.color, colliderVisualizationData.collidingBoundIds);
    return !newVisualizationNodeData.equals(currentVisualizationNodeData);
  }
  function generateNodeData($this, entity, color, collidingBoundIds) {
    return new ColliderVisualizationNodeComponent(entity, color, collidingBoundIds);
  }
  function addDecoration($this, entity, polyhedron, ids, color, collidingBoundIds) {
    var visualizerHolder = $this.s3u_1.createEntity();
    visualizerHolder.addComponent(generateNodeData($this, entity, color, collidingBoundIds));
    visualizerHolder.addComponent(new UnserializableEntityComponent());
    visualizerHolder.addComponent(new DisplayNameComponent('ColliderVisualizerNode'));
    visualizerHolder.addComponent(RenderedComponent_instance);
    setParent(visualizerHolder, entity);
    // Inline function 'kotlin.collections.mutableMapOf' call
    var viewerObjects = LinkedHashMap_init_$Create$();
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(ids.length === 0)) {
      var parent = $this.colliderVisualizer.createParent(visualizerHolder);
      if (parent == null)
        null;
      else {
        parent.registerInputEvents();
      }
      var polyhedronDecorator = generateColliderShapeBounds(Companion_instance_145, visualizerHolder, ids, polyhedron, $this.colliderVisualizer, color, collidingBoundIds);
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = polyhedronDecorator.q2().t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.addDecoration.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var id = element.t2();
        // Inline function 'kotlin.collections.component2' call
        var viewerObject = element.u2();
        viewerObject.registerInputEvents();
        viewerObject.setParent(parent);
        // Inline function 'kotlin.collections.set' call
        viewerObjects.r2(id, viewerObject);
      }
      visualizerHolder.addComponent(new ColliderVisualizerViewerObjectsComponent(viewerObjects));
      tmp = parent;
    } else {
      $this.s3u_1.disposeEntity(visualizerHolder);
      tmp = null;
    }
    var viewerObject_0 = tmp;
    if (viewerObject_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.addDecoration.<anonymous>' call
      visualizerHolder.addComponent(new ViewerObjectComponent(viewerObject_0));
    }
  }
  function updateDecoration($this, entity, polyhedron, ids, color, collidingBoundIds) {
    removeDecoration($this, entity);
    addDecoration($this, entity, polyhedron, ids, color, collidingBoundIds);
  }
  function findVisualizerHolder($this, entity) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_children(entity);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.findVisualizerHolder.<anonymous>' call
        if (element.hasComponent(Companion_instance_129.id)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function removeDecoration($this, entity) {
    var holder = findVisualizerHolder($this, entity);
    var tmp1_safe_receiver = holder == null ? null : holder.__getComponentForKotlin(Companion_instance_29.id);
    var viewerObject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.viewerObject;
    if (holder == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      $this.s3u_1.disposeEntity(holder);
    }
    if (viewerObject == null)
      null;
    else {
      viewerObject.deleteObject();
    }
  }
  function componentsChanged($this, entity) {
    var colliderComponent = entity.__getComponentForKotlin(19);
    var visualizationComponent = entity.__getComponentForKotlin(78);
    if (!(visualizationComponent == null) ? !(colliderComponent == null) : false) {
      var tmp0_elvis_lhs = colliderComponent.ids;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.emptyArray' call
        tmp = [];
      } else {
        tmp = tmp0_elvis_lhs;
      }
      updateDecoration($this, entity, colliderComponent.polyhedron, tmp, visualizationComponent.color, visualizationComponent.collidingBoundIds);
    } else {
      removeDecoration($this, entity);
    }
  }
  function updateColors($this, entity, color, collidingBoundIds) {
    var holder = findVisualizerHolder($this, entity);
    var tmp;
    if (holder == null) {
      tmp = null;
    } else {
      tmp = holder.__getComponentForKotlin(98);
    }
    var tmp1_safe_receiver = tmp;
    var viewerObjects = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.viewerObjets;
    if (viewerObjects == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = viewerObjects.q2().t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.updateColors.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var id = element.t2();
        // Inline function 'kotlin.collections.component2' call
        var viewerObject = element.u2();
        if (contains(collidingBoundIds, id)) {
          $this.colliderVisualizer.indicateCollision(viewerObject);
        } else if (!(color == null)) {
          $this.colliderVisualizer.setColor(viewerObject, color);
        }
      }
    }
  }
  function _get_colliderVisualizationNode__i436cf(_this__u8e3s4, $this) {
    return _this__u8e3s4.__getComponentForKotlin(Companion_instance_129.id);
  }
  function Companion_112() {
    this.ID = 'EntityColliderVisualizationSystem';
  }
  protoOf(Companion_112).u1n = function () {
    return this.ID;
  };
  var Companion_instance_145;
  function Companion_getInstance_121() {
    return Companion_instance_145;
  }
  function EntityColliderVisualizationSystem(coreServices, colliderVisualizer) {
    var tmp = Companion_instance_31.id;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp_1 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$2 = [];
    SystemBase5.call(this, 'EntityColliderVisualizationSystem', 19, 78, 82, tmp, 123, tmp_0, tmp_1, tmp$ret$2);
    this.coreServices = coreServices;
    this.colliderVisualizer = colliderVisualizer;
    this.s3u_1 = this.coreServices.entityManager;
    this.enable();
  }
  protoOf(EntityColliderVisualizationSystem).k2z = function () {
    return this.coreServices;
  };
  protoOf(EntityColliderVisualizationSystem).t3u = function (_set____db54di) {
    this.colliderVisualizer = _set____db54di;
  };
  protoOf(EntityColliderVisualizationSystem).u3u = function () {
    return this.colliderVisualizer;
  };
  protoOf(EntityColliderVisualizationSystem).onAddComponent3 = function (entity, newComponent) {
    this.refresh();
  };
  protoOf(EntityColliderVisualizationSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
    this.refresh();
  };
  protoOf(EntityColliderVisualizationSystem).onRemoveComponent3 = function (entity, oldComponent) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_hierarchy(_get_sceneManager__lxhb6y_0(this).root);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.onRemoveComponent3.<anonymous>' call
      if (!element.hasComponent(Companion_instance_129.id)) {
        destination.q(element);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.onRemoveComponent3.<anonymous>' call
      removeDecoration(this, element_0);
    }
    this.refresh();
  };
  protoOf(EntityColliderVisualizationSystem).onAddComponent5 = function (entity, newComponent) {
    var tmp0_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_instance_129.id);
    var wasAColliderVisualizationNode = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    if (!wasAColliderVisualizationNode) {
      return Unit_instance;
    }
    var newEntity = newComponent.entity;
    var newData = newEntity == null ? null : newEntity.__getComponentForKotlin(Companion_instance_129.id);
    var entityWasRemoved = newEntity == null;
    var shouldRemoveVisualization = newData == null;
    if (entityWasRemoved ? true : shouldRemoveVisualization) {
      var tmp3_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.getComponent(Companion_instance_29.id);
      var oldParentViewerObject = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.viewerObject;
      if (oldParentViewerObject == null)
        null;
      else {
        oldParentViewerObject.deleteObject();
      }
    }
  };
  protoOf(EntityColliderVisualizationSystem).onUpdateComponent5 = function (entity, oldComponent, newComponent) {
  };
  protoOf(EntityColliderVisualizationSystem).onRemoveComponent5 = function (entity, oldComponent) {
  };
  protoOf(EntityColliderVisualizationSystem).onAddComponent4 = function (entity, newComponent) {
  };
  protoOf(EntityColliderVisualizationSystem).onUpdateComponent4 = function (entity, oldComponent, newComponent) {
  };
  protoOf(EntityColliderVisualizationSystem).onRemoveComponent4 = function (entity, oldComponent) {
    this.refresh();
  };
  protoOf(EntityColliderVisualizationSystem).enable = function () {
    protoOf(SystemBase5).enable.call(this);
    this.refresh();
  };
  protoOf(EntityColliderVisualizationSystem).disable = function () {
    protoOf(SystemBase5).disable.call(this);
    this.refresh();
  };
  protoOf(EntityColliderVisualizationSystem).refresh = function () {
    if (this.isEnabled) {
      // Inline function 'kotlin.sequences.forEach' call
      var tmp0_iterator = get_hierarchySequence(_get_sceneManager__lxhb6y_0(this).root).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.refresh.<anonymous>' call
        var colliderVisualizationData = element.__getComponentForKotlin(78);
        var colliderComponent = element.__getComponentForKotlin(19);
        if (!(colliderVisualizationData == null) ? !(colliderComponent == null) : false) {
          if (hasNoVisualization(this, element) ? true : hasNewVisualizationData(this, element, colliderVisualizationData)) {
            var tmp0_elvis_lhs = colliderComponent.ids;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.emptyArray' call
              tmp = [];
            } else {
              tmp = tmp0_elvis_lhs;
            }
            updateDecoration(this, element, colliderComponent.polyhedron, tmp, colliderVisualizationData.color, colliderVisualizationData.collidingBoundIds);
          }
        } else {
          removeDecoration(this, element);
        }
      }
    } else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this.s3u_1.entities;
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_0 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.refresh.<anonymous>' call
        if (!element_0.hasComponent(Companion_instance_129.id)) {
          destination.q(element_0);
        }
      }
      var tmp0_iterator_0 = destination.t();
      while (tmp0_iterator_0.u()) {
        var element_1 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityColliderVisualizationSystem.refresh.<anonymous>' call
        removeDecoration(this, element_1);
      }
    }
  };
  protoOf(EntityColliderVisualizationSystem).setVisualizer = function (colliderVisualizer) {
    this.colliderVisualizer = colliderVisualizer;
  };
  protoOf(EntityColliderVisualizationSystem).onAddComponent = function (entity, newComponent) {
    var tmp;
    if (entity.hasComponent(78)) {
      tmp = get_isInScene(entity);
    } else {
      tmp = false;
    }
    if (tmp) {
      componentsChanged(this, entity);
    }
  };
  protoOf(EntityColliderVisualizationSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    var tmp;
    if (entity.hasComponent(78)) {
      tmp = get_isInScene(entity);
    } else {
      tmp = false;
    }
    if (tmp) {
      componentsChanged(this, entity);
    }
  };
  protoOf(EntityColliderVisualizationSystem).onRemoveComponent = function (entity, oldComponent) {
    removeDecoration(this, entity);
  };
  protoOf(EntityColliderVisualizationSystem).onAddComponent2 = function (entity, newComponent) {
    if (get_isInScene(entity)) {
      componentsChanged(this, entity);
    }
  };
  protoOf(EntityColliderVisualizationSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    if (get_isInScene(entity)) {
      updateColors(this, entity, newComponent.color, newComponent.collidingBoundIds);
    }
  };
  protoOf(EntityColliderVisualizationSystem).onRemoveComponent2 = function (entity, oldComponent) {
    removeDecoration(this, entity);
  };
  function Companion_113() {
    this.ID = 4;
  }
  protoOf(Companion_113).u1n = function () {
    return this.ID;
  };
  var Companion_instance_146;
  function Companion_getInstance_122() {
    return Companion_instance_146;
  }
  function CollisionVisualizationSceneDataComponent(data) {
    this.data = data;
  }
  protoOf(CollisionVisualizationSceneDataComponent).v3r = function () {
    return this.data;
  };
  protoOf(CollisionVisualizationSceneDataComponent).x1k = function () {
    return 4;
  };
  protoOf(CollisionVisualizationSceneDataComponent).eq = function (other) {
    return equals(this.data, (other instanceof CollisionVisualizationSceneDataComponent ? other : THROW_CCE()).data);
  };
  function CollisionVisualizationSceneData(collisions, collisionMap) {
    var tmp;
    if (collisions === VOID) {
      // Inline function 'kotlin.emptyArray' call
      tmp = [];
    } else {
      tmp = collisions;
    }
    collisions = tmp;
    var tmp_0;
    if (collisionMap === VOID) {
      // Inline function 'kotlin.collections.mapOf' call
      tmp_0 = emptyMap();
    } else {
      tmp_0 = collisionMap;
    }
    collisionMap = tmp_0;
    this.collisions = collisions;
    this.collisionMap = collisionMap;
  }
  protoOf(CollisionVisualizationSceneData).v3u = function (_set____db54di) {
    this.collisions = _set____db54di;
  };
  protoOf(CollisionVisualizationSceneData).z1n = function () {
    return this.collisions;
  };
  protoOf(CollisionVisualizationSceneData).w3u = function (_set____db54di) {
    this.collisionMap = _set____db54di;
  };
  protoOf(CollisionVisualizationSceneData).x3u = function () {
    return this.collisionMap;
  };
  function _get_sceneManager__lxhb6y_1($this) {
    return $this.coreServices.sceneManager;
  }
  function _get_collisionData__2ruset($this) {
    var tmp0_safe_receiver = _get_sceneManager__lxhb6y_1($this).scene.__getComponentForKotlin(4);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.data;
  }
  function detectCollision($this, entity) {
    var tmp0_elvis_lhs = _get_collisionData__2ruset($this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var data = tmp;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var tmp0_iterator = get_hierarchySequence(entity).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.detectCollision.<anonymous>' call
        if (element.hasComponent(24)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    if (tmp$ret$1) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      var map = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_0 = data.collisionMap.q2().t();
      while (tmp0_iterator_0.u()) {
        var element_0 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.detectCollision.<anonymous>' call
        // Inline function 'kotlin.collections.set' call
        var this_0 = map;
        var key = element_0.t2();
        // Inline function 'kotlin.emptyArray' call
        var value = [];
        this_0.r2(key, value);
      }
      foldCollisions($this, collisionsWithoutEntity($this, entity), map);
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.detectCollision.<anonymous>' call
      var entityCollisions = Companion_instance_150.getCollisions(entity, get_hierarchySequence(_get_sceneManager__lxhb6y_1($this).root));
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(entityCollisions.length);
      var inductionVariable = 0;
      var last = entityCollisions.length;
      while (inductionVariable < last) {
        var item = entityCollisions[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.detectCollision.<anonymous>.<anonymous>' call
        var tmp$ret$5 = new CollisionVisualizationData(item.penetration, item.otherEntity, item.otherBoundId, item.entity, item.boundId);
        destination.q(tmp$ret$5);
      }
      var newCollisions = plus_0(entityCollisions, destination);
      map = foldCollisions($this, newCollisions, map);
      data.collisionMap = map;
      applyCollisions($this);
    }
  }
  function applyCollisions($this) {
    var tmp0_safe_receiver = _get_sceneManager__lxhb6y_1($this).scene.__getComponentForKotlin(4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.data;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var data = tmp;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = data.collisionMap.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.applyCollisions.<anonymous>' call
      addColliderVisualizationComponent($this, element.t2(), element.u2());
    }
    var tmp_0 = data;
    // Inline function 'kotlin.collections.filterValues' call
    var this_0 = data.collisionMap;
    var result = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = this_0.q2().t();
    while (tmp0_iterator_0.u()) {
      var entry = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.applyCollisions.<anonymous>' call
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (!(entry.u2().length === 0)) {
        result.r2(entry.t2(), entry.u2());
      }
    }
    tmp_0.collisionMap = result;
  }
  function foldCollisions($this, collisionData, map) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = map;
    var inductionVariable = 0;
    var last = collisionData.length;
    while (inductionVariable < last) {
      var element = collisionData[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.foldCollisions.<anonymous>' call
      var acc = accumulator;
      // Inline function 'kotlin.collections.set' call
      var key = element.entity;
      var tmp0_safe_receiver = acc.b3(element.entity);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.plus' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = [element.boundId];
        tmp = tmp0_safe_receiver.concat(tmp$ret$4);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = [element.boundId];
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var value = tmp_0;
      acc.r2(key, value);
      accumulator = acc;
    }
    return accumulator;
  }
  function foldCollisions$default($this, collisionData, map, $super) {
    var tmp;
    if (map === VOID) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap_init_$Create$();
    } else {
      tmp = map;
    }
    map = tmp;
    return foldCollisions($this, collisionData, map);
  }
  function collisionsWithoutEntity($this, entity) {
    var tmp0_safe_receiver = _get_collisionData__2ruset($this);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.collisions;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.collisionsWithoutEntity.<anonymous>' call
        if (!element.entity.equals(entity) ? true : !element.otherEntity.equals(entity)) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_1 = [];
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    return tmp_1;
  }
  function clearCollisions($this) {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = get_hierarchySequence(_get_sceneManager__lxhb6y_1($this).root).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.clearCollisions.<anonymous>' call
      var tmp0_safe_receiver = element.__getComponentForKotlin(78);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        // Inline function 'kotlin.collections.isEmpty' call
        if (!(tmp0_safe_receiver.collidingBoundIds.length === 0)) {
          element.addComponent(new EntityColliderVisualizationComponent(tmp0_safe_receiver.color));
          tmp = Unit_instance;
        }
      }
    }
  }
  function addColliderVisualizationComponent($this, entity, boundIds) {
    var component = entity.__getComponentForKotlin(78);
    if (component == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.addColliderVisualizationComponent.<anonymous>' call
      entity.addComponent(new EntityColliderVisualizationComponent(component.color, boundIds));
    }
  }
  function Companion_114() {
    this.ID = 'EntityCollisionVisualizationSystem';
  }
  protoOf(Companion_114).u1n = function () {
    return this.ID;
  };
  var Companion_instance_147;
  function Companion_getInstance_123() {
    return Companion_instance_147;
  }
  function EntityCollisionVisualizationSystem(coreServices) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [78];
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$4 = [];
    SystemBase3.call(this, 'EntityCollisionVisualizationSystem', 19, 69, 5, tmp, tmp_0, tmp$ret$4);
    this.coreServices = coreServices;
    this.g3v_1 = this.coreServices.entityManager;
    this.enable();
  }
  protoOf(EntityCollisionVisualizationSystem).k2z = function () {
    return this.coreServices;
  };
  protoOf(EntityCollisionVisualizationSystem).enable = function () {
    protoOf(SystemBase3).enable.call(this);
    _get_sceneManager__lxhb6y_1(this).scene.addComponent(new CollisionVisualizationSceneDataComponent(new CollisionVisualizationSceneData()));
    // Inline function 'kotlin.sequences.forEach' call
    var tmp0_iterator = get_hierarchySequence(_get_sceneManager__lxhb6y_1(this).root).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.enable.<anonymous>' call
      detectCollision(this, element);
    }
  };
  protoOf(EntityCollisionVisualizationSystem).disable = function () {
    protoOf(SystemBase3).disable.call(this);
    _get_sceneManager__lxhb6y_1(this).scene.removeComponent(4);
    clearCollisions(this);
  };
  protoOf(EntityCollisionVisualizationSystem).getCollisionData = function (entity, boundId) {
    var tmp0_elvis_lhs = _get_collisionData__2ruset(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var data = tmp;
    // Inline function 'kotlin.collections.find' call
    var this_0 = data.collisions;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.getCollisionData.<anonymous>' call
        if (element.entity.equals(entity) ? element.boundId === boundId : false) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(EntityCollisionVisualizationSystem).onAddComponent = function (entity, newComponent) {
    if (get_isInScene(entity)) {
      detectCollision(this, entity);
    }
  };
  protoOf(EntityCollisionVisualizationSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (get_isInScene(entity)) {
      detectCollision(this, entity);
    }
  };
  protoOf(EntityCollisionVisualizationSystem).onRemoveComponent = function (entity, oldComponent) {
    var tmp0_safe_receiver = _get_collisionData__2ruset(this);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.collisions;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.onRemoveComponent.<anonymous>' call
        if (element.otherEntity.equals(entity)) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = tmp2_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.onRemoveComponent.<anonymous>' call
        if (get_isInScene(element_0.entity)) {
          detectCollision(this, element_0.entity);
        }
      }
    }
  };
  protoOf(EntityCollisionVisualizationSystem).onAddComponent2 = function (entity, newComponent) {
    detectCollision(this, newComponent.dragState.draggedRootEntity);
  };
  protoOf(EntityCollisionVisualizationSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    detectCollision(this, newComponent.dragState.draggedRootEntity);
  };
  protoOf(EntityCollisionVisualizationSystem).onRemoveComponent2 = function (entity, oldComponent) {
    detectCollision(this, oldComponent.dragState.draggedRootEntity);
  };
  protoOf(EntityCollisionVisualizationSystem).onAddComponent3 = function (entity, newComponent) {
    if (entity.hasComponent(SceneComponent_instance.id)) {
      entity.addComponent(new CollisionVisualizationSceneDataComponent(new CollisionVisualizationSceneData()));
      return Unit_instance;
    }
    detectCollision(this, entity);
  };
  protoOf(EntityCollisionVisualizationSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
    detectCollision(this, entity);
  };
  protoOf(EntityCollisionVisualizationSystem).onRemoveComponent3 = function (entity, oldComponent) {
    var tmp0_safe_receiver = _get_collisionData__2ruset(this);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.collisions;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.onRemoveComponent3.<anonymous>' call
        if (element.otherEntity.equals(entity)) {
          destination.q(element);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = tmp2_safe_receiver.t();
      while (tmp0_iterator.u()) {
        var element_0 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityCollisionVisualizationSystem.onRemoveComponent3.<anonymous>' call
        detectCollision(this, element_0.entity);
      }
    }
  };
  function generateConnectorsDecorator($this, entity, connectorVisualizer, offersFilter, demandsFilter, visualizationData) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin(11);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>' call
      var filteredConnectors = getFilteredEnabledConnectors(Companion_getInstance_124(), tmp0_safe_receiver.enabledConnectors, offersFilter, demandsFilter);
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = filteredConnectors.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>.<anonymous>' call
        var tmp_0;
        if (visualizationData == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable = 0;
            var last = visualizationData.length;
            while (inductionVariable < last) {
              var element_0 = visualizationData[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              if (element_0.connectorKey === element.key) {
                tmp$ret$1 = element_0;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$1;
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            var tmp$ret$3;
            $l$block_0: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var inductionVariable_0 = 0;
              var last_0 = visualizationData.length;
              while (inductionVariable_0 < last_0) {
                var element_1 = visualizationData[inductionVariable_0];
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'com.ikea.core.stl.visualization.system.Companion.generateConnectorsDecorator.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                if (element_1.connectorKey === '') {
                  tmp$ret$3 = element_1;
                  break $l$block_0;
                }
              }
              tmp$ret$3 = null;
            }
            tmp_1 = tmp$ret$3;
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }
          tmp_0 = tmp_1;
        }
        var data = tmp_0;
        var c = createConnectorViewerObject(Companion_getInstance_124(), entity, connectorVisualizer, element, data);
        var tmp0_safe_receiver_0 = !(c == null) ? to(element.key, c) : null;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.q(tmp0_safe_receiver_0);
        }
      }
      tmp = toMutableMap(toMap(destination));
    }
    var tmp1_elvis_lhs = tmp;
    var map = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
    return map;
  }
  function createConnectorViewerObject($this, entity, connectorVisualizer, connector, data) {
    var tmp;
    if (connector instanceof PointConnector) {
      tmp = connectorVisualizer.createPointConnector(entity, connector, connector.transform.position, data);
    } else {
      if (connector instanceof PointSeriesConnector) {
        tmp = connectorVisualizer.createPointSeriesConnector(entity, connector, data);
      } else {
        if (connector instanceof SurfaceConnector) {
          tmp = connectorVisualizer.createSurfaceConnector(entity, connector, data);
        } else {
          if (connector instanceof EdgeConnector) {
            tmp = connectorVisualizer.createEdgeConnector(entity, connector, 10.0, data);
          } else {
            tmp = connectorVisualizer.createUnknown(entity, connector, data);
          }
        }
      }
    }
    var viewerObject = tmp;
    if (viewerObject == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.system.Companion.createConnectorViewerObject.<anonymous>' call
      viewerObject.setVisible(true);
    }
    var tmp2_safe_receiver = connectorVisualizer.createTransform(entity, connector, data);
    if (tmp2_safe_receiver == null)
      null;
    else
      tmp2_safe_receiver.setParent(viewerObject);
    return viewerObject;
  }
  function getFilteredEnabledConnectors($this, enabledConnectors, offersFilter, demandsFilter) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = enabledConnectors.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.system.Companion.getFilteredEnabledConnectors.<anonymous>' call
      var tmp;
      if (offersFilter == null) {
        tmp = true;
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable = 0;
          var last = offersFilter.length;
          while (inductionVariable < last) {
            var element_0 = offersFilter[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.stl.visualization.system.Companion.getFilteredEnabledConnectors.<anonymous>.<anonymous>' call
            if (contains(element.offers(), element_0)) {
              tmp$ret$1 = true;
              break $l$block;
            }
          }
          tmp$ret$1 = false;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        destination.q(element);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_0 = destination.t();
    while (tmp0_iterator_0.u()) {
      var element_1 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.stl.visualization.system.Companion.getFilteredEnabledConnectors.<anonymous>' call
      var tmp_0;
      if (demandsFilter == null) {
        tmp_0 = true;
      } else {
        var tmp$ret$6;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable_0 = 0;
          var last_0 = demandsFilter.length;
          while (inductionVariable_0 < last_0) {
            var element_2 = demandsFilter[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.core.stl.visualization.system.Companion.getFilteredEnabledConnectors.<anonymous>.<anonymous>' call
            if (contains(element_1.demands(), element_2)) {
              tmp$ret$6 = true;
              break $l$block_0;
            }
          }
          tmp$ret$6 = false;
        }
        tmp_0 = tmp$ret$6;
      }
      if (tmp_0) {
        destination_0.q(element_1);
      }
    }
    return destination_0;
  }
  function EntityConnectorVisualizationSystem$Companion$runOnDecoratable$lambda(entity, runner) {
    Companion_getInstance_2();
    var tmp0_safe_receiver = entity.__getComponentForKotlin(11);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.system.Companion.runOnDecoratable.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver_0 = entity.__getComponentForKotlin(77);
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.system.Companion.runOnDecoratable.<anonymous>.<anonymous>.<anonymous>' call
        runner(tmp0_safe_receiver, tmp0_safe_receiver_0);
        tmp_0 = entity;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function hasNoVisualization_0($this, entity) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var indexedObject = get_children(entity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.hasNoVisualization.<anonymous>' call
        if (element.hasComponent(99)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return !tmp$ret$1;
  }
  function hasNewVisualizationData_0($this, entity, connectorVisualizationData) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var indexedObject = get_children(entity);
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.hasNewVisualizationData.<anonymous>' call
        var result = _get_connectorVisualizationNode__spb9ou(element, $this);
        if (!(result == null)) {
          tmp$ret$1 = result;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var currentVisualizationNodeData = tmp$ret$1;
    var newVisualizationNodeData = generateNodeData_0($this, entity, connectorVisualizationData.data);
    return !newVisualizationNodeData.equals(currentVisualizationNodeData);
  }
  function generateNodeData_0($this, entity, data) {
    return new ConnectorVisualizationNodeComponent(entity, data, $this.s3v_1, $this.t3v_1);
  }
  function addDecoration_0($this, entity, visualizationHolder, data) {
    visualizationHolder.addComponent(generateNodeData_0($this, entity, data));
    visualizationHolder.addComponent(new DisplayNameComponent('ConnectorVisualizerNode'));
    visualizationHolder.addComponent(RenderedComponent_instance);
    visualizationHolder.addComponent(new UnserializableEntityComponent());
    setParent(visualizationHolder, entity);
    // Inline function 'kotlin.collections.mutableMapOf' call
    var viewerObjects = LinkedHashMap_init_$Create$();
    var parent = $this.connectorVisualizer.createParent(visualizationHolder);
    if (parent == null)
      null;
    else {
      parent.registerInputEvents();
    }
    var connectorsDecorator = generateConnectorsDecorator(Companion_getInstance_124(), entity, $this.connectorVisualizer, $this.s3v_1, $this.t3v_1, data);
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = connectorsDecorator.q2().t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.addDecoration.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var id = element.t2();
      // Inline function 'kotlin.collections.component2' call
      var viewerObject = element.u2();
      viewerObject.setParent(parent);
      // Inline function 'kotlin.collections.set' call
      viewerObjects.r2(id, viewerObject);
    }
    visualizationHolder.addComponent(new ConnectorVisualizerViewerObjectsComponent(viewerObjects));
    if (parent == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.addDecoration.<anonymous>' call
      visualizationHolder.addComponent(new ViewerObjectComponent(parent));
    }
  }
  function removeDecoration_0($this, entity) {
    var holder = findVisualizerHolder_0($this, entity);
    var tmp1_safe_receiver = holder == null ? null : holder.__getComponentForKotlin(Companion_instance_29.id);
    var viewerObject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.viewerObject;
    if (holder == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      $this.q3v_1.disposeEntity(holder);
    }
    if (viewerObject == null)
      null;
    else {
      viewerObject.deleteObject();
    }
  }
  function findVisualizerHolder_0($this, entity) {
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_children(entity);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.findVisualizerHolder.<anonymous>' call
        if (element.hasComponent(Companion_instance_132.id)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function updateDecoration_0($this, entity, data) {
    removeDecoration_0($this, entity);
    var visualizerHolder = $this.q3v_1.createEntity();
    addDecoration_0($this, entity, visualizerHolder, data);
  }
  function componentsChanged_0($this, entity) {
    var tmp = Companion_getInstance_124().u3v_1;
    if (tmp(entity, EntityConnectorVisualizationSystem$componentsChanged$lambda($this, entity)) == null) {
      removeDecoration_0($this, entity);
    }
  }
  function Companion_115() {
    Companion_instance_148 = this;
    this.ID = 'EntityConnectorVisualizationSystem';
    var tmp = this;
    tmp.u3v_1 = EntityConnectorVisualizationSystem$Companion$runOnDecoratable$lambda;
    this.v3v_1 = 10.0;
    this.w3v_1 = 5.0;
  }
  protoOf(Companion_115).u1n = function () {
    return this.ID;
  };
  var Companion_instance_148;
  function Companion_getInstance_124() {
    if (Companion_instance_148 == null)
      new Companion_115();
    return Companion_instance_148;
  }
  function _get_connectorVisualizationNode__spb9ou(_this__u8e3s4, $this) {
    return _this__u8e3s4.__getComponentForKotlin(Companion_instance_132.id);
  }
  function EntityConnectorVisualizationSystem$componentsChanged$lambda(this$0, $entity) {
    return function (_anonymous_parameter_0__qggqh8, visualizationComponent) {
      updateDecoration_0(this$0, $entity, visualizationComponent.data);
      return Unit_instance;
    };
  }
  function EntityConnectorVisualizationSystem(coreServices, connectorVisualizer) {
    Companion_getInstance_124();
    var tmp = Companion_instance_31.id;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp_1 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$2 = [];
    SystemBase5.call(this, 'EntityConnectorVisualizationSystem', 11, 77, 82, tmp, 123, tmp_0, tmp_1, tmp$ret$2);
    this.coreServices = coreServices;
    this.connectorVisualizer = connectorVisualizer;
    this.q3v_1 = this.coreServices.entityManager;
    this.r3v_1 = this.coreServices.sceneManager;
    this.enable();
    this.s3v_1 = null;
    this.t3v_1 = null;
  }
  protoOf(EntityConnectorVisualizationSystem).k2z = function () {
    return this.coreServices;
  };
  protoOf(EntityConnectorVisualizationSystem).x3v = function (_set____db54di) {
    this.connectorVisualizer = _set____db54di;
  };
  protoOf(EntityConnectorVisualizationSystem).y3v = function () {
    return this.connectorVisualizer;
  };
  protoOf(EntityConnectorVisualizationSystem).onAddComponent3 = function (entity, newComponent) {
    this.refresh();
  };
  protoOf(EntityConnectorVisualizationSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
    this.refresh();
  };
  protoOf(EntityConnectorVisualizationSystem).onRemoveComponent3 = function (entity, oldComponent) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = get_hierarchy(this.r3v_1.root);
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.onRemoveComponent3.<anonymous>' call
      if (!element.hasComponent(Companion_instance_132.id)) {
        destination.q(element);
      }
    }
    var tmp0_iterator = destination.t();
    while (tmp0_iterator.u()) {
      var element_0 = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.onRemoveComponent3.<anonymous>' call
      removeDecoration_0(this, element_0);
    }
    this.refresh();
  };
  protoOf(EntityConnectorVisualizationSystem).onAddComponent5 = function (entity, newComponent) {
    var tmp0_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hasComponent(Companion_instance_132.id);
    var wasAConnectorVisualizationNode = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    if (!wasAConnectorVisualizationNode) {
      return Unit_instance;
    }
    var newEntity = newComponent.entity;
    var newData = newEntity == null ? null : newEntity.__getComponentForKotlin(Companion_instance_132.id);
    var entityWasRemoved = newEntity == null;
    var shouldRemoveVisualization = newData == null;
    if (entityWasRemoved ? true : shouldRemoveVisualization) {
      var tmp3_safe_receiver = newComponent.entityStateBeforeLoadingSnapshot;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.getComponent(Companion_instance_29.id);
      var oldParentViewerObject = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.viewerObject;
      if (oldParentViewerObject == null)
        null;
      else {
        oldParentViewerObject.deleteObject();
      }
    }
  };
  protoOf(EntityConnectorVisualizationSystem).onRemoveComponent5 = function (entity, oldComponent) {
  };
  protoOf(EntityConnectorVisualizationSystem).onUpdateComponent5 = function (entity, oldComponent, newComponent) {
  };
  protoOf(EntityConnectorVisualizationSystem).onAddComponent4 = function (entity, newComponent) {
  };
  protoOf(EntityConnectorVisualizationSystem).onUpdateComponent4 = function (entity, oldComponent, newComponent) {
  };
  protoOf(EntityConnectorVisualizationSystem).onRemoveComponent4 = function (entity, oldComponent) {
    this.refresh();
  };
  protoOf(EntityConnectorVisualizationSystem).enable = function () {
    protoOf(SystemBase5).enable.call(this);
    this.refresh();
  };
  protoOf(EntityConnectorVisualizationSystem).disable = function () {
    protoOf(SystemBase5).disable.call(this);
    this.refresh();
  };
  protoOf(EntityConnectorVisualizationSystem).z3v = function (value) {
    this.s3v_1 = value;
    this.refresh();
  };
  protoOf(EntityConnectorVisualizationSystem).w3r = function () {
    return this.s3v_1;
  };
  protoOf(EntityConnectorVisualizationSystem).a3w = function (value) {
    this.t3v_1 = value;
    this.refresh();
  };
  protoOf(EntityConnectorVisualizationSystem).x3r = function () {
    return this.t3v_1;
  };
  protoOf(EntityConnectorVisualizationSystem).refresh = function () {
    if (this.isEnabled) {
      // Inline function 'kotlin.sequences.forEach' call
      var tmp0_iterator = get_hierarchySequence(this.r3v_1.root).t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.refresh.<anonymous>' call
        var connectorVisualizationData = element.__getComponentForKotlin(77);
        if (!(connectorVisualizationData == null)) {
          if (hasNoVisualization_0(this, element) ? true : hasNewVisualizationData_0(this, element, connectorVisualizationData)) {
            updateDecoration_0(this, element, connectorVisualizationData.data);
          }
        } else {
          removeDecoration_0(this, element);
        }
      }
    } else {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = this.q3v_1.entities;
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element_0 = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.refresh.<anonymous>' call
        if (!element_0.hasComponent(Companion_instance_132.id)) {
          destination.q(element_0);
        }
      }
      var tmp0_iterator_0 = destination.t();
      while (tmp0_iterator_0.u()) {
        var element_1 = tmp0_iterator_0.w();
        // Inline function 'com.ikea.core.stl.visualization.system.EntityConnectorVisualizationSystem.refresh.<anonymous>' call
        removeDecoration_0(this, element_1);
      }
    }
  };
  protoOf(EntityConnectorVisualizationSystem).setVisualizer = function (connectorVisualizer) {
    this.connectorVisualizer = connectorVisualizer;
    this.refresh();
  };
  protoOf(EntityConnectorVisualizationSystem).onAddComponent = function (entity, newComponent) {
    if (entity.hasComponent(77)) {
      componentsChanged_0(this, entity);
    }
  };
  protoOf(EntityConnectorVisualizationSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
    if (entity.hasComponent(77)) {
      componentsChanged_0(this, entity);
    }
  };
  protoOf(EntityConnectorVisualizationSystem).onRemoveComponent = function (entity, oldComponent) {
    removeDecoration_0(this, entity);
  };
  protoOf(EntityConnectorVisualizationSystem).onAddComponent2 = function (entity, newComponent) {
    if (get_isInScene(entity)) {
      componentsChanged_0(this, entity);
    }
  };
  protoOf(EntityConnectorVisualizationSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
    if (newComponent.data == null) {
      removeDecoration_0(this, entity);
    } else {
      if (get_isInScene(entity)) {
        updateDecoration_0(this, entity, newComponent.data);
      }
    }
  };
  protoOf(EntityConnectorVisualizationSystem).onRemoveComponent2 = function (entity, oldComponent) {
    removeDecoration_0(this, entity);
  };
  function addConfigComponentToEntities($this, newComponent, oldComponent) {
    // Inline function 'kotlin.sequences.forEach' call
    var tmp = get_hierarchySequence($this.coreServices.sceneManager.root);
    var tmp0_iterator = filter(tmp, ForcedComponentBaseSystem$addConfigComponentToEntities$lambda($this)).t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.stl.visualization.system.ForcedComponentBaseSystem.addConfigComponentToEntities.<anonymous>' call
      var tmp0_safe_receiver = element.__getComponentForKotlin($this.componentId);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (equals(tmp0_safe_receiver, oldComponent)) {
          element.addComponent(newComponent);
          tmp_1 = Unit_instance;
        }
        tmp_0 = Unit_instance;
      }
      if (tmp_0 == null)
        element.addComponent(newComponent);
    }
  }
  function addConfigComponentToEntities$default($this, newComponent, oldComponent, $super) {
    oldComponent = oldComponent === VOID ? null : oldComponent;
    return addConfigComponentToEntities($this, newComponent, oldComponent);
  }
  function removeConfigComponentFromEntities($this, configComponent) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.coreServices.entityManager.entities;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.system.ForcedComponentBaseSystem.removeConfigComponentFromEntities.<anonymous>' call
      if (!element.equals($this.configEntity) ? !element.isDisposed : false) {
        removeConfigComponentFromEntity($this, element, configComponent);
      }
    }
  }
  function removeConfigComponentFromEntities$default($this, configComponent, $super) {
    configComponent = configComponent === VOID ? null : configComponent;
    return removeConfigComponentFromEntities($this, configComponent);
  }
  function removeConfigComponentFromEntity($this, entity, configComponent) {
    var tmp0_safe_receiver = entity.__getComponentForKotlin($this.componentId);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (equals(tmp0_safe_receiver, configComponent)) {
        entity.removeComponent($this.componentId);
        tmp = Unit_instance;
      }
    }
  }
  function removeConfigComponentFromEntity$default($this, entity, configComponent, $super) {
    configComponent = configComponent === VOID ? null : configComponent;
    return removeConfigComponentFromEntity($this, entity, configComponent);
  }
  function refreshComponentOnEntity($this, entity) {
    if ($this.isEnabled) {
      if (!$this.isLoading ? $this.entityIsEligibleForComponent(entity) : false) {
        entity.addComponent($this.getForcedComponentConfigUnsafe($this.componentId));
      }
    } else {
      removeConfigComponentFromEntity($this, entity, $this.getForcedComponentConfigUnsafe($this.componentId));
    }
  }
  function ForcedComponentBaseSystem$addConfigComponentToEntities$lambda(this$0) {
    return function (it) {
      return this$0.entityIsEligibleForComponent(it);
    };
  }
  function ForcedComponentBaseSystem(id, componentId, forcedComponent, coreServices) {
    var tmp = InSceneComponent_instance.id;
    var tmp_0 = SceneReloadingComponent_instance.id;
    SystemBase4.call(this, id, componentId, tmp, tmp_0, 123);
    this.coreServices = coreServices;
    this.configEntity = this.coreServices.entityManager.createEntity();
    this.isLoading = false;
    this.configEntity.addComponent(forcedComponent);
    this.configEntity.addComponent(new DisplayNameComponent('ForcedComponentConfigEntity-Component:' + componentId));
  }
  protoOf(ForcedComponentBaseSystem).k2z = function () {
    return this.coreServices;
  };
  protoOf(ForcedComponentBaseSystem).o3t = function () {
    return this.configEntity;
  };
  protoOf(ForcedComponentBaseSystem).p3t = function (_set____db54di) {
    this.isLoading = _set____db54di;
  };
  protoOf(ForcedComponentBaseSystem).q3t = function () {
    return this.isLoading;
  };
  protoOf(ForcedComponentBaseSystem).enable = function () {
    protoOf(SystemBase4).enable.call(this);
    if (this.isLoading)
      return Unit_instance;
    addConfigComponentToEntities$default(this, this.getForcedComponentConfigUnsafe(this.componentId));
  };
  protoOf(ForcedComponentBaseSystem).disable = function () {
    protoOf(SystemBase4).disable.call(this);
    removeConfigComponentFromEntities(this, this.getForcedComponentConfigUnsafe(this.componentId));
  };
  protoOf(ForcedComponentBaseSystem).setConfigComponent = function (configComponent) {
    var oldComponent = this.configEntity.getComponentUnsafe(this.componentId);
    if (!equals(oldComponent, configComponent)) {
      this.configEntity.addComponent(configComponent);
      if (this.isEnabled) {
        removeConfigComponentFromEntities$default(this);
        addConfigComponentToEntities(this, configComponent, oldComponent);
      }
    }
  };
  protoOf(ForcedComponentBaseSystem).onAddComponent2 = function (entity, newComponent) {
    refreshComponentOnEntity(this, entity);
  };
  protoOf(ForcedComponentBaseSystem).onUpdateComponent2 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ForcedComponentBaseSystem).onRemoveComponent2 = function (entity, oldComponent) {
  };
  protoOf(ForcedComponentBaseSystem).onAddComponent3 = function (entity, newComponent) {
    this.isLoading = true;
  };
  protoOf(ForcedComponentBaseSystem).onRemoveComponent3 = function (entity, oldComponent) {
    this.isLoading = false;
    if (this.isEnabled) {
      this.enable();
    }
  };
  protoOf(ForcedComponentBaseSystem).onUpdateComponent3 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ForcedComponentBaseSystem).onAddComponent4 = function (entity, newComponent) {
    if (!this.isEnabled)
      return Unit_instance;
    var tmp0_elvis_lhs = newComponent.entity;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newEntity = tmp;
    var isNew = newComponent.entityStateBeforeLoadingSnapshot == null;
    if (isNew ? this.entityIsEligibleForComponent(entity) : false) {
      newEntity.addComponentInternal(this.getForcedComponentConfigUnsafe(this.componentId));
    }
  };
  protoOf(ForcedComponentBaseSystem).onUpdateComponent4 = function (entity, oldComponent, newComponent) {
  };
  protoOf(ForcedComponentBaseSystem).onRemoveComponent4 = function (entity, oldComponent) {
  };
  protoOf(ForcedComponentBaseSystem).onAddComponent = function (entity, newComponent) {
  };
  protoOf(ForcedComponentBaseSystem).onUpdateComponent = function (entity, oldComponent, newComponent) {
  };
  protoOf(ForcedComponentBaseSystem).onRemoveComponent = function (entity, oldComponent) {
    var configComponent = this.getForcedComponentConfigUnsafe(this.componentId);
    if (!equals(oldComponent, configComponent) ? this.isEnabled : false) {
      entity.addComponent(configComponent);
    }
  };
  protoOf(ForcedComponentBaseSystem).getForcedComponentConfigUnsafe = function (componentId) {
    var component = this.configEntity.__getComponentForKotlin(componentId);
    var tmp;
    if (component == null) {
      throw Exception_init_$Create$('Config entity missing forced component ' + componentId);
    } else {
      tmp = component;
    }
    return tmp;
  };
  function ColliderVisualizer() {
  }
  function CollisionVisualizationData(penetration, entity, boundId, otherEntity, otherBoundId) {
    this.penetration = penetration;
    this.entity = entity;
    this.boundId = boundId;
    this.otherEntity = otherEntity;
    this.otherBoundId = otherBoundId;
    this.h3v_1 = 0;
  }
  protoOf(CollisionVisualizationData).h3a = function () {
    return this.penetration;
  };
  protoOf(CollisionVisualizationData).r23 = function () {
    return this.entity;
  };
  protoOf(CollisionVisualizationData).c3w = function () {
    return this.boundId;
  };
  protoOf(CollisionVisualizationData).f3a = function () {
    return this.otherEntity;
  };
  protoOf(CollisionVisualizationData).d3w = function () {
    return this.otherBoundId;
  };
  protoOf(CollisionVisualizationData).equals = function (other) {
    if (other === this)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof CollisionVisualizationData))
      THROW_CCE();
    if (!(other.entity.id === this.entity.id))
      return false;
    if (!(other.boundId === this.boundId))
      return false;
    if (!(other.otherEntity.id === this.otherEntity.id))
      return false;
    if (!(other.otherBoundId === this.otherBoundId))
      return false;
    return true;
  };
  protoOf(CollisionVisualizationData).hashCode = function () {
    if (this.h3v_1 === 0) {
      this.h3v_1 = this.entity.hashCode() + this.penetration.hashCode() | 0;
    }
    return this.h3v_1;
  };
  protoOf(CollisionVisualizationData).af = function () {
    return this.penetration;
  };
  protoOf(CollisionVisualizationData).bf = function () {
    return this.entity;
  };
  protoOf(CollisionVisualizationData).g1k = function () {
    return this.boundId;
  };
  protoOf(CollisionVisualizationData).h1k = function () {
    return this.otherEntity;
  };
  protoOf(CollisionVisualizationData).i1k = function () {
    return this.otherBoundId;
  };
  protoOf(CollisionVisualizationData).e3w = function (penetration, entity, boundId, otherEntity, otherBoundId) {
    return new CollisionVisualizationData(penetration, entity, boundId, otherEntity, otherBoundId);
  };
  protoOf(CollisionVisualizationData).copy = function (penetration, entity, boundId, otherEntity, otherBoundId, $super) {
    penetration = penetration === VOID ? this.penetration : penetration;
    entity = entity === VOID ? this.entity : entity;
    boundId = boundId === VOID ? this.boundId : boundId;
    otherEntity = otherEntity === VOID ? this.otherEntity : otherEntity;
    otherBoundId = otherBoundId === VOID ? this.otherBoundId : otherBoundId;
    return this.e3w(penetration, entity, boundId, otherEntity, otherBoundId);
  };
  protoOf(CollisionVisualizationData).toString = function () {
    return 'CollisionVisualizationData(penetration=' + this.penetration + ', entity=' + this.entity + ', boundId=' + this.boundId + ', otherEntity=' + this.otherEntity + ', otherBoundId=' + this.otherBoundId + ')';
  };
  function Color(color, r, g, b) {
    this.color = color;
    this.r = r;
    this.g = g;
    this.b = b;
    this.h3s_1 = 0;
  }
  protoOf(Color).h23 = function () {
    return this.color;
  };
  protoOf(Color).k3b = function () {
    return this.r;
  };
  protoOf(Color).l3b = function () {
    return this.g;
  };
  protoOf(Color).m3b = function () {
    return this.b;
  };
  protoOf(Color).equals = function (other) {
    if (!(other instanceof Color))
      return false;
    return other.color === this.color;
  };
  protoOf(Color).hashCode = function () {
    if (this.h3s_1 === 0)
      this.h3s_1 = getStringHashCode(this.color);
    return this.h3s_1;
  };
  protoOf(Color).af = function () {
    return this.color;
  };
  protoOf(Color).bf = function () {
    return this.r;
  };
  protoOf(Color).g1k = function () {
    return this.g;
  };
  protoOf(Color).h1k = function () {
    return this.b;
  };
  protoOf(Color).f3w = function (color, r, g, b) {
    return new Color(color, r, g, b);
  };
  protoOf(Color).copy = function (color, r, g, b, $super) {
    color = color === VOID ? this.color : color;
    r = r === VOID ? this.r : r;
    g = g === VOID ? this.g : g;
    b = b === VOID ? this.b : b;
    return this.f3w(color, r, g, b);
  };
  protoOf(Color).toString = function () {
    return 'Color(color=' + this.color + ', r=' + this.r + ', g=' + this.g + ', b=' + this.b + ')';
  };
  function ConnectorVisualizer() {
  }
  function setBaseColor($this, viewerObject) {
    var green = 0.5 + Default_getInstance().bh(0.0, 0.5);
    return viewerObject.setBaseColor(0.0, green, 0.0);
  }
  function setCollideColor($this, viewerObject) {
    var red = 0.5 + Default_getInstance().bh(0.0, 0.5);
    return viewerObject.setBaseColor(red, 0.0, 0.0);
  }
  function setTransparency_0($this, viewerObject) {
    return viewerObject.setTransparency(0.8);
  }
  function getColorSeed($this, connector) {
    var seed = 0;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = connector.tags();
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getColorSeed.<anonymous>' call
      seed = seed + getStringHashCode(element) | 0;
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_0 = connector.offers();
    var inductionVariable_0 = 0;
    var last_0 = indexedObject_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = indexedObject_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getColorSeed.<anonymous>' call
      seed = seed + getStringHashCode(element_0) | 0;
    }
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject_1 = connector.demands();
    var inductionVariable_1 = 0;
    var last_1 = indexedObject_1.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = indexedObject_1[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getColorSeed.<anonymous>' call
      seed = seed + getStringHashCode(element_1) | 0;
    }
    return seed;
  }
  function createCube($this, size, color, transparent, position, viewer) {
    return createBox($this, size, size, size, color, transparent, position, viewer);
  }
  function createCube$default($this, size, color, transparent, position, viewer, $super) {
    transparent = transparent === VOID ? false : transparent;
    return createCube($this, size, color, transparent, position, viewer);
  }
  function createBox($this, width, height, depth, color, transparent, position, viewer) {
    return setRandomColor(viewer.createBox(width, height, depth).setPosition(position), color, transparent);
  }
  function createBox$default($this, width, height, depth, color, transparent, position, viewer, $super) {
    transparent = transparent === VOID ? false : transparent;
    return createBox($this, width, height, depth, color, transparent, position, viewer);
  }
  function createLine($this, p1, p2, thickness, color, viewer) {
    var line = p2.minus(p1);
    var center = p2.plus(p1).__divIntForKotlin(2);
    var length = line.size;
    var rotation = (new Vector(length, 0.0, 0.0)).getRotationTo(line);
    return setRandomColor(viewer.createBox(length, thickness, thickness).setPosition(center).setRotation(rotation), color, false);
  }
  function createSphere($this, radius, color, transparent, position, viewer) {
    return setRandomColor(viewer.createSphere(radius).setPosition(position), color, transparent);
  }
  function createSphere$default($this, radius, color, transparent, position, viewer, $super) {
    transparent = transparent === VOID ? false : transparent;
    return createSphere($this, radius, color, transparent, position, viewer);
  }
  function Companion_116() {
    Companion_instance_149 = this;
    this.g3w_1 = LoggerState_getInstance().m1m('DefaultVisualizer');
    this.pointConnectorSize = 40.0;
    this.subConnectorSize = 10.0;
    this.colorRandomizationAmount = 0.5;
    this.alpha = 0.8;
  }
  protoOf(Companion_116).h3w = function () {
    return this.pointConnectorSize;
  };
  protoOf(Companion_116).i3w = function () {
    return this.subConnectorSize;
  };
  protoOf(Companion_116).u3s = function () {
    return this.colorRandomizationAmount;
  };
  protoOf(Companion_116).s3s = function () {
    return this.alpha;
  };
  var Companion_instance_149;
  function Companion_getInstance_125() {
    if (Companion_instance_149 == null)
      new Companion_116();
    return Companion_instance_149;
  }
  function DefaultVisualizer$defaultOnConnectorClick$lambda(_anonymous_parameter_0__qggqh8, connector) {
    println(connector.key);
    return Unit_instance;
  }
  function DefaultVisualizer$createPointConnector$lambda(this$0, $entity, $connector) {
    return function () {
      this$0.m3w_1($entity, $connector);
      return Unit_instance;
    };
  }
  function DefaultVisualizer$createUnknown$lambda() {
    return 'Unknown connector implementation, unable to visualize';
  }
  function DefaultVisualizer(coreServices, transformModel) {
    Companion_getInstance_125();
    this.j3w_1 = coreServices;
    this.k3w_1 = transformModel;
    var tmp = this;
    tmp.l3w_1 = DefaultVisualizer$defaultOnConnectorClick$lambda;
    this.m3w_1 = this.l3w_1;
  }
  protoOf(DefaultVisualizer).l2j = function () {
    return this.j3w_1.coreModules.viewer();
  };
  protoOf(DefaultVisualizer).setOnConnectorClick = function (onClick) {
    var tmp = this;
    tmp.m3w_1 = onClick == null ? this.l3w_1 : onClick;
  };
  protoOf(DefaultVisualizer).createParent = function (entity) {
    var tmp0_safe_receiver = this.viewer;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createEmpty();
  };
  protoOf(DefaultVisualizer).createPlaceHolderModel = function (entity, entityManager) {
    var tmp0_safe_receiver = this.viewer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPlaceHolderModel.<anonymous>' call
      var placeholder = tmp0_safe_receiver.createSphere(0.02, entity);
      var tmp0_safe_receiver_0 = entity.__getComponentForKotlin(6);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPlaceHolderModel.<anonymous>.<anonymous>' call
        placeholder.setRotation(tmp0_safe_receiver_0.transform.rotation);
        placeholder.setPosition(tmp0_safe_receiver_0.transform.position);
        var tmp0_safe_receiver_1 = get_viewerObject(entity);
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPlaceHolderModel.<anonymous>.<anonymous>.<anonymous>' call
          placeholder.setScaleV(tmp0_safe_receiver_1.getScale());
        }
      }
      tmp = placeholder;
    }
    return tmp;
  };
  protoOf(DefaultVisualizer).createDecoratorModel = function (entity, entityManager) {
    var tmp0_safe_receiver = this.viewer;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.createSphere(0.02, entity);
  };
  protoOf(DefaultVisualizer).b3w = function (entity, polyhedron, color, collides, collisionData) {
    var vertices = polyhedron.vertices;
    // Inline function 'kotlin.collections.map' call
    var this_0 = polyhedron.faces;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createColliderVisualization.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = item.indices;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(this_1.length);
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var item_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createColliderVisualization.<anonymous>.<anonymous>' call
        var tmp$ret$0 = vertices[item_0];
        destination_0.q(tmp$ret$0);
      }
      var tmp$ret$4 = copyToArray(destination_0);
      destination.q(tmp$ret$4);
    }
    var faces = destination;
    var tmp0_safe_receiver = this.viewer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createColliderVisualization.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(faces, 10));
      var tmp0_iterator = faces.t();
      while (tmp0_iterator.u()) {
        var item_1 = tmp0_iterator.w();
        // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createColliderVisualization.<anonymous>.<anonymous>' call
        var normal = PolyhedronUtils_getInstance().surfaceNormal(item_1);
        var viewerObject = tmp0_safe_receiver.createSurface(item_1, normal, entity);
        if (collides) {
          setCollideColor(Companion_getInstance_125(), viewerObject);
        } else {
          if (!(color == null)) {
            viewerObject.setBaseColor(color.r, color.g, color.b);
          } else {
            setBaseColor(Companion_getInstance_125(), viewerObject);
          }
        }
        setTransparency_0(Companion_getInstance_125(), viewerObject);
        destination_1.q(viewerObject);
      }
      var viewerObjects = destination_1;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$10 = copyToArray(viewerObjects);
      var colliderVis = tmp0_safe_receiver.groupMeshes(tmp$ret$10, entity);
      tmp = colliderVis;
    }
    return tmp;
  };
  protoOf(DefaultVisualizer).setColor = function (bound, color) {
    bound.setBaseColor(color.r, color.g, color.b);
  };
  protoOf(DefaultVisualizer).indicateCollision = function (bound) {
    setCollideColor(Companion_getInstance_125(), bound);
  };
  protoOf(DefaultVisualizer).createColliderGroupParent = function (entity, polyhedron) {
    var tmp0_safe_receiver = this.viewer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver.createSphere(0.001);
    }
    return tmp;
  };
  protoOf(DefaultVisualizer).createPointConnector = function (entity, connector, position, data) {
    var tmp0_safe_receiver = this.viewer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPointConnector.<anonymous>' call
      var tmp_0;
      if (data == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPointConnector.<anonymous>.<anonymous>' call
        var tmp_1;
        if (data.visible) {
          var tmp0_subject = connector.c20_1;
          var tmp_2;
          if (tmp0_subject === 1) {
            tmp_2 = createCube(Companion_getInstance_125(), 40.0, 1, false, position, tmp0_safe_receiver);
          } else {
            if (tmp0_subject === 0) {
              tmp_2 = createCube(Companion_getInstance_125(), 40.0, 1, false, position, tmp0_safe_receiver).setRotation(Companion_getInstance_6().fromEulerDegrees(new Degrees(35.264), VOID, new Degrees(45.0)));
            } else {
              tmp_2 = createSphere(Companion_getInstance_125(), 20.0, 1, false, position, tmp0_safe_receiver);
            }
          }
          var box = tmp_2;
          if (data.selected) {
            box.setBaseColor(1.0, 0.0, 0.0);
          } else {
            setRandomColor(box, getColorSeed(Companion_getInstance_125(), connector), false);
          }
          box.makeClickable(DefaultVisualizer$createPointConnector$lambda(this, entity, connector));
          var tmp_3;
          if (data.showActivationDistance) {
            // Inline function 'kotlin.takeIf' call
            var this_0 = connector.f20_1;
            // Inline function 'kotlin.contracts.contract' call
            var tmp_4;
            // Inline function 'com.ikea.core.stl.visualization.visualizer.DefaultVisualizer.createPointConnector.<anonymous>.<anonymous>.<anonymous>' call
            if (this_0 > 0.0) {
              tmp_4 = this_0;
            } else {
              tmp_4 = null;
            }
            var tmp1_safe_receiver = tmp_4;
            var tmp_5;
            if (tmp1_safe_receiver == null) {
              tmp_5 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var sphere = createSphere(Companion_getInstance_125(), tmp1_safe_receiver, 1, true, position, tmp0_safe_receiver);
              // Inline function 'kotlin.arrayOf' call
              // Inline function 'kotlin.js.unsafeCast' call
              // Inline function 'kotlin.js.asDynamic' call
              var tmp$ret$4 = [box, sphere];
              return tmp0_safe_receiver.groupMeshes(tmp$ret$4);
            }
            tmp_3 = tmp_5;
          } else {
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$8 = [box];
            return tmp0_safe_receiver.groupMeshes(tmp$ret$8);
          }
          tmp_1 = tmp_3;
        } else {
          return null;
        }
        tmp_0 = tmp_1;
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? createCube(Companion_getInstance_125(), 40.0, 1, false, position, tmp0_safe_receiver) : tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(DefaultVisualizer).createPointSeriesConnector = function (entity, connector, data) {
    var tmp0_safe_receiver = this.viewer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0 = 0;
      var tmp_1 = connector.subConnectorCount;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        tmp_2[tmp_3] = createCube(Companion_getInstance_125(), 10.0, 1, false, connector.getSubConnectorPosition(tmp_3), tmp0_safe_receiver).setBaseColor(1.0, 1.0, 0.0);
        tmp_0 = tmp_0 + 1 | 0;
      }
      var subConnectors = tmp_2;
      return tmp0_safe_receiver.groupMeshes(subConnectors);
    }
    return tmp;
  };
  protoOf(DefaultVisualizer).createSurfaceConnector = function (entity, connector, data) {
    var tmp0_safe_receiver = this.viewer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var viewerObj = tmp0_safe_receiver.createSurface(connector.vertices, connector.normal, entity);
      return viewerObj;
    }
    return tmp;
  };
  protoOf(DefaultVisualizer).createEdgeConnector = function (entity, connector, thickness, data) {
    var tmp0_safe_receiver = this.viewer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var colorSeed = getColorSeed(Companion_getInstance_125(), connector);
      return createLine(Companion_getInstance_125(), connector.p1, connector.p2, thickness, colorSeed, tmp0_safe_receiver);
    }
    return tmp;
  };
  protoOf(DefaultVisualizer).createUnknown = function (entity, connector, data) {
    var tmp0_safe_receiver = this.viewer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0 = Companion_getInstance_125().g3w_1;
      tmp_0.debug(DefaultVisualizer$createUnknown$lambda);
      return tmp0_safe_receiver.createEmpty();
    }
    return tmp;
  };
  protoOf(DefaultVisualizer).createTransform = function (entity, connector, data) {
    var tmp;
    var tmp_0;
    if ((data == null ? null : data.showTransform) === true) {
      tmp_0 = !(this.k3w_1 == null);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp3_safe_receiver = this.viewer;
      var tmp_1;
      if (tmp3_safe_receiver == null) {
        tmp_1 = null;
      } else {
        var tmp1_elvis_lhs = this.k3w_1.modelUrl;
        var tmp_2 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = this.k3w_1.texture;
        tmp_1 = tmp3_safe_receiver.loadModel(null, tmp_2, tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs, null, null);
      }
      var viewerObject = tmp_1;
      if (viewerObject == null)
        null;
      else
        viewerObject.setRotation(connector.transform.rotation);
      tmp = viewerObject;
    } else {
      tmp = null;
    }
    return tmp;
  };
  function setRandomColor(_this__u8e3s4, seed, transparent) {
    var random = Random(seed);
    if (transparent) {
      _this__u8e3s4.setTransparency(0.25);
    }
    return _this__u8e3s4.setBaseColor(random.zg(), random.zg(), random.zg());
  }
  function Visualizer() {
  }
  function getCollisionsForEntity($this, entity, root) {
    var collisions = getWorldCollision($this, entity, root);
    return flatten_0(toList_1(mapNotNull(collisions, VisualizerUtils$Companion$getCollisionsForEntity$lambda(entity))));
  }
  function getWorldCollision($this, entity, root) {
    var tmp0_safe_receiver = get_collider(entity);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getWorldCollision.<anonymous>' call
      tmp = mapNotNull(root, VisualizerUtils$Companion$getWorldCollision$lambda(tmp1_safe_receiver));
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? emptySequence() : tmp2_elvis_lhs;
  }
  function getBoundCollisions($this, entity, otherEntity, collisionPairs, otherCollisionPairs) {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = collisionPairs.ye_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var index = 0;
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getBoundCollisions.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      // Inline function 'kotlin.collections.mapIndexedNotNull' call
      // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
      var this_1 = otherCollisionPairs.ye_1;
      var destination_0 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index_0 = 0;
      var inductionVariable_0 = 0;
      var last_0 = this_1.length;
      while (inductionVariable_0 < last_0) {
        var item_0 = this_1[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
        var tmp1_0 = index_0;
        index_0 = tmp1_0 + 1 | 0;
        // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getBoundCollisions.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver = item_0.penetration(item);
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getBoundCollisions.<anonymous>.<anonymous>.<anonymous>' call
          tmp = !(entity.id === otherEntity.id) ? new CollisionVisualizationData(tmp0_safe_receiver, entity, collisionPairs.ze_1[tmp1], otherEntity, otherCollisionPairs.ze_1[tmp1_0]) : null;
        }
        var tmp0_safe_receiver_0 = tmp;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_0.q(tmp0_safe_receiver_0);
        }
      }
      destination.q(destination_0);
    }
    return flatten_0(destination);
  }
  function createWorldColliderShapePairs($this, entity) {
    var tmp0_safe_receiver = get_colliderShapeComponent(entity);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>' call
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>.<anonymous>' call
      var worldTransform = get_worldTransform(entity);
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.ids;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>.<anonymous>.<anonymous>' call
        var tmp_1 = tmp0_safe_receiver.polyhedron;
        var tmp0_safe_receiver_1 = tmp_1 instanceof PolyhedronGroup ? tmp_1 : null;
        var tmp_2;
        if (tmp0_safe_receiver_1 == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.toTypedArray' call
          // Inline function 'kotlin.collections.map' call
          var this_0 = tmp0_safe_receiver_1.polyhedra;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList_init_$Create$_0(this_0.length);
          var inductionVariable = 0;
          var last = this_0.length;
          while (inductionVariable < last) {
            var item = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.createWorldColliderShapePairs.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            var tmp$ret$0 = item.transform(worldTransform);
            destination.q(tmp$ret$0);
          }
          var tmp$ret$3 = copyToArray(destination);
          tmp_2 = new Pair(tmp$ret$3, tmp0_safe_receiver_0);
        }
        var tmp1_elvis_lhs = tmp_2;
        var tmp_3;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$8 = [tmp0_safe_receiver.polyhedron.transform(worldTransform)];
          tmp_3 = new Pair(tmp$ret$8, tmp0_safe_receiver_0);
        } else {
          tmp_3 = tmp1_elvis_lhs;
        }
        tmp_0 = tmp_3;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function VisualizerUtils$Companion$getCollisions$lambda($root) {
    return function (child) {
      return getCollisionsForEntity(Companion_instance_150, child, $root);
    };
  }
  function VisualizerUtils$Companion$getCollisionsForEntity$lambda($entity) {
    return function (other) {
      var tmp0_safe_receiver = createWorldColliderShapePairs(Companion_instance_150, $entity);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getCollisionsForEntity.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_0 = createWorldColliderShapePairs(Companion_instance_150, other);
        var tmp_0;
        if (tmp0_safe_receiver_0 == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getCollisionsForEntity.<anonymous>.<anonymous>.<anonymous>' call
          tmp_0 = getBoundCollisions(Companion_instance_150, $entity, other, tmp0_safe_receiver, tmp0_safe_receiver_0);
        }
        tmp = tmp_0;
      }
      return tmp;
    };
  }
  function VisualizerUtils$Companion$getWorldCollision$lambda($worldPolyhedron) {
    return function (other) {
      var tmp0_safe_receiver = get_collider(other);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.worldPolyhedron;
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getWorldCollision.<anonymous>.<anonymous>.<anonymous>' call
        var tmp_0;
        if (tmp1_safe_receiver.penetration($worldPolyhedron) == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.core.stl.visualization.visualizer.Companion.getWorldCollision.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          tmp_0 = other;
        }
        tmp = tmp_0;
      }
      return tmp;
    };
  }
  function Companion_117() {
  }
  protoOf(Companion_117).getCollisions = function (entity, root) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = get_hierarchySequence(entity);
    var this_0 = flatten_0(toList_1(map(tmp, VisualizerUtils$Companion$getCollisions$lambda(root))));
    return copyToArray(this_0);
  };
  var Companion_instance_150;
  function Companion_getInstance_126() {
    return Companion_instance_150;
  }
  function VisualizerUtils() {
  }
  function componentName(componentId) {
    var tmp = Object.keys(ComponentIds).find(function (id) {
      return ComponentIds[id] === componentId;
    }) || 'unknown';
    var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    if (endsWith(name, '_ID')) {
      // Inline function 'kotlin.text.substring' call
      var this_0 = name;
      var endIndex = name.length - 3 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      name = this_0.substring(0, endIndex);
    }
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return name.toLowerCase() + ' (' + componentId + ')';
  }
  //region block: post-declaration
  protoOf(AlignmentConnectionsComponent).z1k = get_serializable;
  protoOf(AlignmentConnectionsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AlignmentConnectionsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AlignmentConnectionsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AlignmentConnectionsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(HandleUnderAlignmentComponent).z1k = get_serializable;
  protoOf(HandleUnderAlignmentComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(HandleUnderAlignmentComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(HandleUnderAlignmentComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(HandleUnderAlignmentComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(RoomAlignmentEdgesComponent).z1k = get_serializable;
  protoOf(RoomAlignmentEdgesComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RoomAlignmentEdgesComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RoomAlignmentEdgesComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RoomAlignmentEdgesComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AllowedDoorPairsComponent).z1k = get_serializable;
  protoOf(AllowedDoorPairsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AllowedDoorPairsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AllowedDoorPairsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AllowedDoorPairsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'host', function () {
    return this.i2q();
  });
  defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'guest', function () {
    return this.j2q();
  });
  defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'guestConnectionRoot', function () {
    return this.t1v();
  });
  defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'holeNumber', function () {
    return this.s2y();
  });
  defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'holePositionHostSpace', function () {
    return this.t2y();
  });
  defineProp(protoOf(PointSeriesAssemblyInstructionImpl), 'holePositionWorldSpace', function () {
    return this.u2y();
  });
  protoOf(AutoAdaptChildFailedEventComponent).z1k = get_serializable;
  protoOf(AutoAdaptChildFailedEventComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AutoAdaptChildFailedEventComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AutoAdaptChildFailedEventComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AutoAdaptChildFailedEventComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AutoAdaptCachedVariantsComponent).z1k = get_serializable;
  protoOf(AutoAdaptCachedVariantsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AutoAdaptCachedVariantsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AutoAdaptCachedVariantsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AutoAdaptCachedVariantsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AutoAdaptSessionComponent).z1k = get_serializable;
  protoOf(AutoAdaptSessionComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AutoAdaptSessionComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AutoAdaptSessionComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AutoAdaptSessionComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AutoAdaptGuestComponent).z1k = get_serializable;
  protoOf(AutoAdaptGuestComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AutoAdaptGuestComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AutoAdaptGuestComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AutoAdaptGuestComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AutoAdaptHostComponent).z1k = get_serializable;
  protoOf(AutoAdaptHostComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AutoAdaptHostComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AutoAdaptHostComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AutoAdaptHostComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AutoAdaptProductSpecificationsComponent).z1k = get_serializable;
  protoOf(AutoAdaptProductSpecificationsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AutoAdaptProductSpecificationsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AutoAdaptProductSpecificationsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AutoAdaptProductSpecificationsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AutoAdaptVariantComponent).z1k = get_serializable;
  protoOf(AutoAdaptVariantComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(AutoAdaptVariantComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(AutoAdaptVariantComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(AutoAdaptVariantComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ForceAutoAdaptWhenParentIsDraggedComponent).z1k = get_serializable;
  protoOf(ForceAutoAdaptWhenParentIsDraggedComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ForceAutoAdaptWhenParentIsDraggedComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ForceAutoAdaptWhenParentIsDraggedComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ForceAutoAdaptWhenParentIsDraggedComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ReplacedWithAutoAdaptEventComponent).z1k = get_serializable;
  protoOf(ReplacedWithAutoAdaptEventComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ReplacedWithAutoAdaptEventComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ReplacedWithAutoAdaptEventComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ReplacedWithAutoAdaptEventComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(AbstractDragStrategy).dragStart = dragStart;
  protoOf(AbstractDragStrategy).dragStop = dragStop;
  defineProp(protoOf(AbstractDragStrategy), 'coreServices', function () {
    return this.k2z();
  });
  defineProp(protoOf(AbstractDragStrategy), 'entityManager', protoOf(AbstractDragStrategy).p1i);
  defineProp(protoOf(AbstractDragStrategy), 'isEnabled', function () {
    return this.y1n();
  });
  defineProp(protoOf(AbstractDragStrategy), 'name', function () {
    return this.mb();
  });
  defineProp(protoOf(DragState), 'originalDraggableRoot', protoOf(DragState).g33);
  defineProp(protoOf(DragState), 'lastValidWorldTransform', protoOf(DragState).h33);
  protoOf(DragStateComponent).z1k = get_serializable;
  defineProp(protoOf(DragStateComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DragStateComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(DragStateComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(IsDraggedComponent).z1k = get_serializable;
  defineProp(protoOf(IsDraggedComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(IsDraggedComponent), 'id', protoOf(IsDraggedComponent).s1k);
  defineProp(protoOf(IsDraggedComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(IsDraggedComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(FreeMoveComponent).z1k = get_serializable;
  protoOf(FreeMoveComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(FreeMoveComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(FreeMoveComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(FreeMoveComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(DragProjectionPointComponent).z1k = get_serializable;
  protoOf(DragProjectionPointComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DragProjectionPointComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DragProjectionPointComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DragProjectionPointComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(GrabOffsetComponent).z1k = get_serializable;
  protoOf(GrabOffsetComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(GrabOffsetComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(GrabOffsetComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(GrabOffsetComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Companion_38), 'id', protoOf(Companion_38).s1k);
  protoOf(DragSurfaceEntityPairsCacheComponent).z1k = get_serializable;
  protoOf(DragSurfaceEntityPairsCacheComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DragSurfaceEntityPairsCacheComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DragSurfaceEntityPairsCacheComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DragSurfaceEntityPairsCacheComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(FunctionalMarginComponent).z1k = get_serializable;
  protoOf(FunctionalMarginComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(FunctionalMarginComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(FunctionalMarginComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(FunctionalMarginComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(FunctionalMarginShapeComponent).z1k = get_serializable;
  protoOf(FunctionalMarginShapeComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(FunctionalMarginShapeComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(FunctionalMarginShapeComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(FunctionalMarginShapeComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(FunctionalZonesLocalComponent).z1k = get_serializable;
  protoOf(FunctionalZonesLocalComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(FunctionalZonesLocalComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(FunctionalZonesLocalComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(FunctionalZonesLocalComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(FunctionalZonesWorldComponent).z1k = get_serializable;
  protoOf(FunctionalZonesWorldComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(FunctionalZonesWorldComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(FunctionalZonesWorldComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(FunctionalZonesWorldComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(LabelComponent).z1k = get_serializable;
  protoOf(LabelComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(LabelComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(LabelComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(LabelComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(DebugLogger).f2b = set_logLevel;
  protoOf(DebugLogger).g2b = get_logLevel;
  defineProp(protoOf(DebugLogger), 'level', function () {
    return this.e2b();
  }, function (value) {
    this.d2b(value);
  });
  defineProp(protoOf(DebugLogger), 'exceptionLevel', protoOf(DebugLogger).h3b, protoOf(DebugLogger).g3b);
  defineProp(protoOf(DebugLogger), 'logLevel', function () {
    return this.g2b();
  }, function (value) {
    this.f2b(value);
  });
  protoOf(ColoredOutlineComponent).z1k = get_serializable;
  protoOf(ColoredOutlineComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ColoredOutlineComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ColoredOutlineComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ColoredOutlineComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(OutlineBlockingComponent).z1k = get_serializable;
  protoOf(OutlineBlockingComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(OutlineBlockingComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(OutlineBlockingComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(OutlineBlockingComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(OutlinedComponent).z1k = get_serializable;
  protoOf(OutlinedComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(OutlinedComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(OutlinedComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(OutlinedComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(PlacementResult), 'valid', protoOf(PlacementResult).t2t);
  protoOf(PlacementZoneByHeightComponent).z1k = get_serializable;
  protoOf(PlacementZoneByHeightComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(PlacementZoneByHeightComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(PlacementZoneByHeightComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(PlacementZoneByHeightComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(RecommendedInitialPositionFromFloorComponent).z1k = get_serializable;
  protoOf(RecommendedInitialPositionFromFloorComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RecommendedInitialPositionFromFloorComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RecommendedInitialPositionFromFloorComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RecommendedInitialPositionFromFloorComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(RecommendedInitialPositionFromParentComponent).z1k = get_serializable;
  protoOf(RecommendedInitialPositionFromParentComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RecommendedInitialPositionFromParentComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RecommendedInitialPositionFromParentComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RecommendedInitialPositionFromParentComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(PriorityCriterionSettings$Companion$all$1), 'onlyInActivationDistance', function () {
    return this.y3d();
  });
  defineProp(protoOf(PriorityCriterionSettings$Companion$onlyInActivationDistance$1), 'onlyInActivationDistance', function () {
    return this.y3d();
  });
  protoOf(ProppingHostConnectorsComponent).z1k = get_serializable;
  protoOf(ProppingHostConnectorsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ProppingHostConnectorsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ProppingHostConnectorsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ProppingHostConnectorsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ProppingInfoComponent).z1k = get_serializable;
  protoOf(ProppingInfoComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ProppingInfoComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ProppingInfoComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ProppingInfoComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(CommunicationSizeComponent).z1k = get_serializable;
  protoOf(CommunicationSizeComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(CommunicationSizeComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(CommunicationSizeComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(CommunicationSizeComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(DoorComponent).z1k = get_serializable;
  protoOf(DoorComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DoorComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DoorComponent), 'id', protoOf(DoorComponent).s1k);
  defineProp(protoOf(DoorComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DoorComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(DoorFrontComponent).z1k = get_serializable;
  protoOf(DoorFrontComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DoorFrontComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DoorFrontComponent), 'id', protoOf(DoorFrontComponent).s1k);
  defineProp(protoOf(DoorFrontComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DoorFrontComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(DrawerComponent).z1k = get_serializable;
  protoOf(DrawerComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DrawerComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DrawerComponent), 'id', protoOf(DrawerComponent).s1k);
  defineProp(protoOf(DrawerComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DrawerComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(FrameComponent).z1k = get_serializable;
  protoOf(FrameComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(FrameComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(FrameComponent), 'id', protoOf(FrameComponent).s1k);
  defineProp(protoOf(FrameComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(FrameComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(HandleComponent).z1k = get_serializable;
  protoOf(HandleComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(HandleComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(HandleComponent), 'id', protoOf(HandleComponent).s1k);
  defineProp(protoOf(HandleComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(HandleComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(IncludedHandleComponent).z1k = get_serializable;
  protoOf(IncludedHandleComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(IncludedHandleComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(IncludedHandleComponent), 'id', protoOf(IncludedHandleComponent).s1k);
  defineProp(protoOf(IncludedHandleComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(IncludedHandleComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(LegComponent).z1k = get_serializable;
  protoOf(LegComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(LegComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(LegComponent), 'id', protoOf(LegComponent).s1k);
  defineProp(protoOf(LegComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(LegComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(LightComponent).z1k = get_serializable;
  protoOf(LightComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(LightComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(LightComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(LightComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(RoomComponentDeserializer), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
    return this.a1m();
  });
  protoOf($serializer).sv = typeParametersSerializers;
  protoOf($serializer_0).sv = typeParametersSerializers;
  protoOf($serializer_1).sv = typeParametersSerializers;
  protoOf($serializer_2).sv = typeParametersSerializers;
  protoOf($serializer_3).sv = typeParametersSerializers;
  protoOf($serializer_4).sv = typeParametersSerializers;
  protoOf($serializer_5).sv = typeParametersSerializers;
  protoOf(DisabledRoomConnectorsConfigComponent).z1k = get_serializable;
  protoOf(DisabledRoomConnectorsConfigComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DisabledRoomConnectorsConfigComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DisabledRoomConnectorsConfigComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DisabledRoomConnectorsConfigComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(RoomComponent).z1k = get_serializable;
  protoOf(RoomComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RoomComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RoomComponent), 'id', protoOf(RoomComponent).s1k);
  defineProp(protoOf(RoomComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RoomComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(RoomConnectorRelationsComponent).z1k = get_serializable;
  protoOf(RoomConnectorRelationsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RoomConnectorRelationsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RoomConnectorRelationsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RoomConnectorRelationsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_6).sv = typeParametersSerializers;
  protoOf(RoomDimensionsComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RoomDimensionsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RoomDimensionsComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RoomDimensionsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf($serializer_7).sv = typeParametersSerializers;
  protoOf(RoomGeometryComponent).z1k = get_serializable_0;
  protoOf(RoomGeometryComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RoomGeometryComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RoomGeometryComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RoomGeometryComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(RoomPartComponent).z1k = get_serializable;
  protoOf(RoomPartComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(RoomPartComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(RoomPartComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(RoomPartComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(RoomRefToRoomComponentInterceptor).createCustomAssembly = createCustomAssembly;
  protoOf(RoomRefToRoomComponentInterceptor).createCustomAssemblySpecification = createCustomAssemblySpecification;
  protoOf(RoomRefToRoomComponentInterceptor).beforeDeserialize = beforeDeserialize;
  protoOf(RoomRefToRoomComponentInterceptor).beforeParsingComponents = beforeParsingComponents;
  protoOf(RoomRefToRoomComponentInterceptor).afterDeserializeComplete = afterDeserializeComplete;
  defineProp(protoOf(RoomRefToRoomComponentInterceptor), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
    return this.a1m();
  });
  protoOf(ColliderVisualizationConfigComponent).z1k = get_serializable;
  protoOf(ColliderVisualizationConfigComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ColliderVisualizationConfigComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ColliderVisualizationConfigComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ColliderVisualizationConfigComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Companion_96), 'id', protoOf(Companion_96).s1k);
  protoOf(ColliderVisualizationNodeComponent).z1k = get_serializable;
  protoOf(ColliderVisualizationNodeComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ColliderVisualizationNodeComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ColliderVisualizationNodeComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ColliderVisualizationNodeComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ColliderVisualizerViewerObjectsComponent).z1k = get_serializable;
  defineProp(protoOf(ColliderVisualizerViewerObjectsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ColliderVisualizerViewerObjectsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(ColliderVisualizerViewerObjectsComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(ConnectorVisualizationConfigComponent).z1k = get_serializable;
  protoOf(ConnectorVisualizationConfigComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ConnectorVisualizationConfigComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ConnectorVisualizationConfigComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ConnectorVisualizationConfigComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(Companion_99), 'id', protoOf(Companion_99).s1k);
  protoOf(ConnectorVisualizationNodeComponent).z1k = get_serializable;
  protoOf(ConnectorVisualizationNodeComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(ConnectorVisualizationNodeComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ConnectorVisualizationNodeComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(ConnectorVisualizationNodeComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(ConnectorVisualizerViewerObjectsComponent).z1k = get_serializable;
  defineProp(protoOf(ConnectorVisualizerViewerObjectsComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(ConnectorVisualizerViewerObjectsComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(ConnectorVisualizerViewerObjectsComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(DecoratorComponent).z1k = get_serializable;
  protoOf(DecoratorComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(DecoratorComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(DecoratorComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(DecoratorComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(EntityColliderVisualizationComponent).z1k = get_serializable;
  defineProp(protoOf(EntityColliderVisualizationComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(EntityColliderVisualizationComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(EntityColliderVisualizationComponent), 'serializable', function () {
    return this.z1k();
  });
  protoOf(EntityConnectorVisualizationComponent).z1k = get_serializable;
  defineProp(protoOf(EntityConnectorVisualizationComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(EntityConnectorVisualizationComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(EntityConnectorVisualizationComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(Companion_104), 'id', protoOf(Companion_104).s1k);
  protoOf(PolyhedronVisualizationNodeComponent).z1k = get_serializable;
  protoOf(PolyhedronVisualizationNodeComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(PolyhedronVisualizationNodeComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(PolyhedronVisualizationNodeComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(PolyhedronVisualizationNodeComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  protoOf(PolyhedronVisualizationHolderComponent).z1k = get_serializable;
  protoOf(PolyhedronVisualizationHolderComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(PolyhedronVisualizationHolderComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(PolyhedronVisualizationHolderComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(PolyhedronVisualizationHolderComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(ColliderVisualizationSystem), 'includeRoom', protoOf(ColliderVisualizationSystem).n3r, protoOf(ColliderVisualizationSystem).n3t);
  defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'connectorKey', function () {
    return this.z21();
  });
  defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'style', function () {
    return this.l3s();
  });
  defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'selected', function () {
    return this.m3s();
  });
  defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'visible', function () {
    return this.n3s();
  });
  defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'active', function () {
    return this.o3s();
  });
  defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'showActivationDistance', function () {
    return this.p3s();
  });
  defineProp(protoOf(ConnectorVisualizationSystem$Companion$createEntityConnectorVisualizationComponent$data$1), 'showTransform', function () {
    return this.q3s();
  });
  defineProp(protoOf(ConnectorVisualizationSystem), 'includeRoom', protoOf(ConnectorVisualizationSystem).n3r, protoOf(ConnectorVisualizationSystem).n3t);
  defineProp(protoOf(ConnectorVisualizationSystem), 'connectorActivationDistanceVisualizationEnabled', protoOf(ConnectorVisualizationSystem).f3r, protoOf(ConnectorVisualizationSystem).i3u);
  defineProp(protoOf(ConnectorVisualizationSystem), 'connectorTransformVisualizationEnabled', protoOf(ConnectorVisualizationSystem).g3r, protoOf(ConnectorVisualizationSystem).j3u);
  protoOf(CollisionVisualizationSceneDataComponent).z1k = get_serializable;
  protoOf(CollisionVisualizationSceneDataComponent).a1l = get_doStoreInSnapshot;
  defineProp(protoOf(CollisionVisualizationSceneDataComponent), 'typeId', function () {
    return this.x1k();
  });
  defineProp(protoOf(CollisionVisualizationSceneDataComponent), 'serializable', function () {
    return this.z1k();
  });
  defineProp(protoOf(CollisionVisualizationSceneDataComponent), 'doStoreInSnapshot', function () {
    return this.a1l();
  });
  defineProp(protoOf(EntityConnectorVisualizationSystem), 'offersFilter', protoOf(EntityConnectorVisualizationSystem).w3r, protoOf(EntityConnectorVisualizationSystem).z3v);
  defineProp(protoOf(EntityConnectorVisualizationSystem), 'demandsFilter', protoOf(EntityConnectorVisualizationSystem).x3r, protoOf(EntityConnectorVisualizationSystem).a3w);
  protoOf(DefaultVisualizer).createColliderVisualization = createColliderVisualization;
  defineProp(protoOf(DefaultVisualizer), 'viewer', protoOf(DefaultVisualizer).l2j);
  //endregion
  //region block: init
  Companion_instance_32 = new Companion();
  Companion_instance_33 = new Companion_0();
  Companion_instance_35 = new Companion_2();
  Companion_instance_37 = new Companion_4();
  Companion_instance_38 = new Companion_5();
  Companion_instance_39 = new Companion_6();
  Companion_instance_40 = new Companion_7();
  AutoAdaptFeature_instance = new AutoAdaptFeature();
  Companion_instance_41 = new Companion_8();
  Companion_instance_42 = new Companion_9();
  Companion_instance_45 = new Companion_12();
  Companion_instance_46 = new Companion_13();
  Companion_instance_47 = new Companion_14();
  Companion_instance_48 = new Companion_15();
  Companion_instance_49 = new Companion_16();
  Companion_instance_50 = new Companion_17();
  Companion_instance_51 = new Companion_18();
  Companion_instance_52 = new Companion_19();
  Companion_instance_53 = new Companion_20();
  Companion_instance_54 = new Companion_21();
  DoneEntry_instance = new DoneEntry();
  Companion_instance_57 = new Companion_24();
  Companion_instance_58 = new Companion_25();
  Companion_instance_60 = new Companion_27();
  Companion_instance_62 = new Companion_29();
  IsDraggedComponent_instance = new IsDraggedComponent();
  Companion_instance_63 = new Companion_30();
  FreeMoveComponent_instance = new FreeMoveComponent();
  Companion_instance_64 = new Companion_31();
  Companion_instance_66 = new Companion_33();
  Companion_instance_67 = new Companion_34();
  Companion_instance_68 = new Companion_35();
  Companion_instance_69 = new Companion_36();
  Companion_instance_71 = new Companion_38();
  Companion_instance_72 = new Companion_39();
  Companion_instance_73 = new Companion_40();
  Companion_instance_74 = new Companion_41();
  Companion_instance_75 = new Companion_42();
  Companion_instance_76 = new Companion_43();
  Companion_instance_77 = new Companion_44();
  Companion_instance_78 = new Companion_45();
  Companion_instance_79 = new Companion_46();
  Companion_instance_80 = new Companion_47();
  Companion_instance_82 = new Companion_49();
  Companion_instance_83 = new Companion_50();
  Companion_instance_84 = new Companion_51();
  Companion_instance_85 = new Companion_52();
  Companion_instance_86 = new Companion_53();
  Companion_instance_87 = new Companion_54();
  Companion_instance_88 = new Companion_55();
  Companion_instance_89 = new Companion_56();
  Companion_instance_90 = new Companion_57();
  Companion_instance_91 = new Companion_58();
  SearchDirectionsUtils_instance = new SearchDirectionsUtils();
  Companion_instance_94 = new Companion_61();
  Companion_instance_95 = new Companion_62();
  ProppingUtils_instance = new ProppingUtils();
  Companion_instance_97 = new Companion_64();
  Companion_instance_98 = new Companion_65();
  Companion_instance_99 = new Companion_66();
  Companion_instance_100 = new Companion_67();
  Companion_instance_101 = new Companion_68();
  ReplaceUtils_instance = new ReplaceUtils();
  Companion_instance_103 = new Companion_70();
  Companion_instance_105 = new Companion_72();
  Companion_instance_107 = new Companion_74();
  Companion_instance_108 = new Companion_75();
  Companion_instance_109 = new Companion_76();
  RoomComponent_instance = new RoomComponent();
  Companion_instance_110 = new Companion_77();
  Companion_instance_113 = new Companion_80();
  Companion_instance_114 = new Companion_81();
  Companion_instance_115 = new Companion_82();
  Companion_instance_117 = new Companion_84();
  Companion_instance_118 = new Companion_85();
  Companion_instance_120 = new Companion_87();
  StlSystemIds_instance = new StlSystemIds();
  Companion_instance_122 = new Companion_89();
  Companion_instance_123 = new Companion_90();
  Companion_instance_124 = new Companion_91();
  Companion_instance_125 = new Companion_92();
  Companion_instance_126 = new Companion_93();
  Companion_instance_127 = new Companion_94();
  ValidationResultIds_instance = new ValidationResultIds();
  ValidationRuleIds_instance = new ValidationRuleIds();
  Companion_instance_128 = new Companion_95();
  Companion_instance_129 = new Companion_96();
  Companion_instance_130 = new Companion_97();
  Companion_instance_131 = new Companion_98();
  Companion_instance_132 = new Companion_99();
  Companion_instance_133 = new Companion_100();
  Companion_instance_134 = new Companion_101();
  Companion_instance_135 = new Companion_102();
  Companion_instance_136 = new Companion_103();
  Companion_instance_137 = new Companion_104();
  Companion_instance_138 = new Companion_105();
  Companion_instance_139 = new Companion_106();
  Companion_instance_140 = new Companion_107();
  Companion_instance_141 = new Companion_108();
  Companion_instance_142 = new Companion_109();
  Companion_instance_143 = new Companion_110();
  Companion_instance_144 = new Companion_111();
  Companion_instance_145 = new Companion_112();
  Companion_instance_146 = new Companion_113();
  Companion_instance_147 = new Companion_114();
  Companion_instance_150 = new Companion_117();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignment = $com$ikea$core$stl.alignment || ($com$ikea$core$stl.alignment = {});
    $com$ikea$core$stl$alignment.AlignmentConnectionCreationSystem = AlignmentConnectionCreationSystem;
    defineProp($com$ikea$core$stl$alignment.AlignmentConnectionCreationSystem, 'Companion', Companion_getInstance_8);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignment = $com$ikea$core$stl.alignment || ($com$ikea$core$stl.alignment = {});
    $com$ikea$core$stl$alignment.AlignmentConnectionsComponent = AlignmentConnectionsComponent;
    defineProp($com$ikea$core$stl$alignment.AlignmentConnectionsComponent, 'Companion', Companion_getInstance_9);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignment = $com$ikea$core$stl.alignment || ($com$ikea$core$stl.alignment = {});
    $com$ikea$core$stl$alignment.AlignmentPlane = AlignmentPlane;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignment = $com$ikea$core$stl.alignment || ($com$ikea$core$stl.alignment = {});
    $com$ikea$core$stl$alignment.HandleRotationSystem = HandleRotationSystem;
    defineProp($com$ikea$core$stl$alignment.HandleRotationSystem, 'Companion', Companion_getInstance_10);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignment = $com$ikea$core$stl.alignment || ($com$ikea$core$stl.alignment = {});
    $com$ikea$core$stl$alignment.HostConnectorRotationValidation = HostConnectorRotationValidation;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignmentlines = $com$ikea$core$stl.alignmentlines || ($com$ikea$core$stl.alignmentlines = {});
    $com$ikea$core$stl$alignmentlines.AlignmentLinesReferenceCounter = AlignmentLinesReferenceCounter;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignmentlines = $com$ikea$core$stl.alignmentlines || ($com$ikea$core$stl.alignmentlines = {});
    $com$ikea$core$stl$alignmentlines.AlignmentLinesSystem = AlignmentLinesSystem;
    defineProp($com$ikea$core$stl$alignmentlines.AlignmentLinesSystem, 'Companion', Companion_getInstance_11);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignmentlines = $com$ikea$core$stl.alignmentlines || ($com$ikea$core$stl.alignmentlines = {});
    $com$ikea$core$stl$alignmentlines.AlignmentLinesUtils = AlignmentLinesUtils;
    defineProp($com$ikea$core$stl$alignmentlines.AlignmentLinesUtils, 'Companion', Companion_getInstance_12);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignmentlines = $com$ikea$core$stl.alignmentlines || ($com$ikea$core$stl.alignmentlines = {});
    $com$ikea$core$stl$alignmentlines.IntersectionPointConnectors = IntersectionPointConnectors;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignmentlines = $com$ikea$core$stl.alignmentlines || ($com$ikea$core$stl.alignmentlines = {});
    $com$ikea$core$stl$alignmentlines.IntersectionPointsTracker = IntersectionPointsTracker;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignmentlines = $com$ikea$core$stl.alignmentlines || ($com$ikea$core$stl.alignmentlines = {});
    $com$ikea$core$stl$alignmentlines.RoomAlignmentEdgesComponent = RoomAlignmentEdgesComponent;
    defineProp($com$ikea$core$stl$alignmentlines.RoomAlignmentEdgesComponent, 'Companion', Companion_getInstance_13);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignmentlines = $com$ikea$core$stl.alignmentlines || ($com$ikea$core$stl.alignmentlines = {});
    $com$ikea$core$stl$alignmentlines.getCloseKeyFromSet = getCloseKeyFromSet;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alignmentlines = $com$ikea$core$stl.alignmentlines || ($com$ikea$core$stl.alignmentlines = {});
    $com$ikea$core$stl$alignmentlines.SurfaceAlignmentLines = SurfaceAlignmentLines;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alloweddoorpairs = $com$ikea$core$stl.alloweddoorpairs || ($com$ikea$core$stl.alloweddoorpairs = {});
    $com$ikea$core$stl$alloweddoorpairs.AllowedDoorPairsComponent = AllowedDoorPairsComponent;
    $com$ikea$core$stl$alloweddoorpairs.AllowedDoorPairsComponent.AllowedDoorPairsComponentFromInts = AllowedDoorPairsComponentFromInts;
    $com$ikea$core$stl$alloweddoorpairs.AllowedDoorPairsComponent.AllowedDoorPairsComponentFromArrays = AllowedDoorPairsComponentFromArrays;
    defineProp($com$ikea$core$stl$alloweddoorpairs.AllowedDoorPairsComponent, 'Companion', Companion_getInstance_14);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alloweddoorpairs = $com$ikea$core$stl.alloweddoorpairs || ($com$ikea$core$stl.alloweddoorpairs = {});
    $com$ikea$core$stl$alloweddoorpairs.AllowedDoorPairsValidation = AllowedDoorPairsValidation;
    defineProp($com$ikea$core$stl$alloweddoorpairs.AllowedDoorPairsValidation, 'Companion', Companion_getInstance_15);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$alloweddoorpairs = $com$ikea$core$stl.alloweddoorpairs || ($com$ikea$core$stl.alloweddoorpairs = {});
    $com$ikea$core$stl$alloweddoorpairs.InvalidDoorPairsResult = InvalidDoorPairsResult;
    defineProp($com$ikea$core$stl$alloweddoorpairs.InvalidDoorPairsResult, 'Companion', Companion_getInstance_16);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$assemblyinstructions = $com$ikea$core$stl.assemblyinstructions || ($com$ikea$core$stl.assemblyinstructions = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$assemblyinstructions = $com$ikea$core$stl.assemblyinstructions || ($com$ikea$core$stl.assemblyinstructions = {});
    $com$ikea$core$stl$assemblyinstructions.AssemblyInstructionsServiceImpl = AssemblyInstructionsServiceImpl;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$assemblyinstructions = $com$ikea$core$stl.assemblyinstructions || ($com$ikea$core$stl.assemblyinstructions = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$assemblyinstructions = $com$ikea$core$stl.assemblyinstructions || ($com$ikea$core$stl.assemblyinstructions = {});
    $com$ikea$core$stl$assemblyinstructions.PointSeriesAssemblyInstructionImpl = PointSeriesAssemblyInstructionImpl;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    defineProp($com$ikea$core$stl$autoadapt, 'AutoAdaptFeature', AutoAdaptFeature_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    $com$ikea$core$stl$autoadapt.AutoAdaptProductSpecificationsSystem = AutoAdaptProductSpecificationsSystem;
    defineProp($com$ikea$core$stl$autoadapt.AutoAdaptProductSpecificationsSystem, 'Companion', Companion_getInstance_17);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    $com$ikea$core$stl$autoadapt.AutoAdaptService = AutoAdaptService;
    $com$ikea$core$stl$autoadapt.AutoAdaptService.findWithAutoAdapt$default = findWithAutoAdapt$default;
    $com$ikea$core$stl$autoadapt.AutoAdaptService.snapToValidSnap$default = snapToValidSnap$default;
    $com$ikea$core$stl$autoadapt.AutoAdaptService.snapAndValidateVariant$default = snapAndValidateVariant$default;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    $com$ikea$core$stl$autoadapt.EntityWithSensorZone = EntityWithSensorZone;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    defineProp($com$ikea$core$stl$autoadapt, 'AutoAdaptUtils', AutoAdaptUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$autoadaptchildren = $com$ikea$core$stl$autoadapt.autoadaptchildren || ($com$ikea$core$stl$autoadapt.autoadaptchildren = {});
    $com$ikea$core$stl$autoadapt$autoadaptchildren.AutoAdaptChildrenSystem = AutoAdaptChildrenSystem;
    $com$ikea$core$stl$autoadapt$autoadaptchildren.AutoAdaptChildrenSystem.ChildInfo = ChildInfo;
    $com$ikea$core$stl$autoadapt$autoadaptchildren.AutoAdaptChildrenSystem.PreferSameConnectorsStrategy = PreferSameConnectorsStrategy;
    defineProp($com$ikea$core$stl$autoadapt$autoadaptchildren.AutoAdaptChildrenSystem, 'Companion', Companion_getInstance_19);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$component = $com$ikea$core$stl$autoadapt.component || ($com$ikea$core$stl$autoadapt.component = {});
    $com$ikea$core$stl$autoadapt$component.AutoAdaptGuestComponent = AutoAdaptGuestComponent;
    defineProp($com$ikea$core$stl$autoadapt$component.AutoAdaptGuestComponent, 'Companion', Companion_getInstance_25);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$component = $com$ikea$core$stl$autoadapt.component || ($com$ikea$core$stl$autoadapt.component = {});
    $com$ikea$core$stl$autoadapt$component.AutoAdaptHostComponent = AutoAdaptHostComponent;
    defineProp($com$ikea$core$stl$autoadapt$component.AutoAdaptHostComponent, 'Companion', Companion_getInstance_26);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$component = $com$ikea$core$stl$autoadapt.component || ($com$ikea$core$stl$autoadapt.component = {});
    $com$ikea$core$stl$autoadapt$component.AutoAdaptProductSpecificationsComponent = AutoAdaptProductSpecificationsComponent;
    defineProp($com$ikea$core$stl$autoadapt$component.AutoAdaptProductSpecificationsComponent, 'Companion', Companion_getInstance_27);
    $com$ikea$core$stl$autoadapt$component.SpecificationPair = SpecificationPair;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$component = $com$ikea$core$stl$autoadapt.component || ($com$ikea$core$stl$autoadapt.component = {});
    $com$ikea$core$stl$autoadapt$component.AutoAdaptVariantComponent = AutoAdaptVariantComponent;
    defineProp($com$ikea$core$stl$autoadapt$component.AutoAdaptVariantComponent, 'Companion', Companion_getInstance_28);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$component = $com$ikea$core$stl$autoadapt.component || ($com$ikea$core$stl$autoadapt.component = {});
    $com$ikea$core$stl$autoadapt$component.ForceAutoAdaptWhenParentIsDraggedComponent = ForceAutoAdaptWhenParentIsDraggedComponent;
    defineProp($com$ikea$core$stl$autoadapt$component.ForceAutoAdaptWhenParentIsDraggedComponent, 'Companion', Companion_getInstance_29);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$component = $com$ikea$core$stl$autoadapt.component || ($com$ikea$core$stl$autoadapt.component = {});
    $com$ikea$core$stl$autoadapt$component.ReplacedWithAutoAdaptEventComponent = ReplacedWithAutoAdaptEventComponent;
    defineProp($com$ikea$core$stl$autoadapt$component.ReplacedWithAutoAdaptEventComponent, 'Companion', Companion_getInstance_30);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$drag = $com$ikea$core$stl$autoadapt.drag || ($com$ikea$core$stl$autoadapt.drag = {});
    $com$ikea$core$stl$autoadapt$drag.AutoAdaptDragStrategy = AutoAdaptDragStrategy;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$drag = $com$ikea$core$stl$autoadapt.drag || ($com$ikea$core$stl$autoadapt.drag = {});
    $com$ikea$core$stl$autoadapt$drag.DragSurfaceCanHostWithAutoAdaptSelector = DragSurfaceCanHostWithAutoAdaptSelector;
    defineProp($com$ikea$core$stl$autoadapt$drag.DragSurfaceCanHostWithAutoAdaptSelector, 'Companion', Companion_getInstance_31);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$autoadapt = $com$ikea$core$stl.autoadapt || ($com$ikea$core$stl.autoadapt = {});
    var $com$ikea$core$stl$autoadapt$drag = $com$ikea$core$stl$autoadapt.drag || ($com$ikea$core$stl$autoadapt.drag = {});
    $com$ikea$core$stl$autoadapt$drag.ValidAutoAdaptDragStrategyResult = ValidAutoAdaptDragStrategyResult;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$debug = $com$ikea$core$stl.debug || ($com$ikea$core$stl.debug = {});
    $com$ikea$core$stl$debug.DebugLineDrawingSystem = DebugLineDrawingSystem;
    defineProp($com$ikea$core$stl$debug.DebugLineDrawingSystem, 'Companion', Companion_getInstance_32);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$debug = $com$ikea$core$stl.debug || ($com$ikea$core$stl.debug = {});
    $com$ikea$core$stl$debug.MeasuringEntityManagerWatcher = MeasuringEntityManagerWatcher;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    $com$ikea$core$stl$dragging.DragState = DragState;
    defineProp($com$ikea$core$stl$dragging.DragState, 'Companion', Companion_getInstance_33);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    $com$ikea$core$stl$dragging.DragStateComponent = DragStateComponent;
    defineProp($com$ikea$core$stl$dragging.DragStateComponent, 'Companion', Companion_getInstance_34);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    $com$ikea$core$stl$dragging.DragSurfaceNormalVisualizationSystem = DragSurfaceNormalVisualizationSystem;
    defineProp($com$ikea$core$stl$dragging.DragSurfaceNormalVisualizationSystem, 'Companion', Companion_getInstance_35);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    $com$ikea$core$stl$dragging.DragSurfaceVisualizationSystem = DragSurfaceVisualizationSystem;
    defineProp($com$ikea$core$stl$dragging.DragSurfaceVisualizationSystem, 'Companion', Companion_getInstance_36);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    $com$ikea$core$stl$dragging.DragSurfacesUpdateSystem = DragSurfacesUpdateSystem;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    $com$ikea$core$stl$dragging.DragSystem = DragSystem;
    defineProp($com$ikea$core$stl$dragging.DragSystem, 'Companion', Companion_getInstance_37);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    $com$ikea$core$stl$dragging.DrawDragGhostSystem = DrawDragGhostSystem;
    defineProp($com$ikea$core$stl$dragging.DrawDragGhostSystem, 'Companion', Companion_getInstance_38);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    $com$ikea$core$stl$dragging.HigherPriorityAlignmentPostProcess = HigherPriorityAlignmentPostProcess;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    defineProp($com$ikea$core$stl$dragging, 'IsDraggedComponent', IsDraggedComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$dragstrategy = $com$ikea$core$stl$dragging.dragstrategy || ($com$ikea$core$stl$dragging.dragstrategy = {});
    $com$ikea$core$stl$dragging$dragstrategy.AbstractDragStrategy = AbstractDragStrategy;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$dragstrategy = $com$ikea$core$stl$dragging.dragstrategy || ($com$ikea$core$stl$dragging.dragstrategy = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$dragstrategy = $com$ikea$core$stl$dragging.dragstrategy || ($com$ikea$core$stl$dragging.dragstrategy = {});
    defineProp($com$ikea$core$stl$dragging$dragstrategy, 'FreeMoveComponent', FreeMoveComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$dragstrategy = $com$ikea$core$stl$dragging.dragstrategy || ($com$ikea$core$stl$dragging.dragstrategy = {});
    $com$ikea$core$stl$dragging$dragstrategy.FreeMoveDragStrategy = FreeMoveDragStrategy;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$dragstrategy = $com$ikea$core$stl$dragging.dragstrategy || ($com$ikea$core$stl$dragging.dragstrategy = {});
    $com$ikea$core$stl$dragging$dragstrategy.ResolveCollisionsDragStrategy = ResolveCollisionsDragStrategy;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$dragstrategy = $com$ikea$core$stl$dragging.dragstrategy || ($com$ikea$core$stl$dragging.dragstrategy = {});
    $com$ikea$core$stl$dragging$dragstrategy.SnapCardinalDirectionsDragStrategy = SnapCardinalDirectionsDragStrategy;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$dragstrategy = $com$ikea$core$stl$dragging.dragstrategy || ($com$ikea$core$stl$dragging.dragstrategy = {});
    $com$ikea$core$stl$dragging$dragstrategy.SnapClosestDragStrategy = SnapClosestDragStrategy;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$dragstrategy = $com$ikea$core$stl$dragging.dragstrategy || ($com$ikea$core$stl$dragging.dragstrategy = {});
    $com$ikea$core$stl$dragging$dragstrategy.SnapClosestWithSubConnectorsDragStrategy = SnapClosestWithSubConnectorsDragStrategy;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$dragstrategy = $com$ikea$core$stl$dragging.dragstrategy || ($com$ikea$core$stl$dragging.dragstrategy = {});
    $com$ikea$core$stl$dragging$dragstrategy.ValidDragStrategyResult = ValidDragStrategyResult;
    defineProp($com$ikea$core$stl$dragging$dragstrategy.ValidDragStrategyResult, 'Companion', Companion_getInstance_40);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    $com$ikea$core$stl$dragging$viewerDragConversion.CanvasTo3DDragConverterSystem = CanvasTo3DDragConverterSystem;
    $com$ikea$core$stl$dragging$viewerDragConversion.CanvasTo3DDragConverterSystem.CanvasTo3DDragConverterSystemFromCoreServices = CanvasTo3DDragConverterSystemFromCoreServices;
    defineProp($com$ikea$core$stl$dragging$viewerDragConversion.CanvasTo3DDragConverterSystem, 'Companion', Companion_getInstance_41);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    $com$ikea$core$stl$dragging$viewerDragConversion.DragSurfaceCanHostSelector = DragSurfaceCanHostSelector;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    $com$ikea$core$stl$dragging$viewerDragConversion.DragSurfaceEntityPair = DragSurfaceEntityPair;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    $com$ikea$core$stl$dragging$viewerDragConversion.DragSurfaceOnlyRoomSelector = DragSurfaceOnlyRoomSelector;
    defineProp($com$ikea$core$stl$dragging$viewerDragConversion.DragSurfaceOnlyRoomSelector, 'Companion', Companion_getInstance_42);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    $com$ikea$core$stl$dragging$viewerDragConversion.LegacyCanvasTo3DDragConverterSystem = LegacyCanvasTo3DDragConverterSystem;
    defineProp($com$ikea$core$stl$dragging$viewerDragConversion.LegacyCanvasTo3DDragConverterSystem, 'Companion', Companion_getInstance_43);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    $com$ikea$core$stl$dragging$viewerDragConversion.NoDragConverterDetector = NoDragConverterDetector;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion$component = $com$ikea$core$stl$dragging$viewerDragConversion.component || ($com$ikea$core$stl$dragging$viewerDragConversion.component = {});
    $com$ikea$core$stl$dragging$viewerDragConversion$component.DragProjectionPointComponent = DragProjectionPointComponent;
    defineProp($com$ikea$core$stl$dragging$viewerDragConversion$component.DragProjectionPointComponent, 'Companion', Companion_getInstance_44);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion$component = $com$ikea$core$stl$dragging$viewerDragConversion.component || ($com$ikea$core$stl$dragging$viewerDragConversion.component = {});
    $com$ikea$core$stl$dragging$viewerDragConversion$component.GrabOffsetComponent = GrabOffsetComponent;
    defineProp($com$ikea$core$stl$dragging$viewerDragConversion$component.GrabOffsetComponent, 'Companion', Companion_getInstance_45);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion$projector = $com$ikea$core$stl$dragging$viewerDragConversion.projector || ($com$ikea$core$stl$dragging$viewerDragConversion.projector = {});
    $com$ikea$core$stl$dragging$viewerDragConversion$projector.AnyDragSurfaceProjector = AnyDragSurfaceProjector;
    $com$ikea$core$stl$dragging$viewerDragConversion$projector.AnyDragSurfaceProjector.AnyDragSurfaceProjectorFromCoreServices = AnyDragSurfaceProjectorFromCoreServices;
    defineProp($com$ikea$core$stl$dragging$viewerDragConversion$projector.AnyDragSurfaceProjector, 'Companion', Companion_getInstance_46);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion$projector = $com$ikea$core$stl$dragging$viewerDragConversion.projector || ($com$ikea$core$stl$dragging$viewerDragConversion.projector = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion$projector = $com$ikea$core$stl$dragging$viewerDragConversion.projector || ($com$ikea$core$stl$dragging$viewerDragConversion.projector = {});
    $com$ikea$core$stl$dragging$viewerDragConversion$projector.DragSurfaceUpdatesListenerSystem = DragSurfaceUpdatesListenerSystem;
    defineProp($com$ikea$core$stl$dragging$viewerDragConversion$projector.DragSurfaceUpdatesListenerSystem, 'Companion', Companion_getInstance_48);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$dragging = $com$ikea$core$stl.dragging || ($com$ikea$core$stl.dragging = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion = $com$ikea$core$stl$dragging.viewerDragConversion || ($com$ikea$core$stl$dragging.viewerDragConversion = {});
    var $com$ikea$core$stl$dragging$viewerDragConversion$projector = $com$ikea$core$stl$dragging$viewerDragConversion.projector || ($com$ikea$core$stl$dragging$viewerDragConversion.projector = {});
    $com$ikea$core$stl$dragging$viewerDragConversion$projector.XYPlaneProjector = XYPlaneProjector;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$functionalmargins = $com$ikea$core$stl.functionalmargins || ($com$ikea$core$stl.functionalmargins = {});
    $com$ikea$core$stl$functionalmargins.FunctionalMarginComponent = FunctionalMarginComponent;
    defineProp($com$ikea$core$stl$functionalmargins.FunctionalMarginComponent, 'Companion', Companion_getInstance_49);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$functionalmargins = $com$ikea$core$stl.functionalmargins || ($com$ikea$core$stl.functionalmargins = {});
    $com$ikea$core$stl$functionalmargins.FunctionalMarginShapeComponent = FunctionalMarginShapeComponent;
    defineProp($com$ikea$core$stl$functionalmargins.FunctionalMarginShapeComponent, 'Companion', Companion_getInstance_50);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$functionalmargins = $com$ikea$core$stl.functionalmargins || ($com$ikea$core$stl.functionalmargins = {});
    $com$ikea$core$stl$functionalmargins.FunctionalMarginSystem = FunctionalMarginSystem;
    defineProp($com$ikea$core$stl$functionalmargins.FunctionalMarginSystem, 'Companion', Companion_getInstance_51);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$functionalmargins = $com$ikea$core$stl.functionalmargins || ($com$ikea$core$stl.functionalmargins = {});
    $com$ikea$core$stl$functionalmargins.FunctionalMarginValidation = FunctionalMarginValidation;
    defineProp($com$ikea$core$stl$functionalmargins.FunctionalMarginValidation, 'Companion', Companion_getInstance_52);
    $com$ikea$core$stl$functionalmargins.FunctionalMarginWarning = FunctionalMarginWarning;
    defineProp($com$ikea$core$stl$functionalmargins.FunctionalMarginWarning, 'Companion', Companion_getInstance_53);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$functionalzones = $com$ikea$core$stl.functionalzones || ($com$ikea$core$stl.functionalzones = {});
    $com$ikea$core$stl$functionalzones.FunctionalZone = FunctionalZone;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$functionalzones = $com$ikea$core$stl.functionalzones || ($com$ikea$core$stl.functionalzones = {});
    $com$ikea$core$stl$functionalzones.FunctionalZonesLocalComponent = FunctionalZonesLocalComponent;
    defineProp($com$ikea$core$stl$functionalzones.FunctionalZonesLocalComponent, 'Companion', Companion_getInstance_54);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$functionalzones = $com$ikea$core$stl.functionalzones || ($com$ikea$core$stl.functionalzones = {});
    $com$ikea$core$stl$functionalzones.FunctionalZonesLocalToWorldSystem = FunctionalZonesLocalToWorldSystem;
    defineProp($com$ikea$core$stl$functionalzones.FunctionalZonesLocalToWorldSystem, 'Companion', Companion_getInstance_55);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$functionalzones = $com$ikea$core$stl.functionalzones || ($com$ikea$core$stl.functionalzones = {});
    $com$ikea$core$stl$functionalzones.FunctionalZonesWorldComponent = FunctionalZonesWorldComponent;
    defineProp($com$ikea$core$stl$functionalzones.FunctionalZonesWorldComponent, 'Companion', Companion_getInstance_56);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$icf = $com$ikea$core$stl.icf || ($com$ikea$core$stl.icf = {});
    $com$ikea$core$stl$icf.ICFDataService = ICFDataService;
    defineProp($com$ikea$core$stl$icf.ICFDataService, 'Companion', Companion_getInstance_57);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$icf = $com$ikea$core$stl.icf || ($com$ikea$core$stl.icf = {});
    $com$ikea$core$stl$icf.ICFProductData = ICFProductData;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$label = $com$ikea$core$stl.label || ($com$ikea$core$stl.label = {});
    $com$ikea$core$stl$label.LabelComponent = LabelComponent;
    defineProp($com$ikea$core$stl$label.LabelComponent, 'Companion', Companion_getInstance_58);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$logging = $com$ikea$core$stl.logging || ($com$ikea$core$stl.logging = {});
    $com$ikea$core$stl$logging.DebugLogger = DebugLogger;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$logging = $com$ikea$core.logging || ($com$ikea$core.logging = {});
    $com$ikea$core$logging.LoggerException = LoggerException;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$outlines = $com$ikea$core$stl.outlines || ($com$ikea$core$stl.outlines = {});
    $com$ikea$core$stl$outlines.ColoredOutlineComponent = ColoredOutlineComponent;
    defineProp($com$ikea$core$stl$outlines.ColoredOutlineComponent, 'Companion', Companion_getInstance_59);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$outlines = $com$ikea$core$stl.outlines || ($com$ikea$core$stl.outlines = {});
    $com$ikea$core$stl$outlines.ColoredOutlineSystem = ColoredOutlineSystem;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$outlines = $com$ikea$core$stl.outlines || ($com$ikea$core$stl.outlines = {});
    $com$ikea$core$stl$outlines.OutlineBlockingComponent = OutlineBlockingComponent;
    defineProp($com$ikea$core$stl$outlines.OutlineBlockingComponent, 'Companion', Companion_getInstance_60);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$outlines = $com$ikea$core$stl.outlines || ($com$ikea$core$stl.outlines = {});
    $com$ikea$core$stl$outlines.OutlineEntityGroupDeselectSystem = OutlineEntityGroupDeselectSystem;
    defineProp($com$ikea$core$stl$outlines.OutlineEntityGroupDeselectSystem, 'Companion', Companion_getInstance_61);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$outlines = $com$ikea$core$stl.outlines || ($com$ikea$core$stl.outlines = {});
    $com$ikea$core$stl$outlines.OutlineSelectedSystem = OutlineSelectedSystem;
    defineProp($com$ikea$core$stl$outlines.OutlineSelectedSystem, 'Companion', Companion_getInstance_62);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$outlines = $com$ikea$core$stl.outlines || ($com$ikea$core$stl.outlines = {});
    $com$ikea$core$stl$outlines.OutlineSystem = OutlineSystem;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$outlines = $com$ikea$core$stl.outlines || ($com$ikea$core$stl.outlines = {});
    $com$ikea$core$stl$outlines.OutlinedComponent = OutlinedComponent;
    defineProp($com$ikea$core$stl$outlines.OutlinedComponent, 'Companion', Companion_getInstance_63);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    $com$ikea$core$stl$placement.AutoAdaptPlacementActor = AutoAdaptPlacementActor;
    $com$ikea$core$stl$placement.AutoAdaptPlacementActor.doPlacement$default = doPlacement$default;
    $com$ikea$core$stl$placement.AutoAdaptPlacementActor.tryFindValidSnap$default = tryFindValidSnap$default;
    $com$ikea$core$stl$placement.AutoAdaptPlacementActor.tryFindFirstValidSnapResult$default = tryFindFirstValidSnapResult$default;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    defineProp($com$ikea$core$stl$placement, 'PlacementHelper', PlacementHelper_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    $com$ikea$core$stl$placement.PlacementResult = PlacementResult;
    defineProp($com$ikea$core$stl$placement.PlacementResult, 'Companion', Companion_getInstance_64);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    $com$ikea$core$stl$placement.PlacementService = PlacementService;
    $com$ikea$core$stl$placement.recommendedPosition = recommendedPosition;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    $com$ikea$core$stl$placement.PlacementZoneByHeightComponent = PlacementZoneByHeightComponent;
    defineProp($com$ikea$core$stl$placement.PlacementZoneByHeightComponent, 'Companion', Companion_getInstance_65);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    $com$ikea$core$stl$placement.RecommendedInitialPositionFromFloorComponent = RecommendedInitialPositionFromFloorComponent;
    defineProp($com$ikea$core$stl$placement.RecommendedInitialPositionFromFloorComponent, 'Companion', Companion_getInstance_66);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    $com$ikea$core$stl$placement.RecommendedInitialPositionFromParentComponent = RecommendedInitialPositionFromParentComponent;
    defineProp($com$ikea$core$stl$placement.RecommendedInitialPositionFromParentComponent, 'Companion', Companion_getInstance_67);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    defineProp($com$ikea$core$stl$placement, 'SearchDirectionsUtils', SearchDirectionsUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    $com$ikea$core$stl$placement.SnapPlacementActor = SnapPlacementActor;
    $com$ikea$core$stl$placement.SnapPlacementActor.findBestValidPositionOnConnector$default = findBestValidPositionOnConnector$default;
    $com$ikea$core$stl$placement.SnapPlacementActor.CandidateResult = CandidateResult;
    defineProp($com$ikea$core$stl$placement.SnapPlacementActor, 'Companion', Companion_getInstance_68);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    var $com$ikea$core$stl$placement$snapsorting = $com$ikea$core$stl$placement.snapsorting || ($com$ikea$core$stl$placement.snapsorting = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    var $com$ikea$core$stl$placement$snapsorting = $com$ikea$core$stl$placement.snapsorting || ($com$ikea$core$stl$placement.snapsorting = {});
    $com$ikea$core$stl$placement$snapsorting.PriorityCriterion = PriorityCriterion;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    var $com$ikea$core$stl$placement$snapsorting = $com$ikea$core$stl$placement.snapsorting || ($com$ikea$core$stl$placement.snapsorting = {});
    $com$ikea$core$stl$placement$snapsorting.SnapSorter = SnapSorter;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    var $com$ikea$core$stl$placement$snapsorting = $com$ikea$core$stl$placement.snapsorting || ($com$ikea$core$stl$placement.snapsorting = {});
    $com$ikea$core$stl$placement$snapsorting.SnapSorterBuilder = SnapSorterBuilder;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    var $com$ikea$core$stl$placement$snapsorting = $com$ikea$core$stl$placement.snapsorting || ($com$ikea$core$stl$placement.snapsorting = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$placement = $com$ikea$core$stl.placement || ($com$ikea$core$stl.placement = {});
    var $com$ikea$core$stl$placement$utils = $com$ikea$core$stl$placement.utils || ($com$ikea$core$stl$placement.utils = {});
    defineProp($com$ikea$core$stl$placement$utils, 'SpaceFinderUtils', SpaceFinderUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$propping = $com$ikea$core$stl.propping || ($com$ikea$core$stl.propping = {});
    $com$ikea$core$stl$propping.ProppingData = ProppingData;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$propping = $com$ikea$core$stl.propping || ($com$ikea$core$stl.propping = {});
    $com$ikea$core$stl$propping.ProppingHostConnectorsComponent = ProppingHostConnectorsComponent;
    defineProp($com$ikea$core$stl$propping.ProppingHostConnectorsComponent, 'Companion', Companion_getInstance_70);
    $com$ikea$core$stl$propping.ProppingHostConnectorData = ProppingHostConnectorData;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$propping = $com$ikea$core$stl.propping || ($com$ikea$core$stl.propping = {});
    $com$ikea$core$stl$propping.ProppingInfoComponent = ProppingInfoComponent;
    defineProp($com$ikea$core$stl$propping.ProppingInfoComponent, 'Companion', Companion_getInstance_71);
    $com$ikea$core$stl$propping.PropHolderInfo = PropHolderInfo;
    $com$ikea$core$stl$propping.getPropHolderInfo = getPropHolderInfo;
    $com$ikea$core$stl$propping.getPropping = getPropping;
    $com$ikea$core$stl$propping.setPropping = setPropping;
    $com$ikea$core$stl$propping.getColliderBox = getColliderBox;
    $com$ikea$core$stl$propping.getOldPropping = getOldPropping;
    $com$ikea$core$stl$propping.setOldPropping = setOldPropping;
    $com$ikea$core$stl$propping.removePropping = removePropping;
    $com$ikea$core$stl$propping.clearOldPropping = clearOldPropping;
    $com$ikea$core$stl$propping.restoreOldPropping = restoreOldPropping;
    $com$ikea$core$stl$propping.getShapeComponent = getShapeComponent;
    $com$ikea$core$stl$propping.setProppingProperty = setProppingProperty;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$propping = $com$ikea$core$stl.propping || ($com$ikea$core$stl.propping = {});
    $com$ikea$core$stl$propping.ProppingSystem = ProppingSystem;
    defineProp($com$ikea$core$stl$propping.ProppingSystem, 'Companion', Companion_getInstance_72);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$range = $com$ikea$core$stl.range || ($com$ikea$core$stl.range = {});
    $com$ikea$core$stl$range.CommunicationSizeComponent = CommunicationSizeComponent;
    defineProp($com$ikea$core$stl$range.CommunicationSizeComponent, 'Companion', Companion_getInstance_75);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$range = $com$ikea$core$stl.range || ($com$ikea$core$stl.range = {});
    defineProp($com$ikea$core$stl$range, 'DoorComponent', DoorComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$range = $com$ikea$core$stl.range || ($com$ikea$core$stl.range = {});
    defineProp($com$ikea$core$stl$range, 'DoorFrontComponent', DoorFrontComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$range = $com$ikea$core$stl.range || ($com$ikea$core$stl.range = {});
    defineProp($com$ikea$core$stl$range, 'DrawerComponent', DrawerComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$range = $com$ikea$core$stl.range || ($com$ikea$core$stl.range = {});
    defineProp($com$ikea$core$stl$range, 'FrameComponent', FrameComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$range = $com$ikea$core$stl.range || ($com$ikea$core$stl.range = {});
    defineProp($com$ikea$core$stl$range, 'HandleComponent', HandleComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$range = $com$ikea$core$stl.range || ($com$ikea$core$stl.range = {});
    defineProp($com$ikea$core$stl$range, 'IncludedHandleComponent', IncludedHandleComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$range = $com$ikea$core$stl.range || ($com$ikea$core$stl.range = {});
    defineProp($com$ikea$core$stl$range, 'LegComponent', LegComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$range = $com$ikea$core$stl.range || ($com$ikea$core$stl.range = {});
    $com$ikea$core$stl$range.LightComponent = LightComponent;
    defineProp($com$ikea$core$stl$range.LightComponent, 'Companion', Companion_getInstance_76);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$replace = $com$ikea$core$stl.replace || ($com$ikea$core$stl.replace = {});
    defineProp($com$ikea$core$stl$replace, 'ReplaceAssemblyPartUtils', ReplaceAssemblyPartUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$replace = $com$ikea$core$stl.replace || ($com$ikea$core$stl.replace = {});
    $com$ikea$core$stl$replace.ReplacePartResult = ReplacePartResult;
    defineProp($com$ikea$core$stl$replace.ReplacePartResult, 'Companion', Companion_getInstance_77);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$replace = $com$ikea$core$stl.replace || ($com$ikea$core$stl.replace = {});
    $com$ikea$core$stl$replace.ReplacePlacementResult = ReplacePlacementResult;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$replace = $com$ikea$core$stl.replace || ($com$ikea$core$stl.replace = {});
    defineProp($com$ikea$core$stl$replace, 'ReplaceUtils', ReplaceUtils_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    $com$ikea$core$stl$room.RoomComponentDeserializer = RoomComponentDeserializer;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    defineProp($com$ikea$core$stl$room, 'RoomConnectorConstants', RoomConnectorConstants_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    $com$ikea$core$stl$room.CoreRoomGeometryData = CoreRoomGeometryData;
    defineProp($com$ikea$core$stl$room.CoreRoomGeometryData, 'Companion', Companion_getInstance_78);
    $com$ikea$core$stl$room.CoreRoomSurface = CoreRoomSurface;
    defineProp($com$ikea$core$stl$room.CoreRoomSurface, 'Companion', Companion_getInstance_79);
    $com$ikea$core$stl$room.RoomSurfaceGeometryImpl = RoomSurfaceGeometryImpl;
    defineProp($com$ikea$core$stl$room.RoomSurfaceGeometryImpl, 'Companion', Companion_getInstance_80);
    $com$ikea$core$stl$room.CoreRoomEdge = CoreRoomEdge;
    defineProp($com$ikea$core$stl$room.CoreRoomEdge, 'Companion', Companion_getInstance_81);
    $com$ikea$core$stl$room.CoreRoomVertex = CoreRoomVertex;
    defineProp($com$ikea$core$stl$room.CoreRoomVertex, 'Companion', Companion_getInstance_82);
    $com$ikea$core$stl$room.CoreRoomObstacle = CoreRoomObstacle;
    defineProp($com$ikea$core$stl$room.CoreRoomObstacle, 'Companion', Companion_getInstance_83);
    $com$ikea$core$stl$room.CoreRoomBoundingBox = CoreRoomBoundingBox;
    defineProp($com$ikea$core$stl$room.CoreRoomBoundingBox, 'Companion', Companion_getInstance_84);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    $com$ikea$core$stl$room.RoomService = RoomService;
    $com$ikea$core$stl$room.RoomService.generateDisabledConnectorsComponent$default = generateDisabledConnectorsComponent$default;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$component = $com$ikea$core$stl$room.component || ($com$ikea$core$stl$room.component = {});
    defineProp($com$ikea$core$stl$room$component, 'RoomComponent', RoomComponent_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$component = $com$ikea$core$stl$room.component || ($com$ikea$core$stl$room.component = {});
    $com$ikea$core$stl$room$component.RoomConnectorRelationsComponent = RoomConnectorRelationsComponent;
    defineProp($com$ikea$core$stl$room$component.RoomConnectorRelationsComponent, 'Companion', Companion_getInstance_86);
    $com$ikea$core$stl$room$component.RoomConnectorKeysForSurface = RoomConnectorKeysForSurface;
    $com$ikea$core$stl$room$component.RoomConnectorKeysForEdge = RoomConnectorKeysForEdge;
    $com$ikea$core$stl$room$component.RoomConnectorKeysForCorner = RoomConnectorKeysForCorner;
    $com$ikea$core$stl$room$component.RoomConnectorsForSurface = RoomConnectorsForSurface;
    $com$ikea$core$stl$room$component.RoomConnectorsForEdge = RoomConnectorsForEdge;
    $com$ikea$core$stl$room$component.RoomConnectorsForCorner = RoomConnectorsForCorner;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$component = $com$ikea$core$stl$room.component || ($com$ikea$core$stl$room.component = {});
    $com$ikea$core$stl$room$component.RoomDimensionsComponent = RoomDimensionsComponent;
    defineProp($com$ikea$core$stl$room$component.RoomDimensionsComponent, 'Companion', Companion_getInstance_87);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$component = $com$ikea$core$stl$room.component || ($com$ikea$core$stl$room.component = {});
    $com$ikea$core$stl$room$component.RoomGeometryComponent = RoomGeometryComponent;
    defineProp($com$ikea$core$stl$room$component.RoomGeometryComponent, 'Companion', Companion_getInstance_88);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$component = $com$ikea$core$stl$room.component || ($com$ikea$core$stl$room.component = {});
    $com$ikea$core$stl$room$component.RoomPartComponent = RoomPartComponent;
    defineProp($com$ikea$core$stl$room$component.RoomPartComponent, 'Companion', Companion_getInstance_89);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$interceptor = $com$ikea$core$stl$room.interceptor || ($com$ikea$core$stl$room.interceptor = {});
    $com$ikea$core$stl$room$interceptor.RoomRefToRoomComponentInterceptor = RoomRefToRoomComponentInterceptor;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$system = $com$ikea$core$stl$room.system || ($com$ikea$core$stl$room.system = {});
    $com$ikea$core$stl$room$system.RoomDimensionToGeometrySystem = RoomDimensionToGeometrySystem;
    defineProp($com$ikea$core$stl$room$system.RoomDimensionToGeometrySystem, 'Companion', Companion_getInstance_90);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$system = $com$ikea$core$stl$room.system || ($com$ikea$core$stl$room.system = {});
    $com$ikea$core$stl$room$system.RoomServiceDragSystem = RoomServiceDragSystem;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$system = $com$ikea$core$stl$room.system || ($com$ikea$core$stl$room.system = {});
    $com$ikea$core$stl$room$system.RoomSystem = RoomSystem;
    defineProp($com$ikea$core$stl$room$system.RoomSystem, 'Companion', Companion_getInstance_91);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$utils = $com$ikea$core$stl$room.utils || ($com$ikea$core$stl$room.utils = {});
    $com$ikea$core$stl$room$utils.RoomColliderUtilities = RoomColliderUtilities;
    defineProp($com$ikea$core$stl$room$utils.RoomColliderUtilities, 'Companion', Companion_getInstance_92);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$utils = $com$ikea$core$stl$room.utils || ($com$ikea$core$stl$room.utils = {});
    $com$ikea$core$stl$room$utils.RoomConnectorPair = RoomConnectorPair;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$utils = $com$ikea$core$stl$room.utils || ($com$ikea$core$stl$room.utils = {});
    $com$ikea$core$stl$room$utils.RoomConnectorRelationsMapper = RoomConnectorRelationsMapper;
    defineProp($com$ikea$core$stl$room$utils.RoomConnectorRelationsMapper, 'Companion', Companion_getInstance_93);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$utils = $com$ikea$core$stl$room.utils || ($com$ikea$core$stl$room.utils = {});
    $com$ikea$core$stl$room$utils.RoomConnectorUtilities = RoomConnectorUtilities;
    defineProp($com$ikea$core$stl$room$utils.RoomConnectorUtilities, 'Companion', Companion_getInstance_94);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$room = $com$ikea$core$stl.room || ($com$ikea$core$stl.room = {});
    var $com$ikea$core$stl$room$utils = $com$ikea$core$stl$room.utils || ($com$ikea$core$stl$room.utils = {});
    $com$ikea$core$stl$room$utils.RoomGeometryUtilities = RoomGeometryUtilities;
    defineProp($com$ikea$core$stl$room$utils.RoomGeometryUtilities, 'Companion', Companion_getInstance_95);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$selection = $com$ikea$core$stl.selection || ($com$ikea$core$stl.selection = {});
    $com$ikea$core$stl$selection.StandardSelectionService = StandardSelectionService;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$selection = $com$ikea$core$stl.selection || ($com$ikea$core$stl.selection = {});
    $com$ikea$core$stl$selection.StandardSelectionSystem = StandardSelectionSystem;
    $com$ikea$core$stl$selection.StandardSelectionSystem.StandardSelectionSystemFromCoreServices = StandardSelectionSystemFromCoreServices;
    defineProp($com$ikea$core$stl$selection.StandardSelectionSystem, 'Companion', Companion_getInstance_96);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$system = $com$ikea$core$stl.system || ($com$ikea$core$stl.system = {});
    defineProp($com$ikea$core$stl$system, 'StlSystemIds', StlSystemIds_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$test = $com$ikea$core$stl.test || ($com$ikea$core$stl.test = {});
    $com$ikea$core$stl$test.DragExtensions = DragExtensions;
    defineProp($com$ikea$core$stl$test.DragExtensions, 'Companion', Companion_getInstance_97);
    $com$ikea$core$stl$test.simulateEntireDragInSteps = simulateEntireDragInSteps;
    $com$ikea$core$stl$test.simulateEntireDrag = simulateEntireDrag;
    $com$ikea$core$stl$test.simulateStartDrag = simulateStartDrag;
    $com$ikea$core$stl$test.simulateOngoingDrag = simulateOngoingDrag;
    $com$ikea$core$stl$test.simulateEndDrag = simulateEndDrag;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$test = $com$ikea$core$stl.test || ($com$ikea$core$stl.test = {});
    defineProp($com$ikea$core$stl$test, 'ViewerDragState', ViewerDragState_getInstance);
    $com$ikea$core$stl$test.simulateEntireViewerDragInSteps = simulateEntireViewerDragInSteps;
    $com$ikea$core$stl$test.simulateViewerStartDrag = simulateViewerStartDrag;
    $com$ikea$core$stl$test.simulateViewerOngoingDrag = simulateViewerOngoingDrag;
    $com$ikea$core$stl$test.simulateViewerEndDrag = simulateViewerEndDrag;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$validation = $com$ikea$core$stl.validation || ($com$ikea$core$stl.validation = {});
    $com$ikea$core$stl$validation.AllowedNumberOfChildrenOfTypeValidation = AllowedNumberOfChildrenOfTypeValidation;
    defineProp($com$ikea$core$stl$validation.AllowedNumberOfChildrenOfTypeValidation, 'Companion', Companion_getInstance_98);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$validation = $com$ikea$core$stl.validation || ($com$ikea$core$stl.validation = {});
    $com$ikea$core$stl$validation.DisallowSeparateRequiredHostsValidation = DisallowSeparateRequiredHostsValidation;
    defineProp($com$ikea$core$stl$validation.DisallowSeparateRequiredHostsValidation, 'Companion', Companion_getInstance_99);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$validation = $com$ikea$core$stl.validation || ($com$ikea$core$stl.validation = {});
    $com$ikea$core$stl$validation.InvalidNumberOfChildren = InvalidNumberOfChildren;
    defineProp($com$ikea$core$stl$validation.InvalidNumberOfChildren, 'Companion', Companion_getInstance_100);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$validation = $com$ikea$core$stl.validation || ($com$ikea$core$stl.validation = {});
    $com$ikea$core$stl$validation.PlacementZoneValidation = PlacementZoneValidation;
    defineProp($com$ikea$core$stl$validation.PlacementZoneValidation, 'Companion', Companion_getInstance_101);
    $com$ikea$core$stl$validation.PlacementZoneWarning = PlacementZoneWarning;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$validation = $com$ikea$core$stl.validation || ($com$ikea$core$stl.validation = {});
    $com$ikea$core$stl$validation.RequiredConnectorsSatisfiedValidation = RequiredConnectorsSatisfiedValidation;
    defineProp($com$ikea$core$stl$validation.RequiredConnectorsSatisfiedValidation, 'Companion', Companion_getInstance_102);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$validation = $com$ikea$core$stl.validation || ($com$ikea$core$stl.validation = {});
    $com$ikea$core$stl$validation.RequiredConnectorsValidationResult = RequiredConnectorsValidationResult;
    defineProp($com$ikea$core$stl$validation.RequiredConnectorsValidationResult, 'Companion', Companion_getInstance_103);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$validation = $com$ikea$core$stl.validation || ($com$ikea$core$stl.validation = {});
    defineProp($com$ikea$core$stl$validation, 'ValidationResultIds', ValidationResultIds_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$validation = $com$ikea$core$stl.validation || ($com$ikea$core$stl.validation = {});
    defineProp($com$ikea$core$stl$validation, 'ValidationRuleIds', ValidationRuleIds_getInstance);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    $com$ikea$core$stl$visualization.CoreVisualization = CoreVisualization;
    $com$ikea$core$stl$visualization.CoreVisualization.setEnabled$default = setEnabled$default;
    $com$ikea$core$stl$visualization.VisualizationState = VisualizationState;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.ColliderVisualizationConfigComponent = ColliderVisualizationConfigComponent;
    defineProp($com$ikea$core$stl$visualization$component.ColliderVisualizationConfigComponent, 'Companion', Companion_getInstance_104);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.ColliderVisualizationNodeComponent = ColliderVisualizationNodeComponent;
    defineProp($com$ikea$core$stl$visualization$component.ColliderVisualizationNodeComponent, 'Companion', Companion_getInstance_105);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.ColliderVisualizerViewerObjectsComponent = ColliderVisualizerViewerObjectsComponent;
    defineProp($com$ikea$core$stl$visualization$component.ColliderVisualizerViewerObjectsComponent, 'Companion', Companion_getInstance_106);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.ConnectorVisualizationConfigComponent = ConnectorVisualizationConfigComponent;
    defineProp($com$ikea$core$stl$visualization$component.ConnectorVisualizationConfigComponent, 'Companion', Companion_getInstance_107);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.ConnectorVisualizationNodeComponent = ConnectorVisualizationNodeComponent;
    defineProp($com$ikea$core$stl$visualization$component.ConnectorVisualizationNodeComponent, 'Companion', Companion_getInstance_108);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.ConnectorVisualizerViewerObjectsComponent = ConnectorVisualizerViewerObjectsComponent;
    defineProp($com$ikea$core$stl$visualization$component.ConnectorVisualizerViewerObjectsComponent, 'Companion', Companion_getInstance_109);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.DecoratorComponent = DecoratorComponent;
    defineProp($com$ikea$core$stl$visualization$component.DecoratorComponent, 'Companion', Companion_getInstance_110);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.EntityColliderVisualizationComponent = EntityColliderVisualizationComponent;
    defineProp($com$ikea$core$stl$visualization$component.EntityColliderVisualizationComponent, 'Companion', Companion_getInstance_111);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.EntityConnectorVisualizationComponent = EntityConnectorVisualizationComponent;
    defineProp($com$ikea$core$stl$visualization$component.EntityConnectorVisualizationComponent, 'Companion', Companion_getInstance_112);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$component = $com$ikea$core$stl$visualization.component || ($com$ikea$core$stl$visualization.component = {});
    $com$ikea$core$stl$visualization$component.PolyhedronVisualizationNodeComponent = PolyhedronVisualizationNodeComponent;
    defineProp($com$ikea$core$stl$visualization$component.PolyhedronVisualizationNodeComponent, 'Companion', Companion_getInstance_113);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$polyhedron = $com$ikea$core$stl$visualization.polyhedron || ($com$ikea$core$stl$visualization.polyhedron = {});
    $com$ikea$core$stl$visualization$polyhedron.AutoAdaptHostZoneVisualizationSystem = AutoAdaptHostZoneVisualizationSystem;
    defineProp($com$ikea$core$stl$visualization$polyhedron.AutoAdaptHostZoneVisualizationSystem, 'Companion', Companion_getInstance_114);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$polyhedron = $com$ikea$core$stl$visualization.polyhedron || ($com$ikea$core$stl$visualization.polyhedron = {});
    $com$ikea$core$stl$visualization$polyhedron.DragProjectionPointVisualizationSystem = DragProjectionPointVisualizationSystem;
    defineProp($com$ikea$core$stl$visualization$polyhedron.DragProjectionPointVisualizationSystem, 'Companion', Companion_getInstance_115);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$polyhedron = $com$ikea$core$stl$visualization.polyhedron || ($com$ikea$core$stl$visualization.polyhedron = {});
    $com$ikea$core$stl$visualization$polyhedron.FunctionalMarginVisualizationSystem = FunctionalMarginVisualizationSystem;
    defineProp($com$ikea$core$stl$visualization$polyhedron.FunctionalMarginVisualizationSystem, 'Companion', Companion_getInstance_116);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$polyhedron = $com$ikea$core$stl$visualization.polyhedron || ($com$ikea$core$stl$visualization.polyhedron = {});
    $com$ikea$core$stl$visualization$polyhedron.FunctionalZoneVisualizationSystem = FunctionalZoneVisualizationSystem;
    defineProp($com$ikea$core$stl$visualization$polyhedron.FunctionalZoneVisualizationSystem, 'Companion', Companion_getInstance_117);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$polyhedron = $com$ikea$core$stl$visualization.polyhedron || ($com$ikea$core$stl$visualization.polyhedron = {});
    $com$ikea$core$stl$visualization$polyhedron.PolyhedronVisualizationHolderComponent = PolyhedronVisualizationHolderComponent;
    defineProp($com$ikea$core$stl$visualization$polyhedron.PolyhedronVisualizationHolderComponent, 'Companion', Companion_getInstance_118);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$polyhedron = $com$ikea$core$stl$visualization.polyhedron || ($com$ikea$core$stl$visualization.polyhedron = {});
    $com$ikea$core$stl$visualization$polyhedron.PolyhedronVisualizationSystem = PolyhedronVisualizationSystem;
    $com$ikea$core$stl$visualization$polyhedron.PolyhedronVisualizationSystem.createPolyhedronVisualization$default = createPolyhedronVisualization$default;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$system = $com$ikea$core$stl$visualization.system || ($com$ikea$core$stl$visualization.system = {});
    $com$ikea$core$stl$visualization$system.ColliderVisualizationSystem = ColliderVisualizationSystem;
    defineProp($com$ikea$core$stl$visualization$system.ColliderVisualizationSystem, 'Companion', Companion_getInstance_119);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$system = $com$ikea$core$stl$visualization.system || ($com$ikea$core$stl$visualization.system = {});
    $com$ikea$core$stl$visualization$system.ConnectorVisualizationSystem = ConnectorVisualizationSystem;
    defineProp($com$ikea$core$stl$visualization$system.ConnectorVisualizationSystem, 'Companion', Companion_getInstance_120);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$system = $com$ikea$core$stl$visualization.system || ($com$ikea$core$stl$visualization.system = {});
    $com$ikea$core$stl$visualization$system.EntityColliderVisualizationSystem = EntityColliderVisualizationSystem;
    defineProp($com$ikea$core$stl$visualization$system.EntityColliderVisualizationSystem, 'Companion', Companion_getInstance_121);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$system = $com$ikea$core$stl$visualization.system || ($com$ikea$core$stl$visualization.system = {});
    $com$ikea$core$stl$visualization$system.CollisionVisualizationSceneDataComponent = CollisionVisualizationSceneDataComponent;
    defineProp($com$ikea$core$stl$visualization$system.CollisionVisualizationSceneDataComponent, 'Companion', Companion_getInstance_122);
    $com$ikea$core$stl$visualization$system.CollisionVisualizationSceneData = CollisionVisualizationSceneData;
    $com$ikea$core$stl$visualization$system.EntityCollisionVisualizationSystem = EntityCollisionVisualizationSystem;
    $com$ikea$core$stl$visualization$system.EntityCollisionVisualizationSystem.foldCollisions$default = foldCollisions$default;
    defineProp($com$ikea$core$stl$visualization$system.EntityCollisionVisualizationSystem, 'Companion', Companion_getInstance_123);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$system = $com$ikea$core$stl$visualization.system || ($com$ikea$core$stl$visualization.system = {});
    $com$ikea$core$stl$visualization$system.EntityConnectorVisualizationSystem = EntityConnectorVisualizationSystem;
    defineProp($com$ikea$core$stl$visualization$system.EntityConnectorVisualizationSystem, 'Companion', Companion_getInstance_124);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$system = $com$ikea$core$stl$visualization.system || ($com$ikea$core$stl$visualization.system = {});
    $com$ikea$core$stl$visualization$system.ForcedComponentBaseSystem = ForcedComponentBaseSystem;
    $com$ikea$core$stl$visualization$system.ForcedComponentBaseSystem.addConfigComponentToEntities$default = addConfigComponentToEntities$default;
    $com$ikea$core$stl$visualization$system.ForcedComponentBaseSystem.removeConfigComponentFromEntities$default = removeConfigComponentFromEntities$default;
    $com$ikea$core$stl$visualization$system.ForcedComponentBaseSystem.removeConfigComponentFromEntity$default = removeConfigComponentFromEntity$default;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$visualizer = $com$ikea$core$stl$visualization.visualizer || ($com$ikea$core$stl$visualization.visualizer = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$visualizer = $com$ikea$core$stl$visualization.visualizer || ($com$ikea$core$stl$visualization.visualizer = {});
    $com$ikea$core$stl$visualization$visualizer.CollisionVisualizationData = CollisionVisualizationData;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$visualizer = $com$ikea$core$stl$visualization.visualizer || ($com$ikea$core$stl$visualization.visualizer = {});
    $com$ikea$core$stl$visualization$visualizer.Color = Color;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$visualizer = $com$ikea$core$stl$visualization.visualizer || ($com$ikea$core$stl$visualization.visualizer = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$visualizer = $com$ikea$core$stl$visualization.visualizer || ($com$ikea$core$stl$visualization.visualizer = {});
    $com$ikea$core$stl$visualization$visualizer.DefaultVisualizer = DefaultVisualizer;
    defineProp($com$ikea$core$stl$visualization$visualizer.DefaultVisualizer, 'Companion', Companion_getInstance_125);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$visualizer = $com$ikea$core$stl$visualization.visualizer || ($com$ikea$core$stl$visualization.visualizer = {});
    $com$ikea$core$stl$visualization$visualizer.setRandomColor = setRandomColor;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$visualizer = $com$ikea$core$stl$visualization.visualizer || ($com$ikea$core$stl$visualization.visualizer = {});
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$stl = $com$ikea$core.stl || ($com$ikea$core.stl = {});
    var $com$ikea$core$stl$visualization = $com$ikea$core$stl.visualization || ($com$ikea$core$stl.visualization = {});
    var $com$ikea$core$stl$visualization$visualizer = $com$ikea$core$stl$visualization.visualizer || ($com$ikea$core$stl$visualization.visualizer = {});
    $com$ikea$core$stl$visualization$visualizer.VisualizerUtils = VisualizerUtils;
    defineProp($com$ikea$core$stl$visualization$visualizer.VisualizerUtils, 'Companion', Companion_getInstance_126);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = AlignmentConnectionCreationSystem;
  _.$_$.b = AlignmentConnectionsComponent;
  _.$_$.c = AlignmentPlane;
  _.$_$.d = HandleRotationSystem;
  _.$_$.e = HostConnectorRotationValidation;
  _.$_$.f = AlignmentLinesSystem;
  _.$_$.g = AllowedDoorPairsComponent;
  _.$_$.h = AllowedDoorPairsValidation;
  _.$_$.i = AssemblyInstructionsServiceImpl;
  _.$_$.j = AutoAdaptSessionComponent;
  _.$_$.k = AutoAdaptGuestComponent;
  _.$_$.l = AutoAdaptHostComponent;
  _.$_$.m = AutoAdaptVariantComponent;
  _.$_$.n = ForceAutoAdaptWhenParentIsDraggedComponent;
  _.$_$.o = ReplacedWithAutoAdaptEventComponent;
  _.$_$.p = AutoAdaptDragStrategy;
  _.$_$.q = DragSurfaceCanHostWithAutoAdaptSelector;
  _.$_$.r = AutoAdaptProductSpecificationsSystem;
  _.$_$.s = AutoAdaptService;
  _.$_$.t = get_variantEntities;
  _.$_$.u = DebugLineDrawingSystem;
  _.$_$.v = LoggingEntityManagerWatcher;
  _.$_$.w = MeasuringEntityManagerWatcher;
  _.$_$.x = ResolveCollisionsDragStrategy;
  _.$_$.y = SnapCardinalDirectionsDragStrategy;
  _.$_$.z = SnapClosestDragStrategy;
  _.$_$.a1 = SnapClosestWithSubConnectorsDragStrategy;
  _.$_$.b1 = ValidDragStrategyResult;
  _.$_$.c1 = DragProjectionPointComponent;
  _.$_$.d1 = XYPlaneProjector;
  _.$_$.e1 = DragSurfaceCanHostSelector;
  _.$_$.f1 = DragSurfaceOnlyRoomSelector;
  _.$_$.g1 = LegacyCanvasTo3DDragConverterSystem;
  _.$_$.h1 = DragStateComponent;
  _.$_$.i1 = DragState;
  _.$_$.j1 = DragSurfaceNormalVisualizationSystem;
  _.$_$.k1 = DragSurfaceVisualizationSystem;
  _.$_$.l1 = DragSystem;
  _.$_$.m1 = DrawDragGhostSystem;
  _.$_$.n1 = HigherPriorityAlignmentPostProcess;
  _.$_$.o1 = FunctionalMarginComponent;
  _.$_$.p1 = FunctionalMarginShapeComponent;
  _.$_$.q1 = FunctionalMarginSystem;
  _.$_$.r1 = FunctionalMarginValidation;
  _.$_$.s1 = FunctionalZonesLocalComponent;
  _.$_$.t1 = FunctionalZonesLocalToWorldSystem;
  _.$_$.u1 = FunctionalZone;
  _.$_$.v1 = ICFDataService;
  _.$_$.w1 = LabelComponent;
  _.$_$.x1 = DebugLogger;
  _.$_$.y1 = ColoredOutlineComponent;
  _.$_$.z1 = ColoredOutlineSystem;
  _.$_$.a2 = OutlineBlockingComponent;
  _.$_$.b2 = OutlineEntityGroupDeselectSystem;
  _.$_$.c2 = OutlineSelectedSystem;
  _.$_$.d2 = OutlineSystem;
  _.$_$.e2 = OutlinedComponent;
  _.$_$.f2 = SnapSorterBuilder;
  _.$_$.g2 = PlacementResult;
  _.$_$.h2 = PlacementService;
  _.$_$.i2 = PlacementZoneByHeightComponent;
  _.$_$.j2 = RecommendedInitialPositionFromFloorComponent;
  _.$_$.k2 = SnapPlacementActor;
  _.$_$.l2 = recommendedPosition;
  _.$_$.m2 = ProppingSystem;
  _.$_$.n2 = CommunicationSizeComponent;
  _.$_$.o2 = LightComponent;
  _.$_$.p2 = ReplacePartResult;
  _.$_$.q2 = RoomDimensionsComponent;
  _.$_$.r2 = RoomPartComponent;
  _.$_$.s2 = RoomSystem;
  _.$_$.t2 = RoomBoundingBox;
  _.$_$.u2 = RoomComponentDeserializer;
  _.$_$.v2 = RoomCorner;
  _.$_$.w2 = RoomEdge;
  _.$_$.x2 = RoomGeometryData;
  _.$_$.y2 = RoomObstacle;
  _.$_$.z2 = RoomPoint3D;
  _.$_$.a3 = RoomRotation;
  _.$_$.b3 = RoomService;
  _.$_$.c3 = RoomSurface;
  _.$_$.d3 = RoomTransform;
  _.$_$.e3 = StandardSelectionService;
  _.$_$.f3 = AllowedNumberOfChildrenOfTypeValidation;
  _.$_$.g3 = DisallowSeparateRequiredHostsValidation;
  _.$_$.h3 = PlacementZoneValidation;
  _.$_$.i3 = RequiredConnectorsSatisfiedValidation;
  _.$_$.j3 = ConnectorVisualizationData;
  _.$_$.k3 = DecoratorComponent;
  _.$_$.l3 = EntityColliderVisualizationComponent;
  _.$_$.m3 = EntityConnectorVisualizationComponent;
  _.$_$.n3 = AutoAdaptHostZoneVisualizationSystem;
  _.$_$.o3 = DragProjectionPointVisualizationSystem;
  _.$_$.p3 = FunctionalMarginVisualizationSystem;
  _.$_$.q3 = FunctionalZoneVisualizationSystem;
  _.$_$.r3 = ColliderVisualizationSystem;
  _.$_$.s3 = ConnectorVisualizationSystem;
  _.$_$.t3 = EntityColliderVisualizationSystem;
  _.$_$.u3 = EntityCollisionVisualizationSystem;
  _.$_$.v3 = EntityConnectorVisualizationSystem;
  _.$_$.w3 = Color;
  _.$_$.x3 = DefaultVisualizer;
  _.$_$.y3 = CoreVisualization;
  _.$_$.z3 = AllowedDoorPairsComponentFromArrays;
  _.$_$.a4 = AnyDragSurfaceProjectorFromCoreServices;
  _.$_$.b4 = CanvasTo3DDragConverterSystemFromCoreServices;
  _.$_$.c4 = StandardSelectionSystemFromCoreServices;
  _.$_$.d4 = Companion_instance_47;
  _.$_$.e4 = Companion_instance_49;
  _.$_$.f4 = Companion_instance_50;
  _.$_$.g4 = AutoAdaptFeature_instance;
  _.$_$.h4 = AutoAdaptUtils_getInstance;
  _.$_$.i4 = FreeMoveComponent_instance;
  _.$_$.j4 = IsDraggedComponent_instance;
  _.$_$.k4 = SpaceFinderUtils_getInstance;
  _.$_$.l4 = PlacementHelper_getInstance;
  _.$_$.m4 = Companion_instance_88;
  _.$_$.n4 = Companion_instance_90;
  _.$_$.o4 = Companion_instance_91;
  _.$_$.p4 = SearchDirectionsUtils_instance;
  _.$_$.q4 = DoorComponent_getInstance;
  _.$_$.r4 = DoorFrontComponent_getInstance;
  _.$_$.s4 = DrawerComponent_getInstance;
  _.$_$.t4 = FrameComponent_getInstance;
  _.$_$.u4 = HandleComponent_getInstance;
  _.$_$.v4 = LegComponent_getInstance;
  _.$_$.w4 = ReplaceAssemblyPartUtils_getInstance;
  _.$_$.x4 = ReplaceUtils_instance;
  _.$_$.y4 = RoomComponent_instance;
  _.$_$.z4 = RoomConnectorConstants_getInstance;
  _.$_$.a5 = StlSystemIds_instance;
  _.$_$.b5 = Companion_getInstance_97;
  _.$_$.c5 = ValidationResultIds_instance;
  _.$_$.d5 = ValidationRuleIds_instance;
  //endregion
  return _;
}));

//# sourceMappingURL=core-core-stl.js.map
